//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AccountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Verify if tenant is available
     * @param body (optional) 
     * @return Success
     */
    isTenantAvailable(body: IsTenantAvailableInput | undefined): Observable<IsTenantAvailableOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTenantAvailable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsTenantAvailableOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsTenantAvailableOutput>;
        }));
    }

    protected processIsTenantAvailable(response: HttpResponseBase): Observable<IsTenantAvailableOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsTenantAvailableOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Resolve tenant id from encrypted string
     * @param body (optional) 
     * @return Success
     */
    resolveTenantId(body: ResolveTenantIdInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResolveTenantId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResolveTenantId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processResolveTenantId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Register new account
     * @param body (optional) 
     * @return Success
     */
    register(body: RegisterInput | undefined): Observable<RegisterOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterOutput>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<RegisterOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send the password reset code of an account
     * @param body (optional) 
     * @return Success
     */
    sendPasswordResetCode(body: SendPasswordResetCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPasswordResetCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset the password of an account
     * @param body (optional) 
     * @return Success
     */
    resetPassword(body: ResetPasswordInput | undefined): Observable<ResetPasswordOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ResetPasswordOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ResetPasswordOutput>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<ResetPasswordOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send activation link to the email of a new account
     * @param body (optional) 
     * @return Success
     */
    sendEmailActivationLink(body: SendEmailActivationLinkInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendEmailActivationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendEmailActivationLink(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Activate email on an account
     * @param body (optional) 
     * @return Success
     */
    activateEmail(body: ActivateEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Impersonate another account
     * @param body (optional) 
     * @return Success
     */
    impersonate(body: ImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delegated impersonate
     * @param body (optional) 
     * @return Success
     */
    delegatedImpersonate(body: DelegatedImpersonateInput | undefined): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/DelegatedImpersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processDelegatedImpersonate(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Return to the original when impersonating
     * @return Success
     */
    backToImpersonator(): Observable<ImpersonateOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBackToImpersonator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBackToImpersonator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonateOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonateOutput>;
        }));
    }

    protected processBackToImpersonator(response: HttpResponseBase): Observable<ImpersonateOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonateOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Switch account to another account linked to the current one
     * @param body (optional) 
     * @return Success
     */
    switchToLinkedAccount(body: SwitchToLinkedAccountInput | undefined): Observable<SwitchToLinkedAccountOutput> {
        let url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchToLinkedAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchToLinkedAccountOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchToLinkedAccountOutput>;
        }));
    }

    protected processSwitchToLinkedAccount(response: HttpResponseBase): Observable<SwitchToLinkedAccountOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchToLinkedAccountOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ActionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param actionValueId (optional) 
     * @return Success
     */
    getActionValueById(actionValueId: number | undefined): Observable<ActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Action/GetActionValueById?";
        if (actionValueId === null)
            throw new Error("The parameter 'actionValueId' cannot be null.");
        else if (actionValueId !== undefined)
            url_ += "actionValueId=" + encodeURIComponent("" + actionValueId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActionValueById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActionValueById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActionDto>;
        }));
    }

    protected processGetActionValueById(response: HttpResponseBase): Observable<ActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param actionId (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateActionContacts(actionId: number | undefined, body: ContactDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Action/UpdateActionContacts?";
        if (actionId === null)
            throw new Error("The parameter 'actionId' cannot be null.");
        else if (actionId !== undefined)
            url_ += "actionId=" + encodeURIComponent("" + actionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActionContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActionContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActionContacts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllActionValuesByCurrentPlace(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfActionDto> {
        let url_ = this.baseUrl + "/api/services/app/Action/GetAllActionValuesByCurrentPlace?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllActionValuesByCurrentPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllActionValuesByCurrentPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfActionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfActionDto>;
        }));
    }

    protected processGetAllActionValuesByCurrentPlace(response: HttpResponseBase): Observable<PagedResultDtoOfActionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfActionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Method that apply partial modifications over Activity report.
    Params Availables in "path" parameter are nameof(SingleCustomsDeclarationInputDto),
    nameof(SaveOriginInputDto), nameof(ExternalLinesInput), nameof(ExternalLinesInput), nameof(ExternalDriverInput) and simple properties of WoodControlActivity
    The unique "op" available is "replace"
     * @param id (optional) Activity Report Identifier
     * @param body (optional) 
     * @return Success
     */
    patch(id: number | undefined, body: Operation[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/Patch?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information from the pre-activity report relevant when a truck is arriving at destination
     * @param vehicleExternalId (optional) 
     * @param entryDate (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getPreActivityReportWithArrivalInformation(vehicleExternalId: number | undefined, entryDate: DateTime | undefined, placeId: number | undefined): Observable<PreActivityReportWithArrivalInformationOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetPreActivityReportWithArrivalInformation?";
        if (vehicleExternalId === null)
            throw new Error("The parameter 'vehicleExternalId' cannot be null.");
        else if (vehicleExternalId !== undefined)
            url_ += "VehicleExternalId=" + encodeURIComponent("" + vehicleExternalId) + "&";
        if (entryDate === null)
            throw new Error("The parameter 'entryDate' cannot be null.");
        else if (entryDate !== undefined)
            url_ += "EntryDate=" + encodeURIComponent(entryDate ? "" + entryDate.toString() : "") + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportWithArrivalInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportWithArrivalInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportWithArrivalInformationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportWithArrivalInformationOutput>;
        }));
    }

    protected processGetPreActivityReportWithArrivalInformation(response: HttpResponseBase): Observable<PreActivityReportWithArrivalInformationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportWithArrivalInformationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new activity report from provided information
     * @param body (optional) 
     * @return Success
     */
    createBasicReport(body: CreateBasicReportAutomaticDto | undefined): Observable<CreateBasicReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/CreateBasicReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBasicReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBasicReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateBasicReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateBasicReportOutputDto>;
        }));
    }

    protected processCreateBasicReport(response: HttpResponseBase): Observable<CreateBasicReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateBasicReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a wood pre activity report with the given properties
     * @param body (optional) information data to create wood pre receipt
     * @return Success
     */
    createWoodPreActivityReport(body: CreateWoodPreActivityReportInput | undefined): Observable<CreateWoodActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/CreateWoodPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWoodPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWoodPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodActivityReportOutput>;
        }));
    }

    protected processCreateWoodPreActivityReport(response: HttpResponseBase): Observable<CreateWoodActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if any report is leaving. Gets the report that is leaving if one is found.
     * @param zoneId (optional) not applied on internal query yet
     * @return Success
     */
    isAnyReportLeaving(zoneId: number | undefined): Observable<HasLeavingReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/IsAnyReportLeaving?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAnyReportLeaving(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAnyReportLeaving(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HasLeavingReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HasLeavingReportOutputDto>;
        }));
    }

    protected processIsAnyReportLeaving(response: HttpResponseBase): Observable<HasLeavingReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HasLeavingReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if any report is entering. Gets the report that is entering.
     * @param zoneId (optional) 
     * @return Success
     */
    getEnteringReport(zoneId: number | undefined): Observable<ActiveReceiptOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetEnteringReport?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnteringReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnteringReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActiveReceiptOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActiveReceiptOutputDto>;
        }));
    }

    protected processGetEnteringReport(response: HttpResponseBase): Observable<ActiveReceiptOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActiveReceiptOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a report that is in place by the driver
     * @param exitZoneId (optional) 
     * @param externalDriverId (optional) 
     * @param licensePlate (optional) 
     * @return Success
     */
    getReceiptInPlaceByZoneByDriverLicensePlate(exitZoneId: number | undefined, externalDriverId: number | undefined, licensePlate: string | undefined): Observable<InPlaceReceiptOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetReceiptInPlaceByZoneByDriverLicensePlate?";
        if (exitZoneId === null)
            throw new Error("The parameter 'exitZoneId' cannot be null.");
        else if (exitZoneId !== undefined)
            url_ += "exitZoneId=" + encodeURIComponent("" + exitZoneId) + "&";
        if (externalDriverId === null)
            throw new Error("The parameter 'externalDriverId' cannot be null.");
        else if (externalDriverId !== undefined)
            url_ += "externalDriverId=" + encodeURIComponent("" + externalDriverId) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptInPlaceByZoneByDriverLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptInPlaceByZoneByDriverLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InPlaceReceiptOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InPlaceReceiptOutputDto>;
        }));
    }

    protected processGetReceiptInPlaceByZoneByDriverLicensePlate(response: HttpResponseBase): Observable<InPlaceReceiptOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InPlaceReceiptOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if a serial-number combination is not available
     * @param reportId (optional) 
     * @param vendorId (optional) 
     * @param paysTransport (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param reportOperationMode (optional) 
     * @return Success
     */
    serialNumberCombinationInUse(reportId: number | undefined, vendorId: number | undefined, paysTransport: boolean | undefined, serial: string | undefined, number: number | undefined, reportOperationMode: ActivityReportOperationMode | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/SerialNumberCombinationInUse?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (paysTransport === null)
            throw new Error("The parameter 'paysTransport' cannot be null.");
        else if (paysTransport !== undefined)
            url_ += "PaysTransport=" + encodeURIComponent("" + paysTransport) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (reportOperationMode === null)
            throw new Error("The parameter 'reportOperationMode' cannot be null.");
        else if (reportOperationMode !== undefined)
            url_ += "ReportOperationMode=" + encodeURIComponent("" + reportOperationMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSerialNumberCombinationInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSerialNumberCombinationInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSerialNumberCombinationInUse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the state of the report
     * @param receiptId (optional) 
     * @return Success
     */
    getState(receiptId: number | undefined): Observable<GetReceiptStateOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetState?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReceiptStateOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReceiptStateOutputDto>;
        }));
    }

    protected processGetState(response: HttpResponseBase): Observable<GetReceiptStateOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReceiptStateOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the pre activity report with scheduled entry time and validation status of the given id
     * @param id (optional) 
     * @return Success
     */
    getPreActivityReportWithScheduledEntryTimeAndValidationStatus(id: number | undefined): Observable<PreActivityReportWithApprovalResultAndErrorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetPreActivityReportWithScheduledEntryTimeAndValidationStatus?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportWithScheduledEntryTimeAndValidationStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportWithScheduledEntryTimeAndValidationStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportWithApprovalResultAndErrorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportWithApprovalResultAndErrorsOutput>;
        }));
    }

    protected processGetPreActivityReportWithScheduledEntryTimeAndValidationStatus(response: HttpResponseBase): Observable<PreActivityReportWithApprovalResultAndErrorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportWithApprovalResultAndErrorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Return whether the pre activity report with the given id exists.
     * @param activityReportId (optional) 
     * @return Success
     */
    existsPreActivityReport(activityReportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ExistsPreActivityReport?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistsPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistsPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExistsPreActivityReport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Return whether the pre activity report with the given transport id exists.
     * @param transportExternalId (optional) 
     * @return Success
     */
    existsPreActivityReportByTransportId(transportExternalId: number | undefined): Observable<ExistsPreActivityReportResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ExistsPreActivityReportByTransportId?";
        if (transportExternalId === null)
            throw new Error("The parameter 'transportExternalId' cannot be null.");
        else if (transportExternalId !== undefined)
            url_ += "transportExternalId=" + encodeURIComponent("" + transportExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistsPreActivityReportByTransportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistsPreActivityReportByTransportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistsPreActivityReportResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistsPreActivityReportResultOutput>;
        }));
    }

    protected processExistsPreActivityReportByTransportId(response: HttpResponseBase): Observable<ExistsPreActivityReportResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistsPreActivityReportResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if a trip number is available or not.
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param reportId (optional) 
     * @return Success
     */
    isValidTripNumber(tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, reportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/IsValidTripNumber?";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "tripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "operationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsValidTripNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsValidTripNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsValidTripNumber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Cancel pre activity report
     * @param body (optional) 
     * @return Success
     */
    cancelPreActivityReport(body: CancelPreActivityInput | undefined): Observable<CancelPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/CancelPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelPreActivityReportOutput>;
        }));
    }

    protected processCancelPreActivityReport(response: HttpResponseBase): Observable<CancelPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets an activity report stock integration result
     * @param reportId (optional) 
     * @return Success
     */
    getStockIntegrationResult(reportId: number | undefined): Observable<StockIntegrationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetStockIntegrationResult?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStockIntegrationResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStockIntegrationResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StockIntegrationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StockIntegrationOutputDto>;
        }));
    }

    protected processGetStockIntegrationResult(response: HttpResponseBase): Observable<StockIntegrationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StockIntegrationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if the report was modified since the given date.
     * @param date (optional) 
     * @param reportId (optional) 
     * @return Success
     */
    wasModifiedSince(date: DateTime | undefined, reportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/WasModifiedSince?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWasModifiedSince(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWasModifiedSince(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processWasModifiedSince(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Rejects the entering report of the given id.
     * @param reportId (optional) 
     * @return Success
     */
    reject(reportId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/Reject?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update trip driver
     * @param body (optional) 
     * @return Success
     */
    updateTripDriver(body: UpdateTripDriverInput | undefined): Observable<UpdateTripDriverOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/UpdateTripDriver";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTripDriver(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTripDriver(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTripDriverOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTripDriverOutput>;
        }));
    }

    protected processUpdateTripDriver(response: HttpResponseBase): Observable<UpdateTripDriverOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTripDriverOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update pre-report error list and calculate internal movement validation status
     * @param body (optional) 
     * @return Success
     */
    synchronizeInternalMovementPreActivityReport(body: SynchronizePreActivityReportInput | undefined): Observable<SynchronizePreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/SynchronizeInternalMovementPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeInternalMovementPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeInternalMovementPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SynchronizePreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SynchronizePreActivityReportOutput>;
        }));
    }

    protected processSynchronizeInternalMovementPreActivityReport(response: HttpResponseBase): Observable<SynchronizePreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SynchronizePreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update pre-report error list and calculate diverse product pre-report validation status
     * @param body (optional) 
     * @return Success
     */
    synchronizeDiverseProductPreActivityReport(body: SynchronizeDiverseProductPreActivityReportInput | undefined): Observable<SynchronizePreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/SynchronizeDiverseProductPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeDiverseProductPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeDiverseProductPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SynchronizePreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SynchronizePreActivityReportOutput>;
        }));
    }

    protected processSynchronizeDiverseProductPreActivityReport(response: HttpResponseBase): Observable<SynchronizePreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SynchronizePreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the pre activity report validation and approval result of the given report id
     * @param reportId (optional) 
     * @return Success
     */
    getPreActivityReportValidationAndApprovalResult(reportId: number | undefined): Observable<PreActivityReportValidationAndApprovalResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetPreActivityReportValidationAndApprovalResult?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportValidationAndApprovalResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportValidationAndApprovalResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportValidationAndApprovalResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportValidationAndApprovalResultOutput>;
        }));
    }

    protected processGetPreActivityReportValidationAndApprovalResult(response: HttpResponseBase): Observable<PreActivityReportValidationAndApprovalResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportValidationAndApprovalResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate if currently logged in vendor can access to the prereport of the given id
     * @param reportId (optional) 
     * @param includeDeletedReceipts (optional) 
     * @return Success
     */
    validateVendorCanAccessPreReport(reportId: number | undefined, includeDeletedReceipts: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ValidateVendorCanAccessPreReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (includeDeletedReceipts === null)
            throw new Error("The parameter 'includeDeletedReceipts' cannot be null.");
        else if (includeDeletedReceipts !== undefined)
            url_ += "includeDeletedReceipts=" + encodeURIComponent("" + includeDeletedReceipts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateVendorCanAccessPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateVendorCanAccessPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateVendorCanAccessPreReport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate if currently logged in diverse product transport vendor can access to the prereport of the given id
     * @param reportId (optional) 
     * @return Success
     */
    validateWoodOrDiverseProductTransportVendorCanAccessPreReport(reportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ValidateWoodOrDiverseProductTransportVendorCanAccessPreReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateWoodOrDiverseProductTransportVendorCanAccessPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateWoodOrDiverseProductTransportVendorCanAccessPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateWoodOrDiverseProductTransportVendorCanAccessPreReport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the pre activity report of the given transport id for driver validation
     * @param transportExternalId (optional) 
     * @return Success
     */
    getPreActivityReportByTransportIdForDriverValidation(transportExternalId: number | undefined): Observable<PreActivityReportInfoForDriverValidationDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetPreActivityReportByTransportIdForDriverValidation?";
        if (transportExternalId === null)
            throw new Error("The parameter 'transportExternalId' cannot be null.");
        else if (transportExternalId !== undefined)
            url_ += "transportExternalId=" + encodeURIComponent("" + transportExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportByTransportIdForDriverValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportByTransportIdForDriverValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportInfoForDriverValidationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportInfoForDriverValidationDto>;
        }));
    }

    protected processGetPreActivityReportByTransportIdForDriverValidation(response: HttpResponseBase): Observable<PreActivityReportInfoForDriverValidationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportInfoForDriverValidationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate if currently logged in internal movement transport vendor can access to the prereport of the given id
     * @param reportId (optional) 
     * @return Success
     */
    validateInternalMovementTransportVendorCanAccessPreReport(reportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ValidateInternalMovementTransportVendorCanAccessPreReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateInternalMovementTransportVendorCanAccessPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateInternalMovementTransportVendorCanAccessPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateInternalMovementTransportVendorCanAccessPreReport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate if currently logged in provider can access to the prereport of the given report id and vendor id
     * @param reportId (optional) 
     * @param vendorId (optional) 
     * @return Success
     */
    validateProviderCanAccessPreReportsByVendorExternalId(reportId: number | undefined, vendorId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ValidateProviderCanAccessPreReportsByVendorExternalId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateProviderCanAccessPreReportsByVendorExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateProviderCanAccessPreReportsByVendorExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateProviderCanAccessPreReportsByVendorExternalId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save semitrailers detected by rfid device, 
    In case detected semitrailers quantity is less than semitrailers required quantity, system completes using external semi trailers
     * @param body (optional) 
     * @return Success
     */
    saveSemitrailers(body: SaveSemitrailersInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/SaveSemitrailers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSemitrailers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSemitrailers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveSemitrailers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the pre activity report non blocking errors of the given transport id
     * @param transportExternalId (optional) 
     * @return Success
     */
    getPreActivityReportNonBlockingErrorsByTransportExternalId(transportExternalId: number | undefined): Observable<PreActivityWithNonBlockingErrorsOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetPreActivityReportNonBlockingErrorsByTransportExternalId?";
        if (transportExternalId === null)
            throw new Error("The parameter 'transportExternalId' cannot be null.");
        else if (transportExternalId !== undefined)
            url_ += "transportExternalId=" + encodeURIComponent("" + transportExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportNonBlockingErrorsByTransportExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportNonBlockingErrorsByTransportExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityWithNonBlockingErrorsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityWithNonBlockingErrorsOutput>;
        }));
    }

    protected processGetPreActivityReportNonBlockingErrorsByTransportExternalId(response: HttpResponseBase): Observable<PreActivityWithNonBlockingErrorsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityWithNonBlockingErrorsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the pre activity report monitor info
     * @return Success
     */
    getPreActivityReportsMonitorInfo(): Observable<PreActivityReportMonitorInfoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetPreActivityReportsMonitorInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportsMonitorInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportsMonitorInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportMonitorInfoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportMonitorInfoOutputDto>;
        }));
    }

    protected processGetPreActivityReportsMonitorInfo(response: HttpResponseBase): Observable<PreActivityReportMonitorInfoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportMonitorInfoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reject pre report
     * @param body (optional) 
     * @return Success
     */
    rejectPreReport(body: PreReportRejectionInput | undefined): Observable<PreReportRejectionOutput> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/RejectPreReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRejectPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRejectPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreReportRejectionOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreReportRejectionOutput>;
        }));
    }

    protected processRejectPreReport(response: HttpResponseBase): Observable<PreReportRejectionOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreReportRejectionOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns id of zone which truck's of receipt has detected on entrance process
     * @param reportId (optional) 
     * @return Success
     */
    getEntryZoneByReportId(reportId: number | undefined): Observable<ReportZoneInfoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetEntryZoneByReportId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntryZoneByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntryZoneByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportZoneInfoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportZoneInfoOutputDto>;
        }));
    }

    protected processGetEntryZoneByReportId(response: HttpResponseBase): Observable<ReportZoneInfoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportZoneInfoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns id of zone which truck's of receipt has detected on exit process
     * @param reportId (optional) 
     * @return Success
     */
    getExitZoneByReportId(reportId: number | undefined): Observable<ReportZoneInfoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetExitZoneByReportId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitZoneByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitZoneByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReportZoneInfoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReportZoneInfoOutputDto>;
        }));
    }

    protected processGetExitZoneByReportId(response: HttpResponseBase): Observable<ReportZoneInfoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportZoneInfoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns true if there is a report in place with the driver, false otherwise
     * @param placeId (optional) 
     * @param driverExternalId (optional) 
     * @param currentActivityReportId (optional) 
     * @return Success
     */
    existReportInPlaceByDriverExternalId(placeId: number | undefined, driverExternalId: number | undefined, currentActivityReportId: number | undefined): Observable<ExistReportInPlaceOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ExistReportInPlaceByDriverExternalId?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "driverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (currentActivityReportId === null)
            throw new Error("The parameter 'currentActivityReportId' cannot be null.");
        else if (currentActivityReportId !== undefined)
            url_ += "currentActivityReportId=" + encodeURIComponent("" + currentActivityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistReportInPlaceByDriverExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistReportInPlaceByDriverExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistReportInPlaceOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistReportInPlaceOutputDto>;
        }));
    }

    protected processExistReportInPlaceByDriverExternalId(response: HttpResponseBase): Observable<ExistReportInPlaceOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistReportInPlaceOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns true if there is a report in place with the truck, false otherwise
     * @param placeId (optional) 
     * @param truckExternalId (optional) 
     * @param currentActivityReportId (optional) 
     * @return Success
     */
    existReportInPlaceByTruckExternalId(placeId: number | undefined, truckExternalId: number | undefined, currentActivityReportId: number | undefined): Observable<ExistReportInPlaceOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ExistReportInPlaceByTruckExternalId?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (truckExternalId === null)
            throw new Error("The parameter 'truckExternalId' cannot be null.");
        else if (truckExternalId !== undefined)
            url_ += "truckExternalId=" + encodeURIComponent("" + truckExternalId) + "&";
        if (currentActivityReportId === null)
            throw new Error("The parameter 'currentActivityReportId' cannot be null.");
        else if (currentActivityReportId !== undefined)
            url_ += "currentActivityReportId=" + encodeURIComponent("" + currentActivityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistReportInPlaceByTruckExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistReportInPlaceByTruckExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExistReportInPlaceOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExistReportInPlaceOutputDto>;
        }));
    }

    protected processExistReportInPlaceByTruckExternalId(response: HttpResponseBase): Observable<ExistReportInPlaceOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExistReportInPlaceOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create the activity report scanner info
     * @param body (optional) ScannerInfoInputDto dto
     * @return Success
     */
    createActivityReportScannerInfo(body: ScannerInfoInputDto | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/CreateActivityReportScannerInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivityReportScannerInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivityReportScannerInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateActivityReportScannerInfo(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create Activity report information for entrace process.
     * @param activityReportId (optional) Actiivty report id
     * @param tagValue (optional) Tag information
     * @param initialEntranceTime (optional) 
     * @param body (optional) 
     * @return Success
     */
    createActivityReportInfo(activityReportId: number | undefined, tagValue: number | undefined, initialEntranceTime: DateTime | undefined, body: CheckpointMode | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/CreateActivityReportInfo?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        if (initialEntranceTime === null)
            throw new Error("The parameter 'initialEntranceTime' cannot be null.");
        else if (initialEntranceTime !== undefined)
            url_ += "initialEntranceTime=" + encodeURIComponent(initialEntranceTime ? "" + initialEntranceTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateActivityReportInfo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update activity report information for entrance process.
     * @param reportId (optional) 
     * @param finalEntranceTime (optional) 
     * @return Success
     */
    updateActivityReportInfoFinalEntranceTime(reportId: number | undefined, finalEntranceTime: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/UpdateActivityReportInfoFinalEntranceTime?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (finalEntranceTime === null)
            throw new Error("The parameter 'finalEntranceTime' cannot be null.");
        else if (finalEntranceTime !== undefined)
            url_ += "finalEntranceTime=" + encodeURIComponent(finalEntranceTime ? "" + finalEntranceTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivityReportInfoFinalEntranceTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivityReportInfoFinalEntranceTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActivityReportInfoFinalEntranceTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update activity report information for exit process.
     * @param reportId (optional) 
     * @param initialExitTime (optional) 
     * @param body (optional) 
     * @return Success
     */
    updateActivityReportInfoInitialExitTime(reportId: number | undefined, initialExitTime: DateTime | undefined, body: CheckpointMode | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/UpdateActivityReportInfoInitialExitTime?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (initialExitTime === null)
            throw new Error("The parameter 'initialExitTime' cannot be null.");
        else if (initialExitTime !== undefined)
            url_ += "initialExitTime=" + encodeURIComponent(initialExitTime ? "" + initialExitTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivityReportInfoInitialExitTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivityReportInfoInitialExitTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActivityReportInfoInitialExitTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update activity report information for exit process.
     * @param reportId (optional) 
     * @param finalExitTime (optional) 
     * @return Success
     */
    updateActivityReportInfoFinalExitTime(reportId: number | undefined, finalExitTime: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/UpdateActivityReportInfoFinalExitTime?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (finalExitTime === null)
            throw new Error("The parameter 'finalExitTime' cannot be null.");
        else if (finalExitTime !== undefined)
            url_ += "finalExitTime=" + encodeURIComponent(finalExitTime ? "" + finalExitTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateActivityReportInfoFinalExitTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateActivityReportInfoFinalExitTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateActivityReportInfoFinalExitTime(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve information if any report is in progress by plate
     * @param licensePlate (optional) 
     * @return Success
     */
    isAnyReportInProgressByPlate(licensePlate: string | undefined): Observable<IsAnyReportInProgressOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/IsAnyReportInProgressByPlate?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsAnyReportInProgressByPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsAnyReportInProgressByPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsAnyReportInProgressOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsAnyReportInProgressOutputDto>;
        }));
    }

    protected processIsAnyReportInProgressByPlate(response: HttpResponseBase): Observable<IsAnyReportInProgressOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsAnyReportInProgressOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Success", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves dua information by activity report id
     * @param reportId (optional) 
     * @return Success
     */
    getDuaValidationInfo(reportId: number | undefined): Observable<DuaValidationInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetDuaValidationInfo?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDuaValidationInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDuaValidationInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DuaValidationInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DuaValidationInfoDto>;
        }));
    }

    protected processGetDuaValidationInfo(response: HttpResponseBase): Observable<DuaValidationInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuaValidationInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param placeId (optional) 
     * @param activityReportId (optional) 
     * @param externalActivityReportId (optional) 
     * @param stateFilter (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param activityReportType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWoodControlActivityReportExternalProcessingResults(placeId: number | undefined, activityReportId: number | undefined, externalActivityReportId: number | undefined, stateFilter: ExternalProcessingStateFilter | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, activityReportType: ActivityReportType | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/GetWoodControlActivityReportExternalProcessingResults?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "ActivityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (externalActivityReportId === null)
            throw new Error("The parameter 'externalActivityReportId' cannot be null.");
        else if (externalActivityReportId !== undefined)
            url_ += "ExternalActivityReportId=" + encodeURIComponent("" + externalActivityReportId) + "&";
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (activityReportType === null)
            throw new Error("The parameter 'activityReportType' cannot be null.");
        else if (activityReportType !== undefined)
            url_ += "ActivityReportType=" + encodeURIComponent("" + activityReportType) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodControlActivityReportExternalProcessingResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodControlActivityReportExternalProcessingResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto>;
        }));
    }

    protected processGetWoodControlActivityReportExternalProcessingResults(response: HttpResponseBase): Observable<PagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activityReportId (optional) 
     * @param userReason (optional) 
     * @return Success
     */
    manualExternalProcessingConfirmation(activityReportId: number | undefined, userReason: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/ManualExternalProcessingConfirmation?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (userReason === null)
            throw new Error("The parameter 'userReason' cannot be null.");
        else if (userReason !== undefined)
            url_ += "userReason=" + encodeURIComponent("" + userReason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManualExternalProcessingConfirmation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManualExternalProcessingConfirmation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processManualExternalProcessingConfirmation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateExternalProcessingResult(body: UpdateExternalProcessingResultInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReport/UpdateExternalProcessingResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateExternalProcessingResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateExternalProcessingResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateExternalProcessingResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ActivityReportLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Adds a new log to the activity report
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateActivityReportLogInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReportLog/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a list of all logs of a given activity report, filtered, sorted and paged.
     * @param id (optional) 
     * @return Success
     */
    getByActivityReportId(id: number | undefined): Observable<ActivityReportLogDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReportLog/GetByActivityReportId?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByActivityReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByActivityReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityReportLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityReportLogDto[]>;
        }));
    }

    protected processGetByActivityReportId(response: HttpResponseBase): Observable<ActivityReportLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReportLogDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Activity report not found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Adds a new logyard log to the activity report
     * @param body (optional) 
     * @return Success
     */
    createForLogyard(body: CreateLogyardActivityReportLogInput | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReportLog/CreateForLogyard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForLogyard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForLogyard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateForLogyard(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ActivityReportNumberingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param deviceId (optional) 
     * @param placesId (optional) 
     * @return Success
     */
    getActivityReportNumberRangeAssignmentsByDeviceId(deviceId: string | undefined, placesId: number[] | undefined): Observable<ActivityReportNumberRangeAssignmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ActivityReportNumbering/GetActivityReportNumberRangeAssignmentsByDeviceId?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "DeviceId=" + encodeURIComponent("" + deviceId) + "&";
        if (placesId === null)
            throw new Error("The parameter 'placesId' cannot be null.");
        else if (placesId !== undefined)
            placesId && placesId.forEach(item => { url_ += "PlacesId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityReportNumberRangeAssignmentsByDeviceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityReportNumberRangeAssignmentsByDeviceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityReportNumberRangeAssignmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityReportNumberRangeAssignmentDto[]>;
        }));
    }

    protected processGetActivityReportNumberRangeAssignmentsByDeviceId(response: HttpResponseBase): Observable<ActivityReportNumberRangeAssignmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ActivityReportNumberRangeAssignmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ArchimedesIndicatorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get's the current cube status by current place
     * @return Success
     */
    getCubeStatusIndicatorByCurrentPlace(): Observable<DeviceIsActiveIndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/ArchimedesIndicator/GetCubeStatusIndicatorByCurrentPlace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCubeStatusIndicatorByCurrentPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCubeStatusIndicatorByCurrentPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceIsActiveIndicatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceIsActiveIndicatorDto>;
        }));
    }

    protected processGetCubeStatusIndicatorByCurrentPlace(response: HttpResponseBase): Observable<DeviceIsActiveIndicatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceIsActiveIndicatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's the current loader machine status by current place
     * @return Success
     */
    getLoaderMachineStatusIndicatorByCurrentPlace(): Observable<DeviceIsActiveIndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/ArchimedesIndicator/GetLoaderMachineStatusIndicatorByCurrentPlace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoaderMachineStatusIndicatorByCurrentPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoaderMachineStatusIndicatorByCurrentPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceIsActiveIndicatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceIsActiveIndicatorDto>;
        }));
    }

    protected processGetLoaderMachineStatusIndicatorByCurrentPlace(response: HttpResponseBase): Observable<DeviceIsActiveIndicatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceIsActiveIndicatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Return the indicator of pending samples that are with state as InPlant and are not yet done the sample
     * @param sampleAssignment (optional) Sample type
     * @return Success
     */
    getPendingSamplesIndicator(sampleAssignment: SampleAssignmentType | undefined): Observable<PendingSamplesAssignmentDto> {
        let url_ = this.baseUrl + "/api/services/app/ArchimedesIndicator/GetPendingSamplesIndicator?";
        if (sampleAssignment === null)
            throw new Error("The parameter 'sampleAssignment' cannot be null.");
        else if (sampleAssignment !== undefined)
            url_ += "sampleAssignment=" + encodeURIComponent("" + sampleAssignment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPendingSamplesIndicator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPendingSamplesIndicator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PendingSamplesAssignmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PendingSamplesAssignmentDto>;
        }));
    }

    protected processGetPendingSamplesIndicator(response: HttpResponseBase): Observable<PendingSamplesAssignmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PendingSamplesAssignmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the current percentage
     * @param period_ExternalId (optional) 
     * @param period_StartDatePeriod (optional) 
     * @param period_EndDatePeriod (optional) 
     * @param standNumber (optional) 
     * @param articleId (optional) 
     * @param usesScanner (optional) 
     * @return Success
     */
    calculateCurrentSamplePercentage(period_ExternalId: number | undefined, period_StartDatePeriod: DateTime | undefined, period_EndDatePeriod: DateTime | undefined, standNumber: number | undefined, articleId: number | undefined, usesScanner: boolean | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/ArchimedesIndicator/CalculateCurrentSamplePercentage?";
        if (period_ExternalId === null)
            throw new Error("The parameter 'period_ExternalId' cannot be null.");
        else if (period_ExternalId !== undefined)
            url_ += "Period.ExternalId=" + encodeURIComponent("" + period_ExternalId) + "&";
        if (period_StartDatePeriod === null)
            throw new Error("The parameter 'period_StartDatePeriod' cannot be null.");
        else if (period_StartDatePeriod !== undefined)
            url_ += "Period.StartDatePeriod=" + encodeURIComponent(period_StartDatePeriod ? "" + period_StartDatePeriod.toString() : "") + "&";
        if (period_EndDatePeriod === null)
            throw new Error("The parameter 'period_EndDatePeriod' cannot be null.");
        else if (period_EndDatePeriod !== undefined)
            url_ += "Period.EndDatePeriod=" + encodeURIComponent(period_EndDatePeriod ? "" + period_EndDatePeriod.toString() : "") + "&";
        if (standNumber === null)
            throw new Error("The parameter 'standNumber' cannot be null.");
        else if (standNumber !== undefined)
            url_ += "StandNumber=" + encodeURIComponent("" + standNumber) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (usesScanner === null)
            throw new Error("The parameter 'usesScanner' cannot be null.");
        else if (usesScanner !== undefined)
            url_ += "UsesScanner=" + encodeURIComponent("" + usesScanner) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateCurrentSamplePercentage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateCurrentSamplePercentage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCalculateCurrentSamplePercentage(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Return all non deleted receipts and pre receipts at the user current location and period
     * @param externalId (optional) 
     * @param startDatePeriod (optional) 
     * @param endDatePeriod (optional) 
     * @return Success
     */
    getEntranceReceiptsInCurrentPeriod(externalId: number | undefined, startDatePeriod: DateTime | undefined, endDatePeriod: DateTime | undefined): Observable<IndicatorsConfForArchimedesReceiptDto> {
        let url_ = this.baseUrl + "/api/services/app/ArchimedesIndicator/GetEntranceReceiptsInCurrentPeriod?";
        if (externalId === null)
            throw new Error("The parameter 'externalId' cannot be null.");
        else if (externalId !== undefined)
            url_ += "ExternalId=" + encodeURIComponent("" + externalId) + "&";
        if (startDatePeriod === null)
            throw new Error("The parameter 'startDatePeriod' cannot be null.");
        else if (startDatePeriod !== undefined)
            url_ += "StartDatePeriod=" + encodeURIComponent(startDatePeriod ? "" + startDatePeriod.toString() : "") + "&";
        if (endDatePeriod === null)
            throw new Error("The parameter 'endDatePeriod' cannot be null.");
        else if (endDatePeriod !== undefined)
            url_ += "EndDatePeriod=" + encodeURIComponent(endDatePeriod ? "" + endDatePeriod.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntranceReceiptsInCurrentPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntranceReceiptsInCurrentPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndicatorsConfForArchimedesReceiptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndicatorsConfForArchimedesReceiptDto>;
        }));
    }

    protected processGetEntranceReceiptsInCurrentPeriod(response: HttpResponseBase): Observable<IndicatorsConfForArchimedesReceiptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndicatorsConfForArchimedesReceiptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AuditLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get auditing logs with the given filters
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogs(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfAuditLogListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfAuditLogListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfAuditLogListDto>;
        }));
    }

    protected processGetAuditLogs(response: HttpResponseBase): Observable<PagedResultDtoOfAuditLogListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfAuditLogListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export all auditing logs with the given filters to an Excel file
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param serviceName (optional) 
     * @param methodName (optional) 
     * @param browserInfo (optional) 
     * @param hasException (optional) 
     * @param minExecutionDuration (optional) 
     * @param maxExecutionDuration (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAuditLogsToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, serviceName: string | undefined, methodName: string | undefined, browserInfo: string | undefined, hasException: boolean | undefined, minExecutionDuration: number | undefined, maxExecutionDuration: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName === null)
            throw new Error("The parameter 'serviceName' cannot be null.");
        else if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName === null)
            throw new Error("The parameter 'methodName' cannot be null.");
        else if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo === null)
            throw new Error("The parameter 'browserInfo' cannot be null.");
        else if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException === null)
            throw new Error("The parameter 'hasException' cannot be null.");
        else if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration === null)
            throw new Error("The parameter 'minExecutionDuration' cannot be null.");
        else if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration === null)
            throw new Error("The parameter 'maxExecutionDuration' cannot be null.");
        else if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAuditLogsToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAuditLogsToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the types of the entities whose changes history can be obtained
     * @return Success
     */
    getEntityHistoryObjectTypes(): Observable<NameValueDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityHistoryObjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueDto[]>;
        }));
    }

    protected processGetEntityHistoryObjectTypes(response: HttpResponseBase): Observable<NameValueDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the history of changes of a specific entity between two dates
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChanges(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the history of changes of a specific entity
     * @param entityTypeFullName (optional) 
     * @param entityId (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityTypeChanges(entityTypeFullName: string | undefined, entityId: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfEntityChangeListDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityTypeChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfEntityChangeListDto>;
        }));
    }

    protected processGetEntityTypeChanges(response: HttpResponseBase): Observable<PagedResultDtoOfEntityChangeListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfEntityChangeListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export to excel the history of changes of a specific entity between two dates
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param userName (optional) 
     * @param entityTypeFullName (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getEntityChangesToExcel(startDate: DateTime | undefined, endDate: DateTime | undefined, userName: string | undefined, entityTypeFullName: string | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (userName === null)
            throw new Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName === null)
            throw new Error("The parameter 'entityTypeFullName' cannot be null.");
        else if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityChangesToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetEntityChangesToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the history of changes of the properties of the entity of the given id
     * @param entityChangeId (optional) 
     * @return Success
     */
    getEntityPropertyChanges(entityChangeId: number | undefined): Observable<EntityPropertyChangeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId === null)
            throw new Error("The parameter 'entityChangeId' cannot be null.");
        else if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityPropertyChanges(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityPropertyChangeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityPropertyChangeDto[]>;
        }));
    }

    protected processGetEntityPropertyChanges(response: HttpResponseBase): Observable<EntityPropertyChangeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityPropertyChangeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class BrokerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all the brokers availables paginated
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBrokerDto> {
        let url_ = this.baseUrl + "/api/services/app/Broker/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBrokerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBrokerDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfBrokerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBrokerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an specific broker by it's id
     * @param id (optional) 
     * @return Success
     */
    getBroker(id: number | undefined): Observable<BrokerDto> {
        let url_ = this.baseUrl + "/api/services/app/Broker/GetBroker?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBroker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBroker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BrokerDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BrokerDto>;
        }));
    }

    protected processGetBroker(response: HttpResponseBase): Observable<BrokerDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BrokerDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a broker
     * @param body (optional) 
     * @return Success
     */
    createBroker(body: CreateBrokerInputDto | undefined): Observable<CreateBrokerOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Broker/CreateBroker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateBroker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateBroker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateBrokerOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateBrokerOutputDto>;
        }));
    }

    protected processCreateBroker(response: HttpResponseBase): Observable<CreateBrokerOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateBrokerOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an specific broker by it's id
     * @param body (optional) A class containing the new broker information
     * @return Success
     */
    updateBroker(body: UpdateBrokerInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Broker/UpdateBroker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateBroker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateBroker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateBroker(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an specific broker by it's id
     * @param id (optional) The broker id
     * @return Success
     */
    deleteBroker(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Broker/DeleteBroker?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteBroker(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteBroker(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteBroker(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * It returns an boolean verifing if Jaume Sere is already dispatcher by input externalId value
     * @param externalId (optional) The external id
     * @return Success
     */
    isJaumeSereDispatcher(externalId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Broker/IsJaumeSereDispatcher?";
        if (externalId === null)
            throw new Error("The parameter 'externalId' cannot be null.");
        else if (externalId !== undefined)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsJaumeSereDispatcher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsJaumeSereDispatcher(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsJaumeSereDispatcher(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CachingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllCaches(): Observable<ListResultDtoOfCacheDto> {
        let url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfCacheDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfCacheDto>;
        }));
    }

    protected processGetAllCaches(response: HttpResponseBase): Observable<ListResultDtoOfCacheDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfCacheDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    clearCache(body: EntityDtoOfString | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCache(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCache(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCache(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearAllCaches(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearAllCaches(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearAllCaches(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearAllCaches(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CalibrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a new calibration for the scale
     * @param body (optional) A class that contains the information needed to create a calibration for scale
     * @return Success
     */
    createNewCalibration(body: ArchimedesCalibrationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Calibration/CreateNewCalibration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateNewCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateNewCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateNewCalibration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verifies if an scale has calibration
     * @param deviceId (optional) The device id
     * @return Success
     */
    hasCalibration(deviceId: number | undefined): Observable<CalibrationTimePeriodOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Calibration/HasCalibration?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalibrationTimePeriodOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalibrationTimePeriodOutputDto>;
        }));
    }

    protected processHasCalibration(response: HttpResponseBase): Observable<CalibrationTimePeriodOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalibrationTimePeriodOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ChatServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUserChatFriendsWithSettings(): Observable<GetUserChatFriendsWithSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatFriendsWithSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserChatFriendsWithSettingsOutput>;
        }));
    }

    protected processGetUserChatFriendsWithSettings(response: HttpResponseBase): Observable<GetUserChatFriendsWithSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserChatFriendsWithSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tenantId (optional) 
     * @param userId (optional) 
     * @param minMessageId (optional) 
     * @return Success
     */
    getUserChatMessages(tenantId: number | undefined, userId: number | undefined, minMessageId: number | undefined): Observable<ListResultDtoOfChatMessageDto> {
        let url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId === null)
            throw new Error("The parameter 'minMessageId' cannot be null.");
        else if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserChatMessages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfChatMessageDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfChatMessageDto>;
        }));
    }

    protected processGetUserChatMessages(response: HttpResponseBase): Observable<ListResultDtoOfChatMessageDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfChatMessageDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markAllUnreadMessagesOfUserAsRead(body: MarkAllUnreadMessagesOfUserAsReadInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkAllUnreadMessagesOfUserAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkAllUnreadMessagesOfUserAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CommonLookupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param onlyFreeItems (optional) 
     * @return Success
     */
    getEditionsForCombobox(onlyFreeItems: boolean | undefined): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems === null)
            throw new Error("The parameter 'onlyFreeItems' cannot be null.");
        else if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForCombobox(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfSubscribableEditionComboboxItemDto>;
        }));
    }

    protected processGetEditionsForCombobox(response: HttpResponseBase): Observable<ListResultDtoOfSubscribableEditionComboboxItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDefaultEditionName(): Observable<GetDefaultEditionNameOutput> {
        let url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultEditionName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDefaultEditionNameOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDefaultEditionNameOutput>;
        }));
    }

    protected processGetDefaultEditionName(response: HttpResponseBase): Observable<GetDefaultEditionNameOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDefaultEditionNameOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class CubeChangeLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets information for generating a cube report according to the input
     * @param body (optional) Information of the filters to apply
     * @return Success
     */
    generateCubeReport(body: CubeReportInputDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/CubeChangeLog/GenerateCubeReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateCubeReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateCubeReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGenerateCubeReport(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DashboardCustomizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getUserDashboard(dashboardName: string | undefined, application: string | undefined): Observable<Dashboard> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetUserDashboard?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDashboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDashboard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Dashboard>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Dashboard>;
        }));
    }

    protected processGetUserDashboard(response: HttpResponseBase): Observable<Dashboard> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Dashboard.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    savePage(body: SavePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/SavePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSavePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSavePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSavePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    renamePage(body: RenamePageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/RenamePage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenamePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenamePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenamePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addNewPage(body: AddNewPageInput | undefined): Observable<AddNewPageOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddNewPage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewPage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewPage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddNewPageOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddNewPageOutput>;
        }));
    }

    protected processAddNewPage(response: HttpResponseBase): Observable<AddNewPageOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddNewPageOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    deletePage(id: string | undefined, dashboardName: string | undefined, application: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/DeletePage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addWidget(body: AddWidgetInput | undefined): Observable<Widget> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/AddWidget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddWidget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddWidget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Widget>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Widget>;
        }));
    }

    protected processAddWidget(response: HttpResponseBase): Observable<Widget> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Widget.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getDashboardDefinition(dashboardName: string | undefined, application: string | undefined): Observable<DashboardOutput> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetDashboardDefinition?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardDefinition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardDefinition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DashboardOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DashboardOutput>;
        }));
    }

    protected processGetDashboardDefinition(response: HttpResponseBase): Observable<DashboardOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DashboardOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param dashboardName (optional) 
     * @param application (optional) 
     * @return Success
     */
    getAllWidgetDefinitions(dashboardName: string | undefined, application: string | undefined): Observable<WidgetOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/DashboardCustomization/GetAllWidgetDefinitions?";
        if (dashboardName === null)
            throw new Error("The parameter 'dashboardName' cannot be null.");
        else if (dashboardName !== undefined)
            url_ += "DashboardName=" + encodeURIComponent("" + dashboardName) + "&";
        if (application === null)
            throw new Error("The parameter 'application' cannot be null.");
        else if (application !== undefined)
            url_ += "Application=" + encodeURIComponent("" + application) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWidgetDefinitions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWidgetDefinitions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WidgetOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WidgetOutput[]>;
        }));
    }

    protected processGetAllWidgetDefinitions(response: HttpResponseBase): Observable<WidgetOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WidgetOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DemoUiComponentsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDate(date: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDate(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param date (optional) 
     * @return Success
     */
    sendAndGetDateTime(date: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateTime(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    sendAndGetDateRange(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<DateToStringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetDateRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateToStringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateToStringOutput>;
        }));
    }

    protected processSendAndGetDateRange(response: HttpResponseBase): Observable<DateToStringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DateToStringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param searchTerm (optional) 
     * @return Success
     */
    getCountries(searchTerm: string | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processGetCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendAndGetSelectedCountries(body: NameValueOfString[] | undefined): Observable<NameValueOfString[]> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetSelectedCountries(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NameValueOfString[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NameValueOfString[]>;
        }));
    }

    protected processSendAndGetSelectedCountries(response: HttpResponseBase): Observable<NameValueOfString[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NameValueOfString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    sendAndGetValue(input: string | undefined): Observable<StringOutput> {
        let url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendAndGetValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendAndGetValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StringOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StringOutput>;
        }));
    }

    protected processSendAndGetValue(response: HttpResponseBase): Observable<StringOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StringOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DensityPerSpeciesGroupServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdate(body: DensityPerSpeciesGroupDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DensityPerSpeciesGroup/CreateOrUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DensityPerSpeciesGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDensityPerSpeciesGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/DensityPerSpeciesGroup/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDensityPerSpeciesGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDensityPerSpeciesGroupDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDensityPerSpeciesGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDensityPerSpeciesGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getById(id: number | undefined): Observable<DensityPerSpeciesGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/DensityPerSpeciesGroup/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DensityPerSpeciesGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DensityPerSpeciesGroupDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DensityPerSpeciesGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DensityPerSpeciesGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DeviceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get's all the devices available in the specific place
     * @param deviceType (optional) 
     * @param zoneType (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(deviceType: number | undefined, zoneType: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDeviceDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetAll?";
        if (deviceType === null)
            throw new Error("The parameter 'deviceType' cannot be null.");
        else if (deviceType !== undefined)
            url_ += "DeviceType=" + encodeURIComponent("" + deviceType) + "&";
        if (zoneType === null)
            throw new Error("The parameter 'zoneType' cannot be null.");
        else if (zoneType !== undefined)
            url_ += "ZoneType=" + encodeURIComponent("" + zoneType) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDeviceDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an specific device based on it's id
     * @param deviceId (optional) Device id needed for the request
     * @return Success
     */
    get(deviceId: number | undefined): Observable<DevicesDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Device/Get?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DevicesDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DevicesDtoOutput>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DevicesDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DevicesDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an specific device
     * @param body (optional) An object with the given fields needed to update a device
     * @return Success
     */
    update(body: DevicesDtoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Device/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create an specific device
     * @param body (optional) 
     * @return Success
     */
    create(body: DevicesDtoInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Device/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a device with it's id
     * @param deviceId (optional) The device id
     * @return Success
     */
    delete(deviceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Device/Delete?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of exists device types
     * @return Success
     */
    getDeviceTypes(): Observable<DeviceTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetDeviceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceTypeDto[]>;
        }));
    }

    protected processGetDeviceTypes(response: HttpResponseBase): Observable<DeviceTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the active loader machine in the place
     * @param placeId (optional) The place id
     * @return Success
     */
    getActiveLoaderMachineInPlace(placeId: number | undefined): Observable<LoaderMachineDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetActiveLoaderMachineInPlace?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveLoaderMachineInPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveLoaderMachineInPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoaderMachineDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoaderMachineDto>;
        }));
    }

    protected processGetActiveLoaderMachineInPlace(response: HttpResponseBase): Observable<LoaderMachineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoaderMachineDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of printers available in the zone
     * @param zoneId (optional) The zone id
     * @return Success
     */
    getActivePrintersInZone(zoneId: number | undefined): Observable<PrinterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetActivePrintersInZone?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivePrintersInZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivePrintersInZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrinterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrinterDto[]>;
        }));
    }

    protected processGetActivePrintersInZone(response: HttpResponseBase): Observable<PrinterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrinterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the scale active in the zone
     * @param zoneId (optional) The zone id
     * @return Success
     */
    getActiveScaleInZone(zoneId: number | undefined): Observable<ScaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetActiveScaleInZone?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveScaleInZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveScaleInZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleDto>;
        }));
    }

    protected processGetActiveScaleInZone(response: HttpResponseBase): Observable<ScaleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the active scale based on it's zone type
     * @param zoneTypeId (optional) Zone type id
     * @return Success
     */
    getActiveScaleInZoneType(zoneTypeId: number | undefined): Observable<ScaleDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetActiveScaleInZoneType?";
        if (zoneTypeId === null)
            throw new Error("The parameter 'zoneTypeId' cannot be null.");
        else if (zoneTypeId !== undefined)
            url_ += "zoneTypeId=" + encodeURIComponent("" + zoneTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveScaleInZoneType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveScaleInZoneType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleDto>;
        }));
    }

    protected processGetActiveScaleInZoneType(response: HttpResponseBase): Observable<ScaleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the information from zone based on the devices ids
     * @param devicesIds (optional) A list with the devices id
     * @return Success
     */
    getDeviceZoneInfo(devicesIds: number[] | undefined): Observable<DeviceZoneInfoDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetDeviceZoneInfo?";
        if (devicesIds === null)
            throw new Error("The parameter 'devicesIds' cannot be null.");
        else if (devicesIds !== undefined)
            devicesIds && devicesIds.forEach(item => { url_ += "devicesIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceZoneInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceZoneInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceZoneInfoDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceZoneInfoDto[]>;
        }));
    }

    protected processGetDeviceZoneInfo(response: HttpResponseBase): Observable<DeviceZoneInfoDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceZoneInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the volume from a loader machine
     * @param weightOff (optional) 
     * @param submergedWeight (optional) 
     * @param zoneId (optional) 
     * @return Success
     */
    getLoaderMachineVolume(weightOff: number | undefined, submergedWeight: number | undefined, zoneId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetLoaderMachineVolume?";
        if (weightOff === null)
            throw new Error("The parameter 'weightOff' cannot be null.");
        else if (weightOff !== undefined)
            url_ += "weightOff=" + encodeURIComponent("" + weightOff) + "&";
        if (submergedWeight === null)
            throw new Error("The parameter 'submergedWeight' cannot be null.");
        else if (submergedWeight !== undefined)
            url_ += "submergedWeight=" + encodeURIComponent("" + submergedWeight) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoaderMachineVolume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoaderMachineVolume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLoaderMachineVolume(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an report of water density including: Date when saved, Last waster density, new water density, and the user
     * @param deviceId (optional) The device id
     * @return Success
     */
    getWaterDensityAuditories(deviceId: number | undefined): Observable<PagedResultDtoOfWaterDensityAuditoryDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetWaterDensityAuditories?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWaterDensityAuditories(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWaterDensityAuditories(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWaterDensityAuditoryDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWaterDensityAuditoryDto>;
        }));
    }

    protected processGetWaterDensityAuditories(response: HttpResponseBase): Observable<PagedResultDtoOfWaterDensityAuditoryDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWaterDensityAuditoryDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get Archimedes zone scales for calibration
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getArquimedesZoneScalesForCalibration(filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDeviceDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetArquimedesZoneScalesForCalibration?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArquimedesZoneScalesForCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArquimedesZoneScalesForCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDeviceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDeviceDto>;
        }));
    }

    protected processGetArquimedesZoneScalesForCalibration(response: HttpResponseBase): Observable<PagedResultDtoOfDeviceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDeviceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's all the printers in the place
     * @param placeId (optional) 
     * @param type (optional) 
     * @return Success
     */
    getAllPrintersInPlace(placeId: number | undefined, type: PrinterType | undefined): Observable<PrinterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetAllPrintersInPlace?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPrintersInPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPrintersInPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PrinterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PrinterDto[]>;
        }));
    }

    protected processGetAllPrintersInPlace(response: HttpResponseBase): Observable<PrinterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrinterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's the smartGateway url by device Id
     * @param deviceId (optional) The deviceId
     * @return Success
     */
    getPlaceByDeviceId(deviceId: number | undefined): Observable<PlaceExternalServicesConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetPlaceByDeviceId?";
        if (deviceId === null)
            throw new Error("The parameter 'deviceId' cannot be null.");
        else if (deviceId !== undefined)
            url_ += "deviceId=" + encodeURIComponent("" + deviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaceByDeviceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceByDeviceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceExternalServicesConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceExternalServicesConfigurationDto>;
        }));
    }

    protected processGetPlaceByDeviceId(response: HttpResponseBase): Observable<PlaceExternalServicesConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaceExternalServicesConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's the semaphore active by it's zoneId
     * @param zoneId (optional) The zone id
     * @return Success
     */
    getActiveSemaphoreByZoneId(zoneId: number | undefined): Observable<SemaphoreDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetActiveSemaphoreByZoneId?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveSemaphoreByZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveSemaphoreByZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SemaphoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SemaphoreDto>;
        }));
    }

    protected processGetActiveSemaphoreByZoneId(response: HttpResponseBase): Observable<SemaphoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SemaphoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get scanner information by zone
     * @param zoneId (optional) The zone id
     * @return Success
     */
    getScannerInformationByZone(zoneId: number | undefined): Observable<ScannerInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetScannerInformationByZone?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannerInformationByZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannerInformationByZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerInfoDto>;
        }));
    }

    protected processGetScannerInformationByZone(response: HttpResponseBase): Observable<ScannerInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Set new state to cube in zone id
     * @param zoneId (optional) The zone id
     * @param body (optional) New cube state
     * @return Success
     */
    setCubeStateByZoneId(zoneId: number | undefined, body: ActualState | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Device/SetCubeStateByZoneId?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCubeStateByZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCubeStateByZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetCubeStateByZoneId(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param zoneId (optional) 
     * @return Success
     */
    getCubeByZoneId(zoneId: number | undefined): Observable<CubeDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetCubeByZoneId?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCubeByZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCubeByZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CubeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CubeDto>;
        }));
    }

    protected processGetCubeByZoneId(response: HttpResponseBase): Observable<CubeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CubeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param placeId (optional) 
     * @return Success
     */
    getLoaderMachineForCalibrationByPlaceId(placeId: number | undefined): Observable<LoaderMachineDto> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetLoaderMachineForCalibrationByPlaceId?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoaderMachineForCalibrationByPlaceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoaderMachineForCalibrationByPlaceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoaderMachineDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoaderMachineDto>;
        }));
    }

    protected processGetLoaderMachineForCalibrationByPlaceId(response: HttpResponseBase): Observable<LoaderMachineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoaderMachineDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanners for calibration by current place
     * @return Success
     */
    getAllScannersByCurrentPlaceForCalibration(): Observable<ScannerForCalibrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetAllScannersByCurrentPlaceForCalibration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScannersByCurrentPlaceForCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScannersByCurrentPlaceForCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerForCalibrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerForCalibrationDto[]>;
        }));
    }

    protected processGetAllScannersByCurrentPlaceForCalibration(response: HttpResponseBase): Observable<ScannerForCalibrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScannerForCalibrationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeInactives (optional) 
     * @return Success
     */
    getCurrentPlaceEntryScalesForCalibration(includeInactives: boolean | undefined): Observable<ScaleForCalibrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetCurrentPlaceEntryScalesForCalibration?";
        if (includeInactives === null)
            throw new Error("The parameter 'includeInactives' cannot be null.");
        else if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPlaceEntryScalesForCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPlaceEntryScalesForCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleForCalibrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleForCalibrationDto[]>;
        }));
    }

    protected processGetCurrentPlaceEntryScalesForCalibration(response: HttpResponseBase): Observable<ScaleForCalibrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScaleForCalibrationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeInactives (optional) 
     * @return Success
     */
    getCurrentPlaceExitScalesForCalibration(includeInactives: boolean | undefined): Observable<ScaleForCalibrationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetCurrentPlaceExitScalesForCalibration?";
        if (includeInactives === null)
            throw new Error("The parameter 'includeInactives' cannot be null.");
        else if (includeInactives !== undefined)
            url_ += "includeInactives=" + encodeURIComponent("" + includeInactives) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPlaceExitScalesForCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPlaceExitScalesForCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleForCalibrationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleForCalibrationDto[]>;
        }));
    }

    protected processGetCurrentPlaceExitScalesForCalibration(response: HttpResponseBase): Observable<ScaleForCalibrationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScaleForCalibrationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param zoneId (optional) 
     * @return Success
     */
    getCubeIsActiveByZoneId(zoneId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Device/GetCubeIsActiveByZoneId?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCubeIsActiveByZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCubeIsActiveByZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetCubeIsActiveByZoneId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DiverseProductActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDiverseProductActivityReport(body: CreateManualDiverseProductActivityReportInput | undefined): Observable<CreateManualDiverseProductActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/CreateDiverseProductActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDiverseProductActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDiverseProductActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
        }));
    }

    protected processCreateDiverseProductActivityReport(response: HttpResponseBase): Observable<CreateManualDiverseProductActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualDiverseProductActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createDiverseProductPreActivityReport(body: CreateDiverseProductPreActivityReportInput | undefined): Observable<CreateManualDiverseProductActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/CreateDiverseProductPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateDiverseProductPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateDiverseProductPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
        }));
    }

    protected processCreateDiverseProductPreActivityReport(response: HttpResponseBase): Observable<CreateManualDiverseProductActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualDiverseProductActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a DiverseProduct by it's id
     * @param diverseProductsId (optional) The diverse product id
     * @return Success
     */
    getById(diverseProductsId: number | undefined): Observable<DiverseProductActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetById?";
        if (diverseProductsId === null)
            throw new Error("The parameter 'diverseProductsId' cannot be null.");
        else if (diverseProductsId !== undefined)
            url_ += "diverseProductsId=" + encodeURIComponent("" + diverseProductsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductActivityReportOutputDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DiverseProductActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a diverse product that is in state "in place" by placeId
     * @return Success
     */
    getDiverseProductsInPlantForTripMonitor(): Observable<DiverseCounterTripMonitorDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductsInPlantForTripMonitor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductsInPlantForTripMonitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductsInPlantForTripMonitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseCounterTripMonitorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseCounterTripMonitorDto>;
        }));
    }

    protected processGetDiverseProductsInPlantForTripMonitor(response: HttpResponseBase): Observable<DiverseCounterTripMonitorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseCounterTripMonitorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an activity report of type DiverseProducts
     * @param body (optional) The class that contains the new information from the diverse product
     * @return Success
     */
    updateDiverseProductsActivityReportWithEntranceInformation(body: UpdateDiverseProductActivityReportInput | undefined): Observable<CreateManualDiverseProductActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/UpdateDiverseProductsActivityReportWithEntranceInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDiverseProductsActivityReportWithEntranceInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDiverseProductsActivityReportWithEntranceInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualDiverseProductActivityReportOutput>;
        }));
    }

    protected processUpdateDiverseProductsActivityReportWithEntranceInformation(response: HttpResponseBase): Observable<CreateManualDiverseProductActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualDiverseProductActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the diverse products destinations saved on smartAccess
     * @return Success
     */
    getAllDestinationsForDiverseProducts(): Observable<DiverseProductDestinationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetAllDestinationsForDiverseProducts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDestinationsForDiverseProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDestinationsForDiverseProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductDestinationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductDestinationDto[]>;
        }));
    }

    protected processGetAllDestinationsForDiverseProducts(response: HttpResponseBase): Observable<DiverseProductDestinationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiverseProductDestinationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save all the destinations coming from bioforest into smartAccess
     * @param body (optional) A list with all the destinations coming from bioforest
     * @return Success
     */
    saveDestinations(body: DiverseProductDestinationDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/SaveDestinations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveDestinations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveDestinations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSaveDestinations(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of all the diverse products destinations saved on smartAccess to return for screen
     * @param originPlaceId (optional) 
     * @param destinationNameFilter (optional) 
     * @param includeDisabledDestinations (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllDestinationsForScreen(originPlaceId: number | undefined, destinationNameFilter: string | undefined, includeDisabledDestinations: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetAllDestinationsForScreen?";
        if (originPlaceId === null)
            throw new Error("The parameter 'originPlaceId' cannot be null.");
        else if (originPlaceId !== undefined)
            url_ += "OriginPlaceId=" + encodeURIComponent("" + originPlaceId) + "&";
        if (destinationNameFilter === null)
            throw new Error("The parameter 'destinationNameFilter' cannot be null.");
        else if (destinationNameFilter !== undefined)
            url_ += "DestinationNameFilter=" + encodeURIComponent("" + destinationNameFilter) + "&";
        if (includeDisabledDestinations === null)
            throw new Error("The parameter 'includeDisabledDestinations' cannot be null.");
        else if (includeDisabledDestinations !== undefined)
            url_ += "IncludeDisabledDestinations=" + encodeURIComponent("" + includeDisabledDestinations) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDestinationsForScreen(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDestinationsForScreen(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
        }));
    }

    protected processGetAllDestinationsForScreen(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductDestinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the destinations for the auto complete on the diverse products creation screen
     * @param originPlaceId (optional) 
     * @param destinationNameFilter (optional) 
     * @param includeDisabledDestinations (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDestinationsForAutoComplete(originPlaceId: number | undefined, destinationNameFilter: string | undefined, includeDisabledDestinations: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDestinationsForAutoComplete?";
        if (originPlaceId === null)
            throw new Error("The parameter 'originPlaceId' cannot be null.");
        else if (originPlaceId !== undefined)
            url_ += "OriginPlaceId=" + encodeURIComponent("" + originPlaceId) + "&";
        if (destinationNameFilter === null)
            throw new Error("The parameter 'destinationNameFilter' cannot be null.");
        else if (destinationNameFilter !== undefined)
            url_ += "DestinationNameFilter=" + encodeURIComponent("" + destinationNameFilter) + "&";
        if (includeDisabledDestinations === null)
            throw new Error("The parameter 'includeDisabledDestinations' cannot be null.");
        else if (includeDisabledDestinations !== undefined)
            url_ += "IncludeDisabledDestinations=" + encodeURIComponent("" + includeDisabledDestinations) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinationsForAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinationsForAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
        }));
    }

    protected processGetDestinationsForAutoComplete(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductDestinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active destinations by vendor id
     * @param destinationNameFilter (optional) 
     * @param vendorId (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getActiveNotPaysTransportDestinationsByVendorIdAutoComplete(destinationNameFilter: string | undefined, vendorId: number | undefined, placeId: number | undefined): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetActiveNotPaysTransportDestinationsByVendorIdAutoComplete?";
        if (destinationNameFilter === null)
            throw new Error("The parameter 'destinationNameFilter' cannot be null.");
        else if (destinationNameFilter !== undefined)
            url_ += "destinationNameFilter=" + encodeURIComponent("" + destinationNameFilter) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "vendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveNotPaysTransportDestinationsByVendorIdAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveNotPaysTransportDestinationsByVendorIdAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
        }));
    }

    protected processGetActiveNotPaysTransportDestinationsByVendorIdAutoComplete(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductDestinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active not pays transport  filter by name, external vendorId and placeId
     * @param destinationNameFilter (optional) 
     * @param externalVendorId (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getActiveNotPaysTransportDestinationsByExternalVendorIdAutoComplete(destinationNameFilter: string | undefined, externalVendorId: number | undefined, placeId: number | undefined): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetActiveNotPaysTransportDestinationsByExternalVendorIdAutoComplete?";
        if (destinationNameFilter === null)
            throw new Error("The parameter 'destinationNameFilter' cannot be null.");
        else if (destinationNameFilter !== undefined)
            url_ += "destinationNameFilter=" + encodeURIComponent("" + destinationNameFilter) + "&";
        if (externalVendorId === null)
            throw new Error("The parameter 'externalVendorId' cannot be null.");
        else if (externalVendorId !== undefined)
            url_ += "externalVendorId=" + encodeURIComponent("" + externalVendorId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveNotPaysTransportDestinationsByExternalVendorIdAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveNotPaysTransportDestinationsByExternalVendorIdAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
        }));
    }

    protected processGetActiveNotPaysTransportDestinationsByExternalVendorIdAutoComplete(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductDestinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param destinationNameFilter (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getActivePaysTransportDestinationsAutoComplete(destinationNameFilter: string | undefined, placeId: number | undefined): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetActivePaysTransportDestinationsAutoComplete?";
        if (destinationNameFilter === null)
            throw new Error("The parameter 'destinationNameFilter' cannot be null.");
        else if (destinationNameFilter !== undefined)
            url_ += "destinationNameFilter=" + encodeURIComponent("" + destinationNameFilter) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivePaysTransportDestinationsAutoComplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivePaysTransportDestinationsAutoComplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductDestinationDto>;
        }));
    }

    protected processGetActivePaysTransportDestinationsAutoComplete(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductDestinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductDestinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param destinationId (optional) 
     * @return Success
     */
    getDestinationById(destinationId: number | undefined): Observable<DiverseProductDestinationDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDestinationById?";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDestinationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDestinationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductDestinationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductDestinationDto>;
        }));
    }

    protected processGetDestinationById(response: HttpResponseBase): Observable<DiverseProductDestinationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductDestinationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param destinationId (optional) 
     * @param externalVendorId (optional) 
     * @param paysTransport (optional) 
     * @return Success
     */
    activateDestination(destinationId: number | undefined, externalVendorId: number | undefined, paysTransport: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/ActivateDestination?";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (externalVendorId === null)
            throw new Error("The parameter 'externalVendorId' cannot be null.");
        else if (externalVendorId !== undefined)
            url_ += "externalVendorId=" + encodeURIComponent("" + externalVendorId) + "&";
        if (paysTransport === null)
            throw new Error("The parameter 'paysTransport' cannot be null.");
        else if (paysTransport !== undefined)
            url_ += "paysTransport=" + encodeURIComponent("" + paysTransport) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivateDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivateDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActivateDestination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param destinationId (optional) 
     * @return Success
     */
    deactivateDestination(destinationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/DeactivateDestination?";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeactivateDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeactivateDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeactivateDestination(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * It searches for a diverse product on screen from search
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomDeclarationId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchDiverseProductActivityReport(singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomDeclarationId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/SearchDiverseProductActivityReport?";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomDeclarationId === null)
            throw new Error("The parameter 'singleCustomDeclarationId' cannot be null.");
        else if (singleCustomDeclarationId !== undefined)
            url_ += "SingleCustomDeclarationId=" + encodeURIComponent("" + singleCustomDeclarationId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchDiverseProductActivityReport(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a diverse product passing it's id and a reason for that deletion
     * @return Success
     */
    delete(reportId: number, deletionComment: string, deletionReasonId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/Delete?";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined and cannot be null.");
        else
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (deletionComment === undefined || deletionComment === null)
            throw new Error("The parameter 'deletionComment' must be defined and cannot be null.");
        else
            url_ += "DeletionComment=" + encodeURIComponent("" + deletionComment) + "&";
        if (deletionReasonId === undefined || deletionReasonId === null)
            throw new Error("The parameter 'deletionReasonId' must be defined and cannot be null.");
        else
            url_ += "DeletionReasonId=" + encodeURIComponent("" + deletionReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information about the matching diverse product activity report.
     * @param reportId (optional) Id of the wood activity report
     * @return Success
     */
    getBasicDiverseProductsActivityReportInfo(reportId: number | undefined): Observable<BasicDiverseProductReportInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetBasicDiverseProductsActivityReportInfo?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicDiverseProductsActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicDiverseProductsActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicDiverseProductReportInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicDiverseProductReportInfoDto>;
        }));
    }

    protected processGetBasicDiverseProductsActivityReportInfo(response: HttpResponseBase): Observable<BasicDiverseProductReportInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicDiverseProductReportInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param entranceStatusFilters (optional) 
     * @param transportVendorId (optional) 
     * @param creationSystem (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchDiverseProductPreActivityReports(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, entranceStatusFilters: string[] | undefined, transportVendorId: number | undefined, creationSystem: DiverseProductActivityReportCreationSystemFilter | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/SearchDiverseProductPreActivityReports?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (entranceStatusFilters === null)
            throw new Error("The parameter 'entranceStatusFilters' cannot be null.");
        else if (entranceStatusFilters !== undefined)
            entranceStatusFilters && entranceStatusFilters.forEach(item => { url_ += "EntranceStatusFilters=" + encodeURIComponent("" + item) + "&"; });
        if (transportVendorId === null)
            throw new Error("The parameter 'transportVendorId' cannot be null.");
        else if (transportVendorId !== undefined)
            url_ += "TransportVendorId=" + encodeURIComponent("" + transportVendorId) + "&";
        if (creationSystem === null)
            throw new Error("The parameter 'creationSystem' cannot be null.");
        else if (creationSystem !== undefined)
            url_ += "CreationSystem=" + encodeURIComponent("" + creationSystem) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductPreActivityReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductPreActivityReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto>;
        }));
    }

    protected processSearchDiverseProductPreActivityReports(response: HttpResponseBase): Observable<PagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param driverId (optional) 
     * @param entranceStatusFilter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchDiverseProductPreActivityReportsVendor(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, driverId: number | undefined, entranceStatusFilter: PreActivityReportEntranceStatusFilter | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/SearchDiverseProductPreActivityReportsVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilter === null)
            throw new Error("The parameter 'entranceStatusFilter' cannot be null.");
        else if (entranceStatusFilter !== undefined)
            url_ += "EntranceStatusFilter=" + encodeURIComponent("" + entranceStatusFilter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductPreActivityReportsVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductPreActivityReportsVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto>;
        }));
    }

    protected processSearchDiverseProductPreActivityReportsVendor(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param driverId (optional) 
     * @param entranceStatusFilter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchDiverseProductPreActivityReportsTransportVendor(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, driverId: number | undefined, entranceStatusFilter: PreActivityReportEntranceStatusFilter | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/SearchDiverseProductPreActivityReportsTransportVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilter === null)
            throw new Error("The parameter 'entranceStatusFilter' cannot be null.");
        else if (entranceStatusFilter !== undefined)
            url_ += "EntranceStatusFilter=" + encodeURIComponent("" + entranceStatusFilter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductPreActivityReportsTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductPreActivityReportsTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto>;
        }));
    }

    protected processSearchDiverseProductPreActivityReportsTransportVendor(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a collection of diverse product pre-reports associated to the activity report given by ids
     * @param ids (optional) 
     * @return Success
     */
    getDiverseProductPreActivityReportsByIds(ids: number[] | undefined): Observable<PreActivityReportWithErrorsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductPreActivityReportsByIds?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreActivityReportsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreActivityReportsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportWithErrorsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportWithErrorsDto[]>;
        }));
    }

    protected processGetDiverseProductPreActivityReportsByIds(response: HttpResponseBase): Observable<PreActivityReportWithErrorsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PreActivityReportWithErrorsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the diverse product pre-report associated to the activity report given by id
     * @param id (optional) 
     * @return Success
     */
    getDiverseProductActivityReportWithPreReport(id: number | undefined): Observable<PreActivityReportWithErrorsDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductActivityReportWithPreReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductActivityReportWithPreReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductActivityReportWithPreReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportWithErrorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportWithErrorsDto>;
        }));
    }

    protected processGetDiverseProductActivityReportWithPreReport(response: HttpResponseBase): Observable<PreActivityReportWithErrorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportWithErrorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the diverse product pre-report by id
     * @param id (optional) 
     * @return Success
     */
    getDiverseProductPreActivityReportById(id: number | undefined): Observable<PreActivityReportWithErrorsDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductPreActivityReportById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreActivityReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreActivityReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportWithErrorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportWithErrorsDto>;
        }));
    }

    protected processGetDiverseProductPreActivityReportById(response: HttpResponseBase): Observable<PreActivityReportWithErrorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportWithErrorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDiverseProductPreActivityReportIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductPreActivityReportIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreActivityReportIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreActivityReportIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetDiverseProductPreActivityReportIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomDeclarationId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchDiverseProductActivityReportForVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomDeclarationId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/SearchDiverseProductActivityReportForVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomDeclarationId === null)
            throw new Error("The parameter 'singleCustomDeclarationId' cannot be null.");
        else if (singleCustomDeclarationId !== undefined)
            url_ += "SingleCustomDeclarationId=" + encodeURIComponent("" + singleCustomDeclarationId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductActivityReportForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductActivityReportForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchDiverseProductActivityReportForVendor(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomDeclarationId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchDiverseProductActivityReportForTransportVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomDeclarationId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/SearchDiverseProductActivityReportForTransportVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomDeclarationId === null)
            throw new Error("The parameter 'singleCustomDeclarationId' cannot be null.");
        else if (singleCustomDeclarationId !== undefined)
            url_ += "SingleCustomDeclarationId=" + encodeURIComponent("" + singleCustomDeclarationId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchDiverseProductActivityReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchDiverseProductActivityReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchDiverseProductActivityReportForTransportVendor(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves if diverse product destination is active by its external id
     * @param destinationId (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    checkIfDestinationIsActive(destinationId: number | undefined, placeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/CheckIfDestinationIsActive?";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "destinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckIfDestinationIsActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckIfDestinationIsActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCheckIfDestinationIsActive(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editDiverseProductPreActivityReport(body: DiverseProductPreActivityReportEditionInput | undefined): Observable<EditDiverseProductPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/EditDiverseProductPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditDiverseProductPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditDiverseProductPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditDiverseProductPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditDiverseProductPreActivityReportOutput>;
        }));
    }

    protected processEditDiverseProductPreActivityReport(response: HttpResponseBase): Observable<EditDiverseProductPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditDiverseProductPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param prereportId (optional) 
     * @return Success
     */
    getDiverseProductPreActivityReportForEditionInfo(prereportId: number | undefined): Observable<DiverseProductPreActivityReportForEditionInfo> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductPreActivityReportForEditionInfo?";
        if (prereportId === null)
            throw new Error("The parameter 'prereportId' cannot be null.");
        else if (prereportId !== undefined)
            url_ += "prereportId=" + encodeURIComponent("" + prereportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreActivityReportForEditionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreActivityReportForEditionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductPreActivityReportForEditionInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductPreActivityReportForEditionInfo>;
        }));
    }

    protected processGetDiverseProductPreActivityReportForEditionInfo(response: HttpResponseBase): Observable<DiverseProductPreActivityReportForEditionInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductPreActivityReportForEditionInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getDiverseProductPreReportEntranceRequiredInfo(reportId: number | undefined): Observable<DiverseProductPreReportEntranceRequiredInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductPreReportEntranceRequiredInfo?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductPreReportEntranceRequiredInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductPreReportEntranceRequiredInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductPreReportEntranceRequiredInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductPreReportEntranceRequiredInfoOutput>;
        }));
    }

    protected processGetDiverseProductPreReportEntranceRequiredInfo(response: HttpResponseBase): Observable<DiverseProductPreReportEntranceRequiredInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductPreReportEntranceRequiredInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a DiverseProductTransportReportDto based on the given report ID.
     * @param reportId (optional) The ID of the report to return.
     * @return Success
     */
    getDiverseProductTransportReportDto(reportId: number | undefined): Observable<DiverseProductTransportReportDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetDiverseProductTransportReportDto?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductTransportReportDto(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductTransportReportDto(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductTransportReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductTransportReportDto>;
        }));
    }

    protected processGetDiverseProductTransportReportDto(response: HttpResponseBase): Observable<DiverseProductTransportReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductTransportReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activityReportId (optional) 
     * @return Success
     */
    getServiceEntrySheetInformation(activityReportId: number | undefined): Observable<ServiceEntrySheetInformationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductActivityReport/GetServiceEntrySheetInformation?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceEntrySheetInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceEntrySheetInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceEntrySheetInformationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceEntrySheetInformationDto[]>;
        }));
    }

    protected processGetServiceEntrySheetInformation(response: HttpResponseBase): Observable<ServiceEntrySheetInformationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceEntrySheetInformationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class DiverseProductsTruckTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdate(body: DiverseProductsTruckTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductsTruckType/CreateUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param diverseProductsTruckTypeId (optional) 
     * @return Success
     */
    delete(diverseProductsTruckTypeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductsTruckType/Delete?";
        if (diverseProductsTruckTypeId === null)
            throw new Error("The parameter 'diverseProductsTruckTypeId' cannot be null.");
        else if (diverseProductsTruckTypeId !== undefined)
            url_ += "diverseProductsTruckTypeId=" + encodeURIComponent("" + diverseProductsTruckTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDiverseProductsTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductsTruckType/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductsTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductsTruckTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductsTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductsTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param diverseProductsTruckTypeId (optional) 
     * @return Success
     */
    getById(diverseProductsTruckTypeId: number | undefined): Observable<DiverseProductsTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductsTruckType/GetById?";
        if (diverseProductsTruckTypeId === null)
            throw new Error("The parameter 'diverseProductsTruckTypeId' cannot be null.");
        else if (diverseProductsTruckTypeId !== undefined)
            url_ += "diverseProductsTruckTypeId=" + encodeURIComponent("" + diverseProductsTruckTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductsTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductsTruckTypeDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<DiverseProductsTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductsTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param resourceTypeId (optional) 
     * @return Success
     */
    getByResourceTypeId(resourceTypeId: number | undefined): Observable<DiverseProductsTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/DiverseProductsTruckType/GetByResourceTypeId?";
        if (resourceTypeId === null)
            throw new Error("The parameter 'resourceTypeId' cannot be null.");
        else if (resourceTypeId !== undefined)
            url_ += "resourceTypeId=" + encodeURIComponent("" + resourceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByResourceTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByResourceTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductsTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductsTruckTypeDto>;
        }));
    }

    protected processGetByResourceTypeId(response: HttpResponseBase): Observable<DiverseProductsTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiverseProductsTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EditionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getEditions(): Observable<ListResultDtoOfEditionListDto> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfEditionListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfEditionListDto>;
        }));
    }

    protected processGetEditions(response: HttpResponseBase): Observable<ListResultDtoOfEditionListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfEditionListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getEditionForEdit(id: number | undefined): Observable<GetEditionEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionEditOutput>;
        }));
    }

    protected processGetEditionForEdit(response: HttpResponseBase): Observable<GetEditionEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createEdition(body: CreateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateEdition(body: UpdateEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteEdition(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveTenantsToAnotherEdition(body: MoveTenantsToAnotherEditionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveTenantsToAnotherEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveTenantsToAnotherEdition(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedEditionId (optional) 
     * @param addAllItem (optional) 
     * @param onlyFree (optional) 
     * @return Success
     */
    getEditionComboboxItems(selectedEditionId: number | undefined, addAllItem: boolean | undefined, onlyFree: boolean | undefined): Observable<SubscribableEditionComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId === null)
            throw new Error("The parameter 'selectedEditionId' cannot be null.");
        else if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem === null)
            throw new Error("The parameter 'addAllItem' cannot be null.");
        else if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFree === null)
            throw new Error("The parameter 'onlyFree' cannot be null.");
        else if (onlyFree !== undefined)
            url_ += "onlyFree=" + encodeURIComponent("" + onlyFree) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscribableEditionComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscribableEditionComboboxItemDto[]>;
        }));
    }

    protected processGetEditionComboboxItems(response: HttpResponseBase): Observable<SubscribableEditionComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getTenantCount(editionId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTenantCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EmailServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInformativeEmailToTransportVendors(body: TransportVendorEmailNotificationInputDto | undefined): Observable<SendEmailOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Email/SendInformativeEmailToTransportVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInformativeEmailToTransportVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInformativeEmailToTransportVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendEmailOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendEmailOutputDto>;
        }));
    }

    protected processSendInformativeEmailToTransportVendors(response: HttpResponseBase): Observable<SendEmailOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInformativeEmailToLoaderVendors(body: LoaderVendorEmailNotificationInputDto | undefined): Observable<SendEmailOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Email/SendInformativeEmailToLoaderVendors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInformativeEmailToLoaderVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInformativeEmailToLoaderVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendEmailOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendEmailOutputDto>;
        }));
    }

    protected processSendInformativeEmailToLoaderVendors(response: HttpResponseBase): Observable<SendEmailOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendInformativeEmailToProviders(body: ProviderEmailNotificationInputDto | undefined): Observable<SendEmailOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Email/SendInformativeEmailToProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendInformativeEmailToProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendInformativeEmailToProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendEmailOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendEmailOutputDto>;
        }));
    }

    protected processSendInformativeEmailToProviders(response: HttpResponseBase): Observable<SendEmailOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendScannerSpeedAbortedEmail(body: ScannerSpeedAbortedResultEmailInputDto | undefined): Observable<SendEmailOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Email/SendScannerSpeedAbortedEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendScannerSpeedAbortedEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendScannerSpeedAbortedEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendEmailOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendEmailOutputDto>;
        }));
    }

    protected processSendScannerSpeedAbortedEmail(response: HttpResponseBase): Observable<SendEmailOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSingleCustomsDeclarationWarningTonsEmail(body: SingleCustomsDeclarationWarningTonsEmailInputDto | undefined): Observable<SendEmailOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Email/SendSingleCustomsDeclarationWarningTonsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSingleCustomsDeclarationWarningTonsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSingleCustomsDeclarationWarningTonsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendEmailOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendEmailOutputDto>;
        }));
    }

    protected processSendSingleCustomsDeclarationWarningTonsEmail(response: HttpResponseBase): Observable<SendEmailOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendSingleCustomsDeclarationDiverseProductsWarningTonsEmail(body: SingleCustomsDeclarationWarningTonsEmailInputDto | undefined): Observable<SendEmailOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Email/SendSingleCustomsDeclarationDiverseProductsWarningTonsEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendSingleCustomsDeclarationDiverseProductsWarningTonsEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendSingleCustomsDeclarationDiverseProductsWarningTonsEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendEmailOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendEmailOutputDto>;
        }));
    }

    protected processSendSingleCustomsDeclarationDiverseProductsWarningTonsEmail(response: HttpResponseBase): Observable<SendEmailOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendPolygonValidationEmail(body: PolygonValidationEmailInputDto | undefined): Observable<SendEmailOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Email/SendPolygonValidationEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPolygonValidationEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPolygonValidationEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendEmailOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendEmailOutputDto>;
        }));
    }

    protected processSendPolygonValidationEmail(response: HttpResponseBase): Observable<SendEmailOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendEmailOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class EntryServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the active report based on a truck information
     * @param tag (optional) 
     * @param licensePlate (optional) 
     * @param placeId (optional) 
     * @param zoneId (optional) 
     * @return Success
     */
    checkNewManuallyLicensePlateDetected(tag: number | undefined, licensePlate: string | undefined, placeId: number | undefined, zoneId: number | undefined): Observable<LicensePlateDetectionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Entry/CheckNewManuallyLicensePlateDetected?";
        if (tag === null)
            throw new Error("The parameter 'tag' cannot be null.");
        else if (tag !== undefined)
            url_ += "Tag=" + encodeURIComponent("" + tag) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "ZoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckNewManuallyLicensePlateDetected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckNewManuallyLicensePlateDetected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LicensePlateDetectionOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LicensePlateDetectionOutputDto>;
        }));
    }

    protected processCheckNewManuallyLicensePlateDetected(response: HttpResponseBase): Observable<LicensePlateDetectionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LicensePlateDetectionOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns value decision on detour zone by external vehicle Id.
     * @param vehicleExternalId (optional) external vehicle Id
     * @param placeId (optional) place id to validate
     * @return Success
     */
    shouldGoToEntry(vehicleExternalId: number | undefined, placeId: number | undefined): Observable<ValidationPreActitityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Entry/ShouldGoToEntry?";
        if (vehicleExternalId === null)
            throw new Error("The parameter 'vehicleExternalId' cannot be null.");
        else if (vehicleExternalId !== undefined)
            url_ += "vehicleExternalId=" + encodeURIComponent("" + vehicleExternalId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShouldGoToEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShouldGoToEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidationPreActitityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidationPreActitityReportOutputDto>;
        }));
    }

    protected processShouldGoToEntry(response: HttpResponseBase): Observable<ValidationPreActitityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidationPreActitityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get entry zone Id by current session user
     * @return Success
     */
    getEntryZoneByUser(): Observable<ZoneByUserOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Entry/GetEntryZoneByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntryZoneByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntryZoneByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneByUserOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneByUserOutputDto>;
        }));
    }

    protected processGetEntryZoneByUser(response: HttpResponseBase): Observable<ZoneByUserOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZoneByUserOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    logDetourEntry(body: DetourLogInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Entry/LogDetourEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogDetourEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogDetourEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLogDetourEntry(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify if exists an entry activity report based on a zone id
     * @param zoneId (optional) 
     * @return Success
     */
    existsEntryActivityReportByZoneId(zoneId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Entry/ExistsEntryActivityReportByZoneId?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistsEntryActivityReportByZoneId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistsEntryActivityReportByZoneId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExistsEntryActivityReportByZoneId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Determine if prereport with the given external vehicle id was valid on detour
     * @param externalVehicleId (optional) 
     * @param placeId (optional) Current user place id
     * @return Success
     */
    getPreActivityReportIsValidToEntrance(externalVehicleId: number | undefined, placeId: number | undefined): Observable<IsPreActivityReportValidToEntranceResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/Entry/GetPreActivityReportIsValidToEntrance?";
        if (externalVehicleId === null)
            throw new Error("The parameter 'externalVehicleId' cannot be null.");
        else if (externalVehicleId !== undefined)
            url_ += "externalVehicleId=" + encodeURIComponent("" + externalVehicleId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportIsValidToEntrance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportIsValidToEntrance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IsPreActivityReportValidToEntranceResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IsPreActivityReportValidToEntranceResultOutput>;
        }));
    }

    protected processGetPreActivityReportIsValidToEntrance(response: HttpResponseBase): Observable<IsPreActivityReportValidToEntranceResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IsPreActivityReportValidToEntranceResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class FriendshipServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequest(body: CreateFriendshipRequestInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequest(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFriendshipRequestByUserName(body: CreateFriendshipRequestByUserNameInput | undefined): Observable<FriendDto> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateFriendshipRequestByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FriendDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FriendDto>;
        }));
    }

    protected processCreateFriendshipRequestByUserName(response: HttpResponseBase): Observable<FriendDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FriendDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    blockUser(body: BlockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unblockUser(body: UnblockUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnblockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnblockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnblockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    acceptFriendshipRequest(body: AcceptFriendshipRequestInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptFriendshipRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptFriendshipRequest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HealthCheckServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkHealth(body: HealthCheckContext | undefined): Observable<HealthCheckResult> {
        let url_ = this.baseUrl + "/api/services/app/HealthCheck/CheckHealth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckHealth(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckHealth(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HealthCheckResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HealthCheckResult>;
        }));
    }

    protected processCheckHealth(response: HttpResponseBase): Observable<HealthCheckResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthCheckResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getTopStatsData(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<TopStatsData> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetTopStatsData?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStatsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStatsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TopStatsData>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TopStatsData>;
        }));
    }

    protected processGetTopStatsData(response: HttpResponseBase): Observable<TopStatsData> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TopStatsData.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentTenantsData(): Observable<GetRecentTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetRecentTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRecentTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRecentTenantsOutput>;
        }));
    }

    protected processGetRecentTenantsData(response: HttpResponseBase): Observable<GetRecentTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecentTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSubscriptionExpiringTenantsData(): Observable<GetExpiringTenantsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetSubscriptionExpiringTenantsData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSubscriptionExpiringTenantsData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSubscriptionExpiringTenantsData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpiringTenantsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpiringTenantsOutput>;
        }));
    }

    protected processGetSubscriptionExpiringTenantsData(response: HttpResponseBase): Observable<GetExpiringTenantsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpiringTenantsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param incomeStatisticsDateInterval (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getIncomeStatistics(incomeStatisticsDateInterval: ChartDateInterval | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetIncomeStatisticsDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval === null)
            throw new Error("The parameter 'incomeStatisticsDateInterval' cannot be null.");
        else if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIncomeStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetIncomeStatisticsDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetIncomeStatisticsDataOutput>;
        }));
    }

    protected processGetIncomeStatistics(response: HttpResponseBase): Observable<GetIncomeStatisticsDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetIncomeStatisticsDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getEditionTenantStatistics(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<GetEditionTenantStatisticsOutput> {
        let url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionTenantStatistics(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEditionTenantStatisticsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEditionTenantStatisticsOutput>;
        }));
    }

    protected processGetEditionTenantStatistics(response: HttpResponseBase): Observable<GetEditionTenantStatisticsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEditionTenantStatisticsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HostSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<HostSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HostSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HostSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<HostSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HostSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: HostSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/HostSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IndicatorsConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all configuration of indicators
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfIndicatorsDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorsConfiguration/GetAll?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIndicatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIndicatorsDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfIndicatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIndicatorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's an indicator configuration by it's id
     * @param id (optional) the id of the configuration
     * @return Success
     */
    get(id: number | undefined): Observable<IndicatorsDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorsConfiguration/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndicatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndicatorsDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<IndicatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndicatorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's an indicator configuration by it's id
     * @param code (optional) the code of the configuration
     * @param placeId (optional) search by place
     * @return Success
     */
    getByCode(code: string | undefined, placeId: number | undefined): Observable<IndicatorsDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorsConfiguration/GetByCode?";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndicatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndicatorsDto>;
        }));
    }

    protected processGetByCode(response: HttpResponseBase): Observable<IndicatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndicatorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an specific indicator configuration
     * @param body (optional) An object containing the information of the indicator
     * @return Success
     */
    update(body: UpdateIndicatorConfigurationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorsConfiguration/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the indicador by his code in smartAccess
     * @param indicatorsCode (optional) The indicators code
     * @return Success
     */
    getByCodeAndCurrectPlace(indicatorsCode: string | undefined): Observable<IndicatorsDto> {
        let url_ = this.baseUrl + "/api/services/app/IndicatorsConfiguration/GetByCodeAndCurrectPlace?";
        if (indicatorsCode === null)
            throw new Error("The parameter 'indicatorsCode' cannot be null.");
        else if (indicatorsCode !== undefined)
            url_ += "indicatorsCode=" + encodeURIComponent("" + indicatorsCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByCodeAndCurrectPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByCodeAndCurrectPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IndicatorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IndicatorsDto>;
        }));
    }

    protected processGetByCodeAndCurrectPlace(response: HttpResponseBase): Observable<IndicatorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IndicatorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InstallServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setup(body: InstallDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetup(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getAppSettingsJson(): Observable<AppSettingsJsonDto> {
        let url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAppSettingsJson(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppSettingsJsonDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppSettingsJsonDto>;
        }));
    }

    protected processGetAppSettingsJson(response: HttpResponseBase): Observable<AppSettingsJsonDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppSettingsJsonDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    checkDatabase(): Observable<CheckDatabaseOutput> {
        let url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckDatabase(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckDatabase(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CheckDatabaseOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CheckDatabaseOutput>;
        }));
    }

    protected processCheckDatabase(response: HttpResponseBase): Observable<CheckDatabaseOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CheckDatabaseOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class IntegrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create an integration result entity
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateActivityReportIntegrationLogInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integration/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getAllByReportId(reportId: number | undefined): Observable<PagedResultDtoOfIntegrationLogOutputList> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetAllByReportId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIntegrationLogOutputList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIntegrationLogOutputList>;
        }));
    }

    protected processGetAllByReportId(response: HttpResponseBase): Observable<PagedResultDtoOfIntegrationLogOutputList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIntegrationLogOutputList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @param logId (optional) 
     * @return Success
     */
    getLogById(reportId: number | undefined, logId: number | undefined): Observable<IntegrationLogOutputItem> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetLogById?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (logId === null)
            throw new Error("The parameter 'logId' cannot be null.");
        else if (logId !== undefined)
            url_ += "logId=" + encodeURIComponent("" + logId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationLogOutputItem>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationLogOutputItem>;
        }));
    }

    protected processGetLogById(response: HttpResponseBase): Observable<IntegrationLogOutputItem> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationLogOutputItem.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param placeId (optional) 
     * @return Success
     */
    getAllSystems(placeId: number | undefined): Observable<SystemItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetAllSystems?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSystems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSystems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemItemDto[]>;
        }));
    }

    protected processGetAllSystems(response: HttpResponseBase): Observable<SystemItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SystemItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportType (optional) 
     * @param from (optional) 
     * @param to (optional) 
     * @param systemId (optional) 
     * @param operation (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @param nameStates (optional) 
     * @return Success
     */
    getAll(reportType: ActivityReportType | undefined, from: DateTime | undefined, to: DateTime | undefined, systemId: number | undefined, operation: IntegrationLogActionType | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined, nameStates: string[] | undefined): Observable<PagedResultDtoOfIntegrationLogOutputList> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetAll?";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "ReportType=" + encodeURIComponent("" + reportType) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "From=" + encodeURIComponent(from ? "" + from.toString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "To=" + encodeURIComponent(to ? "" + to.toString() : "") + "&";
        if (systemId === null)
            throw new Error("The parameter 'systemId' cannot be null.");
        else if (systemId !== undefined)
            url_ += "SystemId=" + encodeURIComponent("" + systemId) + "&";
        if (operation === null)
            throw new Error("The parameter 'operation' cannot be null.");
        else if (operation !== undefined)
            url_ += "Operation=" + encodeURIComponent("" + operation) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (nameStates === null)
            throw new Error("The parameter 'nameStates' cannot be null.");
        else if (nameStates !== undefined)
            nameStates && nameStates.forEach(item => { url_ += "nameStates=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfIntegrationLogOutputList>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfIntegrationLogOutputList>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfIntegrationLogOutputList> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfIntegrationLogOutputList.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    executeIntegrations(body: ExecuteIntegrationsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integration/ExecuteIntegrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteIntegrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteIntegrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExecuteIntegrations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveIntegrationInMassExecuteIntegrations(body: CollectionIntegrationLogInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integration/SaveIntegrationInMassExecuteIntegrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveIntegrationInMassExecuteIntegrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveIntegrationInMassExecuteIntegrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveIntegrationInMassExecuteIntegrations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param executionId (optional) 
     * @return Success
     */
    getIntegrationsByExecutionId(executionId: string | undefined): Observable<IntegrationByExecutionOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetIntegrationsByExecutionId?";
        if (executionId === null)
            throw new Error("The parameter 'executionId' cannot be null.");
        else if (executionId !== undefined)
            url_ += "executionId=" + encodeURIComponent("" + executionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationsByExecutionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationsByExecutionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationByExecutionOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationByExecutionOutputDto[]>;
        }));
    }

    protected processGetIntegrationsByExecutionId(response: HttpResponseBase): Observable<IntegrationByExecutionOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IntegrationByExecutionOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    exportIntegrationFile(body: GetIntegrationFileInputFilterDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Integration/ExportIntegrationFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportIntegrationFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportIntegrationFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processExportIntegrationFile(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelScheduledIntegration(body: number[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integration/CancelScheduledIntegration";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelScheduledIntegration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelScheduledIntegration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelScheduledIntegration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    recoverIntegrations(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Integration/RecoverIntegrations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRecoverIntegrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRecoverIntegrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRecoverIntegrations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param serie (optional) 
     * @param type (optional) 
     * @param cfeNumber (optional) 
     * @return Success
     */
    sicfeDataIsAlreadyInUse(serie: string | undefined, type: number | undefined, cfeNumber: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Integration/SicfeDataIsAlreadyInUse?";
        if (serie === null)
            throw new Error("The parameter 'serie' cannot be null.");
        else if (serie !== undefined)
            url_ += "serie=" + encodeURIComponent("" + serie) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (cfeNumber === null)
            throw new Error("The parameter 'cfeNumber' cannot be null.");
        else if (cfeNumber !== undefined)
            url_ += "cfeNumber=" + encodeURIComponent("" + cfeNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSicfeDataIsAlreadyInUse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSicfeDataIsAlreadyInUse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSicfeDataIsAlreadyInUse(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the identifier of an activity report based on the stock integration message.
     * @param sigeDocumentId (optional) Stock integration message to search for.
     * @return Success
     */
    getActivityReportIdBySigeDocumentId(sigeDocumentId: string | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetActivityReportIdBySigeDocumentId?";
        if (sigeDocumentId === null)
            throw new Error("The parameter 'sigeDocumentId' cannot be null.");
        else if (sigeDocumentId !== undefined)
            url_ += "sigeDocumentId=" + encodeURIComponent("" + sigeDocumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityReportIdBySigeDocumentId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityReportIdBySigeDocumentId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetActivityReportIdBySigeDocumentId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if the electronic report integration for a specific wood activity report has been successfully executed.
     * @param reportId (optional) The identifier of the wood activity report to check.
     * @return Success
     */
    isWoodActivityReportElectronicReportIntegrationSuccessfullyExecuted(reportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Integration/IsWoodActivityReportElectronicReportIntegrationSuccessfullyExecuted?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsWoodActivityReportElectronicReportIntegrationSuccessfullyExecuted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsWoodActivityReportElectronicReportIntegrationSuccessfullyExecuted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsWoodActivityReportElectronicReportIntegrationSuccessfullyExecuted(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if an integration can be executed based on the report ID and integration type.
     * @param reportId (optional) Report Id
     * @param body (optional) Integration log operation
     * @return Success
     */
    canExecuteIntegrationByTypeAndReportId(reportId: number | undefined, body: IntegrationLogActionType | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Integration/CanExecuteIntegrationByTypeAndReportId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanExecuteIntegrationByTypeAndReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanExecuteIntegrationByTypeAndReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanExecuteIntegrationByTypeAndReportId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get smart invoicing system details along with its operations.
     * @return Success
     */
    getSmartInvoicingSystem(): Observable<SystemItemDto> {
        let url_ = this.baseUrl + "/api/services/app/Integration/GetSmartInvoicingSystem";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSmartInvoicingSystem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSmartInvoicingSystem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SystemItemDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SystemItemDto>;
        }));
    }

    protected processGetSmartInvoicingSystem(response: HttpResponseBase): Observable<SystemItemDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SystemItemDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InternalMovementActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a receipt of type internal movements
     * @param body (optional) An object that contains the information of the receipt
     * @return Success
     */
    createInternalMovementActivityReport(body: CreateManualInternalMovementActivityReportInput | undefined): Observable<CreateManualInternalMovementActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/CreateInternalMovementActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInternalMovementActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInternalMovementActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
        }));
    }

    protected processCreateInternalMovementActivityReport(response: HttpResponseBase): Observable<CreateManualInternalMovementActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualInternalMovementActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an internal movement receipt by it's id
     * @param activityReportId (optional) The internal movement id
     * @return Success
     */
    getById(activityReportId: number | undefined): Observable<InternalMovementActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetById?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalMovementActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalMovementActivityReportOutputDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<InternalMovementActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalMovementActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create an article of type internal movements
     * @param body (optional) An object that contains the name of the article, the place id that it's part, and his external id from bioforest
     * @return Success
     */
    saveArticleInternalMovements(body: ArticleIMInputDto | undefined): Observable<InternalMovementArticleOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/SaveArticleInternalMovements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveArticleInternalMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveArticleInternalMovements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalMovementArticleOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalMovementArticleOutputDto>;
        }));
    }

    protected processSaveArticleInternalMovements(response: HttpResponseBase): Observable<InternalMovementArticleOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalMovementArticleOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Start an semi-automatic entrance
     * @param body (optional) An object that contains the information of the semi automatic entrance
     * @return Success
     */
    updateInternalMovementsActivityReportWithEntranceInformation(body: UpdateInternalMovementActivityReportInput | undefined): Observable<CreateManualInternalMovementActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/UpdateInternalMovementsActivityReportWithEntranceInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateInternalMovementsActivityReportWithEntranceInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateInternalMovementsActivityReportWithEntranceInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
        }));
    }

    protected processUpdateInternalMovementsActivityReportWithEntranceInformation(response: HttpResponseBase): Observable<CreateManualInternalMovementActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualInternalMovementActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the articles paginated related to internal movements
     * @param filterText (optional) 
     * @param placeId (optional) 
     * @param isActive (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getArticles(filterText: string | undefined, placeId: number | undefined, isActive: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfInternalMovementArticleOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetArticles?";
        if (filterText === null)
            throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetArticles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetArticles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfInternalMovementArticleOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfInternalMovementArticleOutputDto>;
        }));
    }

    protected processGetArticles(response: HttpResponseBase): Observable<PagedResultDtoOfInternalMovementArticleOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfInternalMovementArticleOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an specific internal movements receipt
     * @param body (optional) An object that contains the internal movements id, and a comment of the update
     * @return Success
     */
    editInternalMovementsActivityReport(body: UpdateInternalMovementInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/EditInternalMovementsActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditInternalMovementsActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditInternalMovementsActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditInternalMovementsActivityReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an article internal movement by it's id
     * @param articleId (optional) The article internal movements id
     * @return Success
     */
    deleteArticle(articleId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/DeleteArticle?";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteArticle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInternalMovementPreActivityReport(body: CreateInternalMovementPreActivityReportInput | undefined): Observable<CreateManualInternalMovementActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/CreateInternalMovementPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInternalMovementPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInternalMovementPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateManualInternalMovementActivityReportOutput>;
        }));
    }

    protected processCreateInternalMovementPreActivityReport(response: HttpResponseBase): Observable<CreateManualInternalMovementActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateManualInternalMovementActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the receipt state of internal movement
     * @param receiptId (optional) The receipt id
     * @return Success
     */
    getReceiptState(receiptId: number | undefined): Observable<BasicWoodActivityReportInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetReceiptState?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReceiptState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReceiptState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicWoodActivityReportInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicWoodActivityReportInfoDto>;
        }));
    }

    protected processGetReceiptState(response: HttpResponseBase): Observable<BasicWoodActivityReportInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicWoodActivityReportInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a count for trip monitor of the receipts that are on state entering and leaving
     * @return Success
     */
    getInternalMovementsInPlantForTripMonitor(): Observable<InternalCounterTripMonitorDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetInternalMovementsInPlantForTripMonitor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementsInPlantForTripMonitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementsInPlantForTripMonitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalCounterTripMonitorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalCounterTripMonitorDto>;
        }));
    }

    protected processGetInternalMovementsInPlantForTripMonitor(response: HttpResponseBase): Observable<InternalCounterTripMonitorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalCounterTripMonitorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns an search of internal movements
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomDeclarationId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchInternalMovementsActivityReport(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomDeclarationId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/SearchInternalMovementsActivityReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomDeclarationId === null)
            throw new Error("The parameter 'singleCustomDeclarationId' cannot be null.");
        else if (singleCustomDeclarationId !== undefined)
            url_ += "SingleCustomDeclarationId=" + encodeURIComponent("" + singleCustomDeclarationId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInternalMovementsActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInternalMovementsActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchInternalMovementsActivityReport(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getInternalMovementPreActivityReportsByIds(ids: number[] | undefined): Observable<PreActivityReportWithErrorsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetInternalMovementPreActivityReportsByIds?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementPreActivityReportsByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementPreActivityReportsByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportWithErrorsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportWithErrorsDto[]>;
        }));
    }

    protected processGetInternalMovementPreActivityReportsByIds(response: HttpResponseBase): Observable<PreActivityReportWithErrorsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PreActivityReportWithErrorsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getInternalMovementPreActivityReportIds(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetInternalMovementPreActivityReportIds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementPreActivityReportIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementPreActivityReportIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetInternalMovementPreActivityReportIds(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param articleId (optional) 
     * @param entranceStatusFilters (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchInternalMovementPreActivityReports(licensePlate: string | undefined, articleId: number | undefined, entranceStatusFilters: string[] | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/SearchInternalMovementPreActivityReports?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (entranceStatusFilters === null)
            throw new Error("The parameter 'entranceStatusFilters' cannot be null.");
        else if (entranceStatusFilters !== undefined)
            entranceStatusFilters && entranceStatusFilters.forEach(item => { url_ += "EntranceStatusFilters=" + encodeURIComponent("" + item) + "&"; });
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInternalMovementPreActivityReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInternalMovementPreActivityReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto>;
        }));
    }

    protected processSearchInternalMovementPreActivityReports(response: HttpResponseBase): Observable<PagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param articleId (optional) 
     * @param driverId (optional) 
     * @param entranceStatusFilter (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchInternalMovementPreActivityReportsForTransportVendors(licensePlate: string | undefined, articleId: number | undefined, driverId: number | undefined, entranceStatusFilter: PreActivityReportEntranceStatusFilter | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/SearchInternalMovementPreActivityReportsForTransportVendors?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilter === null)
            throw new Error("The parameter 'entranceStatusFilter' cannot be null.");
        else if (entranceStatusFilter !== undefined)
            url_ += "EntranceStatusFilter=" + encodeURIComponent("" + entranceStatusFilter) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInternalMovementPreActivityReportsForTransportVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInternalMovementPreActivityReportsForTransportVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto>;
        }));
    }

    protected processSearchInternalMovementPreActivityReportsForTransportVendors(response: HttpResponseBase): Observable<PagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInternalMovementPreActivityReportById(id: number | undefined): Observable<PreActivityReportWithErrorsDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetInternalMovementPreActivityReportById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementPreActivityReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementPreActivityReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportWithErrorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportWithErrorsDto>;
        }));
    }

    protected processGetInternalMovementPreActivityReportById(response: HttpResponseBase): Observable<PreActivityReportWithErrorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportWithErrorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an internal movement by it's id
     * @return Success
     */
    deleteActivityReport(reportId: number, deletionComment: string, deletionReasonId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/DeleteActivityReport?";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined and cannot be null.");
        else
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (deletionComment === undefined || deletionComment === null)
            throw new Error("The parameter 'deletionComment' must be defined and cannot be null.");
        else
            url_ += "DeletionComment=" + encodeURIComponent("" + deletionComment) + "&";
        if (deletionReasonId === undefined || deletionReasonId === null)
            throw new Error("The parameter 'deletionReasonId' must be defined and cannot be null.");
        else
            url_ += "DeletionReasonId=" + encodeURIComponent("" + deletionReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteActivityReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomDeclarationId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchInternalMovementsActivityReportForTransportVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomDeclarationId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/SearchInternalMovementsActivityReportForTransportVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomDeclarationId === null)
            throw new Error("The parameter 'singleCustomDeclarationId' cannot be null.");
        else if (singleCustomDeclarationId !== undefined)
            url_ += "SingleCustomDeclarationId=" + encodeURIComponent("" + singleCustomDeclarationId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchInternalMovementsActivityReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchInternalMovementsActivityReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchInternalMovementsActivityReportForTransportVendor(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editInternalMovementPreActivityReport(body: InternalMovementPreActivityReportEditionInput | undefined): Observable<EditInternalMovementPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/EditInternalMovementPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditInternalMovementPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditInternalMovementPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditInternalMovementPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditInternalMovementPreActivityReportOutput>;
        }));
    }

    protected processEditInternalMovementPreActivityReport(response: HttpResponseBase): Observable<EditInternalMovementPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditInternalMovementPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param preReportId (optional) 
     * @return Success
     */
    getInternalMovementPreActivityReportForEditionInfo(preReportId: number | undefined): Observable<InternalMovementPreActivityReportForEditionInfo> {
        let url_ = this.baseUrl + "/api/services/app/InternalMovementActivityReport/GetInternalMovementPreActivityReportForEditionInfo?";
        if (preReportId === null)
            throw new Error("The parameter 'preReportId' cannot be null.");
        else if (preReportId !== undefined)
            url_ += "preReportId=" + encodeURIComponent("" + preReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementPreActivityReportForEditionInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementPreActivityReportForEditionInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalMovementPreActivityReportForEditionInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalMovementPreActivityReportForEditionInfo>;
        }));
    }

    protected processGetInternalMovementPreActivityReportForEditionInfo(response: HttpResponseBase): Observable<InternalMovementPreActivityReportForEditionInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalMovementPreActivityReportForEditionInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class InvoiceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getInvoiceInfo(id: number | undefined): Observable<InvoiceDto> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoiceInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceDto>;
        }));
    }

    protected processGetInvoiceInfo(response: HttpResponseBase): Observable<InvoiceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInvoice(body: CreateInvoiceDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LanguageServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLanguages(): Observable<GetLanguagesOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguagesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguagesOutput>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<GetLanguagesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguagesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLanguageForEdit(id: number | undefined): Observable<GetLanguageForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLanguageForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLanguageForEditOutput>;
        }));
    }

    protected processGetLanguageForEdit(response: HttpResponseBase): Observable<GetLanguageForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLanguageForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateLanguage(body: CreateOrUpdateLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteLanguage(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setDefaultLanguage(body: SetDefaultLanguageInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetDefaultLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetDefaultLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @param baseLanguageName (optional) 
     * @param targetValueFilter (optional) 
     * @param filterText (optional) 
     * @return Success
     */
    getLanguageTexts(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined, sourceName: string, baseLanguageName: string | undefined, targetLanguageName: string, targetValueFilter: string | undefined, filterText: string | undefined): Observable<PagedResultDtoOfLanguageTextListDto> {
        let url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName === null)
            throw new Error("The parameter 'baseLanguageName' cannot be null.");
        else if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter === null)
            throw new Error("The parameter 'targetValueFilter' cannot be null.");
        else if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText === null)
            throw new Error("The parameter 'filterText' cannot be null.");
        else if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguageTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLanguageTextListDto>;
        }));
    }

    protected processGetLanguageTexts(response: HttpResponseBase): Observable<PagedResultDtoOfLanguageTextListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLanguageTextListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLanguageText(body: UpdateLanguageTextInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLanguageText(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateLanguageText(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LicensePlateServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get a tag by its license plate
     * @param licensePlate (optional) The license plate
     * @return Success
     */
    getByLicensePlate(licensePlate: string | undefined): Observable<TagDto> {
        let url_ = this.baseUrl + "/api/services/app/LicensePlate/GetByLicensePlate?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagDto>;
        }));
    }

    protected processGetByLicensePlate(response: HttpResponseBase): Observable<TagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponseDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponseDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class LogyardActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWoodActivityReportFromLogyard(body: CreateWoodActivityReportFromLogyardInput | undefined): Observable<CreateWoodActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/LogyardActivityReport/CreateWoodActivityReportFromLogyard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWoodActivityReportFromLogyard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWoodActivityReportFromLogyard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodActivityReportOutput>;
        }));
    }

    protected processCreateWoodActivityReportFromLogyard(response: HttpResponseBase): Observable<CreateWoodActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Synchronizes local changes to the given activity report
     * @param body (optional) Wood activity report's information
     */
    synchronizeWoodActivityReportUpdates(body: SynchronizeWoodActivityReportUpdates | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/LogyardActivityReport/SynchronizeWoodActivityReportUpdates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeWoodActivityReportUpdates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeWoodActivityReportUpdates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSynchronizeWoodActivityReportUpdates(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete wood exit receipt
     * @return Success
     */
    deleteExitReceipt(reportId: number, deletionComment: string, deletionReasonId: number): Observable<ActivityReportDeletionResultDto> {
        let url_ = this.baseUrl + "/api/services/app/LogyardActivityReport/DeleteExitReceipt?";
        if (reportId === undefined || reportId === null)
            throw new Error("The parameter 'reportId' must be defined and cannot be null.");
        else
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (deletionComment === undefined || deletionComment === null)
            throw new Error("The parameter 'deletionComment' must be defined and cannot be null.");
        else
            url_ += "DeletionComment=" + encodeURIComponent("" + deletionComment) + "&";
        if (deletionReasonId === undefined || deletionReasonId === null)
            throw new Error("The parameter 'deletionReasonId' must be defined and cannot be null.");
        else
            url_ += "DeletionReasonId=" + encodeURIComponent("" + deletionReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExitReceipt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExitReceipt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ActivityReportDeletionResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ActivityReportDeletionResultDto>;
        }));
    }

    protected processDeleteExitReceipt(response: HttpResponseBase): Observable<ActivityReportDeletionResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ActivityReportDeletionResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class NotificationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<GetNotificationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationsOutput>;
        }));
    }

    protected processGetUserNotifications(response: HttpResponseBase): Observable<GetNotificationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    setAllNotificationsAsRead(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetAllNotificationsAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetAllNotificationsAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    setNotificationAsRead(body: EntityDtoOfGuid | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetNotificationAsRead(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSetNotificationAsRead(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getNotificationSettings(): Observable<GetNotificationSettingsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetNotificationSettingsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetNotificationSettingsOutput>;
        }));
    }

    protected processGetNotificationSettings(response: HttpResponseBase): Observable<GetNotificationSettingsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetNotificationSettingsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateNotificationSettings(body: UpdateNotificationSettingsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNotificationSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateNotificationSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteNotification(id: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param state (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    deleteAllUserNotifications(state: UserNotificationState | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Notification/DeleteAllUserNotifications?";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAllUserNotifications(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAllUserNotifications(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAllUserNotifications(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrganizationUnitServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getOrganizationUnits(): Observable<ListResultDtoOfOrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfOrganizationUnitDto>;
        }));
    }

    protected processGetOrganizationUnits(response: HttpResponseBase): Observable<ListResultDtoOfOrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfOrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitUsers(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitUserListDto>;
        }));
    }

    protected processGetOrganizationUnitUsers(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getOrganizationUnitRoles(id: number | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitRoles?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationUnitRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationUnitRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfOrganizationUnitRoleListDto>;
        }));
    }

    protected processGetOrganizationUnitRoles(response: HttpResponseBase): Observable<PagedResultDtoOfOrganizationUnitRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfOrganizationUnitRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganizationUnit(body: CreateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processCreateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateOrganizationUnit(body: UpdateOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processUpdateOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    moveOrganizationUnit(body: MoveOrganizationUnitInput | undefined): Observable<OrganizationUnitDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationUnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationUnitDto>;
        }));
    }

    protected processMoveOrganizationUnit(response: HttpResponseBase): Observable<OrganizationUnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationUnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteOrganizationUnit(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeUserFromOrganizationUnit(userId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveUserFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveUserFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param roleId (optional) 
     * @param organizationUnitId (optional) 
     * @return Success
     */
    removeRoleFromOrganizationUnit(roleId: number | undefined, organizationUnitId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveRoleFromOrganizationUnit?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "RoleId=" + encodeURIComponent("" + roleId) + "&";
        if (organizationUnitId === null)
            throw new Error("The parameter 'organizationUnitId' cannot be null.");
        else if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveRoleFromOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveRoleFromOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveRoleFromOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addUsersToOrganizationUnit(body: UsersToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddUsersToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddUsersToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRolesToOrganizationUnit(body: RolesToOrganizationUnitInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddRolesToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRolesToOrganizationUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRolesToOrganizationUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRolesToOrganizationUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findUsers(body: FindOrganizationUnitUsersInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindUsers(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    findRoles(body: FindOrganizationUnitRolesInput | undefined): Observable<PagedResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFindRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFindRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfNameValueDto>;
        }));
    }

    protected processFindRoles(response: HttpResponseBase): Observable<PagedResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PackageCountServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param factorTypeId (optional) 
     * @param lengthId (optional) 
     * @return Success
     */
    getPackageCount(factorTypeId: number | undefined, lengthId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/PackageCount/GetPackageCount?";
        if (factorTypeId === null)
            throw new Error("The parameter 'factorTypeId' cannot be null.");
        else if (factorTypeId !== undefined)
            url_ += "FactorTypeId=" + encodeURIComponent("" + factorTypeId) + "&";
        if (lengthId === null)
            throw new Error("The parameter 'lengthId' cannot be null.");
        else if (lengthId !== undefined)
            url_ += "LengthId=" + encodeURIComponent("" + lengthId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPackageCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPackageCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetPackageCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ParameterServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param type (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, type: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfParameterDto> {
        let url_ = this.baseUrl + "/api/services/app/Parameter/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfParameterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfParameterDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfParameterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfParameterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetParameterForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Parameter/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetParameterForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetParameterForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetParameterForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetParameterForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ParameterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Parameter/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param placeId (optional) Parameter value for place
     * @return Success
     */
    getByName(name: string | undefined, placeId: number | undefined): Observable<ParameterDto> {
        let url_ = this.baseUrl + "/api/services/app/Parameter/GetByName?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterDto>;
        }));
    }

    protected processGetByName(response: HttpResponseBase): Observable<ParameterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getParameterTypes(): Observable<ParameterTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Parameter/GetParameterTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterTypeDto[]>;
        }));
    }

    protected processGetParameterTypes(response: HttpResponseBase): Observable<ParameterTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param name (optional) 
     * @param externalPlaceId (optional) 
     * @return Success
     */
    getByNameAndExternalPlaceId(name: string | undefined, externalPlaceId: number | undefined): Observable<ParameterDto> {
        let url_ = this.baseUrl + "/api/services/app/Parameter/GetByNameAndExternalPlaceId?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (externalPlaceId === null)
            throw new Error("The parameter 'externalPlaceId' cannot be null.");
        else if (externalPlaceId !== undefined)
            url_ += "externalPlaceId=" + encodeURIComponent("" + externalPlaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByNameAndExternalPlaceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByNameAndExternalPlaceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterDto>;
        }));
    }

    protected processGetByNameAndExternalPlaceId(response: HttpResponseBase): Observable<ParameterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    getPaymentInfo(upgradeEditionId: number | undefined): Observable<PaymentInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentInfoDto>;
        }));
    }

    protected processGetPaymentInfo(response: HttpResponseBase): Observable<PaymentInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPayment(body: CreatePaymentDto | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreatePayment(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelPayment(body: CancelPaymentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancelPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getPaymentHistory(sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSubscriptionPaymentListDto>;
        }));
    }

    protected processGetPaymentHistory(response: HttpResponseBase): Observable<PagedResultDtoOfSubscriptionPaymentListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param recurringPaymentsEnabled (optional) 
     * @return Success
     */
    getActiveGateways(recurringPaymentsEnabled: boolean | undefined): Observable<PaymentGatewayModel[]> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled === null)
            throw new Error("The parameter 'recurringPaymentsEnabled' cannot be null.");
        else if (recurringPaymentsEnabled !== undefined)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveGateways(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveGateways(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PaymentGatewayModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PaymentGatewayModel[]>;
        }));
    }

    protected processGetActiveGateways(response: HttpResponseBase): Observable<PaymentGatewayModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentGatewayModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getPayment(paymentId: number | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getLastCompletedPayment(): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLastCompletedPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetLastCompletedPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    buyNowSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBuyNowSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBuyNowSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    newRegistrationSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNewRegistrationSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNewRegistrationSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    upgradeSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    extendSucceed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtendSucceed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtendSucceed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtendSucceed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    paymentFailed(paymentId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFailed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFailed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPaymentFailed(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param upgradeEditionId (optional) 
     * @return Success
     */
    switchBetweenFreeEditions(upgradeEditionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/SwitchBetweenFreeEditions?";
        if (upgradeEditionId === null)
            throw new Error("The parameter 'upgradeEditionId' cannot be null.");
        else if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwitchBetweenFreeEditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwitchBetweenFreeEditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSwitchBetweenFreeEditions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    upgradeSubscriptionCostsLessThenMinAmount(editionId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSubscriptionCostsLessThenMinAmount?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpgradeSubscriptionCostsLessThenMinAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpgradeSubscriptionCostsLessThenMinAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpgradeSubscriptionCostsLessThenMinAmount(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    hasAnyPayment(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Payment/HasAnyPayment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAnyPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAnyPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasAnyPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PayPalPaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param paymentId (optional) 
     * @param paypalOrderId (optional) 
     * @return Success
     */
    confirmPayment(paymentId: number | undefined, paypalOrderId: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (paypalOrderId === null)
            throw new Error("The parameter 'paypalOrderId' cannot be null.");
        else if (paypalOrderId !== undefined)
            url_ += "paypalOrderId=" + encodeURIComponent("" + paypalOrderId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfirmPayment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<PayPalConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PayPalConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PayPalConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<PayPalConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PayPalConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PeriodServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the periods included in the given dates
     * @param startDate (optional) Start date
     * @param endDate (optional) End date
     * @return Success
     */
    getPeriodsByDates(startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<PeriodDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Period/GetPeriodsByDates?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPeriodsByDates(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPeriodsByDates(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PeriodDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PeriodDto[]>;
        }));
    }

    protected processGetPeriodsByDates(response: HttpResponseBase): Observable<PeriodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PeriodDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PermissionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all permissions
     * @return Success
     */
    getAllPermissions(): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        let url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfFlatPermissionWithLevelDto>;
        }));
    }

    protected processGetAllPermissions(response: HttpResponseBase): Observable<ListResultDtoOfFlatPermissionWithLevelDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Validate Wood Pile input before creation
     * @param body (optional) 
     * @return Success
     */
    validatePileCreation(body: CreatePileInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pile/ValidatePileCreation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePileCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePileCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePileCreation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate Wood Pile origins before status update
     * @param pileId (optional) 
     * @return Success
     */
    validatePileOrigins(pileId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pile/ValidatePileOrigins?";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "pileId=" + encodeURIComponent("" + pileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePileOrigins(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePileOrigins(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePileOrigins(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create new wood pile entry
     * @param body (optional) 
     * @return Success
     */
    createPile(body: CreatePileInput | undefined): Observable<CreatePileOutput> {
        let url_ = this.baseUrl + "/api/services/app/Pile/CreatePile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreatePileOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreatePileOutput>;
        }));
    }

    protected processCreatePile(response: HttpResponseBase): Observable<CreatePileOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreatePileOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the next available pile number for the place of the given id
     * @param externalPlaceId (optional) 
     * @return Success
     */
    getNextPileNumberByExternalPlaceId(externalPlaceId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Pile/GetNextPileNumberByExternalPlaceId?";
        if (externalPlaceId === null)
            throw new Error("The parameter 'externalPlaceId' cannot be null.");
        else if (externalPlaceId !== undefined)
            url_ += "externalPlaceId=" + encodeURIComponent("" + externalPlaceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNextPileNumberByExternalPlaceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNextPileNumberByExternalPlaceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetNextPileNumberByExternalPlaceId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the pile of the given id
     * @param pileId (optional) 
     * @return Success
     */
    getPileById(pileId: number | undefined): Observable<PileDto> {
        let url_ = this.baseUrl + "/api/services/app/Pile/GetPileById?";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "pileId=" + encodeURIComponent("" + pileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPileById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPileById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PileDto>;
        }));
    }

    protected processGetPileById(response: HttpResponseBase): Observable<PileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit the pile of the given id with the given properties
     * @param body (optional) 
     * @return Success
     */
    editPile(body: EditPileInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pile/EditPile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditPile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditPile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditPile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the pile of the given id if the given changes are valid for that pile
     * @param id (optional) 
     * @param pileOrigins (optional) 
     * @param allowsEntry (optional) 
     * @param allowsExit (optional) 
     * @return Success
     */
    getPileIfCanEdit(id: number | undefined, pileOrigins: PileOriginDto[] | undefined, allowsEntry: boolean | undefined, allowsExit: boolean | undefined): Observable<PileDto> {
        let url_ = this.baseUrl + "/api/services/app/Pile/GetPileIfCanEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (pileOrigins === null)
            throw new Error("The parameter 'pileOrigins' cannot be null.");
        else if (pileOrigins !== undefined)
            pileOrigins && pileOrigins.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "PileOrigins[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (allowsEntry === null)
            throw new Error("The parameter 'allowsEntry' cannot be null.");
        else if (allowsEntry !== undefined)
            url_ += "AllowsEntry=" + encodeURIComponent("" + allowsEntry) + "&";
        if (allowsExit === null)
            throw new Error("The parameter 'allowsExit' cannot be null.");
        else if (allowsExit !== undefined)
            url_ += "AllowsExit=" + encodeURIComponent("" + allowsExit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPileIfCanEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPileIfCanEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PileDto>;
        }));
    }

    protected processGetPileIfCanEdit(response: HttpResponseBase): Observable<PileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Change the pile status of the pile with the given id
     * @param pileId (optional) 
     * @param body (optional) 
     * @return Success
     */
    changePileStatus(pileId: number | undefined, body: PileStatus | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Pile/ChangePileStatus?";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "pileId=" + encodeURIComponent("" + pileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePileStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePileStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePileStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verify if any of the given origins was used in a wood activity report with the given pile id
     * @param pileId (optional) 
     * @param body (optional) 
     * @return Success
     */
    isPileAssignedToExistingWoodActivityReport(pileId: number | undefined, body: PileOriginDto[] | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Pile/IsPileAssignedToExistingWoodActivityReport?";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "pileId=" + encodeURIComponent("" + pileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsPileAssignedToExistingWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsPileAssignedToExistingWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsPileAssignedToExistingWoodActivityReport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get active piles by place id
     * @param logyardExternalId (optional) 
     * @return Success
     */
    getActiveAndInactivePilesByLogyardExternalId(logyardExternalId: number | undefined): Observable<PileForReportCreationOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pile/GetActiveAndInactivePilesByLogyardExternalId?";
        if (logyardExternalId === null)
            throw new Error("The parameter 'logyardExternalId' cannot be null.");
        else if (logyardExternalId !== undefined)
            url_ += "logyardExternalId=" + encodeURIComponent("" + logyardExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveAndInactivePilesByLogyardExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveAndInactivePilesByLogyardExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PileForReportCreationOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PileForReportCreationOutputDto[]>;
        }));
    }

    protected processGetActiveAndInactivePilesByLogyardExternalId(response: HttpResponseBase): Observable<PileForReportCreationOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PileForReportCreationOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get pile origins by pile id
     * @param pileId (optional) Pile id
     * @return Success
     */
    getPileOriginsByPileId(pileId: number | undefined): Observable<PileOriginDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pile/GetPileOriginsByPileId?";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "pileId=" + encodeURIComponent("" + pileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPileOriginsByPileId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPileOriginsByPileId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PileOriginDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PileOriginDto[]>;
        }));
    }

    protected processGetPileOriginsByPileId(response: HttpResponseBase): Observable<PileOriginDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PileOriginDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets sorted and filtered list of piles.
     * @param filter (optional) Requested filter information.
     * @param externalLocationId (optional) External location id.
     * @return Success
     */
    getList(filter: string | undefined, externalLocationId: number | undefined): Observable<BasicPileDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Pile/GetList?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (externalLocationId === null)
            throw new Error("The parameter 'externalLocationId' cannot be null.");
        else if (externalLocationId !== undefined)
            url_ += "externalLocationId=" + encodeURIComponent("" + externalLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicPileDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicPileDto[]>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<BasicPileDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicPileDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the active pile (if any) for the specified wood origin and article.
     * @param woodOriginId (optional) Wood origin identifier.
     * @param locationType (optional) Location type
     * @param articleId (optional) Article identifier.
     * @return Success
     */
    getActivePileByWoodOriginAndArticle(woodOriginId: number | undefined, locationType: LocationType | undefined, articleId: number | undefined): Observable<BasicPileDto> {
        let url_ = this.baseUrl + "/api/services/app/Pile/GetActivePileByWoodOriginAndArticle?";
        if (woodOriginId === null)
            throw new Error("The parameter 'woodOriginId' cannot be null.");
        else if (woodOriginId !== undefined)
            url_ += "woodOriginId=" + encodeURIComponent("" + woodOriginId) + "&";
        if (locationType === null)
            throw new Error("The parameter 'locationType' cannot be null.");
        else if (locationType !== undefined)
            url_ += "locationType=" + encodeURIComponent("" + locationType) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "articleId=" + encodeURIComponent("" + articleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivePileByWoodOriginAndArticle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivePileByWoodOriginAndArticle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicPileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicPileDto>;
        }));
    }

    protected processGetActivePileByWoodOriginAndArticle(response: HttpResponseBase): Observable<BasicPileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicPileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PlaceServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all the places by specific user permission
     * @param placeType (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(placeType: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPlaceForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetAll?";
        if (placeType === null)
            throw new Error("The parameter 'placeType' cannot be null.");
        else if (placeType !== undefined)
            url_ += "PlaceType=" + encodeURIComponent("" + placeType) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPlaceForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPlaceForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetPlaceForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPlaceForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get an specific place by place id given the user permissions
     * @param placeId (optional) 
     * @return Success
     */
    get(placeId: number | undefined): Observable<PlaceDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/Get?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PlaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param placeId (optional) 
     * @return Success
     */
    getDevicesConfigurationOfPlace(placeId: number | undefined): Observable<PlaceConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetDevicesConfigurationOfPlace?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevicesConfigurationOfPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevicesConfigurationOfPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceConfigurationDto>;
        }));
    }

    protected processGetDevicesConfigurationOfPlace(response: HttpResponseBase): Observable<PlaceConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaceConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a place given the users permissions
     * @param body (optional) 
     * @return Success
     */
    create(body: PlacesDtoInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Place/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an specific place by placeId given the user permissions
     * @param placeId (optional) 
     * @return Success
     */
    delete(placeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Place/Delete?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an specific place given the user permissions
     * @param body (optional) 
     * @return Success
     */
    update(body: PlacesDtoUpdateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Place/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get User's place Id and externalId
     * @return Success
     */
    getUserPlace(): Observable<UserPlaceOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetUserPlace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserPlaceOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserPlaceOutputDto>;
        }));
    }

    protected processGetUserPlace(response: HttpResponseBase): Observable<UserPlaceOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserPlaceOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Are measurement devices active
     * @param placeId (optional) 
     * @return Success
     */
    areMeasurementDevicesActive(placeId: number | undefined): Observable<AreMeasurementDevicesActiveOutput> {
        let url_ = this.baseUrl + "/api/services/app/Place/AreMeasurementDevicesActive?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAreMeasurementDevicesActive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAreMeasurementDevicesActive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreMeasurementDevicesActiveOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreMeasurementDevicesActiveOutput>;
        }));
    }

    protected processAreMeasurementDevicesActive(response: HttpResponseBase): Observable<AreMeasurementDevicesActiveOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreMeasurementDevicesActiveOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Are measurement devices active for external location id
     * @param externalLocationId (optional) 
     * @return Success
     */
    areMeasurementDevicesActiveForExternalLocationId(externalLocationId: number | undefined): Observable<AreMeasurementDevicesActiveOutput> {
        let url_ = this.baseUrl + "/api/services/app/Place/AreMeasurementDevicesActiveForExternalLocationId?";
        if (externalLocationId === null)
            throw new Error("The parameter 'externalLocationId' cannot be null.");
        else if (externalLocationId !== undefined)
            url_ += "externalLocationId=" + encodeURIComponent("" + externalLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAreMeasurementDevicesActiveForExternalLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAreMeasurementDevicesActiveForExternalLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AreMeasurementDevicesActiveOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AreMeasurementDevicesActiveOutput>;
        }));
    }

    protected processAreMeasurementDevicesActiveForExternalLocationId(response: HttpResponseBase): Observable<AreMeasurementDevicesActiveOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreMeasurementDevicesActiveOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get places for role assignment
     * @return Success
     */
    getPlacesForRoleAssignment(): Observable<PlaceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetPlacesForRoleAssignment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlacesForRoleAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlacesForRoleAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceDto[]>;
        }));
    }

    protected processGetPlacesForRoleAssignment(response: HttpResponseBase): Observable<PlaceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all places to switch
     * @return Success
     */
    getAllPlacesToSwitch(): Observable<GetAllPlacesToSwitchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetAllPlacesToSwitch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlacesToSwitch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlacesToSwitch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllPlacesToSwitchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllPlacesToSwitchOutputDto>;
        }));
    }

    protected processGetAllPlacesToSwitch(response: HttpResponseBase): Observable<GetAllPlacesToSwitchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllPlacesToSwitchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all places with archimedes zone to switch
     * @return Success
     */
    getAllPlacesWithArchimedesZoneToSwitch(): Observable<GetAllPlacesToSwitchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetAllPlacesWithArchimedesZoneToSwitch";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlacesWithArchimedesZoneToSwitch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlacesWithArchimedesZoneToSwitch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllPlacesToSwitchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllPlacesToSwitchOutputDto>;
        }));
    }

    protected processGetAllPlacesWithArchimedesZoneToSwitch(response: HttpResponseBase): Observable<GetAllPlacesToSwitchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllPlacesToSwitchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all places to switch by user
     * @param userId (optional) 
     * @return Success
     */
    getAllPlacesToSwitchByUser(userId: number | undefined): Observable<GetAllPlacesToSwitchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetAllPlacesToSwitchByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlacesToSwitchByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlacesToSwitchByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllPlacesToSwitchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllPlacesToSwitchOutputDto>;
        }));
    }

    protected processGetAllPlacesToSwitchByUser(response: HttpResponseBase): Observable<GetAllPlacesToSwitchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllPlacesToSwitchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if place with externalLocationId exists
     * @param externalLocationId (optional) 
     * @return Success
     */
    existsPlaceByExternalLocationId(externalLocationId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Place/ExistsPlaceByExternalLocationId?";
        if (externalLocationId === null)
            throw new Error("The parameter 'externalLocationId' cannot be null.");
        else if (externalLocationId !== undefined)
            url_ += "externalLocationId=" + encodeURIComponent("" + externalLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistsPlaceByExternalLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistsPlaceByExternalLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExistsPlaceByExternalLocationId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get place configuration by activity report id
     * @param activityReportId (optional) 
     * @return Success
     */
    getPlaceConfigurationByActivityReportId(activityReportId: number | undefined): Observable<PlaceExternalServicesConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetPlaceConfigurationByActivityReportId?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaceConfigurationByActivityReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceConfigurationByActivityReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceExternalServicesConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceExternalServicesConfigurationDto>;
        }));
    }

    protected processGetPlaceConfigurationByActivityReportId(response: HttpResponseBase): Observable<PlaceExternalServicesConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaceExternalServicesConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get place configuration by place id
     * @param placeId (optional) 
     * @return Success
     */
    getPlaceConfigurationByPlaceId(placeId: number | undefined): Observable<PlaceExternalServicesConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetPlaceConfigurationByPlaceId?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaceConfigurationByPlaceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceConfigurationByPlaceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceExternalServicesConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceExternalServicesConfigurationDto>;
        }));
    }

    protected processGetPlaceConfigurationByPlaceId(response: HttpResponseBase): Observable<PlaceExternalServicesConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaceExternalServicesConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get place by external location id
     * @param externalLocationId (optional) 
     * @return Success
     */
    getPlaceByExternalLocationId(externalLocationId: number | undefined): Observable<PlaceDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetPlaceByExternalLocationId?";
        if (externalLocationId === null)
            throw new Error("The parameter 'externalLocationId' cannot be null.");
        else if (externalLocationId !== undefined)
            url_ += "externalLocationId=" + encodeURIComponent("" + externalLocationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaceByExternalLocationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceByExternalLocationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceDto>;
        }));
    }

    protected processGetPlaceByExternalLocationId(response: HttpResponseBase): Observable<PlaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get integration values by placeId
     * @param placeId (optional) place identifier
     * @param type (optional) integration type
     * @return Success
     */
    getIntegrationValues(placeId: number | undefined, type: PlaceExternalIntegrationsType | undefined): Observable<IntegrationValuesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetIntegrationValues?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetIntegrationValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetIntegrationValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationValuesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationValuesOutputDto>;
        }));
    }

    protected processGetIntegrationValues(response: HttpResponseBase): Observable<IntegrationValuesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationValuesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = PlaceConfigurationDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update external integration values
     * @param body (optional) 
     * @return Success
     */
    updateIntegrationValues(body: UpdateIntegrationValuesInputDto | undefined): Observable<IntegrationValuesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/UpdateIntegrationValues";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIntegrationValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIntegrationValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationValuesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationValuesOutputDto>;
        }));
    }

    protected processUpdateIntegrationValues(response: HttpResponseBase): Observable<IntegrationValuesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationValuesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get places which accepts pre receipts creation
     * @return Success
     */
    getPlacesToPreReceiptCreation(): Observable<PlaceToPreReceiptCreationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetPlacesToPreReceiptCreation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlacesToPreReceiptCreation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlacesToPreReceiptCreation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceToPreReceiptCreationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceToPreReceiptCreationDto[]>;
        }));
    }

    protected processGetPlacesToPreReceiptCreation(response: HttpResponseBase): Observable<PlaceToPreReceiptCreationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaceToPreReceiptCreationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Return information if logyard is managed by SmartAccess
     * @param externalLogyardId (optional) 
     * @return Success
     */
    isManagedLogyard(externalLogyardId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Place/IsManagedLogyard?";
        if (externalLogyardId === null)
            throw new Error("The parameter 'externalLogyardId' cannot be null.");
        else if (externalLogyardId !== undefined)
            url_ += "externalLogyardId=" + encodeURIComponent("" + externalLogyardId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsManagedLogyard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsManagedLogyard(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsManagedLogyard(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get integration values by the deposit customs code of the place
     * @param depositCode (optional) Sige's deposit code of the place
     * @return Success
     */
    getSigeValuesByDepositCode(depositCode: number | undefined): Observable<IntegrationValuesOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetSigeValuesByDepositCode?";
        if (depositCode === null)
            throw new Error("The parameter 'depositCode' cannot be null.");
        else if (depositCode !== undefined)
            url_ += "depositCode=" + encodeURIComponent("" + depositCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSigeValuesByDepositCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSigeValuesByDepositCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IntegrationValuesOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IntegrationValuesOutputDto>;
        }));
    }

    protected processGetSigeValuesByDepositCode(response: HttpResponseBase): Observable<IntegrationValuesOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IntegrationValuesOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param placeId (optional) 
     * @return Success
     */
    getPlaceErpCode(placeId: number | undefined): Observable<PlaceErpInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetPlaceErpCode?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlaceErpCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlaceErpCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceErpInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceErpInformationDto>;
        }));
    }

    protected processGetPlaceErpCode(response: HttpResponseBase): Observable<PlaceErpInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaceErpInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param locationType (optional) 
     * @return Success
     */
    getAllBasicPlacesByLocationType(locationType: LocationType | undefined): Observable<BasicPlaceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Place/GetAllBasicPlacesByLocationType?";
        if (locationType === null)
            throw new Error("The parameter 'locationType' cannot be null.");
        else if (locationType !== undefined)
            url_ += "locationType=" + encodeURIComponent("" + locationType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBasicPlacesByLocationType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBasicPlacesByLocationType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicPlaceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicPlaceDto[]>;
        }));
    }

    protected processGetAllBasicPlacesByLocationType(response: HttpResponseBase): Observable<BasicPlaceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BasicPlaceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PlaceDepartmentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPlacesDepartments(): Observable<PlaceDepartmentDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlaceDepartment/GetAllPlacesDepartments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlacesDepartments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlacesDepartments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceDepartmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceDepartmentDto[]>;
        }));
    }

    protected processGetAllPlacesDepartments(response: HttpResponseBase): Observable<PlaceDepartmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaceDepartmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PlaceTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all the places types
     * @return Success
     */
    getAllPlaceTypes(): Observable<PlaceTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/PlaceType/GetAllPlaceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlaceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlaceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceTypeDto[]>;
        }));
    }

    protected processGetAllPlaceTypes(response: HttpResponseBase): Observable<PlaceTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaceTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class PolygonContractServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all polygon contracts
     * @param includePolygonContractInactives (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(includePolygonContractInactives: boolean | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPolygonContractDto> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/GetAll?";
        if (includePolygonContractInactives === null)
            throw new Error("The parameter 'includePolygonContractInactives' cannot be null.");
        else if (includePolygonContractInactives !== undefined)
            url_ += "IncludePolygonContractInactives=" + encodeURIComponent("" + includePolygonContractInactives) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPolygonContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPolygonContractDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfPolygonContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPolygonContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create polygon contract
     * @param body (optional) Input parameters
     * @return Success
     */
    create(body: CreatePolygonContractInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edit polygon contract
     * @param body (optional) Input parameters
     * @return Success
     */
    edit(body: EditPolygonContractInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/Edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEdit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete polygon contract
     * @param polygonContractId (optional) Polygon contract id
     * @return Success
     */
    delete(polygonContractId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/Delete?";
        if (polygonContractId === null)
            throw new Error("The parameter 'polygonContractId' cannot be null.");
        else if (polygonContractId !== undefined)
            url_ += "polygonContractId=" + encodeURIComponent("" + polygonContractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get polygon contract by id
     * @param polygonContractId (optional) Polygon contract id
     * @return Success
     */
    getById(polygonContractId: number | undefined): Observable<PolygonContractDto> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/GetById?";
        if (polygonContractId === null)
            throw new Error("The parameter 'polygonContractId' cannot be null.");
        else if (polygonContractId !== undefined)
            url_ += "polygonContractId=" + encodeURIComponent("" + polygonContractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolygonContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolygonContractDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<PolygonContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PolygonContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get polygon contract by id
     * @param externalContractId (optional) External contract id
     * @return Success
     */
    getByExternalContractId(externalContractId: number | undefined): Observable<PolygonContractDto> {
        let url_ = this.baseUrl + "/api/services/app/PolygonContract/GetByExternalContractId?";
        if (externalContractId === null)
            throw new Error("The parameter 'externalContractId' cannot be null.");
        else if (externalContractId !== undefined)
            url_ += "externalContractId=" + encodeURIComponent("" + externalContractId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByExternalContractId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByExternalContractId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PolygonContractDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PolygonContractDto>;
        }));
    }

    protected processGetByExternalContractId(response: HttpResponseBase): Observable<PolygonContractDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PolygonContractDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProfileServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentUserProfileForEdit(): Observable<CurrentUserProfileEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserProfileForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentUserProfileEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentUserProfileEditDto>;
        }));
    }

    protected processGetCurrentUserProfileForEdit(response: HttpResponseBase): Observable<CurrentUserProfileEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentUserProfileEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    disableGoogleAuthenticator(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/DisableGoogleAuthenticator";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableGoogleAuthenticator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableGoogleAuthenticator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableGoogleAuthenticator(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateGoogleAuthenticatorKey(): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateGoogleAuthenticatorKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateGoogleAuthenticatorKeyOutput>;
        }));
    }

    protected processUpdateGoogleAuthenticatorKey(response: HttpResponseBase): Observable<UpdateGoogleAuthenticatorKeyOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendVerificationSms(body: SendVerificationSmsInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendVerificationSms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendVerificationSms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendVerificationSms(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifySmsCode(body: VerifySmsCodeInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVerifySmsCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVerifySmsCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVerifySmsCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    prepareCollectedData(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareCollectedData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrepareCollectedData(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCurrentUserProfile(body: CurrentUserProfileEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentUserProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentUserProfile(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changePassword(body: ChangePasswordInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangePassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangePassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangePassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateProfilePicture(body: UpdateProfilePictureInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateProfilePicture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getPasswordComplexitySetting(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPasswordComplexitySetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetPasswordComplexitySetting(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getSecondPasswordComplexitySettings(): Observable<GetPasswordComplexitySettingOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetSecondPasswordComplexitySettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSecondPasswordComplexitySettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSecondPasswordComplexitySettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPasswordComplexitySettingOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPasswordComplexitySettingOutput>;
        }));
    }

    protected processGetSecondPasswordComplexitySettings(response: HttpResponseBase): Observable<GetPasswordComplexitySettingOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPasswordComplexitySettingOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfilePicture(): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param username (optional) 
     * @return Success
     */
    getProfilePictureByUserName(username: string | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUserName?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUserName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUserName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUserName(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @param tenantId (optional) 
     * @return Success
     */
    getFriendProfilePicture(userId: number | undefined, tenantId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePicture?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFriendProfilePicture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFriendProfilePicture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetFriendProfilePicture(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userId (optional) 
     * @return Success
     */
    getProfilePictureByUser(userId: number | undefined): Observable<GetProfilePictureOutput> {
        let url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfilePictureByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfilePictureByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfilePictureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfilePictureOutput>;
        }));
    }

    protected processGetProfilePictureByUser(response: HttpResponseBase): Observable<GetProfilePictureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfilePictureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    changeLanguage(body: ChangeUserLanguageDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeLanguage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeLanguage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeLanguage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ProviderServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the configurations of all external providers, paged and sorted according to input
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getExternalProvidersConfig(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfExternalProviderItemOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/GetExternalProvidersConfig?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalProvidersConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalProvidersConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfExternalProviderItemOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfExternalProviderItemOutput>;
        }));
    }

    protected processGetExternalProvidersConfig(response: HttpResponseBase): Observable<PagedResultDtoOfExternalProviderItemOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfExternalProviderItemOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the configuration of an external provider
     * @param configId (optional) The provider's configuration id
     * @return Success
     */
    getExternalProviderConfig(configId: number | undefined): Observable<ExternalProviderItemOutput> {
        let url_ = this.baseUrl + "/api/services/app/Provider/GetExternalProviderConfig?";
        if (configId === null)
            throw new Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalProviderConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalProviderConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalProviderItemOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalProviderItemOutput>;
        }));
    }

    protected processGetExternalProviderConfig(response: HttpResponseBase): Observable<ExternalProviderItemOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalProviderItemOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a new external provider configuration
     * @param body (optional) The provider's configuration
     * @return Success
     */
    createExternalProviderConfig(body: CreateEditExternalProviderInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Provider/CreateExternalProviderConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExternalProviderConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExternalProviderConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateExternalProviderConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Edits the external provider configuration
     * @param body (optional) The provider's new configuration
     * @return Success
     */
    editExternalProviderConfig(body: CreateEditExternalProviderInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Provider/EditExternalProviderConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditExternalProviderConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditExternalProviderConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEditExternalProviderConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an external provider configuration
     * @param toDelete (optional) The id of the deleted provider configuration
     * @return Success
     */
    deleteExternalProvider(toDelete: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Provider/DeleteExternalProvider?";
        if (toDelete === null)
            throw new Error("The parameter 'toDelete' cannot be null.");
        else if (toDelete !== undefined)
            url_ += "toDelete=" + encodeURIComponent("" + toDelete) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExternalProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExternalProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExternalProvider(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentExternalProvider(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Provider/GetCurrentExternalProvider";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentExternalProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentExternalProvider(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetCurrentExternalProvider(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getCurrentExternalProviderType(): Observable<ProviderType> {
        let url_ = this.baseUrl + "/api/services/app/Provider/GetCurrentExternalProviderType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentExternalProviderType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentExternalProviderType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProviderType>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProviderType>;
        }));
    }

    protected processGetCurrentExternalProviderType(response: HttpResponseBase): Observable<ProviderType> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets a paged list of the activity reports of the logged in provider, filtered by date and license plate.
     * @param licensePlate (optional) 
     * @param destinationExternalId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchReportsPaged(fromDate: DateTime, toDate: DateTime, licensePlate: string | undefined, destinationExternalId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportByProviderOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Provider/SearchReportsPaged?";
        if (fromDate === undefined || fromDate === null)
            throw new Error("The parameter 'fromDate' must be defined and cannot be null.");
        else
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toString() : "") + "&";
        if (toDate === undefined || toDate === null)
            throw new Error("The parameter 'toDate' must be defined and cannot be null.");
        else
            url_ += "ToDate=" + encodeURIComponent(toDate ? "" + toDate.toString() : "") + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchReportsPaged(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchReportsPaged(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportByProviderOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportByProviderOutputDto>;
        }));
    }

    protected processSearchReportsPaged(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportByProviderOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportByProviderOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RandomStatisticalSampleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the random sample assignations
     * @param periodId (optional) 
     * @param modelId (optional) 
     * @param woodOriginExternalId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getRandomSampleAssignations(periodId: number | undefined, modelId: number | undefined, woodOriginExternalId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRandomSampleAssignationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSample/GetRandomSampleAssignations?";
        if (periodId === null)
            throw new Error("The parameter 'periodId' cannot be null.");
        else if (periodId !== undefined)
            url_ += "PeriodId=" + encodeURIComponent("" + periodId) + "&";
        if (modelId === null)
            throw new Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        if (woodOriginExternalId === null)
            throw new Error("The parameter 'woodOriginExternalId' cannot be null.");
        else if (woodOriginExternalId !== undefined)
            url_ += "WoodOriginExternalId=" + encodeURIComponent("" + woodOriginExternalId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRandomSampleAssignations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRandomSampleAssignations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRandomSampleAssignationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRandomSampleAssignationOutputDto>;
        }));
    }

    protected processGetRandomSampleAssignations(response: HttpResponseBase): Observable<PagedResultDtoOfRandomSampleAssignationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRandomSampleAssignationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the random sample assignations for report generation
     * @param periodId (optional) 
     * @param modelId (optional) 
     * @param woodOriginExternalId (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getRandomSampleAssignationForReportGeneration(periodId: number | undefined, modelId: number | undefined, woodOriginExternalId: number | undefined, placeId: number | undefined): Observable<RandomSampleAssignationReportOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSample/GetRandomSampleAssignationForReportGeneration?";
        if (periodId === null)
            throw new Error("The parameter 'periodId' cannot be null.");
        else if (periodId !== undefined)
            url_ += "PeriodId=" + encodeURIComponent("" + periodId) + "&";
        if (modelId === null)
            throw new Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        if (woodOriginExternalId === null)
            throw new Error("The parameter 'woodOriginExternalId' cannot be null.");
        else if (woodOriginExternalId !== undefined)
            url_ += "WoodOriginExternalId=" + encodeURIComponent("" + woodOriginExternalId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRandomSampleAssignationForReportGeneration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRandomSampleAssignationForReportGeneration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RandomSampleAssignationReportOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RandomSampleAssignationReportOutputDto[]>;
        }));
    }

    protected processGetRandomSampleAssignationForReportGeneration(response: HttpResponseBase): Observable<RandomSampleAssignationReportOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RandomSampleAssignationReportOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RandomStatisticalSampleQuotaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add sample quota
     * @param body (optional) 
     * @return Success
     */
    addRandomStatisticalSampleQuota(body: RandomStatisticalSampleQuotaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSampleQuota/AddRandomStatisticalSampleQuota";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRandomStatisticalSampleQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRandomStatisticalSampleQuota(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddRandomStatisticalSampleQuota(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all random statistical sample quotas
     * @param placeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllRandomStatisticalSampleQuotas(placeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfRandomStatisticalSampleQuotaDto> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSampleQuota/GetAllRandomStatisticalSampleQuotas?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRandomStatisticalSampleQuotas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRandomStatisticalSampleQuotas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfRandomStatisticalSampleQuotaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfRandomStatisticalSampleQuotaDto>;
        }));
    }

    protected processGetAllRandomStatisticalSampleQuotas(response: HttpResponseBase): Observable<PagedResultDtoOfRandomStatisticalSampleQuotaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfRandomStatisticalSampleQuotaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update sample quota
     * @param body (optional) 
     * @return Success
     */
    updateRandomStatisticalSampleQuota(body: RandomStatisticalSampleQuotaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSampleQuota/UpdateRandomStatisticalSampleQuota";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateRandomStatisticalSampleQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateRandomStatisticalSampleQuota(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateRandomStatisticalSampleQuota(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get sample quota by id
     * @param quotaId (optional) 
     * @return Success
     */
    getRandomStatisticalSampleQuotaById(quotaId: number | undefined): Observable<RandomStatisticalSampleQuotaDto> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSampleQuota/GetRandomStatisticalSampleQuotaById?";
        if (quotaId === null)
            throw new Error("The parameter 'quotaId' cannot be null.");
        else if (quotaId !== undefined)
            url_ += "quotaId=" + encodeURIComponent("" + quotaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRandomStatisticalSampleQuotaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRandomStatisticalSampleQuotaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RandomStatisticalSampleQuotaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RandomStatisticalSampleQuotaDto>;
        }));
    }

    protected processGetRandomStatisticalSampleQuotaById(response: HttpResponseBase): Observable<RandomStatisticalSampleQuotaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RandomStatisticalSampleQuotaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete sample quota
     * @param quotaId (optional) 
     * @return Success
     */
    deleteRandomStatisticalSampleQuota(quotaId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/RandomStatisticalSampleQuota/DeleteRandomStatisticalSampleQuota?";
        if (quotaId === null)
            throw new Error("The parameter 'quotaId' cannot be null.");
        else if (quotaId !== undefined)
            url_ += "quotaId=" + encodeURIComponent("" + quotaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRandomStatisticalSampleQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRandomStatisticalSampleQuota(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRandomStatisticalSampleQuota(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReasonsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param reasonTypeFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(filter: string | undefined, reasonTypeFilter: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetReasonForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Reasons/GetAll?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (reasonTypeFilter === null)
            throw new Error("The parameter 'reasonTypeFilter' cannot be null.");
        else if (reasonTypeFilter !== undefined)
            url_ += "ReasonTypeFilter=" + encodeURIComponent("" + reasonTypeFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetReasonForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetReasonForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetReasonForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetReasonForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<GetReasonForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Reasons/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReasonForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReasonForViewDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetReasonForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetReasonForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: ReasonDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reasons/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: ReasonDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reasons/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reasonId (optional) 
     * @return Success
     */
    delete(reasonId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Reasons/Delete?";
        if (reasonId === null)
            throw new Error("The parameter 'reasonId' cannot be null.");
        else if (reasonId !== undefined)
            url_ += "reasonId=" + encodeURIComponent("" + reasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTypes(): Observable<ReasonTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reasons/GetTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReasonTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReasonTypeDto[]>;
        }));
    }

    protected processGetTypes(response: HttpResponseBase): Observable<ReasonTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReasonTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reasonType (optional) 
     * @return Success
     */
    getReasonsByType(reasonType: ReasonTypes | undefined): Observable<GetReasonForViewDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Reasons/GetReasonsByType?";
        if (reasonType === null)
            throw new Error("The parameter 'reasonType' cannot be null.");
        else if (reasonType !== undefined)
            url_ += "reasonType=" + encodeURIComponent("" + reasonType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReasonsByType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReasonsByType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetReasonForViewDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetReasonForViewDto[]>;
        }));
    }

    protected processGetReasonsByType(response: HttpResponseBase): Observable<GetReasonForViewDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetReasonForViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReceiptIndicatorsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Returns average time for current receipts in place
     * @param placeId (optional) 
     * @return Success
     */
    getTimeAverageInDestination(placeId: number | undefined): Observable<AverageInDestinationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetTimeAverageInDestination?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeAverageInDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeAverageInDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AverageInDestinationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AverageInDestinationOutputDto>;
        }));
    }

    protected processGetTimeAverageInDestination(response: HttpResponseBase): Observable<AverageInDestinationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AverageInDestinationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns average time for current receipts in place from date
     * @param placeId (optional) 
     * @param hours (optional) 
     * @return Success
     */
    getTimeAverageInDestinationByPeriod(placeId: number | undefined, hours: number | undefined): Observable<AverageInDestinationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetTimeAverageInDestinationByPeriod?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (hours === null)
            throw new Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "hours=" + encodeURIComponent("" + hours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimeAverageInDestinationByPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimeAverageInDestinationByPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AverageInDestinationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AverageInDestinationOutputDto>;
        }));
    }

    protected processGetTimeAverageInDestinationByPeriod(response: HttpResponseBase): Observable<AverageInDestinationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AverageInDestinationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's the indicator of Get Max Time On Destination with state in place
     * @param placeId (optional) 
     * @return Success
     */
    getMaxTimeOnDestination(placeId: number | undefined): Observable<MaxTimeOnDestinationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetMaxTimeOnDestination?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMaxTimeOnDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMaxTimeOnDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MaxTimeOnDestinationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MaxTimeOnDestinationOutputDto>;
        }));
    }

    protected processGetMaxTimeOnDestination(response: HttpResponseBase): Observable<MaxTimeOnDestinationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MaxTimeOnDestinationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns Volume projection
     * @param placeId (optional) 
     * @param hours (optional) 
     * @return Success
     */
    getWoodPreActivityReportsForVolumeProjections(placeId: number | undefined, hours: number | undefined): Observable<PreActivityReportInfoForProjectionsIndicator> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetWoodPreActivityReportsForVolumeProjections?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (hours === null)
            throw new Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "hours=" + encodeURIComponent("" + hours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreActivityReportsForVolumeProjections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreActivityReportsForVolumeProjections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportInfoForProjectionsIndicator>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportInfoForProjectionsIndicator>;
        }));
    }

    protected processGetWoodPreActivityReportsForVolumeProjections(response: HttpResponseBase): Observable<PreActivityReportInfoForProjectionsIndicator> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportInfoForProjectionsIndicator.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns wood activityReports for trucks not arrive to next trip
     * @param placeId (optional) 
     * @return Success
     */
    getWoodActivityReportsForTrucksToNextTrip(placeId: number | undefined): Observable<ListWoodActivityReportsForTrucksToNextTrip> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetWoodActivityReportsForTrucksToNextTrip?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportsForTrucksToNextTrip(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportsForTrucksToNextTrip(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListWoodActivityReportsForTrucksToNextTrip>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListWoodActivityReportsForTrucksToNextTrip>;
        }));
    }

    protected processGetWoodActivityReportsForTrucksToNextTrip(response: HttpResponseBase): Observable<ListWoodActivityReportsForTrucksToNextTrip> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListWoodActivityReportsForTrucksToNextTrip.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns number of wood activity reports in place
     * @param placeId (optional) 
     * @return Success
     */
    getWoodReceiptsInPlaceIndicator(placeId: number | undefined): Observable<ReceiptsInPlaceIndicatorOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetWoodReceiptsInPlaceIndicator?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodReceiptsInPlaceIndicator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodReceiptsInPlaceIndicator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptsInPlaceIndicatorOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptsInPlaceIndicatorOutputDto>;
        }));
    }

    protected processGetWoodReceiptsInPlaceIndicator(response: HttpResponseBase): Observable<ReceiptsInPlaceIndicatorOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptsInPlaceIndicatorOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns number of wood activity reports in place without load
     * @param placeId (optional) 
     * @return Success
     */
    getWoodReceiptsWithoutLoad(placeId: number | undefined): Observable<ReceiptsWithoutLoadIndicatorOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetWoodReceiptsWithoutLoad?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodReceiptsWithoutLoad(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodReceiptsWithoutLoad(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReceiptsWithoutLoadIndicatorOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReceiptsWithoutLoadIndicatorOutputDto>;
        }));
    }

    protected processGetWoodReceiptsWithoutLoad(response: HttpResponseBase): Observable<ReceiptsWithoutLoadIndicatorOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReceiptsWithoutLoadIndicatorOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns number of wood activity reports without integrate Bioforest on current period
     * @param placeId (optional) 
     * @return Success
     */
    getWoodReceiptsWithoutIntergrateBioforestCurrentPeriodIndicator(placeId: number | undefined): Observable<WoodReportsWithoutIntegrateBioforestCurrentPeriod> {
        let url_ = this.baseUrl + "/api/services/app/ReceiptIndicators/GetWoodReceiptsWithoutIntergrateBioforestCurrentPeriodIndicator?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodReceiptsWithoutIntergrateBioforestCurrentPeriodIndicator(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodReceiptsWithoutIntergrateBioforestCurrentPeriodIndicator(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodReportsWithoutIntegrateBioforestCurrentPeriod>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodReportsWithoutIntegrateBioforestCurrentPeriod>;
        }));
    }

    protected processGetWoodReceiptsWithoutIntergrateBioforestCurrentPeriodIndicator(response: HttpResponseBase): Observable<WoodReportsWithoutIntegrateBioforestCurrentPeriod> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodReportsWithoutIntegrateBioforestCurrentPeriod.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets information for generating a wood report according to the input
     * @param reportId (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param vehicleLicensePlate (optional) 
     * @param reportState (optional) 
     * @param articleExternalId (optional) 
     * @param tripNumber (optional) 
     * @param woodProviderExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param pileId (optional) 
     * @param densityGuid (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param includeDeletedOnes (optional) 
     * @param placeId (optional) 
     * @param operationMode (optional) 
     * @param tenantId (optional) 
     * @param originExternalId (optional) 
     * @param standExternalId (optional) 
     * @param destinationExternalId (optional) 
     * @param singleCustomDeclarationExternalId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllWoodReports(reportId: number | undefined, serial: string | undefined, number: number | undefined, vehicleLicensePlate: string | undefined, reportState: ActivityReportState | undefined, articleExternalId: number | undefined, tripNumber: number | undefined, woodProviderExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, pileId: number | undefined, densityGuid: string | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, includeDeletedOnes: boolean | undefined, placeId: number | undefined, operationMode: ActivityReportOperationMode | undefined, tenantId: number | undefined, originExternalId: number | undefined, standExternalId: number | undefined, destinationExternalId: number | undefined, singleCustomDeclarationExternalId: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<WoodReceiptForReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAllWoodReports?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (vehicleLicensePlate === null)
            throw new Error("The parameter 'vehicleLicensePlate' cannot be null.");
        else if (vehicleLicensePlate !== undefined)
            url_ += "VehicleLicensePlate=" + encodeURIComponent("" + vehicleLicensePlate) + "&";
        if (reportState === null)
            throw new Error("The parameter 'reportState' cannot be null.");
        else if (reportState !== undefined)
            url_ += "ReportState=" + encodeURIComponent("" + reportState) + "&";
        if (articleExternalId === null)
            throw new Error("The parameter 'articleExternalId' cannot be null.");
        else if (articleExternalId !== undefined)
            url_ += "ArticleExternalId=" + encodeURIComponent("" + articleExternalId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (woodProviderExternalId === null)
            throw new Error("The parameter 'woodProviderExternalId' cannot be null.");
        else if (woodProviderExternalId !== undefined)
            url_ += "WoodProviderExternalId=" + encodeURIComponent("" + woodProviderExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (densityGuid === null)
            throw new Error("The parameter 'densityGuid' cannot be null.");
        else if (densityGuid !== undefined)
            url_ += "DensityGuid=" + encodeURIComponent("" + densityGuid) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (includeDeletedOnes === null)
            throw new Error("The parameter 'includeDeletedOnes' cannot be null.");
        else if (includeDeletedOnes !== undefined)
            url_ += "IncludeDeletedOnes=" + encodeURIComponent("" + includeDeletedOnes) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (originExternalId === null)
            throw new Error("The parameter 'originExternalId' cannot be null.");
        else if (originExternalId !== undefined)
            url_ += "OriginExternalId=" + encodeURIComponent("" + originExternalId) + "&";
        if (standExternalId === null)
            throw new Error("The parameter 'standExternalId' cannot be null.");
        else if (standExternalId !== undefined)
            url_ += "StandExternalId=" + encodeURIComponent("" + standExternalId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (singleCustomDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomDeclarationExternalId' cannot be null.");
        else if (singleCustomDeclarationExternalId !== undefined)
            url_ += "SingleCustomDeclarationExternalId=" + encodeURIComponent("" + singleCustomDeclarationExternalId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWoodReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWoodReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodReceiptForReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodReceiptForReportOutput>;
        }));
    }

    protected processGetAllWoodReports(response: HttpResponseBase): Observable<WoodReceiptForReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodReceiptForReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information for generating a samples report according to the input
     * @param reportId (optional) 
     * @param reportNumber (optional) 
     * @param reportSerial (optional) 
     * @param assignmentsampleType (optional) 
     * @param providerVendorExternalId (optional) 
     * @param articleExternalId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param includeDeletedOnes (optional) 
     * @param placeId (optional) 
     * @param operationMode (optional) 
     * @param tenantId (optional) 
     * @param originExternalId (optional) 
     * @param standExternalId (optional) 
     * @param destinationExternalId (optional) 
     * @param singleCustomDeclarationExternalId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllSamples(reportId: number | undefined, reportNumber: number | undefined, reportSerial: string | undefined, assignmentsampleType: SampleAssignmentType | undefined, providerVendorExternalId: number | undefined, articleExternalId: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, includeDeletedOnes: boolean | undefined, placeId: number | undefined, operationMode: ActivityReportOperationMode | undefined, tenantId: number | undefined, originExternalId: number | undefined, standExternalId: number | undefined, destinationExternalId: number | undefined, singleCustomDeclarationExternalId: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<SamplesReportDtoOutput> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAllSamples?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (reportNumber === null)
            throw new Error("The parameter 'reportNumber' cannot be null.");
        else if (reportNumber !== undefined)
            url_ += "ReportNumber=" + encodeURIComponent("" + reportNumber) + "&";
        if (reportSerial === null)
            throw new Error("The parameter 'reportSerial' cannot be null.");
        else if (reportSerial !== undefined)
            url_ += "ReportSerial=" + encodeURIComponent("" + reportSerial) + "&";
        if (assignmentsampleType === null)
            throw new Error("The parameter 'assignmentsampleType' cannot be null.");
        else if (assignmentsampleType !== undefined)
            url_ += "AssignmentsampleType=" + encodeURIComponent("" + assignmentsampleType) + "&";
        if (providerVendorExternalId === null)
            throw new Error("The parameter 'providerVendorExternalId' cannot be null.");
        else if (providerVendorExternalId !== undefined)
            url_ += "ProviderVendorExternalId=" + encodeURIComponent("" + providerVendorExternalId) + "&";
        if (articleExternalId === null)
            throw new Error("The parameter 'articleExternalId' cannot be null.");
        else if (articleExternalId !== undefined)
            url_ += "ArticleExternalId=" + encodeURIComponent("" + articleExternalId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (includeDeletedOnes === null)
            throw new Error("The parameter 'includeDeletedOnes' cannot be null.");
        else if (includeDeletedOnes !== undefined)
            url_ += "IncludeDeletedOnes=" + encodeURIComponent("" + includeDeletedOnes) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (originExternalId === null)
            throw new Error("The parameter 'originExternalId' cannot be null.");
        else if (originExternalId !== undefined)
            url_ += "OriginExternalId=" + encodeURIComponent("" + originExternalId) + "&";
        if (standExternalId === null)
            throw new Error("The parameter 'standExternalId' cannot be null.");
        else if (standExternalId !== undefined)
            url_ += "StandExternalId=" + encodeURIComponent("" + standExternalId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (singleCustomDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomDeclarationExternalId' cannot be null.");
        else if (singleCustomDeclarationExternalId !== undefined)
            url_ += "SingleCustomDeclarationExternalId=" + encodeURIComponent("" + singleCustomDeclarationExternalId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSamples(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSamples(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SamplesReportDtoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SamplesReportDtoOutput>;
        }));
    }

    protected processGetAllSamples(response: HttpResponseBase): Observable<SamplesReportDtoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SamplesReportDtoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information for generating a bark samples report according to the input
     * @param cutServiceVendorId (optional) 
     * @param extractionServiceVendorId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param includeDeletedOnes (optional) 
     * @param placeId (optional) 
     * @param operationMode (optional) 
     * @param tenantId (optional) 
     * @param originExternalId (optional) 
     * @param standExternalId (optional) 
     * @param destinationExternalId (optional) 
     * @param singleCustomDeclarationExternalId (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getAllBarkSamples(cutServiceVendorId: number | undefined, extractionServiceVendorId: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, includeDeletedOnes: boolean | undefined, placeId: number | undefined, operationMode: ActivityReportOperationMode | undefined, tenantId: number | undefined, originExternalId: number | undefined, standExternalId: number | undefined, destinationExternalId: number | undefined, singleCustomDeclarationExternalId: number | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<BarkSamplesReportDtoOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAllBarkSamples?";
        if (cutServiceVendorId === null)
            throw new Error("The parameter 'cutServiceVendorId' cannot be null.");
        else if (cutServiceVendorId !== undefined)
            url_ += "CutServiceVendorId=" + encodeURIComponent("" + cutServiceVendorId) + "&";
        if (extractionServiceVendorId === null)
            throw new Error("The parameter 'extractionServiceVendorId' cannot be null.");
        else if (extractionServiceVendorId !== undefined)
            url_ += "ExtractionServiceVendorId=" + encodeURIComponent("" + extractionServiceVendorId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (includeDeletedOnes === null)
            throw new Error("The parameter 'includeDeletedOnes' cannot be null.");
        else if (includeDeletedOnes !== undefined)
            url_ += "IncludeDeletedOnes=" + encodeURIComponent("" + includeDeletedOnes) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (originExternalId === null)
            throw new Error("The parameter 'originExternalId' cannot be null.");
        else if (originExternalId !== undefined)
            url_ += "OriginExternalId=" + encodeURIComponent("" + originExternalId) + "&";
        if (standExternalId === null)
            throw new Error("The parameter 'standExternalId' cannot be null.");
        else if (standExternalId !== undefined)
            url_ += "StandExternalId=" + encodeURIComponent("" + standExternalId) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (singleCustomDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomDeclarationExternalId' cannot be null.");
        else if (singleCustomDeclarationExternalId !== undefined)
            url_ += "SingleCustomDeclarationExternalId=" + encodeURIComponent("" + singleCustomDeclarationExternalId) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllBarkSamples(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllBarkSamples(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarkSamplesReportDtoOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarkSamplesReportDtoOutput[]>;
        }));
    }

    protected processGetAllBarkSamples(response: HttpResponseBase): Observable<BarkSamplesReportDtoOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BarkSamplesReportDtoOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information for generating a diverse products and internal movements
    report according to the input
     * @param initialDate (optional) Initial day of the report
     * @param endDate (optional) Final day of the report
     * @param tenantId (optional) Tenant id
     * @param includeDeletedOnes (optional) Whether deleted activity reports should be included
     * @return Success
     */
    getAllDiverseProductsAndInternalMovements(initialDate: DateTime | undefined, endDate: DateTime | undefined, tenantId: number | undefined, includeDeletedOnes: boolean | undefined): Observable<DiverseProductsAndInternalMovementsReportOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAllDiverseProductsAndInternalMovements?";
        if (initialDate === null)
            throw new Error("The parameter 'initialDate' cannot be null.");
        else if (initialDate !== undefined)
            url_ += "initialDate=" + encodeURIComponent(initialDate ? "" + initialDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (includeDeletedOnes === null)
            throw new Error("The parameter 'includeDeletedOnes' cannot be null.");
        else if (includeDeletedOnes !== undefined)
            url_ += "includeDeletedOnes=" + encodeURIComponent("" + includeDeletedOnes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDiverseProductsAndInternalMovements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDiverseProductsAndInternalMovements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductsAndInternalMovementsReportOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductsAndInternalMovementsReportOutput[]>;
        }));
    }

    protected processGetAllDiverseProductsAndInternalMovements(response: HttpResponseBase): Observable<DiverseProductsAndInternalMovementsReportOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiverseProductsAndInternalMovementsReportOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information for generating report for diverse products
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param includeDeletedOnes (optional) 
     * @param destinationExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param singleCustomsDeclarationExternalId (optional) 
     * @param contractUsageExternalId (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getDiverseProductsReport(dateFrom: DateTime | undefined, dateTo: DateTime | undefined, includeDeletedOnes: boolean | undefined, destinationExternalId: number | undefined, driverExternalId: number | undefined, transportVendorExternalId: number | undefined, singleCustomsDeclarationExternalId: number | undefined, contractUsageExternalId: number | undefined, placeId: number | undefined): Observable<DiverseProductActivityReportOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetDiverseProductsReport?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (includeDeletedOnes === null)
            throw new Error("The parameter 'includeDeletedOnes' cannot be null.");
        else if (includeDeletedOnes !== undefined)
            url_ += "IncludeDeletedOnes=" + encodeURIComponent("" + includeDeletedOnes) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (singleCustomsDeclarationExternalId === null)
            throw new Error("The parameter 'singleCustomsDeclarationExternalId' cannot be null.");
        else if (singleCustomsDeclarationExternalId !== undefined)
            url_ += "SingleCustomsDeclarationExternalId=" + encodeURIComponent("" + singleCustomsDeclarationExternalId) + "&";
        if (contractUsageExternalId === null)
            throw new Error("The parameter 'contractUsageExternalId' cannot be null.");
        else if (contractUsageExternalId !== undefined)
            url_ += "ContractUsageExternalId=" + encodeURIComponent("" + contractUsageExternalId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DiverseProductActivityReportOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DiverseProductActivityReportOutputDto[]>;
        }));
    }

    protected processGetDiverseProductsReport(response: HttpResponseBase): Observable<DiverseProductActivityReportOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DiverseProductActivityReportOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets internal movements report
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param includeDeletedOnes (optional) 
     * @param placeId (optional) 
     * @param driverExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @return Success
     */
    getInternalMovementsReport(startDate: DateTime | undefined, endDate: DateTime | undefined, includeDeletedOnes: boolean | undefined, placeId: number | undefined, driverExternalId: number | undefined, transportVendorExternalId: number | undefined): Observable<InternalMovementActivityReportOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetInternalMovementsReport?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (includeDeletedOnes === null)
            throw new Error("The parameter 'includeDeletedOnes' cannot be null.");
        else if (includeDeletedOnes !== undefined)
            url_ += "IncludeDeletedOnes=" + encodeURIComponent("" + includeDeletedOnes) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementsReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementsReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalMovementActivityReportOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalMovementActivityReportOutputDto[]>;
        }));
    }

    protected processGetInternalMovementsReport(response: HttpResponseBase): Observable<InternalMovementActivityReportOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InternalMovementActivityReportOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates a report of the loader machine calibrations by date
     * @param initialDate (optional) Initial day of the report
     * @param endDate (optional) Final day of the report
     * @param placeId (optional) Place id
     * @return Success
     */
    getMachineLoaderCalibrations(initialDate: DateTime | undefined, endDate: DateTime | undefined, placeId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetMachineLoaderCalibrations?";
        if (initialDate === null)
            throw new Error("The parameter 'initialDate' cannot be null.");
        else if (initialDate !== undefined)
            url_ += "initialDate=" + encodeURIComponent(initialDate ? "" + initialDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMachineLoaderCalibrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMachineLoaderCalibrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetMachineLoaderCalibrations(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates a report of the calibrations by date
     * @param initialDate (optional) Initial day of the report
     * @param endDate (optional) Final day of the report
     * @param placeId (optional) Place id
     * @return Success
     */
    getAllCalibrations(initialDate: DateTime | undefined, endDate: DateTime | undefined, placeId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAllCalibrations?";
        if (initialDate === null)
            throw new Error("The parameter 'initialDate' cannot be null.");
        else if (initialDate !== undefined)
            url_ += "initialDate=" + encodeURIComponent(initialDate ? "" + initialDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalibrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalibrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetAllCalibrations(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates a report of the wood pre-reports by date
     * @param initialDate (optional) 
     * @param endDate (optional) 
     * @param includeDeletedOnes (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getInformationToPreReportsReportGeneration(initialDate: DateTime | undefined, endDate: DateTime | undefined, includeDeletedOnes: boolean | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfPreWoodActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetInformationToPreReportsReportGeneration?";
        if (initialDate === null)
            throw new Error("The parameter 'initialDate' cannot be null.");
        else if (initialDate !== undefined)
            url_ += "InitialDate=" + encodeURIComponent(initialDate ? "" + initialDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (includeDeletedOnes === null)
            throw new Error("The parameter 'includeDeletedOnes' cannot be null.");
        else if (includeDeletedOnes !== undefined)
            url_ += "IncludeDeletedOnes=" + encodeURIComponent("" + includeDeletedOnes) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformationToPreReportsReportGeneration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformationToPreReportsReportGeneration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPreWoodActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPreWoodActivityReportOutputDto>;
        }));
    }

    protected processGetInformationToPreReportsReportGeneration(response: HttpResponseBase): Observable<PagedResultDtoOfPreWoodActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPreWoodActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates information about pre-reports of diverse product date
     * @param from (optional) Initial day of the report
     * @param to (optional) Final day of the report
     * @param includeDeletedOnes (optional) Whether deleted activity reports should be included
     * @return Success
     */
    getInformationToPreReportDiverseProductReportGeneration(from: DateTime | undefined, to: DateTime | undefined, includeDeletedOnes: boolean | undefined): Observable<PreDiverseProductActivityReportOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetInformationToPreReportDiverseProductReportGeneration?";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toString() : "") + "&";
        if (includeDeletedOnes === null)
            throw new Error("The parameter 'includeDeletedOnes' cannot be null.");
        else if (includeDeletedOnes !== undefined)
            url_ += "includeDeletedOnes=" + encodeURIComponent("" + includeDeletedOnes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInformationToPreReportDiverseProductReportGeneration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInformationToPreReportDiverseProductReportGeneration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreDiverseProductActivityReportOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreDiverseProductActivityReportOutputDto[]>;
        }));
    }

    protected processGetInformationToPreReportDiverseProductReportGeneration(response: HttpResponseBase): Observable<PreDiverseProductActivityReportOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PreDiverseProductActivityReportOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Notifies the system that certain report was generated and sends a user notification.
     * @param body (optional) The information of the generated report
     * @return Success
     */
    notifyReportGenerated(body: ReportgeneratedDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Report/NotifyReportGenerated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyReportGenerated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyReportGenerated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyReportGenerated(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Generates a report of the entry process by date
     * @param initialDate (optional) Initial day of the report
     * @param endDate (optional) Final day of the report
     * @param placeId (optional) Place id
     * @return Success
     */
    getProcessEntryReport(initialDate: DateTime | undefined, endDate: DateTime | undefined, placeId: number | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetProcessEntryReport?";
        if (initialDate === null)
            throw new Error("The parameter 'initialDate' cannot be null.");
        else if (initialDate !== undefined)
            url_ += "initialDate=" + encodeURIComponent(initialDate ? "" + initialDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProcessEntryReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProcessEntryReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetProcessEntryReport(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information for generating a wood activity report logs according to the input
     * @param activityReportId (optional) 
     * @param placeId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @return Success
     */
    getAllWoodLogs(activityReportId: number | undefined, placeId: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined): Observable<WoodActivityReportLogOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Report/GetAllWoodLogs?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "ActivityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllWoodLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllWoodLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportLogOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportLogOutput[]>;
        }));
    }

    protected processGetAllWoodLogs(response: HttpResponseBase): Observable<WoodActivityReportLogOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WoodActivityReportLogOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RoleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all roles by a list of permissions
     * @param permissions (optional) 
     * @return Success
     */
    getRoles(permissions: string[] | undefined): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the role of the given id for edition
     * @param id (optional) 
     * @return Success
     */
    getRoleForEdit(id: number | undefined): Observable<GetRoleForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRoleForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRoleForEditOutput>;
        }));
    }

    protected processGetRoleForEdit(response: HttpResponseBase): Observable<GetRoleForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRoleForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create role or update if role id exists
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateRole(body: CreateOrUpdateRoleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete role
     * @param id (optional) 
     * @return Success
     */
    deleteRole(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get role for place assignment
     * @param key (optional) 
     * @return Success
     */
    getRoleForPlaceAssignment(key: number | undefined): Observable<RoleEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Role/GetRoleForPlaceAssignment?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoleForPlaceAssignment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoleForPlaceAssignment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleEditDto>;
        }));
    }

    protected processGetRoleForPlaceAssignment(response: HttpResponseBase): Observable<RoleEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoleEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assign place to role
     * @param body (optional) 
     * @return Success
     */
    assignPlaceToRole(body: AssignPlaceToRoleInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Role/AssignPlaceToRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignPlaceToRole(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignPlaceToRole(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAssignPlaceToRole(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SampleServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get a sample by it's Id
     * @param sampleId (optional) 
     * @return Success
     */
    getSampleById(sampleId: number | undefined): Observable<ArchimedesSampleInstanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetSampleById?";
        if (sampleId === null)
            throw new Error("The parameter 'sampleId' cannot be null.");
        else if (sampleId !== undefined)
            url_ += "sampleId=" + encodeURIComponent("" + sampleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSampleById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSampleById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchimedesSampleInstanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchimedesSampleInstanceDto>;
        }));
    }

    protected processGetSampleById(response: HttpResponseBase): Observable<ArchimedesSampleInstanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArchimedesSampleInstanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a sample by it's id
     * @param deletionReasonId (optional) 
     * @return Success
     */
    deleteSample(id: number, deletionCommentary: string, deletionReasonId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/DeleteSample?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionCommentary === undefined || deletionCommentary === null)
            throw new Error("The parameter 'deletionCommentary' must be defined and cannot be null.");
        else
            url_ += "DeletionCommentary=" + encodeURIComponent("" + deletionCommentary) + "&";
        if (deletionReasonId === null)
            throw new Error("The parameter 'deletionReasonId' cannot be null.");
        else if (deletionReasonId !== undefined)
            url_ += "DeletionReasonId=" + encodeURIComponent("" + deletionReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteSample(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all the samples by it's receiptId
     * @param woodActivityReportLine (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllSamplesByLineId(woodActivityReportLine: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfArchimedesSampleInstanceOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetAllSamplesByLineId?";
        if (woodActivityReportLine === null)
            throw new Error("The parameter 'woodActivityReportLine' cannot be null.");
        else if (woodActivityReportLine !== undefined)
            url_ += "WoodActivityReportLine=" + encodeURIComponent("" + woodActivityReportLine) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSamplesByLineId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSamplesByLineId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfArchimedesSampleInstanceOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfArchimedesSampleInstanceOutput>;
        }));
    }

    protected processGetAllSamplesByLineId(response: HttpResponseBase): Observable<PagedResultDtoOfArchimedesSampleInstanceOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfArchimedesSampleInstanceOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns an sampling information by id report
     * @param reportId (optional) Activity Report Identifier
     * @return Success
     */
    getSamplingInformationByReportId(reportId: number | undefined): Observable<ArchimedesInformationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetSamplingInformationByReportId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSamplingInformationByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSamplingInformationByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ArchimedesInformationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ArchimedesInformationOutputDto>;
        }));
    }

    protected processGetSamplingInformationByReportId(response: HttpResponseBase): Observable<ArchimedesInformationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ArchimedesInformationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the chip sample information of a given report
     * @param reportId (optional) 
     * @return Success
     */
    getChipSampleByReportId(reportId: number | undefined): Observable<ChipSampleDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetChipSampleByReportId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetChipSampleByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetChipSampleByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChipSampleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChipSampleDto>;
        }));
    }

    protected processGetChipSampleByReportId(response: HttpResponseBase): Observable<ChipSampleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChipSampleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getBarkSamplesByReportId(reportId: number | undefined): Observable<BarkSampleOutputDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetBarkSamplesByReportId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarkSamplesByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarkSamplesByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BarkSampleOutputDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BarkSampleOutputDto[]>;
        }));
    }

    protected processGetBarkSamplesByReportId(response: HttpResponseBase): Observable<BarkSampleOutputDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BarkSampleOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the sample from it's id
     * @param deletionReasonId (optional) 
     * @return Success
     */
    deleteArchimedeSample(id: number, deletionCommentary: string, deletionReasonId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/DeleteArchimedeSample?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined and cannot be null.");
        else
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (deletionCommentary === undefined || deletionCommentary === null)
            throw new Error("The parameter 'deletionCommentary' must be defined and cannot be null.");
        else
            url_ += "DeletionCommentary=" + encodeURIComponent("" + deletionCommentary) + "&";
        if (deletionReasonId === null)
            throw new Error("The parameter 'deletionReasonId' cannot be null.");
        else if (deletionReasonId !== undefined)
            url_ += "DeletionReasonId=" + encodeURIComponent("" + deletionReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteArchimedeSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteArchimedeSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteArchimedeSample(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    forceSamplesRecovery(body: ForceSamplesRecoveryInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/ForceSamplesRecovery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForceSamplesRecovery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForceSamplesRecovery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processForceSamplesRecovery(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculateDensityForSample(body: CalculateDensityDtoInput | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Sample/CalculateDensityForSample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateDensityForSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateDensityForSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCalculateDensityForSample(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param deviceType (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDevicesForSamplingMaintenance(deviceType: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDeviceForSamplingMaintenaceDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetDevicesForSamplingMaintenance?";
        if (deviceType === null)
            throw new Error("The parameter 'deviceType' cannot be null.");
        else if (deviceType !== undefined)
            url_ += "DeviceType=" + encodeURIComponent("" + deviceType) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDevicesForSamplingMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDevicesForSamplingMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDeviceForSamplingMaintenaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDeviceForSamplingMaintenaceDto>;
        }));
    }

    protected processGetDevicesForSamplingMaintenance(response: HttpResponseBase): Observable<PagedResultDtoOfDeviceForSamplingMaintenaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDeviceForSamplingMaintenaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDeviceTypesForSampleMaintenance(): Observable<DeviceTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetDeviceTypesForSampleMaintenance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeviceTypesForSampleMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeviceTypesForSampleMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceTypeDto[]>;
        }));
    }

    protected processGetDeviceTypesForSampleMaintenance(response: HttpResponseBase): Observable<DeviceTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeviceTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getLoaderMachineForMaintenance(id: number | undefined): Observable<LoaderMachineMaintenanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetLoaderMachineForMaintenance?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoaderMachineForMaintenance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoaderMachineForMaintenance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoaderMachineMaintenanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoaderMachineMaintenanceDto>;
        }));
    }

    protected processGetLoaderMachineForMaintenance(response: HttpResponseBase): Observable<LoaderMachineMaintenanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoaderMachineMaintenanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLoaderMachine(body: LoaderMachineMaintenanceDto | undefined): Observable<LoaderMachineMaintenanceDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/UpdateLoaderMachine";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLoaderMachine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLoaderMachine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LoaderMachineMaintenanceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LoaderMachineMaintenanceDto>;
        }));
    }

    protected processUpdateLoaderMachine(response: HttpResponseBase): Observable<LoaderMachineMaintenanceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LoaderMachineMaintenanceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param weightOff (optional) 
     * @param weightSubmerged (optional) 
     * @param zoneId (optional) 
     * @return Success
     */
    getLoaderMachineVolume(weightOff: number | undefined, weightSubmerged: number | undefined, zoneId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetLoaderMachineVolume?";
        if (weightOff === null)
            throw new Error("The parameter 'weightOff' cannot be null.");
        else if (weightOff !== undefined)
            url_ += "weightOff=" + encodeURIComponent("" + weightOff) + "&";
        if (weightSubmerged === null)
            throw new Error("The parameter 'weightSubmerged' cannot be null.");
        else if (weightSubmerged !== undefined)
            url_ += "WeightSubmerged=" + encodeURIComponent("" + weightSubmerged) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoaderMachineVolume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoaderMachineVolume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLoaderMachineVolume(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCube(body: CubeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/UpdateCube";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCube(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCube(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCube(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the lock once a sample is being taken
     * @param activityReportId (optional) The activity report
     * @return Success
     */
    createLockSample(activityReportId: number | undefined): Observable<LockSampleOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/CreateLockSample?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateLockSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateLockSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LockSampleOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LockSampleOutputDto>;
        }));
    }

    protected processCreateLockSample(response: HttpResponseBase): Observable<LockSampleOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LockSampleOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Executes sampling algorithm based on input. Returns whether the entering truck should be sampled.
     * @param body (optional) 
     * @return Success
     */
    shouldBeSampled(body: ShouldBeSampledInputDto | undefined): Observable<ShouldBeSampledOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sample/ShouldBeSampled";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processShouldBeSampled(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processShouldBeSampled(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ShouldBeSampledOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ShouldBeSampledOutput>;
        }));
    }

    protected processShouldBeSampled(response: HttpResponseBase): Observable<ShouldBeSampledOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShouldBeSampledOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validates whether a report should have been sampled but wasn't. Adjusts sample assignments if necessary.
    Executes samples recovery algorithm.
     * @param body (optional) 
     * @return Success
     */
    validateSamplePerformed(body: ValidateSamplePerformedInput | undefined): Observable<ValidateSamplePerformedOutput> {
        let url_ = this.baseUrl + "/api/services/app/Sample/ValidateSamplePerformed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateSamplePerformed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateSamplePerformed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateSamplePerformedOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateSamplePerformedOutput>;
        }));
    }

    protected processValidateSamplePerformed(response: HttpResponseBase): Observable<ValidateSamplePerformedOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateSamplePerformedOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if current user can release sample by report id
     * @param activityReportId (optional) The activity report
     * @return Success
     */
    canReleaseSample(activityReportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Sample/CanReleaseSample?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCanReleaseSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCanReleaseSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCanReleaseSample(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Release the lock once a sample is being taken
     * @param body (optional) Release sample information
     * @return Success
     */
    releaseSample(body: ReleaseSampleInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Sample/ReleaseSample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseSample(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates an archimedes sample instance and assigns it to an activity report based on input.
     * @param body (optional) 
     * @return Success
     */
    saveTakeSample(body: SaveTakeSampleInput | undefined): Observable<SaveTakeSampleResponseDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/SaveTakeSample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveTakeSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveTakeSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SaveTakeSampleResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SaveTakeSampleResponseDto>;
        }));
    }

    protected processSaveTakeSample(response: HttpResponseBase): Observable<SaveTakeSampleResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SaveTakeSampleResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 401) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorResponse.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get sampling zone Id by current session user
     * @return Success
     */
    getSamplingZoneByUser(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Sample/GetSamplingZoneByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSamplingZoneByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSamplingZoneByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetSamplingZoneByUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood activity reports for sample search
     * @param reportId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param sampleType (optional) 
     * @param woodOriginExternalId (optional) 
     * @param standExternalId (optional) 
     * @param reportNumber (optional) 
     * @param reportSerial (optional) 
     * @param woodProviderExternalId (optional) 
     * @param articleExternalId (optional) 
     * @param placeId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchSamples(reportId: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, sampleType: SampleAssignmentType | undefined, woodOriginExternalId: number | undefined, standExternalId: number | undefined, reportNumber: number | undefined, reportSerial: string | undefined, woodProviderExternalId: number | undefined, articleExternalId: number | undefined, placeId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/SearchSamples?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (sampleType === null)
            throw new Error("The parameter 'sampleType' cannot be null.");
        else if (sampleType !== undefined)
            url_ += "SampleType=" + encodeURIComponent("" + sampleType) + "&";
        if (woodOriginExternalId === null)
            throw new Error("The parameter 'woodOriginExternalId' cannot be null.");
        else if (woodOriginExternalId !== undefined)
            url_ += "WoodOriginExternalId=" + encodeURIComponent("" + woodOriginExternalId) + "&";
        if (standExternalId === null)
            throw new Error("The parameter 'standExternalId' cannot be null.");
        else if (standExternalId !== undefined)
            url_ += "StandExternalId=" + encodeURIComponent("" + standExternalId) + "&";
        if (reportNumber === null)
            throw new Error("The parameter 'reportNumber' cannot be null.");
        else if (reportNumber !== undefined)
            url_ += "ReportNumber=" + encodeURIComponent("" + reportNumber) + "&";
        if (reportSerial === null)
            throw new Error("The parameter 'reportSerial' cannot be null.");
        else if (reportSerial !== undefined)
            url_ += "ReportSerial=" + encodeURIComponent("" + reportSerial) + "&";
        if (woodProviderExternalId === null)
            throw new Error("The parameter 'woodProviderExternalId' cannot be null.");
        else if (woodProviderExternalId !== undefined)
            url_ += "WoodProviderExternalId=" + encodeURIComponent("" + woodProviderExternalId) + "&";
        if (articleExternalId === null)
            throw new Error("The parameter 'articleExternalId' cannot be null.");
        else if (articleExternalId !== undefined)
            url_ += "ArticleExternalId=" + encodeURIComponent("" + articleExternalId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchSamples(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchSamples(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto>;
        }));
    }

    protected processSearchSamples(response: HttpResponseBase): Observable<PagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param cutServiceVendorId (optional) 
     * @param extractionServiceVendorId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchBarkSamples(startDate: DateTime | undefined, endDate: DateTime | undefined, originId: number | undefined, standId: number | undefined, cutServiceVendorId: number | undefined, extractionServiceVendorId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfBarkSampleForGridDto> {
        let url_ = this.baseUrl + "/api/services/app/Sample/SearchBarkSamples?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (cutServiceVendorId === null)
            throw new Error("The parameter 'cutServiceVendorId' cannot be null.");
        else if (cutServiceVendorId !== undefined)
            url_ += "CutServiceVendorId=" + encodeURIComponent("" + cutServiceVendorId) + "&";
        if (extractionServiceVendorId === null)
            throw new Error("The parameter 'extractionServiceVendorId' cannot be null.");
        else if (extractionServiceVendorId !== undefined)
            url_ += "ExtractionServiceVendorId=" + encodeURIComponent("" + extractionServiceVendorId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBarkSamples(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBarkSamples(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfBarkSampleForGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfBarkSampleForGridDto>;
        }));
    }

    protected processSearchBarkSamples(response: HttpResponseBase): Observable<PagedResultDtoOfBarkSampleForGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfBarkSampleForGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Exists random statistical sample assigned
     * @param modelId (optional) 
     * @param speciesGroupId (optional) 
     * @param reportEntryDate (optional) 
     * @param placeId (optional) 
     * @param woodOriginExternalId (optional) 
     * @return Success
     */
    existsRandomStatisticalSampleAssigned(modelId: number | undefined, speciesGroupId: number | undefined, reportEntryDate: DateTime | undefined, placeId: number | undefined, woodOriginExternalId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Sample/ExistsRandomStatisticalSampleAssigned?";
        if (modelId === null)
            throw new Error("The parameter 'modelId' cannot be null.");
        else if (modelId !== undefined)
            url_ += "ModelId=" + encodeURIComponent("" + modelId) + "&";
        if (speciesGroupId === null)
            throw new Error("The parameter 'speciesGroupId' cannot be null.");
        else if (speciesGroupId !== undefined)
            url_ += "SpeciesGroupId=" + encodeURIComponent("" + speciesGroupId) + "&";
        if (reportEntryDate === null)
            throw new Error("The parameter 'reportEntryDate' cannot be null.");
        else if (reportEntryDate !== undefined)
            url_ += "ReportEntryDate=" + encodeURIComponent(reportEntryDate ? "" + reportEntryDate.toString() : "") + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (woodOriginExternalId === null)
            throw new Error("The parameter 'woodOriginExternalId' cannot be null.");
        else if (woodOriginExternalId !== undefined)
            url_ += "WoodOriginExternalId=" + encodeURIComponent("" + woodOriginExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistsRandomStatisticalSampleAssigned(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistsRandomStatisticalSampleAssigned(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExistsRandomStatisticalSampleAssigned(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScaleCalibrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add or update scale calibration instance
     * @param body (optional) Scale calibration instance information
     * @return Success
     */
    addOrUpdateInstance(body: AddOrUpdateScaleCalibrationInstanceInputDto | undefined): Observable<ScaleCalibrationInstanceDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScaleCalibration/AddOrUpdateInstance";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddOrUpdateInstance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddOrUpdateInstance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleCalibrationInstanceDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleCalibrationInstanceDto[]>;
        }));
    }

    protected processAddOrUpdateInstance(response: HttpResponseBase): Observable<ScaleCalibrationInstanceDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScaleCalibrationInstanceDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new scale calibration for current place
     * @param licensePlate (optional) 
     * @return Success
     */
    createForCurrentPlace(licensePlate: string | undefined): Observable<ScaleCalibrationDto> {
        let url_ = this.baseUrl + "/api/services/app/ScaleCalibration/CreateForCurrentPlace?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateForCurrentPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateForCurrentPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleCalibrationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleCalibrationDto>;
        }));
    }

    protected processCreateForCurrentPlace(response: HttpResponseBase): Observable<ScaleCalibrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleCalibrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Finish scale calibration
     * @param id (optional) Scale calibration id
     * @return Success
     */
    finish(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScaleCalibration/Finish?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get scale calibration by id
     * @param id (optional) Scale calibration id
     * @return Success
     */
    getById(id: number | undefined): Observable<ScaleCalibrationDto> {
        let url_ = this.baseUrl + "/api/services/app/ScaleCalibration/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScaleCalibrationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScaleCalibrationDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ScaleCalibrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScaleCalibrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scale calibrations
     * @param id (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param stateFilter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(id: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, stateFilter: ScaleCalibrationStateFilter | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfScaleCalibrationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ScaleCalibration/GetAll?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (stateFilter === null)
            throw new Error("The parameter 'stateFilter' cannot be null.");
        else if (stateFilter !== undefined)
            url_ += "StateFilter=" + encodeURIComponent("" + stateFilter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfScaleCalibrationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfScaleCalibrationForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfScaleCalibrationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfScaleCalibrationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information for generating a scale calibration report according to the input
     * @param body (optional) Information of the filters to apply
     * @return Success
     */
    generateScaleCalibrationReport(body: ScaleCalibrationReportInputDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ScaleCalibration/GenerateScaleCalibrationReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateScaleCalibrationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateScaleCalibrationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGenerateScaleCalibrationReport(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScannerCalibrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add a new scanner calibration
     * @param scannerDeviceId (optional) Scanner device id
     * @return Success
     */
    addScannerCalibration(scannerDeviceId: number | undefined): Observable<ScannerCalibrationDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/AddScannerCalibration?";
        if (scannerDeviceId === null)
            throw new Error("The parameter 'scannerDeviceId' cannot be null.");
        else if (scannerDeviceId !== undefined)
            url_ += "scannerDeviceId=" + encodeURIComponent("" + scannerDeviceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddScannerCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddScannerCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCalibrationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCalibrationDto>;
        }));
    }

    protected processAddScannerCalibration(response: HttpResponseBase): Observable<ScannerCalibrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerCalibrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new event to scanner calibration
     * @param body (optional) Scanner calibration event information
     * @return Success
     */
    addCalibrationEvent(body: AddNewScannerCalibrationEventDto | undefined): Observable<ScannerCalibrationEventDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/AddCalibrationEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCalibrationEvent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCalibrationEvent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCalibrationEventDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCalibrationEventDto>;
        }));
    }

    protected processAddCalibrationEvent(response: HttpResponseBase): Observable<ScannerCalibrationEventDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerCalibrationEventDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get scanner calibration by id
     * @param scannerCalibrationId (optional) Scanner calibration id
     * @return Success
     */
    getScannerCalibration(scannerCalibrationId: number | undefined): Observable<ScannerCalibrationDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/GetScannerCalibration?";
        if (scannerCalibrationId === null)
            throw new Error("The parameter 'scannerCalibrationId' cannot be null.");
        else if (scannerCalibrationId !== undefined)
            url_ += "scannerCalibrationId=" + encodeURIComponent("" + scannerCalibrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannerCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannerCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCalibrationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCalibrationDto>;
        }));
    }

    protected processGetScannerCalibration(response: HttpResponseBase): Observable<ScannerCalibrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerCalibrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanner calibration events by scanner calibration id
     * @param scannerCalibrationId (optional) Scanner calibration id
     * @return Success
     */
    getAllEventsByCalibrationId(scannerCalibrationId: number | undefined): Observable<ScannerCalibrationEventDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/GetAllEventsByCalibrationId?";
        if (scannerCalibrationId === null)
            throw new Error("The parameter 'scannerCalibrationId' cannot be null.");
        else if (scannerCalibrationId !== undefined)
            url_ += "scannerCalibrationId=" + encodeURIComponent("" + scannerCalibrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllEventsByCalibrationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllEventsByCalibrationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCalibrationEventDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCalibrationEventDto[]>;
        }));
    }

    protected processGetAllEventsByCalibrationId(response: HttpResponseBase): Observable<ScannerCalibrationEventDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScannerCalibrationEventDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanner calibrations
     * @param id (optional) 
     * @param scannerDeviceId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param state (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllScannerCalibrations(id: number | undefined, scannerDeviceId: number | undefined, startDate: DateTime | undefined, endDate: DateTime | undefined, state: ScannerCalibrationStateFilter | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfScannerCalibrationForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/GetAllScannerCalibrations?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (scannerDeviceId === null)
            throw new Error("The parameter 'scannerDeviceId' cannot be null.");
        else if (scannerDeviceId !== undefined)
            url_ += "ScannerDeviceId=" + encodeURIComponent("" + scannerDeviceId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScannerCalibrations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScannerCalibrations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfScannerCalibrationForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfScannerCalibrationForViewDto>;
        }));
    }

    protected processGetAllScannerCalibrations(response: HttpResponseBase): Observable<PagedResultDtoOfScannerCalibrationForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfScannerCalibrationForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Finish scanner calibration by id
     * @param scannerCalibrationId (optional) Scanner calibration id
     * @return Success
     */
    finishScannerCalibration(scannerCalibrationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/FinishScannerCalibration?";
        if (scannerCalibrationId === null)
            throw new Error("The parameter 'scannerCalibrationId' cannot be null.");
        else if (scannerCalibrationId !== undefined)
            url_ += "scannerCalibrationId=" + encodeURIComponent("" + scannerCalibrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinishScannerCalibration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinishScannerCalibration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFinishScannerCalibration(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information for generating a scanner calibration report according to the input
     * @param body (optional) Information of the filters to apply
     * @return Success
     */
    generateScannerCalibrationReport(body: ScannerCalibreationReportInputDto | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/GenerateScannerCalibrationReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGenerateScannerCalibrationReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGenerateScannerCalibrationReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGenerateScannerCalibrationReport(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add scanner calibration attachment to scanner calibration
     * @param body (optional) Scanner calibration attachment information
     * @return Success
     */
    addScannerCalibrationAttachment(body: AddScannerCalibrationAttachmentDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/AddScannerCalibrationAttachment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddScannerCalibrationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddScannerCalibrationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddScannerCalibrationAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get scanner calibration attachment by scanner calibration id
     * @param scannerCalibrationId (optional) Scanner calibration id
     * @return Success
     */
    getScannerCalibrationAttachment(scannerCalibrationId: number | undefined): Observable<ScannerCalibrationAttachmentDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/GetScannerCalibrationAttachment?";
        if (scannerCalibrationId === null)
            throw new Error("The parameter 'scannerCalibrationId' cannot be null.");
        else if (scannerCalibrationId !== undefined)
            url_ += "scannerCalibrationId=" + encodeURIComponent("" + scannerCalibrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannerCalibrationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannerCalibrationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCalibrationAttachmentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCalibrationAttachmentDto>;
        }));
    }

    protected processGetScannerCalibrationAttachment(response: HttpResponseBase): Observable<ScannerCalibrationAttachmentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerCalibrationAttachmentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete scanner calibration attachment to scanner calibration
     * @param scannerCalibrationId (optional) Scanner calibration id
     * @return Success
     */
    deleteScannerCalibrationAttachment(scannerCalibrationId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ScannerCalibration/DeleteScannerCalibrationAttachment?";
        if (scannerCalibrationId === null)
            throw new Error("The parameter 'scannerCalibrationId' cannot be null.");
        else if (scannerCalibrationId !== undefined)
            url_ += "scannerCalibrationId=" + encodeURIComponent("" + scannerCalibrationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScannerCalibrationAttachment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScannerCalibrationAttachment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteScannerCalibrationAttachment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScannerIndicatorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get's the current scanner status by current place
     * @return Success
     */
    getScannerStatusIndicatorByCurrentPlace(): Observable<DeviceIsActiveIndicatorDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerIndicator/GetScannerStatusIndicatorByCurrentPlace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannerStatusIndicatorByCurrentPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannerStatusIndicatorByCurrentPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeviceIsActiveIndicatorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeviceIsActiveIndicatorDto>;
        }));
    }

    protected processGetScannerStatusIndicatorByCurrentPlace(response: HttpResponseBase): Observable<DeviceIsActiveIndicatorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeviceIsActiveIndicatorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the number of scannable wood receipt in the last hours. The receipts
    must have a signal sent and model id other than zero.
     * @return Success
     */
    getScannableByHours(): Observable<ScannerCountOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerIndicator/GetScannableByHours";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannableByHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannableByHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCountOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCountOutputDto>;
        }));
    }

    protected processGetScannableByHours(response: HttpResponseBase): Observable<ScannerCountOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerCountOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the number of scanned wood receipt in the last hours. The receipts
    must have an 'event approved' result and have a model id other than zero.
     * @return Success
     */
    getScannedByHours(): Observable<ScannerCountOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerIndicator/GetScannedByHours";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannedByHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannedByHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCountOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCountOutputDto>;
        }));
    }

    protected processGetScannedByHours(response: HttpResponseBase): Observable<ScannerCountOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerCountOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the number of scanned with errors wood receipt in the last hours. The receipts
    must not have signal sent or the result must be different from 'event approved'
     * @return Success
     */
    getScannerErrors(): Observable<ScannerCountOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerIndicator/GetScannerErrors";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannerErrors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannerErrors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerCountOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerCountOutputDto>;
        }));
    }

    protected processGetScannerErrors(response: HttpResponseBase): Observable<ScannerCountOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerCountOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the percentage of scannable receipts that were scanned without errors, in the last hours.
     * @return Success
     */
    getPercentageLastHours(): Observable<ScannerPercentageOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerIndicator/GetPercentageLastHours";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPercentageLastHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPercentageLastHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerPercentageOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerPercentageOutputDto>;
        }));
    }

    protected processGetPercentageLastHours(response: HttpResponseBase): Observable<ScannerPercentageOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerPercentageOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the percentage of scanned receipts that were 'to pay' without errors, in the last hours. 'To pay' receipts
    have scanner measurement type.
     * @param hours (optional) 
     * @return Success
     */
    getScannedOkVSToPayByHours(hours: number | undefined): Observable<ScannerPercentageOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/ScannerIndicator/GetScannedOkVSToPayByHours?";
        if (hours === null)
            throw new Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "hours=" + encodeURIComponent("" + hours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannedOkVSToPayByHours(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannedOkVSToPayByHours(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerPercentageOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerPercentageOutputDto>;
        }));
    }

    protected processGetScannedOkVSToPayByHours(response: HttpResponseBase): Observable<ScannerPercentageOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerPercentageOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ScheduledTurnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Schedule an entry time in smart access
     * @param reportId (optional) Report id from receipt
     * @param entryTime (optional) The entry time
     * @return Success
     */
    scheduleEntryTime(reportId: number | undefined, entryTime: DateTime | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledTurn/ScheduleEntryTime?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (entryTime === null)
            throw new Error("The parameter 'entryTime' cannot be null.");
        else if (entryTime !== undefined)
            url_ += "entryTime=" + encodeURIComponent(entryTime ? "" + entryTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScheduleEntryTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScheduleEntryTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processScheduleEntryTime(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a turn in smart access
     * @param reportId (optional) The report id from receipt
     * @param entryTime (optional) The new entry time
     * @return Success
     */
    updateScheduledEntryTime(reportId: number | undefined, entryTime: DateTime | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledTurn/UpdateScheduledEntryTime?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (entryTime === null)
            throw new Error("The parameter 'entryTime' cannot be null.");
        else if (entryTime !== undefined)
            url_ += "entryTime=" + encodeURIComponent(entryTime ? "" + entryTime.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateScheduledEntryTime(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateScheduledEntryTime(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processUpdateScheduledEntryTime(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the available turns for the provider
     * @param reportId (optional) The report id from receipt
     * @return Success
     */
    getTurnsWithAvailableQuotaForReportVendorId(reportId: number | undefined): Observable<AvailableTurnTimeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ScheduledTurn/GetTurnsWithAvailableQuotaForReportVendorId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTurnsWithAvailableQuotaForReportVendorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTurnsWithAvailableQuotaForReportVendorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AvailableTurnTimeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AvailableTurnTimeDto[]>;
        }));
    }

    protected processGetTurnsWithAvailableQuotaForReportVendorId(response: HttpResponseBase): Observable<AvailableTurnTimeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableTurnTimeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get Service Number Configuration by Id
     * @param id (optional) Service number configuration id
     * @return Success
     */
    getById(id: number | undefined): Observable<ServiceConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConfiguration/GetById?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceConfigurationDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<ServiceConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new Service Number Configuration
     * @param body (optional) Service number configuration information
     * @return Success
     */
    create(body: CreateServiceConfigurationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConfiguration/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing Service Number Configuration
     * @param body (optional) Service number configuration information
     * @return Success
     */
    update(body: UpdateServiceConfigurationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConfiguration/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Service Number Configurations with pagination
     * @param externalArticleId (optional) 
     * @param externalInvoiceServiceId (optional) 
     * @param originId (optional) 
     * @param externalDestinationId (optional) 
     * @param serviceType (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(externalArticleId: number | undefined, externalInvoiceServiceId: number | undefined, originId: number | undefined, externalDestinationId: number | undefined, serviceType: ServiceType | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfServiceConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConfiguration/GetAll?";
        if (externalArticleId === null)
            throw new Error("The parameter 'externalArticleId' cannot be null.");
        else if (externalArticleId !== undefined)
            url_ += "ExternalArticleId=" + encodeURIComponent("" + externalArticleId) + "&";
        if (externalInvoiceServiceId === null)
            throw new Error("The parameter 'externalInvoiceServiceId' cannot be null.");
        else if (externalInvoiceServiceId !== undefined)
            url_ += "ExternalInvoiceServiceId=" + encodeURIComponent("" + externalInvoiceServiceId) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (externalDestinationId === null)
            throw new Error("The parameter 'externalDestinationId' cannot be null.");
        else if (externalDestinationId !== undefined)
            url_ += "ExternalDestinationId=" + encodeURIComponent("" + externalDestinationId) + "&";
        if (serviceType === null)
            throw new Error("The parameter 'serviceType' cannot be null.");
        else if (serviceType !== undefined)
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfServiceConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfServiceConfigurationDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfServiceConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfServiceConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete a Service configuration by Id
     * @param id (optional) Service configuration id
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConfiguration/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param originId (optional) 
     * @param externalDestinationId (optional) 
     * @param externalArticleId (optional) 
     * @return Success
     */
    getServiceConfigurations(originId: number | undefined, externalDestinationId: number | undefined, externalArticleId: number | undefined): Observable<ServiceConfigurationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ServiceConfiguration/GetServiceConfigurations?";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (externalDestinationId === null)
            throw new Error("The parameter 'externalDestinationId' cannot be null.");
        else if (externalDestinationId !== undefined)
            url_ += "ExternalDestinationId=" + encodeURIComponent("" + externalDestinationId) + "&";
        if (externalArticleId === null)
            throw new Error("The parameter 'externalArticleId' cannot be null.");
        else if (externalArticleId !== undefined)
            url_ += "ExternalArticleId=" + encodeURIComponent("" + externalArticleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetServiceConfigurations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetServiceConfigurations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceConfigurationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceConfigurationDto[]>;
        }));
    }

    protected processGetServiceConfigurations(response: HttpResponseBase): Observable<ServiceConfigurationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ServiceConfigurationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceEntrySheetServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    saveServiceEntrySheetInformation(body: SaveServiceEntrySheetInformationInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/ServiceEntrySheet/SaveServiceEntrySheetInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveServiceEntrySheetInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveServiceEntrySheetInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveServiceEntrySheetInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceProviderConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Retrieves active service provider configuration.
     * @param placeId (optional) 
     * @param serviceType (optional) 
     * @return Success
     */
    getActiveServiceProviderConfiguration(placeId: number | undefined, serviceType: ServiceType | undefined): Observable<ServiceProviderConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/ServiceProviderConfiguration/GetActiveServiceProviderConfiguration?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        if (serviceType === null)
            throw new Error("The parameter 'serviceType' cannot be null.");
        else if (serviceType !== undefined)
            url_ += "serviceType=" + encodeURIComponent("" + serviceType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveServiceProviderConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveServiceProviderConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ServiceProviderConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ServiceProviderConfigurationDto>;
        }));
    }

    protected processGetActiveServiceProviderConfiguration(response: HttpResponseBase): Observable<ServiceProviderConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceProviderConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Success", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SessionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getCurrentLoginInformations(): Observable<GetCurrentLoginInformationsOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentLoginInformations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCurrentLoginInformationsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCurrentLoginInformationsOutput>;
        }));
    }

    protected processGetCurrentLoginInformations(response: HttpResponseBase): Observable<GetCurrentLoginInformationsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCurrentLoginInformationsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    updateUserSignInToken(): Observable<UpdateUserSignInTokenOutput> {
        let url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSignInToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserSignInTokenOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserSignInTokenOutput>;
        }));
    }

    protected processUpdateUserSignInToken(response: HttpResponseBase): Observable<UpdateUserSignInTokenOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserSignInTokenOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SingleCustomsDeclarationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Validate if net weight with net weight's of another receipts with the same singleCustomDeclarationId is minor than max weight
     * @param netWeight (optional) 
     * @param maxWeightSingleCustomDeclaration (optional) 
     * @param duaId (optional) 
     * @return Success
     */
    validateSingleCustomDeclarationMaxTons(netWeight: number | undefined, maxWeightSingleCustomDeclaration: number | undefined, duaId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SingleCustomsDeclaration/ValidateSingleCustomDeclarationMaxTons?";
        if (netWeight === null)
            throw new Error("The parameter 'netWeight' cannot be null.");
        else if (netWeight !== undefined)
            url_ += "netWeight=" + encodeURIComponent("" + netWeight) + "&";
        if (maxWeightSingleCustomDeclaration === null)
            throw new Error("The parameter 'maxWeightSingleCustomDeclaration' cannot be null.");
        else if (maxWeightSingleCustomDeclaration !== undefined)
            url_ += "maxWeightSingleCustomDeclaration=" + encodeURIComponent("" + maxWeightSingleCustomDeclaration) + "&";
        if (duaId === null)
            throw new Error("The parameter 'duaId' cannot be null.");
        else if (duaId !== undefined)
            url_ += "duaId=" + encodeURIComponent("" + duaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateSingleCustomDeclarationMaxTons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateSingleCustomDeclarationMaxTons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateSingleCustomDeclarationMaxTons(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Validate if current single customs declaration weight exceeds max weight
     * @param maxWeightSingleCustomDeclaration (optional) 
     * @param duaId (optional) 
     * @return Success
     */
    validateDuaMaxTonsDiverseProductsEntrance(maxWeightSingleCustomDeclaration: number | undefined, duaId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/SingleCustomsDeclaration/ValidateDuaMaxTonsDiverseProductsEntrance?";
        if (maxWeightSingleCustomDeclaration === null)
            throw new Error("The parameter 'maxWeightSingleCustomDeclaration' cannot be null.");
        else if (maxWeightSingleCustomDeclaration !== undefined)
            url_ += "maxWeightSingleCustomDeclaration=" + encodeURIComponent("" + maxWeightSingleCustomDeclaration) + "&";
        if (duaId === null)
            throw new Error("The parameter 'duaId' cannot be null.");
        else if (duaId !== undefined)
            url_ += "duaId=" + encodeURIComponent("" + duaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateDuaMaxTonsDiverseProductsEntrance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateDuaMaxTonsDiverseProductsEntrance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processValidateDuaMaxTonsDiverseProductsEntrance(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param singleCustomsDeclarationId (optional) 
     * @return Success
     */
    getSingleCustomsDeclarationUsedWeight(singleCustomsDeclarationId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/SingleCustomsDeclaration/GetSingleCustomsDeclarationUsedWeight?";
        if (singleCustomsDeclarationId === null)
            throw new Error("The parameter 'singleCustomsDeclarationId' cannot be null.");
        else if (singleCustomsDeclarationId !== undefined)
            url_ += "singleCustomsDeclarationId=" + encodeURIComponent("" + singleCustomsDeclarationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSingleCustomsDeclarationUsedWeight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSingleCustomsDeclarationUsedWeight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetSingleCustomsDeclarationUsedWeight(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SmartInvoicingActivityReportConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param activityReportType (optional) 
     * @return Success
     */
    getActivityReportPrefixByActivityReportType(activityReportType: ActivityReportType | undefined): Observable<SmartInvoicingActivityReportPrefixDto> {
        let url_ = this.baseUrl + "/api/services/app/SmartInvoicingActivityReportConfiguration/GetActivityReportPrefixByActivityReportType?";
        if (activityReportType === null)
            throw new Error("The parameter 'activityReportType' cannot be null.");
        else if (activityReportType !== undefined)
            url_ += "activityReportType=" + encodeURIComponent("" + activityReportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActivityReportPrefixByActivityReportType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActivityReportPrefixByActivityReportType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartInvoicingActivityReportPrefixDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartInvoicingActivityReportPrefixDto>;
        }));
    }

    protected processGetActivityReportPrefixByActivityReportType(response: HttpResponseBase): Observable<SmartInvoicingActivityReportPrefixDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SmartInvoicingActivityReportPrefixDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StandServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param standId (optional) 
     * @param articleId (optional) 
     * @param usesScanner (optional) 
     * @param date (optional) 
     * @return Success
     */
    getStandDensity(standId: number | undefined, articleId: number | undefined, usesScanner: boolean | undefined, date: DateTime | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Stand/GetStandDensity?";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (usesScanner === null)
            throw new Error("The parameter 'usesScanner' cannot be null.");
        else if (usesScanner !== undefined)
            url_ += "UsesScanner=" + encodeURIComponent("" + usesScanner) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent(date ? "" + date.toString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStandDensity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStandDensity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetStandDensity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getStandDensityByReportId(reportId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Stand/GetStandDensityByReportId?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStandDensityByReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStandDensityByReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetStandDensityByReportId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class StripePaymentServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getConfiguration(): Observable<StripeConfigurationDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfiguration(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfiguration(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripeConfigurationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripeConfigurationDto>;
        }));
    }

    protected processGetConfiguration(response: HttpResponseBase): Observable<StripeConfigurationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripeConfigurationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param stripeSessionId (optional) 
     * @return Success
     */
    getPayment(stripeSessionId: string | undefined): Observable<SubscriptionPaymentDto> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPayment?";
        if (stripeSessionId === null)
            throw new Error("The parameter 'stripeSessionId' cannot be null.");
        else if (stripeSessionId !== undefined)
            url_ += "StripeSessionId=" + encodeURIComponent("" + stripeSessionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubscriptionPaymentDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubscriptionPaymentDto>;
        }));
    }

    protected processGetPayment(response: HttpResponseBase): Observable<SubscriptionPaymentDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionPaymentDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createPaymentSession(body: StripeCreatePaymentSessionInput | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/CreatePaymentSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatePaymentSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatePaymentSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreatePaymentSession(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentId (optional) 
     * @return Success
     */
    getPaymentResult(paymentId: number | undefined): Observable<StripePaymentResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/StripePayment/GetPaymentResult?";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "PaymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPaymentResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPaymentResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<StripePaymentResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<StripePaymentResultOutput>;
        }));
    }

    protected processGetPaymentResult(response: HttpResponseBase): Observable<StripePaymentResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StripePaymentResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SubscriptionServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    disableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    enableRecurringPayments(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnableRecurringPayments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnableRecurringPayments(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SynchronizationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all zones
     * @return Success
     */
    getAllZones(): Observable<PagedResultDtoOfZonesDto> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfZonesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfZonesDto>;
        }));
    }

    protected processGetAllZones(response: HttpResponseBase): Observable<PagedResultDtoOfZonesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfZonesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all devices
     * @return Success
     */
    getAllDevices(): Observable<DevicesDtoOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllDevices";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDevices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDevices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DevicesDtoOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DevicesDtoOutput[]>;
        }));
    }

    protected processGetAllDevices(response: HttpResponseBase): Observable<DevicesDtoOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DevicesDtoOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all Places
     * @return Success
     */
    getAllPlaces(): Observable<PagedResultDtoOfPlaceDto> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllPlaces";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlaces(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlaces(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPlaceDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPlaceDto>;
        }));
    }

    protected processGetAllPlaces(response: HttpResponseBase): Observable<PagedResultDtoOfPlaceDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPlaceDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all package counts combinations
     * @return Success
     */
    getAllPackageCount(): Observable<PackageCountOutput[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllPackageCount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPackageCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPackageCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PackageCountOutput[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PackageCountOutput[]>;
        }));
    }

    protected processGetAllPackageCount(response: HttpResponseBase): Observable<PackageCountOutput[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PackageCountOutput.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * GetAll reasons
     * @return Success
     */
    getAllReasons(): Observable<ReasonDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllReasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllReasons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllReasons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ReasonDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ReasonDto[]>;
        }));
    }

    protected processGetAllReasons(response: HttpResponseBase): Observable<ReasonDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReasonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all places to switch by userId
     * @param userId (optional) 
     * @return Success
     */
    getAllPlacesToSwitchByUser(userId: number | undefined): Observable<PlaceToSwitchItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllPlacesToSwitchByUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPlacesToSwitchByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPlacesToSwitchByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PlaceToSwitchItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PlaceToSwitchItemDto[]>;
        }));
    }

    protected processGetAllPlacesToSwitchByUser(response: HttpResponseBase): Observable<PlaceToSwitchItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaceToSwitchItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all system parameters
     * @return Success
     */
    getAllParameters(): Observable<ParameterDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllParameters";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterDto[]>;
        }));
    }

    protected processGetAllParameters(response: HttpResponseBase): Observable<ParameterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanner bank quantities
     * @return Success
     */
    getAllScannerBankQuantities(): Observable<ScannerBankQuantityDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllScannerBankQuantities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScannerBankQuantities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScannerBankQuantities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerBankQuantityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerBankQuantityDto[]>;
        }));
    }

    protected processGetAllScannerBankQuantities(response: HttpResponseBase): Observable<ScannerBankQuantityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScannerBankQuantityDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanner factor types
     * @return Success
     */
    getAllScannerFactorTypes(): Observable<ScannerFactorTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllScannerFactorTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScannerFactorTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScannerFactorTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerFactorTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerFactorTypeDto[]>;
        }));
    }

    protected processGetAllScannerFactorTypes(response: HttpResponseBase): Observable<ScannerFactorTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScannerFactorTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanner lengths
     * @return Success
     */
    getAllScannerLengths(): Observable<ScannerLengthDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllScannerLengths";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScannerLengths(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScannerLengths(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerLengthDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerLengthDto[]>;
        }));
    }

    protected processGetAllScannerLengths(response: HttpResponseBase): Observable<ScannerLengthDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScannerLengthDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanner species
     * @return Success
     */
    getAllScannerSpecies(): Observable<ScannerSpecieDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllScannerSpecies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScannerSpecies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScannerSpecies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerSpecieDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerSpecieDto[]>;
        }));
    }

    protected processGetAllScannerSpecies(response: HttpResponseBase): Observable<ScannerSpecieDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScannerSpecieDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanner truck types
     * @return Success
     */
    getAllScannerTruckTypes(): Observable<ScannerTruckTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllScannerTruckTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScannerTruckTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScannerTruckTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerTruckTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerTruckTypeDto[]>;
        }));
    }

    protected processGetAllScannerTruckTypes(response: HttpResponseBase): Observable<ScannerTruckTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ScannerTruckTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all scanner provider contracts
     * @return Success
     */
    getAllScannerProviderContracts(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllScannerProviderContracts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllScannerProviderContracts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllScannerProviderContracts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetAllScannerProviderContracts(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the piles
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllPiles(sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfPileDto> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllPiles?";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfPileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfPileDto>;
        }));
    }

    protected processGetAllPiles(response: HttpResponseBase): Observable<PagedResultDtoOfPileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfPileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all system roles
     * @return Success
     */
    getAllRoles(): Observable<ListResultDtoOfRoleListDto> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfRoleListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfRoleListDto>;
        }));
    }

    protected processGetAllRoles(response: HttpResponseBase): Observable<ListResultDtoOfRoleListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfRoleListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all densities
     * @return Success
     */
    getAllDensities(): Observable<ListResultDtoOfDensityPerSpeciesGroupDto> {
        let url_ = this.baseUrl + "/api/services/app/Synchronization/GetAllDensities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllDensities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllDensities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfDensityPerSpeciesGroupDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfDensityPerSpeciesGroupDto>;
        }));
    }

    protected processGetAllDensities(response: HttpResponseBase): Observable<ListResultDtoOfDensityPerSpeciesGroupDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfDensityPerSpeciesGroupDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TagServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param includeDisabled (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(includeDisabled: boolean | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetTagForViewDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetAll?";
        if (includeDisabled === null)
            throw new Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "IncludeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetTagForViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetTagForViewDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfGetTagForViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetTagForViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    get(id: number | undefined): Observable<TagDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagDto>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    create(body: CreateTagInputDto | undefined): Observable<CreateTagOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTagOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTagOutputDto>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateTagOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTagOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    update(body: UpdateTagInputDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tag/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    delete(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tag/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves information about tag number. Checks if exists and get its related information
     * @param tag (optional) 
     * @param zoneId (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getTagInformationForTruckEntry(tag: number | undefined, zoneId: number | undefined, placeId: number | undefined): Observable<NewTagDetectionOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetTagInformationForTruckEntry?";
        if (tag === null)
            throw new Error("The parameter 'tag' cannot be null.");
        else if (tag !== undefined)
            url_ += "Tag=" + encodeURIComponent("" + tag) + "&";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "ZoneId=" + encodeURIComponent("" + zoneId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagInformationForTruckEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagInformationForTruckEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NewTagDetectionOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NewTagDetectionOutputDto>;
        }));
    }

    protected processGetTagInformationForTruckEntry(response: HttpResponseBase): Observable<NewTagDetectionOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NewTagDetectionOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param includeDisabled (optional) 
     * @return Success
     */
    getTagsForExporting(includeDisabled: boolean | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetTagsForExporting?";
        if (includeDisabled === null)
            throw new Error("The parameter 'includeDisabled' cannot be null.");
        else if (includeDisabled !== undefined)
            url_ += "includeDisabled=" + encodeURIComponent("" + includeDisabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagsForExporting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagsForExporting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetTagsForExporting(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves information about the tag number according to the license plate received.
     * @param licensePlate (optional) 
     * @return Success
     */
    getActiveTagByLicensePlate(licensePlate: string | undefined): Observable<GetActiveTagByLicensePlateOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetActiveTagByLicensePlate?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveTagByLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveTagByLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetActiveTagByLicensePlateOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetActiveTagByLicensePlateOutputDto>;
        }));
    }

    protected processGetActiveTagByLicensePlate(response: HttpResponseBase): Observable<GetActiveTagByLicensePlateOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetActiveTagByLicensePlateOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns information by tagValue
     * @param tagValue (optional) 
     * @return Success
     */
    getTagInformation(tagValue: number | undefined): Observable<TagInformationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Tag/GetTagInformation?";
        if (tagValue === null)
            throw new Error("The parameter 'tagValue' cannot be null.");
        else if (tagValue !== undefined)
            url_ += "tagValue=" + encodeURIComponent("" + tagValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTagInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTagInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagInformationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagInformationOutputDto>;
        }));
    }

    protected processGetTagInformation(response: HttpResponseBase): Observable<TagInformationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagInformationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param filter (optional) 
     * @param subscriptionEndDateStart (optional) 
     * @param subscriptionEndDateEnd (optional) 
     * @param creationDateStart (optional) 
     * @param creationDateEnd (optional) 
     * @param editionId (optional) 
     * @param editionIdSpecified (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getTenants(filter: string | undefined, subscriptionEndDateStart: DateTime | undefined, subscriptionEndDateEnd: DateTime | undefined, creationDateStart: DateTime | undefined, creationDateEnd: DateTime | undefined, editionId: number | undefined, editionIdSpecified: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfTenantListDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart === null)
            throw new Error("The parameter 'subscriptionEndDateStart' cannot be null.");
        else if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toString() : "") + "&";
        if (subscriptionEndDateEnd === null)
            throw new Error("The parameter 'subscriptionEndDateEnd' cannot be null.");
        else if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toString() : "") + "&";
        if (creationDateStart === null)
            throw new Error("The parameter 'creationDateStart' cannot be null.");
        else if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toString() : "") + "&";
        if (creationDateEnd === null)
            throw new Error("The parameter 'creationDateEnd' cannot be null.");
        else if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toString() : "") + "&";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified === null)
            throw new Error("The parameter 'editionIdSpecified' cannot be null.");
        else if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfTenantListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfTenantListDto>;
        }));
    }

    protected processGetTenants(response: HttpResponseBase): Observable<PagedResultDtoOfTenantListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfTenantListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTenant(body: CreateTenantInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantForEdit(id: number | undefined): Observable<TenantEditDto> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantEditDto>;
        }));
    }

    protected processGetTenantForEdit(response: HttpResponseBase): Observable<TenantEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenant(body: TenantEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    deleteTenant(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTenant(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    getTenantFeaturesForEdit(id: number | undefined): Observable<GetTenantFeaturesEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenantFeaturesForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTenantFeaturesEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTenantFeaturesEditOutput>;
        }));
    }

    protected processGetTenantFeaturesForEdit(response: HttpResponseBase): Observable<GetTenantFeaturesEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTenantFeaturesEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateTenantFeatures(body: UpdateTenantFeaturesInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTenantFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateTenantFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resetTenantSpecificFeatures(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetTenantSpecificFeatures(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetTenantSpecificFeatures(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlockTenantAdmin(body: EntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockTenantAdmin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockTenantAdmin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantDashboardServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getMemberActivity(): Observable<GetMemberActivityOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMemberActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMemberActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMemberActivityOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMemberActivityOutput>;
        }));
    }

    protected processGetMemberActivity(response: HttpResponseBase): Observable<GetMemberActivityOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMemberActivityOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getDashboardData(salesSummaryDatePeriod: SalesSummaryDatePeriod | undefined): Observable<GetDashboardDataOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' cannot be null.");
        else if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDashboardData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDashboardData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDashboardDataOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDashboardDataOutput>;
        }));
    }

    protected processGetDashboardData(response: HttpResponseBase): Observable<GetDashboardDataOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDashboardDataOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getTopStats(): Observable<GetTopStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetTopStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTopStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTopStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTopStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTopStatsOutput>;
        }));
    }

    protected processGetTopStats(response: HttpResponseBase): Observable<GetTopStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTopStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getProfitShare(): Observable<GetProfitShareOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetProfitShare";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfitShare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfitShare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProfitShareOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProfitShareOutput>;
        }));
    }

    protected processGetProfitShare(response: HttpResponseBase): Observable<GetProfitShareOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProfitShareOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getDailySales(): Observable<GetDailySalesOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDailySales";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDailySales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDailySales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetDailySalesOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetDailySalesOutput>;
        }));
    }

    protected processGetDailySales(response: HttpResponseBase): Observable<GetDailySalesOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetDailySalesOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param salesSummaryDatePeriod (optional) 
     * @return Success
     */
    getSalesSummary(salesSummaryDatePeriod: SalesSummaryDatePeriod | undefined): Observable<GetSalesSummaryOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod === null)
            throw new Error("The parameter 'salesSummaryDatePeriod' cannot be null.");
        else if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSalesSummaryOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSalesSummaryOutput>;
        }));
    }

    protected processGetSalesSummary(response: HttpResponseBase): Observable<GetSalesSummaryOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSalesSummaryOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRegionalStats(): Observable<GetRegionalStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRegionalStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRegionalStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRegionalStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRegionalStatsOutput>;
        }));
    }

    protected processGetRegionalStats(response: HttpResponseBase): Observable<GetRegionalStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRegionalStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getGeneralStats(): Observable<GetGeneralStatsOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGeneralStats(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGeneralStats(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetGeneralStatsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetGeneralStatsOutput>;
        }));
    }

    protected processGetGeneralStats(response: HttpResponseBase): Observable<GetGeneralStatsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetGeneralStatsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantRegistrationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    registerTenant(body: RegisterTenantInput | undefined): Observable<RegisterTenantOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterTenant(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterTenant(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RegisterTenantOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RegisterTenantOutput>;
        }));
    }

    protected processRegisterTenant(response: HttpResponseBase): Observable<RegisterTenantOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RegisterTenantOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEditionsForSelect(): Observable<EditionsSelectOutput> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditionsForSelect(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionsSelectOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionsSelectOutput>;
        }));
    }

    protected processGetEditionsForSelect(response: HttpResponseBase): Observable<EditionsSelectOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionsSelectOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param editionId (optional) 
     * @return Success
     */
    getEdition(editionId: number | undefined): Observable<EditionSelectDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId === null)
            throw new Error("The parameter 'editionId' cannot be null.");
        else if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEdition(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEdition(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditionSelectDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditionSelectDto>;
        }));
    }

    protected processGetEdition(response: HttpResponseBase): Observable<EditionSelectDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditionSelectDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TenantSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllSettings(): Observable<TenantSettingsEditDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TenantSettingsEditDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TenantSettingsEditDto>;
        }));
    }

    protected processGetAllSettings(response: HttpResponseBase): Observable<TenantSettingsEditDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenantSettingsEditDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateAllSettings(body: TenantSettingsEditDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAllSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateAllSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearLogo(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearLogo(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    clearCustomCss(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClearCustomCss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClearCustomCss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClearCustomCss(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTestEmail(body: SendTestEmailInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getEnabledSocialLoginSettings(): Observable<ExternalLoginSettingsDto> {
        let url_ = this.baseUrl + "/api/services/app/TenantSettings/GetEnabledSocialLoginSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEnabledSocialLoginSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEnabledSocialLoginSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginSettingsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginSettingsDto>;
        }));
    }

    protected processGetEnabledSocialLoginSettings(response: HttpResponseBase): Observable<ExternalLoginSettingsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalLoginSettingsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    test(): Observable<void> {
        let url_ = this.baseUrl + "/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TimingServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param defaultTimezoneScope (optional) 
     * @return Success
     */
    getTimezones(defaultTimezoneScope: SettingScopes | undefined): Observable<ListResultDtoOfNameValueDto> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope === null)
            throw new Error("The parameter 'defaultTimezoneScope' cannot be null.");
        else if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfNameValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfNameValueDto>;
        }));
    }

    protected processGetTimezones(response: HttpResponseBase): Observable<ListResultDtoOfNameValueDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfNameValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param selectedTimezoneId (optional) 
     * @return Success
     */
    getTimezoneComboboxItems(selectedTimezoneId: string | undefined): Observable<ComboboxItemDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId === null)
            throw new Error("The parameter 'selectedTimezoneId' cannot be null.");
        else if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTimezoneComboboxItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ComboboxItemDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ComboboxItemDto[]>;
        }));
    }

    protected processGetTimezoneComboboxItems(response: HttpResponseBase): Observable<ComboboxItemDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ComboboxItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TokenAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateModel | undefined): Observable<AuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthenticateResultModel>;
        }));
    }

    protected processAuthenticate(response: HttpResponseBase): Observable<AuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param refreshToken (optional) 
     * @return Success
     */
    refreshToken(refreshToken: string | undefined): Observable<RefreshTokenResult> {
        let url_ = this.baseUrl + "/api/TokenAuth/RefreshToken?";
        if (refreshToken === null)
            throw new Error("The parameter 'refreshToken' cannot be null.");
        else if (refreshToken !== undefined)
            url_ += "refreshToken=" + encodeURIComponent("" + refreshToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RefreshTokenResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RefreshTokenResult>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<RefreshTokenResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RefreshTokenResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    logOut(): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processLogOut(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    b2CLogOut(): Observable<string> {
        let url_ = this.baseUrl + "/api/TokenAuth/B2CLogOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processB2CLogOut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processB2CLogOut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processB2CLogOut(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    b2CLogOutUrl(): Observable<B2CLogOutOutput> {
        let url_ = this.baseUrl + "/api/TokenAuth/B2CLogOutUrl";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processB2CLogOutUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processB2CLogOutUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<B2CLogOutOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<B2CLogOutOutput>;
        }));
    }

    protected processB2CLogOutUrl(response: HttpResponseBase): Observable<B2CLogOutOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = B2CLogOutOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    sendTwoFactorAuthCode(body: SendTwoFactorAuthCodeModel | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTwoFactorAuthCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSendTwoFactorAuthCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param impersonationToken (optional) 
     * @return Success
     */
    impersonatedAuthenticate(impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param userDelegationId (optional) 
     * @param impersonationToken (optional) 
     * @return Success
     */
    delegatedImpersonatedAuthenticate(userDelegationId: number | undefined, impersonationToken: string | undefined): Observable<ImpersonatedAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/DelegatedImpersonatedAuthenticate?";
        if (userDelegationId === null)
            throw new Error("The parameter 'userDelegationId' cannot be null.");
        else if (userDelegationId !== undefined)
            url_ += "userDelegationId=" + encodeURIComponent("" + userDelegationId) + "&";
        if (impersonationToken === null)
            throw new Error("The parameter 'impersonationToken' cannot be null.");
        else if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegatedImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegatedImpersonatedAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImpersonatedAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImpersonatedAuthenticateResultModel>;
        }));
    }

    protected processDelegatedImpersonatedAuthenticate(response: HttpResponseBase): Observable<ImpersonatedAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImpersonatedAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param switchAccountToken (optional) 
     * @return Success
     */
    linkedAccountAuthenticate(switchAccountToken: string | undefined): Observable<SwitchedAccountAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken === null)
            throw new Error("The parameter 'switchAccountToken' cannot be null.");
        else if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkedAccountAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwitchedAccountAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwitchedAccountAuthenticateResultModel>;
        }));
    }

    protected processLinkedAccountAuthenticate(response: HttpResponseBase): Observable<SwitchedAccountAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwitchedAccountAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getExternalAuthenticationProviders(): Observable<ExternalLoginProviderInfoModel[]> {
        let url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalAuthenticationProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalLoginProviderInfoModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalLoginProviderInfoModel[]>;
        }));
    }

    protected processGetExternalAuthenticationProviders(response: HttpResponseBase): Observable<ExternalLoginProviderInfoModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLoginProviderInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    externalAuthenticate(body: ExternalAuthenticateModel | undefined): Observable<ExternalAuthenticateResultModel> {
        let url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalAuthenticate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalAuthenticateResultModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalAuthenticateResultModel>;
        }));
    }

    protected processExternalAuthenticate(response: HttpResponseBase): Observable<ExternalAuthenticateResultModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalAuthenticateResultModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param message (optional) 
     * @param severity (optional) 
     * @return Success
     */
    testNotification(message: string | undefined, severity: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message === null)
            throw new Error("The parameter 'message' cannot be null.");
        else if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity === null)
            throw new Error("The parameter 'severity' cannot be null.");
        else if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNotification(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNotification(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestNotification(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class TravelMonitorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all the wood receipts by specific placeId with optional filtering
     * @param id (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWoodActivityReportsByPlace(id: number | undefined, licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, state: ActivityReportState | undefined, articleId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/TravelMonitor/GetWoodActivityReportsByPlace?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportsByPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportsByPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodActivityReportDto>;
        }));
    }

    protected processGetWoodActivityReportsByPlace(response: HttpResponseBase): Observable<PagedResultDtoOfWoodActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the diverse products receipts by specific placeId with optional filtering
     * @param id (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getDiverseProductActivityReportsByPlace(id: number | undefined, licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, state: ActivityReportState | undefined, articleId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfDiverseProductActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/TravelMonitor/GetDiverseProductActivityReportsByPlace?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiverseProductActivityReportsByPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiverseProductActivityReportsByPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfDiverseProductActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfDiverseProductActivityReportOutputDto>;
        }));
    }

    protected processGetDiverseProductActivityReportsByPlace(response: HttpResponseBase): Observable<PagedResultDtoOfDiverseProductActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfDiverseProductActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the internal movements receipts by specific placeId with optional filtering
     * @param id (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getInternalMovementsActivityReportsByPlace(id: number | undefined, licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, state: ActivityReportState | undefined, articleId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfInternalMovementActivityReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/TravelMonitor/GetInternalMovementsActivityReportsByPlace?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalMovementsActivityReportsByPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalMovementsActivityReportsByPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfInternalMovementActivityReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfInternalMovementActivityReportOutputDto>;
        }));
    }

    protected processGetInternalMovementsActivityReportsByPlace(response: HttpResponseBase): Observable<PagedResultDtoOfInternalMovementActivityReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfInternalMovementActivityReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UiCustomizationSettingsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getUiManagementSettings(): Observable<ThemeSettingsDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ThemeSettingsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ThemeSettingsDto[]>;
        }));
    }

    protected processGetUiManagementSettings(response: HttpResponseBase): Observable<ThemeSettingsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ThemeSettingsDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param themeName (optional) 
     * @return Success
     */
    changeThemeWithDefaultValues(themeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/ChangeThemeWithDefaultValues?";
        if (themeName === null)
            throw new Error("The parameter 'themeName' cannot be null.");
        else if (themeName !== undefined)
            url_ += "themeName=" + encodeURIComponent("" + themeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeThemeWithDefaultValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeThemeWithDefaultValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChangeThemeWithDefaultValues(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateDefaultUiManagementSettings(body: ThemeSettingsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDefaultUiManagementSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDefaultUiManagementSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    useSystemDefaultSettings(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUseSystemDefaultSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUseSystemDefaultSettings(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all users with the given filters
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUsers(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the information of the user with given id.
     * @param id (optional) User id.
     * @return Success
     */
    getUser(id: number | undefined): Observable<UserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListDto>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export to excel all users with the given filters
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getUsersToExcel(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersToExcel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processGetUsersToExcel(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a user for edition with the given id
     * @param id (optional) 
     * @return Success
     */
    getUserForEdit(id: number | undefined): Observable<GetUserForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserForEditOutput>;
        }));
    }

    protected processGetUserForEdit(response: HttpResponseBase): Observable<GetUserForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the list of permissions of the user with the given id for edition
     * @param id (optional) 
     * @return Success
     */
    getUserPermissionsForEdit(id: number | undefined): Observable<GetUserPermissionsForEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserPermissionsForEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserPermissionsForEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserPermissionsForEditOutput>;
        }));
    }

    protected processGetUserPermissionsForEdit(response: HttpResponseBase): Observable<GetUserPermissionsForEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserPermissionsForEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Reset the permissions of the user with the given id
     * @param body (optional) 
     * @return Success
     */
    resetUserSpecificPermissions(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetUserSpecificPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetUserSpecificPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the permissions of the user with the given id to the given new permissions
     * @param body (optional) 
     * @return Success
     */
    updateUserPermissions(body: UpdateUserPermissionsInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateUserPermissions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create new user or update existing one depending on the given input
     * @param body (optional) 
     * @return Success
     */
    createOrUpdateUser(body: CreateOrUpdateUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateOrUpdateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete the user of the given id
     * @param id (optional) 
     * @return Success
     */
    deleteUser(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Unlock the user of the given id
     * @param body (optional) 
     * @return Success
     */
    unlockUser(body: EntityDtoOfInt64 | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlockUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlockUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlockUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the list of permissions of the roles of the current user
     * @return Success
     */
    getCurrentUserRolesPermissions(): Observable<UserRolesPermissionsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetCurrentUserRolesPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserRolesPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserRolesPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRolesPermissionsOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRolesPermissionsOutputDto>;
        }));
    }

    protected processGetCurrentUserRolesPermissions(response: HttpResponseBase): Observable<UserRolesPermissionsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRolesPermissionsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the driver information of the user with the given driver external id
     * @param driverExternalId (optional) 
     * @return Success
     */
    getUserDriverInformationByDriverExternalId(driverExternalId: number | undefined): Observable<UserDriverInformationOutput> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUserDriverInformationByDriverExternalId?";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "driverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserDriverInformationByDriverExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserDriverInformationByDriverExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDriverInformationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDriverInformationOutput>;
        }));
    }

    protected processGetUserDriverInformationByDriverExternalId(response: HttpResponseBase): Observable<UserDriverInformationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDriverInformationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the current place of the logged in user
     * @return Success
     */
    getCurrentPlace(): Observable<CurrentPlaceOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetCurrentPlace";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CurrentPlaceOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CurrentPlaceOutputDto>;
        }));
    }

    protected processGetCurrentPlace(response: HttpResponseBase): Observable<CurrentPlaceOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CurrentPlaceOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update the current place of the logged in user to the one of the given id
     * @param placeId (optional) 
     * @return Success
     */
    updateCurrentPlace(placeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/User/UpdateCurrentPlace?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCurrentPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCurrentPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateCurrentPlace(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get basic user information by user id
     * @param userId (optional) 
     * @return Success
     */
    getBasicUserDtoById(userId: number | undefined): Observable<BasicUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetBasicUserDtoById?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicUserDtoById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicUserDtoById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicUserDto>;
        }));
    }

    protected processGetBasicUserDtoById(response: HttpResponseBase): Observable<BasicUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all users vendors with the given filters
     * @param filter (optional) 
     * @param permissions (optional) 
     * @param role (optional) 
     * @param onlyLockedUsers (optional) 
     * @param sorting (optional) 
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @return Success
     */
    getUsersVendors(filter: string | undefined, permissions: string[] | undefined, role: number | undefined, onlyLockedUsers: boolean | undefined, sorting: string | undefined, maxResultCount: number | undefined, skipCount: number | undefined): Observable<PagedResultDtoOfUserListDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetUsersVendors?";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permissions === null)
            throw new Error("The parameter 'permissions' cannot be null.");
        else if (permissions !== undefined)
            permissions && permissions.forEach(item => { url_ += "Permissions=" + encodeURIComponent("" + item) + "&"; });
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers === null)
            throw new Error("The parameter 'onlyLockedUsers' cannot be null.");
        else if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserListDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserListDto>;
        }));
    }

    protected processGetUsersVendors(response: HttpResponseBase): Observable<PagedResultDtoOfUserListDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserListDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get basic user by identity card number
     * @param identityCardNumber (optional) User identity card number
     * @return Success
     */
    getBasicUserByIdentityCardNumber(identityCardNumber: string | undefined): Observable<BasicUserDto> {
        let url_ = this.baseUrl + "/api/services/app/User/GetBasicUserByIdentityCardNumber?";
        if (identityCardNumber === null)
            throw new Error("The parameter 'identityCardNumber' cannot be null.");
        else if (identityCardNumber !== undefined)
            url_ += "identityCardNumber=" + encodeURIComponent("" + identityCardNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicUserByIdentityCardNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicUserByIdentityCardNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicUserDto>;
        }));
    }

    protected processGetBasicUserByIdentityCardNumber(response: HttpResponseBase): Observable<BasicUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDelegationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getDelegatedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfUserDelegationDto> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetDelegatedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDelegatedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDelegatedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserDelegationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserDelegationDto>;
        }));
    }

    protected processGetDelegatedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfUserDelegationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserDelegationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    delegateNewUser(body: CreateUserDelegationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/DelegateNewUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelegateNewUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelegateNewUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelegateNewUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @return Success
     */
    removeDelegation(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/RemoveDelegation?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveDelegation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveDelegation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveDelegation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns active user delegations for current user
     * @return Success
     */
    getActiveUserDelegations(): Observable<UserDelegationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/UserDelegation/GetActiveUserDelegations";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetActiveUserDelegations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetActiveUserDelegations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDelegationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDelegationDto[]>;
        }));
    }

    protected processGetActiveUserDelegations(response: HttpResponseBase): Observable<UserDelegationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDelegationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserDriverServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param driverExternalId (optional) 
     * @return Success
     */
    updateDriverExternalInformation(driverExternalId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserDriver/UpdateDriverExternalInformation?";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "driverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateDriverExternalInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateDriverExternalInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateDriverExternalInformation(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getUserSessionDriverExternalId(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/UserDriver/GetUserSessionDriverExternalId";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSessionDriverExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSessionDriverExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUserSessionDriverExternalId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLinkServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    linkToUser(body: LinkToUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkToUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkToUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkToUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getLinkedUsers(maxResultCount: number | undefined, skipCount: number | undefined, sorting: string | undefined): Observable<PagedResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetLinkedUsers(response: HttpResponseBase): Observable<PagedResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getRecentlyUsedLinkedUsers(): Observable<ListResultDtoOfLinkedUserDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentlyUsedLinkedUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfLinkedUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfLinkedUserDto>;
        }));
    }

    protected processGetRecentlyUsedLinkedUsers(response: HttpResponseBase): Observable<ListResultDtoOfLinkedUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfLinkedUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    unlinkUser(body: UnlinkUserInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUnlinkUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUnlinkUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUnlinkUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserLoginServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the 10 most recent log in attempts
     * @return Success
     */
    getRecentUserLoginAttempts(): Observable<ListResultDtoOfUserLoginAttemptDto> {
        let url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRecentUserLoginAttempts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ListResultDtoOfUserLoginAttemptDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ListResultDtoOfUserLoginAttemptDto>;
        }));
    }

    protected processGetRecentUserLoginAttempts(response: HttpResponseBase): Observable<ListResultDtoOfUserLoginAttemptDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UserVendorServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets the information of the user vendor with given id.
     * @param userId (optional) User vendor id.
     * @return Success
     */
    getUserVendorInformation(userId: number | undefined): Observable<UserVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/GetUserVendorInformation?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserVendorInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserVendorInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVendorDto>;
        }));
    }

    protected processGetUserVendorInformation(response: HttpResponseBase): Observable<UserVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save the information of the user vendor with given input.
     * @param body (optional) User vendor input.
     * @return Success
     */
    saveUserVendor(body: UserVendorInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/SaveUserVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveUserVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveUserVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveUserVendor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets paged, sorted and filtered list of user vendors.
     * @param maxResultCount (optional) 
     * @param skipCount (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @return Success
     */
    getList(maxResultCount: number | undefined, skipCount: number | undefined, filter: string | undefined, sorting: string | undefined): Observable<PagedResultDtoOfUserVendorDto> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/GetList?";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfUserVendorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfUserVendorDto>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<PagedResultDtoOfUserVendorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfUserVendorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete vendor from user.
     * @param userId (optional) User id
     * @return Success
     */
    deleteVendorFromUser(userId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/UserVendor/DeleteVendorFromUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVendorFromUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVendorFromUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteVendorFromUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class VehiclesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Gets all available truck types
     * @return Success
     */
    getTruckTypes(): Observable<TypeTruckDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicles/GetTruckTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTruckTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTruckTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TypeTruckDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TypeTruckDto>;
        }));
    }

    protected processGetTruckTypes(response: HttpResponseBase): Observable<TypeTruckDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TypeTruckDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if a truck with a tag matching the entered license plate exists
     * @param licensePlate (optional) 
     * @return Success
     */
    existTruckWithActiveTagByLicensePlate(licensePlate: string | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Vehicles/ExistTruckWithActiveTagByLicensePlate?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExistTruckWithActiveTagByLicensePlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExistTruckWithActiveTagByLicensePlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExistTruckWithActiveTagByLicensePlate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the historic tare for a vehicle, which is the tare weight of the previous activity report that entered for that vehicle
     * @param truckId (optional) 
     * @return Success
     */
    getHistoricTare(truckId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Vehicles/GetHistoricTare?";
        if (truckId === null)
            throw new Error("The parameter 'truckId' cannot be null.");
        else if (truckId !== undefined)
            url_ += "truckId=" + encodeURIComponent("" + truckId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricTare(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricTare(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetHistoricTare(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the historic tare for a vehicle by its external id, which is the tare weight of the previous activity report that entered for that vehicle
     * @param externalId (optional) 
     * @return Success
     */
    getHistoricTareWithExternalId(externalId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Vehicles/GetHistoricTareWithExternalId?";
        if (externalId === null)
            throw new Error("The parameter 'externalId' cannot be null.");
        else if (externalId !== undefined)
            url_ += "externalId=" + encodeURIComponent("" + externalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHistoricTareWithExternalId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHistoricTareWithExternalId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetHistoricTareWithExternalId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns Truck information with active tag detection
     * @param licensePlate (optional) 
     * @return Success
     */
    getTruckVehicle(licensePlate: string | undefined): Observable<TruckVehicleWithTagDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicles/GetTruckVehicle?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTruckVehicle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTruckVehicle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckVehicleWithTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckVehicleWithTagDto>;
        }));
    }

    protected processGetTruckVehicle(response: HttpResponseBase): Observable<TruckVehicleWithTagDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckVehicleWithTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns tare weight value by semitrailer quantity
     * @param semiTrailersQuantity (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getTareBySemiTrailerQuantity(semiTrailersQuantity: number | undefined, placeId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Vehicles/GetTareBySemiTrailerQuantity?";
        if (semiTrailersQuantity === null)
            throw new Error("The parameter 'semiTrailersQuantity' cannot be null.");
        else if (semiTrailersQuantity !== undefined)
            url_ += "semiTrailersQuantity=" + encodeURIComponent("" + semiTrailersQuantity) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTareBySemiTrailerQuantity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTareBySemiTrailerQuantity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTareBySemiTrailerQuantity(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param plate (optional) 
     * @return Success
     */
    getVehicleReportByPlate(plate: string | undefined): Observable<TruckReportInformationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/Vehicles/GetVehicleReportByPlate?";
        if (plate === null)
            throw new Error("The parameter 'plate' cannot be null.");
        else if (plate !== undefined)
            url_ += "plate=" + encodeURIComponent("" + plate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleReportByPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleReportByPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckReportInformationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckReportInformationOutputDto>;
        }));
    }

    protected processGetVehicleReportByPlate(response: HttpResponseBase): Observable<TruckReportInformationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TruckReportInformationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns true if there is a wood truck type with the given resource type id and is also classified as a tritrain
     * @param resourceTypeId (optional) 
     * @return Success
     */
    isTruckTritrainByResourceTypeId(resourceTypeId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/Vehicles/IsTruckTritrainByResourceTypeId?";
        if (resourceTypeId === null)
            throw new Error("The parameter 'resourceTypeId' cannot be null.");
        else if (resourceTypeId !== undefined)
            url_ += "resourceTypeId=" + encodeURIComponent("" + resourceTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsTruckTritrainByResourceTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsTruckTritrainByResourceTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processIsTruckTritrainByResourceTypeId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WebLogServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getLatestWebLogs(): Observable<GetLatestWebLogsOutput> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetLatestWebLogsOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetLatestWebLogsOutput>;
        }));
    }

    protected processGetLatestWebLogs(response: HttpResponseBase): Observable<GetLatestWebLogsOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetLatestWebLogsOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    downloadWebLogs(): Observable<FileDto> {
        let url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadWebLogs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDto>;
        }));
    }

    protected processDownloadWebLogs(response: HttpResponseBase): Observable<FileDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodActivityReportServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Returns sample information for the wood activity reports filtered by the input parameter
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param sampleType (optional) 
     * @param includeAlreadySampled (optional) 
     * @param includeInPlantSamples (optional) 
     * @param includeNotAssigned (optional) 
     * @param standNumber (optional) 
     * @param isChip (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param id (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWoodActivityReportsForSamplesGrid(dateFrom: DateTime | undefined, dateTo: DateTime | undefined, sampleType: SampleAssignmentType | undefined, includeAlreadySampled: boolean | undefined, includeInPlantSamples: boolean | undefined, includeNotAssigned: boolean | undefined, standNumber: number | undefined, isChip: boolean | undefined, licensePlate: string | undefined, originId: number | undefined, id: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodActivityReportForSamplesGridOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodActivityReportsForSamplesGrid?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (sampleType === null)
            throw new Error("The parameter 'sampleType' cannot be null.");
        else if (sampleType !== undefined)
            url_ += "SampleType=" + encodeURIComponent("" + sampleType) + "&";
        if (includeAlreadySampled === null)
            throw new Error("The parameter 'includeAlreadySampled' cannot be null.");
        else if (includeAlreadySampled !== undefined)
            url_ += "IncludeAlreadySampled=" + encodeURIComponent("" + includeAlreadySampled) + "&";
        if (includeInPlantSamples === null)
            throw new Error("The parameter 'includeInPlantSamples' cannot be null.");
        else if (includeInPlantSamples !== undefined)
            url_ += "IncludeInPlantSamples=" + encodeURIComponent("" + includeInPlantSamples) + "&";
        if (includeNotAssigned === null)
            throw new Error("The parameter 'includeNotAssigned' cannot be null.");
        else if (includeNotAssigned !== undefined)
            url_ += "IncludeNotAssigned=" + encodeURIComponent("" + includeNotAssigned) + "&";
        if (standNumber === null)
            throw new Error("The parameter 'standNumber' cannot be null.");
        else if (standNumber !== undefined)
            url_ += "StandNumber=" + encodeURIComponent("" + standNumber) + "&";
        if (isChip === null)
            throw new Error("The parameter 'isChip' cannot be null.");
        else if (isChip !== undefined)
            url_ += "IsChip=" + encodeURIComponent("" + isChip) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportsForSamplesGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportsForSamplesGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodActivityReportForSamplesGridOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodActivityReportForSamplesGridOutputDto>;
        }));
    }

    protected processGetWoodActivityReportsForSamplesGrid(response: HttpResponseBase): Observable<PagedResultDtoOfWoodActivityReportForSamplesGridOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodActivityReportForSamplesGridOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Recalculates the gross, tare and net weight for each activity report line 
    and the total gross, tare and net weights based on input.
     * @param lines (optional) List of activity report lines
     * @param type (optional) Activity report type
     * @param grossWeight (optional) Current gross weight total
     * @param tareWeight (optional) Current tare weight total
     * @return Success
     */
    getCalculatePerLineWeight(lines: ActivityReportLineDto[] | undefined, type: ActivityReportType | undefined, grossWeight: number | undefined, tareWeight: number | undefined): Observable<ExternalWeightOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetCalculatePerLineWeight?";
        if (lines === null)
            throw new Error("The parameter 'lines' cannot be null.");
        else if (lines !== undefined)
            lines && lines.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "lines[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (grossWeight === null)
            throw new Error("The parameter 'grossWeight' cannot be null.");
        else if (grossWeight !== undefined)
            url_ += "grossWeight=" + encodeURIComponent("" + grossWeight) + "&";
        if (tareWeight === null)
            throw new Error("The parameter 'tareWeight' cannot be null.");
        else if (tareWeight !== undefined)
            url_ += "tareWeight=" + encodeURIComponent("" + tareWeight) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculatePerLineWeight(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculatePerLineWeight(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalWeightOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalWeightOutputDto>;
        }));
    }

    protected processGetCalculatePerLineWeight(response: HttpResponseBase): Observable<ExternalWeightOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExternalWeightOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information about the electronic report from the matching wood activity report.
     * @param reportId (optional) Id of the wood activity report
     * @return Success
     */
    getElectronicReportById(reportId: number | undefined): Observable<ElectronicReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetElectronicReportById?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElectronicReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElectronicReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElectronicReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElectronicReportOutputDto>;
        }));
    }

    protected processGetElectronicReportById(response: HttpResponseBase): Observable<ElectronicReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElectronicReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information about the matching wood activity report object.
     * @param reportId (optional) Id of the wood activity report
     * @return Success
     */
    getBasicWoodActivityReportInfo(reportId: number | undefined): Observable<BasicWoodActivityReportInfoDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetBasicWoodActivityReportInfo?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicWoodActivityReportInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicWoodActivityReportInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BasicWoodActivityReportInfoDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BasicWoodActivityReportInfoDto>;
        }));
    }

    protected processGetBasicWoodActivityReportInfo(response: HttpResponseBase): Observable<BasicWoodActivityReportInfoDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BasicWoodActivityReportInfoDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets information about a collection of wood activity reports filtered by input parameter.
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomDeclarationId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchWoodActivityReport(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomDeclarationId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/SearchWoodActivityReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomDeclarationId === null)
            throw new Error("The parameter 'singleCustomDeclarationId' cannot be null.");
        else if (singleCustomDeclarationId !== undefined)
            url_ += "SingleCustomDeclarationId=" + encodeURIComponent("" + singleCustomDeclarationId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchWoodActivityReport(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param transportVendorId (optional) 
     * @param vendorId (optional) 
     * @param entranceStatusFilters (optional) 
     * @param creationSystem (optional) 
     * @param showActualAndNextTurnDifferentFromTotem (optional) 
     * @param number (optional) 
     * @param serial (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchWoodPreActivityReports(transportVendorId: number | undefined, vendorId: number | undefined, entranceStatusFilters: string[] | undefined, creationSystem: WoodActivityReportCreationSystemFilter | undefined, showActualAndNextTurnDifferentFromTotem: boolean | undefined, number: number | undefined, serial: string | undefined, licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/SearchWoodPreActivityReports?";
        if (transportVendorId === null)
            throw new Error("The parameter 'transportVendorId' cannot be null.");
        else if (transportVendorId !== undefined)
            url_ += "TransportVendorId=" + encodeURIComponent("" + transportVendorId) + "&";
        if (vendorId === null)
            throw new Error("The parameter 'vendorId' cannot be null.");
        else if (vendorId !== undefined)
            url_ += "VendorId=" + encodeURIComponent("" + vendorId) + "&";
        if (entranceStatusFilters === null)
            throw new Error("The parameter 'entranceStatusFilters' cannot be null.");
        else if (entranceStatusFilters !== undefined)
            entranceStatusFilters && entranceStatusFilters.forEach(item => { url_ += "EntranceStatusFilters=" + encodeURIComponent("" + item) + "&"; });
        if (creationSystem === null)
            throw new Error("The parameter 'creationSystem' cannot be null.");
        else if (creationSystem !== undefined)
            url_ += "CreationSystem=" + encodeURIComponent("" + creationSystem) + "&";
        if (showActualAndNextTurnDifferentFromTotem === null)
            throw new Error("The parameter 'showActualAndNextTurnDifferentFromTotem' cannot be null.");
        else if (showActualAndNextTurnDifferentFromTotem !== undefined)
            url_ += "ShowActualAndNextTurnDifferentFromTotem=" + encodeURIComponent("" + showActualAndNextTurnDifferentFromTotem) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodPreActivityReports(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodPreActivityReports(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto>;
        }));
    }

    protected processSearchWoodPreActivityReports(response: HttpResponseBase): Observable<PagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets required information to manually start an exit process for a wood activity report.
     * @param reportId (optional) The id of the wood activity report
     * @return Success
     */
    validateRequiredInformationForWoodForcedExit(reportId: number | undefined): Observable<ValidateRequiredInformationForWoodForcedExitOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/ValidateRequiredInformationForWoodForcedExit?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateRequiredInformationForWoodForcedExit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateRequiredInformationForWoodForcedExit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateRequiredInformationForWoodForcedExitOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateRequiredInformationForWoodForcedExitOutput>;
        }));
    }

    protected processValidateRequiredInformationForWoodForcedExit(response: HttpResponseBase): Observable<ValidateRequiredInformationForWoodForcedExitOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateRequiredInformationForWoodForcedExitOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the matching wood activity report.
     * @param reportId (optional) The id of the wood activity report
     * @param deletionComment (optional) The reason why the report is being deleted
     * @param deleteReasonId (optional) 
     * @return Success
     */
    delete(reportId: number | undefined, deletionComment: string | undefined, deleteReasonId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/Delete?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (deletionComment === null)
            throw new Error("The parameter 'deletionComment' cannot be null.");
        else if (deletionComment !== undefined)
            url_ += "deletionComment=" + encodeURIComponent("" + deletionComment) + "&";
        if (deleteReasonId === null)
            throw new Error("The parameter 'deleteReasonId' cannot be null.");
        else if (deleteReasonId !== undefined)
            url_ += "deleteReasonId=" + encodeURIComponent("" + deleteReasonId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the volume of each line of the wood activity report.
     * @param reportId (optional) 
     * @return Success
     */
    getVolumeByLine(reportId: number | undefined): Observable<{ [key: string]: number; }> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetVolumeByLine?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVolumeByLine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVolumeByLine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<{ [key: string]: number; }>;
                }
            } else
                return _observableThrow(response_) as any as Observable<{ [key: string]: number; }>;
        }));
    }

    protected processGetVolumeByLine(response: HttpResponseBase): Observable<{ [key: string]: number; }> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the pre-report associated to the activity report given by id
     * @param reportId (optional) 
     * @return Success
     */
    getWoodPreActivityReport(reportId: number | undefined): Observable<PreActivityReportWithErrorsDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodPreActivityReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportWithErrorsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportWithErrorsDto>;
        }));
    }

    protected processGetWoodPreActivityReport(response: HttpResponseBase): Observable<PreActivityReportWithErrorsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportWithErrorsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param ids (optional) 
     * @return Success
     */
    getWoodPreActivityReportsForSynchronizationByIds(ids: number[] | undefined): Observable<WoodPreActivityReportForSynchronizationDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodPreActivityReportsForSynchronizationByIds?";
        if (ids === null)
            throw new Error("The parameter 'ids' cannot be null.");
        else if (ids !== undefined)
            ids && ids.forEach(item => { url_ += "ids=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreActivityReportsForSynchronizationByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreActivityReportsForSynchronizationByIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportForSynchronizationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportForSynchronizationDto[]>;
        }));
    }

    protected processGetWoodPreActivityReportsForSynchronizationByIds(response: HttpResponseBase): Observable<WoodPreActivityReportForSynchronizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WoodPreActivityReportForSynchronizationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets the amount of wood activity reports that are currently in the specified plant or leaving it.
     * @return Success
     */
    getWoodInPlaceForTripMonitor(): Observable<WoodCounterTripMonitorDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodInPlaceForTripMonitor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodInPlaceForTripMonitor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodInPlaceForTripMonitor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodCounterTripMonitorDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodCounterTripMonitorDto>;
        }));
    }

    protected processGetWoodInPlaceForTripMonitor(response: HttpResponseBase): Observable<WoodCounterTripMonitorDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodCounterTripMonitorDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return Success
     */
    getWoodPreActivityReportIdsOrderedByTurn(): Observable<number[]> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodPreActivityReportIdsOrderedByTurn";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreActivityReportIdsOrderedByTurn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreActivityReportIdsOrderedByTurn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number[]>;
        }));
    }

    protected processGetWoodPreActivityReportIdsOrderedByTurn(response: HttpResponseBase): Observable<number[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update pre-report error list and calculate wood pre-report validation status
     * @param body (optional) 
     * @return Success
     */
    synchronizeWoodPreActivityReport(body: SynchronizeWoodPreActivityReportInput | undefined): Observable<SynchronizePreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/SynchronizeWoodPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronizeWoodPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronizeWoodPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SynchronizePreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SynchronizePreActivityReportOutput>;
        }));
    }

    protected processSynchronizeWoodPreActivityReport(response: HttpResponseBase): Observable<SynchronizePreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SynchronizePreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns internal destination information by reportId
     * @param reportId (optional) Id of the report
     * @return Success
     */
    getInternalDestination(reportId: number | undefined): Observable<InternalDestinationOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetInternalDestination?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalDestination(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalDestination(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InternalDestinationOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InternalDestinationOutput>;
        }));
    }

    protected processGetInternalDestination(response: HttpResponseBase): Observable<InternalDestinationOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InternalDestinationOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getFullWoodPreActivityReportById(reportId: number | undefined): Observable<WoodPreActivityReportFullDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetFullWoodPreActivityReportById?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFullWoodPreActivityReportById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFullWoodPreActivityReportById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreActivityReportFullDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreActivityReportFullDto>;
        }));
    }

    protected processGetFullWoodPreActivityReportById(response: HttpResponseBase): Observable<WoodPreActivityReportFullDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreActivityReportFullDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param driverId (optional) 
     * @param entranceStatusFilterForVendor (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchWoodPreActivityReportsVendors(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, driverId: number | undefined, entranceStatusFilterForVendor: PreActivityReportEntranceStatusFilterForVendor | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/SearchWoodPreActivityReportsVendors?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilterForVendor === null)
            throw new Error("The parameter 'entranceStatusFilterForVendor' cannot be null.");
        else if (entranceStatusFilterForVendor !== undefined)
            url_ += "EntranceStatusFilterForVendor=" + encodeURIComponent("" + entranceStatusFilterForVendor) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodPreActivityReportsVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodPreActivityReportsVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto>;
        }));
    }

    protected processSearchWoodPreActivityReportsVendors(response: HttpResponseBase): Observable<PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param destinationId (optional) 
     * @param driverId (optional) 
     * @param entranceStatusFilterForTransportVendor (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchWoodPreActivityReportsTransportVendor(licensePlate: string | undefined, originId: number | undefined, destinationId: number | undefined, driverId: number | undefined, entranceStatusFilterForTransportVendor: PreActivityReportEntranceStatusFilterForTransportVendor | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/SearchWoodPreActivityReportsTransportVendor?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (driverId === null)
            throw new Error("The parameter 'driverId' cannot be null.");
        else if (driverId !== undefined)
            url_ += "DriverId=" + encodeURIComponent("" + driverId) + "&";
        if (entranceStatusFilterForTransportVendor === null)
            throw new Error("The parameter 'entranceStatusFilterForTransportVendor' cannot be null.");
        else if (entranceStatusFilterForTransportVendor !== undefined)
            url_ += "EntranceStatusFilterForTransportVendor=" + encodeURIComponent("" + entranceStatusFilterForTransportVendor) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodPreActivityReportsTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodPreActivityReportsTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto>;
        }));
    }

    protected processSearchWoodPreActivityReportsTransportVendor(response: HttpResponseBase): Observable<PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomDeclarationId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchWoodActivityReportForVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomDeclarationId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/SearchWoodActivityReportForVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomDeclarationId === null)
            throw new Error("The parameter 'singleCustomDeclarationId' cannot be null.");
        else if (singleCustomDeclarationId !== undefined)
            url_ += "SingleCustomDeclarationId=" + encodeURIComponent("" + singleCustomDeclarationId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodActivityReportForVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodActivityReportForVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchWoodActivityReportForVendor(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param id (optional) 
     * @param serial (optional) 
     * @param number (optional) 
     * @param licensePlate (optional) 
     * @param originId (optional) 
     * @param standId (optional) 
     * @param destinationId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param state (optional) 
     * @param articleId (optional) 
     * @param tripNumber (optional) 
     * @param operationMode (optional) 
     * @param localId (optional) 
     * @param woodVendorExternalId (optional) 
     * @param cutServiceVendorExternalId (optional) 
     * @param extractionServiceVendorExternalId (optional) 
     * @param transportVendorExternalId (optional) 
     * @param contractTypeExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param singleCustomDeclarationId (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchWoodActivityReportForTransportVendor(id: number | undefined, serial: string | undefined, number: number | undefined, licensePlate: string | undefined, originId: number | undefined, standId: number | undefined, destinationId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, state: ActivityReportState | undefined, articleId: number | undefined, tripNumber: number | undefined, operationMode: ActivityReportOperationMode | undefined, localId: number | undefined, woodVendorExternalId: number | undefined, cutServiceVendorExternalId: number | undefined, extractionServiceVendorExternalId: number | undefined, transportVendorExternalId: number | undefined, contractTypeExternalId: number | undefined, driverExternalId: number | undefined, singleCustomDeclarationId: number | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchReportOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/SearchWoodActivityReportForTransportVendor?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (serial === null)
            throw new Error("The parameter 'serial' cannot be null.");
        else if (serial !== undefined)
            url_ += "Serial=" + encodeURIComponent("" + serial) + "&";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "Number=" + encodeURIComponent("" + number) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "LicensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (destinationId === null)
            throw new Error("The parameter 'destinationId' cannot be null.");
        else if (destinationId !== undefined)
            url_ += "DestinationId=" + encodeURIComponent("" + destinationId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (state === null)
            throw new Error("The parameter 'state' cannot be null.");
        else if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "TripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (operationMode === null)
            throw new Error("The parameter 'operationMode' cannot be null.");
        else if (operationMode !== undefined)
            url_ += "OperationMode=" + encodeURIComponent("" + operationMode) + "&";
        if (localId === null)
            throw new Error("The parameter 'localId' cannot be null.");
        else if (localId !== undefined)
            url_ += "LocalId=" + encodeURIComponent("" + localId) + "&";
        if (woodVendorExternalId === null)
            throw new Error("The parameter 'woodVendorExternalId' cannot be null.");
        else if (woodVendorExternalId !== undefined)
            url_ += "WoodVendorExternalId=" + encodeURIComponent("" + woodVendorExternalId) + "&";
        if (cutServiceVendorExternalId === null)
            throw new Error("The parameter 'cutServiceVendorExternalId' cannot be null.");
        else if (cutServiceVendorExternalId !== undefined)
            url_ += "CutServiceVendorExternalId=" + encodeURIComponent("" + cutServiceVendorExternalId) + "&";
        if (extractionServiceVendorExternalId === null)
            throw new Error("The parameter 'extractionServiceVendorExternalId' cannot be null.");
        else if (extractionServiceVendorExternalId !== undefined)
            url_ += "ExtractionServiceVendorExternalId=" + encodeURIComponent("" + extractionServiceVendorExternalId) + "&";
        if (transportVendorExternalId === null)
            throw new Error("The parameter 'transportVendorExternalId' cannot be null.");
        else if (transportVendorExternalId !== undefined)
            url_ += "TransportVendorExternalId=" + encodeURIComponent("" + transportVendorExternalId) + "&";
        if (contractTypeExternalId === null)
            throw new Error("The parameter 'contractTypeExternalId' cannot be null.");
        else if (contractTypeExternalId !== undefined)
            url_ += "ContractTypeExternalId=" + encodeURIComponent("" + contractTypeExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (singleCustomDeclarationId === null)
            throw new Error("The parameter 'singleCustomDeclarationId' cannot be null.");
        else if (singleCustomDeclarationId !== undefined)
            url_ += "SingleCustomDeclarationId=" + encodeURIComponent("" + singleCustomDeclarationId) + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodActivityReportForTransportVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodActivityReportForTransportVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchReportOutputDto>;
        }));
    }

    protected processSearchWoodActivityReportForTransportVendor(response: HttpResponseBase): Observable<PagedResultDtoOfSearchReportOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchReportOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves a paged and sorted list of wood activity reports to be mass edited,
    and whether these can be edited or not, filtered by the input parameters
     * @param originId (optional) 
     * @param standId (optional) 
     * @param articleId (optional) 
     * @param dateFrom (optional) 
     * @param dateTo (optional) 
     * @param pileId (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWoodActivityReportForMassEditGrid(originId: number | undefined, standId: number | undefined, articleId: number | undefined, dateFrom: DateTime | undefined, dateTo: DateTime | undefined, pileId: number | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodActivityReportForMassEditGridDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodActivityReportForMassEditGrid?";
        if (originId === null)
            throw new Error("The parameter 'originId' cannot be null.");
        else if (originId !== undefined)
            url_ += "OriginId=" + encodeURIComponent("" + originId) + "&";
        if (standId === null)
            throw new Error("The parameter 'standId' cannot be null.");
        else if (standId !== undefined)
            url_ += "StandId=" + encodeURIComponent("" + standId) + "&";
        if (articleId === null)
            throw new Error("The parameter 'articleId' cannot be null.");
        else if (articleId !== undefined)
            url_ += "ArticleId=" + encodeURIComponent("" + articleId) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toString() : "") + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toString() : "") + "&";
        if (pileId === null)
            throw new Error("The parameter 'pileId' cannot be null.");
        else if (pileId !== undefined)
            url_ += "PileId=" + encodeURIComponent("" + pileId) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportForMassEditGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportForMassEditGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodActivityReportForMassEditGridDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodActivityReportForMassEditGridDto>;
        }));
    }

    protected processGetWoodActivityReportForMassEditGrid(response: HttpResponseBase): Observable<PagedResultDtoOfWoodActivityReportForMassEditGridDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodActivityReportForMassEditGridDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood report in plant by license plate
     * @param licensePlate (optional) Id of the report
     * @param placeId (optional) Place id
     * @return Success
     */
    getWoodReportInPlaceByTruckPlate(licensePlate: string | undefined, placeId: number | undefined): Observable<WoodActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodReportInPlaceByTruckPlate?";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodReportInPlaceByTruckPlate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodReportInPlaceByTruckPlate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportDto>;
        }));
    }

    protected processGetWoodReportInPlaceByTruckPlate(response: HttpResponseBase): Observable<WoodActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood pre-report information for entrance status calculation
     * @param reportId (optional) Id of the report
     * @return Success
     */
    getWoodPreReportEntranceRequiredInfo(reportId: number | undefined): Observable<WoodPreReportEntranceRequiredInfoOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodPreReportEntranceRequiredInfo?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreReportEntranceRequiredInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreReportEntranceRequiredInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreReportEntranceRequiredInfoOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreReportEntranceRequiredInfoOutput>;
        }));
    }

    protected processGetWoodPreReportEntranceRequiredInfo(response: HttpResponseBase): Observable<WoodPreReportEntranceRequiredInfoOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreReportEntranceRequiredInfoOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getWoodPreReportInfoForEditValidations(reportId: number | undefined): Observable<WoodPreReportInfoForEditValidationsDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodPreReportInfoForEditValidations?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreReportInfoForEditValidations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreReportInfoForEditValidations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreReportInfoForEditValidationsDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreReportInfoForEditValidationsDto>;
        }));
    }

    protected processGetWoodPreReportInfoForEditValidations(response: HttpResponseBase): Observable<WoodPreReportInfoForEditValidationsDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreReportInfoForEditValidationsDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    editWoodPreActivityReport(body: EditWoodPreActivityReportInput | undefined): Observable<EditWoodPreActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/EditWoodPreActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditWoodPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditWoodPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditWoodPreActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditWoodPreActivityReportOutput>;
        }));
    }

    protected processEditWoodPreActivityReport(response: HttpResponseBase): Observable<EditWoodPreActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EditWoodPreActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Locks the activity reports with the given ids to prevent their edition
     * @param body (optional) 
     * @return Success
     */
    acquireMassEditLock(body: AcquireMassEditLockInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/AcquireMassEditLock";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcquireMassEditLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcquireMassEditLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcquireMassEditLock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not Found", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Bad Request", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Releases the edit lock of the input report
     * @param id (optional) 
     * @return Success
     */
    releaseEditLock(id: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/ReleaseEditLock?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleaseEditLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleaseEditLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReleaseEditLock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Executes a mass edit according to the input parameters
     * @param body (optional) 
     * @return Success
     */
    executeMassEdit(body: ExecuteMassEditInput | undefined): Observable<ExecuteMassEditOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/ExecuteMassEdit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteMassEdit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteMassEdit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExecuteMassEditOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExecuteMassEditOutput>;
        }));
    }

    protected processExecuteMassEdit(response: HttpResponseBase): Observable<ExecuteMassEditOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExecuteMassEditOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    notifyMassEditCompleted(body: NotifyMassEditCompletedInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/NotifyMassEditCompleted";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyMassEditCompleted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyMassEditCompleted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processNotifyMassEditCompleted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Creates a complete activity report with provided information. The report is labeled as finished.
     * @param body (optional) 
     * @return Success
     */
    createWoodActivityReport(body: CreateManualWoodActivityReportInput | undefined): Observable<CreateWoodActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/CreateWoodActivityReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodActivityReportOutput>;
        }));
    }

    protected processCreateWoodActivityReport(response: HttpResponseBase): Observable<CreateWoodActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates an existing activity report with provided information. Used to complete report on entrance truck
     * @param body (optional) 
     * @return Success
     */
    updateWoodActivityReportWithEntranceInformation(body: CreateManualWoodActivityReportInput | undefined): Observable<CreateWoodActivityReportOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/UpdateWoodActivityReportWithEntranceInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWoodActivityReportWithEntranceInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWoodActivityReportWithEntranceInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateWoodActivityReportOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateWoodActivityReportOutput>;
        }));
    }

    protected processUpdateWoodActivityReportWithEntranceInformation(response: HttpResponseBase): Observable<CreateWoodActivityReportOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateWoodActivityReportOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param preActivityReportId (optional) 
     * @param includeDeletedReceipts (optional) 
     * @return Success
     */
    getPreActivityReportStatusForProviders(preActivityReportId: number | undefined, includeDeletedReceipts: boolean | undefined): Observable<PreActivityReportStatusOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetPreActivityReportStatusForProviders?";
        if (preActivityReportId === null)
            throw new Error("The parameter 'preActivityReportId' cannot be null.");
        else if (preActivityReportId !== undefined)
            url_ += "preActivityReportId=" + encodeURIComponent("" + preActivityReportId) + "&";
        if (includeDeletedReceipts === null)
            throw new Error("The parameter 'includeDeletedReceipts' cannot be null.");
        else if (includeDeletedReceipts !== undefined)
            url_ += "includeDeletedReceipts=" + encodeURIComponent("" + includeDeletedReceipts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreActivityReportStatusForProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreActivityReportStatusForProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportStatusOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportStatusOutput>;
        }));
    }

    protected processGetPreActivityReportStatusForProviders(response: HttpResponseBase): Observable<PreActivityReportStatusOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreActivityReportStatusOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updatePreActivityReportDriverForProviders(body: UpdatePreActivityReportDriverForProvidersInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/UpdatePreActivityReportDriverForProviders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePreActivityReportDriverForProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePreActivityReportDriverForProviders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdatePreActivityReportDriverForProviders(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param tripNumber (optional) 
     * @param originExternalId (optional) 
     * @param licensePlate (optional) 
     * @return Success
     */
    getExitWoodActivityReportByTripNumberOrDefault(tripNumber: number | undefined, originExternalId: number | undefined, licensePlate: string | undefined): Observable<WoodActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetExitWoodActivityReportByTripNumberOrDefault?";
        if (tripNumber === null)
            throw new Error("The parameter 'tripNumber' cannot be null.");
        else if (tripNumber !== undefined)
            url_ += "tripNumber=" + encodeURIComponent("" + tripNumber) + "&";
        if (originExternalId === null)
            throw new Error("The parameter 'originExternalId' cannot be null.");
        else if (originExternalId !== undefined)
            url_ += "originExternalId=" + encodeURIComponent("" + originExternalId) + "&";
        if (licensePlate === null)
            throw new Error("The parameter 'licensePlate' cannot be null.");
        else if (licensePlate !== undefined)
            url_ += "licensePlate=" + encodeURIComponent("" + licensePlate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExitWoodActivityReportByTripNumberOrDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExitWoodActivityReportByTripNumberOrDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportDto>;
        }));
    }

    protected processGetExitWoodActivityReportByTripNumberOrDefault(response: HttpResponseBase): Observable<WoodActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param receiptId (optional) 
     * @return Success
     */
    getLoadActivityReportId(receiptId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetLoadActivityReportId?";
        if (receiptId === null)
            throw new Error("The parameter 'receiptId' cannot be null.");
        else if (receiptId !== undefined)
            url_ += "receiptId=" + encodeURIComponent("" + receiptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoadActivityReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoadActivityReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetLoadActivityReportId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns an activity report by id.
     * @param id (optional) Activity Report Identifier
     * @return Success
     */
    getWoodActivityReport(id: number | undefined): Observable<WoodControlActivityReportDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodActivityReport?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodControlActivityReportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodControlActivityReportDto>;
        }));
    }

    protected processGetWoodActivityReport(response: HttpResponseBase): Observable<WoodControlActivityReportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodControlActivityReportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Executes the deletion of the scanner sample
     * @param reportId (optional) 
     * @return Success
     */
    deleteScannerSample(reportId: number | undefined): Observable<DeleteScannerResultsOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/DeleteScannerSample?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteScannerSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteScannerSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteScannerResultsOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteScannerResultsOutputDto>;
        }));
    }

    protected processDeleteScannerSample(response: HttpResponseBase): Observable<DeleteScannerResultsOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteScannerResultsOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get pre report contract information for entry
     * @param preActivityReportId (optional) 
     * @return Success
     */
    getPreReportContractInformationForEntry(preActivityReportId: number | undefined): Observable<PreReportContractInformation> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetPreReportContractInformationForEntry?";
        if (preActivityReportId === null)
            throw new Error("The parameter 'preActivityReportId' cannot be null.");
        else if (preActivityReportId !== undefined)
            url_ += "preActivityReportId=" + encodeURIComponent("" + preActivityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPreReportContractInformationForEntry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPreReportContractInformationForEntry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreReportContractInformation>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreReportContractInformation>;
        }));
    }

    protected processGetPreReportContractInformationForEntry(response: HttpResponseBase): Observable<PreReportContractInformation> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PreReportContractInformation.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood pre report photo
     * @param woodPreReportId (optional) Wood pre report id
     * @return Success
     */
    getWoodPreActivityReportPhotoByPreReportId(woodPreReportId: number | undefined): Observable<WoodPreReportPhotoOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodPreActivityReportPhotoByPreReportId?";
        if (woodPreReportId === null)
            throw new Error("The parameter 'woodPreReportId' cannot be null.");
        else if (woodPreReportId !== undefined)
            url_ += "woodPreReportId=" + encodeURIComponent("" + woodPreReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreActivityReportPhotoByPreReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreActivityReportPhotoByPreReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodPreReportPhotoOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodPreReportPhotoOutputDto>;
        }));
    }

    protected processGetWoodPreActivityReportPhotoByPreReportId(response: HttpResponseBase): Observable<WoodPreReportPhotoOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodPreReportPhotoOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood pre reports to arrive
     * @param hours (optional) 
     * @param destinationExternalId (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getWoodPreActivityReportsToArrive(hours: number | undefined, destinationExternalId: number | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfGetPreReportsToArriveOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodPreActivityReportsToArrive?";
        if (hours === null)
            throw new Error("The parameter 'hours' cannot be null.");
        else if (hours !== undefined)
            url_ += "Hours=" + encodeURIComponent("" + hours) + "&";
        if (destinationExternalId === null)
            throw new Error("The parameter 'destinationExternalId' cannot be null.");
        else if (destinationExternalId !== undefined)
            url_ += "DestinationExternalId=" + encodeURIComponent("" + destinationExternalId) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreActivityReportsToArrive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreActivityReportsToArrive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfGetPreReportsToArriveOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfGetPreReportsToArriveOutputDto>;
        }));
    }

    protected processGetWoodPreActivityReportsToArrive(response: HttpResponseBase): Observable<PagedResultDtoOfGetPreReportsToArriveOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfGetPreReportsToArriveOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete load activity report
     * @param reportId (optional) Wood report id
     * @return Success
     */
    deleteLoadActivityReport(reportId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/DeleteLoadActivityReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLoadActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLoadActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteLoadActivityReport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getWoodActivityReportSemitrailers(reportId: number | undefined): Observable<TruckVehicleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodActivityReportSemitrailers?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportSemitrailers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportSemitrailers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TruckVehicleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TruckVehicleDto[]>;
        }));
    }

    protected processGetWoodActivityReportSemitrailers(response: HttpResponseBase): Observable<TruckVehicleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TruckVehicleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Verifies if the activity report has a pre-activity report.
     * @param reportId (optional) The ID of the wood report.
     * @return Success
     */
    activityReportHasPreActivityReport(reportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/ActivityReportHasPreActivityReport?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActivityReportHasPreActivityReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActivityReportHasPreActivityReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processActivityReportHasPreActivityReport(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the creation mode of a wood pre-activity report.
     * @param woodPreReportId (optional) The ID of the wood pre-activity report.
     * @return Success
     */
    getWoodPreActivityReportCreationMode(woodPreReportId: number | undefined): Observable<PreActivityReportCreationMode> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodPreActivityReportCreationMode?";
        if (woodPreReportId === null)
            throw new Error("The parameter 'woodPreReportId' cannot be null.");
        else if (woodPreReportId !== undefined)
            url_ += "woodPreReportId=" + encodeURIComponent("" + woodPreReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodPreActivityReportCreationMode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodPreActivityReportCreationMode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PreActivityReportCreationMode>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PreActivityReportCreationMode>;
        }));
    }

    protected processGetWoodPreActivityReportCreationMode(response: HttpResponseBase): Observable<PreActivityReportCreationMode> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the scheduled turn for a wood pre-activity report.
     * @param woodPreReportId (optional) The ID of the wood pre-activity report.
     * @return Success
     */
    getScheduleTurnByWoodPreReportId(woodPreReportId: number | undefined): Observable<DateTime> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetScheduleTurnByWoodPreReportId?";
        if (woodPreReportId === null)
            throw new Error("The parameter 'woodPreReportId' cannot be null.");
        else if (woodPreReportId !== undefined)
            url_ += "woodPreReportId=" + encodeURIComponent("" + woodPreReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScheduleTurnByWoodPreReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScheduleTurnByWoodPreReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DateTime>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DateTime>;
        }));
    }

    protected processGetScheduleTurnByWoodPreReportId(response: HttpResponseBase): Observable<DateTime> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 ? DateTime.fromISO(resultData200.toString()) : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 ? DateTime.fromISO(resultData204.toString()) : <any>null;
    
            return _observableOf(result204);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Indicates whether there is GeoLocation information associated with a wood activity report.
     * @param reportId (optional) The ID of the wood activity report.
     * @return Success
     */
    hasWoodActivityReportGeoLocationInformation(reportId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/HasWoodActivityReportGeoLocationInformation?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasWoodActivityReportGeoLocationInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasWoodActivityReportGeoLocationInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processHasWoodActivityReportGeoLocationInformation(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the geo-location information for a wood activity report.
     * @param reportId (optional) The ID of the wood activity report.
     * @param originalStandName (optional) The stand name associated to the wood activity report.
     * @return Success
     */
    getWoodActivityReportGeoLocationInformationData(reportId: number | undefined, originalStandName: string | undefined): Observable<WoodActivityReportGeoLocationInformationDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodActivityReportGeoLocationInformationData?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        if (originalStandName === null)
            throw new Error("The parameter 'originalStandName' cannot be null.");
        else if (originalStandName !== undefined)
            url_ += "originalStandName=" + encodeURIComponent("" + originalStandName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportGeoLocationInformationData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportGeoLocationInformationData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportGeoLocationInformationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportGeoLocationInformationDto>;
        }));
    }

    protected processGetWoodActivityReportGeoLocationInformationData(response: HttpResponseBase): Observable<WoodActivityReportGeoLocationInformationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodActivityReportGeoLocationInformationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Method that apply partial modifications over Wood Activity report.
     * @param id (optional) Wood Activity Report Identifier
     * @param body (optional) 
     * @return Success
     */
    patch(id: number | undefined, body: Operation[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/Patch?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPatch(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Calculates and returns the total average diameter based on the provided average diameter input.
     * @param standExternalId (optional) 
     * @param articleExternalId (optional) 
     * @return Success
     */
    getTotalAverageDiameterCalculatedByAverageDiameter(standExternalId: number | undefined, articleExternalId: number | undefined): Observable<TotalAverageDiameterCalculatedOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetTotalAverageDiameterCalculatedByAverageDiameter?";
        if (standExternalId === null)
            throw new Error("The parameter 'standExternalId' cannot be null.");
        else if (standExternalId !== undefined)
            url_ += "StandExternalId=" + encodeURIComponent("" + standExternalId) + "&";
        if (articleExternalId === null)
            throw new Error("The parameter 'articleExternalId' cannot be null.");
        else if (articleExternalId !== undefined)
            url_ += "ArticleExternalId=" + encodeURIComponent("" + articleExternalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAverageDiameterCalculatedByAverageDiameter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAverageDiameterCalculatedByAverageDiameter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TotalAverageDiameterCalculatedOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TotalAverageDiameterCalculatedOutputDto>;
        }));
    }

    protected processGetTotalAverageDiameterCalculatedByAverageDiameter(response: HttpResponseBase): Observable<TotalAverageDiameterCalculatedOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TotalAverageDiameterCalculatedOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get wood activity report sample by activity report id
     * @param woodActivityReportId (optional) Wood activity report id
     * @return Success
     */
    getWoodActivityReportSample(woodActivityReportId: number | undefined): Observable<WoodActivityReportSampleDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/GetWoodActivityReportSample?";
        if (woodActivityReportId === null)
            throw new Error("The parameter 'woodActivityReportId' cannot be null.");
        else if (woodActivityReportId !== undefined)
            url_ += "woodActivityReportId=" + encodeURIComponent("" + woodActivityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodActivityReportSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodActivityReportSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodActivityReportSampleDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodActivityReportSampleDto>;
        }));
    }

    protected processGetWoodActivityReportSample(response: HttpResponseBase): Observable<WoodActivityReportSampleDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodActivityReportSampleDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the estimated volume for a specific wood activity report.
     * @param woodActivityReportId (optional) Identifier of the wood activity report.
     * @param estimatedVolume (optional) New estimated volume value to assign.
     * @return Success
     */
    updateEstimatedVolume(woodActivityReportId: number | undefined, estimatedVolume: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodActivityReport/UpdateEstimatedVolume?";
        if (woodActivityReportId === null)
            throw new Error("The parameter 'woodActivityReportId' cannot be null.");
        else if (woodActivityReportId !== undefined)
            url_ += "woodActivityReportId=" + encodeURIComponent("" + woodActivityReportId) + "&";
        if (estimatedVolume === null)
            throw new Error("The parameter 'estimatedVolume' cannot be null.");
        else if (estimatedVolume !== undefined)
            url_ += "estimatedVolume=" + encodeURIComponent("" + estimatedVolume) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateEstimatedVolume(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateEstimatedVolume(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateEstimatedVolume(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodScannerServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Notification successful
     */
    notifyResult(body: ScannerNotificationInputDto | undefined): Observable<NotifyResultOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/NotifyResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<NotifyResultOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<NotifyResultOutput>;
        }));
    }

    protected processNotifyResult(response: HttpResponseBase): Observable<NotifyResultOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotifyResultOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Report not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Validation error", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorResponse.fromJS(resultData500);
            return throwException("Internal error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    mapInformationForScanner(body: MapInformationForScannerInput | undefined): Observable<MapInformationForScannerOutput> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/MapInformationForScanner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMapInformationForScanner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMapInformationForScanner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MapInformationForScannerOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MapInformationForScannerOutput>;
        }));
    }

    protected processMapInformationForScanner(response: HttpResponseBase): Observable<MapInformationForScannerOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MapInformationForScannerOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param reportId (optional) 
     * @return Success
     */
    getScannerResults(reportId: number | undefined): Observable<LogmeterIntegrationDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/GetScannerResults?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannerResults(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannerResults(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogmeterIntegrationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogmeterIntegrationDto>;
        }));
    }

    protected processGetScannerResults(response: HttpResponseBase): Observable<LogmeterIntegrationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogmeterIntegrationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Not found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Internal error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves the packages of the scanner result of a given report
     * @param reportId (optional) Report
     * @return Success
     */
    getLogmeterPackagesForBarkSample(reportId: number | undefined): Observable<LogmeterPackageForBarkSampleDto[]> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/GetLogmeterPackagesForBarkSample?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLogmeterPackagesForBarkSample(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLogmeterPackagesForBarkSample(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogmeterPackageForBarkSampleDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogmeterPackageForBarkSampleDto[]>;
        }));
    }

    protected processGetLogmeterPackagesForBarkSample(response: HttpResponseBase): Observable<LogmeterPackageForBarkSampleDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogmeterPackageForBarkSampleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns scanner summary
     * @param reportId (optional) 
     * @return Success
     */
    getScannerSummary(reportId: number | undefined): Observable<ScannerInformationOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/GetScannerSummary?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "reportId=" + encodeURIComponent("" + reportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetScannerSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetScannerSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ScannerInformationOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ScannerInformationOutputDto>;
        }));
    }

    protected processGetScannerSummary(response: HttpResponseBase): Observable<ScannerInformationOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ScannerInformationOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get density range for scanner send signal
     * @param reportId (optional) 
     * @param woodOriginExternalId (optional) 
     * @param speciesGroupId (optional) 
     * @param placeId (optional) 
     * @param externalArticleId (optional) 
     * @return Success
     */
    getDensityRangeForScannerSendSignal(reportId: number | undefined, woodOriginExternalId: number | undefined, speciesGroupId: number | undefined, placeId: number | undefined, externalArticleId: number | undefined): Observable<DensityRangeOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/GetDensityRangeForScannerSendSignal?";
        if (reportId === null)
            throw new Error("The parameter 'reportId' cannot be null.");
        else if (reportId !== undefined)
            url_ += "ReportId=" + encodeURIComponent("" + reportId) + "&";
        if (woodOriginExternalId === null)
            throw new Error("The parameter 'woodOriginExternalId' cannot be null.");
        else if (woodOriginExternalId !== undefined)
            url_ += "WoodOriginExternalId=" + encodeURIComponent("" + woodOriginExternalId) + "&";
        if (speciesGroupId === null)
            throw new Error("The parameter 'speciesGroupId' cannot be null.");
        else if (speciesGroupId !== undefined)
            url_ += "SpeciesGroupId=" + encodeURIComponent("" + speciesGroupId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        if (externalArticleId === null)
            throw new Error("The parameter 'externalArticleId' cannot be null.");
        else if (externalArticleId !== undefined)
            url_ += "ExternalArticleId=" + encodeURIComponent("" + externalArticleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDensityRangeForScannerSendSignal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDensityRangeForScannerSendSignal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DensityRangeOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DensityRangeOutputDto>;
        }));
    }

    protected processGetDensityRangeForScannerSendSignal(response: HttpResponseBase): Observable<DensityRangeOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DensityRangeOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param activityReportId (optional) 
     * @param periodExternalId (optional) 
     * @param driverExternalId (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    hasAbortedSpeedScannerResult(activityReportId: number | undefined, periodExternalId: number | undefined, driverExternalId: number | undefined, placeId: number | undefined): Observable<HasAbortedSpeedScannerResultOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodScanner/HasAbortedSpeedScannerResult?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "ActivityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        if (periodExternalId === null)
            throw new Error("The parameter 'periodExternalId' cannot be null.");
        else if (periodExternalId !== undefined)
            url_ += "PeriodExternalId=" + encodeURIComponent("" + periodExternalId) + "&";
        if (driverExternalId === null)
            throw new Error("The parameter 'driverExternalId' cannot be null.");
        else if (driverExternalId !== undefined)
            url_ += "DriverExternalId=" + encodeURIComponent("" + driverExternalId) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "PlaceId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHasAbortedSpeedScannerResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHasAbortedSpeedScannerResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HasAbortedSpeedScannerResultOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HasAbortedSpeedScannerResultOutputDto>;
        }));
    }

    protected processHasAbortedSpeedScannerResult(response: HttpResponseBase): Observable<HasAbortedSpeedScannerResultOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HasAbortedSpeedScannerResultOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodTruckTypeServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUpdate(body: WoodTruckTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodTruckType/CreateUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param woodTruckTypeId (optional) 
     * @return Success
     */
    delete(woodTruckTypeId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodTruckType/Delete?";
        if (woodTruckTypeId === null)
            throw new Error("The parameter 'woodTruckTypeId' cannot be null.");
        else if (woodTruckTypeId !== undefined)
            url_ += "woodTruckTypeId=" + encodeURIComponent("" + woodTruckTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAll(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfWoodTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodTruckType/GetAll?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "skipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "maxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfWoodTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfWoodTruckTypeDto>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<PagedResultDtoOfWoodTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfWoodTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param woodTruckTypeId (optional) 
     * @return Success
     */
    getById(woodTruckTypeId: number | undefined): Observable<WoodTruckTypeDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodTruckType/GetById?";
        if (woodTruckTypeId === null)
            throw new Error("The parameter 'woodTruckTypeId' cannot be null.");
        else if (woodTruckTypeId !== undefined)
            url_ += "woodTruckTypeId=" + encodeURIComponent("" + woodTruckTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodTruckTypeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodTruckTypeDto>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<WoodTruckTypeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodTruckTypeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class WoodVendorQuotaServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Search for wood vendors
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    searchWoodVendorQuotas(skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfSearchWoodVendorQuotaOutputDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodVendorQuota/SearchWoodVendorQuotas?";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchWoodVendorQuotas(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchWoodVendorQuotas(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfSearchWoodVendorQuotaOutputDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfSearchWoodVendorQuotaOutputDto>;
        }));
    }

    protected processSearchWoodVendorQuotas(response: HttpResponseBase): Observable<PagedResultDtoOfSearchWoodVendorQuotaOutputDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfSearchWoodVendorQuotaOutputDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create's a wood provider
     * @param body (optional) A class containing the external id of the providers, the hourly quota, and the tolerance
     * @return Success
     */
    createWoodVendorQuota(body: CreateWoodVendorQuotaInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodVendorQuota/CreateWoodVendorQuota";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateWoodVendorQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateWoodVendorQuota(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateWoodVendorQuota(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's a wood vendor by it's id
     * @param woodVendorQuotaId (optional) The wood vendor quota id
     * @return Success
     */
    getWoodVendorQuotaById(woodVendorQuotaId: number | undefined): Observable<WoodVendorQuotaDto> {
        let url_ = this.baseUrl + "/api/services/app/WoodVendorQuota/GetWoodVendorQuotaById?";
        if (woodVendorQuotaId === null)
            throw new Error("The parameter 'woodVendorQuotaId' cannot be null.");
        else if (woodVendorQuotaId !== undefined)
            url_ += "woodVendorQuotaId=" + encodeURIComponent("" + woodVendorQuotaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWoodVendorQuotaById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWoodVendorQuotaById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WoodVendorQuotaDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WoodVendorQuotaDto>;
        }));
    }

    protected processGetWoodVendorQuotaById(response: HttpResponseBase): Observable<WoodVendorQuotaDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WoodVendorQuotaDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a wood vendor
     * @param body (optional) A class containing the information of the wood vendor
     * @return Success
     */
    updateWoodVendor(body: WoodVendorQuotaDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodVendorQuota/UpdateWoodVendor";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateWoodVendor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateWoodVendor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateWoodVendor(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete's a wood vendor by it's id
     * @param woodVendorQuotaId (optional) The wood vendor id
     * @return Success
     */
    deleteWoodVendorQuota(woodVendorQuotaId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/WoodVendorQuota/DeleteWoodVendorQuota?";
        if (woodVendorQuotaId === null)
            throw new Error("The parameter 'woodVendorQuotaId' cannot be null.");
        else if (woodVendorQuotaId !== undefined)
            url_ += "woodVendorQuotaId=" + encodeURIComponent("" + woodVendorQuotaId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteWoodVendorQuota(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteWoodVendorQuota(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteWoodVendorQuota(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZonesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all the zones given the user permissions
     * @param zoneType (optional) 
     * @param filter (optional) 
     * @param sorting (optional) 
     * @param skipCount (optional) 
     * @param maxResultCount (optional) 
     * @return Success
     */
    getAllZones(zoneType: number | undefined, filter: string | undefined, sorting: string | undefined, skipCount: number | undefined, maxResultCount: number | undefined): Observable<PagedResultDtoOfZoneInCollectionDto> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetAllZones?";
        if (zoneType === null)
            throw new Error("The parameter 'zoneType' cannot be null.");
        else if (zoneType !== undefined)
            url_ += "ZoneType=" + encodeURIComponent("" + zoneType) + "&";
        if (filter === null)
            throw new Error("The parameter 'filter' cannot be null.");
        else if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (sorting === null)
            throw new Error("The parameter 'sorting' cannot be null.");
        else if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PagedResultDtoOfZoneInCollectionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PagedResultDtoOfZoneInCollectionDto>;
        }));
    }

    protected processGetAllZones(response: HttpResponseBase): Observable<PagedResultDtoOfZoneInCollectionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultDtoOfZoneInCollectionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all the zones to place dropdown creation or edition
     * @return Success
     */
    getAllZonesToPlaceCombo(): Observable<ZonesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetAllZonesToPlaceCombo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllZonesToPlaceCombo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllZonesToPlaceCombo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZonesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZonesDto[]>;
        }));
    }

    protected processGetAllZonesToPlaceCombo(response: HttpResponseBase): Observable<ZonesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZonesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a zone by Id given the user permissions
     * @param zoneId (optional) 
     * @return Success
     */
    getZoneById(zoneId: number | undefined): Observable<ZonesDto> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetZoneById?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetZoneById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetZoneById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZonesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZonesDto>;
        }));
    }

    protected processGetZoneById(response: HttpResponseBase): Observable<ZonesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZonesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Create a new zone given the user permissions
    It has a validation to avoid that in one place does not have two zones active with the same mode
     * @param body (optional) 
     * @return Success
     */
    createZone(body: ZonesDtoInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Zones/CreateZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update a new zone given the user permissions
     * @param body (optional) 
     * @return Success
     */
    updateZone(body: ZonesDtoUpdateInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Zones/UpdateZone";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpdateZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Delete an specific zone given the user permissions
     * @param zoneId (optional) 
     * @return Success
     */
    deleteZone(zoneId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/app/Zones/DeleteZone?";
        if (zoneId === null)
            throw new Error("The parameter 'zoneId' cannot be null.");
        else if (zoneId !== undefined)
            url_ += "zoneId=" + encodeURIComponent("" + zoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteZone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteZone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteZone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ErrorResponse.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets an specific zone by zone type id
     * @param isEntrance (optional) 
     * @param placeId (optional) 
     * @return Success
     */
    getVehicleFlowsZones(isEntrance: boolean | undefined, placeId: number | undefined): Observable<ZonesDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetVehicleFlowsZones?";
        if (isEntrance === null)
            throw new Error("The parameter 'isEntrance' cannot be null.");
        else if (isEntrance !== undefined)
            url_ += "isEntrance=" + encodeURIComponent("" + isEntrance) + "&";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVehicleFlowsZones(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVehicleFlowsZones(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZonesDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZonesDto[]>;
        }));
    }

    protected processGetVehicleFlowsZones(response: HttpResponseBase): Observable<ZonesDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZonesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param isWoodLog (optional) 
     * @return Success
     */
    getInternalDestinationZonesByCurrentPlace(isWoodLog: boolean | undefined): Observable<ZoneInCollectionDto[]> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetInternalDestinationZonesByCurrentPlace?";
        if (isWoodLog === null)
            throw new Error("The parameter 'isWoodLog' cannot be null.");
        else if (isWoodLog !== undefined)
            url_ += "isWoodLog=" + encodeURIComponent("" + isWoodLog) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInternalDestinationZonesByCurrentPlace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInternalDestinationZonesByCurrentPlace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneInCollectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneInCollectionDto[]>;
        }));
    }

    protected processGetInternalDestinationZonesByCurrentPlace(response: HttpResponseBase): Observable<ZoneInCollectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneInCollectionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the totem zone Id by current session user
     * @return Success
     */
    getTotemZoneByUser(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetTotemZoneByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotemZoneByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotemZoneByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotemZoneByUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the detour zone Id by current session user
     * @return Success
     */
    getDetourZoneByUser(): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetDetourZoneByUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetourZoneByUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetourZoneByUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetDetourZoneByUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a zone by destination given the user permissions
     * @param destination (optional) 
     * @return Success
     */
    getByInternalDestinationId(destination: string | undefined): Observable<ZonesDto> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetByInternalDestinationId?";
        if (destination === null)
            throw new Error("The parameter 'destination' cannot be null.");
        else if (destination !== undefined)
            url_ += "destination=" + encodeURIComponent("" + destination) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByInternalDestinationId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByInternalDestinationId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZonesDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZonesDto>;
        }));
    }

    protected processGetByInternalDestinationId(response: HttpResponseBase): Observable<ZonesDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ZonesDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the detour zone Id by placeId
     * @param placeId (optional) 
     * @return Success
     */
    getDetourZoneByPlaceId(placeId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetDetourZoneByPlaceId?";
        if (placeId === null)
            throw new Error("The parameter 'placeId' cannot be null.");
        else if (placeId !== undefined)
            url_ += "placeId=" + encodeURIComponent("" + placeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetourZoneByPlaceId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetourZoneByPlaceId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetDetourZoneByPlaceId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get the totem zone by activityReportId
     * @param activityReportId (optional) 
     * @return Success
     */
    getTotemZoneIdByActivityReportId(activityReportId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/services/app/Zones/GetTotemZoneIdByActivityReportId?";
        if (activityReportId === null)
            throw new Error("The parameter 'activityReportId' cannot be null.");
        else if (activityReportId !== undefined)
            url_ += "activityReportId=" + encodeURIComponent("" + activityReportId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotemZoneIdByActivityReportId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotemZoneIdByActivityReportId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetTotemZoneIdByActivityReportId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class ZoneTypesServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllZoneTypes(): Observable<ZoneTypeDto[]> {
        let url_ = this.baseUrl + "/api/services/app/ZoneTypes/GetAllZoneTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllZoneTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllZoneTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ZoneTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ZoneTypeDto[]>;
        }));
    }

    protected processGetAllZoneTypes(response: HttpResponseBase): Observable<ZoneTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ZoneTypeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class AbpUserConfigurationServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Current user configuration endpoint
     * @return Success
     */
    getAll(): Observable<void> {
        let url_ = this.baseUrl + "/AbpUserConfiguration/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AcceptFriendshipRequestInput implements IAcceptFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IAcceptFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): AcceptFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IAcceptFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class AccessCardReaderDto implements IAccessCardReaderDto {
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: IAccessCardReaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AccessCardReaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccessCardReaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IAccessCardReaderDto {
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export class AcquireMassEditLockInput implements IAcquireMassEditLockInput {
    reportIds!: number[] | undefined;

    constructor(data?: IAcquireMassEditLockInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportIds"])) {
                this.reportIds = [] as any;
                for (let item of _data["reportIds"])
                    this.reportIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AcquireMassEditLockInput {
        data = typeof data === 'object' ? data : {};
        let result = new AcquireMassEditLockInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportIds)) {
            data["reportIds"] = [];
            for (let item of this.reportIds)
                data["reportIds"].push(item);
        }
        return data;
    }
}

export interface IAcquireMassEditLockInput {
    reportIds: number[] | undefined;
}

export class ActionDto implements IActionDto {
    name!: string | undefined;
    contacts!: ContactDto[] | undefined;
    id!: number;

    constructor(data?: IActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IActionDto {
    name: string | undefined;
    contacts: ContactDto[] | undefined;
    id: number;
}

export class ActivateEmailInput implements IActivateEmailInput {
    userId!: number;
    confirmationCode!: string | undefined;
    c!: string | undefined;

    constructor(data?: IActivateEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.confirmationCode = _data["confirmationCode"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ActivateEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    }
}

export interface IActivateEmailInput {
    userId: number;
    confirmationCode: string | undefined;
    c: string | undefined;
}

export class ActiveReceiptOutputDto implements IActiveReceiptOutputDto {
    reportId!: number;
    reportType!: ActivityReportType | undefined;
    error!: boolean;
    errorMessage!: string | undefined;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    grossWeightValue!: number;
    tareWeightValue!: number;
    licensePlate!: string | undefined;

    constructor(data?: IActiveReceiptOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportType = _data["reportType"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.grossWeightValue = _data["grossWeightValue"];
            this.tareWeightValue = _data["tareWeightValue"];
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): ActiveReceiptOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveReceiptOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportType"] = this.reportType;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["grossWeightValue"] = this.grossWeightValue;
        data["tareWeightValue"] = this.tareWeightValue;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface IActiveReceiptOutputDto {
    reportId: number;
    reportType: ActivityReportType | undefined;
    error: boolean;
    errorMessage: string | undefined;
    driverExternalId: number;
    driverVendorExternalId: number;
    grossWeightValue: number;
    tareWeightValue: number;
    licensePlate: string | undefined;
}

export enum ActivityReportCreationSystem {
    SmartAccess = "SmartAccess",
    SmartTruck = "SmartTruck",
    ProvidersModule = "ProvidersModule",
    Api = "Api",
    Totem = "Totem",
}

export class ActivityReportDeletionResultDto implements IActivityReportDeletionResultDto {
    success!: boolean;
    reason!: string | undefined;

    constructor(data?: IActivityReportDeletionResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): ActivityReportDeletionResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReportDeletionResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IActivityReportDeletionResultDto {
    success: boolean;
    reason: string | undefined;
}

export class ActivityReportLineDto implements IActivityReportLineDto {
    tenantId!: number;
    article!: ArticleDto | undefined;
    stand!: StandDto | undefined;
    contract!: ContractDto | undefined;
    articleId!: number;
    services!: ServiceDto[] | undefined;
    origin!: LocationDto | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;

    constructor(data?: IActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.article = _data["article"] ? ArticleDto.fromJS(_data["article"]) : <any>undefined;
            this.stand = _data["stand"] ? StandDto.fromJS(_data["stand"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.articleId = _data["articleId"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceDto.fromJS(item));
            }
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
        }
    }

    static fromJS(data: any): ActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["articleId"] = this.articleId;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        return data;
    }
}

export interface IActivityReportLineDto {
    tenantId: number;
    article: ArticleDto | undefined;
    stand: StandDto | undefined;
    contract: ContractDto | undefined;
    articleId: number;
    services: ServiceDto[] | undefined;
    origin: LocationDto | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
}

export class ActivityReportLogDto implements IActivityReportLogDto {
    localActivityReportId!: number | undefined;
    tenantId!: number;
    activityReportId!: number;
    date!: DateTime;
    operation!: WoodControlActivityReportLogOperation;
    user!: string | undefined;
    system!: ExternalSystemDto | undefined;
    ok!: boolean;
    resultDescription!: string | undefined;

    constructor(data?: IActivityReportLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localActivityReportId = _data["localActivityReportId"];
            this.tenantId = _data["tenantId"];
            this.activityReportId = _data["activityReportId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.operation = _data["operation"];
            this.user = _data["user"];
            this.system = _data["system"] ? ExternalSystemDto.fromJS(_data["system"]) : <any>undefined;
            this.ok = _data["ok"];
            this.resultDescription = _data["resultDescription"];
        }
    }

    static fromJS(data: any): ActivityReportLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReportLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localActivityReportId"] = this.localActivityReportId;
        data["tenantId"] = this.tenantId;
        data["activityReportId"] = this.activityReportId;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["operation"] = this.operation;
        data["user"] = this.user;
        data["system"] = this.system ? this.system.toJSON() : <any>undefined;
        data["ok"] = this.ok;
        data["resultDescription"] = this.resultDescription;
        return data;
    }
}

export interface IActivityReportLogDto {
    localActivityReportId: number | undefined;
    tenantId: number;
    activityReportId: number;
    date: DateTime;
    operation: WoodControlActivityReportLogOperation;
    user: string | undefined;
    system: ExternalSystemDto | undefined;
    ok: boolean;
    resultDescription: string | undefined;
}

export class ActivityReportNumberRangeAssignmentDto implements IActivityReportNumberRangeAssignmentDto {
    id!: number;
    userId!: number;
    deviceId!: string;
    placeId!: number;
    rangeStart!: number;
    rangeEnding!: number;

    constructor(data?: IActivityReportNumberRangeAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.deviceId = _data["deviceId"];
            this.placeId = _data["placeId"];
            this.rangeStart = _data["rangeStart"];
            this.rangeEnding = _data["rangeEnding"];
        }
    }

    static fromJS(data: any): ActivityReportNumberRangeAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityReportNumberRangeAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["deviceId"] = this.deviceId;
        data["placeId"] = this.placeId;
        data["rangeStart"] = this.rangeStart;
        data["rangeEnding"] = this.rangeEnding;
        return data;
    }
}

export interface IActivityReportNumberRangeAssignmentDto {
    id: number;
    userId: number;
    deviceId: string;
    placeId: number;
    rangeStart: number;
    rangeEnding: number;
}

export enum ActivityReportOperationMode {
    Entrance = "Entrance",
    Exit = "Exit",
}

export enum ActivityReportState {
    PreActivityReport = "PreActivityReport",
    Entering = "Entering",
    InPlace = "InPlace",
    Leaving = "Leaving",
    Finished = "Finished",
    Rejected = "Rejected",
}

export enum ActivityReportStateCondition {
    InError = "InError",
    OK = "OK",
    ConditionalProcess = "ConditionalProcess",
    ConditionalExit = "ConditionalExit",
}

export enum ActivityReportSystemReasons {
    None = "None",
    MinValueScaleDetected = "MinValueScaleDetected",
    WildCardAccessCard = "WildCardAccessCard",
    DriverNotValid = "DriverNotValid",
    DuaNotValid = "DuaNotValid",
    LicensePlateNotFound = "LicensePlateNotFound",
    MissingTravelByPlate = "MissingTravelByPlate",
    MissingTravelInvoice = "MissingTravelInvoice",
    TravelStatusInvalid = "TravelStatusInvalid",
    VehicleNotValid = "VehicleNotValid",
    VehicleNotFound = "VehicleNotFound",
    StandNotFound = "StandNotFound",
    ArticleByStandNotFound = "ArticleByStandNotFound",
    ArticleNotFound = "ArticleNotFound",
    ContractNotFound = "ContractNotFound",
    DuaNotFound = "DuaNotFound",
    DuasDifferents = "DuasDifferents",
    InvalidLoaderService = "InvalidLoaderService",
    IncompleteDiverseProduct = "IncompleteDiverseProduct",
    ScaleErrorDetected = "ScaleErrorDetected",
    AccessCardErrorDetected = "AccessCardErrorDetected",
    ErrorProcessingExitIntegrations = "ErrorProcessingExitIntegrations",
    InvalidatingLeavingReport = "InvalidatingLeavingReport",
    IncompleteInternalMovements = "IncompleteInternalMovements",
    ContractDoesntAllowDevicesInactive = "ContractDoesntAllowDevicesInactive",
}

export enum ActivityReportType {
    None = "None",
    WoodActivityReport = "WoodActivityReport",
    DiverseProductActivityReport = "DiverseProductActivityReport",
    InternalMovementsActivityReport = "InternalMovementsActivityReport",
}

export enum ActualState {
    Inactive = "Inactive",
    Active = "Active",
    Maintenance = "Maintenance",
}

export class AddNewPageInput implements IAddNewPageInput {
    dashboardName!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IAddNewPageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddNewPageInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddNewPageInput {
    dashboardName: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class AddNewPageOutput implements IAddNewPageOutput {
    pageId!: string | undefined;

    constructor(data?: IAddNewPageOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageId = _data["pageId"];
        }
    }

    static fromJS(data: any): AddNewPageOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewPageOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageId"] = this.pageId;
        return data;
    }
}

export interface IAddNewPageOutput {
    pageId: string | undefined;
}

export class AddNewScannerCalibrationEventDto implements IAddNewScannerCalibrationEventDto {
    ordinal!: number;
    isSuccess!: boolean;
    scannerCalibrationId!: number;

    constructor(data?: IAddNewScannerCalibrationEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinal = _data["ordinal"];
            this.isSuccess = _data["isSuccess"];
            this.scannerCalibrationId = _data["scannerCalibrationId"];
        }
    }

    static fromJS(data: any): AddNewScannerCalibrationEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddNewScannerCalibrationEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinal"] = this.ordinal;
        data["isSuccess"] = this.isSuccess;
        data["scannerCalibrationId"] = this.scannerCalibrationId;
        return data;
    }
}

export interface IAddNewScannerCalibrationEventDto {
    ordinal: number;
    isSuccess: boolean;
    scannerCalibrationId: number;
}

export class AddNoSamplingReasonInput implements IAddNoSamplingReasonInput {
    reasonId!: number;
    comment!: string | undefined;

    constructor(data?: IAddNoSamplingReasonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonId = _data["reasonId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AddNoSamplingReasonInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddNoSamplingReasonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IAddNoSamplingReasonInput {
    reasonId: number;
    comment: string | undefined;
}

export class AddOrUpdateScaleCalibrationInstanceInputDto implements IAddOrUpdateScaleCalibrationInstanceInputDto {
    scaleCalibrationId!: number;
    scaleId!: number;
    weightValue!: number;

    constructor(data?: IAddOrUpdateScaleCalibrationInstanceInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scaleCalibrationId = _data["scaleCalibrationId"];
            this.scaleId = _data["scaleId"];
            this.weightValue = _data["weightValue"];
        }
    }

    static fromJS(data: any): AddOrUpdateScaleCalibrationInstanceInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateScaleCalibrationInstanceInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scaleCalibrationId"] = this.scaleCalibrationId;
        data["scaleId"] = this.scaleId;
        data["weightValue"] = this.weightValue;
        return data;
    }
}

export interface IAddOrUpdateScaleCalibrationInstanceInputDto {
    scaleCalibrationId: number;
    scaleId: number;
    weightValue: number;
}

export class AddScannerAbortedSpeedResultReasonInput implements IAddScannerAbortedSpeedResultReasonInput {
    reasonId!: number;
    comment!: string | undefined;

    constructor(data?: IAddScannerAbortedSpeedResultReasonInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonId = _data["reasonId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): AddScannerAbortedSpeedResultReasonInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddScannerAbortedSpeedResultReasonInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IAddScannerAbortedSpeedResultReasonInput {
    reasonId: number;
    comment: string | undefined;
}

export class AddScannerCalibrationAttachmentDto implements IAddScannerCalibrationAttachmentDto {
    attachment!: string | undefined;
    attachmentFilename!: string | undefined;
    scannerCalibrationId!: number;

    constructor(data?: IAddScannerCalibrationAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachment = _data["attachment"];
            this.attachmentFilename = _data["attachmentFilename"];
            this.scannerCalibrationId = _data["scannerCalibrationId"];
        }
    }

    static fromJS(data: any): AddScannerCalibrationAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddScannerCalibrationAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment;
        data["attachmentFilename"] = this.attachmentFilename;
        data["scannerCalibrationId"] = this.scannerCalibrationId;
        return data;
    }
}

export interface IAddScannerCalibrationAttachmentDto {
    attachment: string | undefined;
    attachmentFilename: string | undefined;
    scannerCalibrationId: number;
}

export class AddStandWoodGeoLocationDto implements IAddStandWoodGeoLocationDto {
    stand!: string | undefined;

    constructor(data?: IAddStandWoodGeoLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stand = _data["stand"];
        }
    }

    static fromJS(data: any): AddStandWoodGeoLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AddStandWoodGeoLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stand"] = this.stand;
        return data;
    }
}

export interface IAddStandWoodGeoLocationDto {
    stand: string | undefined;
}

export class AddWidgetInput implements IAddWidgetInput {
    widgetId!: string | undefined;
    pageId!: string | undefined;
    dashboardName!: string | undefined;
    width!: number;
    height!: number;
    application!: string | undefined;

    constructor(data?: IAddWidgetInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.pageId = _data["pageId"];
            this.dashboardName = _data["dashboardName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): AddWidgetInput {
        data = typeof data === 'object' ? data : {};
        let result = new AddWidgetInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["pageId"] = this.pageId;
        data["dashboardName"] = this.dashboardName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["application"] = this.application;
        return data;
    }
}

export interface IAddWidgetInput {
    widgetId: string | undefined;
    pageId: string | undefined;
    dashboardName: string | undefined;
    width: number;
    height: number;
    application: string | undefined;
}

export class AlutelValuesDto implements IAlutelValuesDto {
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: IAlutelValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AlutelValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new AlutelValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface IAlutelValuesDto {
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export enum AntennaType {
    Linear = "Linear",
    Circular = "Circular",
}

export class ApplicationInfoDto implements IApplicationInfoDto {
    version!: string | undefined;
    releaseDate!: DateTime;
    currency!: string | undefined;
    currencySign!: string | undefined;
    allowTenantsToChangeEmailSettings!: boolean;
    userDelegationIsEnabled!: boolean;
    features!: { [key: string]: boolean; } | undefined;

    constructor(data?: IApplicationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? DateTime.fromISO(_data["releaseDate"].toString()) : <any>undefined;
            this.currency = _data["currency"];
            this.currencySign = _data["currencySign"];
            this.allowTenantsToChangeEmailSettings = _data["allowTenantsToChangeEmailSettings"];
            this.userDelegationIsEnabled = _data["userDelegationIsEnabled"];
            if (_data["features"]) {
                this.features = {} as any;
                for (let key in _data["features"]) {
                    if (_data["features"].hasOwnProperty(key))
                        (<any>this.features)![key] = _data["features"][key];
                }
            }
        }
    }

    static fromJS(data: any): ApplicationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toString() : <any>undefined;
        data["currency"] = this.currency;
        data["currencySign"] = this.currencySign;
        data["allowTenantsToChangeEmailSettings"] = this.allowTenantsToChangeEmailSettings;
        data["userDelegationIsEnabled"] = this.userDelegationIsEnabled;
        if (this.features) {
            data["features"] = {};
            for (let key in this.features) {
                if (this.features.hasOwnProperty(key))
                    (<any>data["features"])[key] = (<any>this.features)[key];
            }
        }
        return data;
    }
}

export interface IApplicationInfoDto {
    version: string | undefined;
    releaseDate: DateTime;
    currency: string | undefined;
    currencySign: string | undefined;
    allowTenantsToChangeEmailSettings: boolean;
    userDelegationIsEnabled: boolean;
    features: { [key: string]: boolean; } | undefined;
}

export class ApplicationLanguageEditDto implements IApplicationLanguageEditDto {
    id!: number | undefined;
    name!: string;
    icon!: string | undefined;
    isEnabled!: boolean;

    constructor(data?: IApplicationLanguageEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.icon = _data["icon"];
            this.isEnabled = _data["isEnabled"];
        }
    }

    static fromJS(data: any): ApplicationLanguageEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    }
}

export interface IApplicationLanguageEditDto {
    id: number | undefined;
    name: string;
    icon: string | undefined;
    isEnabled: boolean;
}

export class ApplicationLanguageListDto implements IApplicationLanguageListDto {
    tenantId!: number | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    icon!: string | undefined;
    isDisabled!: boolean;
    isDeleted!: boolean;
    deleterUserId!: number | undefined;
    deletionTime!: DateTime | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IApplicationLanguageListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.icon = _data["icon"];
            this.isDisabled = _data["isDisabled"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? DateTime.fromISO(_data["deletionTime"].toString()) : <any>undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationLanguageListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toString() : <any>undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationLanguageListDto {
    tenantId: number | undefined;
    name: string | undefined;
    displayName: string | undefined;
    icon: string | undefined;
    isDisabled: boolean;
    isDeleted: boolean;
    deleterUserId: number | undefined;
    deletionTime: DateTime | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class AppSettingsJsonDto implements IAppSettingsJsonDto {
    webSiteUrl!: string | undefined;
    serverSiteUrl!: string | undefined;
    languages!: NameValue[] | undefined;

    constructor(data?: IAppSettingsJsonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverSiteUrl = _data["serverSiteUrl"];
            if (Array.isArray(_data["languages"])) {
                this.languages = [] as any;
                for (let item of _data["languages"])
                    this.languages!.push(NameValue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppSettingsJsonDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (Array.isArray(this.languages)) {
            data["languages"] = [];
            for (let item of this.languages)
                data["languages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAppSettingsJsonDto {
    webSiteUrl: string | undefined;
    serverSiteUrl: string | undefined;
    languages: NameValue[] | undefined;
}

export class ArchimedesCalibrationDto implements IArchimedesCalibrationDto {
    readonly extremeCalibrationsCount!: number;
    withWeight!: WeightDto | undefined;
    withoutWeight!: WeightDto | undefined;
    extremeCalibrations!: ExtremeCalibrationDto[] | undefined;
    loaderMachineId!: number;
    scaleId!: number;
    mustCalibrate!: boolean;
    cubeId!: number | undefined;

    constructor(data?: IArchimedesCalibrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).extremeCalibrationsCount = _data["extremeCalibrationsCount"];
            this.withWeight = _data["withWeight"] ? WeightDto.fromJS(_data["withWeight"]) : <any>undefined;
            this.withoutWeight = _data["withoutWeight"] ? WeightDto.fromJS(_data["withoutWeight"]) : <any>undefined;
            if (Array.isArray(_data["extremeCalibrations"])) {
                this.extremeCalibrations = [] as any;
                for (let item of _data["extremeCalibrations"])
                    this.extremeCalibrations!.push(ExtremeCalibrationDto.fromJS(item));
            }
            this.loaderMachineId = _data["loaderMachineId"];
            this.scaleId = _data["scaleId"];
            this.mustCalibrate = _data["mustCalibrate"];
            this.cubeId = _data["cubeId"];
        }
    }

    static fromJS(data: any): ArchimedesCalibrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesCalibrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extremeCalibrationsCount"] = this.extremeCalibrationsCount;
        data["withWeight"] = this.withWeight ? this.withWeight.toJSON() : <any>undefined;
        data["withoutWeight"] = this.withoutWeight ? this.withoutWeight.toJSON() : <any>undefined;
        if (Array.isArray(this.extremeCalibrations)) {
            data["extremeCalibrations"] = [];
            for (let item of this.extremeCalibrations)
                data["extremeCalibrations"].push(item.toJSON());
        }
        data["loaderMachineId"] = this.loaderMachineId;
        data["scaleId"] = this.scaleId;
        data["mustCalibrate"] = this.mustCalibrate;
        data["cubeId"] = this.cubeId;
        return data;
    }
}

export interface IArchimedesCalibrationDto {
    extremeCalibrationsCount: number;
    withWeight: WeightDto | undefined;
    withoutWeight: WeightDto | undefined;
    extremeCalibrations: ExtremeCalibrationDto[] | undefined;
    loaderMachineId: number;
    scaleId: number;
    mustCalibrate: boolean;
    cubeId: number | undefined;
}

export class ArchimedesInformationOutputDto implements IArchimedesInformationOutputDto {
    wasSampled!: boolean;
    archimedesSamplingInfo!: ArchimedesSamplingSummaryDto | undefined;
    standDensity!: number;
    noSamplingReason!: ReasonDto | undefined;
    noSamplingReasonComment!: string | undefined;
    sampleType!: SampleAssignmentType;
    externalActivityReportId!: number | undefined;
    needTakeSample!: boolean;
    standNumberOrId!: number;
    isStandExternal!: boolean;
    articleExternalId!: number;
    activityReportLineId!: number;
    activityReportId!: number;

    constructor(data?: IArchimedesInformationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wasSampled = _data["wasSampled"];
            this.archimedesSamplingInfo = _data["archimedesSamplingInfo"] ? ArchimedesSamplingSummaryDto.fromJS(_data["archimedesSamplingInfo"]) : <any>undefined;
            this.standDensity = _data["standDensity"];
            this.noSamplingReason = _data["noSamplingReason"] ? ReasonDto.fromJS(_data["noSamplingReason"]) : <any>undefined;
            this.noSamplingReasonComment = _data["noSamplingReasonComment"];
            this.sampleType = _data["sampleType"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.needTakeSample = _data["needTakeSample"];
            this.standNumberOrId = _data["standNumberOrId"];
            this.isStandExternal = _data["isStandExternal"];
            this.articleExternalId = _data["articleExternalId"];
            this.activityReportLineId = _data["activityReportLineId"];
            this.activityReportId = _data["activityReportId"];
        }
    }

    static fromJS(data: any): ArchimedesInformationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesInformationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wasSampled"] = this.wasSampled;
        data["archimedesSamplingInfo"] = this.archimedesSamplingInfo ? this.archimedesSamplingInfo.toJSON() : <any>undefined;
        data["standDensity"] = this.standDensity;
        data["noSamplingReason"] = this.noSamplingReason ? this.noSamplingReason.toJSON() : <any>undefined;
        data["noSamplingReasonComment"] = this.noSamplingReasonComment;
        data["sampleType"] = this.sampleType;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["needTakeSample"] = this.needTakeSample;
        data["standNumberOrId"] = this.standNumberOrId;
        data["isStandExternal"] = this.isStandExternal;
        data["articleExternalId"] = this.articleExternalId;
        data["activityReportLineId"] = this.activityReportLineId;
        data["activityReportId"] = this.activityReportId;
        return data;
    }
}

export interface IArchimedesInformationOutputDto {
    wasSampled: boolean;
    archimedesSamplingInfo: ArchimedesSamplingSummaryDto | undefined;
    standDensity: number;
    noSamplingReason: ReasonDto | undefined;
    noSamplingReasonComment: string | undefined;
    sampleType: SampleAssignmentType;
    externalActivityReportId: number | undefined;
    needTakeSample: boolean;
    standNumberOrId: number;
    isStandExternal: boolean;
    articleExternalId: number;
    activityReportLineId: number;
    activityReportId: number;
}

export class ArchimedesSampleDto implements IArchimedesSampleDto {
    id!: number;
    finalDensity!: number;
    totalVolume!: number;
    weightTotal!: number;
    loaderMachineId!: number;
    loaderMachine!: LoaderMachineDto | undefined;
    woodActivityReportLineId!: number;
    woodActivityReportLine!: WoodActivityReportLineDto | undefined;
    waterDensity!: number;
    scaleVolume!: number;
    samplingZone!: ZonesDto | undefined;
    samplingZoneId!: number;
    archimedesSampleInstances!: ArchimedesSampleInstanceDto[] | undefined;

    constructor(data?: IArchimedesSampleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.finalDensity = _data["finalDensity"];
            this.totalVolume = _data["totalVolume"];
            this.weightTotal = _data["weightTotal"];
            this.loaderMachineId = _data["loaderMachineId"];
            this.loaderMachine = _data["loaderMachine"] ? LoaderMachineDto.fromJS(_data["loaderMachine"]) : <any>undefined;
            this.woodActivityReportLineId = _data["woodActivityReportLineId"];
            this.woodActivityReportLine = _data["woodActivityReportLine"] ? WoodActivityReportLineDto.fromJS(_data["woodActivityReportLine"]) : <any>undefined;
            this.waterDensity = _data["waterDensity"];
            this.scaleVolume = _data["scaleVolume"];
            this.samplingZone = _data["samplingZone"] ? ZonesDto.fromJS(_data["samplingZone"]) : <any>undefined;
            this.samplingZoneId = _data["samplingZoneId"];
            if (Array.isArray(_data["archimedesSampleInstances"])) {
                this.archimedesSampleInstances = [] as any;
                for (let item of _data["archimedesSampleInstances"])
                    this.archimedesSampleInstances!.push(ArchimedesSampleInstanceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArchimedesSampleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesSampleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["finalDensity"] = this.finalDensity;
        data["totalVolume"] = this.totalVolume;
        data["weightTotal"] = this.weightTotal;
        data["loaderMachineId"] = this.loaderMachineId;
        data["loaderMachine"] = this.loaderMachine ? this.loaderMachine.toJSON() : <any>undefined;
        data["woodActivityReportLineId"] = this.woodActivityReportLineId;
        data["woodActivityReportLine"] = this.woodActivityReportLine ? this.woodActivityReportLine.toJSON() : <any>undefined;
        data["waterDensity"] = this.waterDensity;
        data["scaleVolume"] = this.scaleVolume;
        data["samplingZone"] = this.samplingZone ? this.samplingZone.toJSON() : <any>undefined;
        data["samplingZoneId"] = this.samplingZoneId;
        if (Array.isArray(this.archimedesSampleInstances)) {
            data["archimedesSampleInstances"] = [];
            for (let item of this.archimedesSampleInstances)
                data["archimedesSampleInstances"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArchimedesSampleDto {
    id: number;
    finalDensity: number;
    totalVolume: number;
    weightTotal: number;
    loaderMachineId: number;
    loaderMachine: LoaderMachineDto | undefined;
    woodActivityReportLineId: number;
    woodActivityReportLine: WoodActivityReportLineDto | undefined;
    waterDensity: number;
    scaleVolume: number;
    samplingZone: ZonesDto | undefined;
    samplingZoneId: number;
    archimedesSampleInstances: ArchimedesSampleInstanceDto[] | undefined;
}

export class ArchimedesSampleInstanceDto implements IArchimedesSampleInstanceDto {
    machineTare!: WeightDto | undefined;
    withoutSubmerging!: WeightDto | undefined;
    withSubmerging!: WeightDto | undefined;
    baleWeight!: number;
    density!: number;
    historicalDensity!: number;
    isManual!: boolean;
    woodVolume!: number;
    archimedesSample!: ArchimedesSamplesInArchimedesSamplesInstancesDto | undefined;
    archimedesSampleId!: number;
    deletionCommentary!: string | undefined;
    loaderMachineId!: number;
    activityReportId!: number;
    packageNumber!: number | undefined;

    constructor(data?: IArchimedesSampleInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineTare = _data["machineTare"] ? WeightDto.fromJS(_data["machineTare"]) : <any>undefined;
            this.withoutSubmerging = _data["withoutSubmerging"] ? WeightDto.fromJS(_data["withoutSubmerging"]) : <any>undefined;
            this.withSubmerging = _data["withSubmerging"] ? WeightDto.fromJS(_data["withSubmerging"]) : <any>undefined;
            this.baleWeight = _data["baleWeight"];
            this.density = _data["density"];
            this.historicalDensity = _data["historicalDensity"];
            this.isManual = _data["isManual"];
            this.woodVolume = _data["woodVolume"];
            this.archimedesSample = _data["archimedesSample"] ? ArchimedesSamplesInArchimedesSamplesInstancesDto.fromJS(_data["archimedesSample"]) : <any>undefined;
            this.archimedesSampleId = _data["archimedesSampleId"];
            this.deletionCommentary = _data["deletionCommentary"];
            this.loaderMachineId = _data["loaderMachineId"];
            this.activityReportId = _data["activityReportId"];
            this.packageNumber = _data["packageNumber"];
        }
    }

    static fromJS(data: any): ArchimedesSampleInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesSampleInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineTare"] = this.machineTare ? this.machineTare.toJSON() : <any>undefined;
        data["withoutSubmerging"] = this.withoutSubmerging ? this.withoutSubmerging.toJSON() : <any>undefined;
        data["withSubmerging"] = this.withSubmerging ? this.withSubmerging.toJSON() : <any>undefined;
        data["baleWeight"] = this.baleWeight;
        data["density"] = this.density;
        data["historicalDensity"] = this.historicalDensity;
        data["isManual"] = this.isManual;
        data["woodVolume"] = this.woodVolume;
        data["archimedesSample"] = this.archimedesSample ? this.archimedesSample.toJSON() : <any>undefined;
        data["archimedesSampleId"] = this.archimedesSampleId;
        data["deletionCommentary"] = this.deletionCommentary;
        data["loaderMachineId"] = this.loaderMachineId;
        data["activityReportId"] = this.activityReportId;
        data["packageNumber"] = this.packageNumber;
        return data;
    }
}

export interface IArchimedesSampleInstanceDto {
    machineTare: WeightDto | undefined;
    withoutSubmerging: WeightDto | undefined;
    withSubmerging: WeightDto | undefined;
    baleWeight: number;
    density: number;
    historicalDensity: number;
    isManual: boolean;
    woodVolume: number;
    archimedesSample: ArchimedesSamplesInArchimedesSamplesInstancesDto | undefined;
    archimedesSampleId: number;
    deletionCommentary: string | undefined;
    loaderMachineId: number;
    activityReportId: number;
    packageNumber: number | undefined;
}

export class ArchimedesSampleInstanceOutput implements IArchimedesSampleInstanceOutput {
    machineTare!: WeightDto | undefined;
    withoutSubmerging!: WeightDto | undefined;
    withSubmerging!: WeightDto | undefined;
    baleWeight!: number;
    woodVolume!: number;
    density!: number;
    isManual!: boolean;
    archimedesSample!: ArchimedesSampleDto | undefined;
    sampleDate!: DateTime;
    packageNumber!: number | undefined;
    id!: number;

    constructor(data?: IArchimedesSampleInstanceOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineTare = _data["machineTare"] ? WeightDto.fromJS(_data["machineTare"]) : <any>undefined;
            this.withoutSubmerging = _data["withoutSubmerging"] ? WeightDto.fromJS(_data["withoutSubmerging"]) : <any>undefined;
            this.withSubmerging = _data["withSubmerging"] ? WeightDto.fromJS(_data["withSubmerging"]) : <any>undefined;
            this.baleWeight = _data["baleWeight"];
            this.woodVolume = _data["woodVolume"];
            this.density = _data["density"];
            this.isManual = _data["isManual"];
            this.archimedesSample = _data["archimedesSample"] ? ArchimedesSampleDto.fromJS(_data["archimedesSample"]) : <any>undefined;
            this.sampleDate = _data["sampleDate"] ? DateTime.fromISO(_data["sampleDate"].toString()) : <any>undefined;
            this.packageNumber = _data["packageNumber"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ArchimedesSampleInstanceOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesSampleInstanceOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineTare"] = this.machineTare ? this.machineTare.toJSON() : <any>undefined;
        data["withoutSubmerging"] = this.withoutSubmerging ? this.withoutSubmerging.toJSON() : <any>undefined;
        data["withSubmerging"] = this.withSubmerging ? this.withSubmerging.toJSON() : <any>undefined;
        data["baleWeight"] = this.baleWeight;
        data["woodVolume"] = this.woodVolume;
        data["density"] = this.density;
        data["isManual"] = this.isManual;
        data["archimedesSample"] = this.archimedesSample ? this.archimedesSample.toJSON() : <any>undefined;
        data["sampleDate"] = this.sampleDate ? this.sampleDate.toString() : <any>undefined;
        data["packageNumber"] = this.packageNumber;
        data["id"] = this.id;
        return data;
    }
}

export interface IArchimedesSampleInstanceOutput {
    machineTare: WeightDto | undefined;
    withoutSubmerging: WeightDto | undefined;
    withSubmerging: WeightDto | undefined;
    baleWeight: number;
    woodVolume: number;
    density: number;
    isManual: boolean;
    archimedesSample: ArchimedesSampleDto | undefined;
    sampleDate: DateTime;
    packageNumber: number | undefined;
    id: number;
}

export class ArchimedesSamplesInArchimedesSamplesInstancesDto implements IArchimedesSamplesInArchimedesSamplesInstancesDto {
    machineTare!: WeightDto | undefined;
    withoutSubmerging!: WeightDto | undefined;
    withSubmerging!: WeightDto | undefined;
    baleWeight!: number;
    woodVolume!: number;
    density!: number;
    isManual!: boolean;
    sampleDate!: DateTime;

    constructor(data?: IArchimedesSamplesInArchimedesSamplesInstancesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineTare = _data["machineTare"] ? WeightDto.fromJS(_data["machineTare"]) : <any>undefined;
            this.withoutSubmerging = _data["withoutSubmerging"] ? WeightDto.fromJS(_data["withoutSubmerging"]) : <any>undefined;
            this.withSubmerging = _data["withSubmerging"] ? WeightDto.fromJS(_data["withSubmerging"]) : <any>undefined;
            this.baleWeight = _data["baleWeight"];
            this.woodVolume = _data["woodVolume"];
            this.density = _data["density"];
            this.isManual = _data["isManual"];
            this.sampleDate = _data["sampleDate"] ? DateTime.fromISO(_data["sampleDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ArchimedesSamplesInArchimedesSamplesInstancesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesSamplesInArchimedesSamplesInstancesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineTare"] = this.machineTare ? this.machineTare.toJSON() : <any>undefined;
        data["withoutSubmerging"] = this.withoutSubmerging ? this.withoutSubmerging.toJSON() : <any>undefined;
        data["withSubmerging"] = this.withSubmerging ? this.withSubmerging.toJSON() : <any>undefined;
        data["baleWeight"] = this.baleWeight;
        data["woodVolume"] = this.woodVolume;
        data["density"] = this.density;
        data["isManual"] = this.isManual;
        data["sampleDate"] = this.sampleDate ? this.sampleDate.toString() : <any>undefined;
        return data;
    }
}

export interface IArchimedesSamplesInArchimedesSamplesInstancesDto {
    machineTare: WeightDto | undefined;
    withoutSubmerging: WeightDto | undefined;
    withSubmerging: WeightDto | undefined;
    baleWeight: number;
    woodVolume: number;
    density: number;
    isManual: boolean;
    sampleDate: DateTime;
}

export class ArchimedesSamplingSummaryDto implements IArchimedesSamplingSummaryDto {
    samplingLocation!: PlaceDto | undefined;
    sampleType!: SampleAssignmentType;
    samplingDate!: DateTime;
    activityReportLineId!: number;
    totalWeight!: number;
    totalVolume!: number;
    finalDensity!: number;
    waterDensity!: number;
    machine!: LoaderMachineDto | undefined;
    samples!: ArchimedesSampleInstanceOutput[] | undefined;

    constructor(data?: IArchimedesSamplingSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.samplingLocation = _data["samplingLocation"] ? PlaceDto.fromJS(_data["samplingLocation"]) : <any>undefined;
            this.sampleType = _data["sampleType"];
            this.samplingDate = _data["samplingDate"] ? DateTime.fromISO(_data["samplingDate"].toString()) : <any>undefined;
            this.activityReportLineId = _data["activityReportLineId"];
            this.totalWeight = _data["totalWeight"];
            this.totalVolume = _data["totalVolume"];
            this.finalDensity = _data["finalDensity"];
            this.waterDensity = _data["waterDensity"];
            this.machine = _data["machine"] ? LoaderMachineDto.fromJS(_data["machine"]) : <any>undefined;
            if (Array.isArray(_data["samples"])) {
                this.samples = [] as any;
                for (let item of _data["samples"])
                    this.samples!.push(ArchimedesSampleInstanceOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ArchimedesSamplingSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArchimedesSamplingSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["samplingLocation"] = this.samplingLocation ? this.samplingLocation.toJSON() : <any>undefined;
        data["sampleType"] = this.sampleType;
        data["samplingDate"] = this.samplingDate ? this.samplingDate.toString() : <any>undefined;
        data["activityReportLineId"] = this.activityReportLineId;
        data["totalWeight"] = this.totalWeight;
        data["totalVolume"] = this.totalVolume;
        data["finalDensity"] = this.finalDensity;
        data["waterDensity"] = this.waterDensity;
        data["machine"] = this.machine ? this.machine.toJSON() : <any>undefined;
        if (Array.isArray(this.samples)) {
            data["samples"] = [];
            for (let item of this.samples)
                data["samples"].push(item.toJSON());
        }
        return data;
    }
}

export interface IArchimedesSamplingSummaryDto {
    samplingLocation: PlaceDto | undefined;
    sampleType: SampleAssignmentType;
    samplingDate: DateTime;
    activityReportLineId: number;
    totalWeight: number;
    totalVolume: number;
    finalDensity: number;
    waterDensity: number;
    machine: LoaderMachineDto | undefined;
    samples: ArchimedesSampleInstanceOutput[] | undefined;
}

export class AreMeasurementDevicesActiveOutput implements IAreMeasurementDevicesActiveOutput {
    samplingDevicesActive!: boolean;
    scannerActive!: boolean;

    constructor(data?: IAreMeasurementDevicesActiveOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.samplingDevicesActive = _data["samplingDevicesActive"];
            this.scannerActive = _data["scannerActive"];
        }
    }

    static fromJS(data: any): AreMeasurementDevicesActiveOutput {
        data = typeof data === 'object' ? data : {};
        let result = new AreMeasurementDevicesActiveOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["samplingDevicesActive"] = this.samplingDevicesActive;
        data["scannerActive"] = this.scannerActive;
        return data;
    }
}

export interface IAreMeasurementDevicesActiveOutput {
    samplingDevicesActive: boolean;
    scannerActive: boolean;
}

export class ArticleDto implements IArticleDto {
    externalIdentity!: ExternalIdentityDto | undefined;

    constructor(data?: IArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalIdentity = _data["externalIdentity"] ? ExternalIdentityDto.fromJS(_data["externalIdentity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalIdentity"] = this.externalIdentity ? this.externalIdentity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IArticleDto {
    externalIdentity: ExternalIdentityDto | undefined;
}

export class ArticleIMInputDto implements IArticleIMInputDto {
    externalId!: number;
    placeId!: number;
    name!: string | undefined;

    constructor(data?: IArticleIMInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.placeId = _data["placeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ArticleIMInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleIMInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["placeId"] = this.placeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IArticleIMInputDto {
    externalId: number;
    placeId: number;
    name: string | undefined;
}

export class ArticleLengthOrSpeciesChangeDto implements IArticleLengthOrSpeciesChangeDto {
    isUpdatedArticleLengthOrSpecies!: boolean;
    shouldDeleteScannerMeasurementData!: boolean;

    constructor(data?: IArticleLengthOrSpeciesChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isUpdatedArticleLengthOrSpecies = _data["isUpdatedArticleLengthOrSpecies"];
            this.shouldDeleteScannerMeasurementData = _data["shouldDeleteScannerMeasurementData"];
        }
    }

    static fromJS(data: any): ArticleLengthOrSpeciesChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleLengthOrSpeciesChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isUpdatedArticleLengthOrSpecies"] = this.isUpdatedArticleLengthOrSpecies;
        data["shouldDeleteScannerMeasurementData"] = this.shouldDeleteScannerMeasurementData;
        return data;
    }
}

export interface IArticleLengthOrSpeciesChangeDto {
    isUpdatedArticleLengthOrSpecies: boolean;
    shouldDeleteScannerMeasurementData: boolean;
}

export class ArticleOutputDto implements IArticleOutputDto {
    externalId!: number;

    constructor(data?: IArticleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ArticleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ArticleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IArticleOutputDto {
    externalId: number;
}

export class Assembly implements IAssembly {
    readonly definedTypes!: string[] | undefined;
    readonly exportedTypes!: string[] | undefined;
    readonly codeBase!: string | undefined;
    readonly entryPoint!: MethodInfo | undefined;
    readonly fullName!: string | undefined;
    readonly imageRuntimeVersion!: string | undefined;
    readonly isDynamic!: boolean;
    readonly location!: string | undefined;
    readonly reflectionOnly!: boolean;
    readonly isCollectible!: boolean;
    readonly isFullyTrusted!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly escapedCodeBase!: string | undefined;
    readonly manifestModule!: Module | undefined;
    readonly modules!: Module[] | undefined;
    readonly globalAssemblyCache!: boolean;
    readonly hostContext!: number;
    readonly securityRuleSet!: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                (<any>this).definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    (<any>this).definedTypes!.push(item);
            }
            if (Array.isArray(_data["exportedTypes"])) {
                (<any>this).exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    (<any>this).exportedTypes!.push(item);
            }
            (<any>this).codeBase = _data["codeBase"];
            (<any>this).entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : <any>undefined;
            (<any>this).fullName = _data["fullName"];
            (<any>this).imageRuntimeVersion = _data["imageRuntimeVersion"];
            (<any>this).isDynamic = _data["isDynamic"];
            (<any>this).location = _data["location"];
            (<any>this).reflectionOnly = _data["reflectionOnly"];
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).escapedCodeBase = _data["escapedCodeBase"];
            (<any>this).manifestModule = _data["manifestModule"] ? Module.fromJS(_data["manifestModule"]) : <any>undefined;
            if (Array.isArray(_data["modules"])) {
                (<any>this).modules = [] as any;
                for (let item of _data["modules"])
                    (<any>this).modules!.push(Module.fromJS(item));
            }
            (<any>this).globalAssemblyCache = _data["globalAssemblyCache"];
            (<any>this).hostContext = _data["hostContext"];
            (<any>this).securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        let result = new Assembly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : <any>undefined;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : <any>undefined;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item.toJSON());
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes: string[] | undefined;
    exportedTypes: string[] | undefined;
    codeBase: string | undefined;
    entryPoint: MethodInfo | undefined;
    fullName: string | undefined;
    imageRuntimeVersion: string | undefined;
    isDynamic: boolean;
    location: string | undefined;
    reflectionOnly: boolean;
    isCollectible: boolean;
    isFullyTrusted: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    escapedCodeBase: string | undefined;
    manifestModule: Module | undefined;
    modules: Module[] | undefined;
    globalAssemblyCache: boolean;
    hostContext: number;
    securityRuleSet: SecurityRuleSet;
}

export class AssignPlaceToRoleInputDto implements IAssignPlaceToRoleInputDto {
    roleId!: number;
    placeId!: number | undefined;

    constructor(data?: IAssignPlaceToRoleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): AssignPlaceToRoleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssignPlaceToRoleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IAssignPlaceToRoleInputDto {
    roleId: number;
    placeId: number | undefined;
}

export class AuditLogListDto implements IAuditLogListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    impersonatorTenantId!: number | undefined;
    impersonatorUserId!: number | undefined;
    serviceName!: string | undefined;
    methodName!: string | undefined;
    parameters!: string | undefined;
    executionTime!: DateTime;
    executionDuration!: number;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    exception!: string | undefined;
    customData!: string | undefined;
    returnValue!: string | undefined;
    id!: number;

    constructor(data?: IAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.impersonatorTenantId = _data["impersonatorTenantId"];
            this.impersonatorUserId = _data["impersonatorUserId"];
            this.serviceName = _data["serviceName"];
            this.methodName = _data["methodName"];
            this.parameters = _data["parameters"];
            this.executionTime = _data["executionTime"] ? DateTime.fromISO(_data["executionTime"].toString()) : <any>undefined;
            this.executionDuration = _data["executionDuration"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.exception = _data["exception"];
            this.customData = _data["customData"];
            this.returnValue = _data["returnValue"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toString() : <any>undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["returnValue"] = this.returnValue;
        data["id"] = this.id;
        return data;
    }
}

export interface IAuditLogListDto {
    userId: number | undefined;
    userName: string | undefined;
    impersonatorTenantId: number | undefined;
    impersonatorUserId: number | undefined;
    serviceName: string | undefined;
    methodName: string | undefined;
    parameters: string | undefined;
    executionTime: DateTime;
    executionDuration: number;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    exception: string | undefined;
    customData: string | undefined;
    returnValue: string | undefined;
    id: number;
}

export class AuthenticateModel implements IAuthenticateModel {
    userNameOrEmailAddress!: string;
    password!: string;
    twoFactorVerificationCode!: string | undefined;
    rememberClient!: boolean;
    twoFactorRememberClientToken!: string | undefined;
    singleSignIn!: boolean | undefined;
    returnUrl!: string | undefined;
    captchaResponse!: string | undefined;

    constructor(data?: IAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userNameOrEmailAddress = _data["userNameOrEmailAddress"];
            this.password = _data["password"];
            this.twoFactorVerificationCode = _data["twoFactorVerificationCode"];
            this.rememberClient = _data["rememberClient"];
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.singleSignIn = _data["singleSignIn"];
            this.returnUrl = _data["returnUrl"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): AuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IAuthenticateModel {
    userNameOrEmailAddress: string;
    password: string;
    twoFactorVerificationCode: string | undefined;
    rememberClient: boolean;
    twoFactorRememberClientToken: string | undefined;
    singleSignIn: boolean | undefined;
    returnUrl: string | undefined;
    captchaResponse: string | undefined;
}

export class AuthenticateResultModel implements IAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    shouldResetPassword!: boolean;
    passwordResetCode!: string | undefined;
    userId!: number;
    requiresTwoFactorVerification!: boolean;
    twoFactorAuthProviders!: string[] | undefined;
    twoFactorRememberClientToken!: string | undefined;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;

    constructor(data?: IAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.shouldResetPassword = _data["shouldResetPassword"];
            this.passwordResetCode = _data["passwordResetCode"];
            this.userId = _data["userId"];
            this.requiresTwoFactorVerification = _data["requiresTwoFactorVerification"];
            if (Array.isArray(_data["twoFactorAuthProviders"])) {
                this.twoFactorAuthProviders = [] as any;
                for (let item of _data["twoFactorAuthProviders"])
                    this.twoFactorAuthProviders!.push(item);
            }
            this.twoFactorRememberClientToken = _data["twoFactorRememberClientToken"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
        }
    }

    static fromJS(data: any): AuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (Array.isArray(this.twoFactorAuthProviders)) {
            data["twoFactorAuthProviders"] = [];
            for (let item of this.twoFactorAuthProviders)
                data["twoFactorAuthProviders"].push(item);
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        return data;
    }
}

export interface IAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    shouldResetPassword: boolean;
    passwordResetCode: string | undefined;
    userId: number;
    requiresTwoFactorVerification: boolean;
    twoFactorAuthProviders: string[] | undefined;
    twoFactorRememberClientToken: string | undefined;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
}

export class AvailableTurnTimeDto implements IAvailableTurnTimeDto {
    turn!: DateTime;
    conditional!: boolean;

    constructor(data?: IAvailableTurnTimeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.turn = _data["turn"] ? DateTime.fromISO(_data["turn"].toString()) : <any>undefined;
            this.conditional = _data["conditional"];
        }
    }

    static fromJS(data: any): AvailableTurnTimeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableTurnTimeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["turn"] = this.turn ? this.turn.toString() : <any>undefined;
        data["conditional"] = this.conditional;
        return data;
    }
}

export interface IAvailableTurnTimeDto {
    turn: DateTime;
    conditional: boolean;
}

export class AverageInDestinationOutputDto implements IAverageInDestinationOutputDto {
    placeId!: number;
    sincedHours!: number;
    averageInDestination!: number;
    totalReceipts!: number;
    dateToCompare!: DateTime;
    items!: AverageInDestinationOutputItemDto[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IAverageInDestinationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.sincedHours = _data["sincedHours"];
            this.averageInDestination = _data["averageInDestination"];
            this.totalReceipts = _data["totalReceipts"];
            this.dateToCompare = _data["dateToCompare"] ? DateTime.fromISO(_data["dateToCompare"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AverageInDestinationOutputItemDto.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): AverageInDestinationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new AverageInDestinationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["sincedHours"] = this.sincedHours;
        data["averageInDestination"] = this.averageInDestination;
        data["totalReceipts"] = this.totalReceipts;
        data["dateToCompare"] = this.dateToCompare ? this.dateToCompare.toString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IAverageInDestinationOutputDto {
    placeId: number;
    sincedHours: number;
    averageInDestination: number;
    totalReceipts: number;
    dateToCompare: DateTime;
    items: AverageInDestinationOutputItemDto[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class AverageInDestinationOutputItemDto implements IAverageInDestinationOutputItemDto {
    receiptId!: number;
    entryDate!: DateTime;
    exitDate!: DateTime;

    constructor(data?: IAverageInDestinationOutputItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AverageInDestinationOutputItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new AverageInDestinationOutputItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        return data;
    }
}

export interface IAverageInDestinationOutputItemDto {
    receiptId: number;
    entryDate: DateTime;
    exitDate: DateTime;
}

export class B2CLogOutOutput implements IB2CLogOutOutput {
    logoutUrl!: string | undefined;

    constructor(data?: IB2CLogOutOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logoutUrl = _data["logoutUrl"];
        }
    }

    static fromJS(data: any): B2CLogOutOutput {
        data = typeof data === 'object' ? data : {};
        let result = new B2CLogOutOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logoutUrl"] = this.logoutUrl;
        return data;
    }
}

export interface IB2CLogOutOutput {
    logoutUrl: string | undefined;
}

export class BarkSampleForGridDto implements IBarkSampleForGridDto {
    reportId!: number;
    externalOriginId!: number;
    externalStandId!: number;
    externalCutVendorId!: number;
    externalExtractionVendorId!: number;
    receiptEntryDate!: DateTime;
    totalBarkDensity!: number;
    originLocationType!: LocationType;

    constructor(data?: IBarkSampleForGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.externalOriginId = _data["externalOriginId"];
            this.externalStandId = _data["externalStandId"];
            this.externalCutVendorId = _data["externalCutVendorId"];
            this.externalExtractionVendorId = _data["externalExtractionVendorId"];
            this.receiptEntryDate = _data["receiptEntryDate"] ? DateTime.fromISO(_data["receiptEntryDate"].toString()) : <any>undefined;
            this.totalBarkDensity = _data["totalBarkDensity"];
            this.originLocationType = _data["originLocationType"];
        }
    }

    static fromJS(data: any): BarkSampleForGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarkSampleForGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["externalOriginId"] = this.externalOriginId;
        data["externalStandId"] = this.externalStandId;
        data["externalCutVendorId"] = this.externalCutVendorId;
        data["externalExtractionVendorId"] = this.externalExtractionVendorId;
        data["receiptEntryDate"] = this.receiptEntryDate ? this.receiptEntryDate.toString() : <any>undefined;
        data["totalBarkDensity"] = this.totalBarkDensity;
        data["originLocationType"] = this.originLocationType;
        return data;
    }
}

export interface IBarkSampleForGridDto {
    reportId: number;
    externalOriginId: number;
    externalStandId: number;
    externalCutVendorId: number;
    externalExtractionVendorId: number;
    receiptEntryDate: DateTime;
    totalBarkDensity: number;
    originLocationType: LocationType;
}

export class BarkSampleInputDto implements IBarkSampleInputDto {
    mode!: BarkSampleMode;
    packageSelected!: number | undefined;
    volume!: number;
    adheredBarkWeight!: number;
    sweptBarkWeight!: number;
    isNullifying!: boolean;
    linesDensityBySpecies!: LineDensityBySpeciesDto[] | undefined;

    constructor(data?: IBarkSampleInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.packageSelected = _data["packageSelected"];
            this.volume = _data["volume"];
            this.adheredBarkWeight = _data["adheredBarkWeight"];
            this.sweptBarkWeight = _data["sweptBarkWeight"];
            this.isNullifying = _data["isNullifying"];
            if (Array.isArray(_data["linesDensityBySpecies"])) {
                this.linesDensityBySpecies = [] as any;
                for (let item of _data["linesDensityBySpecies"])
                    this.linesDensityBySpecies!.push(LineDensityBySpeciesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BarkSampleInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarkSampleInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["packageSelected"] = this.packageSelected;
        data["volume"] = this.volume;
        data["adheredBarkWeight"] = this.adheredBarkWeight;
        data["sweptBarkWeight"] = this.sweptBarkWeight;
        data["isNullifying"] = this.isNullifying;
        if (Array.isArray(this.linesDensityBySpecies)) {
            data["linesDensityBySpecies"] = [];
            for (let item of this.linesDensityBySpecies)
                data["linesDensityBySpecies"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBarkSampleInputDto {
    mode: BarkSampleMode;
    packageSelected: number | undefined;
    volume: number;
    adheredBarkWeight: number;
    sweptBarkWeight: number;
    isNullifying: boolean;
    linesDensityBySpecies: LineDensityBySpeciesDto[] | undefined;
}

export enum BarkSampleMode {
    CompleteTruck = "CompleteTruck",
    SelectPackage = "SelectPackage",
}

export class BarkSampleOutputDto implements IBarkSampleOutputDto {
    mode!: BarkSampleMode;
    packageSelected!: number | undefined;
    adheredBarkWeight!: number;
    sweptBarkWeight!: number;
    adheredBarkDensity!: number;
    sweptBarkDensity!: number;
    totalDensity!: number;
    historicalStandDensity!: number;
    isActive!: boolean;
    isDeleted!: boolean;
    creationTime!: DateTime;
    maxDensityAllowed!: number;
    volume!: number;

    constructor(data?: IBarkSampleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.packageSelected = _data["packageSelected"];
            this.adheredBarkWeight = _data["adheredBarkWeight"];
            this.sweptBarkWeight = _data["sweptBarkWeight"];
            this.adheredBarkDensity = _data["adheredBarkDensity"];
            this.sweptBarkDensity = _data["sweptBarkDensity"];
            this.totalDensity = _data["totalDensity"];
            this.historicalStandDensity = _data["historicalStandDensity"];
            this.isActive = _data["isActive"];
            this.isDeleted = _data["isDeleted"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.maxDensityAllowed = _data["maxDensityAllowed"];
            this.volume = _data["volume"];
        }
    }

    static fromJS(data: any): BarkSampleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new BarkSampleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["packageSelected"] = this.packageSelected;
        data["adheredBarkWeight"] = this.adheredBarkWeight;
        data["sweptBarkWeight"] = this.sweptBarkWeight;
        data["adheredBarkDensity"] = this.adheredBarkDensity;
        data["sweptBarkDensity"] = this.sweptBarkDensity;
        data["totalDensity"] = this.totalDensity;
        data["historicalStandDensity"] = this.historicalStandDensity;
        data["isActive"] = this.isActive;
        data["isDeleted"] = this.isDeleted;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["maxDensityAllowed"] = this.maxDensityAllowed;
        data["volume"] = this.volume;
        return data;
    }
}

export interface IBarkSampleOutputDto {
    mode: BarkSampleMode;
    packageSelected: number | undefined;
    adheredBarkWeight: number;
    sweptBarkWeight: number;
    adheredBarkDensity: number;
    sweptBarkDensity: number;
    totalDensity: number;
    historicalStandDensity: number;
    isActive: boolean;
    isDeleted: boolean;
    creationTime: DateTime;
    maxDensityAllowed: number;
    volume: number;
}

export class BarkSamplesReportDtoOutput implements IBarkSamplesReportDtoOutput {
    receiptId!: string | undefined;
    activityReportEntryDate!: DateTime;
    month!: string | undefined;
    year!: string | undefined;
    activityReportReportLines!: ReceiptReportLineOutput[] | undefined;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    netWeight!: number;
    volumeM3!: number;
    transportExternalId!: number;
    transportLicensePlate!: string | undefined;
    transportVendorExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    adheredBarkWeight!: number;
    sweptBarkWeight!: number;
    adheredBarkDensity!: number;
    sweptBarkDensity!: number;
    totalDensity!: number;
    maxDensityAllowed!: number;

    constructor(data?: IBarkSamplesReportDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptId = _data["receiptId"];
            this.activityReportEntryDate = _data["activityReportEntryDate"] ? DateTime.fromISO(_data["activityReportEntryDate"].toString()) : <any>undefined;
            this.month = _data["month"];
            this.year = _data["year"];
            if (Array.isArray(_data["activityReportReportLines"])) {
                this.activityReportReportLines = [] as any;
                for (let item of _data["activityReportReportLines"])
                    this.activityReportReportLines!.push(ReceiptReportLineOutput.fromJS(item));
            }
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.volumeM3 = _data["volumeM3"];
            this.transportExternalId = _data["transportExternalId"];
            this.transportLicensePlate = _data["transportLicensePlate"];
            this.transportVendorExternalId = _data["transportVendorExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.adheredBarkWeight = _data["adheredBarkWeight"];
            this.sweptBarkWeight = _data["sweptBarkWeight"];
            this.adheredBarkDensity = _data["adheredBarkDensity"];
            this.sweptBarkDensity = _data["sweptBarkDensity"];
            this.totalDensity = _data["totalDensity"];
            this.maxDensityAllowed = _data["maxDensityAllowed"];
        }
    }

    static fromJS(data: any): BarkSamplesReportDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new BarkSamplesReportDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptId"] = this.receiptId;
        data["activityReportEntryDate"] = this.activityReportEntryDate ? this.activityReportEntryDate.toString() : <any>undefined;
        data["month"] = this.month;
        data["year"] = this.year;
        if (Array.isArray(this.activityReportReportLines)) {
            data["activityReportReportLines"] = [];
            for (let item of this.activityReportReportLines)
                data["activityReportReportLines"].push(item.toJSON());
        }
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["volumeM3"] = this.volumeM3;
        data["transportExternalId"] = this.transportExternalId;
        data["transportLicensePlate"] = this.transportLicensePlate;
        data["transportVendorExternalId"] = this.transportVendorExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["adheredBarkWeight"] = this.adheredBarkWeight;
        data["sweptBarkWeight"] = this.sweptBarkWeight;
        data["adheredBarkDensity"] = this.adheredBarkDensity;
        data["sweptBarkDensity"] = this.sweptBarkDensity;
        data["totalDensity"] = this.totalDensity;
        data["maxDensityAllowed"] = this.maxDensityAllowed;
        return data;
    }
}

export interface IBarkSamplesReportDtoOutput {
    receiptId: string | undefined;
    activityReportEntryDate: DateTime;
    month: string | undefined;
    year: string | undefined;
    activityReportReportLines: ReceiptReportLineOutput[] | undefined;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    netWeight: number;
    volumeM3: number;
    transportExternalId: number;
    transportLicensePlate: string | undefined;
    transportVendorExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    adheredBarkWeight: number;
    sweptBarkWeight: number;
    adheredBarkDensity: number;
    sweptBarkDensity: number;
    totalDensity: number;
    maxDensityAllowed: number;
}

export class BasicDiverseProductReportInfoDto implements IBasicDiverseProductReportInfoDto {
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    lastModificationDate!: DateTime | undefined;
    entryZoneId!: number | undefined;
    exitZoneId!: number | undefined;
    placeId!: number;
    id!: number;

    constructor(data?: IBasicDiverseProductReportInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.lastModificationDate = _data["lastModificationDate"] ? DateTime.fromISO(_data["lastModificationDate"].toString()) : <any>undefined;
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.placeId = _data["placeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BasicDiverseProductReportInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicDiverseProductReportInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["lastModificationDate"] = this.lastModificationDate ? this.lastModificationDate.toString() : <any>undefined;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["placeId"] = this.placeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IBasicDiverseProductReportInfoDto {
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    lastModificationDate: DateTime | undefined;
    entryZoneId: number | undefined;
    exitZoneId: number | undefined;
    placeId: number;
    id: number;
}

export class BasicPileDto implements IBasicPileDto {
    externalId!: number;
    name!: string | undefined;
    articleExternalId!: number;
    pileStatus!: PileStatus;
    id!: number;

    constructor(data?: IBasicPileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.name = _data["name"];
            this.articleExternalId = _data["articleExternalId"];
            this.pileStatus = _data["pileStatus"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BasicPileDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicPileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["name"] = this.name;
        data["articleExternalId"] = this.articleExternalId;
        data["pileStatus"] = this.pileStatus;
        data["id"] = this.id;
        return data;
    }
}

export interface IBasicPileDto {
    externalId: number;
    name: string | undefined;
    articleExternalId: number;
    pileStatus: PileStatus;
    id: number;
}

export class BasicPlaceDto implements IBasicPlaceDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IBasicPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): BasicPlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IBasicPlaceDto {
    id: number;
    name: string | undefined;
}

export class BasicUserDto implements IBasicUserDto {
    emailAddress!: string | undefined;
    identityCard!: string | undefined;
    fullName!: string | undefined;
    id!: number;

    constructor(data?: IBasicUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.identityCard = _data["identityCard"];
            this.fullName = _data["fullName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BasicUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["identityCard"] = this.identityCard;
        data["fullName"] = this.fullName;
        data["id"] = this.id;
        return data;
    }
}

export interface IBasicUserDto {
    emailAddress: string | undefined;
    identityCard: string | undefined;
    fullName: string | undefined;
    id: number;
}

export class BasicWoodActivityReportInfoDto implements IBasicWoodActivityReportInfoDto {
    isChip!: boolean;
    isAssignedBarkSample!: boolean;
    isAutomatic!: boolean;
    lastModificationDate!: DateTime | undefined;
    hasLoadActivityReport!: boolean;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    activityReportDate!: DateTime;
    editLocked!: boolean;
    operationMode!: ActivityReportOperationMode;
    isAssignedSample!: boolean;
    wasSampled!: boolean;
    hasNoSamplingReason!: boolean;
    externalDestinationId!: number;
    entryZoneId!: number;
    exitZoneId!: number;
    hasAbortedSpeedScannerResult!: boolean;
    paysTransport!: boolean;
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    id!: number;

    constructor(data?: IBasicWoodActivityReportInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isChip = _data["isChip"];
            this.isAssignedBarkSample = _data["isAssignedBarkSample"];
            this.isAutomatic = _data["isAutomatic"];
            this.lastModificationDate = _data["lastModificationDate"] ? DateTime.fromISO(_data["lastModificationDate"].toString()) : <any>undefined;
            this.hasLoadActivityReport = _data["hasLoadActivityReport"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.activityReportDate = _data["activityReportDate"] ? DateTime.fromISO(_data["activityReportDate"].toString()) : <any>undefined;
            this.editLocked = _data["editLocked"];
            this.operationMode = _data["operationMode"];
            this.isAssignedSample = _data["isAssignedSample"];
            this.wasSampled = _data["wasSampled"];
            this.hasNoSamplingReason = _data["hasNoSamplingReason"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.hasAbortedSpeedScannerResult = _data["hasAbortedSpeedScannerResult"];
            this.paysTransport = _data["paysTransport"];
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): BasicWoodActivityReportInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BasicWoodActivityReportInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isChip"] = this.isChip;
        data["isAssignedBarkSample"] = this.isAssignedBarkSample;
        data["isAutomatic"] = this.isAutomatic;
        data["lastModificationDate"] = this.lastModificationDate ? this.lastModificationDate.toString() : <any>undefined;
        data["hasLoadActivityReport"] = this.hasLoadActivityReport;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["activityReportDate"] = this.activityReportDate ? this.activityReportDate.toString() : <any>undefined;
        data["editLocked"] = this.editLocked;
        data["operationMode"] = this.operationMode;
        data["isAssignedSample"] = this.isAssignedSample;
        data["wasSampled"] = this.wasSampled;
        data["hasNoSamplingReason"] = this.hasNoSamplingReason;
        data["externalDestinationId"] = this.externalDestinationId;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["hasAbortedSpeedScannerResult"] = this.hasAbortedSpeedScannerResult;
        data["paysTransport"] = this.paysTransport;
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["id"] = this.id;
        return data;
    }
}

export interface IBasicWoodActivityReportInfoDto {
    isChip: boolean;
    isAssignedBarkSample: boolean;
    isAutomatic: boolean;
    lastModificationDate: DateTime | undefined;
    hasLoadActivityReport: boolean;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    activityReportDate: DateTime;
    editLocked: boolean;
    operationMode: ActivityReportOperationMode;
    isAssignedSample: boolean;
    wasSampled: boolean;
    hasNoSamplingReason: boolean;
    externalDestinationId: number;
    entryZoneId: number;
    exitZoneId: number;
    hasAbortedSpeedScannerResult: boolean;
    paysTransport: boolean;
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    id: number;
}

export class BlockUserInput implements IBlockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IBlockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): BlockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new BlockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IBlockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class BrokerDto implements IBrokerDto {
    id!: number;
    name!: string | undefined;
    url!: string | undefined;
    username!: string | undefined;
    password!: string | undefined;
    email!: string | undefined;
    externalId!: number;

    constructor(data?: IBrokerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): BrokerDto {
        data = typeof data === 'object' ? data : {};
        let result = new BrokerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["username"] = this.username;
        data["password"] = this.password;
        data["email"] = this.email;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IBrokerDto {
    id: number;
    name: string | undefined;
    url: string | undefined;
    username: string | undefined;
    password: string | undefined;
    email: string | undefined;
    externalId: number;
}

export class CacheDto implements ICacheDto {
    name!: string | undefined;

    constructor(data?: ICacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new CacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ICacheDto {
    name: string | undefined;
}

export class CalculateDensityDtoInput implements ICalculateDensityDtoInput {
    machineTareValue!: number;
    withoutSubmergedValue!: number;
    withSubmergedValue!: number;
    stapleVolumeValue!: number;
    waterDensityValue!: number;

    constructor(data?: ICalculateDensityDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineTareValue = _data["machineTareValue"];
            this.withoutSubmergedValue = _data["withoutSubmergedValue"];
            this.withSubmergedValue = _data["withSubmergedValue"];
            this.stapleVolumeValue = _data["stapleVolumeValue"];
            this.waterDensityValue = _data["waterDensityValue"];
        }
    }

    static fromJS(data: any): CalculateDensityDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateDensityDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineTareValue"] = this.machineTareValue;
        data["withoutSubmergedValue"] = this.withoutSubmergedValue;
        data["withSubmergedValue"] = this.withSubmergedValue;
        data["stapleVolumeValue"] = this.stapleVolumeValue;
        data["waterDensityValue"] = this.waterDensityValue;
        return data;
    }
}

export interface ICalculateDensityDtoInput {
    machineTareValue: number;
    withoutSubmergedValue: number;
    withSubmergedValue: number;
    stapleVolumeValue: number;
    waterDensityValue: number;
}

export class CalibrationTimePeriodOutputDto implements ICalibrationTimePeriodOutputDto {
    hasCalibration!: boolean;
    calibrationTimeInHours!: number;

    constructor(data?: ICalibrationTimePeriodOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasCalibration = _data["hasCalibration"];
            this.calibrationTimeInHours = _data["calibrationTimeInHours"];
        }
    }

    static fromJS(data: any): CalibrationTimePeriodOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalibrationTimePeriodOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasCalibration"] = this.hasCalibration;
        data["calibrationTimeInHours"] = this.calibrationTimeInHours;
        return data;
    }
}

export interface ICalibrationTimePeriodOutputDto {
    hasCalibration: boolean;
    calibrationTimeInHours: number;
}

export enum CallingConventions {
    Standard = "Standard",
    VarArgs = "VarArgs",
    Any = "Any",
    HasThis = "HasThis",
    ExplicitThis = "ExplicitThis",
}

export class CancelPaymentDto implements ICancelPaymentDto {
    paymentId!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;

    constructor(data?: ICancelPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.gateway = _data["gateway"];
        }
    }

    static fromJS(data: any): CancelPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data;
    }
}

export interface ICancelPaymentDto {
    paymentId: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
}

export class CancelPreActivityInput implements ICancelPreActivityInput {
    reportId!: number;
    cancelationComment!: string | undefined;
    notifyDriver!: boolean;

    constructor(data?: ICancelPreActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.cancelationComment = _data["cancelationComment"];
            this.notifyDriver = _data["notifyDriver"];
        }
    }

    static fromJS(data: any): CancelPreActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPreActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["cancelationComment"] = this.cancelationComment;
        data["notifyDriver"] = this.notifyDriver;
        return data;
    }
}

export interface ICancelPreActivityInput {
    reportId: number;
    cancelationComment: string | undefined;
    notifyDriver: boolean;
}

export class CancelPreActivityReportOutput implements ICancelPreActivityReportOutput {
    userToNotify!: UserDriverInformationOutput | undefined;
    licensePlate!: string | undefined;

    constructor(data?: ICancelPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userToNotify = _data["userToNotify"] ? UserDriverInformationOutput.fromJS(_data["userToNotify"]) : <any>undefined;
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): CancelPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userToNotify"] = this.userToNotify ? this.userToNotify.toJSON() : <any>undefined;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface ICancelPreActivityReportOutput {
    userToNotify: UserDriverInformationOutput | undefined;
    licensePlate: string | undefined;
}

export class CenterControlDiverseProductPreActivityReportSearchOutputDto implements ICenterControlDiverseProductPreActivityReportSearchOutputDto {
    id!: number;
    externalTruckId!: number;
    externalOriginId!: number;
    originType!: LocationType;
    externalDestinationId!: number;
    destinationType!: LocationType;
    validationResult!: PreActivityReportValidation;
    creationSystem!: ActivityReportCreationSystem;
    externalVehicleVendorId!: number;

    constructor(data?: ICenterControlDiverseProductPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalTruckId = _data["externalTruckId"];
            this.externalOriginId = _data["externalOriginId"];
            this.originType = _data["originType"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.destinationType = _data["destinationType"];
            this.validationResult = _data["validationResult"];
            this.creationSystem = _data["creationSystem"];
            this.externalVehicleVendorId = _data["externalVehicleVendorId"];
        }
    }

    static fromJS(data: any): CenterControlDiverseProductPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenterControlDiverseProductPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalTruckId"] = this.externalTruckId;
        data["externalOriginId"] = this.externalOriginId;
        data["originType"] = this.originType;
        data["externalDestinationId"] = this.externalDestinationId;
        data["destinationType"] = this.destinationType;
        data["validationResult"] = this.validationResult;
        data["creationSystem"] = this.creationSystem;
        data["externalVehicleVendorId"] = this.externalVehicleVendorId;
        return data;
    }
}

export interface ICenterControlDiverseProductPreActivityReportSearchOutputDto {
    id: number;
    externalTruckId: number;
    externalOriginId: number;
    originType: LocationType;
    externalDestinationId: number;
    destinationType: LocationType;
    validationResult: PreActivityReportValidation;
    creationSystem: ActivityReportCreationSystem;
    externalVehicleVendorId: number;
}

export class CenterControlInternalMovementPreActivityReportSearchOutputDto implements ICenterControlInternalMovementPreActivityReportSearchOutputDto {
    id!: number;
    externalTruckId!: number;
    externalOriginId!: number;
    originType!: LocationType;
    externalDestinationId!: number;
    destinationType!: LocationType;
    externalArticleId!: number;
    validationResult!: PreActivityReportValidation;
    creationSystem!: ActivityReportCreationSystem;

    constructor(data?: ICenterControlInternalMovementPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalTruckId = _data["externalTruckId"];
            this.externalOriginId = _data["externalOriginId"];
            this.originType = _data["originType"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.destinationType = _data["destinationType"];
            this.externalArticleId = _data["externalArticleId"];
            this.validationResult = _data["validationResult"];
            this.creationSystem = _data["creationSystem"];
        }
    }

    static fromJS(data: any): CenterControlInternalMovementPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenterControlInternalMovementPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalTruckId"] = this.externalTruckId;
        data["externalOriginId"] = this.externalOriginId;
        data["originType"] = this.originType;
        data["externalDestinationId"] = this.externalDestinationId;
        data["destinationType"] = this.destinationType;
        data["externalArticleId"] = this.externalArticleId;
        data["validationResult"] = this.validationResult;
        data["creationSystem"] = this.creationSystem;
        return data;
    }
}

export interface ICenterControlInternalMovementPreActivityReportSearchOutputDto {
    id: number;
    externalTruckId: number;
    externalOriginId: number;
    originType: LocationType;
    externalDestinationId: number;
    destinationType: LocationType;
    externalArticleId: number;
    validationResult: PreActivityReportValidation;
    creationSystem: ActivityReportCreationSystem;
}

export class CenterControlWoodPreActivityReportSearchOutputDto implements ICenterControlWoodPreActivityReportSearchOutputDto {
    externalVehicleVendorId!: number;
    creationSystem!: ActivityReportCreationSystem;
    number!: number | undefined;
    serial!: string | undefined;
    date!: DateTime;
    externalTruckId!: number;
    externalOriginId!: number;
    originType!: LocationType;
    externalDestinationId!: number;
    destinationType!: LocationType;
    scheduledEntryTime!: DateTime | undefined;
    validationResult!: PreActivityReportValidation;
    isApproved!: boolean;
    creationMode!: PreActivityReportCreationMode;
    paysTransport!: boolean;
    tripNumber!: number | undefined;
    isChip!: boolean;
    externalArticleId!: number;
    id!: number;

    constructor(data?: ICenterControlWoodPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalVehicleVendorId = _data["externalVehicleVendorId"];
            this.creationSystem = _data["creationSystem"];
            this.number = _data["number"];
            this.serial = _data["serial"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.externalTruckId = _data["externalTruckId"];
            this.externalOriginId = _data["externalOriginId"];
            this.originType = _data["originType"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.destinationType = _data["destinationType"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.isApproved = _data["isApproved"];
            this.creationMode = _data["creationMode"];
            this.paysTransport = _data["paysTransport"];
            this.tripNumber = _data["tripNumber"];
            this.isChip = _data["isChip"];
            this.externalArticleId = _data["externalArticleId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CenterControlWoodPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CenterControlWoodPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalVehicleVendorId"] = this.externalVehicleVendorId;
        data["creationSystem"] = this.creationSystem;
        data["number"] = this.number;
        data["serial"] = this.serial;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["externalTruckId"] = this.externalTruckId;
        data["externalOriginId"] = this.externalOriginId;
        data["originType"] = this.originType;
        data["externalDestinationId"] = this.externalDestinationId;
        data["destinationType"] = this.destinationType;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["isApproved"] = this.isApproved;
        data["creationMode"] = this.creationMode;
        data["paysTransport"] = this.paysTransport;
        data["tripNumber"] = this.tripNumber;
        data["isChip"] = this.isChip;
        data["externalArticleId"] = this.externalArticleId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICenterControlWoodPreActivityReportSearchOutputDto {
    externalVehicleVendorId: number;
    creationSystem: ActivityReportCreationSystem;
    number: number | undefined;
    serial: string | undefined;
    date: DateTime;
    externalTruckId: number;
    externalOriginId: number;
    originType: LocationType;
    externalDestinationId: number;
    destinationType: LocationType;
    scheduledEntryTime: DateTime | undefined;
    validationResult: PreActivityReportValidation;
    isApproved: boolean;
    creationMode: PreActivityReportCreationMode;
    paysTransport: boolean;
    tripNumber: number | undefined;
    isChip: boolean;
    externalArticleId: number;
    id: number;
}

export class ChangePasswordInput implements IChangePasswordInput {
    currentPassword!: string;
    newPassword!: string;

    constructor(data?: IChangePasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPassword = _data["currentPassword"];
            this.newPassword = _data["newPassword"];
        }
    }

    static fromJS(data: any): ChangePasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    }
}

export interface IChangePasswordInput {
    currentPassword: string;
    newPassword: string;
}

export class ChangeUserLanguageDto implements IChangeUserLanguageDto {
    languageName!: string;

    constructor(data?: IChangeUserLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
        }
    }

    static fromJS(data: any): ChangeUserLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    }
}

export interface IChangeUserLanguageDto {
    languageName: string;
}

export enum ChartDateInterval {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export class ChatMessageDto implements IChatMessageDto {
    userId!: number;
    tenantId!: number | undefined;
    targetUserId!: number;
    targetTenantId!: number | undefined;
    side!: ChatSide;
    readState!: ChatMessageReadState;
    receiverReadState!: ChatMessageReadState;
    message!: string | undefined;
    creationTime!: DateTime;
    sharedMessageId!: string | undefined;
    id!: number;

    constructor(data?: IChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
            this.targetUserId = _data["targetUserId"];
            this.targetTenantId = _data["targetTenantId"];
            this.side = _data["side"];
            this.readState = _data["readState"];
            this.receiverReadState = _data["receiverReadState"];
            this.message = _data["message"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.sharedMessageId = _data["sharedMessageId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    }
}

export interface IChatMessageDto {
    userId: number;
    tenantId: number | undefined;
    targetUserId: number;
    targetTenantId: number | undefined;
    side: ChatSide;
    readState: ChatMessageReadState;
    receiverReadState: ChatMessageReadState;
    message: string | undefined;
    creationTime: DateTime;
    sharedMessageId: string | undefined;
    id: number;
}

export enum ChatMessageReadState {
    Unread = "Unread",
    Read = "Read",
}

export enum ChatSide {
    Sender = "Sender",
    Receiver = "Receiver",
}

export class CheckDatabaseOutput implements ICheckDatabaseOutput {
    isDatabaseExist!: boolean;

    constructor(data?: ICheckDatabaseOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isDatabaseExist = _data["isDatabaseExist"];
        }
    }

    static fromJS(data: any): CheckDatabaseOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    }
}

export interface ICheckDatabaseOutput {
    isDatabaseExist: boolean;
}

export enum CheckpointMode {
    RFID = "RFID",
    Manual = "Manual",
    AccessCard = "AccessCard",
}

export class ChipSampleDto implements IChipSampleDto {
    sampleId!: number | undefined;
    humidity!: number | undefined;
    wasAssignedSample!: boolean;
    sampleDate!: DateTime | undefined;
    deletionComment!: string | undefined;

    constructor(data?: IChipSampleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sampleId = _data["sampleId"];
            this.humidity = _data["humidity"];
            this.wasAssignedSample = _data["wasAssignedSample"];
            this.sampleDate = _data["sampleDate"] ? DateTime.fromISO(_data["sampleDate"].toString()) : <any>undefined;
            this.deletionComment = _data["deletionComment"];
        }
    }

    static fromJS(data: any): ChipSampleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChipSampleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sampleId"] = this.sampleId;
        data["humidity"] = this.humidity;
        data["wasAssignedSample"] = this.wasAssignedSample;
        data["sampleDate"] = this.sampleDate ? this.sampleDate.toString() : <any>undefined;
        data["deletionComment"] = this.deletionComment;
        return data;
    }
}

export interface IChipSampleDto {
    sampleId: number | undefined;
    humidity: number | undefined;
    wasAssignedSample: boolean;
    sampleDate: DateTime | undefined;
    deletionComment: string | undefined;
}

export class CollectionIntegrationLogInputDto implements ICollectionIntegrationLogInputDto {
    executionId!: string;
    results!: SingleIntegrationLogInputDto[] | undefined;

    constructor(data?: ICollectionIntegrationLogInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executionId = _data["executionId"];
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SingleIntegrationLogInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CollectionIntegrationLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionIntegrationLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executionId"] = this.executionId;
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICollectionIntegrationLogInputDto {
    executionId: string;
    results: SingleIntegrationLogInputDto[] | undefined;
}

export class ComboboxItemDto implements IComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): ComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class ConstructorInfo implements IConstructorInfo {
    readonly memberType!: MemberTypes;
    readonly attributes!: MethodAttributes;
    readonly methodImplementationFlags!: MethodImplAttributes;
    readonly callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    readonly methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    readonly module!: Module | undefined;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IConstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).memberType = _data["memberType"];
            (<any>this).attributes = _data["attributes"];
            (<any>this).methodImplementationFlags = _data["methodImplementationFlags"];
            (<any>this).callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            (<any>this).module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ConstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IConstructorInfo {
    memberType: MemberTypes;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class ContactDto implements IContactDto {
    emailAddress!: string | undefined;
    id!: number;

    constructor(data?: IContactDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContactDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        data["id"] = this.id;
        return data;
    }
}

export interface IContactDto {
    emailAddress: string | undefined;
    id: number;
}

export class ContractDto implements IContractDto {
    tenantId!: number;
    externalIdentity!: ExternalIdentityDto | undefined;
    vendorExternalId!: number;
    contractTypeId!: number;
    id!: number;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.externalIdentity = _data["externalIdentity"] ? ExternalIdentityDto.fromJS(_data["externalIdentity"]) : <any>undefined;
            this.vendorExternalId = _data["vendorExternalId"];
            this.contractTypeId = _data["contractTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["externalIdentity"] = this.externalIdentity ? this.externalIdentity.toJSON() : <any>undefined;
        data["vendorExternalId"] = this.vendorExternalId;
        data["contractTypeId"] = this.contractTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IContractDto {
    tenantId: number;
    externalIdentity: ExternalIdentityDto | undefined;
    vendorExternalId: number;
    contractTypeId: number;
    id: number;
}

export class ContractOutputDto implements IContractOutputDto {
    externalId!: number;

    constructor(data?: IContractOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ContractOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IContractOutputDto {
    externalId: number;
}

export class ContractUsageTypeInfoInput implements IContractUsageTypeInfoInput {
    contractUsageTypeExternalId!: number;
    contractUsageTypeName!: string | undefined;

    constructor(data?: IContractUsageTypeInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractUsageTypeExternalId = _data["contractUsageTypeExternalId"];
            this.contractUsageTypeName = _data["contractUsageTypeName"];
        }
    }

    static fromJS(data: any): ContractUsageTypeInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new ContractUsageTypeInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractUsageTypeExternalId"] = this.contractUsageTypeExternalId;
        data["contractUsageTypeName"] = this.contractUsageTypeName;
        return data;
    }
}

export interface IContractUsageTypeInfoInput {
    contractUsageTypeExternalId: number;
    contractUsageTypeName: string | undefined;
}

export class CreateActivityReportIntegrationLogInputDto implements ICreateActivityReportIntegrationLogInputDto {
    operation!: IntegrationLogActionType;
    state!: IntegrationLogStates;
    date!: DateTime;
    automaticRetry!: boolean;
    activityReportId!: number;
    message!: string | undefined;
    resultCode!: string | undefined;
    shouldBeResetAttempts!: boolean;
    typeCFE!: number | undefined;
    cfeNumber!: number | undefined;
    cfeSerie!: string | undefined;
    stockSystemResponseDetail!: string | undefined;
    stockSystemResponseCode!: string | undefined;
    customsAllowed!: boolean | undefined;
    customsOrdinalInternalMovement!: number | undefined;
    customsOrdinalCustomsMovement!: number | undefined;
    customsErrorDescription!: string | undefined;
    loadActivityReport!: number;
    internalDestinationExternalId!: number;
    id!: number;

    constructor(data?: ICreateActivityReportIntegrationLogInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operation = _data["operation"];
            this.state = _data["state"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.automaticRetry = _data["automaticRetry"];
            this.activityReportId = _data["activityReportId"];
            this.message = _data["message"];
            this.resultCode = _data["resultCode"];
            this.shouldBeResetAttempts = _data["shouldBeResetAttempts"];
            this.typeCFE = _data["typeCFE"];
            this.cfeNumber = _data["cfeNumber"];
            this.cfeSerie = _data["cfeSerie"];
            this.stockSystemResponseDetail = _data["stockSystemResponseDetail"];
            this.stockSystemResponseCode = _data["stockSystemResponseCode"];
            this.customsAllowed = _data["customsAllowed"];
            this.customsOrdinalInternalMovement = _data["customsOrdinalInternalMovement"];
            this.customsOrdinalCustomsMovement = _data["customsOrdinalCustomsMovement"];
            this.customsErrorDescription = _data["customsErrorDescription"];
            this.loadActivityReport = _data["loadActivityReport"];
            this.internalDestinationExternalId = _data["internalDestinationExternalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateActivityReportIntegrationLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityReportIntegrationLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operation"] = this.operation;
        data["state"] = this.state;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["automaticRetry"] = this.automaticRetry;
        data["activityReportId"] = this.activityReportId;
        data["message"] = this.message;
        data["resultCode"] = this.resultCode;
        data["shouldBeResetAttempts"] = this.shouldBeResetAttempts;
        data["typeCFE"] = this.typeCFE;
        data["cfeNumber"] = this.cfeNumber;
        data["cfeSerie"] = this.cfeSerie;
        data["stockSystemResponseDetail"] = this.stockSystemResponseDetail;
        data["stockSystemResponseCode"] = this.stockSystemResponseCode;
        data["customsAllowed"] = this.customsAllowed;
        data["customsOrdinalInternalMovement"] = this.customsOrdinalInternalMovement;
        data["customsOrdinalCustomsMovement"] = this.customsOrdinalCustomsMovement;
        data["customsErrorDescription"] = this.customsErrorDescription;
        data["loadActivityReport"] = this.loadActivityReport;
        data["internalDestinationExternalId"] = this.internalDestinationExternalId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateActivityReportIntegrationLogInputDto {
    operation: IntegrationLogActionType;
    state: IntegrationLogStates;
    date: DateTime;
    automaticRetry: boolean;
    activityReportId: number;
    message: string | undefined;
    resultCode: string | undefined;
    shouldBeResetAttempts: boolean;
    typeCFE: number | undefined;
    cfeNumber: number | undefined;
    cfeSerie: string | undefined;
    stockSystemResponseDetail: string | undefined;
    stockSystemResponseCode: string | undefined;
    customsAllowed: boolean | undefined;
    customsOrdinalInternalMovement: number | undefined;
    customsOrdinalCustomsMovement: number | undefined;
    customsErrorDescription: string | undefined;
    loadActivityReport: number;
    internalDestinationExternalId: number;
    id: number;
}

export class CreateActivityReportLogInput implements ICreateActivityReportLogInput {
    activityReportId!: number;
    operation!: WoodControlActivityReportLogOperation;
    isOkResult!: boolean;
    resultDescription!: string | undefined;
    resultCode!: string | undefined;

    constructor(data?: ICreateActivityReportLogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.operation = _data["operation"];
            this.isOkResult = _data["isOkResult"];
            this.resultDescription = _data["resultDescription"];
            this.resultCode = _data["resultCode"];
        }
    }

    static fromJS(data: any): CreateActivityReportLogInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateActivityReportLogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["operation"] = this.operation;
        data["isOkResult"] = this.isOkResult;
        data["resultDescription"] = this.resultDescription;
        data["resultCode"] = this.resultCode;
        return data;
    }
}

export interface ICreateActivityReportLogInput {
    activityReportId: number;
    operation: WoodControlActivityReportLogOperation;
    isOkResult: boolean;
    resultDescription: string | undefined;
    resultCode: string | undefined;
}

export class CreateBasicReportAutomaticDto implements ICreateBasicReportAutomaticDto {
    tag!: number;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    vehicleTruckTypeExternalId!: number;
    destinationStockAreaId!: number | undefined;
    originStockAreaId!: number | undefined;
    type!: ActivityReportType;
    stateCondition!: ActivityReportStateCondition;
    reason!: ActivityReportSystemReasons | undefined;
    period!: PeriodInputDto | undefined;
    isAutomatic!: boolean;
    internalDestinationId!: number | undefined;
    reportDate!: DateTime;
    entryDate!: DateTime;
    entryZoneId!: number;

    constructor(data?: ICreateBasicReportAutomaticDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.destinationStockAreaId = _data["destinationStockAreaId"];
            this.originStockAreaId = _data["originStockAreaId"];
            this.type = _data["type"];
            this.stateCondition = _data["stateCondition"];
            this.reason = _data["reason"];
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : <any>undefined;
            this.isAutomatic = _data["isAutomatic"];
            this.internalDestinationId = _data["internalDestinationId"];
            this.reportDate = _data["reportDate"] ? DateTime.fromISO(_data["reportDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.entryZoneId = _data["entryZoneId"];
        }
    }

    static fromJS(data: any): CreateBasicReportAutomaticDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBasicReportAutomaticDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["destinationStockAreaId"] = this.destinationStockAreaId;
        data["originStockAreaId"] = this.originStockAreaId;
        data["type"] = this.type;
        data["stateCondition"] = this.stateCondition;
        data["reason"] = this.reason;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["isAutomatic"] = this.isAutomatic;
        data["internalDestinationId"] = this.internalDestinationId;
        data["reportDate"] = this.reportDate ? this.reportDate.toString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["entryZoneId"] = this.entryZoneId;
        return data;
    }
}

export interface ICreateBasicReportAutomaticDto {
    tag: number;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    vehicleTruckTypeExternalId: number;
    destinationStockAreaId: number | undefined;
    originStockAreaId: number | undefined;
    type: ActivityReportType;
    stateCondition: ActivityReportStateCondition;
    reason: ActivityReportSystemReasons | undefined;
    period: PeriodInputDto | undefined;
    isAutomatic: boolean;
    internalDestinationId: number | undefined;
    reportDate: DateTime;
    entryDate: DateTime;
    entryZoneId: number;
}

export class CreateBasicReportOutputDto implements ICreateBasicReportOutputDto {
    reportId!: number | undefined;
    success!: boolean;

    constructor(data?: ICreateBasicReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.success = _data["success"];
        }
    }

    static fromJS(data: any): CreateBasicReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBasicReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["success"] = this.success;
        return data;
    }
}

export interface ICreateBasicReportOutputDto {
    reportId: number | undefined;
    success: boolean;
}

export class CreateBrokerInputDto implements ICreateBrokerInputDto {
    name!: string;
    url!: string;
    username!: string;
    password!: string;
    email!: string;
    externalId!: number;

    constructor(data?: ICreateBrokerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.url = _data["url"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): CreateBrokerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBrokerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["url"] = this.url;
        data["username"] = this.username;
        data["password"] = this.password;
        data["email"] = this.email;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface ICreateBrokerInputDto {
    name: string;
    url: string;
    username: string;
    password: string;
    email: string;
    externalId: number;
}

export class CreateBrokerOutputDto implements ICreateBrokerOutputDto {
    id!: number;
    name!: string | undefined;
    url!: string | undefined;
    username!: string | undefined;

    constructor(data?: ICreateBrokerOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.username = _data["username"];
        }
    }

    static fromJS(data: any): CreateBrokerOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateBrokerOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["username"] = this.username;
        return data;
    }
}

export interface ICreateBrokerOutputDto {
    id: number;
    name: string | undefined;
    url: string | undefined;
    username: string | undefined;
}

export class CreateDiverseProductPreActivityReportInput implements ICreateDiverseProductPreActivityReportInput {
    errors!: PreActivityReportErrorDto[] | undefined;
    creationSystem!: ActivityReportCreationSystem;
    origin!: ExternalLocationInputDto | undefined;
    destination!: ExternalLocationInputDto | undefined;
    date!: DateTime;
    vehicleVendorExternalId!: number;
    vehicleExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleTruckTypeExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    lines!: DiverseProductActivityReportLineInputDto[] | undefined;
    period!: PeriodInputDto | undefined;
    paysTransport!: boolean;

    constructor(data?: ICreateDiverseProductPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.creationSystem = _data["creationSystem"];
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? ExternalLocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DiverseProductActivityReportLineInputDto.fromJS(item));
            }
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
        }
    }

    static fromJS(data: any): CreateDiverseProductPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDiverseProductPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["creationSystem"] = this.creationSystem;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        return data;
    }
}

export interface ICreateDiverseProductPreActivityReportInput {
    errors: PreActivityReportErrorDto[] | undefined;
    creationSystem: ActivityReportCreationSystem;
    origin: ExternalLocationInputDto | undefined;
    destination: ExternalLocationInputDto | undefined;
    date: DateTime;
    vehicleVendorExternalId: number;
    vehicleExternalId: number;
    vehicleLicensePlate: string | undefined;
    vehicleTruckTypeExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    lines: DiverseProductActivityReportLineInputDto[] | undefined;
    period: PeriodInputDto | undefined;
    paysTransport: boolean;
}

export class CreateEditExternalProviderInputDto implements ICreateEditExternalProviderInputDto {
    azureId!: string;
    externalVendorId!: number;
    name!: string;
    providerType!: ProviderType;
    id!: number;

    constructor(data?: ICreateEditExternalProviderInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.azureId = _data["azureId"];
            this.externalVendorId = _data["externalVendorId"];
            this.name = _data["name"];
            this.providerType = _data["providerType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateEditExternalProviderInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditExternalProviderInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["azureId"] = this.azureId;
        data["externalVendorId"] = this.externalVendorId;
        data["name"] = this.name;
        data["providerType"] = this.providerType;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateEditExternalProviderInputDto {
    azureId: string;
    externalVendorId: number;
    name: string;
    providerType: ProviderType;
    id: number;
}

export class CreateEditionDto implements ICreateEditionDto {
    edition!: EditionCreateDto;
    featureValues!: NameValueDto[];

    constructor(data?: ICreateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionCreateDto.fromJS(_data["edition"]) : new EditionCreateDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICreateEditionDto {
    edition: EditionCreateDto;
    featureValues: NameValueDto[];
}

export class CreateFriendshipRequestByUserNameInput implements ICreateFriendshipRequestByUserNameInput {
    tenancyName!: string;
    userName!: string | undefined;

    constructor(data?: ICreateFriendshipRequestByUserNameInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestByUserNameInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    }
}

export interface ICreateFriendshipRequestByUserNameInput {
    tenancyName: string;
    userName: string | undefined;
}

export class CreateFriendshipRequestInput implements ICreateFriendshipRequestInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: ICreateFriendshipRequestInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): CreateFriendshipRequestInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface ICreateFriendshipRequestInput {
    userId: number;
    tenantId: number | undefined;
}

export class CreateInternalMovementPreActivityReportInput implements ICreateInternalMovementPreActivityReportInput {
    errors!: PreActivityReportErrorDto[] | undefined;
    period!: PeriodInputDto | undefined;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationType!: LocationType;
    date!: DateTime;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleTruckTypeExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    lines!: InternalMovementActivityReportLineInputDto[] | undefined;
    creationSystem!: ActivityReportCreationSystem;
    comment!: string | undefined;

    constructor(data?: ICreateInternalMovementPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : <any>undefined;
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(InternalMovementActivityReportLineInputDto.fromJS(item));
            }
            this.creationSystem = _data["creationSystem"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateInternalMovementPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInternalMovementPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["creationSystem"] = this.creationSystem;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateInternalMovementPreActivityReportInput {
    errors: PreActivityReportErrorDto[] | undefined;
    period: PeriodInputDto | undefined;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationType: LocationType;
    date: DateTime;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    vehicleLicensePlate: string | undefined;
    vehicleTruckTypeExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    lines: InternalMovementActivityReportLineInputDto[] | undefined;
    creationSystem: ActivityReportCreationSystem;
    comment: string | undefined;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    subscriptionPaymentId!: number;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.subscriptionPaymentId = _data["subscriptionPaymentId"];
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    }
}

export interface ICreateInvoiceDto {
    subscriptionPaymentId: number;
}

export class CreateLogyardActivityReportLogInput implements ICreateLogyardActivityReportLogInput {
    activityReportId!: number;
    operation!: WoodControlActivityReportLogOperation;
    isOkResult!: boolean;
    resultDescription!: string | undefined;
    resultCode!: string | undefined;
    userId!: number;
    date!: DateTime;
    activityReportLocalId!: number;
    localLogId!: number;

    constructor(data?: ICreateLogyardActivityReportLogInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.operation = _data["operation"];
            this.isOkResult = _data["isOkResult"];
            this.resultDescription = _data["resultDescription"];
            this.resultCode = _data["resultCode"];
            this.userId = _data["userId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.activityReportLocalId = _data["activityReportLocalId"];
            this.localLogId = _data["localLogId"];
        }
    }

    static fromJS(data: any): CreateLogyardActivityReportLogInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLogyardActivityReportLogInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["operation"] = this.operation;
        data["isOkResult"] = this.isOkResult;
        data["resultDescription"] = this.resultDescription;
        data["resultCode"] = this.resultCode;
        data["userId"] = this.userId;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["activityReportLocalId"] = this.activityReportLocalId;
        data["localLogId"] = this.localLogId;
        return data;
    }
}

export interface ICreateLogyardActivityReportLogInput {
    activityReportId: number;
    operation: WoodControlActivityReportLogOperation;
    isOkResult: boolean;
    resultDescription: string | undefined;
    resultCode: string | undefined;
    userId: number;
    date: DateTime;
    activityReportLocalId: number;
    localLogId: number;
}

export class CreateManualDiverseProductActivityReportInput implements ICreateManualDiverseProductActivityReportInput {
    singleCustomDeclarationExternalId!: number;
    netWeight!: number;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    comment!: string | undefined;
    usageName!: string | undefined;
    contractTypeUsageExternalId!: number;
    origin!: ExternalLocationInputDto | undefined;
    destination!: ExternalLocationInputDto | undefined;
    date!: DateTime;
    vehicleVendorExternalId!: number;
    vehicleExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleTruckTypeExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    lines!: DiverseProductActivityReportLineInputDto[] | undefined;
    period!: PeriodInputDto | undefined;
    paysTransport!: boolean;

    constructor(data?: ICreateManualDiverseProductActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.singleCustomDeclarationExternalId = _data["singleCustomDeclarationExternalId"];
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.comment = _data["comment"];
            this.usageName = _data["usageName"];
            this.contractTypeUsageExternalId = _data["contractTypeUsageExternalId"];
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? ExternalLocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DiverseProductActivityReportLineInputDto.fromJS(item));
            }
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
        }
    }

    static fromJS(data: any): CreateManualDiverseProductActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualDiverseProductActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["singleCustomDeclarationExternalId"] = this.singleCustomDeclarationExternalId;
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        data["usageName"] = this.usageName;
        data["contractTypeUsageExternalId"] = this.contractTypeUsageExternalId;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        return data;
    }
}

export interface ICreateManualDiverseProductActivityReportInput {
    singleCustomDeclarationExternalId: number;
    netWeight: number;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    comment: string | undefined;
    usageName: string | undefined;
    contractTypeUsageExternalId: number;
    origin: ExternalLocationInputDto | undefined;
    destination: ExternalLocationInputDto | undefined;
    date: DateTime;
    vehicleVendorExternalId: number;
    vehicleExternalId: number;
    vehicleLicensePlate: string | undefined;
    vehicleTruckTypeExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    lines: DiverseProductActivityReportLineInputDto[] | undefined;
    period: PeriodInputDto | undefined;
    paysTransport: boolean;
}

export class CreateManualDiverseProductActivityReportOutput implements ICreateManualDiverseProductActivityReportOutput {
    result!: boolean;
    diverseProductActivityReportId!: number;
    diverseProductActivityPlaceId!: number;

    constructor(data?: ICreateManualDiverseProductActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"];
            this.diverseProductActivityReportId = _data["diverseProductActivityReportId"];
            this.diverseProductActivityPlaceId = _data["diverseProductActivityPlaceId"];
        }
    }

    static fromJS(data: any): CreateManualDiverseProductActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualDiverseProductActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result;
        data["diverseProductActivityReportId"] = this.diverseProductActivityReportId;
        data["diverseProductActivityPlaceId"] = this.diverseProductActivityPlaceId;
        return data;
    }
}

export interface ICreateManualDiverseProductActivityReportOutput {
    result: boolean;
    diverseProductActivityReportId: number;
    diverseProductActivityPlaceId: number;
}

export class CreateManualInternalMovementActivityReportInput implements ICreateManualInternalMovementActivityReportInput {
    netWeight!: number;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    period!: PeriodInputDto | undefined;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationType!: LocationType;
    date!: DateTime;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleTruckTypeExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    lines!: InternalMovementActivityReportLineInputDto[] | undefined;
    creationSystem!: ActivityReportCreationSystem;
    comment!: string | undefined;

    constructor(data?: ICreateManualInternalMovementActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : <any>undefined;
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(InternalMovementActivityReportLineInputDto.fromJS(item));
            }
            this.creationSystem = _data["creationSystem"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): CreateManualInternalMovementActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualInternalMovementActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["creationSystem"] = this.creationSystem;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ICreateManualInternalMovementActivityReportInput {
    netWeight: number;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    period: PeriodInputDto | undefined;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationType: LocationType;
    date: DateTime;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    vehicleLicensePlate: string | undefined;
    vehicleTruckTypeExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    lines: InternalMovementActivityReportLineInputDto[] | undefined;
    creationSystem: ActivityReportCreationSystem;
    comment: string | undefined;
}

export class CreateManualInternalMovementActivityReportOutput implements ICreateManualInternalMovementActivityReportOutput {
    internalMovementActivityReportId!: number;
    result!: boolean;

    constructor(data?: ICreateManualInternalMovementActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalMovementActivityReportId = _data["internalMovementActivityReportId"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): CreateManualInternalMovementActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualInternalMovementActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalMovementActivityReportId"] = this.internalMovementActivityReportId;
        data["result"] = this.result;
        return data;
    }
}

export interface ICreateManualInternalMovementActivityReportOutput {
    internalMovementActivityReportId: number;
    result: boolean;
}

export class CreateManualWoodActivityReportInput implements ICreateManualWoodActivityReportInput {
    grossWeight!: WeightDto;
    tareWeight!: WeightDto;
    netWeight!: number;
    internalDestination!: ZonesDto;
    cycle!: number | undefined;
    loadDate!: DateTime | undefined;
    singleCustomDeclaration!: SingleCustomsDeclarationInputDto | undefined;
    usesScannerMeasurements!: boolean;
    origin!: ExternalLocationInputDto;
    destination!: ExternalLocationInputDto;
    serial!: string | undefined;
    number!: number;
    date!: DateTime;
    tripNumber!: number | undefined;
    lines!: WoodControlActivityReportLineInputDto[] | undefined;
    period!: PeriodInputDto;
    isChip!: boolean;
    paysTransport!: boolean;
    semitrailers!: ExternalTruckVehicleInput[] | undefined;
    vehicleVendorExternalId!: number;
    placeId!: number;
    vehicleExternalId!: number;
    vehicleTruckTypeExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    comment!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    precision!: number | undefined;
    estimatedVolume!: number;
    id!: number;

    constructor(data?: ICreateManualWoodActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grossWeight = new WeightDto();
            this.tareWeight = new WeightDto();
            this.internalDestination = new ZonesDto();
            this.origin = new ExternalLocationInputDto();
            this.destination = new ExternalLocationInputDto();
            this.period = new PeriodInputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : new WeightDto();
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : new WeightDto();
            this.netWeight = _data["netWeight"];
            this.internalDestination = _data["internalDestination"] ? ZonesDto.fromJS(_data["internalDestination"]) : new ZonesDto();
            this.cycle = _data["cycle"];
            this.loadDate = _data["loadDate"] ? DateTime.fromISO(_data["loadDate"].toString()) : <any>undefined;
            this.singleCustomDeclaration = _data["singleCustomDeclaration"] ? SingleCustomsDeclarationInputDto.fromJS(_data["singleCustomDeclaration"]) : <any>undefined;
            this.usesScannerMeasurements = _data["usesScannerMeasurements"];
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : new ExternalLocationInputDto();
            this.destination = _data["destination"] ? ExternalLocationInputDto.fromJS(_data["destination"]) : new ExternalLocationInputDto();
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineInputDto.fromJS(item));
            }
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : new PeriodInputDto();
            this.isChip = _data["isChip"];
            this.paysTransport = _data["paysTransport"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(ExternalTruckVehicleInput.fromJS(item));
            }
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.placeId = _data["placeId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.comment = _data["comment"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.precision = _data["precision"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateManualWoodActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateManualWoodActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["internalDestination"] = this.internalDestination ? this.internalDestination.toJSON() : <any>undefined;
        data["cycle"] = this.cycle;
        data["loadDate"] = this.loadDate ? this.loadDate.toString() : <any>undefined;
        data["singleCustomDeclaration"] = this.singleCustomDeclaration ? this.singleCustomDeclaration.toJSON() : <any>undefined;
        data["usesScannerMeasurements"] = this.usesScannerMeasurements;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["isChip"] = this.isChip;
        data["paysTransport"] = this.paysTransport;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["placeId"] = this.placeId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["comment"] = this.comment;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["precision"] = this.precision;
        data["estimatedVolume"] = this.estimatedVolume;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateManualWoodActivityReportInput {
    grossWeight: WeightDto;
    tareWeight: WeightDto;
    netWeight: number;
    internalDestination: ZonesDto;
    cycle: number | undefined;
    loadDate: DateTime | undefined;
    singleCustomDeclaration: SingleCustomsDeclarationInputDto | undefined;
    usesScannerMeasurements: boolean;
    origin: ExternalLocationInputDto;
    destination: ExternalLocationInputDto;
    serial: string | undefined;
    number: number;
    date: DateTime;
    tripNumber: number | undefined;
    lines: WoodControlActivityReportLineInputDto[] | undefined;
    period: PeriodInputDto;
    isChip: boolean;
    paysTransport: boolean;
    semitrailers: ExternalTruckVehicleInput[] | undefined;
    vehicleVendorExternalId: number;
    placeId: number;
    vehicleExternalId: number;
    vehicleTruckTypeExternalId: number;
    vehicleLicensePlate: string | undefined;
    driverExternalId: number;
    driverVendorExternalId: number;
    comment: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    precision: number | undefined;
    estimatedVolume: number;
    id: number;
}

export class CreateOrganizationUnitInput implements ICreateOrganizationUnitInput {
    parentId!: number | undefined;
    displayName!: string;

    constructor(data?: ICreateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): CreateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface ICreateOrganizationUnitInput {
    parentId: number | undefined;
    displayName: string;
}

export class CreateOrUpdateLanguageInput implements ICreateOrUpdateLanguageInput {
    language!: ApplicationLanguageEditDto;

    constructor(data?: ICreateOrUpdateLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : new ApplicationLanguageEditDto();
        }
    }

    static fromJS(data: any): CreateOrUpdateLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateOrUpdateLanguageInput {
    language: ApplicationLanguageEditDto;
}

export class CreateOrUpdateRoleInput implements ICreateOrUpdateRoleInput {
    role!: RoleEditDto;
    grantedPermissionNames!: string[];

    constructor(data?: ICreateOrUpdateRoleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : new RoleEditDto();
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateRoleInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateRoleInput {
    role: RoleEditDto;
    grantedPermissionNames: string[];
}

export class CreateOrUpdateUserInput implements ICreateOrUpdateUserInput {
    user!: UserEditDto;
    assignedRoleNames!: string[];
    sendActivationEmail!: boolean;
    setRandomPassword!: boolean;
    organizationUnits!: number[] | undefined;

    constructor(data?: ICreateOrUpdateUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : new UserEditDto();
            if (Array.isArray(_data["assignedRoleNames"])) {
                this.assignedRoleNames = [] as any;
                for (let item of _data["assignedRoleNames"])
                    this.assignedRoleNames!.push(item);
            }
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.setRandomPassword = _data["setRandomPassword"];
            if (Array.isArray(_data["organizationUnits"])) {
                this.organizationUnits = [] as any;
                for (let item of _data["organizationUnits"])
                    this.organizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateOrUpdateUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedRoleNames)) {
            data["assignedRoleNames"] = [];
            for (let item of this.assignedRoleNames)
                data["assignedRoleNames"].push(item);
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (Array.isArray(this.organizationUnits)) {
            data["organizationUnits"] = [];
            for (let item of this.organizationUnits)
                data["organizationUnits"].push(item);
        }
        return data;
    }
}

export interface ICreateOrUpdateUserInput {
    user: UserEditDto;
    assignedRoleNames: string[];
    sendActivationEmail: boolean;
    setRandomPassword: boolean;
    organizationUnits: number[] | undefined;
}

export class CreatePaymentDto implements ICreatePaymentDto {
    editionId!: number;
    editionPaymentType!: EditionPaymentType;
    paymentPeriodType!: PaymentPeriodType | undefined;
    subscriptionPaymentGatewayType!: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled!: boolean;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;

    constructor(data?: ICreatePaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.editionId = _data["editionId"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = _data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = _data["recurringPaymentEnabled"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
        }
    }

    static fromJS(data: any): CreatePaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    }
}

export interface ICreatePaymentDto {
    editionId: number;
    editionPaymentType: EditionPaymentType;
    paymentPeriodType: PaymentPeriodType | undefined;
    subscriptionPaymentGatewayType: SubscriptionPaymentGatewayType;
    recurringPaymentEnabled: boolean;
    successUrl: string | undefined;
    errorUrl: string | undefined;
}

export class CreatePileInput implements ICreatePileInput {
    pileExternalId!: number;
    pileType!: PileType;
    name!: string | undefined;
    number!: number;
    logyardExternalId!: number;
    articleExternalId!: number;
    isPefcCertified!: boolean;
    isFscCertified!: boolean;
    contractTypeGroupId!: number;
    geneticMaterialTypeId!: number;
    pileOrigins!: PileOriginDto[] | undefined;
    allowsEntry!: boolean;
    allowsExit!: boolean;
    pileStatus!: PileStatus;

    constructor(data?: ICreatePileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pileExternalId = _data["pileExternalId"];
            this.pileType = _data["pileType"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.logyardExternalId = _data["logyardExternalId"];
            this.articleExternalId = _data["articleExternalId"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.isFscCertified = _data["isFscCertified"];
            this.contractTypeGroupId = _data["contractTypeGroupId"];
            this.geneticMaterialTypeId = _data["geneticMaterialTypeId"];
            if (Array.isArray(_data["pileOrigins"])) {
                this.pileOrigins = [] as any;
                for (let item of _data["pileOrigins"])
                    this.pileOrigins!.push(PileOriginDto.fromJS(item));
            }
            this.allowsEntry = _data["allowsEntry"];
            this.allowsExit = _data["allowsExit"];
            this.pileStatus = _data["pileStatus"];
        }
    }

    static fromJS(data: any): CreatePileInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pileExternalId"] = this.pileExternalId;
        data["pileType"] = this.pileType;
        data["name"] = this.name;
        data["number"] = this.number;
        data["logyardExternalId"] = this.logyardExternalId;
        data["articleExternalId"] = this.articleExternalId;
        data["isPefcCertified"] = this.isPefcCertified;
        data["isFscCertified"] = this.isFscCertified;
        data["contractTypeGroupId"] = this.contractTypeGroupId;
        data["geneticMaterialTypeId"] = this.geneticMaterialTypeId;
        if (Array.isArray(this.pileOrigins)) {
            data["pileOrigins"] = [];
            for (let item of this.pileOrigins)
                data["pileOrigins"].push(item.toJSON());
        }
        data["allowsEntry"] = this.allowsEntry;
        data["allowsExit"] = this.allowsExit;
        data["pileStatus"] = this.pileStatus;
        return data;
    }
}

export interface ICreatePileInput {
    pileExternalId: number;
    pileType: PileType;
    name: string | undefined;
    number: number;
    logyardExternalId: number;
    articleExternalId: number;
    isPefcCertified: boolean;
    isFscCertified: boolean;
    contractTypeGroupId: number;
    geneticMaterialTypeId: number;
    pileOrigins: PileOriginDto[] | undefined;
    allowsEntry: boolean;
    allowsExit: boolean;
    pileStatus: PileStatus;
}

export class CreatePileOutput implements ICreatePileOutput {
    creationResult!: boolean;
    pileId!: number;

    constructor(data?: ICreatePileOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationResult = _data["creationResult"];
            this.pileId = _data["pileId"];
        }
    }

    static fromJS(data: any): CreatePileOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePileOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationResult"] = this.creationResult;
        data["pileId"] = this.pileId;
        return data;
    }
}

export interface ICreatePileOutput {
    creationResult: boolean;
    pileId: number;
}

export class CreatePolygonContractInputDto implements ICreatePolygonContractInputDto {
    externalContractId!: number;
    isActive!: boolean;
    emails!: string[] | undefined;

    constructor(data?: ICreatePolygonContractInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalContractId = _data["externalContractId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePolygonContractInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePolygonContractInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalContractId"] = this.externalContractId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface ICreatePolygonContractInputDto {
    externalContractId: number;
    isActive: boolean;
    emails: string[] | undefined;
}

export class CreateServiceConfigurationInputDto implements ICreateServiceConfigurationInputDto {
    externalArticleId!: number;
    externalInvoiceServiceId!: number;
    originId!: number;
    externalDestinationId!: number | undefined;
    serviceType!: ServiceType;

    constructor(data?: ICreateServiceConfigurationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalArticleId = _data["externalArticleId"];
            this.externalInvoiceServiceId = _data["externalInvoiceServiceId"];
            this.originId = _data["originId"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.serviceType = _data["serviceType"];
        }
    }

    static fromJS(data: any): CreateServiceConfigurationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateServiceConfigurationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalArticleId"] = this.externalArticleId;
        data["externalInvoiceServiceId"] = this.externalInvoiceServiceId;
        data["originId"] = this.originId;
        data["externalDestinationId"] = this.externalDestinationId;
        data["serviceType"] = this.serviceType;
        return data;
    }
}

export interface ICreateServiceConfigurationInputDto {
    externalArticleId: number;
    externalInvoiceServiceId: number;
    originId: number;
    externalDestinationId: number | undefined;
    serviceType: ServiceType;
}

export class CreateTagInputDto implements ICreateTagInputDto {
    tagNumber!: string;
    truckVehicle!: VehicleInTagDto;
    id!: number;

    constructor(data?: ICreateTagInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.truckVehicle = new VehicleInTagDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagNumber = _data["tagNumber"];
            this.truckVehicle = _data["truckVehicle"] ? VehicleInTagDto.fromJS(_data["truckVehicle"]) : new VehicleInTagDto();
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateTagInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagNumber"] = this.tagNumber;
        data["truckVehicle"] = this.truckVehicle ? this.truckVehicle.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateTagInputDto {
    tagNumber: string;
    truckVehicle: VehicleInTagDto;
    id: number;
}

export class CreateTagOutputDto implements ICreateTagOutputDto {
    tagNumber!: number;
    truckVehicle!: TruckVehicleDto | undefined;
    id!: number;

    constructor(data?: ICreateTagOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagNumber = _data["tagNumber"];
            this.truckVehicle = _data["truckVehicle"] ? TruckVehicleDto.fromJS(_data["truckVehicle"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateTagOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTagOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagNumber"] = this.tagNumber;
        data["truckVehicle"] = this.truckVehicle ? this.truckVehicle.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateTagOutputDto {
    tagNumber: number;
    truckVehicle: TruckVehicleDto | undefined;
    id: number;
}

export class CreateTenantInput implements ICreateTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    connectionString!: string | undefined;
    shouldChangePasswordOnNextLogin!: boolean;
    sendActivationEmail!: boolean;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;

    constructor(data?: ICreateTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.connectionString = _data["connectionString"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = _data["sendActivationEmail"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
        }
    }

    static fromJS(data: any): CreateTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    }
}

export interface ICreateTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    connectionString: string | undefined;
    shouldChangePasswordOnNextLogin: boolean;
    sendActivationEmail: boolean;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
}

export class CreateUserDelegationDto implements ICreateUserDelegationDto {
    targetUserId!: number;
    startTime!: DateTime;
    endTime!: DateTime;

    constructor(data?: ICreateUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUserId = _data["targetUserId"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUserId"] = this.targetUserId;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        return data;
    }
}

export interface ICreateUserDelegationDto {
    targetUserId: number;
    startTime: DateTime;
    endTime: DateTime;
}

export class CreateWoodActivityReportFromLogyardInput implements ICreateWoodActivityReportFromLogyardInput {
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    netWeight!: number;
    loadDate!: DateTime | undefined;
    operationMode!: ActivityReportOperationMode;
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    localId!: number;
    exitDate!: DateTime | undefined;
    hasLoadActivityReport!: boolean;
    useScanner!: boolean;
    woodActivityReportGeoLocationInformation!: WoodActivityReportGeoLocationInformationDto | undefined;
    origin!: ExternalLocationInputDto;
    destination!: ExternalLocationInputDto;
    serial!: string | undefined;
    number!: number;
    date!: DateTime;
    tripNumber!: number | undefined;
    lines!: WoodControlActivityReportLineInputDto[] | undefined;
    period!: PeriodInputDto;
    isChip!: boolean;
    paysTransport!: boolean;
    semitrailers!: ExternalTruckVehicleInput[] | undefined;
    vehicleVendorExternalId!: number;
    placeId!: number;
    vehicleExternalId!: number;
    vehicleTruckTypeExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    comment!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    precision!: number | undefined;
    estimatedVolume!: number;
    id!: number;

    constructor(data?: ICreateWoodActivityReportFromLogyardInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.origin = new ExternalLocationInputDto();
            this.destination = new ExternalLocationInputDto();
            this.period = new PeriodInputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.loadDate = _data["loadDate"] ? DateTime.fromISO(_data["loadDate"].toString()) : <any>undefined;
            this.operationMode = _data["operationMode"];
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.localId = _data["localId"];
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.hasLoadActivityReport = _data["hasLoadActivityReport"];
            this.useScanner = _data["useScanner"];
            this.woodActivityReportGeoLocationInformation = _data["woodActivityReportGeoLocationInformation"] ? WoodActivityReportGeoLocationInformationDto.fromJS(_data["woodActivityReportGeoLocationInformation"]) : <any>undefined;
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : new ExternalLocationInputDto();
            this.destination = _data["destination"] ? ExternalLocationInputDto.fromJS(_data["destination"]) : new ExternalLocationInputDto();
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineInputDto.fromJS(item));
            }
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : new PeriodInputDto();
            this.isChip = _data["isChip"];
            this.paysTransport = _data["paysTransport"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(ExternalTruckVehicleInput.fromJS(item));
            }
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.placeId = _data["placeId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.comment = _data["comment"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.precision = _data["precision"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWoodActivityReportFromLogyardInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodActivityReportFromLogyardInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["loadDate"] = this.loadDate ? this.loadDate.toString() : <any>undefined;
        data["operationMode"] = this.operationMode;
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["localId"] = this.localId;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["hasLoadActivityReport"] = this.hasLoadActivityReport;
        data["useScanner"] = this.useScanner;
        data["woodActivityReportGeoLocationInformation"] = this.woodActivityReportGeoLocationInformation ? this.woodActivityReportGeoLocationInformation.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["isChip"] = this.isChip;
        data["paysTransport"] = this.paysTransport;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["placeId"] = this.placeId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["comment"] = this.comment;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["precision"] = this.precision;
        data["estimatedVolume"] = this.estimatedVolume;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateWoodActivityReportFromLogyardInput {
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    netWeight: number;
    loadDate: DateTime | undefined;
    operationMode: ActivityReportOperationMode;
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    localId: number;
    exitDate: DateTime | undefined;
    hasLoadActivityReport: boolean;
    useScanner: boolean;
    woodActivityReportGeoLocationInformation: WoodActivityReportGeoLocationInformationDto | undefined;
    origin: ExternalLocationInputDto;
    destination: ExternalLocationInputDto;
    serial: string | undefined;
    number: number;
    date: DateTime;
    tripNumber: number | undefined;
    lines: WoodControlActivityReportLineInputDto[] | undefined;
    period: PeriodInputDto;
    isChip: boolean;
    paysTransport: boolean;
    semitrailers: ExternalTruckVehicleInput[] | undefined;
    vehicleVendorExternalId: number;
    placeId: number;
    vehicleExternalId: number;
    vehicleTruckTypeExternalId: number;
    vehicleLicensePlate: string | undefined;
    driverExternalId: number;
    driverVendorExternalId: number;
    comment: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    precision: number | undefined;
    estimatedVolume: number;
    id: number;
}

export class CreateWoodActivityReportOutput implements ICreateWoodActivityReportOutput {
    woodActivityReportId!: number;
    result!: boolean;

    constructor(data?: ICreateWoodActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodActivityReportId = _data["woodActivityReportId"];
            this.result = _data["result"];
        }
    }

    static fromJS(data: any): CreateWoodActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodActivityReportId"] = this.woodActivityReportId;
        data["result"] = this.result;
        return data;
    }
}

export interface ICreateWoodActivityReportOutput {
    woodActivityReportId: number;
    result: boolean;
}

export class CreateWoodPreActivityReportInput implements ICreateWoodPreActivityReportInput {
    receiptPhoto!: string | undefined;
    errors!: PreActivityReportErrorDto[] | undefined;
    creationMode!: PreActivityReportCreationMode;
    eta!: DateTime | undefined;
    loaderVendor!: ExternalVendorInput | undefined;
    creationSystem!: ActivityReportCreationSystem;
    thirdPropertyCategory!: number | undefined;
    certification!: WoodPreActivityReportCertificationDto | undefined;
    travelSystemHasError!: boolean | undefined;
    isTruckPlateDifferentConfirmed!: boolean;
    truckPlateParsedFromQR!: string | undefined;
    origin!: ExternalLocationInputDto;
    destination!: ExternalLocationInputDto;
    serial!: string | undefined;
    number!: number;
    date!: DateTime;
    tripNumber!: number | undefined;
    lines!: WoodControlActivityReportLineInputDto[] | undefined;
    period!: PeriodInputDto;
    isChip!: boolean;
    paysTransport!: boolean;
    semitrailers!: ExternalTruckVehicleInput[] | undefined;
    vehicleVendorExternalId!: number;
    placeId!: number;
    vehicleExternalId!: number;
    vehicleTruckTypeExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    comment!: string | undefined;
    latitude!: number | undefined;
    longitude!: number | undefined;
    precision!: number | undefined;
    estimatedVolume!: number;
    id!: number;

    constructor(data?: ICreateWoodPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.origin = new ExternalLocationInputDto();
            this.destination = new ExternalLocationInputDto();
            this.period = new PeriodInputDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiptPhoto = _data["receiptPhoto"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.creationMode = _data["creationMode"];
            this.eta = _data["eta"] ? DateTime.fromISO(_data["eta"].toString()) : <any>undefined;
            this.loaderVendor = _data["loaderVendor"] ? ExternalVendorInput.fromJS(_data["loaderVendor"]) : <any>undefined;
            this.creationSystem = _data["creationSystem"];
            this.thirdPropertyCategory = _data["thirdPropertyCategory"];
            this.certification = _data["certification"] ? WoodPreActivityReportCertificationDto.fromJS(_data["certification"]) : <any>undefined;
            this.travelSystemHasError = _data["travelSystemHasError"];
            this.isTruckPlateDifferentConfirmed = _data["isTruckPlateDifferentConfirmed"];
            this.truckPlateParsedFromQR = _data["truckPlateParsedFromQR"];
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : new ExternalLocationInputDto();
            this.destination = _data["destination"] ? ExternalLocationInputDto.fromJS(_data["destination"]) : new ExternalLocationInputDto();
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineInputDto.fromJS(item));
            }
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : new PeriodInputDto();
            this.isChip = _data["isChip"];
            this.paysTransport = _data["paysTransport"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(ExternalTruckVehicleInput.fromJS(item));
            }
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.placeId = _data["placeId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.comment = _data["comment"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.precision = _data["precision"];
            this.estimatedVolume = _data["estimatedVolume"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateWoodPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiptPhoto"] = this.receiptPhoto;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["creationMode"] = this.creationMode;
        data["eta"] = this.eta ? this.eta.toString() : <any>undefined;
        data["loaderVendor"] = this.loaderVendor ? this.loaderVendor.toJSON() : <any>undefined;
        data["creationSystem"] = this.creationSystem;
        data["thirdPropertyCategory"] = this.thirdPropertyCategory;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["travelSystemHasError"] = this.travelSystemHasError;
        data["isTruckPlateDifferentConfirmed"] = this.isTruckPlateDifferentConfirmed;
        data["truckPlateParsedFromQR"] = this.truckPlateParsedFromQR;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["isChip"] = this.isChip;
        data["paysTransport"] = this.paysTransport;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["placeId"] = this.placeId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["comment"] = this.comment;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["precision"] = this.precision;
        data["estimatedVolume"] = this.estimatedVolume;
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateWoodPreActivityReportInput {
    receiptPhoto: string | undefined;
    errors: PreActivityReportErrorDto[] | undefined;
    creationMode: PreActivityReportCreationMode;
    eta: DateTime | undefined;
    loaderVendor: ExternalVendorInput | undefined;
    creationSystem: ActivityReportCreationSystem;
    thirdPropertyCategory: number | undefined;
    certification: WoodPreActivityReportCertificationDto | undefined;
    travelSystemHasError: boolean | undefined;
    isTruckPlateDifferentConfirmed: boolean;
    truckPlateParsedFromQR: string | undefined;
    origin: ExternalLocationInputDto;
    destination: ExternalLocationInputDto;
    serial: string | undefined;
    number: number;
    date: DateTime;
    tripNumber: number | undefined;
    lines: WoodControlActivityReportLineInputDto[] | undefined;
    period: PeriodInputDto;
    isChip: boolean;
    paysTransport: boolean;
    semitrailers: ExternalTruckVehicleInput[] | undefined;
    vehicleVendorExternalId: number;
    placeId: number;
    vehicleExternalId: number;
    vehicleTruckTypeExternalId: number;
    vehicleLicensePlate: string | undefined;
    driverExternalId: number;
    driverVendorExternalId: number;
    comment: string | undefined;
    latitude: number | undefined;
    longitude: number | undefined;
    precision: number | undefined;
    estimatedVolume: number;
    id: number;
}

export class CreateWoodVendorQuotaInput implements ICreateWoodVendorQuotaInput {
    vendorExternalIds!: number[];
    hourlyQuota!: number;
    tolerance!: number;
    volumeDailyTolerance!: number;

    constructor(data?: ICreateWoodVendorQuotaInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.vendorExternalIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vendorExternalIds"])) {
                this.vendorExternalIds = [] as any;
                for (let item of _data["vendorExternalIds"])
                    this.vendorExternalIds!.push(item);
            }
            this.hourlyQuota = _data["hourlyQuota"];
            this.tolerance = _data["tolerance"];
            this.volumeDailyTolerance = _data["volumeDailyTolerance"];
        }
    }

    static fromJS(data: any): CreateWoodVendorQuotaInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateWoodVendorQuotaInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendorExternalIds)) {
            data["vendorExternalIds"] = [];
            for (let item of this.vendorExternalIds)
                data["vendorExternalIds"].push(item);
        }
        data["hourlyQuota"] = this.hourlyQuota;
        data["tolerance"] = this.tolerance;
        data["volumeDailyTolerance"] = this.volumeDailyTolerance;
        return data;
    }
}

export interface ICreateWoodVendorQuotaInput {
    vendorExternalIds: number[];
    hourlyQuota: number;
    tolerance: number;
    volumeDailyTolerance: number;
}

export class CubeDto implements ICubeDto {
    cubeType!: CubeType;
    waterDensity!: number;
    surface!: number;
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: ICubeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cubeType = _data["cubeType"];
            this.waterDensity = _data["waterDensity"];
            this.surface = _data["surface"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CubeDto {
        data = typeof data === 'object' ? data : {};
        let result = new CubeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cubeType"] = this.cubeType;
        data["waterDensity"] = this.waterDensity;
        data["surface"] = this.surface;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ICubeDto {
    cubeType: CubeType;
    waterDensity: number;
    surface: number;
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export class CubeReportInputDto implements ICubeReportInputDto {
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;

    constructor(data?: ICubeReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CubeReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CubeReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        return data;
    }
}

export interface ICubeReportInputDto {
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
}

export enum CubeType {
    Archimedes = "Archimedes",
    Level = "Level",
}

export class CurrentPlaceOutputDto implements ICurrentPlaceOutputDto {
    placeId!: number;
    externalPlaceId!: number;
    placeName!: string | undefined;
    initials!: string | undefined;
    userId!: number;

    constructor(data?: ICurrentPlaceOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.externalPlaceId = _data["externalPlaceId"];
            this.placeName = _data["placeName"];
            this.initials = _data["initials"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CurrentPlaceOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentPlaceOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["externalPlaceId"] = this.externalPlaceId;
        data["placeName"] = this.placeName;
        data["initials"] = this.initials;
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICurrentPlaceOutputDto {
    placeId: number;
    externalPlaceId: number;
    placeName: string | undefined;
    initials: string | undefined;
    userId: number;
}

export class CurrentUserProfileEditDto implements ICurrentUserProfileEditDto {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    isPhoneNumberConfirmed!: boolean;
    timezone!: string | undefined;
    qrCodeSetupImageUrl!: string | undefined;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ICurrentUserProfileEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.isPhoneNumberConfirmed = _data["isPhoneNumberConfirmed"];
            this.timezone = _data["timezone"];
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): CurrentUserProfileEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ICurrentUserProfileEditDto {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    isPhoneNumberConfirmed: boolean;
    timezone: string | undefined;
    qrCodeSetupImageUrl: string | undefined;
    isGoogleAuthenticatorEnabled: boolean;
}

export class CustomAttributeData implements ICustomAttributeData {
    readonly attributeType!: string | undefined;
    readonly constructor_!: ConstructorInfo | undefined;
    readonly constructorArguments!: CustomAttributeTypedArgument[] | undefined;
    readonly namedArguments!: CustomAttributeNamedArgument[] | undefined;

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).attributeType = _data["attributeType"];
            (<any>this).constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : <any>undefined;
            if (Array.isArray(_data["constructorArguments"])) {
                (<any>this).constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    (<any>this).constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                (<any>this).namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    (<any>this).namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : <any>undefined;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item.toJSON());
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType: string | undefined;
    constructor_: ConstructorInfo | undefined;
    constructorArguments: CustomAttributeTypedArgument[] | undefined;
    namedArguments: CustomAttributeNamedArgument[] | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo!: MemberInfo | undefined;
    readonly typedValue!: CustomAttributeTypedArgument;
    readonly memberName!: string | undefined;
    readonly isField!: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : <any>undefined;
            (<any>this).typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : <any>undefined;
            (<any>this).memberName = _data["memberName"];
            (<any>this).isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : <any>undefined;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : <any>undefined;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo: MemberInfo | undefined;
    typedValue: CustomAttributeTypedArgument;
    memberName: string | undefined;
    isField: boolean;
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType!: string | undefined;
    value!: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType: string | undefined;
    value: any | undefined;
}

export class CustomsIntegrationOutputDto implements ICustomsIntegrationOutputDto {
    ordinalInternalMovement!: number;
    ordinalCustomsMovement!: number;
    errorDescription!: string | undefined;

    constructor(data?: ICustomsIntegrationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinalInternalMovement = _data["ordinalInternalMovement"];
            this.ordinalCustomsMovement = _data["ordinalCustomsMovement"];
            this.errorDescription = _data["errorDescription"];
        }
    }

    static fromJS(data: any): CustomsIntegrationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomsIntegrationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinalInternalMovement"] = this.ordinalInternalMovement;
        data["ordinalCustomsMovement"] = this.ordinalCustomsMovement;
        data["errorDescription"] = this.errorDescription;
        return data;
    }
}

export interface ICustomsIntegrationOutputDto {
    ordinalInternalMovement: number;
    ordinalCustomsMovement: number;
    errorDescription: string | undefined;
}

export class Dashboard implements IDashboard {
    dashboardName!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDashboard {
    dashboardName: string | undefined;
    pages: Page[] | undefined;
}

/** This class stores filtered dashboard information by user */
export class DashboardOutput implements IDashboardOutput {
    name!: string | undefined;
    widgets!: WidgetOutput[] | undefined;

    constructor(data?: IDashboardOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(WidgetOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DashboardOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

/** This class stores filtered dashboard information by user */
export interface IDashboardOutput {
    name: string | undefined;
    widgets: WidgetOutput[] | undefined;
}

export class DateToStringOutput implements IDateToStringOutput {
    dateString!: string | undefined;

    constructor(data?: IDateToStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateString = _data["dateString"];
        }
    }

    static fromJS(data: any): DateToStringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DateToStringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    }
}

export interface IDateToStringOutput {
    dateString: string | undefined;
}

export class DelegatedImpersonateInput implements IDelegatedImpersonateInput {
    userDelegationId!: number;

    constructor(data?: IDelegatedImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userDelegationId = _data["userDelegationId"];
        }
    }

    static fromJS(data: any): DelegatedImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DelegatedImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userDelegationId"] = this.userDelegationId;
        return data;
    }
}

export interface IDelegatedImpersonateInput {
    userDelegationId: number;
}

export class DeleteScannerResultsOutputDto implements IDeleteScannerResultsOutputDto {
    success!: boolean;
    message!: string | undefined;

    constructor(data?: IDeleteScannerResultsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeleteScannerResultsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteScannerResultsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IDeleteScannerResultsOutputDto {
    success: boolean;
    message: string | undefined;
}

export class DensityPerSpeciesGroupDto implements IDensityPerSpeciesGroupDto {
    speciesGroupId!: number;
    minDensity!: number;
    maxDensity!: number;
    id!: number;

    constructor(data?: IDensityPerSpeciesGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speciesGroupId = _data["speciesGroupId"];
            this.minDensity = _data["minDensity"];
            this.maxDensity = _data["maxDensity"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DensityPerSpeciesGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DensityPerSpeciesGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speciesGroupId"] = this.speciesGroupId;
        data["minDensity"] = this.minDensity;
        data["maxDensity"] = this.maxDensity;
        data["id"] = this.id;
        return data;
    }
}

export interface IDensityPerSpeciesGroupDto {
    speciesGroupId: number;
    minDensity: number;
    maxDensity: number;
    id: number;
}

export class DensityRangeOutputDto implements IDensityRangeOutputDto {
    minDensity!: number;
    maxDensity!: number;

    constructor(data?: IDensityRangeOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.minDensity = _data["minDensity"];
            this.maxDensity = _data["maxDensity"];
        }
    }

    static fromJS(data: any): DensityRangeOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DensityRangeOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minDensity"] = this.minDensity;
        data["maxDensity"] = this.maxDensity;
        return data;
    }
}

export interface IDensityRangeOutputDto {
    minDensity: number;
    maxDensity: number;
}

export class DetailedWeightDto implements IDetailedWeightDto {
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;

    constructor(data?: IDetailedWeightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
        }
    }

    static fromJS(data: any): DetailedWeightDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetailedWeightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        return data;
    }
}

export interface IDetailedWeightDto {
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
}

export enum DetectionSource {
    PreReport = "PreReport",
    RFID = "RFID",
    ExternalWoodSystem = "ExternalWoodSystem",
}

export class DetourLogInputDto implements IDetourLogInputDto {
    activityReportId!: number | undefined;
    isValid!: boolean;
    vehicleExternalId!: number;
    message!: string | undefined;

    constructor(data?: IDetourLogInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.isValid = _data["isValid"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DetourLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DetourLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["isValid"] = this.isValid;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["message"] = this.message;
        return data;
    }
}

export interface IDetourLogInputDto {
    activityReportId: number | undefined;
    isValid: boolean;
    vehicleExternalId: number;
    message: string | undefined;
}

export class DeviceConfigurationDto implements IDeviceConfigurationDto {
    type!: string | undefined;
    deviceId!: number;
    name!: string | undefined;
    actualState!: ActualState;

    constructor(data?: IDeviceConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.deviceId = _data["deviceId"];
            this.name = _data["name"];
            this.actualState = _data["actualState"];
        }
    }

    static fromJS(data: any): DeviceConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["deviceId"] = this.deviceId;
        data["name"] = this.name;
        data["actualState"] = this.actualState;
        return data;
    }
}

export interface IDeviceConfigurationDto {
    type: string | undefined;
    deviceId: number;
    name: string | undefined;
    actualState: ActualState;
}

export class DeviceDto implements IDeviceDto {
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: IDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeviceDto {
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export class DeviceForSamplingMaintenaceDto implements IDeviceForSamplingMaintenaceDto {
    deviceName!: string | undefined;
    placeName!: string | undefined;
    zoneName!: string | undefined;
    deviceType!: DeviceTypeDto | undefined;
    currentState!: ActualState;
    id!: number;

    constructor(data?: IDeviceForSamplingMaintenaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceName = _data["deviceName"];
            this.placeName = _data["placeName"];
            this.zoneName = _data["zoneName"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.currentState = _data["currentState"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeviceForSamplingMaintenaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceForSamplingMaintenaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceName"] = this.deviceName;
        data["placeName"] = this.placeName;
        data["zoneName"] = this.zoneName;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["currentState"] = this.currentState;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeviceForSamplingMaintenaceDto {
    deviceName: string | undefined;
    placeName: string | undefined;
    zoneName: string | undefined;
    deviceType: DeviceTypeDto | undefined;
    currentState: ActualState;
    id: number;
}

export class DeviceInZoneDto implements IDeviceInZoneDto {
    name!: string | undefined;
    deviceType!: DeviceTypeDto | undefined;
    actualState!: ActualState;
    externalId!: number | undefined;
    id!: number;

    constructor(data?: IDeviceInZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.actualState = _data["actualState"];
            this.externalId = _data["externalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DeviceInZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceInZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["actualState"] = this.actualState;
        data["externalId"] = this.externalId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDeviceInZoneDto {
    name: string | undefined;
    deviceType: DeviceTypeDto | undefined;
    actualState: ActualState;
    externalId: number | undefined;
    id: number;
}

export class DeviceIsActiveIndicatorDto implements IDeviceIsActiveIndicatorDto {
    enableIndicator!: boolean;
    isActive!: boolean;
    deviceId!: number;
    deviceName!: string | undefined;
    message!: string | undefined;

    constructor(data?: IDeviceIsActiveIndicatorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enableIndicator = _data["enableIndicator"];
            this.isActive = _data["isActive"];
            this.deviceId = _data["deviceId"];
            this.deviceName = _data["deviceName"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeviceIsActiveIndicatorDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceIsActiveIndicatorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enableIndicator"] = this.enableIndicator;
        data["isActive"] = this.isActive;
        data["deviceId"] = this.deviceId;
        data["deviceName"] = this.deviceName;
        data["message"] = this.message;
        return data;
    }
}

export interface IDeviceIsActiveIndicatorDto {
    enableIndicator: boolean;
    isActive: boolean;
    deviceId: number;
    deviceName: string | undefined;
    message: string | undefined;
}

export class DevicesDtoInput implements IDevicesDtoInput {
    actualState!: ActualState;
    zoneId!: number;
    deviceTypeId!: number;
    deviceType!: DeviceTypes;
    printerValue!: PrinterDto | undefined;
    scaleValue!: ScaleDto | undefined;
    rfidReaderValue!: RfidReaderDto | undefined;
    loaderMachineValue!: LoaderMachineDto | undefined;
    cubeValue!: CubeDto | undefined;
    accessCardReaderValue!: AccessCardReaderDto | undefined;
    qrReaderValue!: QRReaderDto | undefined;
    scannerValue!: ScannerDto | undefined;
    semaphoreValue!: SemaphoreDto | undefined;
    id!: number;

    constructor(data?: IDevicesDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.actualState = _data["actualState"];
            this.zoneId = _data["zoneId"];
            this.deviceTypeId = _data["deviceTypeId"];
            this.deviceType = _data["deviceType"];
            this.printerValue = _data["printerValue"] ? PrinterDto.fromJS(_data["printerValue"]) : <any>undefined;
            this.scaleValue = _data["scaleValue"] ? ScaleDto.fromJS(_data["scaleValue"]) : <any>undefined;
            this.rfidReaderValue = _data["rfidReaderValue"] ? RfidReaderDto.fromJS(_data["rfidReaderValue"]) : <any>undefined;
            this.loaderMachineValue = _data["loaderMachineValue"] ? LoaderMachineDto.fromJS(_data["loaderMachineValue"]) : <any>undefined;
            this.cubeValue = _data["cubeValue"] ? CubeDto.fromJS(_data["cubeValue"]) : <any>undefined;
            this.accessCardReaderValue = _data["accessCardReaderValue"] ? AccessCardReaderDto.fromJS(_data["accessCardReaderValue"]) : <any>undefined;
            this.qrReaderValue = _data["qrReaderValue"] ? QRReaderDto.fromJS(_data["qrReaderValue"]) : <any>undefined;
            this.scannerValue = _data["scannerValue"] ? ScannerDto.fromJS(_data["scannerValue"]) : <any>undefined;
            this.semaphoreValue = _data["semaphoreValue"] ? SemaphoreDto.fromJS(_data["semaphoreValue"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DevicesDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new DevicesDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["actualState"] = this.actualState;
        data["zoneId"] = this.zoneId;
        data["deviceTypeId"] = this.deviceTypeId;
        data["deviceType"] = this.deviceType;
        data["printerValue"] = this.printerValue ? this.printerValue.toJSON() : <any>undefined;
        data["scaleValue"] = this.scaleValue ? this.scaleValue.toJSON() : <any>undefined;
        data["rfidReaderValue"] = this.rfidReaderValue ? this.rfidReaderValue.toJSON() : <any>undefined;
        data["loaderMachineValue"] = this.loaderMachineValue ? this.loaderMachineValue.toJSON() : <any>undefined;
        data["cubeValue"] = this.cubeValue ? this.cubeValue.toJSON() : <any>undefined;
        data["accessCardReaderValue"] = this.accessCardReaderValue ? this.accessCardReaderValue.toJSON() : <any>undefined;
        data["qrReaderValue"] = this.qrReaderValue ? this.qrReaderValue.toJSON() : <any>undefined;
        data["scannerValue"] = this.scannerValue ? this.scannerValue.toJSON() : <any>undefined;
        data["semaphoreValue"] = this.semaphoreValue ? this.semaphoreValue.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IDevicesDtoInput {
    actualState: ActualState;
    zoneId: number;
    deviceTypeId: number;
    deviceType: DeviceTypes;
    printerValue: PrinterDto | undefined;
    scaleValue: ScaleDto | undefined;
    rfidReaderValue: RfidReaderDto | undefined;
    loaderMachineValue: LoaderMachineDto | undefined;
    cubeValue: CubeDto | undefined;
    accessCardReaderValue: AccessCardReaderDto | undefined;
    qrReaderValue: QRReaderDto | undefined;
    scannerValue: ScannerDto | undefined;
    semaphoreValue: SemaphoreDto | undefined;
    id: number;
}

export class DevicesDtoOutput implements IDevicesDtoOutput {
    name!: string | undefined;
    externalId!: number | undefined;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    actualState!: ActualState;
    printerValue!: PrinterDto | undefined;
    scaleValue!: ScaleDto | undefined;
    rfidReaderValue!: RfidReaderDto | undefined;
    loaderMachineValue!: LoaderMachineDto | undefined;
    cubeValue!: CubeDto | undefined;
    accessCardReaderValue!: AccessCardReaderDto | undefined;
    qrReaderValue!: QRReaderDto | undefined;
    scannerValue!: ScannerDto | undefined;
    semaphoreValue!: SemaphoreDto | undefined;
    id!: number;

    constructor(data?: IDevicesDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.actualState = _data["actualState"];
            this.printerValue = _data["printerValue"] ? PrinterDto.fromJS(_data["printerValue"]) : <any>undefined;
            this.scaleValue = _data["scaleValue"] ? ScaleDto.fromJS(_data["scaleValue"]) : <any>undefined;
            this.rfidReaderValue = _data["rfidReaderValue"] ? RfidReaderDto.fromJS(_data["rfidReaderValue"]) : <any>undefined;
            this.loaderMachineValue = _data["loaderMachineValue"] ? LoaderMachineDto.fromJS(_data["loaderMachineValue"]) : <any>undefined;
            this.cubeValue = _data["cubeValue"] ? CubeDto.fromJS(_data["cubeValue"]) : <any>undefined;
            this.accessCardReaderValue = _data["accessCardReaderValue"] ? AccessCardReaderDto.fromJS(_data["accessCardReaderValue"]) : <any>undefined;
            this.qrReaderValue = _data["qrReaderValue"] ? QRReaderDto.fromJS(_data["qrReaderValue"]) : <any>undefined;
            this.scannerValue = _data["scannerValue"] ? ScannerDto.fromJS(_data["scannerValue"]) : <any>undefined;
            this.semaphoreValue = _data["semaphoreValue"] ? SemaphoreDto.fromJS(_data["semaphoreValue"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DevicesDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DevicesDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["actualState"] = this.actualState;
        data["printerValue"] = this.printerValue ? this.printerValue.toJSON() : <any>undefined;
        data["scaleValue"] = this.scaleValue ? this.scaleValue.toJSON() : <any>undefined;
        data["rfidReaderValue"] = this.rfidReaderValue ? this.rfidReaderValue.toJSON() : <any>undefined;
        data["loaderMachineValue"] = this.loaderMachineValue ? this.loaderMachineValue.toJSON() : <any>undefined;
        data["cubeValue"] = this.cubeValue ? this.cubeValue.toJSON() : <any>undefined;
        data["accessCardReaderValue"] = this.accessCardReaderValue ? this.accessCardReaderValue.toJSON() : <any>undefined;
        data["qrReaderValue"] = this.qrReaderValue ? this.qrReaderValue.toJSON() : <any>undefined;
        data["scannerValue"] = this.scannerValue ? this.scannerValue.toJSON() : <any>undefined;
        data["semaphoreValue"] = this.semaphoreValue ? this.semaphoreValue.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IDevicesDtoOutput {
    name: string | undefined;
    externalId: number | undefined;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    actualState: ActualState;
    printerValue: PrinterDto | undefined;
    scaleValue: ScaleDto | undefined;
    rfidReaderValue: RfidReaderDto | undefined;
    loaderMachineValue: LoaderMachineDto | undefined;
    cubeValue: CubeDto | undefined;
    accessCardReaderValue: AccessCardReaderDto | undefined;
    qrReaderValue: QRReaderDto | undefined;
    scannerValue: ScannerDto | undefined;
    semaphoreValue: SemaphoreDto | undefined;
    id: number;
}

export class DeviceTypeDto implements IDeviceTypeDto {
    id!: number;
    type!: string | undefined;

    constructor(data?: IDeviceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): DeviceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IDeviceTypeDto {
    id: number;
    type: string | undefined;
}

export enum DeviceTypes {
    Scale = "Scale",
    QRReader = "QRReader",
    RFIDReader = "RFIDReader",
    LoaderMachine = "LoaderMachine",
    AccessCardReader = "AccessCardReader",
    Printer = "Printer",
    Cube = "Cube",
    Scanner = "Scanner",
    Semaphore = "Semaphore",
}

export class DeviceZoneInfoDto implements IDeviceZoneInfoDto {
    deviceId!: number;
    deviceState!: ActualState;
    zoneId!: number;
    placeId!: number;
    externalPlaceId!: number;
    zoneModeType!: ZoneModeType;

    constructor(data?: IDeviceZoneInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceId = _data["deviceId"];
            this.deviceState = _data["deviceState"];
            this.zoneId = _data["zoneId"];
            this.placeId = _data["placeId"];
            this.externalPlaceId = _data["externalPlaceId"];
            this.zoneModeType = _data["zoneModeType"];
        }
    }

    static fromJS(data: any): DeviceZoneInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceZoneInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceId"] = this.deviceId;
        data["deviceState"] = this.deviceState;
        data["zoneId"] = this.zoneId;
        data["placeId"] = this.placeId;
        data["externalPlaceId"] = this.externalPlaceId;
        data["zoneModeType"] = this.zoneModeType;
        return data;
    }
}

export interface IDeviceZoneInfoDto {
    deviceId: number;
    deviceState: ActualState;
    zoneId: number;
    placeId: number;
    externalPlaceId: number;
    zoneModeType: ZoneModeType;
}

export class DiverseCounterTripMonitorDto implements IDiverseCounterTripMonitorDto {
    diverseInPlant!: number;
    diverseDispatched!: number;

    constructor(data?: IDiverseCounterTripMonitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diverseInPlant = _data["diverseInPlant"];
            this.diverseDispatched = _data["diverseDispatched"];
        }
    }

    static fromJS(data: any): DiverseCounterTripMonitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseCounterTripMonitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diverseInPlant"] = this.diverseInPlant;
        data["diverseDispatched"] = this.diverseDispatched;
        return data;
    }
}

export interface IDiverseCounterTripMonitorDto {
    diverseInPlant: number;
    diverseDispatched: number;
}

export enum DiverseProductActivityReportCreationSystemFilter {
    All = "All",
    SmartTruck = "SmartTruck",
    ProvidersModule = "ProvidersModule",
    Totem = "Totem",
}

export class DiverseProductActivityReportLineDto implements IDiverseProductActivityReportLineDto {
    articleExternalId!: number;
    contractExternalId!: number;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;

    constructor(data?: IDiverseProductActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleExternalId = _data["articleExternalId"];
            this.contractExternalId = _data["contractExternalId"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
        }
    }

    static fromJS(data: any): DiverseProductActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleExternalId"] = this.articleExternalId;
        data["contractExternalId"] = this.contractExternalId;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        return data;
    }
}

export interface IDiverseProductActivityReportLineDto {
    articleExternalId: number;
    contractExternalId: number;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
}

export class DiverseProductActivityReportLineInputDto implements IDiverseProductActivityReportLineInputDto {
    article!: ExternalArticleInput | undefined;
    contract!: ExternalContractInput | undefined;

    constructor(data?: IDiverseProductActivityReportLineInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.article = _data["article"] ? ExternalArticleInput.fromJS(_data["article"]) : <any>undefined;
            this.contract = _data["contract"] ? ExternalContractInput.fromJS(_data["contract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DiverseProductActivityReportLineInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductActivityReportLineInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDiverseProductActivityReportLineInputDto {
    article: ExternalArticleInput | undefined;
    contract: ExternalContractInput | undefined;
}

export class DiverseProductActivityReportOutputDto implements IDiverseProductActivityReportOutputDto {
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    activityReportLines!: DiverseProductActivityReportLineDto[] | undefined;
    originExternalId!: number;
    originType!: LocationType | undefined;
    destinationExternalId!: number;
    destinationType!: LocationType | undefined;
    vehicleLicensePlate!: string | undefined;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    vehicleActiveTag!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    customsDeclaration!: SingleCustomDeclarationDto | undefined;
    serial!: string | undefined;
    number!: number | undefined;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    netWeight!: number;
    externalActivityReportId!: number | undefined;
    paysTransport!: boolean;
    isDeleted!: boolean;
    comment!: string | undefined;
    isAutomatic!: boolean;
    entryDate!: DateTime;
    exitDate!: DateTime;
    reportDate!: DateTime;
    entryZoneId!: number | undefined;
    exitZoneId!: number | undefined;
    entryZoneName!: string | undefined;
    exitZoneName!: string | undefined;
    placeId!: number;
    hasActiveServiceEntrySheet!: boolean;
    id!: number;

    constructor(data?: IDiverseProductActivityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(DiverseProductActivityReportLineDto.fromJS(item));
            }
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleActiveTag = _data["vehicleActiveTag"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.customsDeclaration = _data["customsDeclaration"] ? SingleCustomDeclarationDto.fromJS(_data["customsDeclaration"]) : <any>undefined;
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.paysTransport = _data["paysTransport"];
            this.isDeleted = _data["isDeleted"];
            this.comment = _data["comment"];
            this.isAutomatic = _data["isAutomatic"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.reportDate = _data["reportDate"] ? DateTime.fromISO(_data["reportDate"].toString()) : <any>undefined;
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.entryZoneName = _data["entryZoneName"];
            this.exitZoneName = _data["exitZoneName"];
            this.placeId = _data["placeId"];
            this.hasActiveServiceEntrySheet = _data["hasActiveServiceEntrySheet"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiverseProductActivityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductActivityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleActiveTag"] = this.vehicleActiveTag;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["customsDeclaration"] = this.customsDeclaration ? this.customsDeclaration.toJSON() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["paysTransport"] = this.paysTransport;
        data["isDeleted"] = this.isDeleted;
        data["comment"] = this.comment;
        data["isAutomatic"] = this.isAutomatic;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["reportDate"] = this.reportDate ? this.reportDate.toString() : <any>undefined;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["entryZoneName"] = this.entryZoneName;
        data["exitZoneName"] = this.exitZoneName;
        data["placeId"] = this.placeId;
        data["hasActiveServiceEntrySheet"] = this.hasActiveServiceEntrySheet;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiverseProductActivityReportOutputDto {
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    activityReportLines: DiverseProductActivityReportLineDto[] | undefined;
    originExternalId: number;
    originType: LocationType | undefined;
    destinationExternalId: number;
    destinationType: LocationType | undefined;
    vehicleLicensePlate: string | undefined;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    vehicleActiveTag: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    customsDeclaration: SingleCustomDeclarationDto | undefined;
    serial: string | undefined;
    number: number | undefined;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    netWeight: number;
    externalActivityReportId: number | undefined;
    paysTransport: boolean;
    isDeleted: boolean;
    comment: string | undefined;
    isAutomatic: boolean;
    entryDate: DateTime;
    exitDate: DateTime;
    reportDate: DateTime;
    entryZoneId: number | undefined;
    exitZoneId: number | undefined;
    entryZoneName: string | undefined;
    exitZoneName: string | undefined;
    placeId: number;
    hasActiveServiceEntrySheet: boolean;
    id: number;
}

export class DiverseProductDestinationDto implements IDiverseProductDestinationDto {
    id!: number;
    locationName!: string | undefined;
    externalId!: number;
    locationType!: LocationType;
    paysTransport!: boolean;
    vendor!: VendorDto | undefined;
    isActive!: boolean;

    constructor(data?: IDiverseProductDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationName = _data["locationName"];
            this.externalId = _data["externalId"];
            this.locationType = _data["locationType"];
            this.paysTransport = _data["paysTransport"];
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DiverseProductDestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductDestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationName"] = this.locationName;
        data["externalId"] = this.externalId;
        data["locationType"] = this.locationType;
        data["paysTransport"] = this.paysTransport;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IDiverseProductDestinationDto {
    id: number;
    locationName: string | undefined;
    externalId: number;
    locationType: LocationType;
    paysTransport: boolean;
    vendor: VendorDto | undefined;
    isActive: boolean;
}

export class DiverseProductPreActivityReportEditionInput implements IDiverseProductPreActivityReportEditionInput {
    id!: number;
    newDestination!: ExternalLocationInputDto | undefined;
    newDriverExternalId!: number;
    newDriverVendorExternalId!: number;
    newDriverUserName!: string | undefined;
    newDate!: DateTime;
    newLines!: DiverseProductActivityReportLineInputDto[] | undefined;
    newErrors!: PreActivityReportErrorDto[] | undefined;
    newPreReportStatus!: PreActivityReportValidation;

    constructor(data?: IDiverseProductPreActivityReportEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newDestination = _data["newDestination"] ? ExternalLocationInputDto.fromJS(_data["newDestination"]) : <any>undefined;
            this.newDriverExternalId = _data["newDriverExternalId"];
            this.newDriverVendorExternalId = _data["newDriverVendorExternalId"];
            this.newDriverUserName = _data["newDriverUserName"];
            this.newDate = _data["newDate"] ? DateTime.fromISO(_data["newDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["newLines"])) {
                this.newLines = [] as any;
                for (let item of _data["newLines"])
                    this.newLines!.push(DiverseProductActivityReportLineInputDto.fromJS(item));
            }
            if (Array.isArray(_data["newErrors"])) {
                this.newErrors = [] as any;
                for (let item of _data["newErrors"])
                    this.newErrors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.newPreReportStatus = _data["newPreReportStatus"];
        }
    }

    static fromJS(data: any): DiverseProductPreActivityReportEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductPreActivityReportEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newDestination"] = this.newDestination ? this.newDestination.toJSON() : <any>undefined;
        data["newDriverExternalId"] = this.newDriverExternalId;
        data["newDriverVendorExternalId"] = this.newDriverVendorExternalId;
        data["newDriverUserName"] = this.newDriverUserName;
        data["newDate"] = this.newDate ? this.newDate.toString() : <any>undefined;
        if (Array.isArray(this.newLines)) {
            data["newLines"] = [];
            for (let item of this.newLines)
                data["newLines"].push(item.toJSON());
        }
        if (Array.isArray(this.newErrors)) {
            data["newErrors"] = [];
            for (let item of this.newErrors)
                data["newErrors"].push(item.toJSON());
        }
        data["newPreReportStatus"] = this.newPreReportStatus;
        return data;
    }
}

export interface IDiverseProductPreActivityReportEditionInput {
    id: number;
    newDestination: ExternalLocationInputDto | undefined;
    newDriverExternalId: number;
    newDriverVendorExternalId: number;
    newDriverUserName: string | undefined;
    newDate: DateTime;
    newLines: DiverseProductActivityReportLineInputDto[] | undefined;
    newErrors: PreActivityReportErrorDto[] | undefined;
    newPreReportStatus: PreActivityReportValidation;
}

export class DiverseProductPreActivityReportForEditionInfo implements IDiverseProductPreActivityReportForEditionInfo {
    id!: number;
    externalVehicleId!: number;
    paysTransport!: boolean;
    externalOriginId!: number;
    placeId!: number;

    constructor(data?: IDiverseProductPreActivityReportForEditionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalVehicleId = _data["externalVehicleId"];
            this.paysTransport = _data["paysTransport"];
            this.externalOriginId = _data["externalOriginId"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): DiverseProductPreActivityReportForEditionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductPreActivityReportForEditionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalVehicleId"] = this.externalVehicleId;
        data["paysTransport"] = this.paysTransport;
        data["externalOriginId"] = this.externalOriginId;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IDiverseProductPreActivityReportForEditionInfo {
    id: number;
    externalVehicleId: number;
    paysTransport: boolean;
    externalOriginId: number;
    placeId: number;
}

export class DiverseProductPreActivityReportForProviderSearchOutputDto implements IDiverseProductPreActivityReportForProviderSearchOutputDto {
    id!: number;
    externalDriverId!: number;
    externalTruckId!: number;
    externalOriginId!: number;
    originType!: LocationType;
    externalDestinationId!: number;
    destinationType!: LocationType;
    validationResult!: PreActivityReportValidation;

    constructor(data?: IDiverseProductPreActivityReportForProviderSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalDriverId = _data["externalDriverId"];
            this.externalTruckId = _data["externalTruckId"];
            this.externalOriginId = _data["externalOriginId"];
            this.originType = _data["originType"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.destinationType = _data["destinationType"];
            this.validationResult = _data["validationResult"];
        }
    }

    static fromJS(data: any): DiverseProductPreActivityReportForProviderSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductPreActivityReportForProviderSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalDriverId"] = this.externalDriverId;
        data["externalTruckId"] = this.externalTruckId;
        data["externalOriginId"] = this.externalOriginId;
        data["originType"] = this.originType;
        data["externalDestinationId"] = this.externalDestinationId;
        data["destinationType"] = this.destinationType;
        data["validationResult"] = this.validationResult;
        return data;
    }
}

export interface IDiverseProductPreActivityReportForProviderSearchOutputDto {
    id: number;
    externalDriverId: number;
    externalTruckId: number;
    externalOriginId: number;
    originType: LocationType;
    externalDestinationId: number;
    destinationType: LocationType;
    validationResult: PreActivityReportValidation;
}

export class DiverseProductPreReportEntranceRequiredInfoOutput implements IDiverseProductPreReportEntranceRequiredInfoOutput {
    id!: number;
    validationResult!: PreActivityReportValidation;
    isApproved!: boolean;

    constructor(data?: IDiverseProductPreReportEntranceRequiredInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validationResult = _data["validationResult"];
            this.isApproved = _data["isApproved"];
        }
    }

    static fromJS(data: any): DiverseProductPreReportEntranceRequiredInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductPreReportEntranceRequiredInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validationResult"] = this.validationResult;
        data["isApproved"] = this.isApproved;
        return data;
    }
}

export interface IDiverseProductPreReportEntranceRequiredInfoOutput {
    id: number;
    validationResult: PreActivityReportValidation;
    isApproved: boolean;
}

export class DiverseProductsAndInternalMovementsReportOutput implements IDiverseProductsAndInternalMovementsReportOutput {
    diverseProduct!: DiverseProductActivityReportOutputDto | undefined;
    internalMovement!: InternalMovementActivityReportOutputDto | undefined;

    constructor(data?: IDiverseProductsAndInternalMovementsReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.diverseProduct = _data["diverseProduct"] ? DiverseProductActivityReportOutputDto.fromJS(_data["diverseProduct"]) : <any>undefined;
            this.internalMovement = _data["internalMovement"] ? InternalMovementActivityReportOutputDto.fromJS(_data["internalMovement"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DiverseProductsAndInternalMovementsReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductsAndInternalMovementsReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["diverseProduct"] = this.diverseProduct ? this.diverseProduct.toJSON() : <any>undefined;
        data["internalMovement"] = this.internalMovement ? this.internalMovement.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDiverseProductsAndInternalMovementsReportOutput {
    diverseProduct: DiverseProductActivityReportOutputDto | undefined;
    internalMovement: InternalMovementActivityReportOutputDto | undefined;
}

export class DiverseProductsReportLineEditionDto implements IDiverseProductsReportLineEditionDto {
    externalLineId!: number;
    article!: ExternalArticleDto | undefined;
    contract!: ExternalContractDto | undefined;

    constructor(data?: IDiverseProductsReportLineEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalLineId = _data["externalLineId"];
            this.article = _data["article"] ? ExternalArticleDto.fromJS(_data["article"]) : <any>undefined;
            this.contract = _data["contract"] ? ExternalContractDto.fromJS(_data["contract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DiverseProductsReportLineEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductsReportLineEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalLineId"] = this.externalLineId;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDiverseProductsReportLineEditionDto {
    externalLineId: number;
    article: ExternalArticleDto | undefined;
    contract: ExternalContractDto | undefined;
}

export class DiverseProductsTruckTypeDto implements IDiverseProductsTruckTypeDto {
    maxTonsAllowed!: number;
    resourceTypeId!: number;
    id!: number;

    constructor(data?: IDiverseProductsTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxTonsAllowed = _data["maxTonsAllowed"];
            this.resourceTypeId = _data["resourceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DiverseProductsTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductsTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxTonsAllowed"] = this.maxTonsAllowed;
        data["resourceTypeId"] = this.resourceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IDiverseProductsTruckTypeDto {
    maxTonsAllowed: number;
    resourceTypeId: number;
    id: number;
}

export class DiverseProductTransportReportDto implements IDiverseProductTransportReportDto {
    paysTransport!: boolean;
    transportVendorId!: number;
    hasDestination!: boolean;

    constructor(data?: IDiverseProductTransportReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paysTransport = _data["paysTransport"];
            this.transportVendorId = _data["transportVendorId"];
            this.hasDestination = _data["hasDestination"];
        }
    }

    static fromJS(data: any): DiverseProductTransportReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiverseProductTransportReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paysTransport"] = this.paysTransport;
        data["transportVendorId"] = this.transportVendorId;
        data["hasDestination"] = this.hasDestination;
        return data;
    }
}

export interface IDiverseProductTransportReportDto {
    paysTransport: boolean;
    transportVendorId: number;
    hasDestination: boolean;
}

export class DuaValidationInfoDto implements IDuaValidationInfoDto {
    tareWeight!: number;
    duaId!: number;
    grossWeight!: number;

    constructor(data?: IDuaValidationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tareWeight = _data["tareWeight"];
            this.duaId = _data["duaId"];
            this.grossWeight = _data["grossWeight"];
        }
    }

    static fromJS(data: any): DuaValidationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DuaValidationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tareWeight"] = this.tareWeight;
        data["duaId"] = this.duaId;
        data["grossWeight"] = this.grossWeight;
        return data;
    }
}

export interface IDuaValidationInfoDto {
    tareWeight: number;
    duaId: number;
    grossWeight: number;
}

export class EditDiverseProductPreActivityReportOutput implements IEditDiverseProductPreActivityReportOutput {
    preReportId!: number;
    editionResult!: boolean;
    preReport!: PreActivityReportWithErrorsDto | undefined;
    preReportDriverChanged!: boolean;
    previousTripDriverToNotify!: UserDriverInformationOutput | undefined;
    currentTripDriverToNotify!: UserDriverInformationOutput | undefined;

    constructor(data?: IEditDiverseProductPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportId = _data["preReportId"];
            this.editionResult = _data["editionResult"];
            this.preReport = _data["preReport"] ? PreActivityReportWithErrorsDto.fromJS(_data["preReport"]) : <any>undefined;
            this.preReportDriverChanged = _data["preReportDriverChanged"];
            this.previousTripDriverToNotify = _data["previousTripDriverToNotify"] ? UserDriverInformationOutput.fromJS(_data["previousTripDriverToNotify"]) : <any>undefined;
            this.currentTripDriverToNotify = _data["currentTripDriverToNotify"] ? UserDriverInformationOutput.fromJS(_data["currentTripDriverToNotify"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditDiverseProductPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditDiverseProductPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportId"] = this.preReportId;
        data["editionResult"] = this.editionResult;
        data["preReport"] = this.preReport ? this.preReport.toJSON() : <any>undefined;
        data["preReportDriverChanged"] = this.preReportDriverChanged;
        data["previousTripDriverToNotify"] = this.previousTripDriverToNotify ? this.previousTripDriverToNotify.toJSON() : <any>undefined;
        data["currentTripDriverToNotify"] = this.currentTripDriverToNotify ? this.currentTripDriverToNotify.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditDiverseProductPreActivityReportOutput {
    preReportId: number;
    editionResult: boolean;
    preReport: PreActivityReportWithErrorsDto | undefined;
    preReportDriverChanged: boolean;
    previousTripDriverToNotify: UserDriverInformationOutput | undefined;
    currentTripDriverToNotify: UserDriverInformationOutput | undefined;
}

export class EditInternalMovementPreActivityReportOutput implements IEditInternalMovementPreActivityReportOutput {
    preReportId!: number;
    editionResult!: boolean;
    preReport!: PreActivityReportWithErrorsDto | undefined;
    preReportDriverChanged!: boolean;
    previousTripDriverToNotify!: UserDriverInformationOutput | undefined;
    currentTripDriverToNotify!: UserDriverInformationOutput | undefined;

    constructor(data?: IEditInternalMovementPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportId = _data["preReportId"];
            this.editionResult = _data["editionResult"];
            this.preReport = _data["preReport"] ? PreActivityReportWithErrorsDto.fromJS(_data["preReport"]) : <any>undefined;
            this.preReportDriverChanged = _data["preReportDriverChanged"];
            this.previousTripDriverToNotify = _data["previousTripDriverToNotify"] ? UserDriverInformationOutput.fromJS(_data["previousTripDriverToNotify"]) : <any>undefined;
            this.currentTripDriverToNotify = _data["currentTripDriverToNotify"] ? UserDriverInformationOutput.fromJS(_data["currentTripDriverToNotify"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditInternalMovementPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditInternalMovementPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportId"] = this.preReportId;
        data["editionResult"] = this.editionResult;
        data["preReport"] = this.preReport ? this.preReport.toJSON() : <any>undefined;
        data["preReportDriverChanged"] = this.preReportDriverChanged;
        data["previousTripDriverToNotify"] = this.previousTripDriverToNotify ? this.previousTripDriverToNotify.toJSON() : <any>undefined;
        data["currentTripDriverToNotify"] = this.currentTripDriverToNotify ? this.currentTripDriverToNotify.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditInternalMovementPreActivityReportOutput {
    preReportId: number;
    editionResult: boolean;
    preReport: PreActivityReportWithErrorsDto | undefined;
    preReportDriverChanged: boolean;
    previousTripDriverToNotify: UserDriverInformationOutput | undefined;
    currentTripDriverToNotify: UserDriverInformationOutput | undefined;
}

export class EditionCreateDto implements IEditionCreateDto {
    id!: number | undefined;
    displayName!: string;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionCreateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionCreateDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionCreateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionCreateDto {
    id: number | undefined;
    displayName: string;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    expiringEditionId: number | undefined;
}

export class EditionEditDto implements IEditionEditDto {
    id!: number | undefined;
    displayName!: string;
    expiringEditionId!: number | undefined;

    constructor(data?: IEditionEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
        }
    }

    static fromJS(data: any): EditionEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    }
}

export interface IEditionEditDto {
    id: number | undefined;
    displayName: string;
    expiringEditionId: number | undefined;
}

export class EditionInfoDto implements IEditionInfoDto {
    displayName!: string | undefined;
    trialDayCount!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    isHighestEdition!: boolean;
    isFree!: boolean;
    id!: number;

    constructor(data?: IEditionInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.trialDayCount = _data["trialDayCount"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.isHighestEdition = _data["isHighestEdition"];
            this.isFree = _data["isFree"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionInfoDto {
    displayName: string | undefined;
    trialDayCount: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    isHighestEdition: boolean;
    isFree: boolean;
    id: number;
}

export class EditionListDto implements IEditionListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    trialDayCount!: number | undefined;
    expiringEditionDisplayName!: string | undefined;
    id!: number;

    constructor(data?: IEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.trialDayCount = _data["trialDayCount"];
            this.expiringEditionDisplayName = _data["expiringEditionDisplayName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditionListDto {
    name: string | undefined;
    displayName: string | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    waitingDayAfterExpire: number | undefined;
    trialDayCount: number | undefined;
    expiringEditionDisplayName: string | undefined;
    id: number;
}

export enum EditionPaymentType {
    NewRegistration = "NewRegistration",
    BuyNow = "BuyNow",
    Upgrade = "Upgrade",
    Extend = "Extend",
}

export class EditionSelectDto implements IEditionSelectDto {
    id!: number;
    name!: string | undefined;
    displayName!: string | undefined;
    expiringEditionId!: number | undefined;
    dailyPrice!: number | undefined;
    weeklyPrice!: number | undefined;
    monthlyPrice!: number | undefined;
    annualPrice!: number | undefined;
    trialDayCount!: number | undefined;
    waitingDayAfterExpire!: number | undefined;
    isFree!: boolean;
    additionalData!: AdditionalData | undefined;

    constructor(data?: IEditionSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.expiringEditionId = _data["expiringEditionId"];
            this.dailyPrice = _data["dailyPrice"];
            this.weeklyPrice = _data["weeklyPrice"];
            this.monthlyPrice = _data["monthlyPrice"];
            this.annualPrice = _data["annualPrice"];
            this.trialDayCount = _data["trialDayCount"];
            this.waitingDayAfterExpire = _data["waitingDayAfterExpire"];
            this.isFree = _data["isFree"];
            this.additionalData = _data["additionalData"] ? AdditionalData.fromJS(_data["additionalData"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditionSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["dailyPrice"] = this.dailyPrice;
        data["weeklyPrice"] = this.weeklyPrice;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditionSelectDto {
    id: number;
    name: string | undefined;
    displayName: string | undefined;
    expiringEditionId: number | undefined;
    dailyPrice: number | undefined;
    weeklyPrice: number | undefined;
    monthlyPrice: number | undefined;
    annualPrice: number | undefined;
    trialDayCount: number | undefined;
    waitingDayAfterExpire: number | undefined;
    isFree: boolean;
    additionalData: AdditionalData | undefined;
}

export class EditionsSelectOutput implements IEditionsSelectOutput {
    allFeatures!: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures!: EditionWithFeaturesDto[] | undefined;

    constructor(data?: IEditionsSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["allFeatures"])) {
                this.allFeatures = [] as any;
                for (let item of _data["allFeatures"])
                    this.allFeatures!.push(FlatFeatureSelectDto.fromJS(item));
            }
            if (Array.isArray(_data["editionsWithFeatures"])) {
                this.editionsWithFeatures = [] as any;
                for (let item of _data["editionsWithFeatures"])
                    this.editionsWithFeatures!.push(EditionWithFeaturesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionsSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditionsSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allFeatures)) {
            data["allFeatures"] = [];
            for (let item of this.allFeatures)
                data["allFeatures"].push(item.toJSON());
        }
        if (Array.isArray(this.editionsWithFeatures)) {
            data["editionsWithFeatures"] = [];
            for (let item of this.editionsWithFeatures)
                data["editionsWithFeatures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionsSelectOutput {
    allFeatures: FlatFeatureSelectDto[] | undefined;
    editionsWithFeatures: EditionWithFeaturesDto[] | undefined;
}

export class EditionWithFeaturesDto implements IEditionWithFeaturesDto {
    edition!: EditionSelectDto | undefined;
    featureValues!: NameValueDto[] | undefined;

    constructor(data?: IEditionWithFeaturesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditionWithFeaturesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditionWithFeaturesDto {
    edition: EditionSelectDto | undefined;
    featureValues: NameValueDto[] | undefined;
}

export class EditPileInput implements IEditPileInput {
    id!: number;
    pileOrigins!: PileOriginDto[] | undefined;
    allowsEntry!: boolean;
    allowsExit!: boolean;

    constructor(data?: IEditPileInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["pileOrigins"])) {
                this.pileOrigins = [] as any;
                for (let item of _data["pileOrigins"])
                    this.pileOrigins!.push(PileOriginDto.fromJS(item));
            }
            this.allowsEntry = _data["allowsEntry"];
            this.allowsExit = _data["allowsExit"];
        }
    }

    static fromJS(data: any): EditPileInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditPileInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.pileOrigins)) {
            data["pileOrigins"] = [];
            for (let item of this.pileOrigins)
                data["pileOrigins"].push(item.toJSON());
        }
        data["allowsEntry"] = this.allowsEntry;
        data["allowsExit"] = this.allowsExit;
        return data;
    }
}

export interface IEditPileInput {
    id: number;
    pileOrigins: PileOriginDto[] | undefined;
    allowsEntry: boolean;
    allowsExit: boolean;
}

export class EditPolygonContractInputDto implements IEditPolygonContractInputDto {
    polygonContractId!: number;
    isActive!: boolean;
    emails!: string[] | undefined;

    constructor(data?: IEditPolygonContractInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.polygonContractId = _data["polygonContractId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
        }
    }

    static fromJS(data: any): EditPolygonContractInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditPolygonContractInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["polygonContractId"] = this.polygonContractId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        return data;
    }
}

export interface IEditPolygonContractInputDto {
    polygonContractId: number;
    isActive: boolean;
    emails: string[] | undefined;
}

export class EditTripInfoInput implements IEditTripInfoInput {
    newTripNumber!: number | undefined;
    newTruck!: ExternalTruckVehicleInput | undefined;
    newSemiTrailers!: ExternalTruckVehicleInput[] | undefined;
    newCycle!: number | undefined;
    loadDate!: DateTime | undefined;

    constructor(data?: IEditTripInfoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTripNumber = _data["newTripNumber"];
            this.newTruck = _data["newTruck"] ? ExternalTruckVehicleInput.fromJS(_data["newTruck"]) : <any>undefined;
            if (Array.isArray(_data["newSemiTrailers"])) {
                this.newSemiTrailers = [] as any;
                for (let item of _data["newSemiTrailers"])
                    this.newSemiTrailers!.push(ExternalTruckVehicleInput.fromJS(item));
            }
            this.newCycle = _data["newCycle"];
            this.loadDate = _data["loadDate"] ? DateTime.fromISO(_data["loadDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): EditTripInfoInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditTripInfoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTripNumber"] = this.newTripNumber;
        data["newTruck"] = this.newTruck ? this.newTruck.toJSON() : <any>undefined;
        if (Array.isArray(this.newSemiTrailers)) {
            data["newSemiTrailers"] = [];
            for (let item of this.newSemiTrailers)
                data["newSemiTrailers"].push(item.toJSON());
        }
        data["newCycle"] = this.newCycle;
        data["loadDate"] = this.loadDate ? this.loadDate.toString() : <any>undefined;
        return data;
    }
}

export interface IEditTripInfoInput {
    newTripNumber: number | undefined;
    newTruck: ExternalTruckVehicleInput | undefined;
    newSemiTrailers: ExternalTruckVehicleInput[] | undefined;
    newCycle: number | undefined;
    loadDate: DateTime | undefined;
}

export class EditWoodPreActivityReportInput implements IEditWoodPreActivityReportInput {
    preActivityReportId!: number;
    origin!: ExternalLocationInputDto | undefined;
    serial!: string | undefined;
    number!: number;
    date!: DateTime;
    tripNumber!: number | undefined;
    lines!: WoodControlActivityReportLineInputDto[] | undefined;
    paysTransport!: boolean;
    semitrailers!: ExternalTruckVehicleInput[] | undefined;
    vehicleVendorExternalId!: number;
    vehicleExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleTruckTypeExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    receiptPhoto!: string | undefined;
    errors!: PreActivityReportErrorDto[] | undefined;
    eta!: DateTime | undefined;
    loaderVendor!: ExternalVendorInput | undefined;
    isApproved!: boolean;
    certification!: WoodPreActivityReportCertificationDto | undefined;
    validationResult!: PreActivityReportValidation;
    newDriverUserName!: string | undefined;
    editionIsFromCC!: boolean;

    constructor(data?: IEditWoodPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preActivityReportId = _data["preActivityReportId"];
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(WoodControlActivityReportLineInputDto.fromJS(item));
            }
            this.paysTransport = _data["paysTransport"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(ExternalTruckVehicleInput.fromJS(item));
            }
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.receiptPhoto = _data["receiptPhoto"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.eta = _data["eta"] ? DateTime.fromISO(_data["eta"].toString()) : <any>undefined;
            this.loaderVendor = _data["loaderVendor"] ? ExternalVendorInput.fromJS(_data["loaderVendor"]) : <any>undefined;
            this.isApproved = _data["isApproved"];
            this.certification = _data["certification"] ? WoodPreActivityReportCertificationDto.fromJS(_data["certification"]) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.newDriverUserName = _data["newDriverUserName"];
            this.editionIsFromCC = _data["editionIsFromCC"];
        }
    }

    static fromJS(data: any): EditWoodPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new EditWoodPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preActivityReportId"] = this.preActivityReportId;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["paysTransport"] = this.paysTransport;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["receiptPhoto"] = this.receiptPhoto;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["eta"] = this.eta ? this.eta.toString() : <any>undefined;
        data["loaderVendor"] = this.loaderVendor ? this.loaderVendor.toJSON() : <any>undefined;
        data["isApproved"] = this.isApproved;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["newDriverUserName"] = this.newDriverUserName;
        data["editionIsFromCC"] = this.editionIsFromCC;
        return data;
    }
}

export interface IEditWoodPreActivityReportInput {
    preActivityReportId: number;
    origin: ExternalLocationInputDto | undefined;
    serial: string | undefined;
    number: number;
    date: DateTime;
    tripNumber: number | undefined;
    lines: WoodControlActivityReportLineInputDto[] | undefined;
    paysTransport: boolean;
    semitrailers: ExternalTruckVehicleInput[] | undefined;
    vehicleVendorExternalId: number;
    vehicleExternalId: number;
    vehicleLicensePlate: string | undefined;
    vehicleTruckTypeExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    receiptPhoto: string | undefined;
    errors: PreActivityReportErrorDto[] | undefined;
    eta: DateTime | undefined;
    loaderVendor: ExternalVendorInput | undefined;
    isApproved: boolean;
    certification: WoodPreActivityReportCertificationDto | undefined;
    validationResult: PreActivityReportValidation;
    newDriverUserName: string | undefined;
    editionIsFromCC: boolean;
}

export class EditWoodPreActivityReportOutput implements IEditWoodPreActivityReportOutput {
    preReportId!: number;
    editionResult!: boolean;
    preReport!: WoodPreActivityReportFullDto | undefined;
    preReportDriverChanged!: boolean;
    previousTripDriverToNotify!: UserDriverInformationOutput | undefined;
    currentTripDriverToNotify!: UserDriverInformationOutput | undefined;

    constructor(data?: IEditWoodPreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportId = _data["preReportId"];
            this.editionResult = _data["editionResult"];
            this.preReport = _data["preReport"] ? WoodPreActivityReportFullDto.fromJS(_data["preReport"]) : <any>undefined;
            this.preReportDriverChanged = _data["preReportDriverChanged"];
            this.previousTripDriverToNotify = _data["previousTripDriverToNotify"] ? UserDriverInformationOutput.fromJS(_data["previousTripDriverToNotify"]) : <any>undefined;
            this.currentTripDriverToNotify = _data["currentTripDriverToNotify"] ? UserDriverInformationOutput.fromJS(_data["currentTripDriverToNotify"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditWoodPreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new EditWoodPreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportId"] = this.preReportId;
        data["editionResult"] = this.editionResult;
        data["preReport"] = this.preReport ? this.preReport.toJSON() : <any>undefined;
        data["preReportDriverChanged"] = this.preReportDriverChanged;
        data["previousTripDriverToNotify"] = this.previousTripDriverToNotify ? this.previousTripDriverToNotify.toJSON() : <any>undefined;
        data["currentTripDriverToNotify"] = this.currentTripDriverToNotify ? this.currentTripDriverToNotify.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditWoodPreActivityReportOutput {
    preReportId: number;
    editionResult: boolean;
    preReport: WoodPreActivityReportFullDto | undefined;
    preReportDriverChanged: boolean;
    previousTripDriverToNotify: UserDriverInformationOutput | undefined;
    currentTripDriverToNotify: UserDriverInformationOutput | undefined;
}

export class ElectronicActivityReportDto implements IElectronicActivityReportDto {
    cfeType!: number;
    cfeNumber!: number;
    cfeSeries!: string | undefined;

    constructor(data?: IElectronicActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cfeType = _data["cfeType"];
            this.cfeNumber = _data["cfeNumber"];
            this.cfeSeries = _data["cfeSeries"];
        }
    }

    static fromJS(data: any): ElectronicActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cfeType"] = this.cfeType;
        data["cfeNumber"] = this.cfeNumber;
        data["cfeSeries"] = this.cfeSeries;
        return data;
    }
}

export interface IElectronicActivityReportDto {
    cfeType: number;
    cfeNumber: number;
    cfeSeries: string | undefined;
}

export class ElectronicReportOutputDto implements IElectronicReportOutputDto {
    cfeType!: number;
    cfeNumber!: number;
    cfeSeries!: string | undefined;
    activityReportId!: number;
    id!: number;

    constructor(data?: IElectronicReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cfeType = _data["cfeType"];
            this.cfeNumber = _data["cfeNumber"];
            this.cfeSeries = _data["cfeSeries"];
            this.activityReportId = _data["activityReportId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ElectronicReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElectronicReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cfeType"] = this.cfeType;
        data["cfeNumber"] = this.cfeNumber;
        data["cfeSeries"] = this.cfeSeries;
        data["activityReportId"] = this.activityReportId;
        data["id"] = this.id;
        return data;
    }
}

export interface IElectronicReportOutputDto {
    cfeType: number;
    cfeNumber: number;
    cfeSeries: string | undefined;
    activityReportId: number;
    id: number;
}

export class EmailBoxInfoInputDto implements IEmailBoxInfoInputDto {
    name!: string | undefined;
    email!: string | undefined;

    constructor(data?: IEmailBoxInfoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): EmailBoxInfoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailBoxInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IEmailBoxInfoInputDto {
    name: string | undefined;
    email: string | undefined;
}

export class EmailSettingsEditDto implements IEmailSettingsEditDto {
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: IEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): EmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface IEmailSettingsEditDto {
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class EntityChangeListDto implements IEntityChangeListDto {
    userId!: number | undefined;
    userName!: string | undefined;
    changeTime!: DateTime;
    entityTypeFullName!: string | undefined;
    changeType!: EntityChangeType;
    readonly changeTypeName!: string | undefined;
    entityChangeSetId!: number;
    id!: number;

    constructor(data?: IEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.changeTime = _data["changeTime"] ? DateTime.fromISO(_data["changeTime"].toString()) : <any>undefined;
            this.entityTypeFullName = _data["entityTypeFullName"];
            this.changeType = _data["changeType"];
            (<any>this).changeTypeName = _data["changeTypeName"];
            this.entityChangeSetId = _data["entityChangeSetId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toString() : <any>undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityChangeListDto {
    userId: number | undefined;
    userName: string | undefined;
    changeTime: DateTime;
    entityTypeFullName: string | undefined;
    changeType: EntityChangeType;
    changeTypeName: string | undefined;
    entityChangeSetId: number;
    id: number;
}

export enum EntityChangeType {
    Created = "Created",
    Updated = "Updated",
    Deleted = "Deleted",
}

export class EntityDto implements IEntityDto {
    id!: number;

    constructor(data?: IEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDto {
    id: number;
}

export class EntityDtoOfGuid implements IEntityDtoOfGuid {
    id!: string;

    constructor(data?: IEntityDtoOfGuid) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfGuid {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfGuid {
    id: string;
}

export class EntityDtoOfInt64 implements IEntityDtoOfInt64 {
    id!: number;

    constructor(data?: IEntityDtoOfInt64) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfInt64 {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfInt64 {
    id: number;
}

export class EntityDtoOfString implements IEntityDtoOfString {
    id!: string | undefined;

    constructor(data?: IEntityDtoOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityDtoOfString {
        data = typeof data === 'object' ? data : {};
        let result = new EntityDtoOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityDtoOfString {
    id: string | undefined;
}

export class EntityPropertyChangeDto implements IEntityPropertyChangeDto {
    entityChangeId!: number;
    newValue!: string | undefined;
    originalValue!: string | undefined;
    propertyName!: string | undefined;
    propertyTypeFullName!: string | undefined;
    tenantId!: number | undefined;
    id!: number;

    constructor(data?: IEntityPropertyChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entityChangeId = _data["entityChangeId"];
            this.newValue = _data["newValue"];
            this.originalValue = _data["originalValue"];
            this.propertyName = _data["propertyName"];
            this.propertyTypeFullName = _data["propertyTypeFullName"];
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityPropertyChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityPropertyChangeDto {
    entityChangeId: number;
    newValue: string | undefined;
    originalValue: string | undefined;
    propertyName: string | undefined;
    propertyTypeFullName: string | undefined;
    tenantId: number | undefined;
    id: number;
}

export class ErrorDetail implements IErrorDetail {
    code!: number;
    message!: string | undefined;

    constructor(data?: IErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorDetail {
    code: number;
    message: string | undefined;
}

export class ErrorDetailDto implements IErrorDetailDto {
    code!: number;
    message!: string | undefined;

    constructor(data?: IErrorDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ErrorDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        return data;
    }
}

export interface IErrorDetailDto {
    code: number;
    message: string | undefined;
}

export class ErrorResponse implements IErrorResponse {
    targetUrl!: string | undefined;
    success!: boolean;
    error!: ErrorDetail | undefined;
    unAuthorizedRequest!: boolean;
    __abp!: boolean;

    constructor(data?: IErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetUrl = _data["targetUrl"];
            this.success = _data["success"];
            this.error = _data["error"] ? ErrorDetail.fromJS(_data["error"]) : <any>undefined;
            this.unAuthorizedRequest = _data["unAuthorizedRequest"];
            this.__abp = _data["__abp"];
        }
    }

    static fromJS(data: any): ErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetUrl"] = this.targetUrl;
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["unAuthorizedRequest"] = this.unAuthorizedRequest;
        data["__abp"] = this.__abp;
        return data;
    }
}

export interface IErrorResponse {
    targetUrl: string | undefined;
    success: boolean;
    error: ErrorDetail | undefined;
    unAuthorizedRequest: boolean;
    __abp: boolean;
}

export class ErrorResponseDto implements IErrorResponseDto {
    error!: ErrorDetailDto | undefined;

    constructor(data?: IErrorResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.error = _data["error"] ? ErrorDetailDto.fromJS(_data["error"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ErrorResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        return data;
    }
}

export interface IErrorResponseDto {
    error: ErrorDetailDto | undefined;
}

export class ExecuteIntegrationsInputDto implements IExecuteIntegrationsInputDto {
    integrationLog!: number[] | undefined;

    constructor(data?: IExecuteIntegrationsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["integrationLog"])) {
                this.integrationLog = [] as any;
                for (let item of _data["integrationLog"])
                    this.integrationLog!.push(item);
            }
        }
    }

    static fromJS(data: any): ExecuteIntegrationsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteIntegrationsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.integrationLog)) {
            data["integrationLog"] = [];
            for (let item of this.integrationLog)
                data["integrationLog"].push(item);
        }
        return data;
    }
}

export interface IExecuteIntegrationsInputDto {
    integrationLog: number[] | undefined;
}

export class ExecuteMassEditInput implements IExecuteMassEditInput {
    reportIds!: number[] | undefined;
    newOriginId!: number | undefined;
    newOriginType!: LocationType;
    newStandId!: number | undefined;
    newArticleId!: number | undefined;
    newPefcCertification!: boolean | undefined;
    newLoaderId!: number | undefined;
    newCutId!: number | undefined;
    newExtractionId!: number | undefined;
    scannerModelId!: number;
    registrationDateTime!: DateTime;
    logString!: string | undefined;
    userId!: number;
    newStandOriginId!: number | undefined;
    newStandOriginType!: LocationType | undefined;
    newContractId!: number | undefined;
    newContractVendorExternalId!: number | undefined;
    newExternalContractTypeId!: number | undefined;
    isUpdatedArticleLengthOrSpecies!: boolean;
    newPileId!: number | undefined;

    constructor(data?: IExecuteMassEditInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportIds"])) {
                this.reportIds = [] as any;
                for (let item of _data["reportIds"])
                    this.reportIds!.push(item);
            }
            this.newOriginId = _data["newOriginId"];
            this.newOriginType = _data["newOriginType"];
            this.newStandId = _data["newStandId"];
            this.newArticleId = _data["newArticleId"];
            this.newPefcCertification = _data["newPefcCertification"];
            this.newLoaderId = _data["newLoaderId"];
            this.newCutId = _data["newCutId"];
            this.newExtractionId = _data["newExtractionId"];
            this.scannerModelId = _data["scannerModelId"];
            this.registrationDateTime = _data["registrationDateTime"] ? DateTime.fromISO(_data["registrationDateTime"].toString()) : <any>undefined;
            this.logString = _data["logString"];
            this.userId = _data["userId"];
            this.newStandOriginId = _data["newStandOriginId"];
            this.newStandOriginType = _data["newStandOriginType"];
            this.newContractId = _data["newContractId"];
            this.newContractVendorExternalId = _data["newContractVendorExternalId"];
            this.newExternalContractTypeId = _data["newExternalContractTypeId"];
            this.isUpdatedArticleLengthOrSpecies = _data["isUpdatedArticleLengthOrSpecies"];
            this.newPileId = _data["newPileId"];
        }
    }

    static fromJS(data: any): ExecuteMassEditInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteMassEditInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportIds)) {
            data["reportIds"] = [];
            for (let item of this.reportIds)
                data["reportIds"].push(item);
        }
        data["newOriginId"] = this.newOriginId;
        data["newOriginType"] = this.newOriginType;
        data["newStandId"] = this.newStandId;
        data["newArticleId"] = this.newArticleId;
        data["newPefcCertification"] = this.newPefcCertification;
        data["newLoaderId"] = this.newLoaderId;
        data["newCutId"] = this.newCutId;
        data["newExtractionId"] = this.newExtractionId;
        data["scannerModelId"] = this.scannerModelId;
        data["registrationDateTime"] = this.registrationDateTime ? this.registrationDateTime.toString() : <any>undefined;
        data["logString"] = this.logString;
        data["userId"] = this.userId;
        data["newStandOriginId"] = this.newStandOriginId;
        data["newStandOriginType"] = this.newStandOriginType;
        data["newContractId"] = this.newContractId;
        data["newContractVendorExternalId"] = this.newContractVendorExternalId;
        data["newExternalContractTypeId"] = this.newExternalContractTypeId;
        data["isUpdatedArticleLengthOrSpecies"] = this.isUpdatedArticleLengthOrSpecies;
        data["newPileId"] = this.newPileId;
        return data;
    }
}

export interface IExecuteMassEditInput {
    reportIds: number[] | undefined;
    newOriginId: number | undefined;
    newOriginType: LocationType;
    newStandId: number | undefined;
    newArticleId: number | undefined;
    newPefcCertification: boolean | undefined;
    newLoaderId: number | undefined;
    newCutId: number | undefined;
    newExtractionId: number | undefined;
    scannerModelId: number;
    registrationDateTime: DateTime;
    logString: string | undefined;
    userId: number;
    newStandOriginId: number | undefined;
    newStandOriginType: LocationType | undefined;
    newContractId: number | undefined;
    newContractVendorExternalId: number | undefined;
    newExternalContractTypeId: number | undefined;
    isUpdatedArticleLengthOrSpecies: boolean;
    newPileId: number | undefined;
}

export class ExecuteMassEditOutput implements IExecuteMassEditOutput {
    fatalError!: boolean;
    detailedOutput!: ExecuteMassEditSingleReportOutput[] | undefined;

    constructor(data?: IExecuteMassEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fatalError = _data["fatalError"];
            if (Array.isArray(_data["detailedOutput"])) {
                this.detailedOutput = [] as any;
                for (let item of _data["detailedOutput"])
                    this.detailedOutput!.push(ExecuteMassEditSingleReportOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExecuteMassEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteMassEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fatalError"] = this.fatalError;
        if (Array.isArray(this.detailedOutput)) {
            data["detailedOutput"] = [];
            for (let item of this.detailedOutput)
                data["detailedOutput"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExecuteMassEditOutput {
    fatalError: boolean;
    detailedOutput: ExecuteMassEditSingleReportOutput[] | undefined;
}

export class ExecuteMassEditSingleReportOutput implements IExecuteMassEditSingleReportOutput {
    succeeded!: boolean;
    errorMessage!: string | undefined;
    updatedReport!: WoodControlActivityReportDto | undefined;

    constructor(data?: IExecuteMassEditSingleReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            this.errorMessage = _data["errorMessage"];
            this.updatedReport = _data["updatedReport"] ? WoodControlActivityReportDto.fromJS(_data["updatedReport"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ExecuteMassEditSingleReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExecuteMassEditSingleReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        data["errorMessage"] = this.errorMessage;
        data["updatedReport"] = this.updatedReport ? this.updatedReport.toJSON() : <any>undefined;
        return data;
    }
}

export interface IExecuteMassEditSingleReportOutput {
    succeeded: boolean;
    errorMessage: string | undefined;
    updatedReport: WoodControlActivityReportDto | undefined;
}

export class ExistReportInPlaceOutputDto implements IExistReportInPlaceOutputDto {
    exist!: boolean;
    activityReportId!: number;
    placeName!: string | undefined;

    constructor(data?: IExistReportInPlaceOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exist = _data["exist"];
            this.activityReportId = _data["activityReportId"];
            this.placeName = _data["placeName"];
        }
    }

    static fromJS(data: any): ExistReportInPlaceOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExistReportInPlaceOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exist"] = this.exist;
        data["activityReportId"] = this.activityReportId;
        data["placeName"] = this.placeName;
        return data;
    }
}

export interface IExistReportInPlaceOutputDto {
    exist: boolean;
    activityReportId: number;
    placeName: string | undefined;
}

export class ExistsPreActivityReportResultOutput implements IExistsPreActivityReportResultOutput {
    exists!: boolean;
    activityReportId!: number;
    driverExternalId!: number;
    activityReportPlaceId!: number;
    originDestinationExternalId!: number;
    originDestinationLocationType!: LocationType;

    constructor(data?: IExistsPreActivityReportResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exists = _data["exists"];
            this.activityReportId = _data["activityReportId"];
            this.driverExternalId = _data["driverExternalId"];
            this.activityReportPlaceId = _data["activityReportPlaceId"];
            this.originDestinationExternalId = _data["originDestinationExternalId"];
            this.originDestinationLocationType = _data["originDestinationLocationType"];
        }
    }

    static fromJS(data: any): ExistsPreActivityReportResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExistsPreActivityReportResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        data["activityReportId"] = this.activityReportId;
        data["driverExternalId"] = this.driverExternalId;
        data["activityReportPlaceId"] = this.activityReportPlaceId;
        data["originDestinationExternalId"] = this.originDestinationExternalId;
        data["originDestinationLocationType"] = this.originDestinationLocationType;
        return data;
    }
}

export interface IExistsPreActivityReportResultOutput {
    exists: boolean;
    activityReportId: number;
    driverExternalId: number;
    activityReportPlaceId: number;
    originDestinationExternalId: number;
    originDestinationLocationType: LocationType;
}

export class ExpiringTenant implements IExpiringTenant {
    tenantName!: string | undefined;
    remainingDayCount!: number;

    constructor(data?: IExpiringTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantName = _data["tenantName"];
            this.remainingDayCount = _data["remainingDayCount"];
        }
    }

    static fromJS(data: any): ExpiringTenant {
        data = typeof data === 'object' ? data : {};
        let result = new ExpiringTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    }
}

export interface IExpiringTenant {
    tenantName: string | undefined;
    remainingDayCount: number;
}

export class ExternalArticleDto implements IExternalArticleDto {
    externalId!: number;

    constructor(data?: IExternalArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ExternalArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IExternalArticleDto {
    externalId: number;
}

export class ExternalArticleInput implements IExternalArticleInput {
    externalId!: number;

    constructor(data?: IExternalArticleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ExternalArticleInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalArticleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IExternalArticleInput {
    externalId: number;
}

export class ExternalAuthenticateModel implements IExternalAuthenticateModel {
    authProvider!: string;
    providerKey!: string | undefined;
    providerAccessCode!: string;
    returnUrl!: string | undefined;
    singleSignIn!: boolean | undefined;
    createRefreshToken!: boolean | undefined;

    constructor(data?: IExternalAuthenticateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.authProvider = _data["authProvider"];
            this.providerKey = _data["providerKey"];
            this.providerAccessCode = _data["providerAccessCode"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.createRefreshToken = _data["createRefreshToken"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["createRefreshToken"] = this.createRefreshToken;
        return data;
    }
}

export interface IExternalAuthenticateModel {
    authProvider: string;
    providerKey: string | undefined;
    providerAccessCode: string;
    returnUrl: string | undefined;
    singleSignIn: boolean | undefined;
    createRefreshToken: boolean | undefined;
}

export class ExternalAuthenticateResultModel implements IExternalAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;
    waitingForActivation!: boolean;
    returnUrl!: string | undefined;
    refreshToken!: string | undefined;
    refreshTokenExpireInSeconds!: number;
    isNewUser!: boolean;
    userEmail!: string | undefined;
    userId!: number | undefined;
    useSecondPassword!: boolean;

    constructor(data?: IExternalAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
            this.waitingForActivation = _data["waitingForActivation"];
            this.returnUrl = _data["returnUrl"];
            this.refreshToken = _data["refreshToken"];
            this.refreshTokenExpireInSeconds = _data["refreshTokenExpireInSeconds"];
            this.isNewUser = _data["isNewUser"];
            this.userEmail = _data["userEmail"];
            this.userId = _data["userId"];
            this.useSecondPassword = _data["useSecondPassword"];
        }
    }

    static fromJS(data: any): ExternalAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        data["refreshToken"] = this.refreshToken;
        data["refreshTokenExpireInSeconds"] = this.refreshTokenExpireInSeconds;
        data["isNewUser"] = this.isNewUser;
        data["userEmail"] = this.userEmail;
        data["userId"] = this.userId;
        data["useSecondPassword"] = this.useSecondPassword;
        return data;
    }
}

export interface IExternalAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
    waitingForActivation: boolean;
    returnUrl: string | undefined;
    refreshToken: string | undefined;
    refreshTokenExpireInSeconds: number;
    isNewUser: boolean;
    userEmail: string | undefined;
    userId: number | undefined;
    useSecondPassword: boolean;
}

export class ExternalBioforestReportId implements IExternalBioforestReportId {
    externalActityReportId!: number | undefined;

    constructor(data?: IExternalBioforestReportId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalActityReportId = _data["externalActityReportId"];
        }
    }

    static fromJS(data: any): ExternalBioforestReportId {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalBioforestReportId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalActityReportId"] = this.externalActityReportId;
        return data;
    }
}

export interface IExternalBioforestReportId {
    externalActityReportId: number | undefined;
}

export class ExternalContractDto implements IExternalContractDto {
    externalId!: number;
    externalContractTypeId!: number;
    vendorExternalId!: number;

    constructor(data?: IExternalContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.externalContractTypeId = _data["externalContractTypeId"];
            this.vendorExternalId = _data["vendorExternalId"];
        }
    }

    static fromJS(data: any): ExternalContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["externalContractTypeId"] = this.externalContractTypeId;
        data["vendorExternalId"] = this.vendorExternalId;
        return data;
    }
}

export interface IExternalContractDto {
    externalId: number;
    externalContractTypeId: number;
    vendorExternalId: number;
}

export class ExternalContractInput implements IExternalContractInput {
    externalId!: number;
    contractTypeId!: number;
    vendorExternalId!: number;

    constructor(data?: IExternalContractInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.contractTypeId = _data["contractTypeId"];
            this.vendorExternalId = _data["vendorExternalId"];
        }
    }

    static fromJS(data: any): ExternalContractInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalContractInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["contractTypeId"] = this.contractTypeId;
        data["vendorExternalId"] = this.vendorExternalId;
        return data;
    }
}

export interface IExternalContractInput {
    externalId: number;
    contractTypeId: number;
    vendorExternalId: number;
}

export class ExternalDriverDto implements IExternalDriverDto {
    externalId!: number;
    externalVendorId!: number;

    constructor(data?: IExternalDriverDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.externalVendorId = _data["externalVendorId"];
        }
    }

    static fromJS(data: any): ExternalDriverDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalDriverDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["externalVendorId"] = this.externalVendorId;
        return data;
    }
}

export interface IExternalDriverDto {
    externalId: number;
    externalVendorId: number;
}

export class ExternalDriverInput implements IExternalDriverInput {
    externalId!: number;
    externalVendorId!: number;

    constructor(data?: IExternalDriverInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.externalVendorId = _data["externalVendorId"];
        }
    }

    static fromJS(data: any): ExternalDriverInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalDriverInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["externalVendorId"] = this.externalVendorId;
        return data;
    }
}

export interface IExternalDriverInput {
    externalId: number;
    externalVendorId: number;
}

export class ExternalIdentityDto implements IExternalIdentityDto {
    externalId!: number;

    constructor(data?: IExternalIdentityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ExternalIdentityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalIdentityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IExternalIdentityDto {
    externalId: number;
}

export class ExternalLinesInput implements IExternalLinesInput {
    article!: ExternalArticleInput | undefined;
    contract!: ExternalContractInput | undefined;
    services!: ExternalServiceInput[] | undefined;
    stand!: ExternalStandInput | undefined;
    origin!: ExternalLocationInputDto | undefined;
    pileId!: number | undefined;
    isChip!: boolean | undefined;
    isPefcCertified!: boolean | undefined;

    constructor(data?: IExternalLinesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.article = _data["article"] ? ExternalArticleInput.fromJS(_data["article"]) : <any>undefined;
            this.contract = _data["contract"] ? ExternalContractInput.fromJS(_data["contract"]) : <any>undefined;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ExternalServiceInput.fromJS(item));
            }
            this.stand = _data["stand"] ? ExternalStandInput.fromJS(_data["stand"]) : <any>undefined;
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.pileId = _data["pileId"];
            this.isChip = _data["isChip"];
            this.isPefcCertified = _data["isPefcCertified"];
        }
    }

    static fromJS(data: any): ExternalLinesInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLinesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["pileId"] = this.pileId;
        data["isChip"] = this.isChip;
        data["isPefcCertified"] = this.isPefcCertified;
        return data;
    }
}

export interface IExternalLinesInput {
    article: ExternalArticleInput | undefined;
    contract: ExternalContractInput | undefined;
    services: ExternalServiceInput[] | undefined;
    stand: ExternalStandInput | undefined;
    origin: ExternalLocationInputDto | undefined;
    pileId: number | undefined;
    isChip: boolean | undefined;
    isPefcCertified: boolean | undefined;
}

export class ExternalLocationInputDto implements IExternalLocationInputDto {
    externalId!: number;
    type!: LocationType;

    constructor(data?: IExternalLocationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ExternalLocationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLocationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["type"] = this.type;
        return data;
    }
}

export interface IExternalLocationInputDto {
    externalId: number;
    type: LocationType;
}

export class ExternalLoginProviderInfoModel implements IExternalLoginProviderInfoModel {
    name!: string | undefined;
    clientId!: string | undefined;
    additionalParams!: { [key: string]: string; } | undefined;

    constructor(data?: IExternalLoginProviderInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            if (_data["additionalParams"]) {
                this.additionalParams = {} as any;
                for (let key in _data["additionalParams"]) {
                    if (_data["additionalParams"].hasOwnProperty(key))
                        (<any>this.additionalParams)![key] = _data["additionalParams"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (let key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    (<any>data["additionalParams"])[key] = (<any>this.additionalParams)[key];
            }
        }
        return data;
    }
}

export interface IExternalLoginProviderInfoModel {
    name: string | undefined;
    clientId: string | undefined;
    additionalParams: { [key: string]: string; } | undefined;
}

export class ExternalLoginProviderSettingsEditDto implements IExternalLoginProviderSettingsEditDto {
    facebook!: FacebookExternalLoginProviderSettings | undefined;
    google!: GoogleExternalLoginProviderSettings | undefined;
    twitter!: TwitterExternalLoginProviderSettings | undefined;
    microsoft!: MicrosoftExternalLoginProviderSettings | undefined;
    openIdConnect!: OpenIdConnectExternalLoginProviderSettings | undefined;
    openIdConnectClaimsMapping!: JsonClaimMapDto[] | undefined;
    wsFederation!: WsFederationExternalLoginProviderSettings | undefined;
    wsFederationClaimsMapping!: JsonClaimMapDto[] | undefined;

    constructor(data?: IExternalLoginProviderSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facebook = _data["facebook"] ? FacebookExternalLoginProviderSettings.fromJS(_data["facebook"]) : <any>undefined;
            this.google = _data["google"] ? GoogleExternalLoginProviderSettings.fromJS(_data["google"]) : <any>undefined;
            this.twitter = _data["twitter"] ? TwitterExternalLoginProviderSettings.fromJS(_data["twitter"]) : <any>undefined;
            this.microsoft = _data["microsoft"] ? MicrosoftExternalLoginProviderSettings.fromJS(_data["microsoft"]) : <any>undefined;
            this.openIdConnect = _data["openIdConnect"] ? OpenIdConnectExternalLoginProviderSettings.fromJS(_data["openIdConnect"]) : <any>undefined;
            if (Array.isArray(_data["openIdConnectClaimsMapping"])) {
                this.openIdConnectClaimsMapping = [] as any;
                for (let item of _data["openIdConnectClaimsMapping"])
                    this.openIdConnectClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
            this.wsFederation = _data["wsFederation"] ? WsFederationExternalLoginProviderSettings.fromJS(_data["wsFederation"]) : <any>undefined;
            if (Array.isArray(_data["wsFederationClaimsMapping"])) {
                this.wsFederationClaimsMapping = [] as any;
                for (let item of _data["wsFederationClaimsMapping"])
                    this.wsFederationClaimsMapping!.push(JsonClaimMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalLoginProviderSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginProviderSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facebook"] = this.facebook ? this.facebook.toJSON() : <any>undefined;
        data["google"] = this.google ? this.google.toJSON() : <any>undefined;
        data["twitter"] = this.twitter ? this.twitter.toJSON() : <any>undefined;
        data["microsoft"] = this.microsoft ? this.microsoft.toJSON() : <any>undefined;
        data["openIdConnect"] = this.openIdConnect ? this.openIdConnect.toJSON() : <any>undefined;
        if (Array.isArray(this.openIdConnectClaimsMapping)) {
            data["openIdConnectClaimsMapping"] = [];
            for (let item of this.openIdConnectClaimsMapping)
                data["openIdConnectClaimsMapping"].push(item.toJSON());
        }
        data["wsFederation"] = this.wsFederation ? this.wsFederation.toJSON() : <any>undefined;
        if (Array.isArray(this.wsFederationClaimsMapping)) {
            data["wsFederationClaimsMapping"] = [];
            for (let item of this.wsFederationClaimsMapping)
                data["wsFederationClaimsMapping"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalLoginProviderSettingsEditDto {
    facebook: FacebookExternalLoginProviderSettings | undefined;
    google: GoogleExternalLoginProviderSettings | undefined;
    twitter: TwitterExternalLoginProviderSettings | undefined;
    microsoft: MicrosoftExternalLoginProviderSettings | undefined;
    openIdConnect: OpenIdConnectExternalLoginProviderSettings | undefined;
    openIdConnectClaimsMapping: JsonClaimMapDto[] | undefined;
    wsFederation: WsFederationExternalLoginProviderSettings | undefined;
    wsFederationClaimsMapping: JsonClaimMapDto[] | undefined;
}

export class ExternalLoginSettingsDto implements IExternalLoginSettingsDto {
    enabledSocialLoginSettings!: string[] | undefined;

    constructor(data?: IExternalLoginSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["enabledSocialLoginSettings"])) {
                this.enabledSocialLoginSettings = [] as any;
                for (let item of _data["enabledSocialLoginSettings"])
                    this.enabledSocialLoginSettings!.push(item);
            }
        }
    }

    static fromJS(data: any): ExternalLoginSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLoginSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.enabledSocialLoginSettings)) {
            data["enabledSocialLoginSettings"] = [];
            for (let item of this.enabledSocialLoginSettings)
                data["enabledSocialLoginSettings"].push(item);
        }
        return data;
    }
}

export interface IExternalLoginSettingsDto {
    enabledSocialLoginSettings: string[] | undefined;
}

export enum ExternalProcessingState {
    ProcessingPending = "ProcessingPending",
    ProcessingError = "ProcessingError",
    Processed = "Processed",
}

export enum ExternalProcessingStateFilter {
    IntegrationError = "IntegrationError",
    ProcessingPending = "ProcessingPending",
    ProcessingError = "ProcessingError",
    Processed = "Processed",
}

export class ExternalProcessWeightDto implements IExternalProcessWeightDto {
    reasonId!: number | undefined;
    reasonComment!: string | undefined;
    value!: number;

    constructor(data?: IExternalProcessWeightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonId = _data["reasonId"];
            this.reasonComment = _data["reasonComment"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): ExternalProcessWeightDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalProcessWeightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId;
        data["reasonComment"] = this.reasonComment;
        data["value"] = this.value;
        return data;
    }
}

export interface IExternalProcessWeightDto {
    reasonId: number | undefined;
    reasonComment: string | undefined;
    value: number;
}

export class ExternalProviderItemOutput implements IExternalProviderItemOutput {
    name!: string | undefined;
    clientId!: string | undefined;
    externalVendorId!: number;
    providerType!: ProviderType;
    id!: number;

    constructor(data?: IExternalProviderItemOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.clientId = _data["clientId"];
            this.externalVendorId = _data["externalVendorId"];
            this.providerType = _data["providerType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ExternalProviderItemOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalProviderItemOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        data["externalVendorId"] = this.externalVendorId;
        data["providerType"] = this.providerType;
        data["id"] = this.id;
        return data;
    }
}

export interface IExternalProviderItemOutput {
    name: string | undefined;
    clientId: string | undefined;
    externalVendorId: number;
    providerType: ProviderType;
    id: number;
}

export class ExternalServiceInput implements IExternalServiceInput {
    externalId!: number;
    vendorExternalId!: number;

    constructor(data?: IExternalServiceInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.vendorExternalId = _data["vendorExternalId"];
        }
    }

    static fromJS(data: any): ExternalServiceInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalServiceInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["vendorExternalId"] = this.vendorExternalId;
        return data;
    }
}

export interface IExternalServiceInput {
    externalId: number;
    vendorExternalId: number;
}

export class ExternalSingleCustomDeclarationInput implements IExternalSingleCustomDeclarationInput {
    externalId!: number;

    constructor(data?: IExternalSingleCustomDeclarationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ExternalSingleCustomDeclarationInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSingleCustomDeclarationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IExternalSingleCustomDeclarationInput {
    externalId: number;
}

export class ExternalStandDto implements IExternalStandDto {
    externalId!: number;
    standNumber!: number;

    constructor(data?: IExternalStandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.standNumber = _data["standNumber"];
        }
    }

    static fromJS(data: any): ExternalStandDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalStandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["standNumber"] = this.standNumber;
        return data;
    }
}

export interface IExternalStandDto {
    externalId: number;
    standNumber: number;
}

export class ExternalStandInput implements IExternalStandInput {
    externalId!: number;
    standNumber!: number;

    constructor(data?: IExternalStandInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.standNumber = _data["standNumber"];
        }
    }

    static fromJS(data: any): ExternalStandInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalStandInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["standNumber"] = this.standNumber;
        return data;
    }
}

export interface IExternalStandInput {
    externalId: number;
    standNumber: number;
}

export class ExternalSystemDto implements IExternalSystemDto {
    name!: string | undefined;

    constructor(data?: IExternalSystemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ExternalSystemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalSystemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IExternalSystemDto {
    name: string | undefined;
}

export class ExternalTransportInput implements IExternalTransportInput {
    licensePlate!: string | undefined;
    externalVehicleId!: number;
    externalVendorId!: number;

    constructor(data?: IExternalTransportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensePlate = _data["licensePlate"];
            this.externalVehicleId = _data["externalVehicleId"];
            this.externalVendorId = _data["externalVendorId"];
        }
    }

    static fromJS(data: any): ExternalTransportInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTransportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensePlate"] = this.licensePlate;
        data["externalVehicleId"] = this.externalVehicleId;
        data["externalVendorId"] = this.externalVendorId;
        return data;
    }
}

export interface IExternalTransportInput {
    licensePlate: string | undefined;
    externalVehicleId: number;
    externalVendorId: number;
}

export class ExternalTruckVehicleInput implements IExternalTruckVehicleInput {
    licensePlate!: string;
    isTruck!: boolean;
    vendorExternalId!: number;
    vehicleTruckTypeExternalId!: number;
    externalId!: number;
    source!: DetectionSource;

    constructor(data?: IExternalTruckVehicleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensePlate = _data["licensePlate"];
            this.isTruck = _data["isTruck"];
            this.vendorExternalId = _data["vendorExternalId"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.externalId = _data["externalId"];
            this.source = _data["source"];
        }
    }

    static fromJS(data: any): ExternalTruckVehicleInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalTruckVehicleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensePlate"] = this.licensePlate;
        data["isTruck"] = this.isTruck;
        data["vendorExternalId"] = this.vendorExternalId;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["externalId"] = this.externalId;
        data["source"] = this.source;
        return data;
    }
}

export interface IExternalTruckVehicleInput {
    licensePlate: string;
    isTruck: boolean;
    vendorExternalId: number;
    vehicleTruckTypeExternalId: number;
    externalId: number;
    source: DetectionSource;
}

export class ExternalVendorInput implements IExternalVendorInput {
    externalId!: number;

    constructor(data?: IExternalVendorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): ExternalVendorInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalVendorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IExternalVendorInput {
    externalId: number;
}

export class ExternalWeightOutputDto implements IExternalWeightOutputDto {
    totalWeight!: DetailedWeightDto | undefined;
    perLineWeight!: DetailedWeightDto[] | undefined;

    constructor(data?: IExternalWeightOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWeight = _data["totalWeight"] ? DetailedWeightDto.fromJS(_data["totalWeight"]) : <any>undefined;
            if (Array.isArray(_data["perLineWeight"])) {
                this.perLineWeight = [] as any;
                for (let item of _data["perLineWeight"])
                    this.perLineWeight!.push(DetailedWeightDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExternalWeightOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalWeightOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWeight"] = this.totalWeight ? this.totalWeight.toJSON() : <any>undefined;
        if (Array.isArray(this.perLineWeight)) {
            data["perLineWeight"] = [];
            for (let item of this.perLineWeight)
                data["perLineWeight"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExternalWeightOutputDto {
    totalWeight: DetailedWeightDto | undefined;
    perLineWeight: DetailedWeightDto[] | undefined;
}

export class ExtremeCalibrationDto implements IExtremeCalibrationDto {
    extremeOrder!: number;
    weight!: WeightDto | undefined;
    manual!: boolean;
    calibrationId!: number;

    constructor(data?: IExtremeCalibrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.extremeOrder = _data["extremeOrder"];
            this.weight = _data["weight"] ? WeightDto.fromJS(_data["weight"]) : <any>undefined;
            this.manual = _data["manual"];
            this.calibrationId = _data["calibrationId"];
        }
    }

    static fromJS(data: any): ExtremeCalibrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtremeCalibrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["extremeOrder"] = this.extremeOrder;
        data["weight"] = this.weight ? this.weight.toJSON() : <any>undefined;
        data["manual"] = this.manual;
        data["calibrationId"] = this.calibrationId;
        return data;
    }
}

export interface IExtremeCalibrationDto {
    extremeOrder: number;
    weight: WeightDto | undefined;
    manual: boolean;
    calibrationId: number;
}

export class FacebookExternalLoginProviderSettings implements IFacebookExternalLoginProviderSettings {
    appId!: string | undefined;
    appSecret!: string | undefined;

    constructor(data?: IFacebookExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appId = _data["appId"];
            this.appSecret = _data["appSecret"];
        }
    }

    static fromJS(data: any): FacebookExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new FacebookExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appId"] = this.appId;
        data["appSecret"] = this.appSecret;
        return data;
    }
}

export interface IFacebookExternalLoginProviderSettings {
    appId: string | undefined;
    appSecret: string | undefined;
}

export class FeatureInputTypeDto implements IFeatureInputTypeDto {
    name!: string | undefined;
    attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator | undefined;
    itemSource!: LocalizableComboboxItemSourceDto | undefined;

    constructor(data?: IFeatureInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (_data["attributes"]) {
                this.attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>this.attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
            this.itemSource = _data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(_data["itemSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureInputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFeatureInputTypeDto {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator | undefined;
    itemSource: LocalizableComboboxItemSourceDto | undefined;
}

export class FileDto implements IFileDto {
    fileName!: string;
    fileType!: string | undefined;
    fileToken!: string;

    constructor(data?: IFileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.fileType = _data["fileType"];
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): FileDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IFileDto {
    fileName: string;
    fileType: string | undefined;
    fileToken: string;
}

export class FindOrganizationUnitRolesInput implements IFindOrganizationUnitRolesInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;
    sorting!: string | undefined;

    constructor(data?: IFindOrganizationUnitRolesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitRolesInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitRolesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IFindOrganizationUnitRolesInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    sorting: string | undefined;
}

export class FindOrganizationUnitUsersInput implements IFindOrganizationUnitUsersInput {
    organizationUnitId!: number;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;
    sorting!: string | undefined;

    constructor(data?: IFindOrganizationUnitUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationUnitId = _data["organizationUnitId"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): FindOrganizationUnitUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IFindOrganizationUnitUsersInput {
    organizationUnitId: number;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    sorting: string | undefined;
}

export class FindUsersInput implements IFindUsersInput {
    tenantId!: number | undefined;
    excludeCurrentUser!: boolean;
    maxResultCount!: number;
    skipCount!: number;
    filter!: string | undefined;
    sorting!: string | undefined;

    constructor(data?: IFindUsersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.excludeCurrentUser = _data["excludeCurrentUser"];
            this.maxResultCount = _data["maxResultCount"];
            this.skipCount = _data["skipCount"];
            this.filter = _data["filter"];
            this.sorting = _data["sorting"];
        }
    }

    static fromJS(data: any): FindUsersInput {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["excludeCurrentUser"] = this.excludeCurrentUser;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        data["sorting"] = this.sorting;
        return data;
    }
}

export interface IFindUsersInput {
    tenantId: number | undefined;
    excludeCurrentUser: boolean;
    maxResultCount: number;
    skipCount: number;
    filter: string | undefined;
    sorting: string | undefined;
}

export class FlatFeatureDto implements IFlatFeatureDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: FeatureInputTypeDto | undefined;

    constructor(data?: IFlatFeatureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? FeatureInputTypeDto.fromJS(_data["inputType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FlatFeatureDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFlatFeatureDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: FeatureInputTypeDto | undefined;
}

export class FlatFeatureSelectDto implements IFlatFeatureSelectDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    defaultValue!: string | undefined;
    inputType!: IInputType | undefined;
    textHtmlColor!: string | undefined;

    constructor(data?: IFlatFeatureSelectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.defaultValue = _data["defaultValue"];
            this.inputType = _data["inputType"] ? IInputType.fromJS(_data["inputType"]) : <any>undefined;
            this.textHtmlColor = _data["textHtmlColor"];
        }
    }

    static fromJS(data: any): FlatFeatureSelectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : <any>undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    }
}

export interface IFlatFeatureSelectDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    defaultValue: string | undefined;
    inputType: IInputType | undefined;
    textHtmlColor: string | undefined;
}

export class FlatPermissionDto implements IFlatPermissionDto {
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionDto {
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class FlatPermissionWithLevelDto implements IFlatPermissionWithLevelDto {
    level!: number;
    parentName!: string | undefined;
    name!: string | undefined;
    displayName!: string | undefined;
    description!: string | undefined;
    isGrantedByDefault!: boolean;

    constructor(data?: IFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.level = _data["level"];
            this.parentName = _data["parentName"];
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.isGrantedByDefault = _data["isGrantedByDefault"];
        }
    }

    static fromJS(data: any): FlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    }
}

export interface IFlatPermissionWithLevelDto {
    level: number;
    parentName: string | undefined;
    name: string | undefined;
    displayName: string | undefined;
    description: string | undefined;
    isGrantedByDefault: boolean;
}

export class ForceSamplesRecoveryInput implements IForceSamplesRecoveryInput {
    date!: DateTime;
    samplingInfo!: SampleRecoveryOrValidationInfoDto[] | undefined;
    placeId!: number;

    constructor(data?: IForceSamplesRecoveryInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["samplingInfo"])) {
                this.samplingInfo = [] as any;
                for (let item of _data["samplingInfo"])
                    this.samplingInfo!.push(SampleRecoveryOrValidationInfoDto.fromJS(item));
            }
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): ForceSamplesRecoveryInput {
        data = typeof data === 'object' ? data : {};
        let result = new ForceSamplesRecoveryInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        if (Array.isArray(this.samplingInfo)) {
            data["samplingInfo"] = [];
            for (let item of this.samplingInfo)
                data["samplingInfo"].push(item.toJSON());
        }
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IForceSamplesRecoveryInput {
    date: DateTime;
    samplingInfo: SampleRecoveryOrValidationInfoDto[] | undefined;
    placeId: number;
}

export class FriendDto implements IFriendDto {
    friendUserId!: number;
    friendTenantId!: number | undefined;
    friendUserName!: string | undefined;
    friendTenancyName!: string | undefined;
    friendProfilePictureId!: string | undefined;
    unreadMessageCount!: number;
    isOnline!: boolean;
    state!: FriendshipState;

    constructor(data?: IFriendDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.friendUserId = _data["friendUserId"];
            this.friendTenantId = _data["friendTenantId"];
            this.friendUserName = _data["friendUserName"];
            this.friendTenancyName = _data["friendTenancyName"];
            this.friendProfilePictureId = _data["friendProfilePictureId"];
            this.unreadMessageCount = _data["unreadMessageCount"];
            this.isOnline = _data["isOnline"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): FriendDto {
        data = typeof data === 'object' ? data : {};
        let result = new FriendDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    }
}

export interface IFriendDto {
    friendUserId: number;
    friendTenantId: number | undefined;
    friendUserName: string | undefined;
    friendTenancyName: string | undefined;
    friendProfilePictureId: string | undefined;
    unreadMessageCount: number;
    isOnline: boolean;
    state: FriendshipState;
}

export enum FriendshipState {
    Accepted = "Accepted",
    Blocked = "Blocked",
}

export class FuncOfIServiceProviderIHealthCheck implements IFuncOfIServiceProviderIHealthCheck {
    readonly target!: any | undefined;
    readonly method!: MethodInfo | undefined;

    constructor(data?: IFuncOfIServiceProviderIHealthCheck) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).target = _data["target"];
            (<any>this).method = _data["method"] ? MethodInfo.fromJS(_data["method"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FuncOfIServiceProviderIHealthCheck {
        data = typeof data === 'object' ? data : {};
        let result = new FuncOfIServiceProviderIHealthCheck();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["target"] = this.target;
        data["method"] = this.method ? this.method.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFuncOfIServiceProviderIHealthCheck {
    target: any | undefined;
    method: MethodInfo | undefined;
}

export class GeneralSettingsEditDto implements IGeneralSettingsEditDto {
    timezone!: string | undefined;
    timezoneForComparison!: string | undefined;

    constructor(data?: IGeneralSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timezone = _data["timezone"];
            this.timezoneForComparison = _data["timezoneForComparison"];
        }
    }

    static fromJS(data: any): GeneralSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    }
}

export interface IGeneralSettingsEditDto {
    timezone: string | undefined;
    timezoneForComparison: string | undefined;
}

export class GetActiveTagByLicensePlateOutputDto implements IGetActiveTagByLicensePlateOutputDto {
    tagExists!: boolean;
    tagNumber!: number | undefined;
    isTruck!: boolean;

    constructor(data?: IGetActiveTagByLicensePlateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagExists = _data["tagExists"];
            this.tagNumber = _data["tagNumber"];
            this.isTruck = _data["isTruck"];
        }
    }

    static fromJS(data: any): GetActiveTagByLicensePlateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetActiveTagByLicensePlateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagExists"] = this.tagExists;
        data["tagNumber"] = this.tagNumber;
        data["isTruck"] = this.isTruck;
        return data;
    }
}

export interface IGetActiveTagByLicensePlateOutputDto {
    tagExists: boolean;
    tagNumber: number | undefined;
    isTruck: boolean;
}

export class GetAllPlacesToSwitchOutputDto implements IGetAllPlacesToSwitchOutputDto {
    items!: PlaceToSwitchItemDto[] | undefined;
    current!: PlaceToSwitchItemDto | undefined;

    constructor(data?: IGetAllPlacesToSwitchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlaceToSwitchItemDto.fromJS(item));
            }
            this.current = _data["current"] ? PlaceToSwitchItemDto.fromJS(_data["current"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetAllPlacesToSwitchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPlacesToSwitchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["current"] = this.current ? this.current.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetAllPlacesToSwitchOutputDto {
    items: PlaceToSwitchItemDto[] | undefined;
    current: PlaceToSwitchItemDto | undefined;
}

export class GetCurrentLoginInformationsOutput implements IGetCurrentLoginInformationsOutput {
    user!: UserLoginInfoDto | undefined;
    impersonatorUser!: UserLoginInfoDto | undefined;
    tenant!: TenantLoginInfoDto | undefined;
    impersonatorTenant!: TenantLoginInfoDto | undefined;
    application!: ApplicationInfoDto | undefined;
    theme!: UiCustomizationSettingsDto | undefined;

    constructor(data?: IGetCurrentLoginInformationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserLoginInfoDto.fromJS(_data["user"]) : <any>undefined;
            this.impersonatorUser = _data["impersonatorUser"] ? UserLoginInfoDto.fromJS(_data["impersonatorUser"]) : <any>undefined;
            this.tenant = _data["tenant"] ? TenantLoginInfoDto.fromJS(_data["tenant"]) : <any>undefined;
            this.impersonatorTenant = _data["impersonatorTenant"] ? TenantLoginInfoDto.fromJS(_data["impersonatorTenant"]) : <any>undefined;
            this.application = _data["application"] ? ApplicationInfoDto.fromJS(_data["application"]) : <any>undefined;
            this.theme = _data["theme"] ? UiCustomizationSettingsDto.fromJS(_data["theme"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetCurrentLoginInformationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["impersonatorUser"] = this.impersonatorUser ? this.impersonatorUser.toJSON() : <any>undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : <any>undefined;
        data["impersonatorTenant"] = this.impersonatorTenant ? this.impersonatorTenant.toJSON() : <any>undefined;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetCurrentLoginInformationsOutput {
    user: UserLoginInfoDto | undefined;
    impersonatorUser: UserLoginInfoDto | undefined;
    tenant: TenantLoginInfoDto | undefined;
    impersonatorTenant: TenantLoginInfoDto | undefined;
    application: ApplicationInfoDto | undefined;
    theme: UiCustomizationSettingsDto | undefined;
}

export class GetDailySalesOutput implements IGetDailySalesOutput {
    dailySales!: number[] | undefined;

    constructor(data?: IGetDailySalesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDailySalesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDailySalesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        return data;
    }
}

export interface IGetDailySalesOutput {
    dailySales: number[] | undefined;
}

export class GetDashboardDataOutput implements IGetDashboardDataOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;
    salesSummary!: SalesSummaryData[] | undefined;
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;
    dailySales!: number[] | undefined;
    profitShares!: number[] | undefined;

    constructor(data?: IGetDashboardDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
            if (Array.isArray(_data["dailySales"])) {
                this.dailySales = [] as any;
                for (let item of _data["dailySales"])
                    this.dailySales!.push(item);
            }
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetDashboardDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (Array.isArray(this.dailySales)) {
            data["dailySales"] = [];
            for (let item of this.dailySales)
                data["dailySales"].push(item);
        }
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetDashboardDataOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
    salesSummary: SalesSummaryData[] | undefined;
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
    dailySales: number[] | undefined;
    profitShares: number[] | undefined;
}

export class GetDefaultEditionNameOutput implements IGetDefaultEditionNameOutput {
    name!: string | undefined;

    constructor(data?: IGetDefaultEditionNameOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GetDefaultEditionNameOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IGetDefaultEditionNameOutput {
    name: string | undefined;
}

export class GetEditionEditOutput implements IGetEditionEditOutput {
    edition!: EditionEditDto | undefined;
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetEditionEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : <any>undefined;
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionEditOutput {
    edition: EditionEditDto | undefined;
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetEditionTenantStatisticsOutput implements IGetEditionTenantStatisticsOutput {
    editionStatistics!: TenantEdition[] | undefined;

    constructor(data?: IGetEditionTenantStatisticsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["editionStatistics"])) {
                this.editionStatistics = [] as any;
                for (let item of _data["editionStatistics"])
                    this.editionStatistics!.push(TenantEdition.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetEditionTenantStatisticsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.editionStatistics)) {
            data["editionStatistics"] = [];
            for (let item of this.editionStatistics)
                data["editionStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetEditionTenantStatisticsOutput {
    editionStatistics: TenantEdition[] | undefined;
}

export class GetExpiringTenantsOutput implements IGetExpiringTenantsOutput {
    expiringTenants!: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount!: number;
    maxExpiringTenantsShownCount!: number;
    subscriptionEndDateStart!: DateTime;
    subscriptionEndDateEnd!: DateTime;

    constructor(data?: IGetExpiringTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expiringTenants"])) {
                this.expiringTenants = [] as any;
                for (let item of _data["expiringTenants"])
                    this.expiringTenants!.push(ExpiringTenant.fromJS(item));
            }
            this.subscriptionEndAlertDayCount = _data["subscriptionEndAlertDayCount"];
            this.maxExpiringTenantsShownCount = _data["maxExpiringTenantsShownCount"];
            this.subscriptionEndDateStart = _data["subscriptionEndDateStart"] ? DateTime.fromISO(_data["subscriptionEndDateStart"].toString()) : <any>undefined;
            this.subscriptionEndDateEnd = _data["subscriptionEndDateEnd"] ? DateTime.fromISO(_data["subscriptionEndDateEnd"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetExpiringTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpiringTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expiringTenants)) {
            data["expiringTenants"] = [];
            for (let item of this.expiringTenants)
                data["expiringTenants"].push(item.toJSON());
        }
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toString() : <any>undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toString() : <any>undefined;
        return data;
    }
}

export interface IGetExpiringTenantsOutput {
    expiringTenants: ExpiringTenant[] | undefined;
    subscriptionEndAlertDayCount: number;
    maxExpiringTenantsShownCount: number;
    subscriptionEndDateStart: DateTime;
    subscriptionEndDateEnd: DateTime;
}

export class GetGeneralStatsOutput implements IGetGeneralStatsOutput {
    transactionPercent!: number;
    newVisitPercent!: number;
    bouncePercent!: number;

    constructor(data?: IGetGeneralStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionPercent = _data["transactionPercent"];
            this.newVisitPercent = _data["newVisitPercent"];
            this.bouncePercent = _data["bouncePercent"];
        }
    }

    static fromJS(data: any): GetGeneralStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    }
}

export interface IGetGeneralStatsOutput {
    transactionPercent: number;
    newVisitPercent: number;
    bouncePercent: number;
}

export class GetIncomeStatisticsDataOutput implements IGetIncomeStatisticsDataOutput {
    incomeStatistics!: IncomeStastistic[] | undefined;

    constructor(data?: IGetIncomeStatisticsDataOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["incomeStatistics"])) {
                this.incomeStatistics = [] as any;
                for (let item of _data["incomeStatistics"])
                    this.incomeStatistics!.push(IncomeStastistic.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetIncomeStatisticsDataOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incomeStatistics)) {
            data["incomeStatistics"] = [];
            for (let item of this.incomeStatistics)
                data["incomeStatistics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetIncomeStatisticsDataOutput {
    incomeStatistics: IncomeStastistic[] | undefined;
}

export class GetIntegrationFileInputFilterDto implements IGetIntegrationFileInputFilterDto {
    states!: IntegrationLogStates[] | undefined;
    reportType!: ActivityReportType | undefined;
    from!: DateTime | undefined;
    to!: DateTime | undefined;
    systemId!: number | undefined;
    operation!: IntegrationLogActionType | undefined;
    sorting!: string | undefined;
    skipCount!: number;
    maxResultCount!: number;

    constructor(data?: IGetIntegrationFileInputFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["states"])) {
                this.states = [] as any;
                for (let item of _data["states"])
                    this.states!.push(item);
            }
            this.reportType = _data["reportType"];
            this.from = _data["from"] ? DateTime.fromISO(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? DateTime.fromISO(_data["to"].toString()) : <any>undefined;
            this.systemId = _data["systemId"];
            this.operation = _data["operation"];
            this.sorting = _data["sorting"];
            this.skipCount = _data["skipCount"];
            this.maxResultCount = _data["maxResultCount"];
        }
    }

    static fromJS(data: any): GetIntegrationFileInputFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetIntegrationFileInputFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.states)) {
            data["states"] = [];
            for (let item of this.states)
                data["states"].push(item);
        }
        data["reportType"] = this.reportType;
        data["from"] = this.from ? this.from.toString() : <any>undefined;
        data["to"] = this.to ? this.to.toString() : <any>undefined;
        data["systemId"] = this.systemId;
        data["operation"] = this.operation;
        data["sorting"] = this.sorting;
        data["skipCount"] = this.skipCount;
        data["maxResultCount"] = this.maxResultCount;
        return data;
    }
}

export interface IGetIntegrationFileInputFilterDto {
    states: IntegrationLogStates[] | undefined;
    reportType: ActivityReportType | undefined;
    from: DateTime | undefined;
    to: DateTime | undefined;
    systemId: number | undefined;
    operation: IntegrationLogActionType | undefined;
    sorting: string | undefined;
    skipCount: number;
    maxResultCount: number;
}

export class GetLanguageForEditOutput implements IGetLanguageForEditOutput {
    language!: ApplicationLanguageEditDto | undefined;
    languageNames!: ComboboxItemDto[] | undefined;
    flags!: ComboboxItemDto[] | undefined;

    constructor(data?: IGetLanguageForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"] ? ApplicationLanguageEditDto.fromJS(_data["language"]) : <any>undefined;
            if (Array.isArray(_data["languageNames"])) {
                this.languageNames = [] as any;
                for (let item of _data["languageNames"])
                    this.languageNames!.push(ComboboxItemDto.fromJS(item));
            }
            if (Array.isArray(_data["flags"])) {
                this.flags = [] as any;
                for (let item of _data["flags"])
                    this.flags!.push(ComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguageForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : <any>undefined;
        if (Array.isArray(this.languageNames)) {
            data["languageNames"] = [];
            for (let item of this.languageNames)
                data["languageNames"].push(item.toJSON());
        }
        if (Array.isArray(this.flags)) {
            data["flags"] = [];
            for (let item of this.flags)
                data["flags"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguageForEditOutput {
    language: ApplicationLanguageEditDto | undefined;
    languageNames: ComboboxItemDto[] | undefined;
    flags: ComboboxItemDto[] | undefined;
}

export class GetLanguagesOutput implements IGetLanguagesOutput {
    defaultLanguageName!: string | undefined;
    items!: ApplicationLanguageListDto[] | undefined;

    constructor(data?: IGetLanguagesOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defaultLanguageName = _data["defaultLanguageName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ApplicationLanguageListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetLanguagesOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLanguagesOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetLanguagesOutput {
    defaultLanguageName: string | undefined;
    items: ApplicationLanguageListDto[] | undefined;
}

export class GetLatestWebLogsOutput implements IGetLatestWebLogsOutput {
    latestWebLogLines!: string[] | undefined;

    constructor(data?: IGetLatestWebLogsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["latestWebLogLines"])) {
                this.latestWebLogLines = [] as any;
                for (let item of _data["latestWebLogLines"])
                    this.latestWebLogLines!.push(item);
            }
        }
    }

    static fromJS(data: any): GetLatestWebLogsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.latestWebLogLines)) {
            data["latestWebLogLines"] = [];
            for (let item of this.latestWebLogLines)
                data["latestWebLogLines"].push(item);
        }
        return data;
    }
}

export interface IGetLatestWebLogsOutput {
    latestWebLogLines: string[] | undefined;
}

export class GetMemberActivityOutput implements IGetMemberActivityOutput {
    memberActivities!: MemberActivity[] | undefined;

    constructor(data?: IGetMemberActivityOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["memberActivities"])) {
                this.memberActivities = [] as any;
                for (let item of _data["memberActivities"])
                    this.memberActivities!.push(MemberActivity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetMemberActivityOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.memberActivities)) {
            data["memberActivities"] = [];
            for (let item of this.memberActivities)
                data["memberActivities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetMemberActivityOutput {
    memberActivities: MemberActivity[] | undefined;
}

export class GetNotificationSettingsOutput implements IGetNotificationSettingsOutput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionWithDisplayNameDto[] | undefined;

    constructor(data?: IGetNotificationSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationSettingsOutput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionWithDisplayNameDto[] | undefined;
}

export class GetNotificationsOutput implements IGetNotificationsOutput {
    unreadCount!: number;
    totalCount!: number;
    items!: UserNotification[] | undefined;

    constructor(data?: IGetNotificationsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unreadCount = _data["unreadCount"];
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetNotificationsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetNotificationsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetNotificationsOutput {
    unreadCount: number;
    totalCount: number;
    items: UserNotification[] | undefined;
}

export class GetParameterForViewDto implements IGetParameterForViewDto {
    parameter!: ParameterDto | undefined;
    parameterType!: string | undefined;

    constructor(data?: IGetParameterForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : <any>undefined;
            this.parameterType = _data["parameterType"];
        }
    }

    static fromJS(data: any): GetParameterForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetParameterForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameter"] = this.parameter ? this.parameter.toJSON() : <any>undefined;
        data["parameterType"] = this.parameterType;
        return data;
    }
}

export interface IGetParameterForViewDto {
    parameter: ParameterDto | undefined;
    parameterType: string | undefined;
}

export class GetPasswordComplexitySettingOutput implements IGetPasswordComplexitySettingOutput {
    setting!: PasswordComplexitySetting | undefined;

    constructor(data?: IGetPasswordComplexitySettingOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.setting = _data["setting"] ? PasswordComplexitySetting.fromJS(_data["setting"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPasswordComplexitySettingOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPasswordComplexitySettingOutput {
    setting: PasswordComplexitySetting | undefined;
}

export class GetPendingSamplesIndicatorItemDto implements IGetPendingSamplesIndicatorItemDto {
    id!: number;
    licensePlate!: string | undefined;

    constructor(data?: IGetPendingSamplesIndicatorItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): GetPendingSamplesIndicatorItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPendingSamplesIndicatorItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface IGetPendingSamplesIndicatorItemDto {
    id: number;
    licensePlate: string | undefined;
}

export class GetPlaceForViewDto implements IGetPlaceForViewDto {
    place!: PlaceDto | undefined;
    locationId!: number;
    externalId!: number;

    constructor(data?: IGetPlaceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.place = _data["place"] ? PlaceDto.fromJS(_data["place"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): GetPlaceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlaceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IGetPlaceForViewDto {
    place: PlaceDto | undefined;
    locationId: number;
    externalId: number;
}

export class GetPreReportsToArriveOutputDto implements IGetPreReportsToArriveOutputDto {
    id!: number;
    tripNumber!: number;
    volume!: number;
    originExternalId!: number;
    originLocationType!: LocationType;
    articleExternalId!: number;
    driverExternalId!: number;
    truckExternalId!: number;
    truckPlate!: string | undefined;
    transportVendorExternalId!: number;
    standExternalId!: number;
    scheduledEntryTime!: DateTime;
    isTritrain!: boolean;

    constructor(data?: IGetPreReportsToArriveOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.tripNumber = _data["tripNumber"];
            this.volume = _data["volume"];
            this.originExternalId = _data["originExternalId"];
            this.originLocationType = _data["originLocationType"];
            this.articleExternalId = _data["articleExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.truckExternalId = _data["truckExternalId"];
            this.truckPlate = _data["truckPlate"];
            this.transportVendorExternalId = _data["transportVendorExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.isTritrain = _data["isTritrain"];
        }
    }

    static fromJS(data: any): GetPreReportsToArriveOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetPreReportsToArriveOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["tripNumber"] = this.tripNumber;
        data["volume"] = this.volume;
        data["originExternalId"] = this.originExternalId;
        data["originLocationType"] = this.originLocationType;
        data["articleExternalId"] = this.articleExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["truckExternalId"] = this.truckExternalId;
        data["truckPlate"] = this.truckPlate;
        data["transportVendorExternalId"] = this.transportVendorExternalId;
        data["standExternalId"] = this.standExternalId;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["isTritrain"] = this.isTritrain;
        return data;
    }
}

export interface IGetPreReportsToArriveOutputDto {
    id: number;
    tripNumber: number;
    volume: number;
    originExternalId: number;
    originLocationType: LocationType;
    articleExternalId: number;
    driverExternalId: number;
    truckExternalId: number;
    truckPlate: string | undefined;
    transportVendorExternalId: number;
    standExternalId: number;
    scheduledEntryTime: DateTime;
    isTritrain: boolean;
}

export class GetProfilePictureOutput implements IGetProfilePictureOutput {
    profilePicture!: string | undefined;

    constructor(data?: IGetProfilePictureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePicture = _data["profilePicture"];
        }
    }

    static fromJS(data: any): GetProfilePictureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        return data;
    }
}

export interface IGetProfilePictureOutput {
    profilePicture: string | undefined;
}

export class GetProfitShareOutput implements IGetProfitShareOutput {
    profitShares!: number[] | undefined;

    constructor(data?: IGetProfitShareOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["profitShares"])) {
                this.profitShares = [] as any;
                for (let item of _data["profitShares"])
                    this.profitShares!.push(item);
            }
        }
    }

    static fromJS(data: any): GetProfitShareOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetProfitShareOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.profitShares)) {
            data["profitShares"] = [];
            for (let item of this.profitShares)
                data["profitShares"].push(item);
        }
        return data;
    }
}

export interface IGetProfitShareOutput {
    profitShares: number[] | undefined;
}

export class GetReasonForViewDto implements IGetReasonForViewDto {
    reason!: ReasonDto | undefined;
    reasonTypeType!: string | undefined;

    constructor(data?: IGetReasonForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] ? ReasonDto.fromJS(_data["reason"]) : <any>undefined;
            this.reasonTypeType = _data["reasonTypeType"];
        }
    }

    static fromJS(data: any): GetReasonForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReasonForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        data["reasonTypeType"] = this.reasonTypeType;
        return data;
    }
}

export interface IGetReasonForViewDto {
    reason: ReasonDto | undefined;
    reasonTypeType: string | undefined;
}

export class GetReceiptStateOutputDto implements IGetReceiptStateOutputDto {
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    id!: number;

    constructor(data?: IGetReceiptStateOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): GetReceiptStateOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetReceiptStateOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["id"] = this.id;
        return data;
    }
}

export interface IGetReceiptStateOutputDto {
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    id: number;
}

export class GetRecentTenantsOutput implements IGetRecentTenantsOutput {
    recentTenantsDayCount!: number;
    maxRecentTenantsShownCount!: number;
    tenantCreationStartDate!: DateTime;
    recentTenants!: RecentTenant[] | undefined;

    constructor(data?: IGetRecentTenantsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recentTenantsDayCount = _data["recentTenantsDayCount"];
            this.maxRecentTenantsShownCount = _data["maxRecentTenantsShownCount"];
            this.tenantCreationStartDate = _data["tenantCreationStartDate"] ? DateTime.fromISO(_data["tenantCreationStartDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recentTenants"])) {
                this.recentTenants = [] as any;
                for (let item of _data["recentTenants"])
                    this.recentTenants!.push(RecentTenant.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRecentTenantsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecentTenantsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toString() : <any>undefined;
        if (Array.isArray(this.recentTenants)) {
            data["recentTenants"] = [];
            for (let item of this.recentTenants)
                data["recentTenants"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRecentTenantsOutput {
    recentTenantsDayCount: number;
    maxRecentTenantsShownCount: number;
    tenantCreationStartDate: DateTime;
    recentTenants: RecentTenant[] | undefined;
}

export class GetRegionalStatsOutput implements IGetRegionalStatsOutput {
    stats!: RegionalStatCountry[] | undefined;

    constructor(data?: IGetRegionalStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stats"])) {
                this.stats = [] as any;
                for (let item of _data["stats"])
                    this.stats!.push(RegionalStatCountry.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetRegionalStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stats)) {
            data["stats"] = [];
            for (let item of this.stats)
                data["stats"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetRegionalStatsOutput {
    stats: RegionalStatCountry[] | undefined;
}

export class GetRoleForEditOutput implements IGetRoleForEditOutput {
    role!: RoleEditDto | undefined;
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetRoleForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.role = _data["role"] ? RoleEditDto.fromJS(_data["role"]) : <any>undefined;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetRoleForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : <any>undefined;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetRoleForEditOutput {
    role: RoleEditDto | undefined;
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetSalesSummaryOutput implements IGetSalesSummaryOutput {
    totalSales!: number;
    revenue!: number;
    expenses!: number;
    growth!: number;
    salesSummary!: SalesSummaryData[] | undefined;

    constructor(data?: IGetSalesSummaryOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalSales = _data["totalSales"];
            this.revenue = _data["revenue"];
            this.expenses = _data["expenses"];
            this.growth = _data["growth"];
            if (Array.isArray(_data["salesSummary"])) {
                this.salesSummary = [] as any;
                for (let item of _data["salesSummary"])
                    this.salesSummary!.push(SalesSummaryData.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetSalesSummaryOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        if (Array.isArray(this.salesSummary)) {
            data["salesSummary"] = [];
            for (let item of this.salesSummary)
                data["salesSummary"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetSalesSummaryOutput {
    totalSales: number;
    revenue: number;
    expenses: number;
    growth: number;
    salesSummary: SalesSummaryData[] | undefined;
}

export class GetTagForViewDto implements IGetTagForViewDto {
    tag!: TagDto | undefined;
    truckType!: string | undefined;
    licensePlate!: string | undefined;

    constructor(data?: IGetTagForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tag = _data["tag"] ? TagDto.fromJS(_data["tag"]) : <any>undefined;
            this.truckType = _data["truckType"];
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): GetTagForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTagForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tag"] = this.tag ? this.tag.toJSON() : <any>undefined;
        data["truckType"] = this.truckType;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface IGetTagForViewDto {
    tag: TagDto | undefined;
    truckType: string | undefined;
    licensePlate: string | undefined;
}

export class GetTenantFeaturesEditOutput implements IGetTenantFeaturesEditOutput {
    featureValues!: NameValueDto[] | undefined;
    features!: FlatFeatureDto[] | undefined;

    constructor(data?: IGetTenantFeaturesEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(FlatFeatureDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTenantFeaturesEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetTenantFeaturesEditOutput {
    featureValues: NameValueDto[] | undefined;
    features: FlatFeatureDto[] | undefined;
}

export class GetTopStatsOutput implements IGetTopStatsOutput {
    totalProfit!: number;
    newFeedbacks!: number;
    newOrders!: number;
    newUsers!: number;

    constructor(data?: IGetTopStatsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalProfit = _data["totalProfit"];
            this.newFeedbacks = _data["newFeedbacks"];
            this.newOrders = _data["newOrders"];
            this.newUsers = _data["newUsers"];
        }
    }

    static fromJS(data: any): GetTopStatsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetTopStatsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        return data;
    }
}

export interface IGetTopStatsOutput {
    totalProfit: number;
    newFeedbacks: number;
    newOrders: number;
    newUsers: number;
}

export class GetUserChatFriendsWithSettingsOutput implements IGetUserChatFriendsWithSettingsOutput {
    serverTime!: DateTime;
    friends!: FriendDto[] | undefined;

    constructor(data?: IGetUserChatFriendsWithSettingsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serverTime = _data["serverTime"] ? DateTime.fromISO(_data["serverTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["friends"])) {
                this.friends = [] as any;
                for (let item of _data["friends"])
                    this.friends!.push(FriendDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetUserChatFriendsWithSettingsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toString() : <any>undefined;
        if (Array.isArray(this.friends)) {
            data["friends"] = [];
            for (let item of this.friends)
                data["friends"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetUserChatFriendsWithSettingsOutput {
    serverTime: DateTime;
    friends: FriendDto[] | undefined;
}

export class GetUserForEditOutput implements IGetUserForEditOutput {
    profilePictureId!: string | undefined;
    user!: UserEditDto | undefined;
    roles!: UserRoleDto[] | undefined;
    allOrganizationUnits!: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits!: string[] | undefined;

    constructor(data?: IGetUserForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profilePictureId = _data["profilePictureId"];
            this.user = _data["user"] ? UserEditDto.fromJS(_data["user"]) : <any>undefined;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserRoleDto.fromJS(item));
            }
            if (Array.isArray(_data["allOrganizationUnits"])) {
                this.allOrganizationUnits = [] as any;
                for (let item of _data["allOrganizationUnits"])
                    this.allOrganizationUnits!.push(OrganizationUnitDto.fromJS(item));
            }
            if (Array.isArray(_data["memberedOrganizationUnits"])) {
                this.memberedOrganizationUnits = [] as any;
                for (let item of _data["memberedOrganizationUnits"])
                    this.memberedOrganizationUnits!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.allOrganizationUnits)) {
            data["allOrganizationUnits"] = [];
            for (let item of this.allOrganizationUnits)
                data["allOrganizationUnits"].push(item.toJSON());
        }
        if (Array.isArray(this.memberedOrganizationUnits)) {
            data["memberedOrganizationUnits"] = [];
            for (let item of this.memberedOrganizationUnits)
                data["memberedOrganizationUnits"].push(item);
        }
        return data;
    }
}

export interface IGetUserForEditOutput {
    profilePictureId: string | undefined;
    user: UserEditDto | undefined;
    roles: UserRoleDto[] | undefined;
    allOrganizationUnits: OrganizationUnitDto[] | undefined;
    memberedOrganizationUnits: string[] | undefined;
}

export class GetUserPermissionsForEditOutput implements IGetUserPermissionsForEditOutput {
    permissions!: FlatPermissionDto[] | undefined;
    grantedPermissionNames!: string[] | undefined;

    constructor(data?: IGetUserPermissionsForEditOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(FlatPermissionDto.fromJS(item));
            }
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): GetUserPermissionsForEditOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IGetUserPermissionsForEditOutput {
    permissions: FlatPermissionDto[] | undefined;
    grantedPermissionNames: string[] | undefined;
}

export class GetWoodActivityReportsForSampleSearchOutputDto implements IGetWoodActivityReportsForSampleSearchOutputDto {
    reportId!: number;
    sampleDate!: DateTime;
    sampleType!: SampleAssignmentType;
    woodOriginExternalId!: number;
    standExternalId!: number;
    density!: number;
    originLocationType!: LocationType;

    constructor(data?: IGetWoodActivityReportsForSampleSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.sampleDate = _data["sampleDate"] ? DateTime.fromISO(_data["sampleDate"].toString()) : <any>undefined;
            this.sampleType = _data["sampleType"];
            this.woodOriginExternalId = _data["woodOriginExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.density = _data["density"];
            this.originLocationType = _data["originLocationType"];
        }
    }

    static fromJS(data: any): GetWoodActivityReportsForSampleSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWoodActivityReportsForSampleSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["sampleDate"] = this.sampleDate ? this.sampleDate.toString() : <any>undefined;
        data["sampleType"] = this.sampleType;
        data["woodOriginExternalId"] = this.woodOriginExternalId;
        data["standExternalId"] = this.standExternalId;
        data["density"] = this.density;
        data["originLocationType"] = this.originLocationType;
        return data;
    }
}

export interface IGetWoodActivityReportsForSampleSearchOutputDto {
    reportId: number;
    sampleDate: DateTime;
    sampleType: SampleAssignmentType;
    woodOriginExternalId: number;
    standExternalId: number;
    density: number;
    originLocationType: LocationType;
}

export class GetWoodControlActivityReportExternalProcessingResultForViewDto implements IGetWoodControlActivityReportExternalProcessingResultForViewDto {
    activityReportId!: number;
    externalActivityReportId!: number;
    state!: ExternalProcessingStateFilter;
    activityReportType!: ActivityReportType;
    resultDetail!: string | undefined;
    entryDate!: DateTime;

    constructor(data?: IGetWoodControlActivityReportExternalProcessingResultForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.state = _data["state"];
            this.activityReportType = _data["activityReportType"];
            this.resultDetail = _data["resultDetail"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetWoodControlActivityReportExternalProcessingResultForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetWoodControlActivityReportExternalProcessingResultForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["state"] = this.state;
        data["activityReportType"] = this.activityReportType;
        data["resultDetail"] = this.resultDetail;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        return data;
    }
}

export interface IGetWoodControlActivityReportExternalProcessingResultForViewDto {
    activityReportId: number;
    externalActivityReportId: number;
    state: ExternalProcessingStateFilter;
    activityReportType: ActivityReportType;
    resultDetail: string | undefined;
    entryDate: DateTime;
}

export class GoogleExternalLoginProviderSettings implements IGoogleExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    userInfoEndpoint!: string | undefined;

    constructor(data?: IGoogleExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.userInfoEndpoint = _data["userInfoEndpoint"];
        }
    }

    static fromJS(data: any): GoogleExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new GoogleExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["userInfoEndpoint"] = this.userInfoEndpoint;
        return data;
    }
}

export interface IGoogleExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    userInfoEndpoint: string | undefined;
}

export class HasAbortedSpeedScannerResultOutputDto implements IHasAbortedSpeedScannerResultOutputDto {
    hasAbortedSpeedScannerResult!: boolean;
    shouldSendEmail!: boolean;

    constructor(data?: IHasAbortedSpeedScannerResultOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasAbortedSpeedScannerResult = _data["hasAbortedSpeedScannerResult"];
            this.shouldSendEmail = _data["shouldSendEmail"];
        }
    }

    static fromJS(data: any): HasAbortedSpeedScannerResultOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new HasAbortedSpeedScannerResultOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasAbortedSpeedScannerResult"] = this.hasAbortedSpeedScannerResult;
        data["shouldSendEmail"] = this.shouldSendEmail;
        return data;
    }
}

export interface IHasAbortedSpeedScannerResultOutputDto {
    hasAbortedSpeedScannerResult: boolean;
    shouldSendEmail: boolean;
}

export class HasLeavingReportOutputDto implements IHasLeavingReportOutputDto {
    hasLeavingReport!: boolean;
    reportId!: number | undefined;
    type!: ActivityReportType | undefined;

    constructor(data?: IHasLeavingReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasLeavingReport = _data["hasLeavingReport"];
            this.reportId = _data["reportId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): HasLeavingReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new HasLeavingReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasLeavingReport"] = this.hasLeavingReport;
        data["reportId"] = this.reportId;
        data["type"] = this.type;
        return data;
    }
}

export interface IHasLeavingReportOutputDto {
    hasLeavingReport: boolean;
    reportId: number | undefined;
    type: ActivityReportType | undefined;
}

export class HealthCheckContext implements IHealthCheckContext {
    registration!: HealthCheckRegistration | undefined;

    constructor(data?: IHealthCheckContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registration = _data["registration"] ? HealthCheckRegistration.fromJS(_data["registration"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthCheckContext {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registration"] = this.registration ? this.registration.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHealthCheckContext {
    registration: HealthCheckRegistration | undefined;
}

export class HealthCheckRegistration implements IHealthCheckRegistration {
    factory!: FuncOfIServiceProviderIHealthCheck | undefined;
    failureStatus!: HealthStatus;
    timeout!: string;
    delay!: string | undefined;
    period!: string | undefined;
    name!: string | undefined;
    tags!: string[] | undefined;

    constructor(data?: IHealthCheckRegistration) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factory = _data["factory"] ? FuncOfIServiceProviderIHealthCheck.fromJS(_data["factory"]) : <any>undefined;
            this.failureStatus = _data["failureStatus"];
            this.timeout = _data["timeout"];
            this.delay = _data["delay"];
            this.period = _data["period"];
            this.name = _data["name"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): HealthCheckRegistration {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckRegistration();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factory"] = this.factory ? this.factory.toJSON() : <any>undefined;
        data["failureStatus"] = this.failureStatus;
        data["timeout"] = this.timeout;
        data["delay"] = this.delay;
        data["period"] = this.period;
        data["name"] = this.name;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IHealthCheckRegistration {
    factory: FuncOfIServiceProviderIHealthCheck | undefined;
    failureStatus: HealthStatus;
    timeout: string;
    delay: string | undefined;
    period: string | undefined;
    name: string | undefined;
    tags: string[] | undefined;
}

export class HealthCheckResult implements IHealthCheckResult {
    data!: { [key: string]: any; } | undefined;
    description!: string | undefined;
    exception!: any | undefined;
    status!: HealthStatus;

    constructor(data?: IHealthCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.description = _data["description"];
            this.exception = _data["exception"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): HealthCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["description"] = this.description;
        data["exception"] = this.exception;
        data["status"] = this.status;
        return data;
    }
}

export interface IHealthCheckResult {
    data: { [key: string]: any; } | undefined;
    description: string | undefined;
    exception: any | undefined;
    status: HealthStatus;
}

export enum HealthStatus {
    Unhealthy = "Unhealthy",
    Degraded = "Degraded",
    Healthy = "Healthy",
}

export class HostBillingSettingsEditDto implements IHostBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;

    constructor(data?: IHostBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
        }
    }

    static fromJS(data: any): HostBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    }
}

export interface IHostBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
}

export class HostSettingsEditDto implements IHostSettingsEditDto {
    general!: GeneralSettingsEditDto;
    userManagement!: HostUserManagementSettingsEditDto;
    email!: EmailSettingsEditDto;
    tenantManagement!: TenantManagementSettingsEditDto;
    security!: SecuritySettingsEditDto;
    billing!: HostBillingSettingsEditDto | undefined;
    otherSettings!: OtherSettingsEditDto | undefined;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto | undefined;

    constructor(data?: IHostSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = _data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = _data["email"] ? EmailSettingsEditDto.fromJS(_data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = _data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(_data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? HostBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? OtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostSettingsEditDto {
    general: GeneralSettingsEditDto;
    userManagement: HostUserManagementSettingsEditDto;
    email: EmailSettingsEditDto;
    tenantManagement: TenantManagementSettingsEditDto;
    security: SecuritySettingsEditDto;
    billing: HostBillingSettingsEditDto | undefined;
    otherSettings: OtherSettingsEditDto | undefined;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto | undefined;
}

export class HostUserManagementSettingsEditDto implements IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin!: boolean;
    smsVerificationEnabled!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    useCaptchaOnLogin!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto | undefined;

    constructor(data?: IHostUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = _data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HostUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHostUserManagementSettingsEditDto {
    isEmailConfirmationRequiredForLogin: boolean;
    smsVerificationEnabled: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    useCaptchaOnLogin: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto | undefined;
}

export class ICustomAttributeProvider implements IICustomAttributeProvider {

    constructor(data?: IICustomAttributeProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ICustomAttributeProvider {
        data = typeof data === 'object' ? data : {};
        let result = new ICustomAttributeProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IICustomAttributeProvider {
}

export class IInputType implements IIInputType {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;
    validator!: IValueValidator | undefined;

    constructor(data?: IIInputType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
            this.validator = _data["validator"] ? IValueValidator.fromJS(_data["validator"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IInputType {
        data = typeof data === 'object' ? data : {};
        let result = new IInputType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIInputType {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
    validator: IValueValidator | undefined;
}

export class ImpersonatedAuthenticateResultModel implements IImpersonatedAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IImpersonatedAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): ImpersonatedAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IImpersonatedAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class ImpersonateInput implements IImpersonateInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IImpersonateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): ImpersonateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IImpersonateInput {
    tenantId: number | undefined;
    userId: number;
}

export class ImpersonateOutput implements IImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: IImpersonateOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.impersonationToken = _data["impersonationToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): ImpersonateOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ImpersonateOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IImpersonateOutput {
    impersonationToken: string | undefined;
    tenancyName: string | undefined;
}

export class IncomeStastistic implements IIncomeStastistic {
    label!: string | undefined;
    date!: DateTime;
    amount!: number;

    constructor(data?: IIncomeStastistic) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): IncomeStastistic {
        data = typeof data === 'object' ? data : {};
        let result = new IncomeStastistic();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IIncomeStastistic {
    label: string | undefined;
    date: DateTime;
    amount: number;
}

export class IndicatorsConfForArchimedesReceiptDto implements IIndicatorsConfForArchimedesReceiptDto {
    items!: WoodReceiptForArchimedesIndicatorOutputDto[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IIndicatorsConfForArchimedesReceiptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodReceiptForArchimedesIndicatorOutputDto.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): IndicatorsConfForArchimedesReceiptDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorsConfForArchimedesReceiptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IIndicatorsConfForArchimedesReceiptDto {
    items: WoodReceiptForArchimedesIndicatorOutputDto[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class IndicatorsDto implements IIndicatorsDto {
    name!: string | undefined;
    code!: string | undefined;
    maximumTreshold!: number;
    minimumThreshold!: number;
    targetValue!: number;
    type!: IndicatorTypes;
    parameterValue!: number;
    parameterValueDescription!: string | undefined;
    id!: number;

    constructor(data?: IIndicatorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.code = _data["code"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.targetValue = _data["targetValue"];
            this.type = _data["type"];
            this.parameterValue = _data["parameterValue"];
            this.parameterValueDescription = _data["parameterValueDescription"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IndicatorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["code"] = this.code;
        data["maximumTreshold"] = this.maximumTreshold;
        data["minimumThreshold"] = this.minimumThreshold;
        data["targetValue"] = this.targetValue;
        data["type"] = this.type;
        data["parameterValue"] = this.parameterValue;
        data["parameterValueDescription"] = this.parameterValueDescription;
        data["id"] = this.id;
        return data;
    }
}

export interface IIndicatorsDto {
    name: string | undefined;
    code: string | undefined;
    maximumTreshold: number;
    minimumThreshold: number;
    targetValue: number;
    type: IndicatorTypes;
    parameterValue: number;
    parameterValueDescription: string | undefined;
    id: number;
}

export class IndicatorsWoodActivityReportDto implements IIndicatorsWoodActivityReportDto {
    id!: number;
    woodActivityReportLines!: IndicatorsWoodActivityReportLineDto[] | undefined;
    date!: DateTime;
    vehicleExternalId!: number;
    resourceTypeExternalIdentityId!: number;

    constructor(data?: IIndicatorsWoodActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["woodActivityReportLines"])) {
                this.woodActivityReportLines = [] as any;
                for (let item of _data["woodActivityReportLines"])
                    this.woodActivityReportLines!.push(IndicatorsWoodActivityReportLineDto.fromJS(item));
            }
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.resourceTypeExternalIdentityId = _data["resourceTypeExternalIdentityId"];
        }
    }

    static fromJS(data: any): IndicatorsWoodActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorsWoodActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.woodActivityReportLines)) {
            data["woodActivityReportLines"] = [];
            for (let item of this.woodActivityReportLines)
                data["woodActivityReportLines"].push(item.toJSON());
        }
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["resourceTypeExternalIdentityId"] = this.resourceTypeExternalIdentityId;
        return data;
    }
}

export interface IIndicatorsWoodActivityReportDto {
    id: number;
    woodActivityReportLines: IndicatorsWoodActivityReportLineDto[] | undefined;
    date: DateTime;
    vehicleExternalId: number;
    resourceTypeExternalIdentityId: number;
}

export class IndicatorsWoodActivityReportLineDto implements IIndicatorsWoodActivityReportLineDto {
    articleExternalId!: number;

    constructor(data?: IIndicatorsWoodActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleExternalId = _data["articleExternalId"];
        }
    }

    static fromJS(data: any): IndicatorsWoodActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new IndicatorsWoodActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleExternalId"] = this.articleExternalId;
        return data;
    }
}

export interface IIndicatorsWoodActivityReportLineDto {
    articleExternalId: number;
}

export enum IndicatorTypes {
    GAUGE = "GAUGE",
}

export class InPlaceReceiptOutputDto implements IInPlaceReceiptOutputDto {
    reportId!: number;
    reportType!: ActivityReportType;
    state!: ActivityReportState;
    condition!: ActivityReportStateCondition;
    error!: boolean;
    errorMessage!: string | undefined;
    licensePlate!: string | undefined;
    driverExternalId!: number;
    grossWeight!: number;

    constructor(data?: IInPlaceReceiptOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportType = _data["reportType"];
            this.state = _data["state"];
            this.condition = _data["condition"];
            this.error = _data["error"];
            this.errorMessage = _data["errorMessage"];
            this.licensePlate = _data["licensePlate"];
            this.driverExternalId = _data["driverExternalId"];
            this.grossWeight = _data["grossWeight"];
        }
    }

    static fromJS(data: any): InPlaceReceiptOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InPlaceReceiptOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportType"] = this.reportType;
        data["state"] = this.state;
        data["condition"] = this.condition;
        data["error"] = this.error;
        data["errorMessage"] = this.errorMessage;
        data["licensePlate"] = this.licensePlate;
        data["driverExternalId"] = this.driverExternalId;
        data["grossWeight"] = this.grossWeight;
        return data;
    }
}

export interface IInPlaceReceiptOutputDto {
    reportId: number;
    reportType: ActivityReportType;
    state: ActivityReportState;
    condition: ActivityReportStateCondition;
    error: boolean;
    errorMessage: string | undefined;
    licensePlate: string | undefined;
    driverExternalId: number;
    grossWeight: number;
}

export class InstallDto implements IInstallDto {
    connectionString!: string;
    adminPassword!: string;
    webSiteUrl!: string;
    serverUrl!: string | undefined;
    defaultLanguage!: string;
    smtpSettings!: EmailSettingsEditDto | undefined;
    billInfo!: HostBillingSettingsEditDto | undefined;

    constructor(data?: IInstallDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectionString = _data["connectionString"];
            this.adminPassword = _data["adminPassword"];
            this.webSiteUrl = _data["webSiteUrl"];
            this.serverUrl = _data["serverUrl"];
            this.defaultLanguage = _data["defaultLanguage"];
            this.smtpSettings = _data["smtpSettings"] ? EmailSettingsEditDto.fromJS(_data["smtpSettings"]) : <any>undefined;
            this.billInfo = _data["billInfo"] ? HostBillingSettingsEditDto.fromJS(_data["billInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InstallDto {
        data = typeof data === 'object' ? data : {};
        let result = new InstallDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : <any>undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInstallDto {
    connectionString: string;
    adminPassword: string;
    webSiteUrl: string;
    serverUrl: string | undefined;
    defaultLanguage: string;
    smtpSettings: EmailSettingsEditDto | undefined;
    billInfo: HostBillingSettingsEditDto | undefined;
}

export class IntegrationByExecutionOutputDto implements IIntegrationByExecutionOutputDto {
    executionId!: string;
    reportId!: number;
    reportType!: ActivityReportType;
    integrationId!: number;

    constructor(data?: IIntegrationByExecutionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executionId = _data["executionId"];
            this.reportId = _data["reportId"];
            this.reportType = _data["reportType"];
            this.integrationId = _data["integrationId"];
        }
    }

    static fromJS(data: any): IntegrationByExecutionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationByExecutionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executionId"] = this.executionId;
        data["reportId"] = this.reportId;
        data["reportType"] = this.reportType;
        data["integrationId"] = this.integrationId;
        return data;
    }
}

export interface IIntegrationByExecutionOutputDto {
    executionId: string;
    reportId: number;
    reportType: ActivityReportType;
    integrationId: number;
}

export class IntegrationConfigurationDto implements IIntegrationConfigurationDto {
    travelManagementOn!: ActualState;
    yardManagementOn!: ActualState;
    sicfeState!: ActualState;
    sigeState!: ActualState;
    jaumeSereState!: ActualState;
    alutelState!: ActualState;
    smartLogyardState!: ActualState;
    smartLogyardMultisiteState!: ActualState;
    smartInvoicingState!: ActualState;

    constructor(data?: IIntegrationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.travelManagementOn = _data["travelManagementOn"];
            this.yardManagementOn = _data["yardManagementOn"];
            this.sicfeState = _data["sicfeState"];
            this.sigeState = _data["sigeState"];
            this.jaumeSereState = _data["jaumeSereState"];
            this.alutelState = _data["alutelState"];
            this.smartLogyardState = _data["smartLogyardState"];
            this.smartLogyardMultisiteState = _data["smartLogyardMultisiteState"];
            this.smartInvoicingState = _data["smartInvoicingState"];
        }
    }

    static fromJS(data: any): IntegrationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["travelManagementOn"] = this.travelManagementOn;
        data["yardManagementOn"] = this.yardManagementOn;
        data["sicfeState"] = this.sicfeState;
        data["sigeState"] = this.sigeState;
        data["jaumeSereState"] = this.jaumeSereState;
        data["alutelState"] = this.alutelState;
        data["smartLogyardState"] = this.smartLogyardState;
        data["smartLogyardMultisiteState"] = this.smartLogyardMultisiteState;
        data["smartInvoicingState"] = this.smartInvoicingState;
        return data;
    }
}

export interface IIntegrationConfigurationDto {
    travelManagementOn: ActualState;
    yardManagementOn: ActualState;
    sicfeState: ActualState;
    sigeState: ActualState;
    jaumeSereState: ActualState;
    alutelState: ActualState;
    smartLogyardState: ActualState;
    smartLogyardMultisiteState: ActualState;
    smartInvoicingState: ActualState;
}

export enum IntegrationLogActionType {
    BioforestIntegrationReport = "BioforestIntegrationReport",
    BioforestDeleteReport = "BioforestDeleteReport",
    LogmeterExecution = "LogmeterExecution",
    SdaExecute2 = "SdaExecute2",
    SdaExecute3 = "SdaExecute3",
    SdaExecute5 = "SdaExecute5",
    CheckTurn = "CheckTurn",
    SigeExecution = "SigeExecution",
    SmartripTravelArrival = "SmartripTravelArrival",
    SmartripUpdateInvoice = "SmartripUpdateInvoice",
    Semaphore = "Semaphore",
    ElectronicReport = "ElectronicReport",
    JySCallback = "JySCallback",
    Scanner = "Scanner",
    SdaCompleteSample = "SdaCompleteSample",
    GetInternalDestination = "GetInternalDestination",
    BioforestUpdateReport = "BioforestUpdateReport",
    SmartripTravelLoaded = "SmartripTravelLoaded",
    SendWoodInformativeEmailToProviders = "SendWoodInformativeEmailToProviders",
    SendWoodInformativeEmailToTransportVendors = "SendWoodInformativeEmailToTransportVendors",
    SendWoodInformativeEmailToLoaderVendors = "SendWoodInformativeEmailToLoaderVendors",
    SendWoodScannerSpeedAbortedEmail = "SendWoodScannerSpeedAbortedEmail",
    SendWoodSingleCustomsDeclarationWarningEmail = "SendWoodSingleCustomsDeclarationWarningEmail",
    SendSampleInformationToScanner = "SendSampleInformationToScanner",
    SendPolygonValidationEmail = "SendPolygonValidationEmail",
    SendUpdateLogyardLoadActivityReport = "SendUpdateLogyardLoadActivityReport",
    SmartInvoicingIntegration = "SmartInvoicingIntegration",
}

export class IntegrationLogOutputItem implements IIntegrationLogOutputItem {
    id!: number;
    state!: IntegrationLogStates;
    date!: DateTime;
    lastExecution!: DateTime | undefined;
    automaticRetry!: boolean;
    message!: string | undefined;
    operation!: IntegrationLogActionType;
    resultCode!: string | undefined;
    attempts!: number;
    reportType!: ActivityReportType | undefined;
    reportId!: number;

    constructor(data?: IIntegrationLogOutputItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.lastExecution = _data["lastExecution"] ? DateTime.fromISO(_data["lastExecution"].toString()) : <any>undefined;
            this.automaticRetry = _data["automaticRetry"];
            this.message = _data["message"];
            this.operation = _data["operation"];
            this.resultCode = _data["resultCode"];
            this.attempts = _data["attempts"];
            this.reportType = _data["reportType"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): IntegrationLogOutputItem {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationLogOutputItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["lastExecution"] = this.lastExecution ? this.lastExecution.toString() : <any>undefined;
        data["automaticRetry"] = this.automaticRetry;
        data["message"] = this.message;
        data["operation"] = this.operation;
        data["resultCode"] = this.resultCode;
        data["attempts"] = this.attempts;
        data["reportType"] = this.reportType;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IIntegrationLogOutputItem {
    id: number;
    state: IntegrationLogStates;
    date: DateTime;
    lastExecution: DateTime | undefined;
    automaticRetry: boolean;
    message: string | undefined;
    operation: IntegrationLogActionType;
    resultCode: string | undefined;
    attempts: number;
    reportType: ActivityReportType | undefined;
    reportId: number;
}

export class IntegrationLogOutputList implements IIntegrationLogOutputList {
    isSelectableToRetry!: boolean;
    isCancelable!: boolean;
    isOk!: boolean;
    isError!: boolean;
    isPending!: boolean;
    isExecuting!: boolean;
    statusDescription!: string | undefined;
    systemName!: string | undefined;
    log!: IntegrationLogOutputItem | undefined;
    activityReportId!: number;
    activityReportType!: ActivityReportType;
    isLogyardIntegration!: boolean;
    operation!: IntegrationLogActionType;

    constructor(data?: IIntegrationLogOutputList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSelectableToRetry = _data["isSelectableToRetry"];
            this.isCancelable = _data["isCancelable"];
            this.isOk = _data["isOk"];
            this.isError = _data["isError"];
            this.isPending = _data["isPending"];
            this.isExecuting = _data["isExecuting"];
            this.statusDescription = _data["statusDescription"];
            this.systemName = _data["systemName"];
            this.log = _data["log"] ? IntegrationLogOutputItem.fromJS(_data["log"]) : <any>undefined;
            this.activityReportId = _data["activityReportId"];
            this.activityReportType = _data["activityReportType"];
            this.isLogyardIntegration = _data["isLogyardIntegration"];
            this.operation = _data["operation"];
        }
    }

    static fromJS(data: any): IntegrationLogOutputList {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationLogOutputList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSelectableToRetry"] = this.isSelectableToRetry;
        data["isCancelable"] = this.isCancelable;
        data["isOk"] = this.isOk;
        data["isError"] = this.isError;
        data["isPending"] = this.isPending;
        data["isExecuting"] = this.isExecuting;
        data["statusDescription"] = this.statusDescription;
        data["systemName"] = this.systemName;
        data["log"] = this.log ? this.log.toJSON() : <any>undefined;
        data["activityReportId"] = this.activityReportId;
        data["activityReportType"] = this.activityReportType;
        data["isLogyardIntegration"] = this.isLogyardIntegration;
        data["operation"] = this.operation;
        return data;
    }
}

export interface IIntegrationLogOutputList {
    isSelectableToRetry: boolean;
    isCancelable: boolean;
    isOk: boolean;
    isError: boolean;
    isPending: boolean;
    isExecuting: boolean;
    statusDescription: string | undefined;
    systemName: string | undefined;
    log: IntegrationLogOutputItem | undefined;
    activityReportId: number;
    activityReportType: ActivityReportType;
    isLogyardIntegration: boolean;
    operation: IntegrationLogActionType;
}

export enum IntegrationLogStates {
    Ok = "Ok",
    Error = "Error",
    Pending = "Pending",
    Executing = "Executing",
}

export class IntegrationValuesOutputDto implements IIntegrationValuesOutputDto {
    placeId!: number;
    type!: PlaceExternalIntegrationsType;
    sicfeValues!: SicfeValuesDto | undefined;
    sdaValues!: SDAValuesDto | undefined;
    jaumeSereValues!: JaumeSereValueDto | undefined;
    sigeValues!: SigeValuesDto | undefined;
    alutelValues!: AlutelValuesDto | undefined;
    smartripValues!: SmartripValuesDto | undefined;
    smartLogyardValues!: SmartLogyardValuesDto | undefined;
    smartLogyardMultisiteValues!: SmartLogyardMultisiteValuesDto | undefined;
    smartInvoicingValues!: SmartInvoicingValuesDto | undefined;
    id!: number;

    constructor(data?: IIntegrationValuesOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.type = _data["type"];
            this.sicfeValues = _data["sicfeValues"] ? SicfeValuesDto.fromJS(_data["sicfeValues"]) : <any>undefined;
            this.sdaValues = _data["sdaValues"] ? SDAValuesDto.fromJS(_data["sdaValues"]) : <any>undefined;
            this.jaumeSereValues = _data["jaumeSereValues"] ? JaumeSereValueDto.fromJS(_data["jaumeSereValues"]) : <any>undefined;
            this.sigeValues = _data["sigeValues"] ? SigeValuesDto.fromJS(_data["sigeValues"]) : <any>undefined;
            this.alutelValues = _data["alutelValues"] ? AlutelValuesDto.fromJS(_data["alutelValues"]) : <any>undefined;
            this.smartripValues = _data["smartripValues"] ? SmartripValuesDto.fromJS(_data["smartripValues"]) : <any>undefined;
            this.smartLogyardValues = _data["smartLogyardValues"] ? SmartLogyardValuesDto.fromJS(_data["smartLogyardValues"]) : <any>undefined;
            this.smartLogyardMultisiteValues = _data["smartLogyardMultisiteValues"] ? SmartLogyardMultisiteValuesDto.fromJS(_data["smartLogyardMultisiteValues"]) : <any>undefined;
            this.smartInvoicingValues = _data["smartInvoicingValues"] ? SmartInvoicingValuesDto.fromJS(_data["smartInvoicingValues"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IntegrationValuesOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new IntegrationValuesOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["type"] = this.type;
        data["sicfeValues"] = this.sicfeValues ? this.sicfeValues.toJSON() : <any>undefined;
        data["sdaValues"] = this.sdaValues ? this.sdaValues.toJSON() : <any>undefined;
        data["jaumeSereValues"] = this.jaumeSereValues ? this.jaumeSereValues.toJSON() : <any>undefined;
        data["sigeValues"] = this.sigeValues ? this.sigeValues.toJSON() : <any>undefined;
        data["alutelValues"] = this.alutelValues ? this.alutelValues.toJSON() : <any>undefined;
        data["smartripValues"] = this.smartripValues ? this.smartripValues.toJSON() : <any>undefined;
        data["smartLogyardValues"] = this.smartLogyardValues ? this.smartLogyardValues.toJSON() : <any>undefined;
        data["smartLogyardMultisiteValues"] = this.smartLogyardMultisiteValues ? this.smartLogyardMultisiteValues.toJSON() : <any>undefined;
        data["smartInvoicingValues"] = this.smartInvoicingValues ? this.smartInvoicingValues.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IIntegrationValuesOutputDto {
    placeId: number;
    type: PlaceExternalIntegrationsType;
    sicfeValues: SicfeValuesDto | undefined;
    sdaValues: SDAValuesDto | undefined;
    jaumeSereValues: JaumeSereValueDto | undefined;
    sigeValues: SigeValuesDto | undefined;
    alutelValues: AlutelValuesDto | undefined;
    smartripValues: SmartripValuesDto | undefined;
    smartLogyardValues: SmartLogyardValuesDto | undefined;
    smartLogyardMultisiteValues: SmartLogyardMultisiteValuesDto | undefined;
    smartInvoicingValues: SmartInvoicingValuesDto | undefined;
    id: number;
}

export class InternalCounterTripMonitorDto implements IInternalCounterTripMonitorDto {
    internalInPlant!: number;
    internalDispatched!: number;

    constructor(data?: IInternalCounterTripMonitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalInPlant = _data["internalInPlant"];
            this.internalDispatched = _data["internalDispatched"];
        }
    }

    static fromJS(data: any): InternalCounterTripMonitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalCounterTripMonitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalInPlant"] = this.internalInPlant;
        data["internalDispatched"] = this.internalDispatched;
        return data;
    }
}

export interface IInternalCounterTripMonitorDto {
    internalInPlant: number;
    internalDispatched: number;
}

export class InternalDestinationDto implements IInternalDestinationDto {
    name!: string | undefined;
    externalId!: number;
    id!: number;

    constructor(data?: IInternalDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): InternalDestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalDestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["id"] = this.id;
        return data;
    }
}

export interface IInternalDestinationDto {
    name: string | undefined;
    externalId: number;
    id: number;
}

export class InternalDestinationOutput implements IInternalDestinationOutput {
    reportId!: number;
    id!: number;
    name!: string | undefined;
    externalId!: number;

    constructor(data?: IInternalDestinationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): InternalDestinationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new InternalDestinationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["id"] = this.id;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IInternalDestinationOutput {
    reportId: number;
    id: number;
    name: string | undefined;
    externalId: number;
}

export class InternalMovementActivityReportLineInputDto implements IInternalMovementActivityReportLineInputDto {
    article!: ExternalArticleDto | undefined;
    contract!: ExternalContractDto | undefined;

    constructor(data?: IInternalMovementActivityReportLineInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.article = _data["article"] ? ExternalArticleDto.fromJS(_data["article"]) : <any>undefined;
            this.contract = _data["contract"] ? ExternalContractDto.fromJS(_data["contract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InternalMovementActivityReportLineInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementActivityReportLineInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInternalMovementActivityReportLineInputDto {
    article: ExternalArticleDto | undefined;
    contract: ExternalContractDto | undefined;
}

export class InternalMovementActivityReportLineOutputDto implements IInternalMovementActivityReportLineOutputDto {
    contract!: ContractOutputDto | undefined;
    article!: ArticleOutputDto | undefined;

    constructor(data?: IInternalMovementActivityReportLineOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractOutputDto.fromJS(_data["contract"]) : <any>undefined;
            this.article = _data["article"] ? ArticleOutputDto.fromJS(_data["article"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InternalMovementActivityReportLineOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementActivityReportLineOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInternalMovementActivityReportLineOutputDto {
    contract: ContractOutputDto | undefined;
    article: ArticleOutputDto | undefined;
}

export class InternalMovementActivityReportOutputDto implements IInternalMovementActivityReportOutputDto {
    id!: number;
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    originExternalId!: number;
    originType!: LocationType | undefined;
    destinationExternalId!: number;
    destinationType!: LocationType | undefined;
    vehicleExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleVendorExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    activityReportLines!: InternalMovementActivityReportLineOutputDto[] | undefined;
    serial!: string | undefined;
    number!: number | undefined;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    netWeight!: number;
    isAutomatic!: boolean;
    comment!: string | undefined;
    isDeleted!: boolean;
    reportDate!: DateTime;
    exitDate!: DateTime;
    entryDate!: DateTime;
    entryZoneId!: number | undefined;
    exitZoneId!: number | undefined;
    placeId!: number;

    constructor(data?: IInternalMovementActivityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(InternalMovementActivityReportLineOutputDto.fromJS(item));
            }
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.isAutomatic = _data["isAutomatic"];
            this.comment = _data["comment"];
            this.isDeleted = _data["isDeleted"];
            this.reportDate = _data["reportDate"] ? DateTime.fromISO(_data["reportDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): InternalMovementActivityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementActivityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["isAutomatic"] = this.isAutomatic;
        data["comment"] = this.comment;
        data["isDeleted"] = this.isDeleted;
        data["reportDate"] = this.reportDate ? this.reportDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IInternalMovementActivityReportOutputDto {
    id: number;
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    originExternalId: number;
    originType: LocationType | undefined;
    destinationExternalId: number;
    destinationType: LocationType | undefined;
    vehicleExternalId: number;
    vehicleLicensePlate: string | undefined;
    vehicleVendorExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    activityReportLines: InternalMovementActivityReportLineOutputDto[] | undefined;
    serial: string | undefined;
    number: number | undefined;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    netWeight: number;
    isAutomatic: boolean;
    comment: string | undefined;
    isDeleted: boolean;
    reportDate: DateTime;
    exitDate: DateTime;
    entryDate: DateTime;
    entryZoneId: number | undefined;
    exitZoneId: number | undefined;
    placeId: number;
}

export class InternalMovementArticleOutputDto implements IInternalMovementArticleOutputDto {
    id!: number;
    name!: string | undefined;
    externalId!: number;
    isActive!: boolean;

    constructor(data?: IInternalMovementArticleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): InternalMovementArticleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementArticleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IInternalMovementArticleOutputDto {
    id: number;
    name: string | undefined;
    externalId: number;
    isActive: boolean;
}

export class InternalMovementPreActivityReportEditionInput implements IInternalMovementPreActivityReportEditionInput {
    id!: number;
    newDriverExternalId!: number;
    newDriverVendorExternalId!: number;
    newDriverUserName!: string | undefined;
    newDate!: DateTime;
    newLines!: InternalMovementActivityReportLineInputDto[] | undefined;
    newErrors!: PreActivityReportErrorDto[] | undefined;
    newPreReportStatus!: PreActivityReportValidation;

    constructor(data?: IInternalMovementPreActivityReportEditionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newDriverExternalId = _data["newDriverExternalId"];
            this.newDriverVendorExternalId = _data["newDriverVendorExternalId"];
            this.newDriverUserName = _data["newDriverUserName"];
            this.newDate = _data["newDate"] ? DateTime.fromISO(_data["newDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["newLines"])) {
                this.newLines = [] as any;
                for (let item of _data["newLines"])
                    this.newLines!.push(InternalMovementActivityReportLineInputDto.fromJS(item));
            }
            if (Array.isArray(_data["newErrors"])) {
                this.newErrors = [] as any;
                for (let item of _data["newErrors"])
                    this.newErrors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.newPreReportStatus = _data["newPreReportStatus"];
        }
    }

    static fromJS(data: any): InternalMovementPreActivityReportEditionInput {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementPreActivityReportEditionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newDriverExternalId"] = this.newDriverExternalId;
        data["newDriverVendorExternalId"] = this.newDriverVendorExternalId;
        data["newDriverUserName"] = this.newDriverUserName;
        data["newDate"] = this.newDate ? this.newDate.toString() : <any>undefined;
        if (Array.isArray(this.newLines)) {
            data["newLines"] = [];
            for (let item of this.newLines)
                data["newLines"].push(item.toJSON());
        }
        if (Array.isArray(this.newErrors)) {
            data["newErrors"] = [];
            for (let item of this.newErrors)
                data["newErrors"].push(item.toJSON());
        }
        data["newPreReportStatus"] = this.newPreReportStatus;
        return data;
    }
}

export interface IInternalMovementPreActivityReportEditionInput {
    id: number;
    newDriverExternalId: number;
    newDriverVendorExternalId: number;
    newDriverUserName: string | undefined;
    newDate: DateTime;
    newLines: InternalMovementActivityReportLineInputDto[] | undefined;
    newErrors: PreActivityReportErrorDto[] | undefined;
    newPreReportStatus: PreActivityReportValidation;
}

export class InternalMovementPreActivityReportForEditionInfo implements IInternalMovementPreActivityReportForEditionInfo {
    id!: number;
    externalVehicleId!: number;
    placeId!: number;

    constructor(data?: IInternalMovementPreActivityReportForEditionInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalVehicleId = _data["externalVehicleId"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): InternalMovementPreActivityReportForEditionInfo {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementPreActivityReportForEditionInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalVehicleId"] = this.externalVehicleId;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IInternalMovementPreActivityReportForEditionInfo {
    id: number;
    externalVehicleId: number;
    placeId: number;
}

export class InternalMovementPreActivityReportSearchOutputDto implements IInternalMovementPreActivityReportSearchOutputDto {
    id!: number;
    externalDriverId!: number;
    externalTruckId!: number;
    externalOriginId!: number;
    originType!: LocationType;
    externalDestinationId!: number;
    destinationType!: LocationType;
    externalArticleId!: number;
    validationResult!: PreActivityReportValidation;

    constructor(data?: IInternalMovementPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalDriverId = _data["externalDriverId"];
            this.externalTruckId = _data["externalTruckId"];
            this.externalOriginId = _data["externalOriginId"];
            this.originType = _data["originType"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.destinationType = _data["destinationType"];
            this.externalArticleId = _data["externalArticleId"];
            this.validationResult = _data["validationResult"];
        }
    }

    static fromJS(data: any): InternalMovementPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new InternalMovementPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalDriverId"] = this.externalDriverId;
        data["externalTruckId"] = this.externalTruckId;
        data["externalOriginId"] = this.externalOriginId;
        data["originType"] = this.originType;
        data["externalDestinationId"] = this.externalDestinationId;
        data["destinationType"] = this.destinationType;
        data["externalArticleId"] = this.externalArticleId;
        data["validationResult"] = this.validationResult;
        return data;
    }
}

export interface IInternalMovementPreActivityReportSearchOutputDto {
    id: number;
    externalDriverId: number;
    externalTruckId: number;
    externalOriginId: number;
    originType: LocationType;
    externalDestinationId: number;
    destinationType: LocationType;
    externalArticleId: number;
    validationResult: PreActivityReportValidation;
}

export class InvoiceDto implements IInvoiceDto {
    amount!: number;
    editionDisplayName!: string | undefined;
    invoiceNo!: string | undefined;
    invoiceDate!: DateTime;
    tenantLegalName!: string | undefined;
    tenantAddress!: string[] | undefined;
    tenantTaxNo!: string | undefined;
    hostLegalName!: string | undefined;
    hostAddress!: string[] | undefined;

    constructor(data?: IInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"] ? DateTime.fromISO(_data["invoiceDate"].toString()) : <any>undefined;
            this.tenantLegalName = _data["tenantLegalName"];
            if (Array.isArray(_data["tenantAddress"])) {
                this.tenantAddress = [] as any;
                for (let item of _data["tenantAddress"])
                    this.tenantAddress!.push(item);
            }
            this.tenantTaxNo = _data["tenantTaxNo"];
            this.hostLegalName = _data["hostLegalName"];
            if (Array.isArray(_data["hostAddress"])) {
                this.hostAddress = [] as any;
                for (let item of _data["hostAddress"])
                    this.hostAddress!.push(item);
            }
        }
    }

    static fromJS(data: any): InvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toString() : <any>undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (Array.isArray(this.tenantAddress)) {
            data["tenantAddress"] = [];
            for (let item of this.tenantAddress)
                data["tenantAddress"].push(item);
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (Array.isArray(this.hostAddress)) {
            data["hostAddress"] = [];
            for (let item of this.hostAddress)
                data["hostAddress"].push(item);
        }
        return data;
    }
}

export interface IInvoiceDto {
    amount: number;
    editionDisplayName: string | undefined;
    invoiceNo: string | undefined;
    invoiceDate: DateTime;
    tenantLegalName: string | undefined;
    tenantAddress: string[] | undefined;
    tenantTaxNo: string | undefined;
    hostLegalName: string | undefined;
    hostAddress: string[] | undefined;
}

export class IsAnyReportInProgressOutputDto implements IIsAnyReportInProgressOutputDto {
    existAnyReportInProgress!: boolean;
    reportId!: number;

    constructor(data?: IIsAnyReportInProgressOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.existAnyReportInProgress = _data["existAnyReportInProgress"];
            this.reportId = _data["reportId"];
        }
    }

    static fromJS(data: any): IsAnyReportInProgressOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new IsAnyReportInProgressOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["existAnyReportInProgress"] = this.existAnyReportInProgress;
        data["reportId"] = this.reportId;
        return data;
    }
}

export interface IIsAnyReportInProgressOutputDto {
    existAnyReportInProgress: boolean;
    reportId: number;
}

export class IsPreActivityReportValidToEntranceResultOutput implements IIsPreActivityReportValidToEntranceResultOutput {
    isValid!: boolean;
    preActivityReportId!: number;
    preActivityReportType!: ActivityReportType | undefined;
    isChip!: boolean | undefined;
    validatedOrigin!: LocationDto | undefined;
    validatedArticles!: ArticleDto[] | undefined;
    validatedDestination!: LocationDto | undefined;
    placeId!: number;

    constructor(data?: IIsPreActivityReportValidToEntranceResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.preActivityReportId = _data["preActivityReportId"];
            this.preActivityReportType = _data["preActivityReportType"];
            this.isChip = _data["isChip"];
            this.validatedOrigin = _data["validatedOrigin"] ? LocationDto.fromJS(_data["validatedOrigin"]) : <any>undefined;
            if (Array.isArray(_data["validatedArticles"])) {
                this.validatedArticles = [] as any;
                for (let item of _data["validatedArticles"])
                    this.validatedArticles!.push(ArticleDto.fromJS(item));
            }
            this.validatedDestination = _data["validatedDestination"] ? LocationDto.fromJS(_data["validatedDestination"]) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): IsPreActivityReportValidToEntranceResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsPreActivityReportValidToEntranceResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["preActivityReportId"] = this.preActivityReportId;
        data["preActivityReportType"] = this.preActivityReportType;
        data["isChip"] = this.isChip;
        data["validatedOrigin"] = this.validatedOrigin ? this.validatedOrigin.toJSON() : <any>undefined;
        if (Array.isArray(this.validatedArticles)) {
            data["validatedArticles"] = [];
            for (let item of this.validatedArticles)
                data["validatedArticles"].push(item.toJSON());
        }
        data["validatedDestination"] = this.validatedDestination ? this.validatedDestination.toJSON() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IIsPreActivityReportValidToEntranceResultOutput {
    isValid: boolean;
    preActivityReportId: number;
    preActivityReportType: ActivityReportType | undefined;
    isChip: boolean | undefined;
    validatedOrigin: LocationDto | undefined;
    validatedArticles: ArticleDto[] | undefined;
    validatedDestination: LocationDto | undefined;
    placeId: number;
}

export class IsTenantAvailableInput implements IIsTenantAvailableInput {
    tenancyName!: string;

    constructor(data?: IIsTenantAvailableInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): IsTenantAvailableInput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface IIsTenantAvailableInput {
    tenancyName: string;
}

export class IsTenantAvailableOutput implements IIsTenantAvailableOutput {
    state!: TenantAvailabilityState;
    tenantId!: number | undefined;
    serverRootAddress!: string | undefined;

    constructor(data?: IIsTenantAvailableOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.tenantId = _data["tenantId"];
            this.serverRootAddress = _data["serverRootAddress"];
        }
    }

    static fromJS(data: any): IsTenantAvailableOutput {
        data = typeof data === 'object' ? data : {};
        let result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    }
}

export interface IIsTenantAvailableOutput {
    state: TenantAvailabilityState;
    tenantId: number | undefined;
    serverRootAddress: string | undefined;
}

export class IValueValidator implements IIValueValidator {
    readonly name!: string | undefined;
    readonly attributes!: { [key: string]: any; } | undefined;

    constructor(data?: IIValueValidator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).name = _data["name"];
            if (_data["attributes"]) {
                (<any>this).attributes = {} as any;
                for (let key in _data["attributes"]) {
                    if (_data["attributes"].hasOwnProperty(key))
                        (<any>(<any>this).attributes)![key] = _data["attributes"][key];
                }
            }
        }
    }

    static fromJS(data: any): IValueValidator {
        data = typeof data === 'object' ? data : {};
        let result = new IValueValidator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (let key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    (<any>data["attributes"])[key] = (<any>this.attributes)[key];
            }
        }
        return data;
    }
}

export interface IIValueValidator {
    name: string | undefined;
    attributes: { [key: string]: any; } | undefined;
}

export class JaumeSereValueDto implements IJaumeSereValueDto {
    depositId!: number;
    communicateImmediately!: boolean;
    lastMovement!: boolean;
    emptyScaleCode!: string | undefined;
    fullScaleCode!: string | undefined;
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: IJaumeSereValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depositId = _data["depositId"];
            this.communicateImmediately = _data["communicateImmediately"];
            this.lastMovement = _data["lastMovement"];
            this.emptyScaleCode = _data["emptyScaleCode"];
            this.fullScaleCode = _data["fullScaleCode"];
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): JaumeSereValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new JaumeSereValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depositId"] = this.depositId;
        data["communicateImmediately"] = this.communicateImmediately;
        data["lastMovement"] = this.lastMovement;
        data["emptyScaleCode"] = this.emptyScaleCode;
        data["fullScaleCode"] = this.fullScaleCode;
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface IJaumeSereValueDto {
    depositId: number;
    communicateImmediately: boolean;
    lastMovement: boolean;
    emptyScaleCode: string | undefined;
    fullScaleCode: string | undefined;
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export class JsonClaimMapDto implements IJsonClaimMapDto {
    claim!: string | undefined;
    key!: string | undefined;

    constructor(data?: IJsonClaimMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.claim = _data["claim"];
            this.key = _data["key"];
        }
    }

    static fromJS(data: any): JsonClaimMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new JsonClaimMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["claim"] = this.claim;
        data["key"] = this.key;
        return data;
    }
}

export interface IJsonClaimMapDto {
    claim: string | undefined;
    key: string | undefined;
}

export class LanguageTextListDto implements ILanguageTextListDto {
    key!: string | undefined;
    baseValue!: string | undefined;
    targetValue!: string | undefined;

    constructor(data?: ILanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.baseValue = _data["baseValue"];
            this.targetValue = _data["targetValue"];
        }
    }

    static fromJS(data: any): LanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    }
}

export interface ILanguageTextListDto {
    key: string | undefined;
    baseValue: string | undefined;
    targetValue: string | undefined;
}

export class LdapSettingsEditDto implements ILdapSettingsEditDto {
    isModuleEnabled!: boolean;
    isEnabled!: boolean;
    domain!: string | undefined;
    userName!: string | undefined;
    password!: string | undefined;

    constructor(data?: ILdapSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isModuleEnabled = _data["isModuleEnabled"];
            this.isEnabled = _data["isEnabled"];
            this.domain = _data["domain"];
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LdapSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface ILdapSettingsEditDto {
    isModuleEnabled: boolean;
    isEnabled: boolean;
    domain: string | undefined;
    userName: string | undefined;
    password: string | undefined;
}

export class LicensePlateDetectionOutputDto implements ILicensePlateDetectionOutputDto {
    exist!: boolean;
    reportId!: number;
    state!: ActivityReportState | undefined;
    type!: ActivityReportType | undefined;
    message!: string | undefined;

    constructor(data?: ILicensePlateDetectionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exist = _data["exist"];
            this.reportId = _data["reportId"];
            this.state = _data["state"];
            this.type = _data["type"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LicensePlateDetectionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LicensePlateDetectionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exist"] = this.exist;
        data["reportId"] = this.reportId;
        data["state"] = this.state;
        data["type"] = this.type;
        data["message"] = this.message;
        return data;
    }
}

export interface ILicensePlateDetectionOutputDto {
    exist: boolean;
    reportId: number;
    state: ActivityReportState | undefined;
    type: ActivityReportType | undefined;
    message: string | undefined;
}

export class LineDensityBySpeciesDto implements ILineDensityBySpeciesDto {
    lineId!: number;
    densityBySpecies!: number;

    constructor(data?: ILineDensityBySpeciesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lineId = _data["lineId"];
            this.densityBySpecies = _data["densityBySpecies"];
        }
    }

    static fromJS(data: any): LineDensityBySpeciesDto {
        data = typeof data === 'object' ? data : {};
        let result = new LineDensityBySpeciesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lineId"] = this.lineId;
        data["densityBySpecies"] = this.densityBySpecies;
        return data;
    }
}

export interface ILineDensityBySpeciesDto {
    lineId: number;
    densityBySpecies: number;
}

export class LinkedUserDto implements ILinkedUserDto {
    tenantId!: number | undefined;
    tenancyName!: string | undefined;
    username!: string | undefined;
    id!: number;

    constructor(data?: ILinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.username = _data["username"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["id"] = this.id;
        return data;
    }
}

export interface ILinkedUserDto {
    tenantId: number | undefined;
    tenancyName: string | undefined;
    username: string | undefined;
    id: number;
}

export class LinkToUserInput implements ILinkToUserInput {
    tenancyName!: string | undefined;
    usernameOrEmailAddress!: string;
    password!: string;

    constructor(data?: ILinkToUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.usernameOrEmailAddress = _data["usernameOrEmailAddress"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): LinkToUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    }
}

export interface ILinkToUserInput {
    tenancyName: string | undefined;
    usernameOrEmailAddress: string;
    password: string;
}

export class ListResultDtoOfCacheDto implements IListResultDtoOfCacheDto {
    items!: CacheDto[] | undefined;

    constructor(data?: IListResultDtoOfCacheDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CacheDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfCacheDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfCacheDto {
    items: CacheDto[] | undefined;
}

export class ListResultDtoOfChatMessageDto implements IListResultDtoOfChatMessageDto {
    items!: ChatMessageDto[] | undefined;

    constructor(data?: IListResultDtoOfChatMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ChatMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfChatMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfChatMessageDto {
    items: ChatMessageDto[] | undefined;
}

export class ListResultDtoOfDensityPerSpeciesGroupDto implements IListResultDtoOfDensityPerSpeciesGroupDto {
    items!: DensityPerSpeciesGroupDto[] | undefined;

    constructor(data?: IListResultDtoOfDensityPerSpeciesGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DensityPerSpeciesGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfDensityPerSpeciesGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfDensityPerSpeciesGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfDensityPerSpeciesGroupDto {
    items: DensityPerSpeciesGroupDto[] | undefined;
}

export class ListResultDtoOfEditionListDto implements IListResultDtoOfEditionListDto {
    items!: EditionListDto[] | undefined;

    constructor(data?: IListResultDtoOfEditionListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EditionListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfEditionListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfEditionListDto {
    items: EditionListDto[] | undefined;
}

export class ListResultDtoOfFlatPermissionWithLevelDto implements IListResultDtoOfFlatPermissionWithLevelDto {
    items!: FlatPermissionWithLevelDto[] | undefined;

    constructor(data?: IListResultDtoOfFlatPermissionWithLevelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(FlatPermissionWithLevelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfFlatPermissionWithLevelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfFlatPermissionWithLevelDto {
    items: FlatPermissionWithLevelDto[] | undefined;
}

export class ListResultDtoOfLinkedUserDto implements IListResultDtoOfLinkedUserDto {
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IListResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfLinkedUserDto {
    items: LinkedUserDto[] | undefined;
}

export class ListResultDtoOfNameValueDto implements IListResultDtoOfNameValueDto {
    items!: NameValueDto[] | undefined;

    constructor(data?: IListResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfNameValueDto {
    items: NameValueDto[] | undefined;
}

export class ListResultDtoOfOrganizationUnitDto implements IListResultDtoOfOrganizationUnitDto {
    items!: OrganizationUnitDto[] | undefined;

    constructor(data?: IListResultDtoOfOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfOrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfOrganizationUnitDto {
    items: OrganizationUnitDto[] | undefined;
}

export class ListResultDtoOfRoleListDto implements IListResultDtoOfRoleListDto {
    items!: RoleListDto[] | undefined;

    constructor(data?: IListResultDtoOfRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfRoleListDto {
    items: RoleListDto[] | undefined;
}

export class ListResultDtoOfSubscribableEditionComboboxItemDto implements IListResultDtoOfSubscribableEditionComboboxItemDto {
    items!: SubscribableEditionComboboxItemDto[] | undefined;

    constructor(data?: IListResultDtoOfSubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscribableEditionComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfSubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfSubscribableEditionComboboxItemDto {
    items: SubscribableEditionComboboxItemDto[] | undefined;
}

export class ListResultDtoOfUserLoginAttemptDto implements IListResultDtoOfUserLoginAttemptDto {
    items!: UserLoginAttemptDto[] | undefined;

    constructor(data?: IListResultDtoOfUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserLoginAttemptDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResultDtoOfUserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResultDtoOfUserLoginAttemptDto {
    items: UserLoginAttemptDto[] | undefined;
}

export class ListWoodActivityReportsForTrucksToNextTrip implements IListWoodActivityReportsForTrucksToNextTrip {
    placeId!: number;
    dateToCompare!: DateTime;
    items!: WoodActivityReportsForTrucksToNextTrip[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IListWoodActivityReportsForTrucksToNextTrip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.dateToCompare = _data["dateToCompare"] ? DateTime.fromISO(_data["dateToCompare"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodActivityReportsForTrucksToNextTrip.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ListWoodActivityReportsForTrucksToNextTrip {
        data = typeof data === 'object' ? data : {};
        let result = new ListWoodActivityReportsForTrucksToNextTrip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["dateToCompare"] = this.dateToCompare ? this.dateToCompare.toString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IListWoodActivityReportsForTrucksToNextTrip {
    placeId: number;
    dateToCompare: DateTime;
    items: WoodActivityReportsForTrucksToNextTrip[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class LoaderMachineDto implements ILoaderMachineDto {
    staple!: string | undefined;
    waterDensity!: number;
    volume!: number | undefined;
    maxVariation!: number | undefined;
    submergedWeight!: number | undefined;
    weightOff!: number | undefined;
    minVolume!: number | undefined;
    maxVolume!: number | undefined;
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: ILoaderMachineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.staple = _data["staple"];
            this.waterDensity = _data["waterDensity"];
            this.volume = _data["volume"];
            this.maxVariation = _data["maxVariation"];
            this.submergedWeight = _data["submergedWeight"];
            this.weightOff = _data["weightOff"];
            this.minVolume = _data["minVolume"];
            this.maxVolume = _data["maxVolume"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LoaderMachineDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoaderMachineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["staple"] = this.staple;
        data["waterDensity"] = this.waterDensity;
        data["volume"] = this.volume;
        data["maxVariation"] = this.maxVariation;
        data["submergedWeight"] = this.submergedWeight;
        data["weightOff"] = this.weightOff;
        data["minVolume"] = this.minVolume;
        data["maxVolume"] = this.maxVolume;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILoaderMachineDto {
    staple: string | undefined;
    waterDensity: number;
    volume: number | undefined;
    maxVariation: number | undefined;
    submergedWeight: number | undefined;
    weightOff: number | undefined;
    minVolume: number | undefined;
    maxVolume: number | undefined;
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export class LoaderMachineMaintenanceDto implements ILoaderMachineMaintenanceDto {
    placeName!: string | undefined;
    zoneName!: string | undefined;
    zoneId!: number;
    deviceName!: string | undefined;
    currentState!: ActualState;
    weightOff!: WeightDto | undefined;
    submergedWeight!: WeightDto | undefined;
    volume!: number | undefined;
    minVolume!: number | undefined;
    maxVolume!: number | undefined;
    id!: number;

    constructor(data?: ILoaderMachineMaintenanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeName = _data["placeName"];
            this.zoneName = _data["zoneName"];
            this.zoneId = _data["zoneId"];
            this.deviceName = _data["deviceName"];
            this.currentState = _data["currentState"];
            this.weightOff = _data["weightOff"] ? WeightDto.fromJS(_data["weightOff"]) : <any>undefined;
            this.submergedWeight = _data["submergedWeight"] ? WeightDto.fromJS(_data["submergedWeight"]) : <any>undefined;
            this.volume = _data["volume"];
            this.minVolume = _data["minVolume"];
            this.maxVolume = _data["maxVolume"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LoaderMachineMaintenanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoaderMachineMaintenanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeName"] = this.placeName;
        data["zoneName"] = this.zoneName;
        data["zoneId"] = this.zoneId;
        data["deviceName"] = this.deviceName;
        data["currentState"] = this.currentState;
        data["weightOff"] = this.weightOff ? this.weightOff.toJSON() : <any>undefined;
        data["submergedWeight"] = this.submergedWeight ? this.submergedWeight.toJSON() : <any>undefined;
        data["volume"] = this.volume;
        data["minVolume"] = this.minVolume;
        data["maxVolume"] = this.maxVolume;
        data["id"] = this.id;
        return data;
    }
}

export interface ILoaderMachineMaintenanceDto {
    placeName: string | undefined;
    zoneName: string | undefined;
    zoneId: number;
    deviceName: string | undefined;
    currentState: ActualState;
    weightOff: WeightDto | undefined;
    submergedWeight: WeightDto | undefined;
    volume: number | undefined;
    minVolume: number | undefined;
    maxVolume: number | undefined;
    id: number;
}

export class LoaderVendorEmailNotificationInputDto implements ILoaderVendorEmailNotificationInputDto {
    loaderVendorEmailList!: EmailBoxInfoInputDto[] | undefined;
    isFOVendor!: boolean;
    isThirdProperty!: boolean;
    deposit!: string | undefined;
    provider!: string | undefined;
    receiptNumberOrigin!: string | undefined;
    reportNumber!: number;
    date!: DateTime;
    receiptOrigen!: string | undefined;
    product!: string | undefined;
    transportVendor!: string | undefined;
    licensePlate!: string | undefined;
    driverName!: string | undefined;
    loaderVendor!: string | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;
    observations!: string | undefined;
    serial!: string | undefined;
    placeId!: number;

    constructor(data?: ILoaderVendorEmailNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["loaderVendorEmailList"])) {
                this.loaderVendorEmailList = [] as any;
                for (let item of _data["loaderVendorEmailList"])
                    this.loaderVendorEmailList!.push(EmailBoxInfoInputDto.fromJS(item));
            }
            this.isFOVendor = _data["isFOVendor"];
            this.isThirdProperty = _data["isThirdProperty"];
            this.deposit = _data["deposit"];
            this.provider = _data["provider"];
            this.receiptNumberOrigin = _data["receiptNumberOrigin"];
            this.reportNumber = _data["reportNumber"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.receiptOrigen = _data["receiptOrigen"];
            this.product = _data["product"];
            this.transportVendor = _data["transportVendor"];
            this.licensePlate = _data["licensePlate"];
            this.driverName = _data["driverName"];
            this.loaderVendor = _data["loaderVendor"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
            this.observations = _data["observations"];
            this.serial = _data["serial"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): LoaderVendorEmailNotificationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LoaderVendorEmailNotificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.loaderVendorEmailList)) {
            data["loaderVendorEmailList"] = [];
            for (let item of this.loaderVendorEmailList)
                data["loaderVendorEmailList"].push(item.toJSON());
        }
        data["isFOVendor"] = this.isFOVendor;
        data["isThirdProperty"] = this.isThirdProperty;
        data["deposit"] = this.deposit;
        data["provider"] = this.provider;
        data["receiptNumberOrigin"] = this.receiptNumberOrigin;
        data["reportNumber"] = this.reportNumber;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["receiptOrigen"] = this.receiptOrigen;
        data["product"] = this.product;
        data["transportVendor"] = this.transportVendor;
        data["licensePlate"] = this.licensePlate;
        data["driverName"] = this.driverName;
        data["loaderVendor"] = this.loaderVendor;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        data["observations"] = this.observations;
        data["serial"] = this.serial;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface ILoaderVendorEmailNotificationInputDto {
    loaderVendorEmailList: EmailBoxInfoInputDto[] | undefined;
    isFOVendor: boolean;
    isThirdProperty: boolean;
    deposit: string | undefined;
    provider: string | undefined;
    receiptNumberOrigin: string | undefined;
    reportNumber: number;
    date: DateTime;
    receiptOrigen: string | undefined;
    product: string | undefined;
    transportVendor: string | undefined;
    licensePlate: string | undefined;
    driverName: string | undefined;
    loaderVendor: string | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
    observations: string | undefined;
    serial: string | undefined;
    placeId: number;
}

export class LocalizableComboboxItemDto implements ILocalizableComboboxItemDto {
    value!: string | undefined;
    displayText!: string | undefined;

    constructor(data?: ILocalizableComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.displayText = _data["displayText"];
        }
    }

    static fromJS(data: any): LocalizableComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    }
}

export interface ILocalizableComboboxItemDto {
    value: string | undefined;
    displayText: string | undefined;
}

export class LocalizableComboboxItemSourceDto implements ILocalizableComboboxItemSourceDto {
    items!: LocalizableComboboxItemDto[] | undefined;

    constructor(data?: ILocalizableComboboxItemSourceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocalizableComboboxItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LocalizableComboboxItemSourceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocalizableComboboxItemSourceDto {
    items: LocalizableComboboxItemDto[] | undefined;
}

export class LocationDto implements ILocationDto {
    place!: PlaceDto | undefined;
    externalIdentity!: ExternalIdentityDto | undefined;
    type!: LocationType;
    id!: number;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.place = _data["place"] ? PlaceDto.fromJS(_data["place"]) : <any>undefined;
            this.externalIdentity = _data["externalIdentity"] ? ExternalIdentityDto.fromJS(_data["externalIdentity"]) : <any>undefined;
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["externalIdentity"] = this.externalIdentity ? this.externalIdentity.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}

export interface ILocationDto {
    place: PlaceDto | undefined;
    externalIdentity: ExternalIdentityDto | undefined;
    type: LocationType;
    id: number;
}

export class LocationInPlaceDto implements ILocationInPlaceDto {
    externalIdentity!: ExternalIdentityDto | undefined;
    type!: LocationType;
    typeId!: number;
    id!: number;

    constructor(data?: ILocationInPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalIdentity = _data["externalIdentity"] ? ExternalIdentityDto.fromJS(_data["externalIdentity"]) : <any>undefined;
            this.type = _data["type"];
            this.typeId = _data["typeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): LocationInPlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationInPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalIdentity"] = this.externalIdentity ? this.externalIdentity.toJSON() : <any>undefined;
        data["type"] = this.type;
        data["typeId"] = this.typeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ILocationInPlaceDto {
    externalIdentity: ExternalIdentityDto | undefined;
    type: LocationType;
    typeId: number;
    id: number;
}

export class LocationOutputDto implements ILocationOutputDto {
    externalId!: number;
    type!: LocationType;

    constructor(data?: ILocationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): LocationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["type"] = this.type;
        return data;
    }
}

export interface ILocationOutputDto {
    externalId: number;
    type: LocationType;
}

export enum LocationType {
    Stand = "Stand",
    Plant = "Plant",
    Logyard = "Logyard",
    IntermediateLogyard = "IntermediateLogyard",
    Property = "Property",
    ThirdProperty = "ThirdProperty",
}

export class LockSampleOutputDto implements ILockSampleOutputDto {
    lockedByUserId!: number;
    lockedByUserName!: string | undefined;
    samplingZoneId!: number;

    constructor(data?: ILockSampleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lockedByUserId = _data["lockedByUserId"];
            this.lockedByUserName = _data["lockedByUserName"];
            this.samplingZoneId = _data["samplingZoneId"];
        }
    }

    static fromJS(data: any): LockSampleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LockSampleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lockedByUserId"] = this.lockedByUserId;
        data["lockedByUserName"] = this.lockedByUserName;
        data["samplingZoneId"] = this.samplingZoneId;
        return data;
    }
}

export interface ILockSampleOutputDto {
    lockedByUserId: number;
    lockedByUserName: string | undefined;
    samplingZoneId: number;
}

export class LogmeterIntegrationDto implements ILogmeterIntegrationDto {
    id!: number;
    executionDateTime!: DateTime | undefined;
    eventId!: string | undefined;
    totalAverageDiameter!: number;
    totalSolidVolume!: number;
    totalStackedVolume!: number;
    fixedAverageLength!: number;
    visibleAverageLength!: number;
    fullTruck!: boolean;
    excessDiameterAlarm!: boolean;
    averageHeight!: number;
    isRecalculation!: boolean;
    modelId!: number;
    interventionState!: string | undefined;
    packages!: LogmeterPackageDto[] | undefined;
    isManual!: boolean;
    density!: number | undefined;
    historicalDensity!: number;
    lengthClassification!: LogmeterValueOutputDto | undefined;
    averageLengthClassification!: LogmeterValueOutputDto | undefined;
    isAborted!: boolean;
    readonly isSuccessfulInterventionState!: boolean;

    constructor(data?: ILogmeterIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.executionDateTime = _data["executionDateTime"] ? DateTime.fromISO(_data["executionDateTime"].toString()) : <any>undefined;
            this.eventId = _data["eventId"];
            this.totalAverageDiameter = _data["totalAverageDiameter"];
            this.totalSolidVolume = _data["totalSolidVolume"];
            this.totalStackedVolume = _data["totalStackedVolume"];
            this.fixedAverageLength = _data["fixedAverageLength"];
            this.visibleAverageLength = _data["visibleAverageLength"];
            this.fullTruck = _data["fullTruck"];
            this.excessDiameterAlarm = _data["excessDiameterAlarm"];
            this.averageHeight = _data["averageHeight"];
            this.isRecalculation = _data["isRecalculation"];
            this.modelId = _data["modelId"];
            this.interventionState = _data["interventionState"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(LogmeterPackageDto.fromJS(item));
            }
            this.isManual = _data["isManual"];
            this.density = _data["density"];
            this.historicalDensity = _data["historicalDensity"];
            this.lengthClassification = _data["lengthClassification"] ? LogmeterValueOutputDto.fromJS(_data["lengthClassification"]) : <any>undefined;
            this.averageLengthClassification = _data["averageLengthClassification"] ? LogmeterValueOutputDto.fromJS(_data["averageLengthClassification"]) : <any>undefined;
            this.isAborted = _data["isAborted"];
            (<any>this).isSuccessfulInterventionState = _data["isSuccessfulInterventionState"];
        }
    }

    static fromJS(data: any): LogmeterIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogmeterIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["executionDateTime"] = this.executionDateTime ? this.executionDateTime.toString() : <any>undefined;
        data["eventId"] = this.eventId;
        data["totalAverageDiameter"] = this.totalAverageDiameter;
        data["totalSolidVolume"] = this.totalSolidVolume;
        data["totalStackedVolume"] = this.totalStackedVolume;
        data["fixedAverageLength"] = this.fixedAverageLength;
        data["visibleAverageLength"] = this.visibleAverageLength;
        data["fullTruck"] = this.fullTruck;
        data["excessDiameterAlarm"] = this.excessDiameterAlarm;
        data["averageHeight"] = this.averageHeight;
        data["isRecalculation"] = this.isRecalculation;
        data["modelId"] = this.modelId;
        data["interventionState"] = this.interventionState;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["isManual"] = this.isManual;
        data["density"] = this.density;
        data["historicalDensity"] = this.historicalDensity;
        data["lengthClassification"] = this.lengthClassification ? this.lengthClassification.toJSON() : <any>undefined;
        data["averageLengthClassification"] = this.averageLengthClassification ? this.averageLengthClassification.toJSON() : <any>undefined;
        data["isAborted"] = this.isAborted;
        data["isSuccessfulInterventionState"] = this.isSuccessfulInterventionState;
        return data;
    }
}

export interface ILogmeterIntegrationDto {
    id: number;
    executionDateTime: DateTime | undefined;
    eventId: string | undefined;
    totalAverageDiameter: number;
    totalSolidVolume: number;
    totalStackedVolume: number;
    fixedAverageLength: number;
    visibleAverageLength: number;
    fullTruck: boolean;
    excessDiameterAlarm: boolean;
    averageHeight: number;
    isRecalculation: boolean;
    modelId: number;
    interventionState: string | undefined;
    packages: LogmeterPackageDto[] | undefined;
    isManual: boolean;
    density: number | undefined;
    historicalDensity: number;
    lengthClassification: LogmeterValueOutputDto | undefined;
    averageLengthClassification: LogmeterValueOutputDto | undefined;
    isAborted: boolean;
    isSuccessfulInterventionState: boolean;
}

export class LogmeterPackageDto implements ILogmeterPackageDto {
    averageDiameterPackages!: number;
    solidVolumePackages!: number;
    stackedVolumePackages!: number;
    upperSlopePackages!: number;
    rightSlopePackages!: number;
    leftSlopePackages!: number;
    rightProfilePointsPackages!: number;
    leftProfilePointsPackages!: number;
    heightBankPackages!: number | undefined;
    barHeightBankPackages!: number | undefined;
    widthBankPackages!: number | undefined;
    order!: number;

    constructor(data?: ILogmeterPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageDiameterPackages = _data["averageDiameterPackages"];
            this.solidVolumePackages = _data["solidVolumePackages"];
            this.stackedVolumePackages = _data["stackedVolumePackages"];
            this.upperSlopePackages = _data["upperSlopePackages"];
            this.rightSlopePackages = _data["rightSlopePackages"];
            this.leftSlopePackages = _data["leftSlopePackages"];
            this.rightProfilePointsPackages = _data["rightProfilePointsPackages"];
            this.leftProfilePointsPackages = _data["leftProfilePointsPackages"];
            this.heightBankPackages = _data["heightBankPackages"];
            this.barHeightBankPackages = _data["barHeightBankPackages"];
            this.widthBankPackages = _data["widthBankPackages"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): LogmeterPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogmeterPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageDiameterPackages"] = this.averageDiameterPackages;
        data["solidVolumePackages"] = this.solidVolumePackages;
        data["stackedVolumePackages"] = this.stackedVolumePackages;
        data["upperSlopePackages"] = this.upperSlopePackages;
        data["rightSlopePackages"] = this.rightSlopePackages;
        data["leftSlopePackages"] = this.leftSlopePackages;
        data["rightProfilePointsPackages"] = this.rightProfilePointsPackages;
        data["leftProfilePointsPackages"] = this.leftProfilePointsPackages;
        data["heightBankPackages"] = this.heightBankPackages;
        data["barHeightBankPackages"] = this.barHeightBankPackages;
        data["widthBankPackages"] = this.widthBankPackages;
        data["order"] = this.order;
        return data;
    }
}

export interface ILogmeterPackageDto {
    averageDiameterPackages: number;
    solidVolumePackages: number;
    stackedVolumePackages: number;
    upperSlopePackages: number;
    rightSlopePackages: number;
    leftSlopePackages: number;
    rightProfilePointsPackages: number;
    leftProfilePointsPackages: number;
    heightBankPackages: number | undefined;
    barHeightBankPackages: number | undefined;
    widthBankPackages: number | undefined;
    order: number;
}

export class LogmeterPackageForBarkSampleDto implements ILogmeterPackageForBarkSampleDto {
    number!: number;
    solidVolumePackages!: number;

    constructor(data?: ILogmeterPackageForBarkSampleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"];
            this.solidVolumePackages = _data["solidVolumePackages"];
        }
    }

    static fromJS(data: any): LogmeterPackageForBarkSampleDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogmeterPackageForBarkSampleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["solidVolumePackages"] = this.solidVolumePackages;
        return data;
    }
}

export interface ILogmeterPackageForBarkSampleDto {
    number: number;
    solidVolumePackages: number;
}

export class LogmeterValueOutputDto implements ILogmeterValueOutputDto {
    logmeterIntegrationId!: number;
    minorValue!: string | undefined;
    expectedValue!: string | undefined;
    aboveValueValue!: string | undefined;

    constructor(data?: ILogmeterValueOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logmeterIntegrationId = _data["logmeterIntegrationId"];
            this.minorValue = _data["minorValue"];
            this.expectedValue = _data["expectedValue"];
            this.aboveValueValue = _data["aboveValueValue"];
        }
    }

    static fromJS(data: any): LogmeterValueOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new LogmeterValueOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logmeterIntegrationId"] = this.logmeterIntegrationId;
        data["minorValue"] = this.minorValue;
        data["expectedValue"] = this.expectedValue;
        data["aboveValueValue"] = this.aboveValueValue;
        return data;
    }
}

export interface ILogmeterValueOutputDto {
    logmeterIntegrationId: number;
    minorValue: string | undefined;
    expectedValue: string | undefined;
    aboveValueValue: string | undefined;
}

export class MapInformationForScannerInput implements IMapInformationForScannerInput {
    speciesCode!: string | undefined;
    lengthValue!: number;
    factorTypeCode!: number;
    contractId!: number;

    constructor(data?: IMapInformationForScannerInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.speciesCode = _data["speciesCode"];
            this.lengthValue = _data["lengthValue"];
            this.factorTypeCode = _data["factorTypeCode"];
            this.contractId = _data["contractId"];
        }
    }

    static fromJS(data: any): MapInformationForScannerInput {
        data = typeof data === 'object' ? data : {};
        let result = new MapInformationForScannerInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["speciesCode"] = this.speciesCode;
        data["lengthValue"] = this.lengthValue;
        data["factorTypeCode"] = this.factorTypeCode;
        data["contractId"] = this.contractId;
        return data;
    }
}

export interface IMapInformationForScannerInput {
    speciesCode: string | undefined;
    lengthValue: number;
    factorTypeCode: number;
    contractId: number;
}

export class MapInformationForScannerOutput implements IMapInformationForScannerOutput {
    species!: number;
    length!: string | undefined;
    truckType!: string | undefined;
    bankQuantity!: number;
    vehicleQuantity!: number;
    maxHeight!: number;
    isProvider!: boolean;

    constructor(data?: IMapInformationForScannerOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.species = _data["species"];
            this.length = _data["length"];
            this.truckType = _data["truckType"];
            this.bankQuantity = _data["bankQuantity"];
            this.vehicleQuantity = _data["vehicleQuantity"];
            this.maxHeight = _data["maxHeight"];
            this.isProvider = _data["isProvider"];
        }
    }

    static fromJS(data: any): MapInformationForScannerOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MapInformationForScannerOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["species"] = this.species;
        data["length"] = this.length;
        data["truckType"] = this.truckType;
        data["bankQuantity"] = this.bankQuantity;
        data["vehicleQuantity"] = this.vehicleQuantity;
        data["maxHeight"] = this.maxHeight;
        data["isProvider"] = this.isProvider;
        return data;
    }
}

export interface IMapInformationForScannerOutput {
    species: number;
    length: string | undefined;
    truckType: string | undefined;
    bankQuantity: number;
    vehicleQuantity: number;
    maxHeight: number;
    isProvider: boolean;
}

export class MarkAllUnreadMessagesOfUserAsReadInput implements IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IMarkAllUnreadMessagesOfUserAsReadInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): MarkAllUnreadMessagesOfUserAsReadInput {
        data = typeof data === 'object' ? data : {};
        let result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IMarkAllUnreadMessagesOfUserAsReadInput {
    tenantId: number | undefined;
    userId: number;
}

export enum MassEditStatus {
    Succeeded = "Succeeded",
    UnexpectedError = "UnexpectedError",
    SystemApiFatalError = "SystemApiFatalError",
    SystemApiErrors = "SystemApiErrors",
    ExternalSystemErrors = "ExternalSystemErrors",
    ExternalAndInternalErrors = "ExternalAndInternalErrors",
}

export class MaxTimeOnDestinationItem implements IMaxTimeOnDestinationItem {
    id!: number;
    licensePlate!: string | undefined;
    minutes!: number;
    entryDate!: DateTime | undefined;

    constructor(data?: IMaxTimeOnDestinationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licensePlate = _data["licensePlate"];
            this.minutes = _data["minutes"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MaxTimeOnDestinationItem {
        data = typeof data === 'object' ? data : {};
        let result = new MaxTimeOnDestinationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licensePlate"] = this.licensePlate;
        data["minutes"] = this.minutes;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        return data;
    }
}

export interface IMaxTimeOnDestinationItem {
    id: number;
    licensePlate: string | undefined;
    minutes: number;
    entryDate: DateTime | undefined;
}

export class MaxTimeOnDestinationOutputDto implements IMaxTimeOnDestinationOutputDto {
    placeId!: number;
    maxTimeOnDestinationMinutes!: number;
    totalReceipts!: number;
    dateToCompare!: DateTime;
    items!: MaxTimeOnDestinationItem[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IMaxTimeOnDestinationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.maxTimeOnDestinationMinutes = _data["maxTimeOnDestinationMinutes"];
            this.totalReceipts = _data["totalReceipts"];
            this.dateToCompare = _data["dateToCompare"] ? DateTime.fromISO(_data["dateToCompare"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(MaxTimeOnDestinationItem.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): MaxTimeOnDestinationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaxTimeOnDestinationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["maxTimeOnDestinationMinutes"] = this.maxTimeOnDestinationMinutes;
        data["totalReceipts"] = this.totalReceipts;
        data["dateToCompare"] = this.dateToCompare ? this.dateToCompare.toString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IMaxTimeOnDestinationOutputDto {
    placeId: number;
    maxTimeOnDestinationMinutes: number;
    totalReceipts: number;
    dateToCompare: DateTime;
    items: MaxTimeOnDestinationItem[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class MemberActivity implements IMemberActivity {
    name!: string | undefined;
    earnings!: string | undefined;
    cases!: number;
    closed!: number;
    rate!: string | undefined;

    constructor(data?: IMemberActivity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.earnings = _data["earnings"];
            this.cases = _data["cases"];
            this.closed = _data["closed"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): MemberActivity {
        data = typeof data === 'object' ? data : {};
        let result = new MemberActivity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IMemberActivity {
    name: string | undefined;
    earnings: string | undefined;
    cases: number;
    closed: number;
    rate: string | undefined;
}

export class MemberInfo implements IMemberInfo {
    readonly memberType!: MemberTypes;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    readonly module!: Module | undefined;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).memberType = _data["memberType"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            (<any>this).module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MemberInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    memberType: MemberTypes;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export enum MemberTypes {
    Constructor = "Constructor",
    Event = "Event",
    Field = "Field",
    Method = "Method",
    Property = "Property",
    TypeInfo = "TypeInfo",
    Custom = "Custom",
    NestedType = "NestedType",
    All = "All",
}

export enum MethodAttributes {
    PrivateScope = "PrivateScope",
    ReuseSlot = "ReuseSlot, Private",
    Private = "ReuseSlot, FamANDAssem",
    FamANDAssem = "ReuseSlot, Assembly",
    Assembly = "ReuseSlot, Family",
    Family = "ReuseSlot, FamORAssem",
    FamORAssem = "ReuseSlot, Public",
    Public = "ReuseSlot, MemberAccessMask",
    MemberAccessMask = "ReuseSlot, UnmanagedExport",
    UnmanagedExport = "ReuseSlot, Static",
    Static = "ReuseSlot, Final",
    Final = "ReuseSlot, Virtual",
    Virtual = "ReuseSlot, HideBySig",
    HideBySig = "ReuseSlot, VtableLayoutMask",
    NewSlot = "ReuseSlot, CheckAccessOnOverride",
    VtableLayoutMask = "ReuseSlot, Abstract",
    CheckAccessOnOverride = "ReuseSlot, SpecialName",
    Abstract = "ReuseSlot, RTSpecialName",
    SpecialName = "ReuseSlot, PinvokeImpl",
    RTSpecialName = "ReuseSlot, HasSecurity",
    PinvokeImpl = "ReuseSlot, RequireSecObject",
    HasSecurity = "ReuseSlot, ReservedMask",
}

export enum MethodImplAttributes {
    IL = "Managed",
    Managed = "Native",
    Native = "OPTIL",
    OPTIL = "Runtime",
    CodeTypeMask = "ManagedMask",
    Runtime = "NoInlining",
    ManagedMask = "ForwardRef",
    Unmanaged = "Synchronized",
    NoInlining = "NoOptimization",
    ForwardRef = "PreserveSig",
    Synchronized = "AggressiveInlining",
    NoOptimization = "AggressiveOptimization",
    PreserveSig = "InternalCall",
    AggressiveInlining = "MaxMethodImplVal",
}

export class MethodInfo implements IMethodInfo {
    readonly memberType!: MemberTypes;
    readonly returnParameter!: ParameterInfo | undefined;
    readonly returnType!: string | undefined;
    readonly returnTypeCustomAttributes!: ICustomAttributeProvider | undefined;
    readonly attributes!: MethodAttributes;
    readonly methodImplementationFlags!: MethodImplAttributes;
    readonly callingConvention!: CallingConventions;
    readonly isAbstract!: boolean;
    readonly isConstructor!: boolean;
    readonly isFinal!: boolean;
    readonly isHideBySig!: boolean;
    readonly isSpecialName!: boolean;
    readonly isStatic!: boolean;
    readonly isVirtual!: boolean;
    readonly isAssembly!: boolean;
    readonly isFamily!: boolean;
    readonly isFamilyAndAssembly!: boolean;
    readonly isFamilyOrAssembly!: boolean;
    readonly isPrivate!: boolean;
    readonly isPublic!: boolean;
    readonly isConstructedGenericMethod!: boolean;
    readonly isGenericMethod!: boolean;
    readonly isGenericMethodDefinition!: boolean;
    readonly containsGenericParameters!: boolean;
    readonly methodHandle!: RuntimeMethodHandle;
    readonly isSecurityCritical!: boolean;
    readonly isSecuritySafeCritical!: boolean;
    readonly isSecurityTransparent!: boolean;
    readonly name!: string | undefined;
    readonly declaringType!: string | undefined;
    readonly reflectedType!: string | undefined;
    readonly module!: Module | undefined;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly isCollectible!: boolean;
    readonly metadataToken!: number;

    constructor(data?: IMethodInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).memberType = _data["memberType"];
            (<any>this).returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : <any>undefined;
            (<any>this).returnType = _data["returnType"];
            (<any>this).returnTypeCustomAttributes = _data["returnTypeCustomAttributes"] ? ICustomAttributeProvider.fromJS(_data["returnTypeCustomAttributes"]) : <any>undefined;
            (<any>this).attributes = _data["attributes"];
            (<any>this).methodImplementationFlags = _data["methodImplementationFlags"];
            (<any>this).callingConvention = _data["callingConvention"];
            (<any>this).isAbstract = _data["isAbstract"];
            (<any>this).isConstructor = _data["isConstructor"];
            (<any>this).isFinal = _data["isFinal"];
            (<any>this).isHideBySig = _data["isHideBySig"];
            (<any>this).isSpecialName = _data["isSpecialName"];
            (<any>this).isStatic = _data["isStatic"];
            (<any>this).isVirtual = _data["isVirtual"];
            (<any>this).isAssembly = _data["isAssembly"];
            (<any>this).isFamily = _data["isFamily"];
            (<any>this).isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            (<any>this).isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            (<any>this).isPrivate = _data["isPrivate"];
            (<any>this).isPublic = _data["isPublic"];
            (<any>this).isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            (<any>this).isGenericMethod = _data["isGenericMethod"];
            (<any>this).isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            (<any>this).containsGenericParameters = _data["containsGenericParameters"];
            (<any>this).methodHandle = _data["methodHandle"] ? RuntimeMethodHandle.fromJS(_data["methodHandle"]) : <any>undefined;
            (<any>this).isSecurityCritical = _data["isSecurityCritical"];
            (<any>this).isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            (<any>this).isSecurityTransparent = _data["isSecurityTransparent"];
            (<any>this).name = _data["name"];
            (<any>this).declaringType = _data["declaringType"];
            (<any>this).reflectedType = _data["reflectedType"];
            (<any>this).module = _data["module"] ? Module.fromJS(_data["module"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).isCollectible = _data["isCollectible"];
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        let result = new MethodInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : <any>undefined;
        data["returnType"] = this.returnType;
        data["returnTypeCustomAttributes"] = this.returnTypeCustomAttributes ? this.returnTypeCustomAttributes.toJSON() : <any>undefined;
        data["attributes"] = this.attributes;
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["methodHandle"] = this.methodHandle ? this.methodHandle.toJSON() : <any>undefined;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        data["name"] = this.name;
        data["declaringType"] = this.declaringType;
        data["reflectedType"] = this.reflectedType;
        data["module"] = this.module ? this.module.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMethodInfo {
    memberType: MemberTypes;
    returnParameter: ParameterInfo | undefined;
    returnType: string | undefined;
    returnTypeCustomAttributes: ICustomAttributeProvider | undefined;
    attributes: MethodAttributes;
    methodImplementationFlags: MethodImplAttributes;
    callingConvention: CallingConventions;
    isAbstract: boolean;
    isConstructor: boolean;
    isFinal: boolean;
    isHideBySig: boolean;
    isSpecialName: boolean;
    isStatic: boolean;
    isVirtual: boolean;
    isAssembly: boolean;
    isFamily: boolean;
    isFamilyAndAssembly: boolean;
    isFamilyOrAssembly: boolean;
    isPrivate: boolean;
    isPublic: boolean;
    isConstructedGenericMethod: boolean;
    isGenericMethod: boolean;
    isGenericMethodDefinition: boolean;
    containsGenericParameters: boolean;
    methodHandle: RuntimeMethodHandle;
    isSecurityCritical: boolean;
    isSecuritySafeCritical: boolean;
    isSecurityTransparent: boolean;
    name: string | undefined;
    declaringType: string | undefined;
    reflectedType: string | undefined;
    module: Module | undefined;
    customAttributes: CustomAttributeData[] | undefined;
    isCollectible: boolean;
    metadataToken: number;
}

export class MicrosoftExternalLoginProviderSettings implements IMicrosoftExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;

    constructor(data?: IMicrosoftExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
        }
    }

    static fromJS(data: any): MicrosoftExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new MicrosoftExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        return data;
    }
}

export interface IMicrosoftExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
}

export class Module implements IModule {
    readonly assembly!: Assembly | undefined;
    readonly fullyQualifiedName!: string | undefined;
    readonly name!: string | undefined;
    readonly mdStreamVersion!: number;
    readonly moduleVersionId!: string;
    readonly scopeName!: string | undefined;
    readonly moduleHandle!: ModuleHandle;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : <any>undefined;
            (<any>this).fullyQualifiedName = _data["fullyQualifiedName"];
            (<any>this).name = _data["name"];
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
            (<any>this).moduleVersionId = _data["moduleVersionId"];
            (<any>this).scopeName = _data["scopeName"];
            (<any>this).moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : <any>undefined;
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : <any>undefined;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : <any>undefined;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule {
    assembly: Assembly | undefined;
    fullyQualifiedName: string | undefined;
    name: string | undefined;
    mdStreamVersion: number;
    moduleVersionId: string;
    scopeName: string | undefined;
    moduleHandle: ModuleHandle;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export class ModuleHandle implements IModuleHandle {
    readonly mdStreamVersion!: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion: number;
}

export class MoveOrganizationUnitInput implements IMoveOrganizationUnitInput {
    id!: number;
    newParentId!: number | undefined;

    constructor(data?: IMoveOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.newParentId = _data["newParentId"];
        }
    }

    static fromJS(data: any): MoveOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    }
}

export interface IMoveOrganizationUnitInput {
    id: number;
    newParentId: number | undefined;
}

export class MoveTenantsToAnotherEditionDto implements IMoveTenantsToAnotherEditionDto {
    sourceEditionId!: number;
    targetEditionId!: number;

    constructor(data?: IMoveTenantsToAnotherEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sourceEditionId = _data["sourceEditionId"];
            this.targetEditionId = _data["targetEditionId"];
        }
    }

    static fromJS(data: any): MoveTenantsToAnotherEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    }
}

export interface IMoveTenantsToAnotherEditionDto {
    sourceEditionId: number;
    targetEditionId: number;
}

export class NameValue implements INameValue {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValue {
        data = typeof data === 'object' ? data : {};
        let result = new NameValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValue {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueDto implements INameValueDto {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueDto {
    name: string | undefined;
    value: string | undefined;
}

export class NameValueOfString implements INameValueOfString {
    name!: string | undefined;
    value!: string | undefined;

    constructor(data?: INameValueOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): NameValueOfString {
        data = typeof data === 'object' ? data : {};
        let result = new NameValueOfString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

export interface INameValueOfString {
    name: string | undefined;
    value: string | undefined;
}

export class NewTagDetectionOutputDto implements INewTagDetectionOutputDto {
    isValid!: boolean;
    isValidToEntry!: boolean;
    tag!: number;
    vehicleId!: number;
    externalVehicleId!: number;
    licensePlate!: string | undefined;
    isTruck!: boolean;
    message!: string | undefined;

    constructor(data?: INewTagDetectionOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.isValidToEntry = _data["isValidToEntry"];
            this.tag = _data["tag"];
            this.vehicleId = _data["vehicleId"];
            this.externalVehicleId = _data["externalVehicleId"];
            this.licensePlate = _data["licensePlate"];
            this.isTruck = _data["isTruck"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): NewTagDetectionOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new NewTagDetectionOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["isValidToEntry"] = this.isValidToEntry;
        data["tag"] = this.tag;
        data["vehicleId"] = this.vehicleId;
        data["externalVehicleId"] = this.externalVehicleId;
        data["licensePlate"] = this.licensePlate;
        data["isTruck"] = this.isTruck;
        data["message"] = this.message;
        return data;
    }
}

export interface INewTagDetectionOutputDto {
    isValid: boolean;
    isValidToEntry: boolean;
    tag: number;
    vehicleId: number;
    externalVehicleId: number;
    licensePlate: string | undefined;
    isTruck: boolean;
    message: string | undefined;
}

export class NotificationData implements INotificationData {
    readonly type!: string | undefined;
    properties!: { [key: string]: any; } | undefined;

    constructor(data?: INotificationData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).type = _data["type"];
            if (_data["properties"]) {
                this.properties = {} as any;
                for (let key in _data["properties"]) {
                    if (_data["properties"].hasOwnProperty(key))
                        (<any>this.properties)![key] = _data["properties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NotificationData {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (let key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    (<any>data["properties"])[key] = (<any>this.properties)[key];
            }
        }
        return data;
    }
}

export interface INotificationData {
    type: string | undefined;
    properties: { [key: string]: any; } | undefined;
}

export enum NotificationSeverity {
    Info = "Info",
    Success = "Success",
    Warn = "Warn",
    Error = "Error",
    Fatal = "Fatal",
}

export class NotificationSubscriptionDto implements INotificationSubscriptionDto {
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionDto {
    name: string;
    isSubscribed: boolean;
}

export class NotificationSubscriptionWithDisplayNameDto implements INotificationSubscriptionWithDisplayNameDto {
    displayName!: string | undefined;
    description!: string | undefined;
    name!: string;
    isSubscribed!: boolean;

    constructor(data?: INotificationSubscriptionWithDisplayNameDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.description = _data["description"];
            this.name = _data["name"];
            this.isSubscribed = _data["isSubscribed"];
        }
    }

    static fromJS(data: any): NotificationSubscriptionWithDisplayNameDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    }
}

export interface INotificationSubscriptionWithDisplayNameDto {
    displayName: string | undefined;
    description: string | undefined;
    name: string;
    isSubscribed: boolean;
}

export class NotifyMassEditCompletedInput implements INotifyMassEditCompletedInput {
    user!: UserIdentifier | undefined;
    status!: MassEditStatus;
    massEditId!: string;

    constructor(data?: INotifyMassEditCompletedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserIdentifier.fromJS(_data["user"]) : <any>undefined;
            this.status = _data["status"];
            this.massEditId = _data["massEditId"];
        }
    }

    static fromJS(data: any): NotifyMassEditCompletedInput {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyMassEditCompletedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["status"] = this.status;
        data["massEditId"] = this.massEditId;
        return data;
    }
}

export interface INotifyMassEditCompletedInput {
    user: UserIdentifier | undefined;
    status: MassEditStatus;
    massEditId: string;
}

export class NotifyResultOutput implements INotifyResultOutput {
    shouldUpdateWoodControlSystem!: boolean;
    isRepeatedResult!: boolean;

    constructor(data?: INotifyResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldUpdateWoodControlSystem = _data["shouldUpdateWoodControlSystem"];
            this.isRepeatedResult = _data["isRepeatedResult"];
        }
    }

    static fromJS(data: any): NotifyResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new NotifyResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldUpdateWoodControlSystem"] = this.shouldUpdateWoodControlSystem;
        data["isRepeatedResult"] = this.isRepeatedResult;
        return data;
    }
}

export interface INotifyResultOutput {
    shouldUpdateWoodControlSystem: boolean;
    isRepeatedResult: boolean;
}

export class OpenIdConnectExternalLoginProviderSettings implements IOpenIdConnectExternalLoginProviderSettings {
    clientId!: string | undefined;
    clientSecret!: string | undefined;
    authority!: string | undefined;
    loginUrl!: string | undefined;
    validateIssuer!: boolean;

    constructor(data?: IOpenIdConnectExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.clientSecret = _data["clientSecret"];
            this.authority = _data["authority"];
            this.loginUrl = _data["loginUrl"];
            this.validateIssuer = _data["validateIssuer"];
        }
    }

    static fromJS(data: any): OpenIdConnectExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new OpenIdConnectExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["clientSecret"] = this.clientSecret;
        data["authority"] = this.authority;
        data["loginUrl"] = this.loginUrl;
        data["validateIssuer"] = this.validateIssuer;
        return data;
    }
}

export interface IOpenIdConnectExternalLoginProviderSettings {
    clientId: string | undefined;
    clientSecret: string | undefined;
    authority: string | undefined;
    loginUrl: string | undefined;
    validateIssuer: boolean;
}

export class Operation implements IOperation {
    value!: any | undefined;
    path!: string | undefined;
    op!: string | undefined;
    from!: string | undefined;

    constructor(data?: IOperation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.path = _data["path"];
            this.op = _data["op"];
            this.from = _data["from"];
        }
    }

    static fromJS(data: any): Operation {
        data = typeof data === 'object' ? data : {};
        let result = new Operation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["path"] = this.path;
        data["op"] = this.op;
        data["from"] = this.from;
        return data;
    }
}

export interface IOperation {
    value: any | undefined;
    path: string | undefined;
    op: string | undefined;
    from: string | undefined;
}

export class OrganizationUnitDto implements IOrganizationUnitDto {
    parentId!: number | undefined;
    code!: string | undefined;
    displayName!: string | undefined;
    memberCount!: number;
    roleCount!: number;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: IOrganizationUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.memberCount = _data["memberCount"];
            this.roleCount = _data["roleCount"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["roleCount"] = this.roleCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitDto {
    parentId: number | undefined;
    code: string | undefined;
    displayName: string | undefined;
    memberCount: number;
    roleCount: number;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export class OrganizationUnitRoleListDto implements IOrganizationUnitRoleListDto {
    displayName!: string | undefined;
    name!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.displayName = _data["displayName"];
            this.name = _data["name"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["name"] = this.name;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitRoleListDto {
    displayName: string | undefined;
    name: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OrganizationUnitUserListDto implements IOrganizationUnitUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    addedTime!: DateTime;
    id!: number;

    constructor(data?: IOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.addedTime = _data["addedTime"] ? DateTime.fromISO(_data["addedTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): OrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IOrganizationUnitUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    addedTime: DateTime;
    id: number;
}

export class OtherSettingsEditDto implements IOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: IOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): OtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new OtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface IOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class PackageCountOutput implements IPackageCountOutput {
    factorTypeId!: number;
    lengthId!: number;
    count!: number;
    id!: number;

    constructor(data?: IPackageCountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.factorTypeId = _data["factorTypeId"];
            this.lengthId = _data["lengthId"];
            this.count = _data["count"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PackageCountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PackageCountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["factorTypeId"] = this.factorTypeId;
        data["lengthId"] = this.lengthId;
        data["count"] = this.count;
        data["id"] = this.id;
        return data;
    }
}

export interface IPackageCountOutput {
    factorTypeId: number;
    lengthId: number;
    count: number;
    id: number;
}

export class Page implements IPage {
    id!: string | undefined;
    name!: string | undefined;
    widgets!: Widget[] | undefined;

    constructor(data?: IPage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["widgets"])) {
                this.widgets = [] as any;
                for (let item of _data["widgets"])
                    this.widgets!.push(Widget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Page {
        data = typeof data === 'object' ? data : {};
        let result = new Page();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.widgets)) {
            data["widgets"] = [];
            for (let item of this.widgets)
                data["widgets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPage {
    id: string | undefined;
    name: string | undefined;
    widgets: Widget[] | undefined;
}

export class PagedResultDtoOfActionDto implements IPagedResultDtoOfActionDto {
    totalCount!: number;
    items!: ActionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfActionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ActionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfActionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfActionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfActionDto {
    totalCount: number;
    items: ActionDto[] | undefined;
}

export class PagedResultDtoOfArchimedesSampleInstanceOutput implements IPagedResultDtoOfArchimedesSampleInstanceOutput {
    totalCount!: number;
    items!: ArchimedesSampleInstanceOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfArchimedesSampleInstanceOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ArchimedesSampleInstanceOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfArchimedesSampleInstanceOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfArchimedesSampleInstanceOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfArchimedesSampleInstanceOutput {
    totalCount: number;
    items: ArchimedesSampleInstanceOutput[] | undefined;
}

export class PagedResultDtoOfAuditLogListDto implements IPagedResultDtoOfAuditLogListDto {
    totalCount!: number;
    items!: AuditLogListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfAuditLogListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(AuditLogListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfAuditLogListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfAuditLogListDto {
    totalCount: number;
    items: AuditLogListDto[] | undefined;
}

export class PagedResultDtoOfBarkSampleForGridDto implements IPagedResultDtoOfBarkSampleForGridDto {
    totalCount!: number;
    items!: BarkSampleForGridDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBarkSampleForGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BarkSampleForGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBarkSampleForGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBarkSampleForGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfBarkSampleForGridDto {
    totalCount: number;
    items: BarkSampleForGridDto[] | undefined;
}

export class PagedResultDtoOfBrokerDto implements IPagedResultDtoOfBrokerDto {
    totalCount!: number;
    items!: BrokerDto[] | undefined;

    constructor(data?: IPagedResultDtoOfBrokerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BrokerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfBrokerDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfBrokerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfBrokerDto {
    totalCount: number;
    items: BrokerDto[] | undefined;
}

export class PagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto implements IPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto {
    totalCount!: number;
    items!: CenterControlDiverseProductPreActivityReportSearchOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CenterControlDiverseProductPreActivityReportSearchOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCenterControlDiverseProductPreActivityReportSearchOutputDto {
    totalCount: number;
    items: CenterControlDiverseProductPreActivityReportSearchOutputDto[] | undefined;
}

export class PagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto implements IPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto {
    totalCount!: number;
    items!: CenterControlInternalMovementPreActivityReportSearchOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CenterControlInternalMovementPreActivityReportSearchOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCenterControlInternalMovementPreActivityReportSearchOutputDto {
    totalCount: number;
    items: CenterControlInternalMovementPreActivityReportSearchOutputDto[] | undefined;
}

export class PagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto implements IPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto {
    totalCount!: number;
    items!: CenterControlWoodPreActivityReportSearchOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CenterControlWoodPreActivityReportSearchOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfCenterControlWoodPreActivityReportSearchOutputDto {
    totalCount: number;
    items: CenterControlWoodPreActivityReportSearchOutputDto[] | undefined;
}

export class PagedResultDtoOfDensityPerSpeciesGroupDto implements IPagedResultDtoOfDensityPerSpeciesGroupDto {
    totalCount!: number;
    items!: DensityPerSpeciesGroupDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDensityPerSpeciesGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DensityPerSpeciesGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDensityPerSpeciesGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDensityPerSpeciesGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDensityPerSpeciesGroupDto {
    totalCount: number;
    items: DensityPerSpeciesGroupDto[] | undefined;
}

export class PagedResultDtoOfDeviceDto implements IPagedResultDtoOfDeviceDto {
    totalCount!: number;
    items!: DeviceDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DeviceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDeviceDto {
    totalCount: number;
    items: DeviceDto[] | undefined;
}

export class PagedResultDtoOfDeviceForSamplingMaintenaceDto implements IPagedResultDtoOfDeviceForSamplingMaintenaceDto {
    totalCount!: number;
    items!: DeviceForSamplingMaintenaceDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDeviceForSamplingMaintenaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DeviceForSamplingMaintenaceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDeviceForSamplingMaintenaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDeviceForSamplingMaintenaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDeviceForSamplingMaintenaceDto {
    totalCount: number;
    items: DeviceForSamplingMaintenaceDto[] | undefined;
}

export class PagedResultDtoOfDiverseProductActivityReportOutputDto implements IPagedResultDtoOfDiverseProductActivityReportOutputDto {
    totalCount!: number;
    items!: DiverseProductActivityReportOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDiverseProductActivityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiverseProductActivityReportOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDiverseProductActivityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDiverseProductActivityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDiverseProductActivityReportOutputDto {
    totalCount: number;
    items: DiverseProductActivityReportOutputDto[] | undefined;
}

export class PagedResultDtoOfDiverseProductDestinationDto implements IPagedResultDtoOfDiverseProductDestinationDto {
    totalCount!: number;
    items!: DiverseProductDestinationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDiverseProductDestinationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiverseProductDestinationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDiverseProductDestinationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDiverseProductDestinationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDiverseProductDestinationDto {
    totalCount: number;
    items: DiverseProductDestinationDto[] | undefined;
}

export class PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto implements IPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto {
    totalCount!: number;
    items!: DiverseProductPreActivityReportForProviderSearchOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiverseProductPreActivityReportForProviderSearchOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDiverseProductPreActivityReportForProviderSearchOutputDto {
    totalCount: number;
    items: DiverseProductPreActivityReportForProviderSearchOutputDto[] | undefined;
}

export class PagedResultDtoOfDiverseProductsTruckTypeDto implements IPagedResultDtoOfDiverseProductsTruckTypeDto {
    totalCount!: number;
    items!: DiverseProductsTruckTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfDiverseProductsTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DiverseProductsTruckTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfDiverseProductsTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfDiverseProductsTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfDiverseProductsTruckTypeDto {
    totalCount: number;
    items: DiverseProductsTruckTypeDto[] | undefined;
}

export class PagedResultDtoOfEntityChangeListDto implements IPagedResultDtoOfEntityChangeListDto {
    totalCount!: number;
    items!: EntityChangeListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfEntityChangeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EntityChangeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfEntityChangeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfEntityChangeListDto {
    totalCount: number;
    items: EntityChangeListDto[] | undefined;
}

export class PagedResultDtoOfExternalProviderItemOutput implements IPagedResultDtoOfExternalProviderItemOutput {
    totalCount!: number;
    items!: ExternalProviderItemOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfExternalProviderItemOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ExternalProviderItemOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfExternalProviderItemOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfExternalProviderItemOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfExternalProviderItemOutput {
    totalCount: number;
    items: ExternalProviderItemOutput[] | undefined;
}

export class PagedResultDtoOfGetPlaceForViewDto implements IPagedResultDtoOfGetPlaceForViewDto {
    totalCount!: number;
    items!: GetPlaceForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPlaceForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPlaceForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPlaceForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPlaceForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPlaceForViewDto {
    totalCount: number;
    items: GetPlaceForViewDto[] | undefined;
}

export class PagedResultDtoOfGetPreReportsToArriveOutputDto implements IPagedResultDtoOfGetPreReportsToArriveOutputDto {
    totalCount!: number;
    items!: GetPreReportsToArriveOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetPreReportsToArriveOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPreReportsToArriveOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetPreReportsToArriveOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetPreReportsToArriveOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetPreReportsToArriveOutputDto {
    totalCount: number;
    items: GetPreReportsToArriveOutputDto[] | undefined;
}

export class PagedResultDtoOfGetReasonForViewDto implements IPagedResultDtoOfGetReasonForViewDto {
    totalCount!: number;
    items!: GetReasonForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetReasonForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetReasonForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetReasonForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetReasonForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetReasonForViewDto {
    totalCount: number;
    items: GetReasonForViewDto[] | undefined;
}

export class PagedResultDtoOfGetTagForViewDto implements IPagedResultDtoOfGetTagForViewDto {
    totalCount!: number;
    items!: GetTagForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetTagForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetTagForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetTagForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetTagForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetTagForViewDto {
    totalCount: number;
    items: GetTagForViewDto[] | undefined;
}

export class PagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto implements IPagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto {
    totalCount!: number;
    items!: GetWoodActivityReportsForSampleSearchOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetWoodActivityReportsForSampleSearchOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetWoodActivityReportsForSampleSearchOutputDto {
    totalCount: number;
    items: GetWoodActivityReportsForSampleSearchOutputDto[] | undefined;
}

export class PagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto implements IPagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto {
    totalCount!: number;
    items!: GetWoodControlActivityReportExternalProcessingResultForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetWoodControlActivityReportExternalProcessingResultForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfGetWoodControlActivityReportExternalProcessingResultForViewDto {
    totalCount: number;
    items: GetWoodControlActivityReportExternalProcessingResultForViewDto[] | undefined;
}

export class PagedResultDtoOfIndicatorsDto implements IPagedResultDtoOfIndicatorsDto {
    totalCount!: number;
    items!: IndicatorsDto[] | undefined;

    constructor(data?: IPagedResultDtoOfIndicatorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IndicatorsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfIndicatorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIndicatorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfIndicatorsDto {
    totalCount: number;
    items: IndicatorsDto[] | undefined;
}

export class PagedResultDtoOfIntegrationLogOutputList implements IPagedResultDtoOfIntegrationLogOutputList {
    totalCount!: number;
    items!: IntegrationLogOutputList[] | undefined;

    constructor(data?: IPagedResultDtoOfIntegrationLogOutputList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IntegrationLogOutputList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfIntegrationLogOutputList {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfIntegrationLogOutputList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfIntegrationLogOutputList {
    totalCount: number;
    items: IntegrationLogOutputList[] | undefined;
}

export class PagedResultDtoOfInternalMovementActivityReportOutputDto implements IPagedResultDtoOfInternalMovementActivityReportOutputDto {
    totalCount!: number;
    items!: InternalMovementActivityReportOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInternalMovementActivityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InternalMovementActivityReportOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInternalMovementActivityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInternalMovementActivityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfInternalMovementActivityReportOutputDto {
    totalCount: number;
    items: InternalMovementActivityReportOutputDto[] | undefined;
}

export class PagedResultDtoOfInternalMovementArticleOutputDto implements IPagedResultDtoOfInternalMovementArticleOutputDto {
    totalCount!: number;
    items!: InternalMovementArticleOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInternalMovementArticleOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InternalMovementArticleOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInternalMovementArticleOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInternalMovementArticleOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfInternalMovementArticleOutputDto {
    totalCount: number;
    items: InternalMovementArticleOutputDto[] | undefined;
}

export class PagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto implements IPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto {
    totalCount!: number;
    items!: InternalMovementPreActivityReportSearchOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(InternalMovementPreActivityReportSearchOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfInternalMovementPreActivityReportSearchOutputDto {
    totalCount: number;
    items: InternalMovementPreActivityReportSearchOutputDto[] | undefined;
}

export class PagedResultDtoOfLanguageTextListDto implements IPagedResultDtoOfLanguageTextListDto {
    totalCount!: number;
    items!: LanguageTextListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLanguageTextListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LanguageTextListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLanguageTextListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLanguageTextListDto {
    totalCount: number;
    items: LanguageTextListDto[] | undefined;
}

export class PagedResultDtoOfLinkedUserDto implements IPagedResultDtoOfLinkedUserDto {
    totalCount!: number;
    items!: LinkedUserDto[] | undefined;

    constructor(data?: IPagedResultDtoOfLinkedUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LinkedUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfLinkedUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfLinkedUserDto {
    totalCount: number;
    items: LinkedUserDto[] | undefined;
}

export class PagedResultDtoOfNameValueDto implements IPagedResultDtoOfNameValueDto {
    totalCount!: number;
    items!: NameValueDto[] | undefined;

    constructor(data?: IPagedResultDtoOfNameValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfNameValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfNameValueDto {
    totalCount: number;
    items: NameValueDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitRoleListDto implements IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount!: number;
    items!: OrganizationUnitRoleListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitRoleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitRoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitRoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitRoleListDto {
    totalCount: number;
    items: OrganizationUnitRoleListDto[] | undefined;
}

export class PagedResultDtoOfOrganizationUnitUserListDto implements IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount!: number;
    items!: OrganizationUnitUserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfOrganizationUnitUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(OrganizationUnitUserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfOrganizationUnitUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfOrganizationUnitUserListDto {
    totalCount: number;
    items: OrganizationUnitUserListDto[] | undefined;
}

export class PagedResultDtoOfParameterDto implements IPagedResultDtoOfParameterDto {
    totalCount!: number;
    items!: ParameterDto[] | undefined;

    constructor(data?: IPagedResultDtoOfParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfParameterDto {
    totalCount: number;
    items: ParameterDto[] | undefined;
}

export class PagedResultDtoOfPileDto implements IPagedResultDtoOfPileDto {
    totalCount!: number;
    items!: PileDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PileDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPileDto {
    totalCount: number;
    items: PileDto[] | undefined;
}

export class PagedResultDtoOfPlaceDto implements IPagedResultDtoOfPlaceDto {
    totalCount!: number;
    items!: PlaceDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PlaceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPlaceDto {
    totalCount: number;
    items: PlaceDto[] | undefined;
}

export class PagedResultDtoOfPolygonContractDto implements IPagedResultDtoOfPolygonContractDto {
    totalCount!: number;
    items!: PolygonContractDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPolygonContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PolygonContractDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPolygonContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPolygonContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPolygonContractDto {
    totalCount: number;
    items: PolygonContractDto[] | undefined;
}

export class PagedResultDtoOfPreWoodActivityReportOutputDto implements IPagedResultDtoOfPreWoodActivityReportOutputDto {
    totalCount!: number;
    items!: PreWoodActivityReportOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfPreWoodActivityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PreWoodActivityReportOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfPreWoodActivityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfPreWoodActivityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfPreWoodActivityReportOutputDto {
    totalCount: number;
    items: PreWoodActivityReportOutputDto[] | undefined;
}

export class PagedResultDtoOfRandomSampleAssignationOutputDto implements IPagedResultDtoOfRandomSampleAssignationOutputDto {
    totalCount!: number;
    items!: RandomSampleAssignationOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRandomSampleAssignationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RandomSampleAssignationOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRandomSampleAssignationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRandomSampleAssignationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRandomSampleAssignationOutputDto {
    totalCount: number;
    items: RandomSampleAssignationOutputDto[] | undefined;
}

export class PagedResultDtoOfRandomStatisticalSampleQuotaDto implements IPagedResultDtoOfRandomStatisticalSampleQuotaDto {
    totalCount!: number;
    items!: RandomStatisticalSampleQuotaDto[] | undefined;

    constructor(data?: IPagedResultDtoOfRandomStatisticalSampleQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RandomStatisticalSampleQuotaDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfRandomStatisticalSampleQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfRandomStatisticalSampleQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfRandomStatisticalSampleQuotaDto {
    totalCount: number;
    items: RandomStatisticalSampleQuotaDto[] | undefined;
}

export class PagedResultDtoOfScaleCalibrationForViewDto implements IPagedResultDtoOfScaleCalibrationForViewDto {
    totalCount!: number;
    items!: ScaleCalibrationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfScaleCalibrationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScaleCalibrationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfScaleCalibrationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfScaleCalibrationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfScaleCalibrationForViewDto {
    totalCount: number;
    items: ScaleCalibrationForViewDto[] | undefined;
}

export class PagedResultDtoOfScannerCalibrationForViewDto implements IPagedResultDtoOfScannerCalibrationForViewDto {
    totalCount!: number;
    items!: ScannerCalibrationForViewDto[] | undefined;

    constructor(data?: IPagedResultDtoOfScannerCalibrationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScannerCalibrationForViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfScannerCalibrationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfScannerCalibrationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfScannerCalibrationForViewDto {
    totalCount: number;
    items: ScannerCalibrationForViewDto[] | undefined;
}

export class PagedResultDtoOfSearchReportByProviderOutputDto implements IPagedResultDtoOfSearchReportByProviderOutputDto {
    totalCount!: number;
    items!: SearchReportByProviderOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSearchReportByProviderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchReportByProviderOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSearchReportByProviderOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSearchReportByProviderOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSearchReportByProviderOutputDto {
    totalCount: number;
    items: SearchReportByProviderOutputDto[] | undefined;
}

export class PagedResultDtoOfSearchReportOutputDto implements IPagedResultDtoOfSearchReportOutputDto {
    totalCount!: number;
    items!: SearchReportOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSearchReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchReportOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSearchReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSearchReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSearchReportOutputDto {
    totalCount: number;
    items: SearchReportOutputDto[] | undefined;
}

export class PagedResultDtoOfSearchWoodVendorQuotaOutputDto implements IPagedResultDtoOfSearchWoodVendorQuotaOutputDto {
    totalCount!: number;
    items!: SearchWoodVendorQuotaOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSearchWoodVendorQuotaOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SearchWoodVendorQuotaOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSearchWoodVendorQuotaOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSearchWoodVendorQuotaOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSearchWoodVendorQuotaOutputDto {
    totalCount: number;
    items: SearchWoodVendorQuotaOutputDto[] | undefined;
}

export class PagedResultDtoOfServiceConfigurationDto implements IPagedResultDtoOfServiceConfigurationDto {
    totalCount!: number;
    items!: ServiceConfigurationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfServiceConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfServiceConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfServiceConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfServiceConfigurationDto {
    totalCount: number;
    items: ServiceConfigurationDto[] | undefined;
}

export class PagedResultDtoOfSubscriptionPaymentListDto implements IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount!: number;
    items!: SubscriptionPaymentListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfSubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SubscriptionPaymentListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfSubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfSubscriptionPaymentListDto {
    totalCount: number;
    items: SubscriptionPaymentListDto[] | undefined;
}

export class PagedResultDtoOfTenantListDto implements IPagedResultDtoOfTenantListDto {
    totalCount!: number;
    items!: TenantListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfTenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TenantListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfTenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfTenantListDto {
    totalCount: number;
    items: TenantListDto[] | undefined;
}

export class PagedResultDtoOfUserDelegationDto implements IPagedResultDtoOfUserDelegationDto {
    totalCount!: number;
    items!: UserDelegationDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserDelegationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserDelegationDto {
    totalCount: number;
    items: UserDelegationDto[] | undefined;
}

export class PagedResultDtoOfUserListDto implements IPagedResultDtoOfUserListDto {
    totalCount!: number;
    items!: UserListDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserListDto {
    totalCount: number;
    items: UserListDto[] | undefined;
}

export class PagedResultDtoOfUserVendorDto implements IPagedResultDtoOfUserVendorDto {
    totalCount!: number;
    items!: UserVendorDto[] | undefined;

    constructor(data?: IPagedResultDtoOfUserVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UserVendorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfUserVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfUserVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfUserVendorDto {
    totalCount: number;
    items: UserVendorDto[] | undefined;
}

export class PagedResultDtoOfWaterDensityAuditoryDto implements IPagedResultDtoOfWaterDensityAuditoryDto {
    totalCount!: number;
    items!: WaterDensityAuditoryDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWaterDensityAuditoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WaterDensityAuditoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWaterDensityAuditoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWaterDensityAuditoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWaterDensityAuditoryDto {
    totalCount: number;
    items: WaterDensityAuditoryDto[] | undefined;
}

export class PagedResultDtoOfWoodActivityReportDto implements IPagedResultDtoOfWoodActivityReportDto {
    totalCount!: number;
    items!: WoodActivityReportDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodActivityReportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodActivityReportDto {
    totalCount: number;
    items: WoodActivityReportDto[] | undefined;
}

export class PagedResultDtoOfWoodActivityReportForMassEditGridDto implements IPagedResultDtoOfWoodActivityReportForMassEditGridDto {
    totalCount!: number;
    items!: WoodActivityReportForMassEditGridDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodActivityReportForMassEditGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodActivityReportForMassEditGridDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodActivityReportForMassEditGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodActivityReportForMassEditGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodActivityReportForMassEditGridDto {
    totalCount: number;
    items: WoodActivityReportForMassEditGridDto[] | undefined;
}

export class PagedResultDtoOfWoodActivityReportForSamplesGridOutputDto implements IPagedResultDtoOfWoodActivityReportForSamplesGridOutputDto {
    totalCount!: number;
    items!: WoodActivityReportForSamplesGridOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodActivityReportForSamplesGridOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodActivityReportForSamplesGridOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodActivityReportForSamplesGridOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodActivityReportForSamplesGridOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodActivityReportForSamplesGridOutputDto {
    totalCount: number;
    items: WoodActivityReportForSamplesGridOutputDto[] | undefined;
}

export class PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto implements IPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto {
    totalCount!: number;
    items!: WoodPreActivityReportForProviderSearchOutputDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodPreActivityReportForProviderSearchOutputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodPreActivityReportForProviderSearchOutputDto {
    totalCount: number;
    items: WoodPreActivityReportForProviderSearchOutputDto[] | undefined;
}

export class PagedResultDtoOfWoodReceiptItemReportOutput implements IPagedResultDtoOfWoodReceiptItemReportOutput {
    totalCount!: number;
    items!: WoodReceiptItemReportOutput[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodReceiptItemReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodReceiptItemReportOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodReceiptItemReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodReceiptItemReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodReceiptItemReportOutput {
    totalCount: number;
    items: WoodReceiptItemReportOutput[] | undefined;
}

export class PagedResultDtoOfWoodTruckTypeDto implements IPagedResultDtoOfWoodTruckTypeDto {
    totalCount!: number;
    items!: WoodTruckTypeDto[] | undefined;

    constructor(data?: IPagedResultDtoOfWoodTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodTruckTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfWoodTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfWoodTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfWoodTruckTypeDto {
    totalCount: number;
    items: WoodTruckTypeDto[] | undefined;
}

export class PagedResultDtoOfZoneInCollectionDto implements IPagedResultDtoOfZoneInCollectionDto {
    totalCount!: number;
    items!: ZoneInCollectionDto[] | undefined;

    constructor(data?: IPagedResultDtoOfZoneInCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ZoneInCollectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfZoneInCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfZoneInCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfZoneInCollectionDto {
    totalCount: number;
    items: ZoneInCollectionDto[] | undefined;
}

export class PagedResultDtoOfZonesDto implements IPagedResultDtoOfZonesDto {
    totalCount!: number;
    items!: ZonesDto[] | undefined;

    constructor(data?: IPagedResultDtoOfZonesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ZonesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedResultDtoOfZonesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultDtoOfZonesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedResultDtoOfZonesDto {
    totalCount: number;
    items: ZonesDto[] | undefined;
}

export enum ParameterAttributes {
    None = "None",
    In = "In",
    Out = "Out",
    Lcid = "Lcid",
    Retval = "Retval",
    Optional = "Optional",
    HasDefault = "HasDefault",
    HasFieldMarshal = "HasFieldMarshal",
    Reserved3 = "Reserved3",
    Reserved4 = "Reserved4",
    ReservedMask = "ReservedMask",
}

export class ParameterDto implements IParameterDto {
    code!: string | undefined;
    displayName!: string | undefined;
    type!: ParameterType;
    valueString!: string | undefined;
    valueNumber!: number | undefined;
    valueDate!: DateTime | undefined;
    valueBoolean!: boolean | undefined;
    placeId!: number;
    id!: number;

    constructor(data?: IParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.displayName = _data["displayName"];
            this.type = _data["type"];
            this.valueString = _data["valueString"];
            this.valueNumber = _data["valueNumber"];
            this.valueDate = _data["valueDate"] ? DateTime.fromISO(_data["valueDate"].toString()) : <any>undefined;
            this.valueBoolean = _data["valueBoolean"];
            this.placeId = _data["placeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["type"] = this.type;
        data["valueString"] = this.valueString;
        data["valueNumber"] = this.valueNumber;
        data["valueDate"] = this.valueDate ? this.valueDate.toString() : <any>undefined;
        data["valueBoolean"] = this.valueBoolean;
        data["placeId"] = this.placeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IParameterDto {
    code: string | undefined;
    displayName: string | undefined;
    type: ParameterType;
    valueString: string | undefined;
    valueNumber: number | undefined;
    valueDate: DateTime | undefined;
    valueBoolean: boolean | undefined;
    placeId: number;
    id: number;
}

export class ParameterInfo implements IParameterInfo {
    readonly attributes!: ParameterAttributes;
    readonly member!: MemberInfo | undefined;
    readonly name!: string | undefined;
    readonly parameterType!: string | undefined;
    readonly position!: number;
    readonly isIn!: boolean;
    readonly isLcid!: boolean;
    readonly isOptional!: boolean;
    readonly isOut!: boolean;
    readonly isRetval!: boolean;
    readonly defaultValue!: any | undefined;
    readonly rawDefaultValue!: any | undefined;
    readonly hasDefaultValue!: boolean;
    readonly customAttributes!: CustomAttributeData[] | undefined;
    readonly metadataToken!: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).attributes = _data["attributes"];
            (<any>this).member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : <any>undefined;
            (<any>this).name = _data["name"];
            (<any>this).parameterType = _data["parameterType"];
            (<any>this).position = _data["position"];
            (<any>this).isIn = _data["isIn"];
            (<any>this).isLcid = _data["isLcid"];
            (<any>this).isOptional = _data["isOptional"];
            (<any>this).isOut = _data["isOut"];
            (<any>this).isRetval = _data["isRetval"];
            (<any>this).defaultValue = _data["defaultValue"];
            (<any>this).rawDefaultValue = _data["rawDefaultValue"];
            (<any>this).hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                (<any>this).customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    (<any>this).customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            (<any>this).metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item.toJSON());
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes: ParameterAttributes;
    member: MemberInfo | undefined;
    name: string | undefined;
    parameterType: string | undefined;
    position: number;
    isIn: boolean;
    isLcid: boolean;
    isOptional: boolean;
    isOut: boolean;
    isRetval: boolean;
    defaultValue: any | undefined;
    rawDefaultValue: any | undefined;
    hasDefaultValue: boolean;
    customAttributes: CustomAttributeData[] | undefined;
    metadataToken: number;
}

export enum ParameterType {
    Number = "Number",
    String = "String",
    DateTime = "DateTime",
    Boolean = "Boolean",
}

export class ParameterTypeDto implements IParameterTypeDto {
    id!: number;
    type!: string | undefined;

    constructor(data?: IParameterTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ParameterTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IParameterTypeDto {
    id: number;
    type: string | undefined;
}

export class PasswordComplexitySetting implements IPasswordComplexitySetting {
    requireDigit!: boolean;
    requireLowercase!: boolean;
    requireNonAlphanumeric!: boolean;
    requireUppercase!: boolean;
    requiredLength!: number;

    constructor(data?: IPasswordComplexitySetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requireDigit = _data["requireDigit"];
            this.requireLowercase = _data["requireLowercase"];
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"];
            this.requireUppercase = _data["requireUppercase"];
            this.requiredLength = _data["requiredLength"];
        }
    }

    static fromJS(data: any): PasswordComplexitySetting {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    }
}

export interface IPasswordComplexitySetting {
    requireDigit: boolean;
    requireLowercase: boolean;
    requireNonAlphanumeric: boolean;
    requireUppercase: boolean;
    requiredLength: number;
}

export class PaymentGatewayModel implements IPaymentGatewayModel {
    gatewayType!: SubscriptionPaymentGatewayType;
    supportsRecurringPayments!: boolean;

    constructor(data?: IPaymentGatewayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gatewayType = _data["gatewayType"];
            this.supportsRecurringPayments = _data["supportsRecurringPayments"];
        }
    }

    static fromJS(data: any): PaymentGatewayModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentGatewayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data;
    }
}

export interface IPaymentGatewayModel {
    gatewayType: SubscriptionPaymentGatewayType;
    supportsRecurringPayments: boolean;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    edition!: EditionSelectDto | undefined;
    additionalPrice!: number;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionSelectDto.fromJS(_data["edition"]) : <any>undefined;
            this.additionalPrice = _data["additionalPrice"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    }
}

export interface IPaymentInfoDto {
    edition: EditionSelectDto | undefined;
    additionalPrice: number;
}

export enum PaymentPeriodType {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Annual = "Annual",
}

export class PayPalConfigurationDto implements IPayPalConfigurationDto {
    clientId!: string | undefined;
    demoUsername!: string | undefined;
    demoPassword!: string | undefined;

    constructor(data?: IPayPalConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.demoUsername = _data["demoUsername"];
            this.demoPassword = _data["demoPassword"];
        }
    }

    static fromJS(data: any): PayPalConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        return data;
    }
}

export interface IPayPalConfigurationDto {
    clientId: string | undefined;
    demoUsername: string | undefined;
    demoPassword: string | undefined;
}

export class PendingSamplesAssignmentDto implements IPendingSamplesAssignmentDto {
    pendingSamplesCounter!: number;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    message!: string | undefined;
    items!: GetPendingSamplesIndicatorItemDto[] | undefined;

    constructor(data?: IPendingSamplesAssignmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pendingSamplesCounter = _data["pendingSamplesCounter"];
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.message = _data["message"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GetPendingSamplesIndicatorItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PendingSamplesAssignmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PendingSamplesAssignmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pendingSamplesCounter"] = this.pendingSamplesCounter;
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["message"] = this.message;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPendingSamplesAssignmentDto {
    pendingSamplesCounter: number;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    message: string | undefined;
    items: GetPendingSamplesIndicatorItemDto[] | undefined;
}

export class PeriodDto implements IPeriodDto {
    id!: number;
    startDatePeriod!: DateTime;
    endDatePeriod!: DateTime;

    constructor(data?: IPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDatePeriod = _data["startDatePeriod"] ? DateTime.fromISO(_data["startDatePeriod"].toString()) : <any>undefined;
            this.endDatePeriod = _data["endDatePeriod"] ? DateTime.fromISO(_data["endDatePeriod"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDatePeriod"] = this.startDatePeriod ? this.startDatePeriod.toString() : <any>undefined;
        data["endDatePeriod"] = this.endDatePeriod ? this.endDatePeriod.toString() : <any>undefined;
        return data;
    }
}

export interface IPeriodDto {
    id: number;
    startDatePeriod: DateTime;
    endDatePeriod: DateTime;
}

export class PeriodInputDto implements IPeriodInputDto {
    externalId!: number;
    startDatePeriod!: DateTime;
    endDatePeriod!: DateTime;

    constructor(data?: IPeriodInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.startDatePeriod = _data["startDatePeriod"] ? DateTime.fromISO(_data["startDatePeriod"].toString()) : <any>undefined;
            this.endDatePeriod = _data["endDatePeriod"] ? DateTime.fromISO(_data["endDatePeriod"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PeriodInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["startDatePeriod"] = this.startDatePeriod ? this.startDatePeriod.toString() : <any>undefined;
        data["endDatePeriod"] = this.endDatePeriod ? this.endDatePeriod.toString() : <any>undefined;
        return data;
    }
}

export interface IPeriodInputDto {
    externalId: number;
    startDatePeriod: DateTime;
    endDatePeriod: DateTime;
}

export class PileDto implements IPileDto {
    id!: number;
    pileExternalId!: number;
    pileType!: PileType;
    name!: string | undefined;
    number!: number;
    article!: ArticleDto | undefined;
    articleExternalId!: number;
    isPefcCertified!: boolean;
    isFscCertified!: boolean;
    contractTypeGroupExternalId!: number;
    geneticMaterialTypeExternalId!: number;
    pileOrigins!: PileOriginDto[] | undefined;
    allowsEntry!: boolean;
    allowsExit!: boolean;
    pileStatus!: PileStatus;
    placeId!: number;
    placeExternalId!: number;

    constructor(data?: IPileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.pileExternalId = _data["pileExternalId"];
            this.pileType = _data["pileType"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.article = _data["article"] ? ArticleDto.fromJS(_data["article"]) : <any>undefined;
            this.articleExternalId = _data["articleExternalId"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.isFscCertified = _data["isFscCertified"];
            this.contractTypeGroupExternalId = _data["contractTypeGroupExternalId"];
            this.geneticMaterialTypeExternalId = _data["geneticMaterialTypeExternalId"];
            if (Array.isArray(_data["pileOrigins"])) {
                this.pileOrigins = [] as any;
                for (let item of _data["pileOrigins"])
                    this.pileOrigins!.push(PileOriginDto.fromJS(item));
            }
            this.allowsEntry = _data["allowsEntry"];
            this.allowsExit = _data["allowsExit"];
            this.pileStatus = _data["pileStatus"];
            this.placeId = _data["placeId"];
            this.placeExternalId = _data["placeExternalId"];
        }
    }

    static fromJS(data: any): PileDto {
        data = typeof data === 'object' ? data : {};
        let result = new PileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["pileExternalId"] = this.pileExternalId;
        data["pileType"] = this.pileType;
        data["name"] = this.name;
        data["number"] = this.number;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["articleExternalId"] = this.articleExternalId;
        data["isPefcCertified"] = this.isPefcCertified;
        data["isFscCertified"] = this.isFscCertified;
        data["contractTypeGroupExternalId"] = this.contractTypeGroupExternalId;
        data["geneticMaterialTypeExternalId"] = this.geneticMaterialTypeExternalId;
        if (Array.isArray(this.pileOrigins)) {
            data["pileOrigins"] = [];
            for (let item of this.pileOrigins)
                data["pileOrigins"].push(item.toJSON());
        }
        data["allowsEntry"] = this.allowsEntry;
        data["allowsExit"] = this.allowsExit;
        data["pileStatus"] = this.pileStatus;
        data["placeId"] = this.placeId;
        data["placeExternalId"] = this.placeExternalId;
        return data;
    }
}

export interface IPileDto {
    id: number;
    pileExternalId: number;
    pileType: PileType;
    name: string | undefined;
    number: number;
    article: ArticleDto | undefined;
    articleExternalId: number;
    isPefcCertified: boolean;
    isFscCertified: boolean;
    contractTypeGroupExternalId: number;
    geneticMaterialTypeExternalId: number;
    pileOrigins: PileOriginDto[] | undefined;
    allowsEntry: boolean;
    allowsExit: boolean;
    pileStatus: PileStatus;
    placeId: number;
    placeExternalId: number;
}

export class PileForReportCreationOutputDto implements IPileForReportCreationOutputDto {
    id!: number;
    name!: string | undefined;
    pileStatus!: PileStatus;
    externalId!: number;
    articleExternalId!: number;

    constructor(data?: IPileForReportCreationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.pileStatus = _data["pileStatus"];
            this.externalId = _data["externalId"];
            this.articleExternalId = _data["articleExternalId"];
        }
    }

    static fromJS(data: any): PileForReportCreationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PileForReportCreationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["pileStatus"] = this.pileStatus;
        data["externalId"] = this.externalId;
        data["articleExternalId"] = this.articleExternalId;
        return data;
    }
}

export interface IPileForReportCreationOutputDto {
    id: number;
    name: string | undefined;
    pileStatus: PileStatus;
    externalId: number;
    articleExternalId: number;
}

export class PileOriginDto implements IPileOriginDto {
    externalId!: number;
    pileOriginType!: PileOriginType;

    constructor(data?: IPileOriginDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.pileOriginType = _data["pileOriginType"];
        }
    }

    static fromJS(data: any): PileOriginDto {
        data = typeof data === 'object' ? data : {};
        let result = new PileOriginDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["pileOriginType"] = this.pileOriginType;
        return data;
    }
}

export interface IPileOriginDto {
    externalId: number;
    pileOriginType: PileOriginType;
}

export enum PileOriginType {
    Stand = "Stand",
    ThirdProperty = "ThirdProperty",
    Logyard = "Logyard",
}

export enum PileStatus {
    Active = "Active",
    Inactive = "Inactive",
    Closed = "Closed",
}

export enum PileType {
    Simple = "Simple",
    Mix = "Mix",
}

export class PlaceConfigurationDto implements IPlaceConfigurationDto {
    placeId!: number;
    isActive!: boolean;
    zones!: ZoneConfigurationDto[] | undefined;

    constructor(data?: IPlaceConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(ZoneConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlaceConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlaceConfigurationDto {
    placeId: number;
    isActive: boolean;
    zones: ZoneConfigurationDto[] | undefined;
}

export class PlaceDepartmentDto implements IPlaceDepartmentDto {
    id!: number;
    department!: string | undefined;

    constructor(data?: IPlaceDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.department = _data["department"];
        }
    }

    static fromJS(data: any): PlaceDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["department"] = this.department;
        return data;
    }
}

export interface IPlaceDepartmentDto {
    id: number;
    department: string | undefined;
}

export class PlaceDto implements IPlaceDto {
    name!: string | undefined;
    initials!: string | undefined;
    active!: boolean;
    latitude!: number;
    longitude!: number;
    placeDepartment!: PlaceDepartmentDto | undefined;
    placeType!: PlaceTypeDto | undefined;
    zones!: ZoneInPlaceDto[] | undefined;
    placeDepartmentId!: number;
    placeTypeId!: number;
    location!: LocationInPlaceDto | undefined;
    locationId!: number;
    externalId!: number;
    hasWoodScanner!: boolean;
    hasYardAssignmentAutomation!: boolean;
    integrationConfiguration!: IntegrationConfigurationDto | undefined;
    smartGatewayUrl!: string | undefined;
    supportsOffline!: boolean;
    isForExportation!: boolean;
    placeExternalIntegrationsTypes!: PlaceExternalIntegrationsType[] | undefined;
    acceptPreReceipt!: boolean;
    id!: number;

    constructor(data?: IPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.initials = _data["initials"];
            this.active = _data["active"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.placeDepartment = _data["placeDepartment"] ? PlaceDepartmentDto.fromJS(_data["placeDepartment"]) : <any>undefined;
            this.placeType = _data["placeType"] ? PlaceTypeDto.fromJS(_data["placeType"]) : <any>undefined;
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(ZoneInPlaceDto.fromJS(item));
            }
            this.placeDepartmentId = _data["placeDepartmentId"];
            this.placeTypeId = _data["placeTypeId"];
            this.location = _data["location"] ? LocationInPlaceDto.fromJS(_data["location"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.externalId = _data["externalId"];
            this.hasWoodScanner = _data["hasWoodScanner"];
            this.hasYardAssignmentAutomation = _data["hasYardAssignmentAutomation"];
            this.integrationConfiguration = _data["integrationConfiguration"] ? IntegrationConfigurationDto.fromJS(_data["integrationConfiguration"]) : <any>undefined;
            this.smartGatewayUrl = _data["smartGatewayUrl"];
            this.supportsOffline = _data["supportsOffline"];
            this.isForExportation = _data["isForExportation"];
            if (Array.isArray(_data["placeExternalIntegrationsTypes"])) {
                this.placeExternalIntegrationsTypes = [] as any;
                for (let item of _data["placeExternalIntegrationsTypes"])
                    this.placeExternalIntegrationsTypes!.push(item);
            }
            this.acceptPreReceipt = _data["acceptPreReceipt"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["initials"] = this.initials;
        data["active"] = this.active;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["placeDepartment"] = this.placeDepartment ? this.placeDepartment.toJSON() : <any>undefined;
        data["placeType"] = this.placeType ? this.placeType.toJSON() : <any>undefined;
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item.toJSON());
        }
        data["placeDepartmentId"] = this.placeDepartmentId;
        data["placeTypeId"] = this.placeTypeId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["externalId"] = this.externalId;
        data["hasWoodScanner"] = this.hasWoodScanner;
        data["hasYardAssignmentAutomation"] = this.hasYardAssignmentAutomation;
        data["integrationConfiguration"] = this.integrationConfiguration ? this.integrationConfiguration.toJSON() : <any>undefined;
        data["smartGatewayUrl"] = this.smartGatewayUrl;
        data["supportsOffline"] = this.supportsOffline;
        data["isForExportation"] = this.isForExportation;
        if (Array.isArray(this.placeExternalIntegrationsTypes)) {
            data["placeExternalIntegrationsTypes"] = [];
            for (let item of this.placeExternalIntegrationsTypes)
                data["placeExternalIntegrationsTypes"].push(item);
        }
        data["acceptPreReceipt"] = this.acceptPreReceipt;
        data["id"] = this.id;
        return data;
    }
}

export interface IPlaceDto {
    name: string | undefined;
    initials: string | undefined;
    active: boolean;
    latitude: number;
    longitude: number;
    placeDepartment: PlaceDepartmentDto | undefined;
    placeType: PlaceTypeDto | undefined;
    zones: ZoneInPlaceDto[] | undefined;
    placeDepartmentId: number;
    placeTypeId: number;
    location: LocationInPlaceDto | undefined;
    locationId: number;
    externalId: number;
    hasWoodScanner: boolean;
    hasYardAssignmentAutomation: boolean;
    integrationConfiguration: IntegrationConfigurationDto | undefined;
    smartGatewayUrl: string | undefined;
    supportsOffline: boolean;
    isForExportation: boolean;
    placeExternalIntegrationsTypes: PlaceExternalIntegrationsType[] | undefined;
    acceptPreReceipt: boolean;
    id: number;
}

export class PlaceErpInformationDto implements IPlaceErpInformationDto {
    erpCode!: string | undefined;

    constructor(data?: IPlaceErpInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpCode = _data["erpCode"];
        }
    }

    static fromJS(data: any): PlaceErpInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceErpInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpCode"] = this.erpCode;
        return data;
    }
}

export interface IPlaceErpInformationDto {
    erpCode: string | undefined;
}

export enum PlaceExternalIntegrationsType {
    Sicfe = "Sicfe",
    SDA = "SDA",
    SIGE = "SIGE",
    JaumeSere = "JaumeSere",
    Smartrip = "Smartrip",
    Alutel = "Alutel",
    SmartLogyard = "SmartLogyard",
    SmartLogyardMultisite = "SmartLogyardMultisite",
    SmartInvoicing = "SmartInvoicing",
}

export class PlaceExternalServicesConfigurationDto implements IPlaceExternalServicesConfigurationDto {
    placeId!: number;
    placeExternalId!: number;
    sdaIsActive!: boolean;
    smartTripActive!: boolean;
    alutelIsActive!: boolean;
    smartLogyardIsActive!: boolean;
    smartLogyardMultisiteIsActive!: boolean;
    smartGatewayUrl!: string | undefined;

    constructor(data?: IPlaceExternalServicesConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.placeExternalId = _data["placeExternalId"];
            this.sdaIsActive = _data["sdaIsActive"];
            this.smartTripActive = _data["smartTripActive"];
            this.alutelIsActive = _data["alutelIsActive"];
            this.smartLogyardIsActive = _data["smartLogyardIsActive"];
            this.smartLogyardMultisiteIsActive = _data["smartLogyardMultisiteIsActive"];
            this.smartGatewayUrl = _data["smartGatewayUrl"];
        }
    }

    static fromJS(data: any): PlaceExternalServicesConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceExternalServicesConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["placeExternalId"] = this.placeExternalId;
        data["sdaIsActive"] = this.sdaIsActive;
        data["smartTripActive"] = this.smartTripActive;
        data["alutelIsActive"] = this.alutelIsActive;
        data["smartLogyardIsActive"] = this.smartLogyardIsActive;
        data["smartLogyardMultisiteIsActive"] = this.smartLogyardMultisiteIsActive;
        data["smartGatewayUrl"] = this.smartGatewayUrl;
        return data;
    }
}

export interface IPlaceExternalServicesConfigurationDto {
    placeId: number;
    placeExternalId: number;
    sdaIsActive: boolean;
    smartTripActive: boolean;
    alutelIsActive: boolean;
    smartLogyardIsActive: boolean;
    smartLogyardMultisiteIsActive: boolean;
    smartGatewayUrl: string | undefined;
}

export class PlaceInZoneDto implements IPlaceInZoneDto {
    id!: number;
    name!: string | undefined;
    idBioforest!: number | undefined;
    active!: boolean;
    latitude!: number;
    longitude!: number;
    placeDepartment!: PlaceDepartmentDto | undefined;
    placeType!: PlaceTypeDto | undefined;
    hasWoodScanner!: boolean;
    hasYardAssignmentAutomation!: boolean;
    location!: LocationInPlaceDto | undefined;
    locationId!: number;
    externalPlaceId!: number;
    smartGatewayUrl!: string | undefined;

    constructor(data?: IPlaceInZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.idBioforest = _data["idBioforest"];
            this.active = _data["active"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.placeDepartment = _data["placeDepartment"] ? PlaceDepartmentDto.fromJS(_data["placeDepartment"]) : <any>undefined;
            this.placeType = _data["placeType"] ? PlaceTypeDto.fromJS(_data["placeType"]) : <any>undefined;
            this.hasWoodScanner = _data["hasWoodScanner"];
            this.hasYardAssignmentAutomation = _data["hasYardAssignmentAutomation"];
            this.location = _data["location"] ? LocationInPlaceDto.fromJS(_data["location"]) : <any>undefined;
            this.locationId = _data["locationId"];
            this.externalPlaceId = _data["externalPlaceId"];
            this.smartGatewayUrl = _data["smartGatewayUrl"];
        }
    }

    static fromJS(data: any): PlaceInZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceInZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["idBioforest"] = this.idBioforest;
        data["active"] = this.active;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["placeDepartment"] = this.placeDepartment ? this.placeDepartment.toJSON() : <any>undefined;
        data["placeType"] = this.placeType ? this.placeType.toJSON() : <any>undefined;
        data["hasWoodScanner"] = this.hasWoodScanner;
        data["hasYardAssignmentAutomation"] = this.hasYardAssignmentAutomation;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["locationId"] = this.locationId;
        data["externalPlaceId"] = this.externalPlaceId;
        data["smartGatewayUrl"] = this.smartGatewayUrl;
        return data;
    }
}

export interface IPlaceInZoneDto {
    id: number;
    name: string | undefined;
    idBioforest: number | undefined;
    active: boolean;
    latitude: number;
    longitude: number;
    placeDepartment: PlaceDepartmentDto | undefined;
    placeType: PlaceTypeDto | undefined;
    hasWoodScanner: boolean;
    hasYardAssignmentAutomation: boolean;
    location: LocationInPlaceDto | undefined;
    locationId: number;
    externalPlaceId: number;
    smartGatewayUrl: string | undefined;
}

export class PlacesDtoInput implements IPlacesDtoInput {
    name!: string | undefined;
    initials!: string | undefined;
    externalId!: number;
    active!: boolean;
    latitude!: number;
    longitude!: number;
    placeDepartmentId!: number;
    placeTypeId!: number;
    zones!: ZonesDto[] | undefined;
    hasWoodScanner!: boolean;
    hasYardAssignmentAutomation!: boolean;
    integrationConfiguration!: IntegrationConfigurationDto | undefined;
    smartGatewayUrl!: string | undefined;
    isForExportation!: boolean;
    id!: number;

    constructor(data?: IPlacesDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.initials = _data["initials"];
            this.externalId = _data["externalId"];
            this.active = _data["active"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.placeDepartmentId = _data["placeDepartmentId"];
            this.placeTypeId = _data["placeTypeId"];
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(ZonesDto.fromJS(item));
            }
            this.hasWoodScanner = _data["hasWoodScanner"];
            this.hasYardAssignmentAutomation = _data["hasYardAssignmentAutomation"];
            this.integrationConfiguration = _data["integrationConfiguration"] ? IntegrationConfigurationDto.fromJS(_data["integrationConfiguration"]) : <any>undefined;
            this.smartGatewayUrl = _data["smartGatewayUrl"];
            this.isForExportation = _data["isForExportation"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlacesDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new PlacesDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["initials"] = this.initials;
        data["externalId"] = this.externalId;
        data["active"] = this.active;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["placeDepartmentId"] = this.placeDepartmentId;
        data["placeTypeId"] = this.placeTypeId;
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item.toJSON());
        }
        data["hasWoodScanner"] = this.hasWoodScanner;
        data["hasYardAssignmentAutomation"] = this.hasYardAssignmentAutomation;
        data["integrationConfiguration"] = this.integrationConfiguration ? this.integrationConfiguration.toJSON() : <any>undefined;
        data["smartGatewayUrl"] = this.smartGatewayUrl;
        data["isForExportation"] = this.isForExportation;
        data["id"] = this.id;
        return data;
    }
}

export interface IPlacesDtoInput {
    name: string | undefined;
    initials: string | undefined;
    externalId: number;
    active: boolean;
    latitude: number;
    longitude: number;
    placeDepartmentId: number;
    placeTypeId: number;
    zones: ZonesDto[] | undefined;
    hasWoodScanner: boolean;
    hasYardAssignmentAutomation: boolean;
    integrationConfiguration: IntegrationConfigurationDto | undefined;
    smartGatewayUrl: string | undefined;
    isForExportation: boolean;
    id: number;
}

export class PlacesDtoUpdateInput implements IPlacesDtoUpdateInput {
    name!: string | undefined;
    initials!: string | undefined;
    active!: boolean;
    latitude!: number;
    longitude!: number;
    placeDepartmentId!: number;
    placeTypeId!: number;
    zones!: ZoneInPlaceDto[] | undefined;
    externalId!: number;
    hasWoodScanner!: boolean;
    hasYardAssignmentAutomation!: boolean;
    integrationConfiguration!: IntegrationConfigurationDto | undefined;
    smartGatewayUrl!: string | undefined;
    isForExportation!: boolean;
    acceptPreReceipt!: boolean;
    id!: number;

    constructor(data?: IPlacesDtoUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.initials = _data["initials"];
            this.active = _data["active"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.placeDepartmentId = _data["placeDepartmentId"];
            this.placeTypeId = _data["placeTypeId"];
            if (Array.isArray(_data["zones"])) {
                this.zones = [] as any;
                for (let item of _data["zones"])
                    this.zones!.push(ZoneInPlaceDto.fromJS(item));
            }
            this.externalId = _data["externalId"];
            this.hasWoodScanner = _data["hasWoodScanner"];
            this.hasYardAssignmentAutomation = _data["hasYardAssignmentAutomation"];
            this.integrationConfiguration = _data["integrationConfiguration"] ? IntegrationConfigurationDto.fromJS(_data["integrationConfiguration"]) : <any>undefined;
            this.smartGatewayUrl = _data["smartGatewayUrl"];
            this.isForExportation = _data["isForExportation"];
            this.acceptPreReceipt = _data["acceptPreReceipt"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlacesDtoUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new PlacesDtoUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["initials"] = this.initials;
        data["active"] = this.active;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["placeDepartmentId"] = this.placeDepartmentId;
        data["placeTypeId"] = this.placeTypeId;
        if (Array.isArray(this.zones)) {
            data["zones"] = [];
            for (let item of this.zones)
                data["zones"].push(item.toJSON());
        }
        data["externalId"] = this.externalId;
        data["hasWoodScanner"] = this.hasWoodScanner;
        data["hasYardAssignmentAutomation"] = this.hasYardAssignmentAutomation;
        data["integrationConfiguration"] = this.integrationConfiguration ? this.integrationConfiguration.toJSON() : <any>undefined;
        data["smartGatewayUrl"] = this.smartGatewayUrl;
        data["isForExportation"] = this.isForExportation;
        data["acceptPreReceipt"] = this.acceptPreReceipt;
        data["id"] = this.id;
        return data;
    }
}

export interface IPlacesDtoUpdateInput {
    name: string | undefined;
    initials: string | undefined;
    active: boolean;
    latitude: number;
    longitude: number;
    placeDepartmentId: number;
    placeTypeId: number;
    zones: ZoneInPlaceDto[] | undefined;
    externalId: number;
    hasWoodScanner: boolean;
    hasYardAssignmentAutomation: boolean;
    integrationConfiguration: IntegrationConfigurationDto | undefined;
    smartGatewayUrl: string | undefined;
    isForExportation: boolean;
    acceptPreReceipt: boolean;
    id: number;
}

export class PlaceToPreReceiptCreationDto implements IPlaceToPreReceiptCreationDto {
    name!: string | undefined;
    externalId!: number;
    locationType!: LocationType;
    id!: number;

    constructor(data?: IPlaceToPreReceiptCreationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.locationType = _data["locationType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PlaceToPreReceiptCreationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceToPreReceiptCreationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["locationType"] = this.locationType;
        data["id"] = this.id;
        return data;
    }
}

export interface IPlaceToPreReceiptCreationDto {
    name: string | undefined;
    externalId: number;
    locationType: LocationType;
    id: number;
}

export class PlaceToSwitchItemDto implements IPlaceToSwitchItemDto {
    id!: number;
    name!: string | undefined;
    initials!: string | undefined;
    externalPlaceId!: number;
    locationTypeId!: number;
    smartGatewayUrl!: string | undefined;
    supportsOffline!: boolean;
    isForExportation!: boolean;

    constructor(data?: IPlaceToSwitchItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.initials = _data["initials"];
            this.externalPlaceId = _data["externalPlaceId"];
            this.locationTypeId = _data["locationTypeId"];
            this.smartGatewayUrl = _data["smartGatewayUrl"];
            this.supportsOffline = _data["supportsOffline"];
            this.isForExportation = _data["isForExportation"];
        }
    }

    static fromJS(data: any): PlaceToSwitchItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceToSwitchItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["initials"] = this.initials;
        data["externalPlaceId"] = this.externalPlaceId;
        data["locationTypeId"] = this.locationTypeId;
        data["smartGatewayUrl"] = this.smartGatewayUrl;
        data["supportsOffline"] = this.supportsOffline;
        data["isForExportation"] = this.isForExportation;
        return data;
    }
}

export interface IPlaceToSwitchItemDto {
    id: number;
    name: string | undefined;
    initials: string | undefined;
    externalPlaceId: number;
    locationTypeId: number;
    smartGatewayUrl: string | undefined;
    supportsOffline: boolean;
    isForExportation: boolean;
}

export class PlaceTypeDto implements IPlaceTypeDto {
    id!: number;
    type!: string | undefined;

    constructor(data?: IPlaceTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): PlaceTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IPlaceTypeDto {
    id: number;
    type: string | undefined;
}

export class PolygonContractDto implements IPolygonContractDto {
    externalContractId!: number;
    isActive!: boolean;
    emails!: string[] | undefined;
    id!: number;

    constructor(data?: IPolygonContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalContractId = _data["externalContractId"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PolygonContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolygonContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalContractId"] = this.externalContractId;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IPolygonContractDto {
    externalContractId: number;
    isActive: boolean;
    emails: string[] | undefined;
    id: number;
}

export class PolygonValidationEmailInputDto implements IPolygonValidationEmailInputDto {
    woodActivityReportId!: number;
    originName!: string | undefined;
    periodName!: string | undefined;
    placeId!: number;
    placeName!: string | undefined;
    externalOriginId!: number;
    externalPeriodId!: number;
    polygonContractEmails!: string[] | undefined;

    constructor(data?: IPolygonValidationEmailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodActivityReportId = _data["woodActivityReportId"];
            this.originName = _data["originName"];
            this.periodName = _data["periodName"];
            this.placeId = _data["placeId"];
            this.placeName = _data["placeName"];
            this.externalOriginId = _data["externalOriginId"];
            this.externalPeriodId = _data["externalPeriodId"];
            if (Array.isArray(_data["polygonContractEmails"])) {
                this.polygonContractEmails = [] as any;
                for (let item of _data["polygonContractEmails"])
                    this.polygonContractEmails!.push(item);
            }
        }
    }

    static fromJS(data: any): PolygonValidationEmailInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PolygonValidationEmailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodActivityReportId"] = this.woodActivityReportId;
        data["originName"] = this.originName;
        data["periodName"] = this.periodName;
        data["placeId"] = this.placeId;
        data["placeName"] = this.placeName;
        data["externalOriginId"] = this.externalOriginId;
        data["externalPeriodId"] = this.externalPeriodId;
        if (Array.isArray(this.polygonContractEmails)) {
            data["polygonContractEmails"] = [];
            for (let item of this.polygonContractEmails)
                data["polygonContractEmails"].push(item);
        }
        return data;
    }
}

export interface IPolygonValidationEmailInputDto {
    woodActivityReportId: number;
    originName: string | undefined;
    periodName: string | undefined;
    placeId: number;
    placeName: string | undefined;
    externalOriginId: number;
    externalPeriodId: number;
    polygonContractEmails: string[] | undefined;
}

export enum PreActivityReportCreationMode {
    Automatic = "Automatic",
    QR = "QR",
    Manual = "Manual",
    ThirdPartyQR = "ThirdPartyQR",
    ProvidersApi = "ProvidersApi",
}

export enum PreActivityReportEntranceStatusFilter {
    None = "None",
    EnabledEntrance = "EnabledEntrance",
    ConditionalEntrance = "ConditionalEntrance",
}

export enum PreActivityReportEntranceStatusFilterForTransportVendor {
    None = "None",
    EnabledEntrance = "EnabledEntrance",
    ConditionalEntrance = "ConditionalEntrance",
    UPMReview = "UPMReview",
    ProviderErrors = "ProviderErrors",
}

export enum PreActivityReportEntranceStatusFilterForVendor {
    None = "None",
    EnabledEntrance = "EnabledEntrance",
    ConditionalEntrance = "ConditionalEntrance",
    UPMReview = "UPMReview",
    ProviderErrors = "ProviderErrors",
    WithoutTurn = "WithoutTurn",
}

export class PreActivityReportErrorDto implements IPreActivityReportErrorDto {
    errorType!: PreActivityReportErrorType;
    isProvidersResponsibility!: boolean;
    errorMessages!: string[] | undefined;
    syncUp!: boolean;
    deleteOnReceiptVerification!: boolean;

    constructor(data?: IPreActivityReportErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorType = _data["errorType"];
            this.isProvidersResponsibility = _data["isProvidersResponsibility"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [] as any;
                for (let item of _data["errorMessages"])
                    this.errorMessages!.push(item);
            }
            this.syncUp = _data["syncUp"];
            this.deleteOnReceiptVerification = _data["deleteOnReceiptVerification"];
        }
    }

    static fromJS(data: any): PreActivityReportErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorType"] = this.errorType;
        data["isProvidersResponsibility"] = this.isProvidersResponsibility;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["syncUp"] = this.syncUp;
        data["deleteOnReceiptVerification"] = this.deleteOnReceiptVerification;
        return data;
    }
}

export interface IPreActivityReportErrorDto {
    errorType: PreActivityReportErrorType;
    isProvidersResponsibility: boolean;
    errorMessages: string[] | undefined;
    syncUp: boolean;
    deleteOnReceiptVerification: boolean;
}

export enum PreActivityReportErrorType {
    Driver = "Driver",
    Truck = "Truck",
    Semitrailer = "Semitrailer",
    Stand = "Stand",
    Contract = "Contract",
    DUA = "DUA",
    TripNumber = "TripNumber",
    QRCertification = "QRCertification",
    Sample = "Sample",
    Destination = "Destination",
    LoadingService = "LoadingService",
    Origin = "Origin",
    Article = "Article",
    ValidatePhoto = "ValidatePhoto",
    ValidateQRCode = "ValidateQRCode",
}

export class PreActivityReportInfoForDriverValidationDto implements IPreActivityReportInfoForDriverValidationDto {
    paysTransport!: boolean;
    originExternalId!: number;
    originLocationType!: LocationType;
    vehicleVendorExternalId!: number;
    reportType!: ActivityReportType;

    constructor(data?: IPreActivityReportInfoForDriverValidationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paysTransport = _data["paysTransport"];
            this.originExternalId = _data["originExternalId"];
            this.originLocationType = _data["originLocationType"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.reportType = _data["reportType"];
        }
    }

    static fromJS(data: any): PreActivityReportInfoForDriverValidationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportInfoForDriverValidationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paysTransport"] = this.paysTransport;
        data["originExternalId"] = this.originExternalId;
        data["originLocationType"] = this.originLocationType;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["reportType"] = this.reportType;
        return data;
    }
}

export interface IPreActivityReportInfoForDriverValidationDto {
    paysTransport: boolean;
    originExternalId: number;
    originLocationType: LocationType;
    vehicleVendorExternalId: number;
    reportType: ActivityReportType;
}

export class PreActivityReportInfoForProjectionsIndicator implements IPreActivityReportInfoForProjectionsIndicator {
    placeId!: number;
    dateToCompare!: DateTime;
    items!: IndicatorsWoodActivityReportDto[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IPreActivityReportInfoForProjectionsIndicator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.dateToCompare = _data["dateToCompare"] ? DateTime.fromISO(_data["dateToCompare"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(IndicatorsWoodActivityReportDto.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PreActivityReportInfoForProjectionsIndicator {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportInfoForProjectionsIndicator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["dateToCompare"] = this.dateToCompare ? this.dateToCompare.toString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IPreActivityReportInfoForProjectionsIndicator {
    placeId: number;
    dateToCompare: DateTime;
    items: IndicatorsWoodActivityReportDto[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class PreActivityReportLineDto implements IPreActivityReportLineDto {
    tenantId!: number;
    article!: ArticleDto | undefined;
    stand!: StandDto | undefined;
    contract!: ContractDto | undefined;
    articleId!: number;
    origin!: LocationDto | undefined;
    isPefcCertified!: boolean | undefined;

    constructor(data?: IPreActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.article = _data["article"] ? ArticleDto.fromJS(_data["article"]) : <any>undefined;
            this.stand = _data["stand"] ? StandDto.fromJS(_data["stand"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.articleId = _data["articleId"];
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.isPefcCertified = _data["isPefcCertified"];
        }
    }

    static fromJS(data: any): PreActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["articleId"] = this.articleId;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["isPefcCertified"] = this.isPefcCertified;
        return data;
    }
}

export interface IPreActivityReportLineDto {
    tenantId: number;
    article: ArticleDto | undefined;
    stand: StandDto | undefined;
    contract: ContractDto | undefined;
    articleId: number;
    origin: LocationDto | undefined;
    isPefcCertified: boolean | undefined;
}

export class PreActivityReportMonitorInfoOutputDto implements IPreActivityReportMonitorInfoOutputDto {
    totalWoodPreActivityReport!: number;
    totalDiverseProductPreActivityReport!: number;
    totalInternalMovementPreActivityReport!: number;
    notValidatedDiverseProductPreReports!: DiverseProductPreReportEntranceRequiredInfoOutput[] | undefined;
    notValidatedWoodPreReports!: WoodPreReportEntranceRequiredInfoOutput[] | undefined;

    constructor(data?: IPreActivityReportMonitorInfoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalWoodPreActivityReport = _data["totalWoodPreActivityReport"];
            this.totalDiverseProductPreActivityReport = _data["totalDiverseProductPreActivityReport"];
            this.totalInternalMovementPreActivityReport = _data["totalInternalMovementPreActivityReport"];
            if (Array.isArray(_data["notValidatedDiverseProductPreReports"])) {
                this.notValidatedDiverseProductPreReports = [] as any;
                for (let item of _data["notValidatedDiverseProductPreReports"])
                    this.notValidatedDiverseProductPreReports!.push(DiverseProductPreReportEntranceRequiredInfoOutput.fromJS(item));
            }
            if (Array.isArray(_data["notValidatedWoodPreReports"])) {
                this.notValidatedWoodPreReports = [] as any;
                for (let item of _data["notValidatedWoodPreReports"])
                    this.notValidatedWoodPreReports!.push(WoodPreReportEntranceRequiredInfoOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PreActivityReportMonitorInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportMonitorInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalWoodPreActivityReport"] = this.totalWoodPreActivityReport;
        data["totalDiverseProductPreActivityReport"] = this.totalDiverseProductPreActivityReport;
        data["totalInternalMovementPreActivityReport"] = this.totalInternalMovementPreActivityReport;
        if (Array.isArray(this.notValidatedDiverseProductPreReports)) {
            data["notValidatedDiverseProductPreReports"] = [];
            for (let item of this.notValidatedDiverseProductPreReports)
                data["notValidatedDiverseProductPreReports"].push(item.toJSON());
        }
        if (Array.isArray(this.notValidatedWoodPreReports)) {
            data["notValidatedWoodPreReports"] = [];
            for (let item of this.notValidatedWoodPreReports)
                data["notValidatedWoodPreReports"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPreActivityReportMonitorInfoOutputDto {
    totalWoodPreActivityReport: number;
    totalDiverseProductPreActivityReport: number;
    totalInternalMovementPreActivityReport: number;
    notValidatedDiverseProductPreReports: DiverseProductPreReportEntranceRequiredInfoOutput[] | undefined;
    notValidatedWoodPreReports: WoodPreReportEntranceRequiredInfoOutput[] | undefined;
}

export enum PreActivityReportStatusForProviders {
    NoErrorsDetected = "NoErrorsDetected",
    HasUpmErrors = "HasUpmErrors",
    HasProviderErrors = "HasProviderErrors",
    HasNoTurn = "HasNoTurn",
    PendingPhotoValidation = "PendingPhotoValidation",
    HasUpmAndProviderErrors = "HasUpmAndProviderErrors",
    Rejected = "Rejected",
}

export class PreActivityReportStatusOutput implements IPreActivityReportStatusOutput {
    status!: PreActivityReportStatusForProviders;
    message!: string | undefined;

    constructor(data?: IPreActivityReportStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): PreActivityReportStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        return data;
    }
}

export interface IPreActivityReportStatusOutput {
    status: PreActivityReportStatusForProviders;
    message: string | undefined;
}

export enum PreActivityReportValidation {
    NoErrorsDetected = "NoErrorsDetected",
    HasUpmErrors = "HasUpmErrors",
    HasProviderErrors = "HasProviderErrors",
    HasUpmAndProviderErrors = "HasUpmAndProviderErrors",
    Rejected = "Rejected",
}

export class PreActivityReportValidationAndApprovalResultOutput implements IPreActivityReportValidationAndApprovalResultOutput {
    preReportValidation!: PreActivityReportValidation;
    isApproved!: boolean;
    preReportNotFound!: boolean;

    constructor(data?: IPreActivityReportValidationAndApprovalResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportValidation = _data["preReportValidation"];
            this.isApproved = _data["isApproved"];
            this.preReportNotFound = _data["preReportNotFound"];
        }
    }

    static fromJS(data: any): PreActivityReportValidationAndApprovalResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportValidationAndApprovalResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportValidation"] = this.preReportValidation;
        data["isApproved"] = this.isApproved;
        data["preReportNotFound"] = this.preReportNotFound;
        return data;
    }
}

export interface IPreActivityReportValidationAndApprovalResultOutput {
    preReportValidation: PreActivityReportValidation;
    isApproved: boolean;
    preReportNotFound: boolean;
}

export class PreActivityReportWithApprovalResultAndErrorsOutput implements IPreActivityReportWithApprovalResultAndErrorsOutput {
    isApproved!: boolean;
    reportCreationMode!: PreActivityReportCreationMode;
    nonBlockingErrors!: PreActivityReportErrorDto[] | undefined;
    isChip!: boolean;
    activityReportLines!: PreActivityReportLineDto[] | undefined;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationType!: LocationType;
    vehicleId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    driverExternalId!: number;
    semitrailers!: TruckVehicleDto[] | undefined;
    tripNumber!: number | undefined;
    serial!: string | undefined;
    number!: number;
    reportType!: ActivityReportType;
    scheduledEntryTime!: DateTime | undefined;
    paysTransport!: boolean;
    date!: DateTime;
    validationResult!: PreActivityReportValidation;
    loaderVendorExternalId!: number;
    placeId!: number;
    id!: number;

    constructor(data?: IPreActivityReportWithApprovalResultAndErrorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isApproved = _data["isApproved"];
            this.reportCreationMode = _data["reportCreationMode"];
            if (Array.isArray(_data["nonBlockingErrors"])) {
                this.nonBlockingErrors = [] as any;
                for (let item of _data["nonBlockingErrors"])
                    this.nonBlockingErrors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.isChip = _data["isChip"];
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(PreActivityReportLineDto.fromJS(item));
            }
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(TruckVehicleDto.fromJS(item));
            }
            this.tripNumber = _data["tripNumber"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.reportType = _data["reportType"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.loaderVendorExternalId = _data["loaderVendorExternalId"];
            this.placeId = _data["placeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PreActivityReportWithApprovalResultAndErrorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportWithApprovalResultAndErrorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isApproved"] = this.isApproved;
        data["reportCreationMode"] = this.reportCreationMode;
        if (Array.isArray(this.nonBlockingErrors)) {
            data["nonBlockingErrors"] = [];
            for (let item of this.nonBlockingErrors)
                data["nonBlockingErrors"].push(item.toJSON());
        }
        data["isChip"] = this.isChip;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["vehicleId"] = this.vehicleId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["driverExternalId"] = this.driverExternalId;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["tripNumber"] = this.tripNumber;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["reportType"] = this.reportType;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["loaderVendorExternalId"] = this.loaderVendorExternalId;
        data["placeId"] = this.placeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPreActivityReportWithApprovalResultAndErrorsOutput {
    isApproved: boolean;
    reportCreationMode: PreActivityReportCreationMode;
    nonBlockingErrors: PreActivityReportErrorDto[] | undefined;
    isChip: boolean;
    activityReportLines: PreActivityReportLineDto[] | undefined;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationType: LocationType;
    vehicleId: number;
    vehicleLicensePlate: string | undefined;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    driverExternalId: number;
    semitrailers: TruckVehicleDto[] | undefined;
    tripNumber: number | undefined;
    serial: string | undefined;
    number: number;
    reportType: ActivityReportType;
    scheduledEntryTime: DateTime | undefined;
    paysTransport: boolean;
    date: DateTime;
    validationResult: PreActivityReportValidation;
    loaderVendorExternalId: number;
    placeId: number;
    id: number;
}

export class PreActivityReportWithArrivalInformationOutput implements IPreActivityReportWithArrivalInformationOutput {
    success!: boolean;
    preReportFound!: boolean;
    preReportApproved!: boolean;
    preReportWithoutTurn!: boolean;
    preReportInExpiredTurn!: boolean;
    preReportInFutureTurn!: boolean;
    preReportId!: number | undefined;
    assignedTurn!: DateTime | undefined;
    userToNotify!: UserDriverInformationOutput | undefined;
    preReportValidatedSuccessfullyOnDetour!: boolean | undefined;
    placeId!: number | undefined;

    constructor(data?: IPreActivityReportWithArrivalInformationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.preReportFound = _data["preReportFound"];
            this.preReportApproved = _data["preReportApproved"];
            this.preReportWithoutTurn = _data["preReportWithoutTurn"];
            this.preReportInExpiredTurn = _data["preReportInExpiredTurn"];
            this.preReportInFutureTurn = _data["preReportInFutureTurn"];
            this.preReportId = _data["preReportId"];
            this.assignedTurn = _data["assignedTurn"] ? DateTime.fromISO(_data["assignedTurn"].toString()) : <any>undefined;
            this.userToNotify = _data["userToNotify"] ? UserDriverInformationOutput.fromJS(_data["userToNotify"]) : <any>undefined;
            this.preReportValidatedSuccessfullyOnDetour = _data["preReportValidatedSuccessfullyOnDetour"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): PreActivityReportWithArrivalInformationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportWithArrivalInformationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["preReportFound"] = this.preReportFound;
        data["preReportApproved"] = this.preReportApproved;
        data["preReportWithoutTurn"] = this.preReportWithoutTurn;
        data["preReportInExpiredTurn"] = this.preReportInExpiredTurn;
        data["preReportInFutureTurn"] = this.preReportInFutureTurn;
        data["preReportId"] = this.preReportId;
        data["assignedTurn"] = this.assignedTurn ? this.assignedTurn.toString() : <any>undefined;
        data["userToNotify"] = this.userToNotify ? this.userToNotify.toJSON() : <any>undefined;
        data["preReportValidatedSuccessfullyOnDetour"] = this.preReportValidatedSuccessfullyOnDetour;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IPreActivityReportWithArrivalInformationOutput {
    success: boolean;
    preReportFound: boolean;
    preReportApproved: boolean;
    preReportWithoutTurn: boolean;
    preReportInExpiredTurn: boolean;
    preReportInFutureTurn: boolean;
    preReportId: number | undefined;
    assignedTurn: DateTime | undefined;
    userToNotify: UserDriverInformationOutput | undefined;
    preReportValidatedSuccessfullyOnDetour: boolean | undefined;
    placeId: number | undefined;
}

export class PreActivityReportWithErrorsDto implements IPreActivityReportWithErrorsDto {
    errors!: PreActivityReportErrorDto[] | undefined;
    isApproved!: boolean;
    activityReportLines!: PreActivityReportLineDto[] | undefined;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationType!: LocationType;
    vehicleId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    driverExternalId!: number;
    semitrailers!: TruckVehicleDto[] | undefined;
    tripNumber!: number | undefined;
    serial!: string | undefined;
    number!: number;
    reportType!: ActivityReportType;
    scheduledEntryTime!: DateTime | undefined;
    paysTransport!: boolean;
    date!: DateTime;
    validationResult!: PreActivityReportValidation;
    loaderVendorExternalId!: number;
    placeId!: number;
    id!: number;

    constructor(data?: IPreActivityReportWithErrorsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.isApproved = _data["isApproved"];
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(PreActivityReportLineDto.fromJS(item));
            }
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(TruckVehicleDto.fromJS(item));
            }
            this.tripNumber = _data["tripNumber"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.reportType = _data["reportType"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.loaderVendorExternalId = _data["loaderVendorExternalId"];
            this.placeId = _data["placeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PreActivityReportWithErrorsDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityReportWithErrorsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isApproved"] = this.isApproved;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["vehicleId"] = this.vehicleId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["driverExternalId"] = this.driverExternalId;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["tripNumber"] = this.tripNumber;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["reportType"] = this.reportType;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["loaderVendorExternalId"] = this.loaderVendorExternalId;
        data["placeId"] = this.placeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPreActivityReportWithErrorsDto {
    errors: PreActivityReportErrorDto[] | undefined;
    isApproved: boolean;
    activityReportLines: PreActivityReportLineDto[] | undefined;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationType: LocationType;
    vehicleId: number;
    vehicleLicensePlate: string | undefined;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    driverExternalId: number;
    semitrailers: TruckVehicleDto[] | undefined;
    tripNumber: number | undefined;
    serial: string | undefined;
    number: number;
    reportType: ActivityReportType;
    scheduledEntryTime: DateTime | undefined;
    paysTransport: boolean;
    date: DateTime;
    validationResult: PreActivityReportValidation;
    loaderVendorExternalId: number;
    placeId: number;
    id: number;
}

export class PreActivityWithNonBlockingErrorsOutput implements IPreActivityWithNonBlockingErrorsOutput {
    preReportFound!: boolean;
    preReportId!: number;
    nonBlockingErrors!: PreActivityReportErrorDto[] | undefined;
    driverExternalId!: number;

    constructor(data?: IPreActivityWithNonBlockingErrorsOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportFound = _data["preReportFound"];
            this.preReportId = _data["preReportId"];
            if (Array.isArray(_data["nonBlockingErrors"])) {
                this.nonBlockingErrors = [] as any;
                for (let item of _data["nonBlockingErrors"])
                    this.nonBlockingErrors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.driverExternalId = _data["driverExternalId"];
        }
    }

    static fromJS(data: any): PreActivityWithNonBlockingErrorsOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreActivityWithNonBlockingErrorsOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportFound"] = this.preReportFound;
        data["preReportId"] = this.preReportId;
        if (Array.isArray(this.nonBlockingErrors)) {
            data["nonBlockingErrors"] = [];
            for (let item of this.nonBlockingErrors)
                data["nonBlockingErrors"].push(item.toJSON());
        }
        data["driverExternalId"] = this.driverExternalId;
        return data;
    }
}

export interface IPreActivityWithNonBlockingErrorsOutput {
    preReportFound: boolean;
    preReportId: number;
    nonBlockingErrors: PreActivityReportErrorDto[] | undefined;
    driverExternalId: number;
}

export class PreDiverseProductActivityReportOutputDto implements IPreDiverseProductActivityReportOutputDto {
    articleId!: number;
    activityReportId!: number;
    vehicleExternalId!: number;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    creationDateOfPreActivityReport!: DateTime;
    creationSystem!: string | undefined;
    creationMode!: string | undefined;
    state!: string | undefined;
    creationUsername!: string | undefined;
    creationUserType!: string | undefined;
    driverId!: number;
    userDriverIdentityCard!: string | undefined;
    originId!: number;
    originType!: LocationType;
    destinationId!: number;
    destinationType!: LocationType;
    vehicleVendorId!: number;
    cancellationReason!: string | undefined;
    cancellationComment!: string | undefined;
    rejectingUserComment!: string | undefined;

    constructor(data?: IPreDiverseProductActivityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"];
            this.activityReportId = _data["activityReportId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.creationDateOfPreActivityReport = _data["creationDateOfPreActivityReport"] ? DateTime.fromISO(_data["creationDateOfPreActivityReport"].toString()) : <any>undefined;
            this.creationSystem = _data["creationSystem"];
            this.creationMode = _data["creationMode"];
            this.state = _data["state"];
            this.creationUsername = _data["creationUsername"];
            this.creationUserType = _data["creationUserType"];
            this.driverId = _data["driverId"];
            this.userDriverIdentityCard = _data["userDriverIdentityCard"];
            this.originId = _data["originId"];
            this.originType = _data["originType"];
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
            this.vehicleVendorId = _data["vehicleVendorId"];
            this.cancellationReason = _data["cancellationReason"];
            this.cancellationComment = _data["cancellationComment"];
            this.rejectingUserComment = _data["rejectingUserComment"];
        }
    }

    static fromJS(data: any): PreDiverseProductActivityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreDiverseProductActivityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId;
        data["activityReportId"] = this.activityReportId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["creationDateOfPreActivityReport"] = this.creationDateOfPreActivityReport ? this.creationDateOfPreActivityReport.toString() : <any>undefined;
        data["creationSystem"] = this.creationSystem;
        data["creationMode"] = this.creationMode;
        data["state"] = this.state;
        data["creationUsername"] = this.creationUsername;
        data["creationUserType"] = this.creationUserType;
        data["driverId"] = this.driverId;
        data["userDriverIdentityCard"] = this.userDriverIdentityCard;
        data["originId"] = this.originId;
        data["originType"] = this.originType;
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        data["vehicleVendorId"] = this.vehicleVendorId;
        data["cancellationReason"] = this.cancellationReason;
        data["cancellationComment"] = this.cancellationComment;
        data["rejectingUserComment"] = this.rejectingUserComment;
        return data;
    }
}

export interface IPreDiverseProductActivityReportOutputDto {
    articleId: number;
    activityReportId: number;
    vehicleExternalId: number;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    creationDateOfPreActivityReport: DateTime;
    creationSystem: string | undefined;
    creationMode: string | undefined;
    state: string | undefined;
    creationUsername: string | undefined;
    creationUserType: string | undefined;
    driverId: number;
    userDriverIdentityCard: string | undefined;
    originId: number;
    originType: LocationType;
    destinationId: number;
    destinationType: LocationType;
    vehicleVendorId: number;
    cancellationReason: string | undefined;
    cancellationComment: string | undefined;
    rejectingUserComment: string | undefined;
}

export class PreReportContractInformation implements IPreReportContractInformation {
    contractExternalId!: number;
    isPefcCertified!: boolean;
    reportOriginType!: LocationType;

    constructor(data?: IPreReportContractInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contractExternalId = _data["contractExternalId"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.reportOriginType = _data["reportOriginType"];
        }
    }

    static fromJS(data: any): PreReportContractInformation {
        data = typeof data === 'object' ? data : {};
        let result = new PreReportContractInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contractExternalId"] = this.contractExternalId;
        data["isPefcCertified"] = this.isPefcCertified;
        data["reportOriginType"] = this.reportOriginType;
        return data;
    }
}

export interface IPreReportContractInformation {
    contractExternalId: number;
    isPefcCertified: boolean;
    reportOriginType: LocationType;
}

export class PreReportRejectionInput implements IPreReportRejectionInput {
    reportId!: number;
    rejectingUserComment!: string | undefined;

    constructor(data?: IPreReportRejectionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.rejectingUserComment = _data["rejectingUserComment"];
        }
    }

    static fromJS(data: any): PreReportRejectionInput {
        data = typeof data === 'object' ? data : {};
        let result = new PreReportRejectionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["rejectingUserComment"] = this.rejectingUserComment;
        return data;
    }
}

export interface IPreReportRejectionInput {
    reportId: number;
    rejectingUserComment: string | undefined;
}

export class PreReportRejectionOutput implements IPreReportRejectionOutput {
    preReportId!: number;
    userToNotify!: UserDriverInformationOutput | undefined;
    licensePlate!: string | undefined;

    constructor(data?: IPreReportRejectionOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preReportId = _data["preReportId"];
            this.userToNotify = _data["userToNotify"] ? UserDriverInformationOutput.fromJS(_data["userToNotify"]) : <any>undefined;
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): PreReportRejectionOutput {
        data = typeof data === 'object' ? data : {};
        let result = new PreReportRejectionOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preReportId"] = this.preReportId;
        data["userToNotify"] = this.userToNotify ? this.userToNotify.toJSON() : <any>undefined;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface IPreReportRejectionOutput {
    preReportId: number;
    userToNotify: UserDriverInformationOutput | undefined;
    licensePlate: string | undefined;
}

export class PreWoodActivityReportOutputDto implements IPreWoodActivityReportOutputDto {
    providerId!: number;
    activityReportId!: number;
    vehicleExternalId!: number;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    creationDateOfPreActivityReport!: DateTime;
    creationSystem!: string | undefined;
    creationMode!: string | undefined;
    state!: string | undefined;
    creationUsername!: string | undefined;
    creationUserType!: string | undefined;
    driverId!: number;
    userDriverIdentityCard!: string | undefined;
    originId!: number;
    originType!: LocationType;
    destinationId!: number;
    destinationType!: LocationType;
    vehicleVendorId!: number;
    cancellationReason!: string | undefined;
    cancellationComment!: string | undefined;
    rejectingUserComment!: string | undefined;

    constructor(data?: IPreWoodActivityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerId = _data["providerId"];
            this.activityReportId = _data["activityReportId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.creationDateOfPreActivityReport = _data["creationDateOfPreActivityReport"] ? DateTime.fromISO(_data["creationDateOfPreActivityReport"].toString()) : <any>undefined;
            this.creationSystem = _data["creationSystem"];
            this.creationMode = _data["creationMode"];
            this.state = _data["state"];
            this.creationUsername = _data["creationUsername"];
            this.creationUserType = _data["creationUserType"];
            this.driverId = _data["driverId"];
            this.userDriverIdentityCard = _data["userDriverIdentityCard"];
            this.originId = _data["originId"];
            this.originType = _data["originType"];
            this.destinationId = _data["destinationId"];
            this.destinationType = _data["destinationType"];
            this.vehicleVendorId = _data["vehicleVendorId"];
            this.cancellationReason = _data["cancellationReason"];
            this.cancellationComment = _data["cancellationComment"];
            this.rejectingUserComment = _data["rejectingUserComment"];
        }
    }

    static fromJS(data: any): PreWoodActivityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new PreWoodActivityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerId"] = this.providerId;
        data["activityReportId"] = this.activityReportId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["creationDateOfPreActivityReport"] = this.creationDateOfPreActivityReport ? this.creationDateOfPreActivityReport.toString() : <any>undefined;
        data["creationSystem"] = this.creationSystem;
        data["creationMode"] = this.creationMode;
        data["state"] = this.state;
        data["creationUsername"] = this.creationUsername;
        data["creationUserType"] = this.creationUserType;
        data["driverId"] = this.driverId;
        data["userDriverIdentityCard"] = this.userDriverIdentityCard;
        data["originId"] = this.originId;
        data["originType"] = this.originType;
        data["destinationId"] = this.destinationId;
        data["destinationType"] = this.destinationType;
        data["vehicleVendorId"] = this.vehicleVendorId;
        data["cancellationReason"] = this.cancellationReason;
        data["cancellationComment"] = this.cancellationComment;
        data["rejectingUserComment"] = this.rejectingUserComment;
        return data;
    }
}

export interface IPreWoodActivityReportOutputDto {
    providerId: number;
    activityReportId: number;
    vehicleExternalId: number;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    creationDateOfPreActivityReport: DateTime;
    creationSystem: string | undefined;
    creationMode: string | undefined;
    state: string | undefined;
    creationUsername: string | undefined;
    creationUserType: string | undefined;
    driverId: number;
    userDriverIdentityCard: string | undefined;
    originId: number;
    originType: LocationType;
    destinationId: number;
    destinationType: LocationType;
    vehicleVendorId: number;
    cancellationReason: string | undefined;
    cancellationComment: string | undefined;
    rejectingUserComment: string | undefined;
}

export class PrinterDto implements IPrinterDto {
    port!: number;
    ipAddress!: string | undefined;
    printerType!: PrinterType;
    printerProfileName!: string | undefined;
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: IPrinterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.port = _data["port"];
            this.ipAddress = _data["ipAddress"];
            this.printerType = _data["printerType"];
            this.printerProfileName = _data["printerProfileName"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PrinterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrinterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["port"] = this.port;
        data["ipAddress"] = this.ipAddress;
        data["printerType"] = this.printerType;
        data["printerProfileName"] = this.printerProfileName;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IPrinterDto {
    port: number;
    ipAddress: string | undefined;
    printerType: PrinterType;
    printerProfileName: string | undefined;
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export enum PrinterType {
    Ticket = "Ticket",
    ActivityReportWood = "ActivityReportWood",
    ActivityReportDiverseProducts = "ActivityReportDiverseProducts",
}

export class ProviderEmailNotificationInputDto implements IProviderEmailNotificationInputDto {
    providerEmailList!: EmailBoxInfoInputDto[] | undefined;
    isFOVendor!: boolean;
    isThirdProperty!: boolean;
    deposit!: string | undefined;
    provider!: string | undefined;
    receiptNumberOrigin!: string | undefined;
    reportNumber!: number;
    date!: DateTime;
    receiptOrigen!: string | undefined;
    product!: string | undefined;
    transportVendor!: string | undefined;
    licensePlate!: string | undefined;
    driverName!: string | undefined;
    loaderVendor!: string | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;
    observations!: string | undefined;
    serial!: string | undefined;
    placeId!: number;

    constructor(data?: IProviderEmailNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["providerEmailList"])) {
                this.providerEmailList = [] as any;
                for (let item of _data["providerEmailList"])
                    this.providerEmailList!.push(EmailBoxInfoInputDto.fromJS(item));
            }
            this.isFOVendor = _data["isFOVendor"];
            this.isThirdProperty = _data["isThirdProperty"];
            this.deposit = _data["deposit"];
            this.provider = _data["provider"];
            this.receiptNumberOrigin = _data["receiptNumberOrigin"];
            this.reportNumber = _data["reportNumber"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.receiptOrigen = _data["receiptOrigen"];
            this.product = _data["product"];
            this.transportVendor = _data["transportVendor"];
            this.licensePlate = _data["licensePlate"];
            this.driverName = _data["driverName"];
            this.loaderVendor = _data["loaderVendor"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
            this.observations = _data["observations"];
            this.serial = _data["serial"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): ProviderEmailNotificationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderEmailNotificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.providerEmailList)) {
            data["providerEmailList"] = [];
            for (let item of this.providerEmailList)
                data["providerEmailList"].push(item.toJSON());
        }
        data["isFOVendor"] = this.isFOVendor;
        data["isThirdProperty"] = this.isThirdProperty;
        data["deposit"] = this.deposit;
        data["provider"] = this.provider;
        data["receiptNumberOrigin"] = this.receiptNumberOrigin;
        data["reportNumber"] = this.reportNumber;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["receiptOrigen"] = this.receiptOrigen;
        data["product"] = this.product;
        data["transportVendor"] = this.transportVendor;
        data["licensePlate"] = this.licensePlate;
        data["driverName"] = this.driverName;
        data["loaderVendor"] = this.loaderVendor;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        data["observations"] = this.observations;
        data["serial"] = this.serial;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IProviderEmailNotificationInputDto {
    providerEmailList: EmailBoxInfoInputDto[] | undefined;
    isFOVendor: boolean;
    isThirdProperty: boolean;
    deposit: string | undefined;
    provider: string | undefined;
    receiptNumberOrigin: string | undefined;
    reportNumber: number;
    date: DateTime;
    receiptOrigen: string | undefined;
    product: string | undefined;
    transportVendor: string | undefined;
    licensePlate: string | undefined;
    driverName: string | undefined;
    loaderVendor: string | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
    observations: string | undefined;
    serial: string | undefined;
    placeId: number;
}

export enum ProviderType {
    TransportCompany = "TransportCompany",
    WoodProvider = "WoodProvider",
}

export class QRInfoDto implements IQRInfoDto {
    thirdPropertyCategory!: number | undefined;

    constructor(data?: IQRInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.thirdPropertyCategory = _data["thirdPropertyCategory"];
        }
    }

    static fromJS(data: any): QRInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new QRInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["thirdPropertyCategory"] = this.thirdPropertyCategory;
        return data;
    }
}

export interface IQRInfoDto {
    thirdPropertyCategory: number | undefined;
}

export class QRReaderDto implements IQRReaderDto {
    port!: number;
    ipAddress!: string | undefined;
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: IQRReaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.port = _data["port"];
            this.ipAddress = _data["ipAddress"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): QRReaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new QRReaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["port"] = this.port;
        data["ipAddress"] = this.ipAddress;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IQRReaderDto {
    port: number;
    ipAddress: string | undefined;
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export class RandomSampleAssignationOutputDto implements IRandomSampleAssignationOutputDto {
    woodOriginExternalId!: number;
    woodOriginType!: LocationType;
    periodStartDate!: DateTime;
    speciesGroupId!: number;
    modelId!: number;
    randomSampleCount!: number;
    reportCount!: number;

    constructor(data?: IRandomSampleAssignationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodOriginExternalId = _data["woodOriginExternalId"];
            this.woodOriginType = _data["woodOriginType"];
            this.periodStartDate = _data["periodStartDate"] ? DateTime.fromISO(_data["periodStartDate"].toString()) : <any>undefined;
            this.speciesGroupId = _data["speciesGroupId"];
            this.modelId = _data["modelId"];
            this.randomSampleCount = _data["randomSampleCount"];
            this.reportCount = _data["reportCount"];
        }
    }

    static fromJS(data: any): RandomSampleAssignationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RandomSampleAssignationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodOriginExternalId"] = this.woodOriginExternalId;
        data["woodOriginType"] = this.woodOriginType;
        data["periodStartDate"] = this.periodStartDate ? this.periodStartDate.toString() : <any>undefined;
        data["speciesGroupId"] = this.speciesGroupId;
        data["modelId"] = this.modelId;
        data["randomSampleCount"] = this.randomSampleCount;
        data["reportCount"] = this.reportCount;
        return data;
    }
}

export interface IRandomSampleAssignationOutputDto {
    woodOriginExternalId: number;
    woodOriginType: LocationType;
    periodStartDate: DateTime;
    speciesGroupId: number;
    modelId: number;
    randomSampleCount: number;
    reportCount: number;
}

export class RandomSampleAssignationReportOutputDto implements IRandomSampleAssignationReportOutputDto {
    placeName!: string | undefined;
    woodOriginExternalId!: number;
    woodOriginType!: LocationType;
    periodStartDate!: DateTime;
    speciesGroupId!: number;
    modelId!: number;
    randomSampleCount!: number;
    reportCount!: number;

    constructor(data?: IRandomSampleAssignationReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeName = _data["placeName"];
            this.woodOriginExternalId = _data["woodOriginExternalId"];
            this.woodOriginType = _data["woodOriginType"];
            this.periodStartDate = _data["periodStartDate"] ? DateTime.fromISO(_data["periodStartDate"].toString()) : <any>undefined;
            this.speciesGroupId = _data["speciesGroupId"];
            this.modelId = _data["modelId"];
            this.randomSampleCount = _data["randomSampleCount"];
            this.reportCount = _data["reportCount"];
        }
    }

    static fromJS(data: any): RandomSampleAssignationReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RandomSampleAssignationReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeName"] = this.placeName;
        data["woodOriginExternalId"] = this.woodOriginExternalId;
        data["woodOriginType"] = this.woodOriginType;
        data["periodStartDate"] = this.periodStartDate ? this.periodStartDate.toString() : <any>undefined;
        data["speciesGroupId"] = this.speciesGroupId;
        data["modelId"] = this.modelId;
        data["randomSampleCount"] = this.randomSampleCount;
        data["reportCount"] = this.reportCount;
        return data;
    }
}

export interface IRandomSampleAssignationReportOutputDto {
    placeName: string | undefined;
    woodOriginExternalId: number;
    woodOriginType: LocationType;
    periodStartDate: DateTime;
    speciesGroupId: number;
    modelId: number;
    randomSampleCount: number;
    reportCount: number;
}

export class RandomStatisticalSampleQuotaDto implements IRandomStatisticalSampleQuotaDto {
    modelId!: number;
    speciesGroupId!: number;
    woodOriginType!: LocationType;
    amount!: number;
    samplePercentage!: number;
    placeId!: number;
    id!: number;

    constructor(data?: IRandomStatisticalSampleQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modelId = _data["modelId"];
            this.speciesGroupId = _data["speciesGroupId"];
            this.woodOriginType = _data["woodOriginType"];
            this.amount = _data["amount"];
            this.samplePercentage = _data["samplePercentage"];
            this.placeId = _data["placeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RandomStatisticalSampleQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new RandomStatisticalSampleQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modelId"] = this.modelId;
        data["speciesGroupId"] = this.speciesGroupId;
        data["woodOriginType"] = this.woodOriginType;
        data["amount"] = this.amount;
        data["samplePercentage"] = this.samplePercentage;
        data["placeId"] = this.placeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRandomStatisticalSampleQuotaDto {
    modelId: number;
    speciesGroupId: number;
    woodOriginType: LocationType;
    amount: number;
    samplePercentage: number;
    placeId: number;
    id: number;
}

export class ReasonDto implements IReasonDto {
    id!: number | undefined;
    reasonTypeId!: number;
    name!: string | undefined;

    constructor(data?: IReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.reasonTypeId = _data["reasonTypeId"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["reasonTypeId"] = this.reasonTypeId;
        data["name"] = this.name;
        return data;
    }
}

export interface IReasonDto {
    id: number | undefined;
    reasonTypeId: number;
    name: string | undefined;
}

export class ReasonTypeDto implements IReasonTypeDto {
    id!: number;
    type!: string | undefined;

    constructor(data?: IReasonTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ReasonTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReasonTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IReasonTypeDto {
    id: number;
    type: string | undefined;
}

export enum ReasonTypes {
    ManualWeight = "ManualWeight",
    NoMeasurement = "NoMeasurement",
    ReceiptDeletion = "ReceiptDeletion",
    ArchimedesSampleDeletion = "ArchimedesSampleDeletion",
    ScannerSampleDeletion = "ScannerSampleDeletion",
    ScannerMeasurementSpeedAborted = "ScannerMeasurementSpeedAborted",
}

export class ReceiptReportLineOutput implements IReceiptReportLineOutput {
    articleExternalId!: number;
    contractExternalId!: number;
    contractTypeId!: number;
    contractVendorExternalId!: number;
    stand!: StandDto | undefined;
    origin!: LocationOutputDto | undefined;
    services!: ServiceDto[] | undefined;
    isPefcCertified!: boolean | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;
    archimedesSample!: ArchimedesSampleDto | undefined;
    currentCubicMeters!: number;
    currentDensityAvg!: number;
    scannerVolume!: number;
    scannerDensity!: number;
    pileName!: string | undefined;
    archimedesVolume!: number;

    constructor(data?: IReceiptReportLineOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleExternalId = _data["articleExternalId"];
            this.contractExternalId = _data["contractExternalId"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractVendorExternalId = _data["contractVendorExternalId"];
            this.stand = _data["stand"] ? StandDto.fromJS(_data["stand"]) : <any>undefined;
            this.origin = _data["origin"] ? LocationOutputDto.fromJS(_data["origin"]) : <any>undefined;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceDto.fromJS(item));
            }
            this.isPefcCertified = _data["isPefcCertified"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
            this.archimedesSample = _data["archimedesSample"] ? ArchimedesSampleDto.fromJS(_data["archimedesSample"]) : <any>undefined;
            this.currentCubicMeters = _data["currentCubicMeters"];
            this.currentDensityAvg = _data["currentDensityAvg"];
            this.scannerVolume = _data["scannerVolume"];
            this.scannerDensity = _data["scannerDensity"];
            this.pileName = _data["pileName"];
            this.archimedesVolume = _data["archimedesVolume"];
        }
    }

    static fromJS(data: any): ReceiptReportLineOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptReportLineOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleExternalId"] = this.articleExternalId;
        data["contractExternalId"] = this.contractExternalId;
        data["contractTypeId"] = this.contractTypeId;
        data["contractVendorExternalId"] = this.contractVendorExternalId;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["isPefcCertified"] = this.isPefcCertified;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        data["archimedesSample"] = this.archimedesSample ? this.archimedesSample.toJSON() : <any>undefined;
        data["currentCubicMeters"] = this.currentCubicMeters;
        data["currentDensityAvg"] = this.currentDensityAvg;
        data["scannerVolume"] = this.scannerVolume;
        data["scannerDensity"] = this.scannerDensity;
        data["pileName"] = this.pileName;
        data["archimedesVolume"] = this.archimedesVolume;
        return data;
    }
}

export interface IReceiptReportLineOutput {
    articleExternalId: number;
    contractExternalId: number;
    contractTypeId: number;
    contractVendorExternalId: number;
    stand: StandDto | undefined;
    origin: LocationOutputDto | undefined;
    services: ServiceDto[] | undefined;
    isPefcCertified: boolean | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
    archimedesSample: ArchimedesSampleDto | undefined;
    currentCubicMeters: number;
    currentDensityAvg: number;
    scannerVolume: number;
    scannerDensity: number;
    pileName: string | undefined;
    archimedesVolume: number;
}

export class ReceiptsInPlaceIndicatorOutputDto implements IReceiptsInPlaceIndicatorOutputDto {
    placeId!: number;
    woodReceiptsInPlaceCounter!: number;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IReceiptsInPlaceIndicatorOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.woodReceiptsInPlaceCounter = _data["woodReceiptsInPlaceCounter"];
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReceiptsInPlaceIndicatorOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptsInPlaceIndicatorOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["woodReceiptsInPlaceCounter"] = this.woodReceiptsInPlaceCounter;
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IReceiptsInPlaceIndicatorOutputDto {
    placeId: number;
    woodReceiptsInPlaceCounter: number;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class ReceiptsWithoutLoadIndicatorOutputDto implements IReceiptsWithoutLoadIndicatorOutputDto {
    placeId!: number;
    woodReceiptsWithoutLoadCounter!: number;
    receiptsInPlaceWithoutLoad!: WoodReceiptWithoutLoadIndicatorItem[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IReceiptsWithoutLoadIndicatorOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.woodReceiptsWithoutLoadCounter = _data["woodReceiptsWithoutLoadCounter"];
            if (Array.isArray(_data["receiptsInPlaceWithoutLoad"])) {
                this.receiptsInPlaceWithoutLoad = [] as any;
                for (let item of _data["receiptsInPlaceWithoutLoad"])
                    this.receiptsInPlaceWithoutLoad!.push(WoodReceiptWithoutLoadIndicatorItem.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ReceiptsWithoutLoadIndicatorOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReceiptsWithoutLoadIndicatorOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["woodReceiptsWithoutLoadCounter"] = this.woodReceiptsWithoutLoadCounter;
        if (Array.isArray(this.receiptsInPlaceWithoutLoad)) {
            data["receiptsInPlaceWithoutLoad"] = [];
            for (let item of this.receiptsInPlaceWithoutLoad)
                data["receiptsInPlaceWithoutLoad"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IReceiptsWithoutLoadIndicatorOutputDto {
    placeId: number;
    woodReceiptsWithoutLoadCounter: number;
    receiptsInPlaceWithoutLoad: WoodReceiptWithoutLoadIndicatorItem[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class RecentTenant implements IRecentTenant {
    id!: number;
    name!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IRecentTenant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): RecentTenant {
        data = typeof data === 'object' ? data : {};
        let result = new RecentTenant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IRecentTenant {
    id: number;
    name: string | undefined;
    creationTime: DateTime;
}

export class RefreshTokenResult implements IRefreshTokenResult {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: IRefreshTokenResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): RefreshTokenResult {
        data = typeof data === 'object' ? data : {};
        let result = new RefreshTokenResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface IRefreshTokenResult {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class RegionalStatCountry implements IRegionalStatCountry {
    countryName!: string | undefined;
    sales!: number;
    change!: number[] | undefined;
    averagePrice!: number;
    totalPrice!: number;

    constructor(data?: IRegionalStatCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            this.sales = _data["sales"];
            if (Array.isArray(_data["change"])) {
                this.change = [] as any;
                for (let item of _data["change"])
                    this.change!.push(item);
            }
            this.averagePrice = _data["averagePrice"];
            this.totalPrice = _data["totalPrice"];
        }
    }

    static fromJS(data: any): RegionalStatCountry {
        data = typeof data === 'object' ? data : {};
        let result = new RegionalStatCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (Array.isArray(this.change)) {
            data["change"] = [];
            for (let item of this.change)
                data["change"].push(item);
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    }
}

export interface IRegionalStatCountry {
    countryName: string | undefined;
    sales: number;
    change: number[] | undefined;
    averagePrice: number;
    totalPrice: number;
}

export class RegisterInput implements IRegisterInput {
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    password!: string;
    captchaResponse!: string | undefined;

    constructor(data?: IRegisterInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.password = _data["password"];
            this.captchaResponse = _data["captchaResponse"];
        }
    }

    static fromJS(data: any): RegisterInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    }
}

export interface IRegisterInput {
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    password: string;
    captchaResponse: string | undefined;
}

export class RegisterOutput implements IRegisterOutput {
    canLogin!: boolean;

    constructor(data?: IRegisterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
        }
    }

    static fromJS(data: any): RegisterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    }
}

export interface IRegisterOutput {
    canLogin: boolean;
}

export class RegisterTenantInput implements IRegisterTenantInput {
    tenancyName!: string;
    name!: string;
    adminEmailAddress!: string;
    adminPassword!: string | undefined;
    captchaResponse!: string | undefined;
    subscriptionStartType!: SubscriptionStartType;
    editionId!: number | undefined;

    constructor(data?: IRegisterTenantInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.adminEmailAddress = _data["adminEmailAddress"];
            this.adminPassword = _data["adminPassword"];
            this.captchaResponse = _data["captchaResponse"];
            this.subscriptionStartType = _data["subscriptionStartType"];
            this.editionId = _data["editionId"];
        }
    }

    static fromJS(data: any): RegisterTenantInput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data;
    }
}

export interface IRegisterTenantInput {
    tenancyName: string;
    name: string;
    adminEmailAddress: string;
    adminPassword: string | undefined;
    captchaResponse: string | undefined;
    subscriptionStartType: SubscriptionStartType;
    editionId: number | undefined;
}

export class RegisterTenantOutput implements IRegisterTenantOutput {
    tenantId!: number;
    tenancyName!: string | undefined;
    name!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    isTenantActive!: boolean;
    isActive!: boolean;
    isEmailConfirmationRequired!: boolean;

    constructor(data?: IRegisterTenantOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.isTenantActive = _data["isTenantActive"];
            this.isActive = _data["isActive"];
            this.isEmailConfirmationRequired = _data["isEmailConfirmationRequired"];
        }
    }

    static fromJS(data: any): RegisterTenantOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterTenantOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    }
}

export interface IRegisterTenantOutput {
    tenantId: number;
    tenancyName: string | undefined;
    name: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    isTenantActive: boolean;
    isActive: boolean;
    isEmailConfirmationRequired: boolean;
}

export class ReleaseSampleInput implements IReleaseSampleInput {
    activityReportId!: number;
    sampleAssignmentType!: SampleAssignmentType;
    sampleIsCompleted!: boolean;

    constructor(data?: IReleaseSampleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.sampleAssignmentType = _data["sampleAssignmentType"];
            this.sampleIsCompleted = _data["sampleIsCompleted"];
        }
    }

    static fromJS(data: any): ReleaseSampleInput {
        data = typeof data === 'object' ? data : {};
        let result = new ReleaseSampleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["sampleAssignmentType"] = this.sampleAssignmentType;
        data["sampleIsCompleted"] = this.sampleIsCompleted;
        return data;
    }
}

export interface IReleaseSampleInput {
    activityReportId: number;
    sampleAssignmentType: SampleAssignmentType;
    sampleIsCompleted: boolean;
}

export class RenamePageInput implements IRenamePageInput {
    dashboardName!: string | undefined;
    id!: string | undefined;
    name!: string | undefined;
    application!: string | undefined;

    constructor(data?: IRenamePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.application = _data["application"];
        }
    }

    static fromJS(data: any): RenamePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new RenamePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["id"] = this.id;
        data["name"] = this.name;
        data["application"] = this.application;
        return data;
    }
}

export interface IRenamePageInput {
    dashboardName: string | undefined;
    id: string | undefined;
    name: string | undefined;
    application: string | undefined;
}

export class ReportgeneratedDto implements IReportgeneratedDto {
    user!: UserIdentifier | undefined;
    successfullyGenerated!: boolean;
    fileToken!: string | undefined;
    fileType!: string | undefined;
    fileName!: string | undefined;
    reportGenerationType!: ReportGenerationType | undefined;

    constructor(data?: IReportgeneratedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserIdentifier.fromJS(_data["user"]) : <any>undefined;
            this.successfullyGenerated = _data["successfullyGenerated"];
            this.fileToken = _data["fileToken"];
            this.fileType = _data["fileType"];
            this.fileName = _data["fileName"];
            this.reportGenerationType = _data["reportGenerationType"];
        }
    }

    static fromJS(data: any): ReportgeneratedDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportgeneratedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["successfullyGenerated"] = this.successfullyGenerated;
        data["fileToken"] = this.fileToken;
        data["fileType"] = this.fileType;
        data["fileName"] = this.fileName;
        data["reportGenerationType"] = this.reportGenerationType;
        return data;
    }
}

export interface IReportgeneratedDto {
    user: UserIdentifier | undefined;
    successfullyGenerated: boolean;
    fileToken: string | undefined;
    fileType: string | undefined;
    fileName: string | undefined;
    reportGenerationType: ReportGenerationType | undefined;
}

export enum ReportGenerationType {
    Wood = "Wood",
    Products = "Products",
}

export class ReportZoneInfoOutputDto implements IReportZoneInfoOutputDto {
    reportId!: number;
    zoneId!: number;
    placeId!: number;

    constructor(data?: IReportZoneInfoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.zoneId = _data["zoneId"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): ReportZoneInfoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportZoneInfoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["zoneId"] = this.zoneId;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IReportZoneInfoOutputDto {
    reportId: number;
    zoneId: number;
    placeId: number;
}

export class ResetPasswordInput implements IResetPasswordInput {
    userId!: number;
    resetCode!: string | undefined;
    password!: string | undefined;
    returnUrl!: string | undefined;
    singleSignIn!: string | undefined;
    c!: string | undefined;

    constructor(data?: IResetPasswordInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.resetCode = _data["resetCode"];
            this.password = _data["password"];
            this.returnUrl = _data["returnUrl"];
            this.singleSignIn = _data["singleSignIn"];
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResetPasswordInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    }
}

export interface IResetPasswordInput {
    userId: number;
    resetCode: string | undefined;
    password: string | undefined;
    returnUrl: string | undefined;
    singleSignIn: string | undefined;
    c: string | undefined;
}

export class ResetPasswordOutput implements IResetPasswordOutput {
    canLogin!: boolean;
    userName!: string | undefined;

    constructor(data?: IResetPasswordOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canLogin = _data["canLogin"];
            this.userName = _data["userName"];
        }
    }

    static fromJS(data: any): ResetPasswordOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    }
}

export interface IResetPasswordOutput {
    canLogin: boolean;
    userName: string | undefined;
}

export class ResolveTenantIdInput implements IResolveTenantIdInput {
    c!: string | undefined;

    constructor(data?: IResolveTenantIdInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.c = _data["c"];
        }
    }

    static fromJS(data: any): ResolveTenantIdInput {
        data = typeof data === 'object' ? data : {};
        let result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    }
}

export interface IResolveTenantIdInput {
    c: string | undefined;
}

export class RfidPortConfigurationDto implements IRfidPortConfigurationDto {
    rfidReaderId!: number;
    portNumber!: number;
    antennaType!: AntennaType;
    rfidTagPrefixes!: RfidTagPrefixDto[] | undefined;
    id!: number;

    constructor(data?: IRfidPortConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rfidReaderId = _data["rfidReaderId"];
            this.portNumber = _data["portNumber"];
            this.antennaType = _data["antennaType"];
            if (Array.isArray(_data["rfidTagPrefixes"])) {
                this.rfidTagPrefixes = [] as any;
                for (let item of _data["rfidTagPrefixes"])
                    this.rfidTagPrefixes!.push(RfidTagPrefixDto.fromJS(item));
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RfidPortConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new RfidPortConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rfidReaderId"] = this.rfidReaderId;
        data["portNumber"] = this.portNumber;
        data["antennaType"] = this.antennaType;
        if (Array.isArray(this.rfidTagPrefixes)) {
            data["rfidTagPrefixes"] = [];
            for (let item of this.rfidTagPrefixes)
                data["rfidTagPrefixes"].push(item.toJSON());
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IRfidPortConfigurationDto {
    rfidReaderId: number;
    portNumber: number;
    antennaType: AntennaType;
    rfidTagPrefixes: RfidTagPrefixDto[] | undefined;
    id: number;
}

export class RfidReaderDto implements IRfidReaderDto {
    hostname!: string | undefined;
    rfidReaderType!: RFIDReaderType;
    useRabbitMq!: boolean;
    rabbitMqRoutingKey!: string | undefined;
    rfidPortConfigurations!: RfidPortConfigurationDto[] | undefined;
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: IRfidReaderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hostname = _data["hostname"];
            this.rfidReaderType = _data["rfidReaderType"];
            this.useRabbitMq = _data["useRabbitMq"];
            this.rabbitMqRoutingKey = _data["rabbitMqRoutingKey"];
            if (Array.isArray(_data["rfidPortConfigurations"])) {
                this.rfidPortConfigurations = [] as any;
                for (let item of _data["rfidPortConfigurations"])
                    this.rfidPortConfigurations!.push(RfidPortConfigurationDto.fromJS(item));
            }
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RfidReaderDto {
        data = typeof data === 'object' ? data : {};
        let result = new RfidReaderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hostname"] = this.hostname;
        data["rfidReaderType"] = this.rfidReaderType;
        data["useRabbitMq"] = this.useRabbitMq;
        data["rabbitMqRoutingKey"] = this.rabbitMqRoutingKey;
        if (Array.isArray(this.rfidPortConfigurations)) {
            data["rfidPortConfigurations"] = [];
            for (let item of this.rfidPortConfigurations)
                data["rfidPortConfigurations"].push(item.toJSON());
        }
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IRfidReaderDto {
    hostname: string | undefined;
    rfidReaderType: RFIDReaderType;
    useRabbitMq: boolean;
    rabbitMqRoutingKey: string | undefined;
    rfidPortConfigurations: RfidPortConfigurationDto[] | undefined;
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export enum RFIDReaderType {
    Rfid420 = "Rfid420",
    Rfid700 = "Rfid700",
}

export class RfidTagPrefixDto implements IRfidTagPrefixDto {
    prefix!: string | undefined;
    id!: number;

    constructor(data?: IRfidTagPrefixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RfidTagPrefixDto {
        data = typeof data === 'object' ? data : {};
        let result = new RfidTagPrefixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        data["id"] = this.id;
        return data;
    }
}

export interface IRfidTagPrefixDto {
    prefix: string | undefined;
    id: number;
}

export class RoleEditDto implements IRoleEditDto {
    id!: number | undefined;
    displayName!: string;
    isDefault!: boolean;
    placeId!: number | undefined;

    constructor(data?: IRoleEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
            this.isDefault = _data["isDefault"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): RoleEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IRoleEditDto {
    id: number | undefined;
    displayName: string;
    isDefault: boolean;
    placeId: number | undefined;
}

export class RoleListDto implements IRoleListDto {
    name!: string | undefined;
    displayName!: string | undefined;
    isStatic!: boolean;
    isDefault!: boolean;
    placeId!: number;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IRoleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.displayName = _data["displayName"];
            this.isStatic = _data["isStatic"];
            this.isDefault = _data["isDefault"];
            this.placeId = _data["placeId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): RoleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["placeId"] = this.placeId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IRoleListDto {
    name: string | undefined;
    displayName: string | undefined;
    isStatic: boolean;
    isDefault: boolean;
    placeId: number;
    creationTime: DateTime;
    id: number;
}

export class RolesToOrganizationUnitInput implements IRolesToOrganizationUnitInput {
    roleIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IRolesToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roleIds"])) {
                this.roleIds = [] as any;
                for (let item of _data["roleIds"])
                    this.roleIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): RolesToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new RolesToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roleIds)) {
            data["roleIds"] = [];
            for (let item of this.roleIds)
                data["roleIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IRolesToOrganizationUnitInput {
    roleIds: number[] | undefined;
    organizationUnitId: number;
}

export class RuntimeMethodHandle implements IRuntimeMethodHandle {
    readonly value!: any;

    constructor(data?: IRuntimeMethodHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).value = _data["value"];
        }
    }

    static fromJS(data: any): RuntimeMethodHandle {
        data = typeof data === 'object' ? data : {};
        let result = new RuntimeMethodHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IRuntimeMethodHandle {
    value: any;
}

export class SalesSummaryData implements ISalesSummaryData {
    period!: string | undefined;
    sales!: number;
    profit!: number;

    constructor(data?: ISalesSummaryData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"];
            this.sales = _data["sales"];
            this.profit = _data["profit"];
        }
    }

    static fromJS(data: any): SalesSummaryData {
        data = typeof data === 'object' ? data : {};
        let result = new SalesSummaryData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    }
}

export interface ISalesSummaryData {
    period: string | undefined;
    sales: number;
    profit: number;
}

export enum SalesSummaryDatePeriod {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export enum SampleAssignmentType {
    None = "None",
    SimpleSample = "SimpleSample",
    CalibrationSample = "CalibrationSample",
    ManualSample = "ManualSample",
    RandomStatisticalSample = "RandomStatisticalSample",
}

export class SampleInstanceReportDtoOutput implements ISampleInstanceReportDtoOutput {
    idBioforest!: string | undefined;
    receiptId!: number;
    mount!: string | undefined;
    sampleNumber!: number;
    services!: ServiceDto[] | undefined;
    articleExternalId!: number;
    destinationExternalId!: number;
    destinationType!: LocationType | undefined;
    originLineExternalId!: number;
    originLineType!: LocationType | undefined;
    contractExternalId!: number;
    contractTypeId!: number;
    contractVendorExternalId!: number;
    stand!: StandDto | undefined;
    sampleDate!: DateTime;
    loaderMachine!: string | undefined;
    scaleVolume!: number;
    machineTare!: WeightDto | undefined;
    withoutSubmerging!: WeightDto | undefined;
    withSubmerging!: WeightDto | undefined;
    baleWeight!: number;
    density!: number;
    woodVolume!: number;
    waterDensity!: number;
    canceled!: string | undefined;
    transmited!: string | undefined;
    harvester!: string | undefined;
    month!: string | undefined;
    deposit!: string | undefined;
    length!: string | undefined;
    species!: string | undefined;
    serial!: string | undefined;
    number!: number;
    cancellationReason!: string | undefined;
    hasDeviation!: boolean;
    deviationValue!: number;
    user!: string | undefined;
    receiptLocalId!: number | undefined;
    sampleTypeLabel!: string | undefined;
    packageNumber!: number | undefined;

    constructor(data?: ISampleInstanceReportDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.idBioforest = _data["idBioforest"];
            this.receiptId = _data["receiptId"];
            this.mount = _data["mount"];
            this.sampleNumber = _data["sampleNumber"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceDto.fromJS(item));
            }
            this.articleExternalId = _data["articleExternalId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.originLineExternalId = _data["originLineExternalId"];
            this.originLineType = _data["originLineType"];
            this.contractExternalId = _data["contractExternalId"];
            this.contractTypeId = _data["contractTypeId"];
            this.contractVendorExternalId = _data["contractVendorExternalId"];
            this.stand = _data["stand"] ? StandDto.fromJS(_data["stand"]) : <any>undefined;
            this.sampleDate = _data["sampleDate"] ? DateTime.fromISO(_data["sampleDate"].toString()) : <any>undefined;
            this.loaderMachine = _data["loaderMachine"];
            this.scaleVolume = _data["scaleVolume"];
            this.machineTare = _data["machineTare"] ? WeightDto.fromJS(_data["machineTare"]) : <any>undefined;
            this.withoutSubmerging = _data["withoutSubmerging"] ? WeightDto.fromJS(_data["withoutSubmerging"]) : <any>undefined;
            this.withSubmerging = _data["withSubmerging"] ? WeightDto.fromJS(_data["withSubmerging"]) : <any>undefined;
            this.baleWeight = _data["baleWeight"];
            this.density = _data["density"];
            this.woodVolume = _data["woodVolume"];
            this.waterDensity = _data["waterDensity"];
            this.canceled = _data["canceled"];
            this.transmited = _data["transmited"];
            this.harvester = _data["harvester"];
            this.month = _data["month"];
            this.deposit = _data["deposit"];
            this.length = _data["length"];
            this.species = _data["species"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.cancellationReason = _data["cancellationReason"];
            this.hasDeviation = _data["hasDeviation"];
            this.deviationValue = _data["deviationValue"];
            this.user = _data["user"];
            this.receiptLocalId = _data["receiptLocalId"];
            this.sampleTypeLabel = _data["sampleTypeLabel"];
            this.packageNumber = _data["packageNumber"];
        }
    }

    static fromJS(data: any): SampleInstanceReportDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SampleInstanceReportDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["idBioforest"] = this.idBioforest;
        data["receiptId"] = this.receiptId;
        data["mount"] = this.mount;
        data["sampleNumber"] = this.sampleNumber;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["articleExternalId"] = this.articleExternalId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["originLineExternalId"] = this.originLineExternalId;
        data["originLineType"] = this.originLineType;
        data["contractExternalId"] = this.contractExternalId;
        data["contractTypeId"] = this.contractTypeId;
        data["contractVendorExternalId"] = this.contractVendorExternalId;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["sampleDate"] = this.sampleDate ? this.sampleDate.toString() : <any>undefined;
        data["loaderMachine"] = this.loaderMachine;
        data["scaleVolume"] = this.scaleVolume;
        data["machineTare"] = this.machineTare ? this.machineTare.toJSON() : <any>undefined;
        data["withoutSubmerging"] = this.withoutSubmerging ? this.withoutSubmerging.toJSON() : <any>undefined;
        data["withSubmerging"] = this.withSubmerging ? this.withSubmerging.toJSON() : <any>undefined;
        data["baleWeight"] = this.baleWeight;
        data["density"] = this.density;
        data["woodVolume"] = this.woodVolume;
        data["waterDensity"] = this.waterDensity;
        data["canceled"] = this.canceled;
        data["transmited"] = this.transmited;
        data["harvester"] = this.harvester;
        data["month"] = this.month;
        data["deposit"] = this.deposit;
        data["length"] = this.length;
        data["species"] = this.species;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["cancellationReason"] = this.cancellationReason;
        data["hasDeviation"] = this.hasDeviation;
        data["deviationValue"] = this.deviationValue;
        data["user"] = this.user;
        data["receiptLocalId"] = this.receiptLocalId;
        data["sampleTypeLabel"] = this.sampleTypeLabel;
        data["packageNumber"] = this.packageNumber;
        return data;
    }
}

export interface ISampleInstanceReportDtoOutput {
    idBioforest: string | undefined;
    receiptId: number;
    mount: string | undefined;
    sampleNumber: number;
    services: ServiceDto[] | undefined;
    articleExternalId: number;
    destinationExternalId: number;
    destinationType: LocationType | undefined;
    originLineExternalId: number;
    originLineType: LocationType | undefined;
    contractExternalId: number;
    contractTypeId: number;
    contractVendorExternalId: number;
    stand: StandDto | undefined;
    sampleDate: DateTime;
    loaderMachine: string | undefined;
    scaleVolume: number;
    machineTare: WeightDto | undefined;
    withoutSubmerging: WeightDto | undefined;
    withSubmerging: WeightDto | undefined;
    baleWeight: number;
    density: number;
    woodVolume: number;
    waterDensity: number;
    canceled: string | undefined;
    transmited: string | undefined;
    harvester: string | undefined;
    month: string | undefined;
    deposit: string | undefined;
    length: string | undefined;
    species: string | undefined;
    serial: string | undefined;
    number: number;
    cancellationReason: string | undefined;
    hasDeviation: boolean;
    deviationValue: number;
    user: string | undefined;
    receiptLocalId: number | undefined;
    sampleTypeLabel: string | undefined;
    packageNumber: number | undefined;
}

export class SampleRecoveryOrValidationInfoDto implements ISampleRecoveryOrValidationInfoDto {
    standNumber!: number;
    articleId!: number;
    samplingPercentage!: number;
    notSyncedReportsCount!: number;
    notSyncedSkippedSamplesCount!: number;
    usesScanner!: boolean;

    constructor(data?: ISampleRecoveryOrValidationInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.standNumber = _data["standNumber"];
            this.articleId = _data["articleId"];
            this.samplingPercentage = _data["samplingPercentage"];
            this.notSyncedReportsCount = _data["notSyncedReportsCount"];
            this.notSyncedSkippedSamplesCount = _data["notSyncedSkippedSamplesCount"];
            this.usesScanner = _data["usesScanner"];
        }
    }

    static fromJS(data: any): SampleRecoveryOrValidationInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new SampleRecoveryOrValidationInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["standNumber"] = this.standNumber;
        data["articleId"] = this.articleId;
        data["samplingPercentage"] = this.samplingPercentage;
        data["notSyncedReportsCount"] = this.notSyncedReportsCount;
        data["notSyncedSkippedSamplesCount"] = this.notSyncedSkippedSamplesCount;
        data["usesScanner"] = this.usesScanner;
        return data;
    }
}

export interface ISampleRecoveryOrValidationInfoDto {
    standNumber: number;
    articleId: number;
    samplingPercentage: number;
    notSyncedReportsCount: number;
    notSyncedSkippedSamplesCount: number;
    usesScanner: boolean;
}

export class SamplesReportDtoOutput implements ISamplesReportDtoOutput {
    items!: SampleInstanceReportDtoOutput[] | undefined;
    placeName!: string | undefined;

    constructor(data?: ISamplesReportDtoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SampleInstanceReportDtoOutput.fromJS(item));
            }
            this.placeName = _data["placeName"];
        }
    }

    static fromJS(data: any): SamplesReportDtoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SamplesReportDtoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["placeName"] = this.placeName;
        return data;
    }
}

export interface ISamplesReportDtoOutput {
    items: SampleInstanceReportDtoOutput[] | undefined;
    placeName: string | undefined;
}

export enum SampleTypeOfRead {
    Tag = "Tag",
    Manual = "Manual",
}

export class SaveDestinationInputDto implements ISaveDestinationInputDto {
    activityReportId!: number;
    destination!: ExternalLocationInputDto | undefined;

    constructor(data?: ISaveDestinationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.destination = _data["destination"] ? ExternalLocationInputDto.fromJS(_data["destination"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveDestinationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveDestinationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveDestinationInputDto {
    activityReportId: number;
    destination: ExternalLocationInputDto | undefined;
}

export class SaveOriginInputDto implements ISaveOriginInputDto {
    origin!: ExternalLocationInputDto | undefined;

    constructor(data?: ISaveOriginInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveOriginInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveOriginInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaveOriginInputDto {
    origin: ExternalLocationInputDto | undefined;
}

export class SavePageInput implements ISavePageInput {
    dashboardName!: string | undefined;
    application!: string | undefined;
    pages!: Page[] | undefined;

    constructor(data?: ISavePageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardName = _data["dashboardName"];
            this.application = _data["application"];
            if (Array.isArray(_data["pages"])) {
                this.pages = [] as any;
                for (let item of _data["pages"])
                    this.pages!.push(Page.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SavePageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SavePageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardName"] = this.dashboardName;
        data["application"] = this.application;
        if (Array.isArray(this.pages)) {
            data["pages"] = [];
            for (let item of this.pages)
                data["pages"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISavePageInput {
    dashboardName: string | undefined;
    application: string | undefined;
    pages: Page[] | undefined;
}

export class SaveSemitrailersInputDto implements ISaveSemitrailersInputDto {
    reportId!: number;
    semitrailersQntRequired!: number;
    semitrailersDetected!: ExternalTruckVehicleInput[] | undefined;
    externalSemitrailers!: ExternalTruckVehicleInput[] | undefined;
    truckResourceTypeId!: number;

    constructor(data?: ISaveSemitrailersInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.semitrailersQntRequired = _data["semitrailersQntRequired"];
            if (Array.isArray(_data["semitrailersDetected"])) {
                this.semitrailersDetected = [] as any;
                for (let item of _data["semitrailersDetected"])
                    this.semitrailersDetected!.push(ExternalTruckVehicleInput.fromJS(item));
            }
            if (Array.isArray(_data["externalSemitrailers"])) {
                this.externalSemitrailers = [] as any;
                for (let item of _data["externalSemitrailers"])
                    this.externalSemitrailers!.push(ExternalTruckVehicleInput.fromJS(item));
            }
            this.truckResourceTypeId = _data["truckResourceTypeId"];
        }
    }

    static fromJS(data: any): SaveSemitrailersInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveSemitrailersInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["semitrailersQntRequired"] = this.semitrailersQntRequired;
        if (Array.isArray(this.semitrailersDetected)) {
            data["semitrailersDetected"] = [];
            for (let item of this.semitrailersDetected)
                data["semitrailersDetected"].push(item.toJSON());
        }
        if (Array.isArray(this.externalSemitrailers)) {
            data["externalSemitrailers"] = [];
            for (let item of this.externalSemitrailers)
                data["externalSemitrailers"].push(item.toJSON());
        }
        data["truckResourceTypeId"] = this.truckResourceTypeId;
        return data;
    }
}

export interface ISaveSemitrailersInputDto {
    reportId: number;
    semitrailersQntRequired: number;
    semitrailersDetected: ExternalTruckVehicleInput[] | undefined;
    externalSemitrailers: ExternalTruckVehicleInput[] | undefined;
    truckResourceTypeId: number;
}

export class SaveServiceEntrySheetInformationActivityReportInputDto implements ISaveServiceEntrySheetInformationActivityReportInputDto {
    activityReportId!: string | undefined;
    serviceExternalId!: number;

    constructor(data?: ISaveServiceEntrySheetInformationActivityReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.serviceExternalId = _data["serviceExternalId"];
        }
    }

    static fromJS(data: any): SaveServiceEntrySheetInformationActivityReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveServiceEntrySheetInformationActivityReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["serviceExternalId"] = this.serviceExternalId;
        return data;
    }
}

export interface ISaveServiceEntrySheetInformationActivityReportInputDto {
    activityReportId: string | undefined;
    serviceExternalId: number;
}

export class SaveServiceEntrySheetInformationInputDto implements ISaveServiceEntrySheetInformationInputDto {
    activityReports!: SaveServiceEntrySheetInformationActivityReportInputDto[] | undefined;
    serviceEntrySheetNumber!: number;
    isReversed!: boolean;
    isError!: boolean;
    errorMessage!: string | undefined;
    generatedDate!: DateTime | undefined;
    reversedDate!: DateTime | undefined;

    constructor(data?: ISaveServiceEntrySheetInformationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityReports"])) {
                this.activityReports = [] as any;
                for (let item of _data["activityReports"])
                    this.activityReports!.push(SaveServiceEntrySheetInformationActivityReportInputDto.fromJS(item));
            }
            this.serviceEntrySheetNumber = _data["serviceEntrySheetNumber"];
            this.isReversed = _data["isReversed"];
            this.isError = _data["isError"];
            this.errorMessage = _data["errorMessage"];
            this.generatedDate = _data["generatedDate"] ? DateTime.fromISO(_data["generatedDate"].toString()) : <any>undefined;
            this.reversedDate = _data["reversedDate"] ? DateTime.fromISO(_data["reversedDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SaveServiceEntrySheetInformationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveServiceEntrySheetInformationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityReports)) {
            data["activityReports"] = [];
            for (let item of this.activityReports)
                data["activityReports"].push(item.toJSON());
        }
        data["serviceEntrySheetNumber"] = this.serviceEntrySheetNumber;
        data["isReversed"] = this.isReversed;
        data["isError"] = this.isError;
        data["errorMessage"] = this.errorMessage;
        data["generatedDate"] = this.generatedDate ? this.generatedDate.toString() : <any>undefined;
        data["reversedDate"] = this.reversedDate ? this.reversedDate.toString() : <any>undefined;
        return data;
    }
}

export interface ISaveServiceEntrySheetInformationInputDto {
    activityReports: SaveServiceEntrySheetInformationActivityReportInputDto[] | undefined;
    serviceEntrySheetNumber: number;
    isReversed: boolean;
    isError: boolean;
    errorMessage: string | undefined;
    generatedDate: DateTime | undefined;
    reversedDate: DateTime | undefined;
}

export class SaveTakeSampleInput implements ISaveTakeSampleInput {
    sample!: ArchimedesSampleInstanceDto | undefined;
    isManual!: boolean;
    reasonForManualAssignment!: string | undefined;
    sampleAssignment!: SampleAssignmentType;
    sampleTyeOfRead!: SampleTypeOfRead;

    constructor(data?: ISaveTakeSampleInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sample = _data["sample"] ? ArchimedesSampleInstanceDto.fromJS(_data["sample"]) : <any>undefined;
            this.isManual = _data["isManual"];
            this.reasonForManualAssignment = _data["reasonForManualAssignment"];
            this.sampleAssignment = _data["sampleAssignment"];
            this.sampleTyeOfRead = _data["sampleTyeOfRead"];
        }
    }

    static fromJS(data: any): SaveTakeSampleInput {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTakeSampleInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sample"] = this.sample ? this.sample.toJSON() : <any>undefined;
        data["isManual"] = this.isManual;
        data["reasonForManualAssignment"] = this.reasonForManualAssignment;
        data["sampleAssignment"] = this.sampleAssignment;
        data["sampleTyeOfRead"] = this.sampleTyeOfRead;
        return data;
    }
}

export interface ISaveTakeSampleInput {
    sample: ArchimedesSampleInstanceDto | undefined;
    isManual: boolean;
    reasonForManualAssignment: string | undefined;
    sampleAssignment: SampleAssignmentType;
    sampleTyeOfRead: SampleTypeOfRead;
}

export class SaveTakeSampleResponseDto implements ISaveTakeSampleResponseDto {
    archimedesSampleId!: number;
    archimedesSampleAlreadyExist!: boolean;

    constructor(data?: ISaveTakeSampleResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.archimedesSampleId = _data["archimedesSampleId"];
            this.archimedesSampleAlreadyExist = _data["archimedesSampleAlreadyExist"];
        }
    }

    static fromJS(data: any): SaveTakeSampleResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SaveTakeSampleResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["archimedesSampleId"] = this.archimedesSampleId;
        data["archimedesSampleAlreadyExist"] = this.archimedesSampleAlreadyExist;
        return data;
    }
}

export interface ISaveTakeSampleResponseDto {
    archimedesSampleId: number;
    archimedesSampleAlreadyExist: boolean;
}

export class ScaleCalibrationDto implements IScaleCalibrationDto {
    placeId!: number;
    placeName!: string | undefined;
    instances!: ScaleCalibrationInstanceDto[] | undefined;
    isFinished!: boolean;
    creationTime!: DateTime;
    licensePlate!: string | undefined;
    id!: number;

    constructor(data?: IScaleCalibrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.placeName = _data["placeName"];
            if (Array.isArray(_data["instances"])) {
                this.instances = [] as any;
                for (let item of _data["instances"])
                    this.instances!.push(ScaleCalibrationInstanceDto.fromJS(item));
            }
            this.isFinished = _data["isFinished"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.licensePlate = _data["licensePlate"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScaleCalibrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleCalibrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["placeName"] = this.placeName;
        if (Array.isArray(this.instances)) {
            data["instances"] = [];
            for (let item of this.instances)
                data["instances"].push(item.toJSON());
        }
        data["isFinished"] = this.isFinished;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["licensePlate"] = this.licensePlate;
        data["id"] = this.id;
        return data;
    }
}

export interface IScaleCalibrationDto {
    placeId: number;
    placeName: string | undefined;
    instances: ScaleCalibrationInstanceDto[] | undefined;
    isFinished: boolean;
    creationTime: DateTime;
    licensePlate: string | undefined;
    id: number;
}

export class ScaleCalibrationForViewDto implements IScaleCalibrationForViewDto {
    creationTime!: DateTime;
    isFinished!: boolean;
    id!: number;

    constructor(data?: IScaleCalibrationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.isFinished = _data["isFinished"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScaleCalibrationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleCalibrationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["isFinished"] = this.isFinished;
        data["id"] = this.id;
        return data;
    }
}

export interface IScaleCalibrationForViewDto {
    creationTime: DateTime;
    isFinished: boolean;
    id: number;
}

export class ScaleCalibrationInstanceDto implements IScaleCalibrationInstanceDto {
    scaleCalibrationId!: number;
    weightId!: number;
    weightValue!: number;
    message!: string | undefined;
    scaleName!: string | undefined;
    scaleId!: number;
    id!: number;

    constructor(data?: IScaleCalibrationInstanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scaleCalibrationId = _data["scaleCalibrationId"];
            this.weightId = _data["weightId"];
            this.weightValue = _data["weightValue"];
            this.message = _data["message"];
            this.scaleName = _data["scaleName"];
            this.scaleId = _data["scaleId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScaleCalibrationInstanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleCalibrationInstanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scaleCalibrationId"] = this.scaleCalibrationId;
        data["weightId"] = this.weightId;
        data["weightValue"] = this.weightValue;
        data["message"] = this.message;
        data["scaleName"] = this.scaleName;
        data["scaleId"] = this.scaleId;
        data["id"] = this.id;
        return data;
    }
}

export interface IScaleCalibrationInstanceDto {
    scaleCalibrationId: number;
    weightId: number;
    weightValue: number;
    message: string | undefined;
    scaleName: string | undefined;
    scaleId: number;
    id: number;
}

export class ScaleCalibrationReportInputDto implements IScaleCalibrationReportInputDto {
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;

    constructor(data?: IScaleCalibrationReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScaleCalibrationReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleCalibrationReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        return data;
    }
}

export interface IScaleCalibrationReportInputDto {
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
}

export enum ScaleCalibrationStateFilter {
    All = "All",
    InProgress = "InProgress",
    Finished = "Finished",
}

export class ScaleDto implements IScaleDto {
    ipAddress!: string | undefined;
    port!: number;
    bufferSize!: number;
    startIndex!: number;
    endIndex!: number;
    readTime!: number;
    readRetries!: number;
    minWeightValueOfWeight!: number | undefined;
    maxWeightValueOfWeight!: number | undefined;
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: IScaleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ipAddress = _data["ipAddress"];
            this.port = _data["port"];
            this.bufferSize = _data["bufferSize"];
            this.startIndex = _data["startIndex"];
            this.endIndex = _data["endIndex"];
            this.readTime = _data["readTime"];
            this.readRetries = _data["readRetries"];
            this.minWeightValueOfWeight = _data["minWeightValueOfWeight"];
            this.maxWeightValueOfWeight = _data["maxWeightValueOfWeight"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScaleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ipAddress"] = this.ipAddress;
        data["port"] = this.port;
        data["bufferSize"] = this.bufferSize;
        data["startIndex"] = this.startIndex;
        data["endIndex"] = this.endIndex;
        data["readTime"] = this.readTime;
        data["readRetries"] = this.readRetries;
        data["minWeightValueOfWeight"] = this.minWeightValueOfWeight;
        data["maxWeightValueOfWeight"] = this.maxWeightValueOfWeight;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IScaleDto {
    ipAddress: string | undefined;
    port: number;
    bufferSize: number;
    startIndex: number;
    endIndex: number;
    readTime: number;
    readRetries: number;
    minWeightValueOfWeight: number | undefined;
    maxWeightValueOfWeight: number | undefined;
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export class ScaleForCalibrationDto implements IScaleForCalibrationDto {
    name!: string | undefined;
    zoneType!: string | undefined;
    id!: number;

    constructor(data?: IScaleForCalibrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.zoneType = _data["zoneType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScaleForCalibrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScaleForCalibrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["zoneType"] = this.zoneType;
        data["id"] = this.id;
        return data;
    }
}

export interface IScaleForCalibrationDto {
    name: string | undefined;
    zoneType: string | undefined;
    id: number;
}

export class ScannerBankQuantityDto implements IScannerBankQuantityDto {
    id!: number;
    truckTypeId!: number;
    lengthId!: number;
    quantity!: number;

    constructor(data?: IScannerBankQuantityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.truckTypeId = _data["truckTypeId"];
            this.lengthId = _data["lengthId"];
            this.quantity = _data["quantity"];
        }
    }

    static fromJS(data: any): ScannerBankQuantityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerBankQuantityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["truckTypeId"] = this.truckTypeId;
        data["lengthId"] = this.lengthId;
        data["quantity"] = this.quantity;
        return data;
    }
}

export interface IScannerBankQuantityDto {
    id: number;
    truckTypeId: number;
    lengthId: number;
    quantity: number;
}

export class ScannerCalibrationAttachmentDto implements IScannerCalibrationAttachmentDto {
    attachment!: string | undefined;
    attachmentFileName!: string | undefined;

    constructor(data?: IScannerCalibrationAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attachment = _data["attachment"];
            this.attachmentFileName = _data["attachmentFileName"];
        }
    }

    static fromJS(data: any): ScannerCalibrationAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerCalibrationAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attachment"] = this.attachment;
        data["attachmentFileName"] = this.attachmentFileName;
        return data;
    }
}

export interface IScannerCalibrationAttachmentDto {
    attachment: string | undefined;
    attachmentFileName: string | undefined;
}

export class ScannerCalibrationDto implements IScannerCalibrationDto {
    creationTime!: DateTime;
    hasAttachment!: boolean;
    isFinished!: boolean;
    scannerName!: string | undefined;
    scannerId!: number;
    id!: number;

    constructor(data?: IScannerCalibrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.hasAttachment = _data["hasAttachment"];
            this.isFinished = _data["isFinished"];
            this.scannerName = _data["scannerName"];
            this.scannerId = _data["scannerId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScannerCalibrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerCalibrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["hasAttachment"] = this.hasAttachment;
        data["isFinished"] = this.isFinished;
        data["scannerName"] = this.scannerName;
        data["scannerId"] = this.scannerId;
        data["id"] = this.id;
        return data;
    }
}

export interface IScannerCalibrationDto {
    creationTime: DateTime;
    hasAttachment: boolean;
    isFinished: boolean;
    scannerName: string | undefined;
    scannerId: number;
    id: number;
}

export class ScannerCalibrationEventDto implements IScannerCalibrationEventDto {
    ordinal!: number;
    isSuccess!: boolean;
    creationUserName!: string | undefined;
    creationDate!: DateTime;
    id!: number;

    constructor(data?: IScannerCalibrationEventDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ordinal = _data["ordinal"];
            this.isSuccess = _data["isSuccess"];
            this.creationUserName = _data["creationUserName"];
            this.creationDate = _data["creationDate"] ? DateTime.fromISO(_data["creationDate"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScannerCalibrationEventDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerCalibrationEventDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ordinal"] = this.ordinal;
        data["isSuccess"] = this.isSuccess;
        data["creationUserName"] = this.creationUserName;
        data["creationDate"] = this.creationDate ? this.creationDate.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IScannerCalibrationEventDto {
    ordinal: number;
    isSuccess: boolean;
    creationUserName: string | undefined;
    creationDate: DateTime;
    id: number;
}

export class ScannerCalibrationForViewDto implements IScannerCalibrationForViewDto {
    creationTime!: DateTime;
    hasAttachment!: boolean;
    isFinished!: boolean;
    scannerName!: string | undefined;
    id!: number;

    constructor(data?: IScannerCalibrationForViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.hasAttachment = _data["hasAttachment"];
            this.isFinished = _data["isFinished"];
            this.scannerName = _data["scannerName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScannerCalibrationForViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerCalibrationForViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["hasAttachment"] = this.hasAttachment;
        data["isFinished"] = this.isFinished;
        data["scannerName"] = this.scannerName;
        data["id"] = this.id;
        return data;
    }
}

export interface IScannerCalibrationForViewDto {
    creationTime: DateTime;
    hasAttachment: boolean;
    isFinished: boolean;
    scannerName: string | undefined;
    id: number;
}

export enum ScannerCalibrationStateFilter {
    All = "All",
    InProgress = "InProgress",
    Finished = "Finished",
}

export class ScannerCalibreationReportInputDto implements IScannerCalibreationReportInputDto {
    scannerDeviceId!: number | undefined;
    startDate!: DateTime | undefined;
    endDate!: DateTime | undefined;

    constructor(data?: IScannerCalibreationReportInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scannerDeviceId = _data["scannerDeviceId"];
            this.startDate = _data["startDate"] ? DateTime.fromISO(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? DateTime.fromISO(_data["endDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScannerCalibreationReportInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerCalibreationReportInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scannerDeviceId"] = this.scannerDeviceId;
        data["startDate"] = this.startDate ? this.startDate.toString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toString() : <any>undefined;
        return data;
    }
}

export interface IScannerCalibreationReportInputDto {
    scannerDeviceId: number | undefined;
    startDate: DateTime | undefined;
    endDate: DateTime | undefined;
}

export class ScannerCountOutputDto implements IScannerCountOutputDto {
    sincedHours!: number;
    totalReceipts!: number;
    dateToCompare!: DateTime;
    items!: ScannerItemsSummaryDto[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IScannerCountOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sincedHours = _data["sincedHours"];
            this.totalReceipts = _data["totalReceipts"];
            this.dateToCompare = _data["dateToCompare"] ? DateTime.fromISO(_data["dateToCompare"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScannerItemsSummaryDto.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ScannerCountOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerCountOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sincedHours"] = this.sincedHours;
        data["totalReceipts"] = this.totalReceipts;
        data["dateToCompare"] = this.dateToCompare ? this.dateToCompare.toString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IScannerCountOutputDto {
    sincedHours: number;
    totalReceipts: number;
    dateToCompare: DateTime;
    items: ScannerItemsSummaryDto[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class ScannerDto implements IScannerDto {
    url!: string | undefined;
    daysBetweenCalibrations!: number;
    shouldSendSampleInformation!: boolean;
    urlSampleInformation!: string | undefined;
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: IScannerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.daysBetweenCalibrations = _data["daysBetweenCalibrations"];
            this.shouldSendSampleInformation = _data["shouldSendSampleInformation"];
            this.urlSampleInformation = _data["urlSampleInformation"];
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScannerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["daysBetweenCalibrations"] = this.daysBetweenCalibrations;
        data["shouldSendSampleInformation"] = this.shouldSendSampleInformation;
        data["urlSampleInformation"] = this.urlSampleInformation;
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IScannerDto {
    url: string | undefined;
    daysBetweenCalibrations: number;
    shouldSendSampleInformation: boolean;
    urlSampleInformation: string | undefined;
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export class ScannerFactorTypeDto implements IScannerFactorTypeDto {
    id!: number;
    code!: number;
    truckTypeId!: number;
    vehicleQuantity!: number;
    maxHeight!: number;

    constructor(data?: IScannerFactorTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.truckTypeId = _data["truckTypeId"];
            this.vehicleQuantity = _data["vehicleQuantity"];
            this.maxHeight = _data["maxHeight"];
        }
    }

    static fromJS(data: any): ScannerFactorTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerFactorTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["truckTypeId"] = this.truckTypeId;
        data["vehicleQuantity"] = this.vehicleQuantity;
        data["maxHeight"] = this.maxHeight;
        return data;
    }
}

export interface IScannerFactorTypeDto {
    id: number;
    code: number;
    truckTypeId: number;
    vehicleQuantity: number;
    maxHeight: number;
}

export class ScannerForCalibrationDto implements IScannerForCalibrationDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IScannerForCalibrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ScannerForCalibrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerForCalibrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IScannerForCalibrationDto {
    name: string | undefined;
    id: number;
}

export class ScannerInfoDto implements IScannerInfoDto {
    id!: number;
    isScannerActive!: boolean;
    hasToSendSampleInformation!: boolean;

    constructor(data?: IScannerInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isScannerActive = _data["isScannerActive"];
            this.hasToSendSampleInformation = _data["hasToSendSampleInformation"];
        }
    }

    static fromJS(data: any): ScannerInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isScannerActive"] = this.isScannerActive;
        data["hasToSendSampleInformation"] = this.hasToSendSampleInformation;
        return data;
    }
}

export interface IScannerInfoDto {
    id: number;
    isScannerActive: boolean;
    hasToSendSampleInformation: boolean;
}

export class ScannerInfoInputDto implements IScannerInfoInputDto {
    activityReportId!: number;
    scannerModel!: number;
    isSendSignalSucceeded!: boolean;
    responseCodeOnSendSignal!: number | undefined;
    executionMsgOnSendSignal!: string | undefined;

    constructor(data?: IScannerInfoInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.scannerModel = _data["scannerModel"];
            this.isSendSignalSucceeded = _data["isSendSignalSucceeded"];
            this.responseCodeOnSendSignal = _data["responseCodeOnSendSignal"];
            this.executionMsgOnSendSignal = _data["executionMsgOnSendSignal"];
        }
    }

    static fromJS(data: any): ScannerInfoInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerInfoInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["scannerModel"] = this.scannerModel;
        data["isSendSignalSucceeded"] = this.isSendSignalSucceeded;
        data["responseCodeOnSendSignal"] = this.responseCodeOnSendSignal;
        data["executionMsgOnSendSignal"] = this.executionMsgOnSendSignal;
        return data;
    }
}

export interface IScannerInfoInputDto {
    activityReportId: number;
    scannerModel: number;
    isSendSignalSucceeded: boolean;
    responseCodeOnSendSignal: number | undefined;
    executionMsgOnSendSignal: string | undefined;
}

export class ScannerInformationOutputDto implements IScannerInformationOutputDto {
    localReceiptId!: number;
    externalActivityReportId!: number | undefined;
    scannerSummary!: ScannerSummaryDto | undefined;
    hasAbortedSpeedScannerResult!: boolean;
    scannerAbortedSpeedResultReason!: WoodActivityReportAbortedScannerReasonDto | undefined;
    standNumberOrId!: number;
    isStandExternal!: boolean;
    articleExternalId!: number;
    activityReportLineId!: number;
    activityReportId!: number;

    constructor(data?: IScannerInformationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localReceiptId = _data["localReceiptId"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.scannerSummary = _data["scannerSummary"] ? ScannerSummaryDto.fromJS(_data["scannerSummary"]) : <any>undefined;
            this.hasAbortedSpeedScannerResult = _data["hasAbortedSpeedScannerResult"];
            this.scannerAbortedSpeedResultReason = _data["scannerAbortedSpeedResultReason"] ? WoodActivityReportAbortedScannerReasonDto.fromJS(_data["scannerAbortedSpeedResultReason"]) : <any>undefined;
            this.standNumberOrId = _data["standNumberOrId"];
            this.isStandExternal = _data["isStandExternal"];
            this.articleExternalId = _data["articleExternalId"];
            this.activityReportLineId = _data["activityReportLineId"];
            this.activityReportId = _data["activityReportId"];
        }
    }

    static fromJS(data: any): ScannerInformationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerInformationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localReceiptId"] = this.localReceiptId;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["scannerSummary"] = this.scannerSummary ? this.scannerSummary.toJSON() : <any>undefined;
        data["hasAbortedSpeedScannerResult"] = this.hasAbortedSpeedScannerResult;
        data["scannerAbortedSpeedResultReason"] = this.scannerAbortedSpeedResultReason ? this.scannerAbortedSpeedResultReason.toJSON() : <any>undefined;
        data["standNumberOrId"] = this.standNumberOrId;
        data["isStandExternal"] = this.isStandExternal;
        data["articleExternalId"] = this.articleExternalId;
        data["activityReportLineId"] = this.activityReportLineId;
        data["activityReportId"] = this.activityReportId;
        return data;
    }
}

export interface IScannerInformationOutputDto {
    localReceiptId: number;
    externalActivityReportId: number | undefined;
    scannerSummary: ScannerSummaryDto | undefined;
    hasAbortedSpeedScannerResult: boolean;
    scannerAbortedSpeedResultReason: WoodActivityReportAbortedScannerReasonDto | undefined;
    standNumberOrId: number;
    isStandExternal: boolean;
    articleExternalId: number;
    activityReportLineId: number;
    activityReportId: number;
}

export class ScannerIntegrationDto implements IScannerIntegrationDto {
    density!: number;
    totalSolidVolume!: number;
    fullTruck!: number;

    constructor(data?: IScannerIntegrationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.density = _data["density"];
            this.totalSolidVolume = _data["totalSolidVolume"];
            this.fullTruck = _data["fullTruck"];
        }
    }

    static fromJS(data: any): ScannerIntegrationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerIntegrationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["density"] = this.density;
        data["totalSolidVolume"] = this.totalSolidVolume;
        data["fullTruck"] = this.fullTruck;
        return data;
    }
}

export interface IScannerIntegrationDto {
    density: number;
    totalSolidVolume: number;
    fullTruck: number;
}

export class ScannerItemDto implements IScannerItemDto {
    woodActivityReceiptId!: number;
    categoryResult!: WoodScannerCategoryResults | undefined;
    isLogyardReceipt!: boolean;

    constructor(data?: IScannerItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodActivityReceiptId = _data["woodActivityReceiptId"];
            this.categoryResult = _data["categoryResult"];
            this.isLogyardReceipt = _data["isLogyardReceipt"];
        }
    }

    static fromJS(data: any): ScannerItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodActivityReceiptId"] = this.woodActivityReceiptId;
        data["categoryResult"] = this.categoryResult;
        data["isLogyardReceipt"] = this.isLogyardReceipt;
        return data;
    }
}

export interface IScannerItemDto {
    woodActivityReceiptId: number;
    categoryResult: WoodScannerCategoryResults | undefined;
    isLogyardReceipt: boolean;
}

export class ScannerItemsSummaryDto implements IScannerItemsSummaryDto {
    categoryResult!: WoodScannerCategoryResults | undefined;
    count!: number;
    receipts!: ScannerItemDto[] | undefined;

    constructor(data?: IScannerItemsSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryResult = _data["categoryResult"];
            this.count = _data["count"];
            if (Array.isArray(_data["receipts"])) {
                this.receipts = [] as any;
                for (let item of _data["receipts"])
                    this.receipts!.push(ScannerItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScannerItemsSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerItemsSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryResult"] = this.categoryResult;
        data["count"] = this.count;
        if (Array.isArray(this.receipts)) {
            data["receipts"] = [];
            for (let item of this.receipts)
                data["receipts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScannerItemsSummaryDto {
    categoryResult: WoodScannerCategoryResults | undefined;
    count: number;
    receipts: ScannerItemDto[] | undefined;
}

export class ScannerLengthDto implements IScannerLengthDto {
    id!: number;
    lenghtValue!: number;
    lengthCode!: string | undefined;

    constructor(data?: IScannerLengthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lenghtValue = _data["lenghtValue"];
            this.lengthCode = _data["lengthCode"];
        }
    }

    static fromJS(data: any): ScannerLengthDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerLengthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lenghtValue"] = this.lenghtValue;
        data["lengthCode"] = this.lengthCode;
        return data;
    }
}

export interface IScannerLengthDto {
    id: number;
    lenghtValue: number;
    lengthCode: string | undefined;
}

export class ScannerNotificationInputDto implements IScannerNotificationInputDto {
    eventId!: string | undefined;
    activityReportId!: number;
    executionDateTime!: string | undefined;
    averageTotalDiameters!: number;
    solidTotalVolume!: number;
    stereoTotalVolume!: number;
    averageLengthFixed!: number;
    averageLengthVisible!: number;
    fullIndicator!: string | undefined;
    averageHeight!: number;
    isDiameterExcessiveAlarm!: boolean;
    interventionState!: string | undefined;
    isRecalculation!: boolean;
    modelId!: number;
    packages!: LogmeterPackageDto[] | undefined;
    lengthClassification!: LogmeterValueOutputDto | undefined;
    averageLengthClassification!: LogmeterValueOutputDto | undefined;

    constructor(data?: IScannerNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.activityReportId = _data["activityReportId"];
            this.executionDateTime = _data["executionDateTime"];
            this.averageTotalDiameters = _data["averageTotalDiameters"];
            this.solidTotalVolume = _data["solidTotalVolume"];
            this.stereoTotalVolume = _data["stereoTotalVolume"];
            this.averageLengthFixed = _data["averageLengthFixed"];
            this.averageLengthVisible = _data["averageLengthVisible"];
            this.fullIndicator = _data["fullIndicator"];
            this.averageHeight = _data["averageHeight"];
            this.isDiameterExcessiveAlarm = _data["isDiameterExcessiveAlarm"];
            this.interventionState = _data["interventionState"];
            this.isRecalculation = _data["isRecalculation"];
            this.modelId = _data["modelId"];
            if (Array.isArray(_data["packages"])) {
                this.packages = [] as any;
                for (let item of _data["packages"])
                    this.packages!.push(LogmeterPackageDto.fromJS(item));
            }
            this.lengthClassification = _data["lengthClassification"] ? LogmeterValueOutputDto.fromJS(_data["lengthClassification"]) : <any>undefined;
            this.averageLengthClassification = _data["averageLengthClassification"] ? LogmeterValueOutputDto.fromJS(_data["averageLengthClassification"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScannerNotificationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerNotificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["activityReportId"] = this.activityReportId;
        data["executionDateTime"] = this.executionDateTime;
        data["averageTotalDiameters"] = this.averageTotalDiameters;
        data["solidTotalVolume"] = this.solidTotalVolume;
        data["stereoTotalVolume"] = this.stereoTotalVolume;
        data["averageLengthFixed"] = this.averageLengthFixed;
        data["averageLengthVisible"] = this.averageLengthVisible;
        data["fullIndicator"] = this.fullIndicator;
        data["averageHeight"] = this.averageHeight;
        data["isDiameterExcessiveAlarm"] = this.isDiameterExcessiveAlarm;
        data["interventionState"] = this.interventionState;
        data["isRecalculation"] = this.isRecalculation;
        data["modelId"] = this.modelId;
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            for (let item of this.packages)
                data["packages"].push(item.toJSON());
        }
        data["lengthClassification"] = this.lengthClassification ? this.lengthClassification.toJSON() : <any>undefined;
        data["averageLengthClassification"] = this.averageLengthClassification ? this.averageLengthClassification.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScannerNotificationInputDto {
    eventId: string | undefined;
    activityReportId: number;
    executionDateTime: string | undefined;
    averageTotalDiameters: number;
    solidTotalVolume: number;
    stereoTotalVolume: number;
    averageLengthFixed: number;
    averageLengthVisible: number;
    fullIndicator: string | undefined;
    averageHeight: number;
    isDiameterExcessiveAlarm: boolean;
    interventionState: string | undefined;
    isRecalculation: boolean;
    modelId: number;
    packages: LogmeterPackageDto[] | undefined;
    lengthClassification: LogmeterValueOutputDto | undefined;
    averageLengthClassification: LogmeterValueOutputDto | undefined;
}

export class ScannerPercentageOutputDto implements IScannerPercentageOutputDto {
    percentage!: number;
    sincedHours!: number;
    totalReceipts!: number;
    dateToCompare!: DateTime;
    items!: ScannerItemsSummaryDto[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IScannerPercentageOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"];
            this.sincedHours = _data["sincedHours"];
            this.totalReceipts = _data["totalReceipts"];
            this.dateToCompare = _data["dateToCompare"] ? DateTime.fromISO(_data["dateToCompare"].toString()) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScannerItemsSummaryDto.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ScannerPercentageOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerPercentageOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage;
        data["sincedHours"] = this.sincedHours;
        data["totalReceipts"] = this.totalReceipts;
        data["dateToCompare"] = this.dateToCompare ? this.dateToCompare.toString() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IScannerPercentageOutputDto {
    percentage: number;
    sincedHours: number;
    totalReceipts: number;
    dateToCompare: DateTime;
    items: ScannerItemsSummaryDto[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class ScannerSpecieDto implements IScannerSpecieDto {
    id!: number;
    specieCode!: string | undefined;
    scannerCode!: number;

    constructor(data?: IScannerSpecieDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.specieCode = _data["specieCode"];
            this.scannerCode = _data["scannerCode"];
        }
    }

    static fromJS(data: any): ScannerSpecieDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerSpecieDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["specieCode"] = this.specieCode;
        data["scannerCode"] = this.scannerCode;
        return data;
    }
}

export interface IScannerSpecieDto {
    id: number;
    specieCode: string | undefined;
    scannerCode: number;
}

export class ScannerSpeedAbortedResultEmailInputDto implements IScannerSpeedAbortedResultEmailInputDto {
    vendorEmails!: string[] | undefined;
    vendorName!: string | undefined;
    periodExternalId!: number;
    driverExternalId!: number;
    driverName!: string | undefined;
    periodStartDate!: DateTime;
    periodEndDate!: DateTime;
    placeId!: number;

    constructor(data?: IScannerSpeedAbortedResultEmailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vendorEmails"])) {
                this.vendorEmails = [] as any;
                for (let item of _data["vendorEmails"])
                    this.vendorEmails!.push(item);
            }
            this.vendorName = _data["vendorName"];
            this.periodExternalId = _data["periodExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverName = _data["driverName"];
            this.periodStartDate = _data["periodStartDate"] ? DateTime.fromISO(_data["periodStartDate"].toString()) : <any>undefined;
            this.periodEndDate = _data["periodEndDate"] ? DateTime.fromISO(_data["periodEndDate"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): ScannerSpeedAbortedResultEmailInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerSpeedAbortedResultEmailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendorEmails)) {
            data["vendorEmails"] = [];
            for (let item of this.vendorEmails)
                data["vendorEmails"].push(item);
        }
        data["vendorName"] = this.vendorName;
        data["periodExternalId"] = this.periodExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverName"] = this.driverName;
        data["periodStartDate"] = this.periodStartDate ? this.periodStartDate.toString() : <any>undefined;
        data["periodEndDate"] = this.periodEndDate ? this.periodEndDate.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IScannerSpeedAbortedResultEmailInputDto {
    vendorEmails: string[] | undefined;
    vendorName: string | undefined;
    periodExternalId: number;
    driverExternalId: number;
    driverName: string | undefined;
    periodStartDate: DateTime;
    periodEndDate: DateTime;
    placeId: number;
}

export class ScannerSummaryDto implements IScannerSummaryDto {
    executionDate!: DateTime | undefined;
    loadQuality!: boolean;
    fullIndicator!: boolean;
    totalSolidVolume!: number;
    density!: number;

    constructor(data?: IScannerSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.executionDate = _data["executionDate"] ? DateTime.fromISO(_data["executionDate"].toString()) : <any>undefined;
            this.loadQuality = _data["loadQuality"];
            this.fullIndicator = _data["fullIndicator"];
            this.totalSolidVolume = _data["totalSolidVolume"];
            this.density = _data["density"];
        }
    }

    static fromJS(data: any): ScannerSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["executionDate"] = this.executionDate ? this.executionDate.toString() : <any>undefined;
        data["loadQuality"] = this.loadQuality;
        data["fullIndicator"] = this.fullIndicator;
        data["totalSolidVolume"] = this.totalSolidVolume;
        data["density"] = this.density;
        return data;
    }
}

export interface IScannerSummaryDto {
    executionDate: DateTime | undefined;
    loadQuality: boolean;
    fullIndicator: boolean;
    totalSolidVolume: number;
    density: number;
}

export class ScannerTruckTypeDto implements IScannerTruckTypeDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IScannerTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ScannerTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScannerTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IScannerTruckTypeDto {
    id: number;
    name: string | undefined;
}

export class SDAValuesDto implements ISDAValuesDto {
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: ISDAValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SDAValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SDAValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface ISDAValuesDto {
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export class SearchReportByProviderOutputDto implements ISearchReportByProviderOutputDto {
    reportId!: number;
    reportSerial!: string | undefined;
    reportNumber!: number;
    externalArticlelId!: number | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;
    externalVehicleId!: number;
    externalDriverId!: number;
    externalOriginId!: number;
    originType!: LocationType;
    externalDestinationId!: number;
    destinationType!: LocationType;
    externalLineId!: number;
    lineType!: LocationType;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    tripNumber!: number | undefined;

    constructor(data?: ISearchReportByProviderOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.reportSerial = _data["reportSerial"];
            this.reportNumber = _data["reportNumber"];
            this.externalArticlelId = _data["externalArticlelId"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
            this.externalVehicleId = _data["externalVehicleId"];
            this.externalDriverId = _data["externalDriverId"];
            this.externalOriginId = _data["externalOriginId"];
            this.originType = _data["originType"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.destinationType = _data["destinationType"];
            this.externalLineId = _data["externalLineId"];
            this.lineType = _data["lineType"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
        }
    }

    static fromJS(data: any): SearchReportByProviderOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReportByProviderOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["reportSerial"] = this.reportSerial;
        data["reportNumber"] = this.reportNumber;
        data["externalArticlelId"] = this.externalArticlelId;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        data["externalVehicleId"] = this.externalVehicleId;
        data["externalDriverId"] = this.externalDriverId;
        data["externalOriginId"] = this.externalOriginId;
        data["originType"] = this.originType;
        data["externalDestinationId"] = this.externalDestinationId;
        data["destinationType"] = this.destinationType;
        data["externalLineId"] = this.externalLineId;
        data["lineType"] = this.lineType;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        return data;
    }
}

export interface ISearchReportByProviderOutputDto {
    reportId: number;
    reportSerial: string | undefined;
    reportNumber: number;
    externalArticlelId: number | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
    externalVehicleId: number;
    externalDriverId: number;
    externalOriginId: number;
    originType: LocationType;
    externalDestinationId: number;
    destinationType: LocationType;
    externalLineId: number;
    lineType: LocationType;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    tripNumber: number | undefined;
}

export class SearchReportOutputDto implements ISearchReportOutputDto {
    id!: number;
    serial!: string | undefined;
    number!: number;
    date!: DateTime;
    exitDate!: DateTime | undefined;
    state!: ActivityReportState;
    externalTruckId!: number;
    externalOriginId!: number;
    originType!: LocationType;
    externalDestinationId!: number;
    destinationType!: LocationType;
    operationMode!: ActivityReportOperationMode;
    localId!: number;
    externalStandId!: number;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;
    pileName!: string | undefined;

    constructor(data?: ISearchReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.state = _data["state"];
            this.externalTruckId = _data["externalTruckId"];
            this.externalOriginId = _data["externalOriginId"];
            this.originType = _data["originType"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.destinationType = _data["destinationType"];
            this.operationMode = _data["operationMode"];
            this.localId = _data["localId"];
            this.externalStandId = _data["externalStandId"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
            this.pileName = _data["pileName"];
        }
    }

    static fromJS(data: any): SearchReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["state"] = this.state;
        data["externalTruckId"] = this.externalTruckId;
        data["externalOriginId"] = this.externalOriginId;
        data["originType"] = this.originType;
        data["externalDestinationId"] = this.externalDestinationId;
        data["destinationType"] = this.destinationType;
        data["operationMode"] = this.operationMode;
        data["localId"] = this.localId;
        data["externalStandId"] = this.externalStandId;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        data["pileName"] = this.pileName;
        return data;
    }
}

export interface ISearchReportOutputDto {
    id: number;
    serial: string | undefined;
    number: number;
    date: DateTime;
    exitDate: DateTime | undefined;
    state: ActivityReportState;
    externalTruckId: number;
    externalOriginId: number;
    originType: LocationType;
    externalDestinationId: number;
    destinationType: LocationType;
    operationMode: ActivityReportOperationMode;
    localId: number;
    externalStandId: number;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
    pileName: string | undefined;
}

export class SearchWoodVendorQuotaOutputDto implements ISearchWoodVendorQuotaOutputDto {
    externalVendorIds!: number[] | undefined;
    hourlyQuota!: number;
    tolerance!: number;
    woodVendorQuotaId!: number;
    volumeDailyTolerance!: number;

    constructor(data?: ISearchWoodVendorQuotaOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["externalVendorIds"])) {
                this.externalVendorIds = [] as any;
                for (let item of _data["externalVendorIds"])
                    this.externalVendorIds!.push(item);
            }
            this.hourlyQuota = _data["hourlyQuota"];
            this.tolerance = _data["tolerance"];
            this.woodVendorQuotaId = _data["woodVendorQuotaId"];
            this.volumeDailyTolerance = _data["volumeDailyTolerance"];
        }
    }

    static fromJS(data: any): SearchWoodVendorQuotaOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SearchWoodVendorQuotaOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.externalVendorIds)) {
            data["externalVendorIds"] = [];
            for (let item of this.externalVendorIds)
                data["externalVendorIds"].push(item);
        }
        data["hourlyQuota"] = this.hourlyQuota;
        data["tolerance"] = this.tolerance;
        data["woodVendorQuotaId"] = this.woodVendorQuotaId;
        data["volumeDailyTolerance"] = this.volumeDailyTolerance;
        return data;
    }
}

export interface ISearchWoodVendorQuotaOutputDto {
    externalVendorIds: number[] | undefined;
    hourlyQuota: number;
    tolerance: number;
    woodVendorQuotaId: number;
    volumeDailyTolerance: number;
}

export enum SecurityRuleSet {
    None = "None",
    Level1 = "Level1",
    Level2 = "Level2",
}

export class SecuritySettingsEditDto implements ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser!: boolean;
    useDefaultPasswordComplexitySettings!: boolean;
    passwordComplexity!: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity!: PasswordComplexitySetting | undefined;
    userLockOut!: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin!: TwoFactorLoginSettingsEditDto | undefined;

    constructor(data?: ISecuritySettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowOneConcurrentLoginPerUser = _data["allowOneConcurrentLoginPerUser"];
            this.useDefaultPasswordComplexitySettings = _data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = _data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(_data["passwordComplexity"]) : <any>undefined;
            this.defaultPasswordComplexity = _data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(_data["defaultPasswordComplexity"]) : <any>undefined;
            this.userLockOut = _data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(_data["userLockOut"]) : <any>undefined;
            this.twoFactorLogin = _data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(_data["twoFactorLogin"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SecuritySettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowOneConcurrentLoginPerUser"] = this.allowOneConcurrentLoginPerUser;
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : <any>undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : <any>undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : <any>undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISecuritySettingsEditDto {
    allowOneConcurrentLoginPerUser: boolean;
    useDefaultPasswordComplexitySettings: boolean;
    passwordComplexity: PasswordComplexitySetting | undefined;
    defaultPasswordComplexity: PasswordComplexitySetting | undefined;
    userLockOut: UserLockOutSettingsEditDto | undefined;
    twoFactorLogin: TwoFactorLoginSettingsEditDto | undefined;
}

export class SemaphoreDto implements ISemaphoreDto {
    name!: string | undefined;
    externalId!: number | undefined;
    actualState!: ActualState;
    zone!: ZoneInDeviceDto | undefined;
    zoneId!: number;
    deviceType!: DeviceTypeDto | undefined;
    deviceTypeId!: number;
    id!: number;

    constructor(data?: ISemaphoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.externalId = _data["externalId"];
            this.actualState = _data["actualState"];
            this.zone = _data["zone"] ? ZoneInDeviceDto.fromJS(_data["zone"]) : <any>undefined;
            this.zoneId = _data["zoneId"];
            this.deviceType = _data["deviceType"] ? DeviceTypeDto.fromJS(_data["deviceType"]) : <any>undefined;
            this.deviceTypeId = _data["deviceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SemaphoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new SemaphoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["externalId"] = this.externalId;
        data["actualState"] = this.actualState;
        data["zone"] = this.zone ? this.zone.toJSON() : <any>undefined;
        data["zoneId"] = this.zoneId;
        data["deviceType"] = this.deviceType ? this.deviceType.toJSON() : <any>undefined;
        data["deviceTypeId"] = this.deviceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISemaphoreDto {
    name: string | undefined;
    externalId: number | undefined;
    actualState: ActualState;
    zone: ZoneInDeviceDto | undefined;
    zoneId: number;
    deviceType: DeviceTypeDto | undefined;
    deviceTypeId: number;
    id: number;
}

export class SendEmailActivationLinkInput implements ISendEmailActivationLinkInput {
    emailAddress!: string;

    constructor(data?: ISendEmailActivationLinkInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendEmailActivationLinkInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendEmailActivationLinkInput {
    emailAddress: string;
}

export class SendEmailOutputDto implements ISendEmailOutputDto {
    isSuccess!: boolean;
    message!: string | undefined;

    constructor(data?: ISendEmailOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SendEmailOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendEmailOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface ISendEmailOutputDto {
    isSuccess: boolean;
    message: string | undefined;
}

export class SendPasswordResetCodeInput implements ISendPasswordResetCodeInput {
    emailAddress!: string;

    constructor(data?: ISendPasswordResetCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendPasswordResetCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendPasswordResetCodeInput {
    emailAddress: string;
}

export class SendTestEmailInput implements ISendTestEmailInput {
    emailAddress!: string;

    constructor(data?: ISendTestEmailInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailAddress = _data["emailAddress"];
        }
    }

    static fromJS(data: any): SendTestEmailInput {
        data = typeof data === 'object' ? data : {};
        let result = new SendTestEmailInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    }
}

export interface ISendTestEmailInput {
    emailAddress: string;
}

export class SendTwoFactorAuthCodeModel implements ISendTwoFactorAuthCodeModel {
    userId!: number;
    provider!: string;

    constructor(data?: ISendTwoFactorAuthCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.provider = _data["provider"];
        }
    }

    static fromJS(data: any): SendTwoFactorAuthCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    }
}

export interface ISendTwoFactorAuthCodeModel {
    userId: number;
    provider: string;
}

export class SendVerificationSmsInputDto implements ISendVerificationSmsInputDto {
    phoneNumber!: string | undefined;

    constructor(data?: ISendVerificationSmsInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): SendVerificationSmsInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SendVerificationSmsInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface ISendVerificationSmsInputDto {
    phoneNumber: string | undefined;
}

export class ServiceConfigurationDto implements IServiceConfigurationDto {
    externalArticleId!: number;
    serviceType!: ServiceType;
    originId!: number;
    originName!: string | undefined;
    externalDestinationId!: number | undefined;
    externalInvoiceServiceId!: number;
    id!: number;

    constructor(data?: IServiceConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalArticleId = _data["externalArticleId"];
            this.serviceType = _data["serviceType"];
            this.originId = _data["originId"];
            this.originName = _data["originName"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.externalInvoiceServiceId = _data["externalInvoiceServiceId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ServiceConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalArticleId"] = this.externalArticleId;
        data["serviceType"] = this.serviceType;
        data["originId"] = this.originId;
        data["originName"] = this.originName;
        data["externalDestinationId"] = this.externalDestinationId;
        data["externalInvoiceServiceId"] = this.externalInvoiceServiceId;
        data["id"] = this.id;
        return data;
    }
}

export interface IServiceConfigurationDto {
    externalArticleId: number;
    serviceType: ServiceType;
    originId: number;
    originName: string | undefined;
    externalDestinationId: number | undefined;
    externalInvoiceServiceId: number;
    id: number;
}

export class ServiceDto implements IServiceDto {
    tenantId!: number;
    externalIdentity!: ExternalIdentityDto | undefined;
    externalVendorId!: number;

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.externalIdentity = _data["externalIdentity"] ? ExternalIdentityDto.fromJS(_data["externalIdentity"]) : <any>undefined;
            this.externalVendorId = _data["externalVendorId"];
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["externalIdentity"] = this.externalIdentity ? this.externalIdentity.toJSON() : <any>undefined;
        data["externalVendorId"] = this.externalVendorId;
        return data;
    }
}

export interface IServiceDto {
    tenantId: number;
    externalIdentity: ExternalIdentityDto | undefined;
    externalVendorId: number;
}

export class ServiceEntrySheetInformationDto implements IServiceEntrySheetInformationDto {
    externalServiceId!: number;
    isReversed!: boolean;
    generatedDate!: DateTime;
    reversedDate!: DateTime | undefined;
    serviceEntrySheetNumber!: number;

    constructor(data?: IServiceEntrySheetInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalServiceId = _data["externalServiceId"];
            this.isReversed = _data["isReversed"];
            this.generatedDate = _data["generatedDate"] ? DateTime.fromISO(_data["generatedDate"].toString()) : <any>undefined;
            this.reversedDate = _data["reversedDate"] ? DateTime.fromISO(_data["reversedDate"].toString()) : <any>undefined;
            this.serviceEntrySheetNumber = _data["serviceEntrySheetNumber"];
        }
    }

    static fromJS(data: any): ServiceEntrySheetInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceEntrySheetInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalServiceId"] = this.externalServiceId;
        data["isReversed"] = this.isReversed;
        data["generatedDate"] = this.generatedDate ? this.generatedDate.toString() : <any>undefined;
        data["reversedDate"] = this.reversedDate ? this.reversedDate.toString() : <any>undefined;
        data["serviceEntrySheetNumber"] = this.serviceEntrySheetNumber;
        return data;
    }
}

export interface IServiceEntrySheetInformationDto {
    externalServiceId: number;
    isReversed: boolean;
    generatedDate: DateTime;
    reversedDate: DateTime | undefined;
    serviceEntrySheetNumber: number;
}

export class ServiceProviderConfigurationDto implements IServiceProviderConfigurationDto {
    providerVatNumber!: string | undefined;

    constructor(data?: IServiceProviderConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.providerVatNumber = _data["providerVatNumber"];
        }
    }

    static fromJS(data: any): ServiceProviderConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceProviderConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerVatNumber"] = this.providerVatNumber;
        return data;
    }
}

export interface IServiceProviderConfigurationDto {
    providerVatNumber: string | undefined;
}

export enum ServiceType {
    Transport = "Transport",
    Load = "Load",
}

export class SessionTimeOutSettingsEditDto implements ISessionTimeOutSettingsEditDto {
    isEnabled!: boolean;
    timeOutSecond!: number;
    showTimeOutNotificationSecond!: number;
    showLockScreenWhenTimedOut!: boolean;

    constructor(data?: ISessionTimeOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.timeOutSecond = _data["timeOutSecond"];
            this.showTimeOutNotificationSecond = _data["showTimeOutNotificationSecond"];
            this.showLockScreenWhenTimedOut = _data["showLockScreenWhenTimedOut"];
        }
    }

    static fromJS(data: any): SessionTimeOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTimeOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["timeOutSecond"] = this.timeOutSecond;
        data["showTimeOutNotificationSecond"] = this.showTimeOutNotificationSecond;
        data["showLockScreenWhenTimedOut"] = this.showLockScreenWhenTimedOut;
        return data;
    }
}

export interface ISessionTimeOutSettingsEditDto {
    isEnabled: boolean;
    timeOutSecond: number;
    showTimeOutNotificationSecond: number;
    showLockScreenWhenTimedOut: boolean;
}

export class SetDefaultLanguageInput implements ISetDefaultLanguageInput {
    name!: string;

    constructor(data?: ISetDefaultLanguageInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SetDefaultLanguageInput {
        data = typeof data === 'object' ? data : {};
        let result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface ISetDefaultLanguageInput {
    name: string;
}

export enum SettingScopes {
    Application = "Application",
    Tenant = "Tenant",
    User = "User",
    All = "All",
}

export class ShouldBeSampledInputDto implements IShouldBeSampledInputDto {
    reportId!: number;
    standNumber!: number;
    articleId!: number;
    samplingPercentage!: number;
    periodStart!: DateTime;
    periodEnd!: DateTime;
    placeId!: number;
    isManualReport!: boolean;
    notSyncedReportsCount!: number;
    notSyncedSkippedSamplesCount!: number;
    usesScanner!: boolean;
    modelId!: number;
    speciesGroupId!: number;
    isCandidateForRandomSample!: boolean;
    woodOrginIsStand!: boolean;

    constructor(data?: IShouldBeSampledInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.standNumber = _data["standNumber"];
            this.articleId = _data["articleId"];
            this.samplingPercentage = _data["samplingPercentage"];
            this.periodStart = _data["periodStart"] ? DateTime.fromISO(_data["periodStart"].toString()) : <any>undefined;
            this.periodEnd = _data["periodEnd"] ? DateTime.fromISO(_data["periodEnd"].toString()) : <any>undefined;
            this.placeId = _data["placeId"];
            this.isManualReport = _data["isManualReport"];
            this.notSyncedReportsCount = _data["notSyncedReportsCount"];
            this.notSyncedSkippedSamplesCount = _data["notSyncedSkippedSamplesCount"];
            this.usesScanner = _data["usesScanner"];
            this.modelId = _data["modelId"];
            this.speciesGroupId = _data["speciesGroupId"];
            this.isCandidateForRandomSample = _data["isCandidateForRandomSample"];
            this.woodOrginIsStand = _data["woodOrginIsStand"];
        }
    }

    static fromJS(data: any): ShouldBeSampledInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShouldBeSampledInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["standNumber"] = this.standNumber;
        data["articleId"] = this.articleId;
        data["samplingPercentage"] = this.samplingPercentage;
        data["periodStart"] = this.periodStart ? this.periodStart.toString() : <any>undefined;
        data["periodEnd"] = this.periodEnd ? this.periodEnd.toString() : <any>undefined;
        data["placeId"] = this.placeId;
        data["isManualReport"] = this.isManualReport;
        data["notSyncedReportsCount"] = this.notSyncedReportsCount;
        data["notSyncedSkippedSamplesCount"] = this.notSyncedSkippedSamplesCount;
        data["usesScanner"] = this.usesScanner;
        data["modelId"] = this.modelId;
        data["speciesGroupId"] = this.speciesGroupId;
        data["isCandidateForRandomSample"] = this.isCandidateForRandomSample;
        data["woodOrginIsStand"] = this.woodOrginIsStand;
        return data;
    }
}

export interface IShouldBeSampledInputDto {
    reportId: number;
    standNumber: number;
    articleId: number;
    samplingPercentage: number;
    periodStart: DateTime;
    periodEnd: DateTime;
    placeId: number;
    isManualReport: boolean;
    notSyncedReportsCount: number;
    notSyncedSkippedSamplesCount: number;
    usesScanner: boolean;
    modelId: number;
    speciesGroupId: number;
    isCandidateForRandomSample: boolean;
    woodOrginIsStand: boolean;
}

export class ShouldBeSampledOutput implements IShouldBeSampledOutput {
    shouldBeSampled!: boolean;
    wasAssignedSample!: boolean;
    warning!: string | undefined;
    shouldConfirmEntrance!: boolean;

    constructor(data?: IShouldBeSampledOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldBeSampled = _data["shouldBeSampled"];
            this.wasAssignedSample = _data["wasAssignedSample"];
            this.warning = _data["warning"];
            this.shouldConfirmEntrance = _data["shouldConfirmEntrance"];
        }
    }

    static fromJS(data: any): ShouldBeSampledOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ShouldBeSampledOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldBeSampled"] = this.shouldBeSampled;
        data["wasAssignedSample"] = this.wasAssignedSample;
        data["warning"] = this.warning;
        data["shouldConfirmEntrance"] = this.shouldConfirmEntrance;
        return data;
    }
}

export interface IShouldBeSampledOutput {
    shouldBeSampled: boolean;
    wasAssignedSample: boolean;
    warning: string | undefined;
    shouldConfirmEntrance: boolean;
}

export class SicfeValuesDto implements ISicfeValuesDto {
    cfeXmlTagVersion!: string | undefined;
    docMode!: string | undefined;
    docVia!: string | undefined;
    docType!: string | undefined;
    emmiterBusinessName!: string | undefined;
    emmiterDocument!: string | undefined;
    emmiterComercialName!: string | undefined;
    emmiterMail!: string | undefined;
    emmiterDGICode!: string | undefined;
    emmiterAddress!: string | undefined;
    emmiterCity!: string | undefined;
    emmiterDepartment!: string | undefined;
    emmiterPhone!: string | undefined;
    receiverName!: string | undefined;
    receiverAddress!: string | undefined;
    receiverCity!: string | undefined;
    receiverDepartment!: string | undefined;
    receiverCountry!: string | undefined;
    receiverPostalCode!: string | undefined;
    unitsCurrencyCode!: string | undefined;
    unitsCurrency!: string | undefined;
    unitsItemUnit!: string | undefined;
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: ISicfeValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cfeXmlTagVersion = _data["cfeXmlTagVersion"];
            this.docMode = _data["docMode"];
            this.docVia = _data["docVia"];
            this.docType = _data["docType"];
            this.emmiterBusinessName = _data["emmiterBusinessName"];
            this.emmiterDocument = _data["emmiterDocument"];
            this.emmiterComercialName = _data["emmiterComercialName"];
            this.emmiterMail = _data["emmiterMail"];
            this.emmiterDGICode = _data["emmiterDGICode"];
            this.emmiterAddress = _data["emmiterAddress"];
            this.emmiterCity = _data["emmiterCity"];
            this.emmiterDepartment = _data["emmiterDepartment"];
            this.emmiterPhone = _data["emmiterPhone"];
            this.receiverName = _data["receiverName"];
            this.receiverAddress = _data["receiverAddress"];
            this.receiverCity = _data["receiverCity"];
            this.receiverDepartment = _data["receiverDepartment"];
            this.receiverCountry = _data["receiverCountry"];
            this.receiverPostalCode = _data["receiverPostalCode"];
            this.unitsCurrencyCode = _data["unitsCurrencyCode"];
            this.unitsCurrency = _data["unitsCurrency"];
            this.unitsItemUnit = _data["unitsItemUnit"];
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SicfeValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SicfeValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cfeXmlTagVersion"] = this.cfeXmlTagVersion;
        data["docMode"] = this.docMode;
        data["docVia"] = this.docVia;
        data["docType"] = this.docType;
        data["emmiterBusinessName"] = this.emmiterBusinessName;
        data["emmiterDocument"] = this.emmiterDocument;
        data["emmiterComercialName"] = this.emmiterComercialName;
        data["emmiterMail"] = this.emmiterMail;
        data["emmiterDGICode"] = this.emmiterDGICode;
        data["emmiterAddress"] = this.emmiterAddress;
        data["emmiterCity"] = this.emmiterCity;
        data["emmiterDepartment"] = this.emmiterDepartment;
        data["emmiterPhone"] = this.emmiterPhone;
        data["receiverName"] = this.receiverName;
        data["receiverAddress"] = this.receiverAddress;
        data["receiverCity"] = this.receiverCity;
        data["receiverDepartment"] = this.receiverDepartment;
        data["receiverCountry"] = this.receiverCountry;
        data["receiverPostalCode"] = this.receiverPostalCode;
        data["unitsCurrencyCode"] = this.unitsCurrencyCode;
        data["unitsCurrency"] = this.unitsCurrency;
        data["unitsItemUnit"] = this.unitsItemUnit;
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface ISicfeValuesDto {
    cfeXmlTagVersion: string | undefined;
    docMode: string | undefined;
    docVia: string | undefined;
    docType: string | undefined;
    emmiterBusinessName: string | undefined;
    emmiterDocument: string | undefined;
    emmiterComercialName: string | undefined;
    emmiterMail: string | undefined;
    emmiterDGICode: string | undefined;
    emmiterAddress: string | undefined;
    emmiterCity: string | undefined;
    emmiterDepartment: string | undefined;
    emmiterPhone: string | undefined;
    receiverName: string | undefined;
    receiverAddress: string | undefined;
    receiverCity: string | undefined;
    receiverDepartment: string | undefined;
    receiverCountry: string | undefined;
    receiverPostalCode: string | undefined;
    unitsCurrencyCode: string | undefined;
    unitsCurrency: string | undefined;
    unitsItemUnit: string | undefined;
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export class SigeValueByProductDto implements ISigeValueByProductDto {
    depositCode!: number;
    userNameKey!: string | undefined;
    passwordKey!: string | undefined;
    url!: string | undefined;
    appliesToWood!: boolean;
    appliesToPulp!: boolean;
    appliesToChemicals!: boolean;
    appliesToWaste!: boolean;

    constructor(data?: ISigeValueByProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.depositCode = _data["depositCode"];
            this.userNameKey = _data["userNameKey"];
            this.passwordKey = _data["passwordKey"];
            this.url = _data["url"];
            this.appliesToWood = _data["appliesToWood"];
            this.appliesToPulp = _data["appliesToPulp"];
            this.appliesToChemicals = _data["appliesToChemicals"];
            this.appliesToWaste = _data["appliesToWaste"];
        }
    }

    static fromJS(data: any): SigeValueByProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new SigeValueByProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["depositCode"] = this.depositCode;
        data["userNameKey"] = this.userNameKey;
        data["passwordKey"] = this.passwordKey;
        data["url"] = this.url;
        data["appliesToWood"] = this.appliesToWood;
        data["appliesToPulp"] = this.appliesToPulp;
        data["appliesToChemicals"] = this.appliesToChemicals;
        data["appliesToWaste"] = this.appliesToWaste;
        return data;
    }
}

export interface ISigeValueByProductDto {
    depositCode: number;
    userNameKey: string | undefined;
    passwordKey: string | undefined;
    url: string | undefined;
    appliesToWood: boolean;
    appliesToPulp: boolean;
    appliesToChemicals: boolean;
    appliesToWaste: boolean;
}

export class SigeValuesDto implements ISigeValuesDto {
    customsTypeExport!: string | undefined;
    customsTypeImport!: string | undefined;
    newOperationCode!: string | undefined;
    deleteOperationCode!: string | undefined;
    applicationCode!: string | undefined;
    customsCode!: string | undefined;
    customsDocCode!: string | undefined;
    qntStock!: number;
    codeUnitMeasure!: string | undefined;
    codeUnitMeasureStock!: string | undefined;
    destinationCountry!: string | undefined;
    countryOrigin!: string | undefined;
    precedenseCountry!: string | undefined;
    cifDolls!: string | undefined;
    defaultChannel!: string | undefined;
    user!: string | undefined;
    configurationsByProduct!: SigeValueByProductDto[] | undefined;
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: ISigeValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customsTypeExport = _data["customsTypeExport"];
            this.customsTypeImport = _data["customsTypeImport"];
            this.newOperationCode = _data["newOperationCode"];
            this.deleteOperationCode = _data["deleteOperationCode"];
            this.applicationCode = _data["applicationCode"];
            this.customsCode = _data["customsCode"];
            this.customsDocCode = _data["customsDocCode"];
            this.qntStock = _data["qntStock"];
            this.codeUnitMeasure = _data["codeUnitMeasure"];
            this.codeUnitMeasureStock = _data["codeUnitMeasureStock"];
            this.destinationCountry = _data["destinationCountry"];
            this.countryOrigin = _data["countryOrigin"];
            this.precedenseCountry = _data["precedenseCountry"];
            this.cifDolls = _data["cifDolls"];
            this.defaultChannel = _data["defaultChannel"];
            this.user = _data["user"];
            if (Array.isArray(_data["configurationsByProduct"])) {
                this.configurationsByProduct = [] as any;
                for (let item of _data["configurationsByProduct"])
                    this.configurationsByProduct!.push(SigeValueByProductDto.fromJS(item));
            }
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SigeValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SigeValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customsTypeExport"] = this.customsTypeExport;
        data["customsTypeImport"] = this.customsTypeImport;
        data["newOperationCode"] = this.newOperationCode;
        data["deleteOperationCode"] = this.deleteOperationCode;
        data["applicationCode"] = this.applicationCode;
        data["customsCode"] = this.customsCode;
        data["customsDocCode"] = this.customsDocCode;
        data["qntStock"] = this.qntStock;
        data["codeUnitMeasure"] = this.codeUnitMeasure;
        data["codeUnitMeasureStock"] = this.codeUnitMeasureStock;
        data["destinationCountry"] = this.destinationCountry;
        data["countryOrigin"] = this.countryOrigin;
        data["precedenseCountry"] = this.precedenseCountry;
        data["cifDolls"] = this.cifDolls;
        data["defaultChannel"] = this.defaultChannel;
        data["user"] = this.user;
        if (Array.isArray(this.configurationsByProduct)) {
            data["configurationsByProduct"] = [];
            for (let item of this.configurationsByProduct)
                data["configurationsByProduct"].push(item.toJSON());
        }
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface ISigeValuesDto {
    customsTypeExport: string | undefined;
    customsTypeImport: string | undefined;
    newOperationCode: string | undefined;
    deleteOperationCode: string | undefined;
    applicationCode: string | undefined;
    customsCode: string | undefined;
    customsDocCode: string | undefined;
    qntStock: number;
    codeUnitMeasure: string | undefined;
    codeUnitMeasureStock: string | undefined;
    destinationCountry: string | undefined;
    countryOrigin: string | undefined;
    precedenseCountry: string | undefined;
    cifDolls: string | undefined;
    defaultChannel: string | undefined;
    user: string | undefined;
    configurationsByProduct: SigeValueByProductDto[] | undefined;
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export class SingleCustomDeclarationDto implements ISingleCustomDeclarationDto {
    tenantId!: number;
    externalIdentity!: ExternalIdentityDto | undefined;
    id!: number;

    constructor(data?: ISingleCustomDeclarationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.externalIdentity = _data["externalIdentity"] ? ExternalIdentityDto.fromJS(_data["externalIdentity"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SingleCustomDeclarationDto {
        data = typeof data === 'object' ? data : {};
        let result = new SingleCustomDeclarationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["externalIdentity"] = this.externalIdentity ? this.externalIdentity.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ISingleCustomDeclarationDto {
    tenantId: number;
    externalIdentity: ExternalIdentityDto | undefined;
    id: number;
}

export class SingleCustomsDeclarationInputDto implements ISingleCustomsDeclarationInputDto {
    externalId!: number;
    number!: string | undefined;
    vendorId!: number;
    ncmName!: string | undefined;
    initialDate!: DateTime;
    finalDate!: DateTime;
    tolerance!: number;
    tons!: number;
    tonsWarning!: number;
    ncmNumber!: number;
    dispatcher!: string | undefined;
    carryWay!: string | undefined;

    constructor(data?: ISingleCustomsDeclarationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.number = _data["number"];
            this.vendorId = _data["vendorId"];
            this.ncmName = _data["ncmName"];
            this.initialDate = _data["initialDate"] ? DateTime.fromISO(_data["initialDate"].toString()) : <any>undefined;
            this.finalDate = _data["finalDate"] ? DateTime.fromISO(_data["finalDate"].toString()) : <any>undefined;
            this.tolerance = _data["tolerance"];
            this.tons = _data["tons"];
            this.tonsWarning = _data["tonsWarning"];
            this.ncmNumber = _data["ncmNumber"];
            this.dispatcher = _data["dispatcher"];
            this.carryWay = _data["carryWay"];
        }
    }

    static fromJS(data: any): SingleCustomsDeclarationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SingleCustomsDeclarationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["number"] = this.number;
        data["vendorId"] = this.vendorId;
        data["ncmName"] = this.ncmName;
        data["initialDate"] = this.initialDate ? this.initialDate.toString() : <any>undefined;
        data["finalDate"] = this.finalDate ? this.finalDate.toString() : <any>undefined;
        data["tolerance"] = this.tolerance;
        data["tons"] = this.tons;
        data["tonsWarning"] = this.tonsWarning;
        data["ncmNumber"] = this.ncmNumber;
        data["dispatcher"] = this.dispatcher;
        data["carryWay"] = this.carryWay;
        return data;
    }
}

export interface ISingleCustomsDeclarationInputDto {
    externalId: number;
    number: string | undefined;
    vendorId: number;
    ncmName: string | undefined;
    initialDate: DateTime;
    finalDate: DateTime;
    tolerance: number;
    tons: number;
    tonsWarning: number;
    ncmNumber: number;
    dispatcher: string | undefined;
    carryWay: string | undefined;
}

export class SingleCustomsDeclarationWarningTonsEmailInputDto implements ISingleCustomsDeclarationWarningTonsEmailInputDto {
    singleCustomsDeclarationNumber!: string | undefined;
    singleCustomsDeclarationCurrentTons!: number;
    singleCustomsDeclarationMaxTons!: number;
    singleCustomsDeclarationWarningTons!: number;
    placeId!: number;

    constructor(data?: ISingleCustomsDeclarationWarningTonsEmailInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.singleCustomsDeclarationNumber = _data["singleCustomsDeclarationNumber"];
            this.singleCustomsDeclarationCurrentTons = _data["singleCustomsDeclarationCurrentTons"];
            this.singleCustomsDeclarationMaxTons = _data["singleCustomsDeclarationMaxTons"];
            this.singleCustomsDeclarationWarningTons = _data["singleCustomsDeclarationWarningTons"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): SingleCustomsDeclarationWarningTonsEmailInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SingleCustomsDeclarationWarningTonsEmailInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["singleCustomsDeclarationNumber"] = this.singleCustomsDeclarationNumber;
        data["singleCustomsDeclarationCurrentTons"] = this.singleCustomsDeclarationCurrentTons;
        data["singleCustomsDeclarationMaxTons"] = this.singleCustomsDeclarationMaxTons;
        data["singleCustomsDeclarationWarningTons"] = this.singleCustomsDeclarationWarningTons;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface ISingleCustomsDeclarationWarningTonsEmailInputDto {
    singleCustomsDeclarationNumber: string | undefined;
    singleCustomsDeclarationCurrentTons: number;
    singleCustomsDeclarationMaxTons: number;
    singleCustomsDeclarationWarningTons: number;
    placeId: number;
}

export class SingleIntegrationLogInputDto implements ISingleIntegrationLogInputDto {
    logId!: number;
    isSuccess!: boolean;
    message!: string | undefined;

    constructor(data?: ISingleIntegrationLogInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logId = _data["logId"];
            this.isSuccess = _data["isSuccess"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): SingleIntegrationLogInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new SingleIntegrationLogInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logId"] = this.logId;
        data["isSuccess"] = this.isSuccess;
        data["message"] = this.message;
        return data;
    }
}

export interface ISingleIntegrationLogInputDto {
    logId: number;
    isSuccess: boolean;
    message: string | undefined;
}

export class SmartInvoicingActivityReportPrefixDto implements ISmartInvoicingActivityReportPrefixDto {
    prefix!: string | undefined;

    constructor(data?: ISmartInvoicingActivityReportPrefixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prefix = _data["prefix"];
        }
    }

    static fromJS(data: any): SmartInvoicingActivityReportPrefixDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartInvoicingActivityReportPrefixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prefix"] = this.prefix;
        return data;
    }
}

export interface ISmartInvoicingActivityReportPrefixDto {
    prefix: string | undefined;
}

export class SmartInvoicingValuesDto implements ISmartInvoicingValuesDto {
    erpCode!: string | undefined;
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: ISmartInvoicingValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.erpCode = _data["erpCode"];
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SmartInvoicingValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartInvoicingValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["erpCode"] = this.erpCode;
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface ISmartInvoicingValuesDto {
    erpCode: string | undefined;
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export class SmartLogyardMultisiteValuesDto implements ISmartLogyardMultisiteValuesDto {
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: ISmartLogyardMultisiteValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SmartLogyardMultisiteValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartLogyardMultisiteValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface ISmartLogyardMultisiteValuesDto {
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export class SmartLogyardValuesDto implements ISmartLogyardValuesDto {
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: ISmartLogyardValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SmartLogyardValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartLogyardValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface ISmartLogyardValuesDto {
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export class SmartripValuesDto implements ISmartripValuesDto {
    endpoint!: string | undefined;
    timeout!: number;
    id!: number;

    constructor(data?: ISmartripValuesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endpoint = _data["endpoint"];
            this.timeout = _data["timeout"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SmartripValuesDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartripValuesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endpoint"] = this.endpoint;
        data["timeout"] = this.timeout;
        data["id"] = this.id;
        return data;
    }
}

export interface ISmartripValuesDto {
    endpoint: string | undefined;
    timeout: number;
    id: number;
}

export class StandDto implements IStandDto {
    externalIdentity!: ExternalIdentityDto | undefined;
    density!: number;
    isExternal!: boolean;
    standNumber!: number;

    constructor(data?: IStandDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalIdentity = _data["externalIdentity"] ? ExternalIdentityDto.fromJS(_data["externalIdentity"]) : <any>undefined;
            this.density = _data["density"];
            this.isExternal = _data["isExternal"];
            this.standNumber = _data["standNumber"];
        }
    }

    static fromJS(data: any): StandDto {
        data = typeof data === 'object' ? data : {};
        let result = new StandDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalIdentity"] = this.externalIdentity ? this.externalIdentity.toJSON() : <any>undefined;
        data["density"] = this.density;
        data["isExternal"] = this.isExternal;
        data["standNumber"] = this.standNumber;
        return data;
    }
}

export interface IStandDto {
    externalIdentity: ExternalIdentityDto | undefined;
    density: number;
    isExternal: boolean;
    standNumber: number;
}

export class StockIntegrationOutputDto implements IStockIntegrationOutputDto {
    successfull!: boolean;
    activityReportId!: number;
    activityReportType!: ActivityReportType;
    message!: string | undefined;

    constructor(data?: IStockIntegrationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.successfull = _data["successfull"];
            this.activityReportId = _data["activityReportId"];
            this.activityReportType = _data["activityReportType"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): StockIntegrationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new StockIntegrationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["successfull"] = this.successfull;
        data["activityReportId"] = this.activityReportId;
        data["activityReportType"] = this.activityReportType;
        data["message"] = this.message;
        return data;
    }
}

export interface IStockIntegrationOutputDto {
    successfull: boolean;
    activityReportId: number;
    activityReportType: ActivityReportType;
    message: string | undefined;
}

export class StringOutput implements IStringOutput {
    output!: string | undefined;

    constructor(data?: IStringOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.output = _data["output"];
        }
    }

    static fromJS(data: any): StringOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StringOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    }
}

export interface IStringOutput {
    output: string | undefined;
}

export class StripeConfigurationDto implements IStripeConfigurationDto {
    publishableKey!: string | undefined;

    constructor(data?: IStripeConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publishableKey = _data["publishableKey"];
        }
    }

    static fromJS(data: any): StripeConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new StripeConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    }
}

export interface IStripeConfigurationDto {
    publishableKey: string | undefined;
}

export class StripeCreatePaymentSessionInput implements IStripeCreatePaymentSessionInput {
    paymentId!: number;
    successUrl!: string | undefined;
    cancelUrl!: string | undefined;

    constructor(data?: IStripeCreatePaymentSessionInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentId = _data["paymentId"];
            this.successUrl = _data["successUrl"];
            this.cancelUrl = _data["cancelUrl"];
        }
    }

    static fromJS(data: any): StripeCreatePaymentSessionInput {
        data = typeof data === 'object' ? data : {};
        let result = new StripeCreatePaymentSessionInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["successUrl"] = this.successUrl;
        data["cancelUrl"] = this.cancelUrl;
        return data;
    }
}

export interface IStripeCreatePaymentSessionInput {
    paymentId: number;
    successUrl: string | undefined;
    cancelUrl: string | undefined;
}

export class StripePaymentResultOutput implements IStripePaymentResultOutput {
    paymentDone!: boolean;

    constructor(data?: IStripePaymentResultOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentDone = _data["paymentDone"];
        }
    }

    static fromJS(data: any): StripePaymentResultOutput {
        data = typeof data === 'object' ? data : {};
        let result = new StripePaymentResultOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentDone"] = this.paymentDone;
        return data;
    }
}

export interface IStripePaymentResultOutput {
    paymentDone: boolean;
}

export class SubscribableEditionComboboxItemDto implements ISubscribableEditionComboboxItemDto {
    isFree!: boolean | undefined;
    value!: string | undefined;
    displayText!: string | undefined;
    isSelected!: boolean;

    constructor(data?: ISubscribableEditionComboboxItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFree = _data["isFree"];
            this.value = _data["value"];
            this.displayText = _data["displayText"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): SubscribableEditionComboboxItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface ISubscribableEditionComboboxItemDto {
    isFree: boolean | undefined;
    value: string | undefined;
    displayText: string | undefined;
    isSelected: boolean;
}

export class SubscriptionPaymentDto implements ISubscriptionPaymentDto {
    description!: string | undefined;
    gateway!: SubscriptionPaymentGatewayType;
    amount!: number;
    editionId!: number;
    tenantId!: number;
    dayCount!: number;
    paymentPeriodType!: PaymentPeriodType;
    paymentId!: string | undefined;
    payerId!: string | undefined;
    editionDisplayName!: string | undefined;
    invoiceNo!: number;
    status!: SubscriptionPaymentStatus;
    isRecurring!: boolean;
    externalPaymentId!: string | undefined;
    successUrl!: string | undefined;
    errorUrl!: string | undefined;
    editionPaymentType!: EditionPaymentType;
    id!: number;

    constructor(data?: ISubscriptionPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.tenantId = _data["tenantId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.paymentId = _data["paymentId"];
            this.payerId = _data["payerId"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.invoiceNo = _data["invoiceNo"];
            this.status = _data["status"];
            this.isRecurring = _data["isRecurring"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.successUrl = _data["successUrl"];
            this.errorUrl = _data["errorUrl"];
            this.editionPaymentType = _data["editionPaymentType"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["editionPaymentType"] = this.editionPaymentType;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentDto {
    description: string | undefined;
    gateway: SubscriptionPaymentGatewayType;
    amount: number;
    editionId: number;
    tenantId: number;
    dayCount: number;
    paymentPeriodType: PaymentPeriodType;
    paymentId: string | undefined;
    payerId: string | undefined;
    editionDisplayName: string | undefined;
    invoiceNo: number;
    status: SubscriptionPaymentStatus;
    isRecurring: boolean;
    externalPaymentId: string | undefined;
    successUrl: string | undefined;
    errorUrl: string | undefined;
    editionPaymentType: EditionPaymentType;
    id: number;
}

export enum SubscriptionPaymentGatewayType {
    Paypal = "Paypal",
    Stripe = "Stripe",
}

export class SubscriptionPaymentListDto implements ISubscriptionPaymentListDto {
    gateway!: string | undefined;
    amount!: number;
    editionId!: number;
    dayCount!: number;
    paymentPeriodType!: string | undefined;
    externalPaymentId!: string | undefined;
    payerId!: string | undefined;
    status!: string | undefined;
    editionDisplayName!: string | undefined;
    tenantId!: number;
    invoiceNo!: string | undefined;
    lastModificationTime!: DateTime | undefined;
    lastModifierUserId!: number | undefined;
    creationTime!: DateTime;
    creatorUserId!: number | undefined;
    id!: number;

    constructor(data?: ISubscriptionPaymentListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gateway = _data["gateway"];
            this.amount = _data["amount"];
            this.editionId = _data["editionId"];
            this.dayCount = _data["dayCount"];
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.externalPaymentId = _data["externalPaymentId"];
            this.payerId = _data["payerId"];
            this.status = _data["status"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.tenantId = _data["tenantId"];
            this.invoiceNo = _data["invoiceNo"];
            this.lastModificationTime = _data["lastModificationTime"] ? DateTime.fromISO(_data["lastModificationTime"].toString()) : <any>undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): SubscriptionPaymentListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["externalPaymentId"] = this.externalPaymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toString() : <any>undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    }
}

export interface ISubscriptionPaymentListDto {
    gateway: string | undefined;
    amount: number;
    editionId: number;
    dayCount: number;
    paymentPeriodType: string | undefined;
    externalPaymentId: string | undefined;
    payerId: string | undefined;
    status: string | undefined;
    editionDisplayName: string | undefined;
    tenantId: number;
    invoiceNo: string | undefined;
    lastModificationTime: DateTime | undefined;
    lastModifierUserId: number | undefined;
    creationTime: DateTime;
    creatorUserId: number | undefined;
    id: number;
}

export enum SubscriptionPaymentStatus {
    NotPaid = "NotPaid",
    Paid = "Paid",
    Failed = "Failed",
    Cancelled = "Cancelled",
    Completed = "Completed",
}

export enum SubscriptionPaymentType {
    Manual = "Manual",
    RecurringAutomatic = "RecurringAutomatic",
    RecurringManual = "RecurringManual",
}

export enum SubscriptionStartType {
    Free = "Free",
    Trial = "Trial",
    Paid = "Paid",
}

export class SwitchedAccountAuthenticateResultModel implements ISwitchedAccountAuthenticateResultModel {
    accessToken!: string | undefined;
    encryptedAccessToken!: string | undefined;
    expireInSeconds!: number;

    constructor(data?: ISwitchedAccountAuthenticateResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessToken = _data["accessToken"];
            this.encryptedAccessToken = _data["encryptedAccessToken"];
            this.expireInSeconds = _data["expireInSeconds"];
        }
    }

    static fromJS(data: any): SwitchedAccountAuthenticateResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    }
}

export interface ISwitchedAccountAuthenticateResultModel {
    accessToken: string | undefined;
    encryptedAccessToken: string | undefined;
    expireInSeconds: number;
}

export class SwitchToLinkedAccountInput implements ISwitchToLinkedAccountInput {
    targetTenantId!: number | undefined;
    targetUserId!: number;

    constructor(data?: ISwitchToLinkedAccountInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetTenantId = _data["targetTenantId"];
            this.targetUserId = _data["targetUserId"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountInput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    }
}

export interface ISwitchToLinkedAccountInput {
    targetTenantId: number | undefined;
    targetUserId: number;
}

export class SwitchToLinkedAccountOutput implements ISwitchToLinkedAccountOutput {
    switchAccountToken!: string | undefined;
    tenancyName!: string | undefined;

    constructor(data?: ISwitchToLinkedAccountOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.switchAccountToken = _data["switchAccountToken"];
            this.tenancyName = _data["tenancyName"];
        }
    }

    static fromJS(data: any): SwitchToLinkedAccountOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    }
}

export interface ISwitchToLinkedAccountOutput {
    switchAccountToken: string | undefined;
    tenancyName: string | undefined;
}

export class SynchronizeDiverseProductPreActivityReportInput implements ISynchronizeDiverseProductPreActivityReportInput {
    errorsChanged!: boolean;
    contractChanged!: boolean;
    newContract!: ExternalContractInput | undefined;
    activityReportId!: number;
    errors!: PreActivityReportErrorDto[] | undefined;

    constructor(data?: ISynchronizeDiverseProductPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.errorsChanged = _data["errorsChanged"];
            this.contractChanged = _data["contractChanged"];
            this.newContract = _data["newContract"] ? ExternalContractInput.fromJS(_data["newContract"]) : <any>undefined;
            this.activityReportId = _data["activityReportId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SynchronizeDiverseProductPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeDiverseProductPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["errorsChanged"] = this.errorsChanged;
        data["contractChanged"] = this.contractChanged;
        data["newContract"] = this.newContract ? this.newContract.toJSON() : <any>undefined;
        data["activityReportId"] = this.activityReportId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISynchronizeDiverseProductPreActivityReportInput {
    errorsChanged: boolean;
    contractChanged: boolean;
    newContract: ExternalContractInput | undefined;
    activityReportId: number;
    errors: PreActivityReportErrorDto[] | undefined;
}

export class SynchronizePreActivityReportInput implements ISynchronizePreActivityReportInput {
    activityReportId!: number;
    errors!: PreActivityReportErrorDto[] | undefined;

    constructor(data?: ISynchronizePreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SynchronizePreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizePreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISynchronizePreActivityReportInput {
    activityReportId: number;
    errors: PreActivityReportErrorDto[] | undefined;
}

export class SynchronizePreActivityReportOutput implements ISynchronizePreActivityReportOutput {
    preActivityReportId!: number;
    vehicleExternalId!: number;
    preReportIsValidToEntry!: boolean;

    constructor(data?: ISynchronizePreActivityReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preActivityReportId = _data["preActivityReportId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.preReportIsValidToEntry = _data["preReportIsValidToEntry"];
        }
    }

    static fromJS(data: any): SynchronizePreActivityReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizePreActivityReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preActivityReportId"] = this.preActivityReportId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["preReportIsValidToEntry"] = this.preReportIsValidToEntry;
        return data;
    }
}

export interface ISynchronizePreActivityReportOutput {
    preActivityReportId: number;
    vehicleExternalId: number;
    preReportIsValidToEntry: boolean;
}

export class SynchronizeWoodActivityReportUpdates implements ISynchronizeWoodActivityReportUpdates {
    isEditionUpdate!: boolean;
    localId!: number;
    activityReportId!: number;
    userId!: number;
    newDate!: DateTime | undefined;
    newExitDate!: DateTime | undefined;
    newState!: ActivityReportState | undefined;
    newStateCondition!: ActivityReportStateCondition | undefined;
    paysTransport!: boolean;
    newOriginExternalId!: number | undefined;
    newOriginType!: LocationType | undefined;
    newDestinationExternalId!: number | undefined;
    newDestinationType!: LocationType | undefined;
    newNumber!: number | undefined;
    newSerial!: string | undefined;
    newTransportExternalId!: number | undefined;
    newTransportPlate!: string | undefined;
    newTransportVendorExternalId!: number | undefined;
    newTransportExternalTruckTypeId!: number | undefined;
    semis!: ExternalTruckVehicleInput[] | undefined;
    newDriverExternalId!: number | undefined;
    newDriverVendorExternalId!: number | undefined;
    newTripNumber!: number | undefined;
    newComment!: string | undefined;
    lines!: SynchronizeWoodLineActivityReportUpdates[] | undefined;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    updateLog!: string | undefined;
    newScannerModel!: number | undefined;
    noSamplingReasonId!: number | undefined;
    noSamplingReasonComment!: string | undefined;
    scannerAbortedSpeedResultReason!: WoodActivityReportAbortedScannerReasonDto | undefined;
    isUpdatedArticleLengthOrSpecies!: boolean;
    shouldDeleteScannerMeasurementData!: boolean;

    constructor(data?: ISynchronizeWoodActivityReportUpdates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEditionUpdate = _data["isEditionUpdate"];
            this.localId = _data["localId"];
            this.activityReportId = _data["activityReportId"];
            this.userId = _data["userId"];
            this.newDate = _data["newDate"] ? DateTime.fromISO(_data["newDate"].toString()) : <any>undefined;
            this.newExitDate = _data["newExitDate"] ? DateTime.fromISO(_data["newExitDate"].toString()) : <any>undefined;
            this.newState = _data["newState"];
            this.newStateCondition = _data["newStateCondition"];
            this.paysTransport = _data["paysTransport"];
            this.newOriginExternalId = _data["newOriginExternalId"];
            this.newOriginType = _data["newOriginType"];
            this.newDestinationExternalId = _data["newDestinationExternalId"];
            this.newDestinationType = _data["newDestinationType"];
            this.newNumber = _data["newNumber"];
            this.newSerial = _data["newSerial"];
            this.newTransportExternalId = _data["newTransportExternalId"];
            this.newTransportPlate = _data["newTransportPlate"];
            this.newTransportVendorExternalId = _data["newTransportVendorExternalId"];
            this.newTransportExternalTruckTypeId = _data["newTransportExternalTruckTypeId"];
            if (Array.isArray(_data["semis"])) {
                this.semis = [] as any;
                for (let item of _data["semis"])
                    this.semis!.push(ExternalTruckVehicleInput.fromJS(item));
            }
            this.newDriverExternalId = _data["newDriverExternalId"];
            this.newDriverVendorExternalId = _data["newDriverVendorExternalId"];
            this.newTripNumber = _data["newTripNumber"];
            this.newComment = _data["newComment"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SynchronizeWoodLineActivityReportUpdates.fromJS(item));
            }
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.updateLog = _data["updateLog"];
            this.newScannerModel = _data["newScannerModel"];
            this.noSamplingReasonId = _data["noSamplingReasonId"];
            this.noSamplingReasonComment = _data["noSamplingReasonComment"];
            this.scannerAbortedSpeedResultReason = _data["scannerAbortedSpeedResultReason"] ? WoodActivityReportAbortedScannerReasonDto.fromJS(_data["scannerAbortedSpeedResultReason"]) : <any>undefined;
            this.isUpdatedArticleLengthOrSpecies = _data["isUpdatedArticleLengthOrSpecies"];
            this.shouldDeleteScannerMeasurementData = _data["shouldDeleteScannerMeasurementData"];
        }
    }

    static fromJS(data: any): SynchronizeWoodActivityReportUpdates {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeWoodActivityReportUpdates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEditionUpdate"] = this.isEditionUpdate;
        data["localId"] = this.localId;
        data["activityReportId"] = this.activityReportId;
        data["userId"] = this.userId;
        data["newDate"] = this.newDate ? this.newDate.toString() : <any>undefined;
        data["newExitDate"] = this.newExitDate ? this.newExitDate.toString() : <any>undefined;
        data["newState"] = this.newState;
        data["newStateCondition"] = this.newStateCondition;
        data["paysTransport"] = this.paysTransport;
        data["newOriginExternalId"] = this.newOriginExternalId;
        data["newOriginType"] = this.newOriginType;
        data["newDestinationExternalId"] = this.newDestinationExternalId;
        data["newDestinationType"] = this.newDestinationType;
        data["newNumber"] = this.newNumber;
        data["newSerial"] = this.newSerial;
        data["newTransportExternalId"] = this.newTransportExternalId;
        data["newTransportPlate"] = this.newTransportPlate;
        data["newTransportVendorExternalId"] = this.newTransportVendorExternalId;
        data["newTransportExternalTruckTypeId"] = this.newTransportExternalTruckTypeId;
        if (Array.isArray(this.semis)) {
            data["semis"] = [];
            for (let item of this.semis)
                data["semis"].push(item.toJSON());
        }
        data["newDriverExternalId"] = this.newDriverExternalId;
        data["newDriverVendorExternalId"] = this.newDriverVendorExternalId;
        data["newTripNumber"] = this.newTripNumber;
        data["newComment"] = this.newComment;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["updateLog"] = this.updateLog;
        data["newScannerModel"] = this.newScannerModel;
        data["noSamplingReasonId"] = this.noSamplingReasonId;
        data["noSamplingReasonComment"] = this.noSamplingReasonComment;
        data["scannerAbortedSpeedResultReason"] = this.scannerAbortedSpeedResultReason ? this.scannerAbortedSpeedResultReason.toJSON() : <any>undefined;
        data["isUpdatedArticleLengthOrSpecies"] = this.isUpdatedArticleLengthOrSpecies;
        data["shouldDeleteScannerMeasurementData"] = this.shouldDeleteScannerMeasurementData;
        return data;
    }
}

export interface ISynchronizeWoodActivityReportUpdates {
    isEditionUpdate: boolean;
    localId: number;
    activityReportId: number;
    userId: number;
    newDate: DateTime | undefined;
    newExitDate: DateTime | undefined;
    newState: ActivityReportState | undefined;
    newStateCondition: ActivityReportStateCondition | undefined;
    paysTransport: boolean;
    newOriginExternalId: number | undefined;
    newOriginType: LocationType | undefined;
    newDestinationExternalId: number | undefined;
    newDestinationType: LocationType | undefined;
    newNumber: number | undefined;
    newSerial: string | undefined;
    newTransportExternalId: number | undefined;
    newTransportPlate: string | undefined;
    newTransportVendorExternalId: number | undefined;
    newTransportExternalTruckTypeId: number | undefined;
    semis: ExternalTruckVehicleInput[] | undefined;
    newDriverExternalId: number | undefined;
    newDriverVendorExternalId: number | undefined;
    newTripNumber: number | undefined;
    newComment: string | undefined;
    lines: SynchronizeWoodLineActivityReportUpdates[] | undefined;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    updateLog: string | undefined;
    newScannerModel: number | undefined;
    noSamplingReasonId: number | undefined;
    noSamplingReasonComment: string | undefined;
    scannerAbortedSpeedResultReason: WoodActivityReportAbortedScannerReasonDto | undefined;
    isUpdatedArticleLengthOrSpecies: boolean;
    shouldDeleteScannerMeasurementData: boolean;
}

export class SynchronizeWoodLineActivityReportUpdates implements ISynchronizeWoodLineActivityReportUpdates {
    newStandId!: number;
    newArticleId!: number;
    newContractExternalId!: number;
    newContractTypeExternalId!: number;
    newContractVendorExternalId!: number;
    newPefc!: boolean;
    loaderVendorId!: number;
    unLoadVendorId!: number;
    cutVendorId!: number;
    extractionVendorId!: number;
    newOriginExternalId!: number | undefined;
    newOriginType!: LocationType | undefined;
    newPileId!: number | undefined;

    constructor(data?: ISynchronizeWoodLineActivityReportUpdates) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newStandId = _data["newStandId"];
            this.newArticleId = _data["newArticleId"];
            this.newContractExternalId = _data["newContractExternalId"];
            this.newContractTypeExternalId = _data["newContractTypeExternalId"];
            this.newContractVendorExternalId = _data["newContractVendorExternalId"];
            this.newPefc = _data["newPefc"];
            this.loaderVendorId = _data["loaderVendorId"];
            this.unLoadVendorId = _data["unLoadVendorId"];
            this.cutVendorId = _data["cutVendorId"];
            this.extractionVendorId = _data["extractionVendorId"];
            this.newOriginExternalId = _data["newOriginExternalId"];
            this.newOriginType = _data["newOriginType"];
            this.newPileId = _data["newPileId"];
        }
    }

    static fromJS(data: any): SynchronizeWoodLineActivityReportUpdates {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeWoodLineActivityReportUpdates();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newStandId"] = this.newStandId;
        data["newArticleId"] = this.newArticleId;
        data["newContractExternalId"] = this.newContractExternalId;
        data["newContractTypeExternalId"] = this.newContractTypeExternalId;
        data["newContractVendorExternalId"] = this.newContractVendorExternalId;
        data["newPefc"] = this.newPefc;
        data["loaderVendorId"] = this.loaderVendorId;
        data["unLoadVendorId"] = this.unLoadVendorId;
        data["cutVendorId"] = this.cutVendorId;
        data["extractionVendorId"] = this.extractionVendorId;
        data["newOriginExternalId"] = this.newOriginExternalId;
        data["newOriginType"] = this.newOriginType;
        data["newPileId"] = this.newPileId;
        return data;
    }
}

export interface ISynchronizeWoodLineActivityReportUpdates {
    newStandId: number;
    newArticleId: number;
    newContractExternalId: number;
    newContractTypeExternalId: number;
    newContractVendorExternalId: number;
    newPefc: boolean;
    loaderVendorId: number;
    unLoadVendorId: number;
    cutVendorId: number;
    extractionVendorId: number;
    newOriginExternalId: number | undefined;
    newOriginType: LocationType | undefined;
    newPileId: number | undefined;
}

export class SynchronizeWoodPreActivityReportInput implements ISynchronizeWoodPreActivityReportInput {
    updateTripNumber!: boolean;
    tripNumber!: number | undefined;
    updateScheduledTurnByETA!: boolean;
    newETA!: DateTime | undefined;
    turnExpired!: boolean;
    errorsChanged!: boolean;
    contractChanged!: boolean;
    servicesChanged!: boolean;
    newLinesContracts!: ExternalContractInput[] | undefined;
    newLinesServices!: ExternalServiceInput[][] | undefined;
    travelSystemHasError!: boolean | undefined;
    activityReportId!: number;
    errors!: PreActivityReportErrorDto[] | undefined;

    constructor(data?: ISynchronizeWoodPreActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updateTripNumber = _data["updateTripNumber"];
            this.tripNumber = _data["tripNumber"];
            this.updateScheduledTurnByETA = _data["updateScheduledTurnByETA"];
            this.newETA = _data["newETA"] ? DateTime.fromISO(_data["newETA"].toString()) : <any>undefined;
            this.turnExpired = _data["turnExpired"];
            this.errorsChanged = _data["errorsChanged"];
            this.contractChanged = _data["contractChanged"];
            this.servicesChanged = _data["servicesChanged"];
            if (Array.isArray(_data["newLinesContracts"])) {
                this.newLinesContracts = [] as any;
                for (let item of _data["newLinesContracts"])
                    this.newLinesContracts!.push(ExternalContractInput.fromJS(item));
            }
            if (Array.isArray(_data["newLinesServices"])) {
                this.newLinesServices = [] as any;
                for (let item of _data["newLinesServices"])
                    this.newLinesServices!.push(item);
            }
            this.travelSystemHasError = _data["travelSystemHasError"];
            this.activityReportId = _data["activityReportId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SynchronizeWoodPreActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new SynchronizeWoodPreActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updateTripNumber"] = this.updateTripNumber;
        data["tripNumber"] = this.tripNumber;
        data["updateScheduledTurnByETA"] = this.updateScheduledTurnByETA;
        data["newETA"] = this.newETA ? this.newETA.toString() : <any>undefined;
        data["turnExpired"] = this.turnExpired;
        data["errorsChanged"] = this.errorsChanged;
        data["contractChanged"] = this.contractChanged;
        data["servicesChanged"] = this.servicesChanged;
        if (Array.isArray(this.newLinesContracts)) {
            data["newLinesContracts"] = [];
            for (let item of this.newLinesContracts)
                data["newLinesContracts"].push(item.toJSON());
        }
        if (Array.isArray(this.newLinesServices)) {
            data["newLinesServices"] = [];
            for (let item of this.newLinesServices)
                data["newLinesServices"].push(item);
        }
        data["travelSystemHasError"] = this.travelSystemHasError;
        data["activityReportId"] = this.activityReportId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISynchronizeWoodPreActivityReportInput {
    updateTripNumber: boolean;
    tripNumber: number | undefined;
    updateScheduledTurnByETA: boolean;
    newETA: DateTime | undefined;
    turnExpired: boolean;
    errorsChanged: boolean;
    contractChanged: boolean;
    servicesChanged: boolean;
    newLinesContracts: ExternalContractInput[] | undefined;
    newLinesServices: ExternalServiceInput[][] | undefined;
    travelSystemHasError: boolean | undefined;
    activityReportId: number;
    errors: PreActivityReportErrorDto[] | undefined;
}

export class SystemItemDto implements ISystemItemDto {
    id!: number;
    name!: string | undefined;
    operations!: IntegrationLogActionType[] | undefined;

    constructor(data?: ISystemItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["operations"])) {
                this.operations = [] as any;
                for (let item of _data["operations"])
                    this.operations!.push(item);
            }
        }
    }

    static fromJS(data: any): SystemItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.operations)) {
            data["operations"] = [];
            for (let item of this.operations)
                data["operations"].push(item);
        }
        return data;
    }
}

export interface ISystemItemDto {
    id: number;
    name: string | undefined;
    operations: IntegrationLogActionType[] | undefined;
}

export class TagDto implements ITagDto {
    tagNumber!: string | undefined;
    enabled!: boolean;
    truckVehicle!: VehicleInTagDto | undefined;
    id!: number;

    constructor(data?: ITagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagNumber = _data["tagNumber"];
            this.enabled = _data["enabled"];
            this.truckVehicle = _data["truckVehicle"] ? VehicleInTagDto.fromJS(_data["truckVehicle"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagNumber"] = this.tagNumber;
        data["enabled"] = this.enabled;
        data["truckVehicle"] = this.truckVehicle ? this.truckVehicle.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITagDto {
    tagNumber: string | undefined;
    enabled: boolean;
    truckVehicle: VehicleInTagDto | undefined;
    id: number;
}

export class TagInformationOutputDto implements ITagInformationOutputDto {
    tagValue!: number;
    isTruck!: boolean;
    licensePlate!: string | undefined;
    hasPreReportOrReport!: boolean;
    reportType!: ActivityReportType;
    reportId!: number;
    isPreReport!: boolean;
    truckId!: number;

    constructor(data?: ITagInformationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagValue = _data["tagValue"];
            this.isTruck = _data["isTruck"];
            this.licensePlate = _data["licensePlate"];
            this.hasPreReportOrReport = _data["hasPreReportOrReport"];
            this.reportType = _data["reportType"];
            this.reportId = _data["reportId"];
            this.isPreReport = _data["isPreReport"];
            this.truckId = _data["truckId"];
        }
    }

    static fromJS(data: any): TagInformationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TagInformationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagValue"] = this.tagValue;
        data["isTruck"] = this.isTruck;
        data["licensePlate"] = this.licensePlate;
        data["hasPreReportOrReport"] = this.hasPreReportOrReport;
        data["reportType"] = this.reportType;
        data["reportId"] = this.reportId;
        data["isPreReport"] = this.isPreReport;
        data["truckId"] = this.truckId;
        return data;
    }
}

export interface ITagInformationOutputDto {
    tagValue: number;
    isTruck: boolean;
    licensePlate: string | undefined;
    hasPreReportOrReport: boolean;
    reportType: ActivityReportType;
    reportId: number;
    isPreReport: boolean;
    truckId: number;
}

export enum TenantAvailabilityState {
    Available = "Available",
    InActive = "InActive",
    NotFound = "NotFound",
}

export class TenantBillingSettingsEditDto implements ITenantBillingSettingsEditDto {
    legalName!: string | undefined;
    address!: string | undefined;
    taxVatNo!: string | undefined;

    constructor(data?: ITenantBillingSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.legalName = _data["legalName"];
            this.address = _data["address"];
            this.taxVatNo = _data["taxVatNo"];
        }
    }

    static fromJS(data: any): TenantBillingSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    }
}

export interface ITenantBillingSettingsEditDto {
    legalName: string | undefined;
    address: string | undefined;
    taxVatNo: string | undefined;
}

export class TenantEditDto implements ITenantEditDto {
    tenancyName!: string;
    name!: string;
    connectionString!: string | undefined;
    editionId!: number | undefined;
    isActive!: boolean;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.connectionString = _data["connectionString"];
            this.editionId = _data["editionId"];
            this.isActive = _data["isActive"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantEditDto {
    tenancyName: string;
    name: string;
    connectionString: string | undefined;
    editionId: number | undefined;
    isActive: boolean;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantEdition implements ITenantEdition {
    label!: string | undefined;
    value!: number;

    constructor(data?: ITenantEdition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TenantEdition {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEdition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface ITenantEdition {
    label: string | undefined;
    value: number;
}

export class TenantEmailSettingsEditDto implements ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings!: boolean;
    defaultFromAddress!: string | undefined;
    defaultFromDisplayName!: string | undefined;
    smtpHost!: string | undefined;
    smtpPort!: number;
    smtpUserName!: string | undefined;
    smtpPassword!: string | undefined;
    smtpDomain!: string | undefined;
    smtpEnableSsl!: boolean;
    smtpUseDefaultCredentials!: boolean;

    constructor(data?: ITenantEmailSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.useHostDefaultEmailSettings = _data["useHostDefaultEmailSettings"];
            this.defaultFromAddress = _data["defaultFromAddress"];
            this.defaultFromDisplayName = _data["defaultFromDisplayName"];
            this.smtpHost = _data["smtpHost"];
            this.smtpPort = _data["smtpPort"];
            this.smtpUserName = _data["smtpUserName"];
            this.smtpPassword = _data["smtpPassword"];
            this.smtpDomain = _data["smtpDomain"];
            this.smtpEnableSsl = _data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = _data["smtpUseDefaultCredentials"];
        }
    }

    static fromJS(data: any): TenantEmailSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantEmailSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["useHostDefaultEmailSettings"] = this.useHostDefaultEmailSettings;
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    }
}

export interface ITenantEmailSettingsEditDto {
    useHostDefaultEmailSettings: boolean;
    defaultFromAddress: string | undefined;
    defaultFromDisplayName: string | undefined;
    smtpHost: string | undefined;
    smtpPort: number;
    smtpUserName: string | undefined;
    smtpPassword: string | undefined;
    smtpDomain: string | undefined;
    smtpEnableSsl: boolean;
    smtpUseDefaultCredentials: boolean;
}

export class TenantListDto implements ITenantListDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    editionDisplayName!: string | undefined;
    connectionString!: string | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    subscriptionEndDateUtc!: DateTime | undefined;
    editionId!: number | undefined;
    isInTrialPeriod!: boolean;
    id!: number;

    constructor(data?: ITenantListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.editionDisplayName = _data["editionDisplayName"];
            this.connectionString = _data["connectionString"];
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.editionId = _data["editionId"];
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantListDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantListDto {
    tenancyName: string | undefined;
    name: string | undefined;
    editionDisplayName: string | undefined;
    connectionString: string | undefined;
    isActive: boolean;
    creationTime: DateTime;
    subscriptionEndDateUtc: DateTime | undefined;
    editionId: number | undefined;
    isInTrialPeriod: boolean;
    id: number;
}

export class TenantLoginInfoDto implements ITenantLoginInfoDto {
    tenancyName!: string | undefined;
    name!: string | undefined;
    logoId!: string | undefined;
    logoFileType!: string | undefined;
    customCssId!: string | undefined;
    subscriptionEndDateUtc!: DateTime | undefined;
    isInTrialPeriod!: boolean;
    subscriptionPaymentType!: SubscriptionPaymentType;
    edition!: EditionInfoDto | undefined;
    creationTime!: DateTime;
    paymentPeriodType!: PaymentPeriodType;
    subscriptionDateString!: string | undefined;
    creationTimeString!: string | undefined;
    id!: number;

    constructor(data?: ITenantLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.name = _data["name"];
            this.logoId = _data["logoId"];
            this.logoFileType = _data["logoFileType"];
            this.customCssId = _data["customCssId"];
            this.subscriptionEndDateUtc = _data["subscriptionEndDateUtc"] ? DateTime.fromISO(_data["subscriptionEndDateUtc"].toString()) : <any>undefined;
            this.isInTrialPeriod = _data["isInTrialPeriod"];
            this.subscriptionPaymentType = _data["subscriptionPaymentType"];
            this.edition = _data["edition"] ? EditionInfoDto.fromJS(_data["edition"]) : <any>undefined;
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.paymentPeriodType = _data["paymentPeriodType"];
            this.subscriptionDateString = _data["subscriptionDateString"];
            this.creationTimeString = _data["creationTimeString"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toString() : <any>undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantLoginInfoDto {
    tenancyName: string | undefined;
    name: string | undefined;
    logoId: string | undefined;
    logoFileType: string | undefined;
    customCssId: string | undefined;
    subscriptionEndDateUtc: DateTime | undefined;
    isInTrialPeriod: boolean;
    subscriptionPaymentType: SubscriptionPaymentType;
    edition: EditionInfoDto | undefined;
    creationTime: DateTime;
    paymentPeriodType: PaymentPeriodType;
    subscriptionDateString: string | undefined;
    creationTimeString: string | undefined;
    id: number;
}

export class TenantManagementSettingsEditDto implements ITenantManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredTenantActiveByDefault!: boolean;
    useCaptchaOnRegistration!: boolean;
    defaultEditionId!: number | undefined;

    constructor(data?: ITenantManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = _data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.defaultEditionId = _data["defaultEditionId"];
        }
    }

    static fromJS(data: any): TenantManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    }
}

export interface ITenantManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredTenantActiveByDefault: boolean;
    useCaptchaOnRegistration: boolean;
    defaultEditionId: number | undefined;
}

export class TenantNotification implements ITenantNotification {
    tenantId!: number | undefined;
    notificationName!: string | undefined;
    data!: NotificationData | undefined;
    entityType!: string | undefined;
    entityTypeName!: string | undefined;
    entityId!: any | undefined;
    severity!: NotificationSeverity;
    creationTime!: DateTime;
    id!: string;

    constructor(data?: ITenantNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.notificationName = _data["notificationName"];
            this.data = _data["data"] ? NotificationData.fromJS(_data["data"]) : <any>undefined;
            this.entityType = _data["entityType"];
            this.entityTypeName = _data["entityTypeName"];
            this.entityId = _data["entityId"];
            this.severity = _data["severity"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TenantNotification {
        data = typeof data === 'object' ? data : {};
        let result = new TenantNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface ITenantNotification {
    tenantId: number | undefined;
    notificationName: string | undefined;
    data: NotificationData | undefined;
    entityType: string | undefined;
    entityTypeName: string | undefined;
    entityId: any | undefined;
    severity: NotificationSeverity;
    creationTime: DateTime;
    id: string;
}

export class TenantOtherSettingsEditDto implements ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled!: boolean;

    constructor(data?: ITenantOtherSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
        }
    }

    static fromJS(data: any): TenantOtherSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantOtherSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        return data;
    }
}

export interface ITenantOtherSettingsEditDto {
    isQuickThemeSelectEnabled: boolean;
}

export class TenantSettingsEditDto implements ITenantSettingsEditDto {
    general!: GeneralSettingsEditDto | undefined;
    userManagement!: TenantUserManagementSettingsEditDto;
    email!: TenantEmailSettingsEditDto | undefined;
    ldap!: LdapSettingsEditDto | undefined;
    security!: SecuritySettingsEditDto;
    billing!: TenantBillingSettingsEditDto | undefined;
    otherSettings!: TenantOtherSettingsEditDto | undefined;
    externalLoginProviderSettings!: ExternalLoginProviderSettingsEditDto | undefined;

    constructor(data?: ITenantSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.general = _data["general"] ? GeneralSettingsEditDto.fromJS(_data["general"]) : <any>undefined;
            this.userManagement = _data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(_data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = _data["email"] ? TenantEmailSettingsEditDto.fromJS(_data["email"]) : <any>undefined;
            this.ldap = _data["ldap"] ? LdapSettingsEditDto.fromJS(_data["ldap"]) : <any>undefined;
            this.security = _data["security"] ? SecuritySettingsEditDto.fromJS(_data["security"]) : new SecuritySettingsEditDto();
            this.billing = _data["billing"] ? TenantBillingSettingsEditDto.fromJS(_data["billing"]) : <any>undefined;
            this.otherSettings = _data["otherSettings"] ? TenantOtherSettingsEditDto.fromJS(_data["otherSettings"]) : <any>undefined;
            this.externalLoginProviderSettings = _data["externalLoginProviderSettings"] ? ExternalLoginProviderSettingsEditDto.fromJS(_data["externalLoginProviderSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : <any>undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : <any>undefined;
        data["email"] = this.email ? this.email.toJSON() : <any>undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : <any>undefined;
        data["security"] = this.security ? this.security.toJSON() : <any>undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : <any>undefined;
        data["otherSettings"] = this.otherSettings ? this.otherSettings.toJSON() : <any>undefined;
        data["externalLoginProviderSettings"] = this.externalLoginProviderSettings ? this.externalLoginProviderSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantSettingsEditDto {
    general: GeneralSettingsEditDto | undefined;
    userManagement: TenantUserManagementSettingsEditDto;
    email: TenantEmailSettingsEditDto | undefined;
    ldap: LdapSettingsEditDto | undefined;
    security: SecuritySettingsEditDto;
    billing: TenantBillingSettingsEditDto | undefined;
    otherSettings: TenantOtherSettingsEditDto | undefined;
    externalLoginProviderSettings: ExternalLoginProviderSettingsEditDto | undefined;
}

export class TenantUserManagementSettingsEditDto implements ITenantUserManagementSettingsEditDto {
    allowSelfRegistration!: boolean;
    isNewRegisteredUserActiveByDefault!: boolean;
    isEmailConfirmationRequiredForLogin!: boolean;
    useCaptchaOnRegistration!: boolean;
    useCaptchaOnLogin!: boolean;
    isCookieConsentEnabled!: boolean;
    isQuickThemeSelectEnabled!: boolean;
    allowUsingGravatarProfilePicture!: boolean;
    sessionTimeOutSettings!: SessionTimeOutSettingsEditDto | undefined;

    constructor(data?: ITenantUserManagementSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allowSelfRegistration = _data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = _data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = _data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = _data["useCaptchaOnRegistration"];
            this.useCaptchaOnLogin = _data["useCaptchaOnLogin"];
            this.isCookieConsentEnabled = _data["isCookieConsentEnabled"];
            this.isQuickThemeSelectEnabled = _data["isQuickThemeSelectEnabled"];
            this.allowUsingGravatarProfilePicture = _data["allowUsingGravatarProfilePicture"];
            this.sessionTimeOutSettings = _data["sessionTimeOutSettings"] ? SessionTimeOutSettingsEditDto.fromJS(_data["sessionTimeOutSettings"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TenantUserManagementSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["useCaptchaOnLogin"] = this.useCaptchaOnLogin;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        data["isQuickThemeSelectEnabled"] = this.isQuickThemeSelectEnabled;
        data["allowUsingGravatarProfilePicture"] = this.allowUsingGravatarProfilePicture;
        data["sessionTimeOutSettings"] = this.sessionTimeOutSettings ? this.sessionTimeOutSettings.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITenantUserManagementSettingsEditDto {
    allowSelfRegistration: boolean;
    isNewRegisteredUserActiveByDefault: boolean;
    isEmailConfirmationRequiredForLogin: boolean;
    useCaptchaOnRegistration: boolean;
    useCaptchaOnLogin: boolean;
    isCookieConsentEnabled: boolean;
    isQuickThemeSelectEnabled: boolean;
    allowUsingGravatarProfilePicture: boolean;
    sessionTimeOutSettings: SessionTimeOutSettingsEditDto | undefined;
}

export class ThemeFooterSettingsDto implements IThemeFooterSettingsDto {
    fixedFooter!: boolean;

    constructor(data?: IThemeFooterSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedFooter = _data["fixedFooter"];
        }
    }

    static fromJS(data: any): ThemeFooterSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    }
}

export interface IThemeFooterSettingsDto {
    fixedFooter: boolean;
}

export class ThemeHeaderSettingsDto implements IThemeHeaderSettingsDto {
    desktopFixedHeader!: boolean;
    mobileFixedHeader!: boolean;
    headerSkin!: string | undefined;
    minimizeDesktopHeaderType!: string | undefined;

    constructor(data?: IThemeHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.desktopFixedHeader = _data["desktopFixedHeader"];
            this.mobileFixedHeader = _data["mobileFixedHeader"];
            this.headerSkin = _data["headerSkin"];
            this.minimizeDesktopHeaderType = _data["minimizeDesktopHeaderType"];
        }
    }

    static fromJS(data: any): ThemeHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        data["minimizeDesktopHeaderType"] = this.minimizeDesktopHeaderType;
        return data;
    }
}

export interface IThemeHeaderSettingsDto {
    desktopFixedHeader: boolean;
    mobileFixedHeader: boolean;
    headerSkin: string | undefined;
    minimizeDesktopHeaderType: string | undefined;
}

export class ThemeLayoutSettingsDto implements IThemeLayoutSettingsDto {
    layoutType!: string | undefined;

    constructor(data?: IThemeLayoutSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.layoutType = _data["layoutType"];
        }
    }

    static fromJS(data: any): ThemeLayoutSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        return data;
    }
}

export interface IThemeLayoutSettingsDto {
    layoutType: string | undefined;
}

export class ThemeMenuSettingsDto implements IThemeMenuSettingsDto {
    position!: string | undefined;
    asideSkin!: string | undefined;
    fixedAside!: boolean;
    allowAsideMinimizing!: boolean;
    defaultMinimizedAside!: boolean;
    submenuToggle!: string | undefined;
    searchActive!: boolean;
    enableSecondary!: boolean;

    constructor(data?: IThemeMenuSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.position = _data["position"];
            this.asideSkin = _data["asideSkin"];
            this.fixedAside = _data["fixedAside"];
            this.allowAsideMinimizing = _data["allowAsideMinimizing"];
            this.defaultMinimizedAside = _data["defaultMinimizedAside"];
            this.submenuToggle = _data["submenuToggle"];
            this.searchActive = _data["searchActive"];
            this.enableSecondary = _data["enableSecondary"];
        }
    }

    static fromJS(data: any): ThemeMenuSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["submenuToggle"] = this.submenuToggle;
        data["searchActive"] = this.searchActive;
        data["enableSecondary"] = this.enableSecondary;
        return data;
    }
}

export interface IThemeMenuSettingsDto {
    position: string | undefined;
    asideSkin: string | undefined;
    fixedAside: boolean;
    allowAsideMinimizing: boolean;
    defaultMinimizedAside: boolean;
    submenuToggle: string | undefined;
    searchActive: boolean;
    enableSecondary: boolean;
}

export class ThemeSettingsDto implements IThemeSettingsDto {
    theme!: string | undefined;
    layout!: ThemeLayoutSettingsDto | undefined;
    header!: ThemeHeaderSettingsDto | undefined;
    subHeader!: ThemeSubHeaderSettingsDto | undefined;
    menu!: ThemeMenuSettingsDto | undefined;
    footer!: ThemeFooterSettingsDto | undefined;

    constructor(data?: IThemeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.theme = _data["theme"];
            this.layout = _data["layout"] ? ThemeLayoutSettingsDto.fromJS(_data["layout"]) : <any>undefined;
            this.header = _data["header"] ? ThemeHeaderSettingsDto.fromJS(_data["header"]) : <any>undefined;
            this.subHeader = _data["subHeader"] ? ThemeSubHeaderSettingsDto.fromJS(_data["subHeader"]) : <any>undefined;
            this.menu = _data["menu"] ? ThemeMenuSettingsDto.fromJS(_data["menu"]) : <any>undefined;
            this.footer = _data["footer"] ? ThemeFooterSettingsDto.fromJS(_data["footer"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ThemeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : <any>undefined;
        data["header"] = this.header ? this.header.toJSON() : <any>undefined;
        data["subHeader"] = this.subHeader ? this.subHeader.toJSON() : <any>undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : <any>undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : <any>undefined;
        return data;
    }
}

export interface IThemeSettingsDto {
    theme: string | undefined;
    layout: ThemeLayoutSettingsDto | undefined;
    header: ThemeHeaderSettingsDto | undefined;
    subHeader: ThemeSubHeaderSettingsDto | undefined;
    menu: ThemeMenuSettingsDto | undefined;
    footer: ThemeFooterSettingsDto | undefined;
}

export class ThemeSubHeaderSettingsDto implements IThemeSubHeaderSettingsDto {
    fixedSubHeader!: boolean;
    subheaderStyle!: string | undefined;
    subheaderSize!: number;
    titleStlye!: string | undefined;
    containerStyle!: string | undefined;

    constructor(data?: IThemeSubHeaderSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fixedSubHeader = _data["fixedSubHeader"];
            this.subheaderStyle = _data["subheaderStyle"];
            this.subheaderSize = _data["subheaderSize"];
            this.titleStlye = _data["titleStlye"];
            this.containerStyle = _data["containerStyle"];
        }
    }

    static fromJS(data: any): ThemeSubHeaderSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ThemeSubHeaderSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fixedSubHeader"] = this.fixedSubHeader;
        data["subheaderStyle"] = this.subheaderStyle;
        data["subheaderSize"] = this.subheaderSize;
        data["titleStlye"] = this.titleStlye;
        data["containerStyle"] = this.containerStyle;
        return data;
    }
}

export interface IThemeSubHeaderSettingsDto {
    fixedSubHeader: boolean;
    subheaderStyle: string | undefined;
    subheaderSize: number;
    titleStlye: string | undefined;
    containerStyle: string | undefined;
}

export class TopStatsData implements ITopStatsData {
    newTenantsCount!: number;
    newSubscriptionAmount!: number;
    dashboardPlaceholder1!: number;
    dashboardPlaceholder2!: number;

    constructor(data?: ITopStatsData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newTenantsCount = _data["newTenantsCount"];
            this.newSubscriptionAmount = _data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = _data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = _data["dashboardPlaceholder2"];
        }
    }

    static fromJS(data: any): TopStatsData {
        data = typeof data === 'object' ? data : {};
        let result = new TopStatsData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        return data;
    }
}

export interface ITopStatsData {
    newTenantsCount: number;
    newSubscriptionAmount: number;
    dashboardPlaceholder1: number;
    dashboardPlaceholder2: number;
}

export class TotalAverageDiameterCalculatedOutputDto implements ITotalAverageDiameterCalculatedOutputDto {
    averageDiameter!: number | undefined;

    constructor(data?: ITotalAverageDiameterCalculatedOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.averageDiameter = _data["averageDiameter"];
        }
    }

    static fromJS(data: any): TotalAverageDiameterCalculatedOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TotalAverageDiameterCalculatedOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["averageDiameter"] = this.averageDiameter;
        return data;
    }
}

export interface ITotalAverageDiameterCalculatedOutputDto {
    averageDiameter: number | undefined;
}

export class TransportVendorEmailNotificationInputDto implements ITransportVendorEmailNotificationInputDto {
    transportVendorList!: EmailBoxInfoInputDto[] | undefined;
    isFOVendor!: boolean;
    isThirdProperty!: boolean;
    deposit!: string | undefined;
    provider!: string | undefined;
    receiptNumberOrigin!: string | undefined;
    reportNumber!: number;
    date!: DateTime;
    receiptOrigen!: string | undefined;
    product!: string | undefined;
    transportVendor!: string | undefined;
    licensePlate!: string | undefined;
    driverName!: string | undefined;
    loaderVendor!: string | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;
    observations!: string | undefined;
    serial!: string | undefined;
    placeId!: number;

    constructor(data?: ITransportVendorEmailNotificationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transportVendorList"])) {
                this.transportVendorList = [] as any;
                for (let item of _data["transportVendorList"])
                    this.transportVendorList!.push(EmailBoxInfoInputDto.fromJS(item));
            }
            this.isFOVendor = _data["isFOVendor"];
            this.isThirdProperty = _data["isThirdProperty"];
            this.deposit = _data["deposit"];
            this.provider = _data["provider"];
            this.receiptNumberOrigin = _data["receiptNumberOrigin"];
            this.reportNumber = _data["reportNumber"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.receiptOrigen = _data["receiptOrigen"];
            this.product = _data["product"];
            this.transportVendor = _data["transportVendor"];
            this.licensePlate = _data["licensePlate"];
            this.driverName = _data["driverName"];
            this.loaderVendor = _data["loaderVendor"];
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
            this.observations = _data["observations"];
            this.serial = _data["serial"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): TransportVendorEmailNotificationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransportVendorEmailNotificationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transportVendorList)) {
            data["transportVendorList"] = [];
            for (let item of this.transportVendorList)
                data["transportVendorList"].push(item.toJSON());
        }
        data["isFOVendor"] = this.isFOVendor;
        data["isThirdProperty"] = this.isThirdProperty;
        data["deposit"] = this.deposit;
        data["provider"] = this.provider;
        data["receiptNumberOrigin"] = this.receiptNumberOrigin;
        data["reportNumber"] = this.reportNumber;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["receiptOrigen"] = this.receiptOrigen;
        data["product"] = this.product;
        data["transportVendor"] = this.transportVendor;
        data["licensePlate"] = this.licensePlate;
        data["driverName"] = this.driverName;
        data["loaderVendor"] = this.loaderVendor;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        data["observations"] = this.observations;
        data["serial"] = this.serial;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface ITransportVendorEmailNotificationInputDto {
    transportVendorList: EmailBoxInfoInputDto[] | undefined;
    isFOVendor: boolean;
    isThirdProperty: boolean;
    deposit: string | undefined;
    provider: string | undefined;
    receiptNumberOrigin: string | undefined;
    reportNumber: number;
    date: DateTime;
    receiptOrigen: string | undefined;
    product: string | undefined;
    transportVendor: string | undefined;
    licensePlate: string | undefined;
    driverName: string | undefined;
    loaderVendor: string | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
    observations: string | undefined;
    serial: string | undefined;
    placeId: number;
}

export class TruckReportInformationOutputDto implements ITruckReportInformationOutputDto {
    licensePlate!: string | undefined;
    reportId!: number;
    reportType!: ActivityReportType;
    existAnyReport!: boolean;
    isTruck!: boolean;

    constructor(data?: ITruckReportInformationOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensePlate = _data["licensePlate"];
            this.reportId = _data["reportId"];
            this.reportType = _data["reportType"];
            this.existAnyReport = _data["existAnyReport"];
            this.isTruck = _data["isTruck"];
        }
    }

    static fromJS(data: any): TruckReportInformationOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TruckReportInformationOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensePlate"] = this.licensePlate;
        data["reportId"] = this.reportId;
        data["reportType"] = this.reportType;
        data["existAnyReport"] = this.existAnyReport;
        data["isTruck"] = this.isTruck;
        return data;
    }
}

export interface ITruckReportInformationOutputDto {
    licensePlate: string | undefined;
    reportId: number;
    reportType: ActivityReportType;
    existAnyReport: boolean;
    isTruck: boolean;
}

export class TruckVehicleDto implements ITruckVehicleDto {
    licensePlate!: string | undefined;
    type!: TypeTruckDto | undefined;
    activeTag!: number;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    source!: DetectionSource | undefined;
    id!: number;

    constructor(data?: ITruckVehicleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensePlate = _data["licensePlate"];
            this.type = _data["type"] ? TypeTruckDto.fromJS(_data["type"]) : <any>undefined;
            this.activeTag = _data["activeTag"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.source = _data["source"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TruckVehicleDto {
        data = typeof data === 'object' ? data : {};
        let result = new TruckVehicleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensePlate"] = this.licensePlate;
        data["type"] = this.type ? this.type.toJSON() : <any>undefined;
        data["activeTag"] = this.activeTag;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["source"] = this.source;
        data["id"] = this.id;
        return data;
    }
}

export interface ITruckVehicleDto {
    licensePlate: string | undefined;
    type: TypeTruckDto | undefined;
    activeTag: number;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    source: DetectionSource | undefined;
    id: number;
}

export class TruckVehicleWithTagDto implements ITruckVehicleWithTagDto {
    licensePlate!: string | undefined;
    activeTag!: number;
    vehicleExternalId!: number;
    id!: number;

    constructor(data?: ITruckVehicleWithTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.licensePlate = _data["licensePlate"];
            this.activeTag = _data["activeTag"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TruckVehicleWithTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new TruckVehicleWithTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["licensePlate"] = this.licensePlate;
        data["activeTag"] = this.activeTag;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["id"] = this.id;
        return data;
    }
}

export interface ITruckVehicleWithTagDto {
    licensePlate: string | undefined;
    activeTag: number;
    vehicleExternalId: number;
    id: number;
}

export class TwitterExternalLoginProviderSettings implements ITwitterExternalLoginProviderSettings {
    consumerKey!: string | undefined;
    consumerSecret!: string | undefined;

    constructor(data?: ITwitterExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.consumerKey = _data["consumerKey"];
            this.consumerSecret = _data["consumerSecret"];
        }
    }

    static fromJS(data: any): TwitterExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new TwitterExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["consumerKey"] = this.consumerKey;
        data["consumerSecret"] = this.consumerSecret;
        return data;
    }
}

export interface ITwitterExternalLoginProviderSettings {
    consumerKey: string | undefined;
    consumerSecret: string | undefined;
}

export class TwoFactorLoginSettingsEditDto implements ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication!: boolean;
    isEnabled!: boolean;
    isEmailProviderEnabled!: boolean;
    isSmsProviderEnabled!: boolean;
    isRememberBrowserEnabled!: boolean;
    isGoogleAuthenticatorEnabled!: boolean;

    constructor(data?: ITwoFactorLoginSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabledForApplication = _data["isEnabledForApplication"];
            this.isEnabled = _data["isEnabled"];
            this.isEmailProviderEnabled = _data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = _data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = _data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = _data["isGoogleAuthenticatorEnabled"];
        }
    }

    static fromJS(data: any): TwoFactorLoginSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    }
}

export interface ITwoFactorLoginSettingsEditDto {
    isEnabledForApplication: boolean;
    isEnabled: boolean;
    isEmailProviderEnabled: boolean;
    isSmsProviderEnabled: boolean;
    isRememberBrowserEnabled: boolean;
    isGoogleAuthenticatorEnabled: boolean;
}

export class TypeTruckDto implements ITypeTruckDto {
    description!: string | undefined;
    id!: number;

    constructor(data?: ITypeTruckDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): TypeTruckDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeTruckDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    }
}

export interface ITypeTruckDto {
    description: string | undefined;
    id: number;
}

export class UiCustomizationSettingsDto implements IUiCustomizationSettingsDto {
    baseSettings!: ThemeSettingsDto | undefined;
    isLeftMenuUsed!: boolean;
    isTopMenuUsed!: boolean;
    isTabMenuUsed!: boolean;
    allowMenuScroll!: boolean;

    constructor(data?: IUiCustomizationSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseSettings = _data["baseSettings"] ? ThemeSettingsDto.fromJS(_data["baseSettings"]) : <any>undefined;
            this.isLeftMenuUsed = _data["isLeftMenuUsed"];
            this.isTopMenuUsed = _data["isTopMenuUsed"];
            this.isTabMenuUsed = _data["isTabMenuUsed"];
            this.allowMenuScroll = _data["allowMenuScroll"];
        }
    }

    static fromJS(data: any): UiCustomizationSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : <any>undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    }
}

export interface IUiCustomizationSettingsDto {
    baseSettings: ThemeSettingsDto | undefined;
    isLeftMenuUsed: boolean;
    isTopMenuUsed: boolean;
    isTabMenuUsed: boolean;
    allowMenuScroll: boolean;
}

export class UnblockUserInput implements IUnblockUserInput {
    userId!: number;
    tenantId!: number | undefined;

    constructor(data?: IUnblockUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.tenantId = _data["tenantId"];
        }
    }

    static fromJS(data: any): UnblockUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnblockUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    }
}

export interface IUnblockUserInput {
    userId: number;
    tenantId: number | undefined;
}

export class UnlinkUserInput implements IUnlinkUserInput {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUnlinkUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UnlinkUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new UnlinkUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUnlinkUserInput {
    tenantId: number | undefined;
    userId: number;
}

export class UpdateBrokerInputDto implements IUpdateBrokerInputDto {
    id!: number;
    name!: string;
    url!: string;
    username!: string;
    password!: string | undefined;
    email!: string;
    externalId!: number;

    constructor(data?: IUpdateBrokerInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.email = _data["email"];
            this.externalId = _data["externalId"];
        }
    }

    static fromJS(data: any): UpdateBrokerInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateBrokerInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["username"] = this.username;
        data["password"] = this.password;
        data["email"] = this.email;
        data["externalId"] = this.externalId;
        return data;
    }
}

export interface IUpdateBrokerInputDto {
    id: number;
    name: string;
    url: string;
    username: string;
    password: string | undefined;
    email: string;
    externalId: number;
}

export class UpdateChipHumidityDto implements IUpdateChipHumidityDto {
    chipHumidity!: number;
    manualChipSampleAssignmentComment!: string | undefined;
    deletionComment!: string | undefined;

    constructor(data?: IUpdateChipHumidityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chipHumidity = _data["chipHumidity"];
            this.manualChipSampleAssignmentComment = _data["manualChipSampleAssignmentComment"];
            this.deletionComment = _data["deletionComment"];
        }
    }

    static fromJS(data: any): UpdateChipHumidityDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateChipHumidityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chipHumidity"] = this.chipHumidity;
        data["manualChipSampleAssignmentComment"] = this.manualChipSampleAssignmentComment;
        data["deletionComment"] = this.deletionComment;
        return data;
    }
}

export interface IUpdateChipHumidityDto {
    chipHumidity: number;
    manualChipSampleAssignmentComment: string | undefined;
    deletionComment: string | undefined;
}

export class UpdateDiverseProductActivityReportInput implements IUpdateDiverseProductActivityReportInput {
    id!: number;
    origin!: ExternalLocationInputDto | undefined;
    destination!: ExternalLocationInputDto | undefined;
    date!: DateTime;
    vehicleVendorExternalId!: number;
    vehicleExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleTruckTypeExternalId!: number;
    lines!: DiverseProductActivityReportLineInputDto[] | undefined;
    netWeight!: number;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    singleCustomDeclaration!: ExternalSingleCustomDeclarationInput | undefined;
    period!: PeriodInputDto | undefined;
    state!: ActivityReportState;
    paysTransport!: boolean;
    comment!: string | undefined;

    constructor(data?: IUpdateDiverseProductActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? ExternalLocationInputDto.fromJS(_data["destination"]) : <any>undefined;
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(DiverseProductActivityReportLineInputDto.fromJS(item));
            }
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.singleCustomDeclaration = _data["singleCustomDeclaration"] ? ExternalSingleCustomDeclarationInput.fromJS(_data["singleCustomDeclaration"]) : <any>undefined;
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : <any>undefined;
            this.state = _data["state"];
            this.paysTransport = _data["paysTransport"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateDiverseProductActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDiverseProductActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["singleCustomDeclaration"] = this.singleCustomDeclaration ? this.singleCustomDeclaration.toJSON() : <any>undefined;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["state"] = this.state;
        data["paysTransport"] = this.paysTransport;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateDiverseProductActivityReportInput {
    id: number;
    origin: ExternalLocationInputDto | undefined;
    destination: ExternalLocationInputDto | undefined;
    date: DateTime;
    vehicleVendorExternalId: number;
    vehicleExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    vehicleLicensePlate: string | undefined;
    vehicleTruckTypeExternalId: number;
    lines: DiverseProductActivityReportLineInputDto[] | undefined;
    netWeight: number;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    singleCustomDeclaration: ExternalSingleCustomDeclarationInput | undefined;
    period: PeriodInputDto | undefined;
    state: ActivityReportState;
    paysTransport: boolean;
    comment: string | undefined;
}

export class UpdateEditionDto implements IUpdateEditionDto {
    edition!: EditionEditDto;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.edition = _data["edition"] ? EditionEditDto.fromJS(_data["edition"]) : new EditionEditDto();
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : <any>undefined;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateEditionDto {
    edition: EditionEditDto;
    featureValues: NameValueDto[];
}

export class UpdateExitDateInput implements IUpdateExitDateInput {
    exitDate!: DateTime;

    constructor(data?: IUpdateExitDateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateExitDateInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExitDateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        return data;
    }
}

export interface IUpdateExitDateInput {
    exitDate: DateTime;
}

export class UpdateExternalProcessingResultInputDto implements IUpdateExternalProcessingResultInputDto {
    activityReportId!: number;
    resultDetail!: string | undefined;
    state!: ExternalProcessingState;

    constructor(data?: IUpdateExternalProcessingResultInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.resultDetail = _data["resultDetail"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): UpdateExternalProcessingResultInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateExternalProcessingResultInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["resultDetail"] = this.resultDetail;
        data["state"] = this.state;
        return data;
    }
}

export interface IUpdateExternalProcessingResultInputDto {
    activityReportId: number;
    resultDetail: string | undefined;
    state: ExternalProcessingState;
}

export class UpdateGoogleAuthenticatorKeyOutput implements IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl!: string | undefined;

    constructor(data?: IUpdateGoogleAuthenticatorKeyOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.qrCodeSetupImageUrl = _data["qrCodeSetupImageUrl"];
        }
    }

    static fromJS(data: any): UpdateGoogleAuthenticatorKeyOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    }
}

export interface IUpdateGoogleAuthenticatorKeyOutput {
    qrCodeSetupImageUrl: string | undefined;
}

export class UpdateGrossWeight implements IUpdateGrossWeight {
    weightValue!: number;

    constructor(data?: IUpdateGrossWeight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weightValue = _data["weightValue"];
        }
    }

    static fromJS(data: any): UpdateGrossWeight {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateGrossWeight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weightValue"] = this.weightValue;
        return data;
    }
}

export interface IUpdateGrossWeight {
    weightValue: number;
}

export class UpdateIndicatorConfigurationDto implements IUpdateIndicatorConfigurationDto {
    id!: number;
    name!: string | undefined;
    code!: string | undefined;
    maximumTreshold!: number;
    minimumThreshold!: number;
    targetValue!: number;
    parameterValue!: number;

    constructor(data?: IUpdateIndicatorConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.targetValue = _data["targetValue"];
            this.parameterValue = _data["parameterValue"];
        }
    }

    static fromJS(data: any): UpdateIndicatorConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIndicatorConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["code"] = this.code;
        data["maximumTreshold"] = this.maximumTreshold;
        data["minimumThreshold"] = this.minimumThreshold;
        data["targetValue"] = this.targetValue;
        data["parameterValue"] = this.parameterValue;
        return data;
    }
}

export interface IUpdateIndicatorConfigurationDto {
    id: number;
    name: string | undefined;
    code: string | undefined;
    maximumTreshold: number;
    minimumThreshold: number;
    targetValue: number;
    parameterValue: number;
}

export class UpdateIntegrationValuesInputDto implements IUpdateIntegrationValuesInputDto {
    placeId!: number;
    type!: PlaceExternalIntegrationsType;
    sicfeValues!: SicfeValuesDto | undefined;
    sdaValues!: SDAValuesDto | undefined;
    jaumeSereValues!: JaumeSereValueDto | undefined;
    sigeValues!: SigeValuesDto | undefined;
    alutelValues!: AlutelValuesDto | undefined;
    smartripValues!: SmartripValuesDto | undefined;
    smartLogyardValues!: SmartLogyardValuesDto | undefined;
    smartLogyardMultisiteValues!: SmartLogyardMultisiteValuesDto | undefined;
    smartInvoicingValues!: SmartInvoicingValuesDto | undefined;
    id!: number;

    constructor(data?: IUpdateIntegrationValuesInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.type = _data["type"];
            this.sicfeValues = _data["sicfeValues"] ? SicfeValuesDto.fromJS(_data["sicfeValues"]) : <any>undefined;
            this.sdaValues = _data["sdaValues"] ? SDAValuesDto.fromJS(_data["sdaValues"]) : <any>undefined;
            this.jaumeSereValues = _data["jaumeSereValues"] ? JaumeSereValueDto.fromJS(_data["jaumeSereValues"]) : <any>undefined;
            this.sigeValues = _data["sigeValues"] ? SigeValuesDto.fromJS(_data["sigeValues"]) : <any>undefined;
            this.alutelValues = _data["alutelValues"] ? AlutelValuesDto.fromJS(_data["alutelValues"]) : <any>undefined;
            this.smartripValues = _data["smartripValues"] ? SmartripValuesDto.fromJS(_data["smartripValues"]) : <any>undefined;
            this.smartLogyardValues = _data["smartLogyardValues"] ? SmartLogyardValuesDto.fromJS(_data["smartLogyardValues"]) : <any>undefined;
            this.smartLogyardMultisiteValues = _data["smartLogyardMultisiteValues"] ? SmartLogyardMultisiteValuesDto.fromJS(_data["smartLogyardMultisiteValues"]) : <any>undefined;
            this.smartInvoicingValues = _data["smartInvoicingValues"] ? SmartInvoicingValuesDto.fromJS(_data["smartInvoicingValues"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateIntegrationValuesInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateIntegrationValuesInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["type"] = this.type;
        data["sicfeValues"] = this.sicfeValues ? this.sicfeValues.toJSON() : <any>undefined;
        data["sdaValues"] = this.sdaValues ? this.sdaValues.toJSON() : <any>undefined;
        data["jaumeSereValues"] = this.jaumeSereValues ? this.jaumeSereValues.toJSON() : <any>undefined;
        data["sigeValues"] = this.sigeValues ? this.sigeValues.toJSON() : <any>undefined;
        data["alutelValues"] = this.alutelValues ? this.alutelValues.toJSON() : <any>undefined;
        data["smartripValues"] = this.smartripValues ? this.smartripValues.toJSON() : <any>undefined;
        data["smartLogyardValues"] = this.smartLogyardValues ? this.smartLogyardValues.toJSON() : <any>undefined;
        data["smartLogyardMultisiteValues"] = this.smartLogyardMultisiteValues ? this.smartLogyardMultisiteValues.toJSON() : <any>undefined;
        data["smartInvoicingValues"] = this.smartInvoicingValues ? this.smartInvoicingValues.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateIntegrationValuesInputDto {
    placeId: number;
    type: PlaceExternalIntegrationsType;
    sicfeValues: SicfeValuesDto | undefined;
    sdaValues: SDAValuesDto | undefined;
    jaumeSereValues: JaumeSereValueDto | undefined;
    sigeValues: SigeValuesDto | undefined;
    alutelValues: AlutelValuesDto | undefined;
    smartripValues: SmartripValuesDto | undefined;
    smartLogyardValues: SmartLogyardValuesDto | undefined;
    smartLogyardMultisiteValues: SmartLogyardMultisiteValuesDto | undefined;
    smartInvoicingValues: SmartInvoicingValuesDto | undefined;
    id: number;
}

export class UpdateInternalDestination implements IUpdateInternalDestination {
    internalDestinationId!: number;

    constructor(data?: IUpdateInternalDestination) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.internalDestinationId = _data["internalDestinationId"];
        }
    }

    static fromJS(data: any): UpdateInternalDestination {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInternalDestination();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["internalDestinationId"] = this.internalDestinationId;
        return data;
    }
}

export interface IUpdateInternalDestination {
    internalDestinationId: number;
}

export class UpdateInternalMovementActivityReportInput implements IUpdateInternalMovementActivityReportInput {
    activityReportId!: number;
    period!: PeriodInputDto | undefined;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationType!: LocationType;
    date!: DateTime;
    vehicle!: ExternalTruckVehicleInput | undefined;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    lines!: InternalMovementActivityReportLineInputDto[] | undefined;
    netWeight!: number;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    comment!: string | undefined;

    constructor(data?: IUpdateInternalMovementActivityReportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.period = _data["period"] ? PeriodInputDto.fromJS(_data["period"]) : <any>undefined;
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.vehicle = _data["vehicle"] ? ExternalTruckVehicleInput.fromJS(_data["vehicle"]) : <any>undefined;
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(InternalMovementActivityReportLineInputDto.fromJS(item));
            }
            this.netWeight = _data["netWeight"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateInternalMovementActivityReportInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInternalMovementActivityReportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["period"] = this.period ? this.period.toJSON() : <any>undefined;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["vehicle"] = this.vehicle ? this.vehicle.toJSON() : <any>undefined;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        data["netWeight"] = this.netWeight;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateInternalMovementActivityReportInput {
    activityReportId: number;
    period: PeriodInputDto | undefined;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationType: LocationType;
    date: DateTime;
    vehicle: ExternalTruckVehicleInput | undefined;
    driverExternalId: number;
    driverVendorExternalId: number;
    lines: InternalMovementActivityReportLineInputDto[] | undefined;
    netWeight: number;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    comment: string | undefined;
}

export class UpdateInternalMovementInputDto implements IUpdateInternalMovementInputDto {
    activityReportId!: number;
    articleExternalId!: number;
    comment!: string | undefined;

    constructor(data?: IUpdateInternalMovementInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportId = _data["activityReportId"];
            this.articleExternalId = _data["articleExternalId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): UpdateInternalMovementInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateInternalMovementInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportId"] = this.activityReportId;
        data["articleExternalId"] = this.articleExternalId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IUpdateInternalMovementInputDto {
    activityReportId: number;
    articleExternalId: number;
    comment: string | undefined;
}

export class UpdateLanguageTextInput implements IUpdateLanguageTextInput {
    languageName!: string;
    sourceName!: string;
    key!: string;
    value!: string;

    constructor(data?: IUpdateLanguageTextInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.languageName = _data["languageName"];
            this.sourceName = _data["sourceName"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdateLanguageTextInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdateLanguageTextInput {
    languageName: string;
    sourceName: string;
    key: string;
    value: string;
}

export class UpdateNotificationSettingsInput implements IUpdateNotificationSettingsInput {
    receiveNotifications!: boolean;
    notifications!: NotificationSubscriptionDto[] | undefined;

    constructor(data?: IUpdateNotificationSettingsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.receiveNotifications = _data["receiveNotifications"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [] as any;
                for (let item of _data["notifications"])
                    this.notifications!.push(NotificationSubscriptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateNotificationSettingsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateNotificationSettingsInput {
    receiveNotifications: boolean;
    notifications: NotificationSubscriptionDto[] | undefined;
}

export class UpdateOrganizationUnitInput implements IUpdateOrganizationUnitInput {
    id!: number;
    displayName!: string;

    constructor(data?: IUpdateOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.displayName = _data["displayName"];
        }
    }

    static fromJS(data: any): UpdateOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    }
}

export interface IUpdateOrganizationUnitInput {
    id: number;
    displayName: string;
}

export class UpdatePaysTransportInput implements IUpdatePaysTransportInput {
    value!: boolean;

    constructor(data?: IUpdatePaysTransportInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UpdatePaysTransportInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePaysTransportInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    }
}

export interface IUpdatePaysTransportInput {
    value: boolean;
}

export class UpdatePeriod implements IUpdatePeriod {
    externalId!: number;
    startDatePeriod!: DateTime;
    endDatePeriod!: DateTime;

    constructor(data?: IUpdatePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.startDatePeriod = _data["startDatePeriod"] ? DateTime.fromISO(_data["startDatePeriod"].toString()) : <any>undefined;
            this.endDatePeriod = _data["endDatePeriod"] ? DateTime.fromISO(_data["endDatePeriod"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdatePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["startDatePeriod"] = this.startDatePeriod ? this.startDatePeriod.toString() : <any>undefined;
        data["endDatePeriod"] = this.endDatePeriod ? this.endDatePeriod.toString() : <any>undefined;
        return data;
    }
}

export interface IUpdatePeriod {
    externalId: number;
    startDatePeriod: DateTime;
    endDatePeriod: DateTime;
}

export class UpdatePreActivityReportDriverForProvidersInput implements IUpdatePreActivityReportDriverForProvidersInput {
    preActivityReportId!: number;
    newExternalDriverId!: number;
    externalDriverVendorId!: number;
    notifyBothDrivers!: boolean;
    newErrors!: PreActivityReportErrorDto[] | undefined;

    constructor(data?: IUpdatePreActivityReportDriverForProvidersInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.preActivityReportId = _data["preActivityReportId"];
            this.newExternalDriverId = _data["newExternalDriverId"];
            this.externalDriverVendorId = _data["externalDriverVendorId"];
            this.notifyBothDrivers = _data["notifyBothDrivers"];
            if (Array.isArray(_data["newErrors"])) {
                this.newErrors = [] as any;
                for (let item of _data["newErrors"])
                    this.newErrors!.push(PreActivityReportErrorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdatePreActivityReportDriverForProvidersInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePreActivityReportDriverForProvidersInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["preActivityReportId"] = this.preActivityReportId;
        data["newExternalDriverId"] = this.newExternalDriverId;
        data["externalDriverVendorId"] = this.externalDriverVendorId;
        data["notifyBothDrivers"] = this.notifyBothDrivers;
        if (Array.isArray(this.newErrors)) {
            data["newErrors"] = [];
            for (let item of this.newErrors)
                data["newErrors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdatePreActivityReportDriverForProvidersInput {
    preActivityReportId: number;
    newExternalDriverId: number;
    externalDriverVendorId: number;
    notifyBothDrivers: boolean;
    newErrors: PreActivityReportErrorDto[] | undefined;
}

export class UpdateProfilePictureInput implements IUpdateProfilePictureInput {
    fileToken!: string | undefined;
    x!: number;
    y!: number;
    width!: number;
    height!: number;
    useGravatarProfilePicture!: boolean;

    constructor(data?: IUpdateProfilePictureInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.x = _data["x"];
            this.y = _data["y"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.useGravatarProfilePicture = _data["useGravatarProfilePicture"];
        }
    }

    static fromJS(data: any): UpdateProfilePictureInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        data["useGravatarProfilePicture"] = this.useGravatarProfilePicture;
        return data;
    }
}

export interface IUpdateProfilePictureInput {
    fileToken: string | undefined;
    x: number;
    y: number;
    width: number;
    height: number;
    useGravatarProfilePicture: boolean;
}

export class UpdateSerialAndNumberInput implements IUpdateSerialAndNumberInput {
    serial!: string | undefined;
    number!: number | undefined;

    constructor(data?: IUpdateSerialAndNumberInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serial = _data["serial"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): UpdateSerialAndNumberInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSerialAndNumberInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serial"] = this.serial;
        data["number"] = this.number;
        return data;
    }
}

export interface IUpdateSerialAndNumberInput {
    serial: string | undefined;
    number: number | undefined;
}

export class UpdateServiceConfigurationInputDto implements IUpdateServiceConfigurationInputDto {
    id!: number;
    externalArticleId!: number;
    externalInvoiceServiceId!: number;
    originId!: number;
    externalDestinationId!: number | undefined;
    serviceType!: ServiceType;

    constructor(data?: IUpdateServiceConfigurationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.externalArticleId = _data["externalArticleId"];
            this.externalInvoiceServiceId = _data["externalInvoiceServiceId"];
            this.originId = _data["originId"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.serviceType = _data["serviceType"];
        }
    }

    static fromJS(data: any): UpdateServiceConfigurationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateServiceConfigurationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["externalArticleId"] = this.externalArticleId;
        data["externalInvoiceServiceId"] = this.externalInvoiceServiceId;
        data["originId"] = this.originId;
        data["externalDestinationId"] = this.externalDestinationId;
        data["serviceType"] = this.serviceType;
        return data;
    }
}

export interface IUpdateServiceConfigurationInputDto {
    id: number;
    externalArticleId: number;
    externalInvoiceServiceId: number;
    originId: number;
    externalDestinationId: number | undefined;
    serviceType: ServiceType;
}

export class UpdateStateDto implements IUpdateStateDto {
    state!: ActivityReportState | undefined;
    contitionState!: ActivityReportStateCondition | undefined;

    constructor(data?: IUpdateStateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.contitionState = _data["contitionState"];
        }
    }

    static fromJS(data: any): UpdateStateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["contitionState"] = this.contitionState;
        return data;
    }
}

export interface IUpdateStateDto {
    state: ActivityReportState | undefined;
    contitionState: ActivityReportStateCondition | undefined;
}

export class UpdateTagInputDto implements IUpdateTagInputDto {
    tagNumber!: string | undefined;
    enabled!: boolean;
    truckVehicle!: VehicleInTagDto | undefined;
    id!: number;

    constructor(data?: IUpdateTagInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagNumber = _data["tagNumber"];
            this.enabled = _data["enabled"];
            this.truckVehicle = _data["truckVehicle"] ? VehicleInTagDto.fromJS(_data["truckVehicle"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTagInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTagInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagNumber"] = this.tagNumber;
        data["enabled"] = this.enabled;
        data["truckVehicle"] = this.truckVehicle ? this.truckVehicle.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTagInputDto {
    tagNumber: string | undefined;
    enabled: boolean;
    truckVehicle: VehicleInTagDto | undefined;
    id: number;
}

export class UpdateTareWeight implements IUpdateTareWeight {
    weightValue!: number;

    constructor(data?: IUpdateTareWeight) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weightValue = _data["weightValue"];
        }
    }

    static fromJS(data: any): UpdateTareWeight {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTareWeight();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weightValue"] = this.weightValue;
        return data;
    }
}

export interface IUpdateTareWeight {
    weightValue: number;
}

export class UpdateTenantFeaturesInput implements IUpdateTenantFeaturesInput {
    id!: number;
    featureValues!: NameValueDto[];

    constructor(data?: IUpdateTenantFeaturesInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["featureValues"])) {
                this.featureValues = [] as any;
                for (let item of _data["featureValues"])
                    this.featureValues!.push(NameValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateTenantFeaturesInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.featureValues)) {
            data["featureValues"] = [];
            for (let item of this.featureValues)
                data["featureValues"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateTenantFeaturesInput {
    id: number;
    featureValues: NameValueDto[];
}

export class UpdateTripDriverInput implements IUpdateTripDriverInput {
    truckExternalId!: number;
    errors!: PreActivityReportErrorDto[] | undefined;
    driver!: ExternalDriverDto | undefined;
    notifyBothDrivers!: boolean;
    newUserName!: string | undefined;

    constructor(data?: IUpdateTripDriverInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckExternalId = _data["truckExternalId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.driver = _data["driver"] ? ExternalDriverDto.fromJS(_data["driver"]) : <any>undefined;
            this.notifyBothDrivers = _data["notifyBothDrivers"];
            this.newUserName = _data["newUserName"];
        }
    }

    static fromJS(data: any): UpdateTripDriverInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTripDriverInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckExternalId"] = this.truckExternalId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["driver"] = this.driver ? this.driver.toJSON() : <any>undefined;
        data["notifyBothDrivers"] = this.notifyBothDrivers;
        data["newUserName"] = this.newUserName;
        return data;
    }
}

export interface IUpdateTripDriverInput {
    truckExternalId: number;
    errors: PreActivityReportErrorDto[] | undefined;
    driver: ExternalDriverDto | undefined;
    notifyBothDrivers: boolean;
    newUserName: string | undefined;
}

export class UpdateTripDriverOutput implements IUpdateTripDriverOutput {
    reportId!: number;
    oldTripDriverToNotify!: UserDriverInformationOutput | undefined;
    newTripDriverToNotify!: UserDriverInformationOutput | undefined;
    truckLicensePlate!: string | undefined;

    constructor(data?: IUpdateTripDriverOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.oldTripDriverToNotify = _data["oldTripDriverToNotify"] ? UserDriverInformationOutput.fromJS(_data["oldTripDriverToNotify"]) : <any>undefined;
            this.newTripDriverToNotify = _data["newTripDriverToNotify"] ? UserDriverInformationOutput.fromJS(_data["newTripDriverToNotify"]) : <any>undefined;
            this.truckLicensePlate = _data["truckLicensePlate"];
        }
    }

    static fromJS(data: any): UpdateTripDriverOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTripDriverOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["oldTripDriverToNotify"] = this.oldTripDriverToNotify ? this.oldTripDriverToNotify.toJSON() : <any>undefined;
        data["newTripDriverToNotify"] = this.newTripDriverToNotify ? this.newTripDriverToNotify.toJSON() : <any>undefined;
        data["truckLicensePlate"] = this.truckLicensePlate;
        return data;
    }
}

export interface IUpdateTripDriverOutput {
    reportId: number;
    oldTripDriverToNotify: UserDriverInformationOutput | undefined;
    newTripDriverToNotify: UserDriverInformationOutput | undefined;
    truckLicensePlate: string | undefined;
}

export class UpdateTripInformationInputDto implements IUpdateTripInformationInputDto {
    stateCondition!: ActivityReportStateCondition | undefined;
    reason!: ActivityReportSystemReasons | undefined;
    cycle!: number;
    tripNumber!: number;
    loadDateTime!: DateTime;
    originCode!: number;
    destinationCode!: number;
    id!: number;

    constructor(data?: IUpdateTripInformationInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stateCondition = _data["stateCondition"];
            this.reason = _data["reason"];
            this.cycle = _data["cycle"];
            this.tripNumber = _data["tripNumber"];
            this.loadDateTime = _data["loadDateTime"] ? DateTime.fromISO(_data["loadDateTime"].toString()) : <any>undefined;
            this.originCode = _data["originCode"];
            this.destinationCode = _data["destinationCode"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UpdateTripInformationInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTripInformationInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stateCondition"] = this.stateCondition;
        data["reason"] = this.reason;
        data["cycle"] = this.cycle;
        data["tripNumber"] = this.tripNumber;
        data["loadDateTime"] = this.loadDateTime ? this.loadDateTime.toString() : <any>undefined;
        data["originCode"] = this.originCode;
        data["destinationCode"] = this.destinationCode;
        data["id"] = this.id;
        return data;
    }
}

export interface IUpdateTripInformationInputDto {
    stateCondition: ActivityReportStateCondition | undefined;
    reason: ActivityReportSystemReasons | undefined;
    cycle: number;
    tripNumber: number;
    loadDateTime: DateTime;
    originCode: number;
    destinationCode: number;
    id: number;
}

export class UpdateUserPermissionsInput implements IUpdateUserPermissionsInput {
    id!: number;
    grantedPermissionNames!: string[];

    constructor(data?: IUpdateUserPermissionsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["grantedPermissionNames"])) {
                this.grantedPermissionNames = [] as any;
                for (let item of _data["grantedPermissionNames"])
                    this.grantedPermissionNames!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateUserPermissionsInput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.grantedPermissionNames)) {
            data["grantedPermissionNames"] = [];
            for (let item of this.grantedPermissionNames)
                data["grantedPermissionNames"].push(item);
        }
        return data;
    }
}

export interface IUpdateUserPermissionsInput {
    id: number;
    grantedPermissionNames: string[];
}

export class UpdateUserSignInTokenOutput implements IUpdateUserSignInTokenOutput {
    signInToken!: string | undefined;
    encodedUserId!: string | undefined;
    encodedTenantId!: string | undefined;

    constructor(data?: IUpdateUserSignInTokenOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signInToken = _data["signInToken"];
            this.encodedUserId = _data["encodedUserId"];
            this.encodedTenantId = _data["encodedTenantId"];
        }
    }

    static fromJS(data: any): UpdateUserSignInTokenOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    }
}

export interface IUpdateUserSignInTokenOutput {
    signInToken: string | undefined;
    encodedUserId: string | undefined;
    encodedTenantId: string | undefined;
}

export class UpdateWoodActivityReportMeasurementType implements IUpdateWoodActivityReportMeasurementType {
    usesScannerMeasurement!: boolean;

    constructor(data?: IUpdateWoodActivityReportMeasurementType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usesScannerMeasurement = _data["usesScannerMeasurement"];
        }
    }

    static fromJS(data: any): UpdateWoodActivityReportMeasurementType {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWoodActivityReportMeasurementType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usesScannerMeasurement"] = this.usesScannerMeasurement;
        return data;
    }
}

export interface IUpdateWoodActivityReportMeasurementType {
    usesScannerMeasurement: boolean;
}

export class UpdateWoodGeoLocationDto implements IUpdateWoodGeoLocationDto {
    latitude!: number;
    longitude!: number;
    precision!: number | undefined;
    stand!: string | undefined;

    constructor(data?: IUpdateWoodGeoLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.precision = _data["precision"];
            this.stand = _data["stand"];
        }
    }

    static fromJS(data: any): UpdateWoodGeoLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateWoodGeoLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["precision"] = this.precision;
        data["stand"] = this.stand;
        return data;
    }
}

export interface IUpdateWoodGeoLocationDto {
    latitude: number;
    longitude: number;
    precision: number | undefined;
    stand: string | undefined;
}

export class UserDelegationDto implements IUserDelegationDto {
    username!: string | undefined;
    startTime!: DateTime;
    endTime!: DateTime;
    id!: number;

    constructor(data?: IUserDelegationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.startTime = _data["startTime"] ? DateTime.fromISO(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? DateTime.fromISO(_data["endTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDelegationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["startTime"] = this.startTime ? this.startTime.toString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserDelegationDto {
    username: string | undefined;
    startTime: DateTime;
    endTime: DateTime;
    id: number;
}

export class UserDriverInformationOutput implements IUserDriverInformationOutput {
    userId!: number;
    identityCard!: string | undefined;
    driverExternalId!: number;

    constructor(data?: IUserDriverInformationOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.identityCard = _data["identityCard"];
            this.driverExternalId = _data["driverExternalId"];
        }
    }

    static fromJS(data: any): UserDriverInformationOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserDriverInformationOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["identityCard"] = this.identityCard;
        data["driverExternalId"] = this.driverExternalId;
        return data;
    }
}

export interface IUserDriverInformationOutput {
    userId: number;
    identityCard: string | undefined;
    driverExternalId: number;
}

export class UserEditDto implements IUserEditDto {
    id!: number | undefined;
    name!: string;
    surname!: string;
    userName!: string;
    emailAddress!: string;
    phoneNumber!: string | undefined;
    password!: string | undefined;
    isActive!: boolean;
    shouldChangePasswordOnNextLogin!: boolean;
    isTwoFactorEnabled!: boolean;
    isLockoutEnabled!: boolean;

    constructor(data?: IUserEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.password = _data["password"];
            this.isActive = _data["isActive"];
            this.shouldChangePasswordOnNextLogin = _data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = _data["isTwoFactorEnabled"];
            this.isLockoutEnabled = _data["isLockoutEnabled"];
        }
    }

    static fromJS(data: any): UserEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    }
}

export interface IUserEditDto {
    id: number | undefined;
    name: string;
    surname: string;
    userName: string;
    emailAddress: string;
    phoneNumber: string | undefined;
    password: string | undefined;
    isActive: boolean;
    shouldChangePasswordOnNextLogin: boolean;
    isTwoFactorEnabled: boolean;
    isLockoutEnabled: boolean;
}

export class UserIdentifier implements IUserIdentifier {
    tenantId!: number | undefined;
    userId!: number;

    constructor(data?: IUserIdentifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): UserIdentifier {
        data = typeof data === 'object' ? data : {};
        let result = new UserIdentifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IUserIdentifier {
    tenantId: number | undefined;
    userId: number;
}

export class UserListDto implements IUserListDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    phoneNumber!: string | undefined;
    profilePictureId!: string | undefined;
    isEmailConfirmed!: boolean;
    roles!: UserListRoleDto[] | undefined;
    isActive!: boolean;
    creationTime!: DateTime;
    id!: number;

    constructor(data?: IUserListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.phoneNumber = _data["phoneNumber"];
            this.profilePictureId = _data["profilePictureId"];
            this.isEmailConfirmed = _data["isEmailConfirmed"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UserListRoleDto.fromJS(item));
            }
            this.isActive = _data["isActive"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserListDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    phoneNumber: string | undefined;
    profilePictureId: string | undefined;
    isEmailConfirmed: boolean;
    roles: UserListRoleDto[] | undefined;
    isActive: boolean;
    creationTime: DateTime;
    id: number;
}

export class UserListRoleDto implements IUserListRoleDto {
    roleId!: number;
    roleName!: string | undefined;

    constructor(data?: IUserListRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
        }
    }

    static fromJS(data: any): UserListRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserListRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    }
}

export interface IUserListRoleDto {
    roleId: number;
    roleName: string | undefined;
}

export class UserLockOutSettingsEditDto implements IUserLockOutSettingsEditDto {
    isEnabled!: boolean;
    maxFailedAccessAttemptsBeforeLockout!: number;
    defaultAccountLockoutSeconds!: number;

    constructor(data?: IUserLockOutSettingsEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isEnabled = _data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = _data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = _data["defaultAccountLockoutSeconds"];
        }
    }

    static fromJS(data: any): UserLockOutSettingsEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    }
}

export interface IUserLockOutSettingsEditDto {
    isEnabled: boolean;
    maxFailedAccessAttemptsBeforeLockout: number;
    defaultAccountLockoutSeconds: number;
}

export class UserLoginAttemptDto implements IUserLoginAttemptDto {
    tenancyName!: string | undefined;
    userNameOrEmail!: string | undefined;
    clientIpAddress!: string | undefined;
    clientName!: string | undefined;
    browserInfo!: string | undefined;
    result!: string | undefined;
    creationTime!: DateTime;

    constructor(data?: IUserLoginAttemptDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenancyName = _data["tenancyName"];
            this.userNameOrEmail = _data["userNameOrEmail"];
            this.clientIpAddress = _data["clientIpAddress"];
            this.clientName = _data["clientName"];
            this.browserInfo = _data["browserInfo"];
            this.result = _data["result"];
            this.creationTime = _data["creationTime"] ? DateTime.fromISO(_data["creationTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserLoginAttemptDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toString() : <any>undefined;
        return data;
    }
}

export interface IUserLoginAttemptDto {
    tenancyName: string | undefined;
    userNameOrEmail: string | undefined;
    clientIpAddress: string | undefined;
    clientName: string | undefined;
    browserInfo: string | undefined;
    result: string | undefined;
    creationTime: DateTime;
}

export class UserLoginInfoDto implements IUserLoginInfoDto {
    name!: string | undefined;
    surname!: string | undefined;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    profilePictureId!: string | undefined;
    placeId!: number;
    vendorSystemApiId!: number | undefined;
    vendorExternalId!: number | undefined;
    id!: number;

    constructor(data?: IUserLoginInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.surname = _data["surname"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.profilePictureId = _data["profilePictureId"];
            this.placeId = _data["placeId"];
            this.vendorSystemApiId = _data["vendorSystemApiId"];
            this.vendorExternalId = _data["vendorExternalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserLoginInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserLoginInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["placeId"] = this.placeId;
        data["vendorSystemApiId"] = this.vendorSystemApiId;
        data["vendorExternalId"] = this.vendorExternalId;
        data["id"] = this.id;
        return data;
    }
}

export interface IUserLoginInfoDto {
    name: string | undefined;
    surname: string | undefined;
    userName: string | undefined;
    emailAddress: string | undefined;
    profilePictureId: string | undefined;
    placeId: number;
    vendorSystemApiId: number | undefined;
    vendorExternalId: number | undefined;
    id: number;
}

export class UserNotification implements IUserNotification {
    tenantId!: number | undefined;
    userId!: number;
    state!: UserNotificationState;
    notification!: TenantNotification | undefined;
    targetNotifiers!: string | undefined;
    readonly targetNotifiersList!: string[] | undefined;
    id!: string;

    constructor(data?: IUserNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.userId = _data["userId"];
            this.state = _data["state"];
            this.notification = _data["notification"] ? TenantNotification.fromJS(_data["notification"]) : <any>undefined;
            this.targetNotifiers = _data["targetNotifiers"];
            if (Array.isArray(_data["targetNotifiersList"])) {
                (<any>this).targetNotifiersList = [] as any;
                for (let item of _data["targetNotifiersList"])
                    (<any>this).targetNotifiersList!.push(item);
            }
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UserNotification {
        data = typeof data === 'object' ? data : {};
        let result = new UserNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : <any>undefined;
        data["targetNotifiers"] = this.targetNotifiers;
        if (Array.isArray(this.targetNotifiersList)) {
            data["targetNotifiersList"] = [];
            for (let item of this.targetNotifiersList)
                data["targetNotifiersList"].push(item);
        }
        data["id"] = this.id;
        return data;
    }
}

export interface IUserNotification {
    tenantId: number | undefined;
    userId: number;
    state: UserNotificationState;
    notification: TenantNotification | undefined;
    targetNotifiers: string | undefined;
    targetNotifiersList: string[] | undefined;
    id: string;
}

export enum UserNotificationState {
    Unread = "Unread",
    Read = "Read",
}

export class UserPlaceOutputDto implements IUserPlaceOutputDto {
    placeId!: number;
    externalPlaceId!: number;

    constructor(data?: IUserPlaceOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.externalPlaceId = _data["externalPlaceId"];
        }
    }

    static fromJS(data: any): UserPlaceOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserPlaceOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["externalPlaceId"] = this.externalPlaceId;
        return data;
    }
}

export interface IUserPlaceOutputDto {
    placeId: number;
    externalPlaceId: number;
}

export class UserRoleDto implements IUserRoleDto {
    roleId!: number;
    roleName!: string | undefined;
    roleDisplayName!: string | undefined;
    isAssigned!: boolean;
    inheritedFromOrganizationUnit!: boolean;

    constructor(data?: IUserRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"];
            this.roleName = _data["roleName"];
            this.roleDisplayName = _data["roleDisplayName"];
            this.isAssigned = _data["isAssigned"];
            this.inheritedFromOrganizationUnit = _data["inheritedFromOrganizationUnit"];
        }
    }

    static fromJS(data: any): UserRoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        data["inheritedFromOrganizationUnit"] = this.inheritedFromOrganizationUnit;
        return data;
    }
}

export interface IUserRoleDto {
    roleId: number;
    roleName: string | undefined;
    roleDisplayName: string | undefined;
    isAssigned: boolean;
    inheritedFromOrganizationUnit: boolean;
}

export class UserRolesPermissionsOutputDto implements IUserRolesPermissionsOutputDto {
    currentPlaceId!: number;
    permissionsByRole!: { [key: string]: { [key: string]: string[]; }; } | undefined;

    constructor(data?: IUserRolesPermissionsOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentPlaceId = _data["currentPlaceId"];
            if (_data["permissionsByRole"]) {
                this.permissionsByRole = {} as any;
                for (let key in _data["permissionsByRole"]) {
                    if (_data["permissionsByRole"].hasOwnProperty(key))
                        (<any>this.permissionsByRole)![key] = _data["permissionsByRole"][key] !== undefined ? _data["permissionsByRole"][key] : {};
                }
            }
        }
    }

    static fromJS(data: any): UserRolesPermissionsOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserRolesPermissionsOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentPlaceId"] = this.currentPlaceId;
        if (this.permissionsByRole) {
            data["permissionsByRole"] = {};
            for (let key in this.permissionsByRole) {
                if (this.permissionsByRole.hasOwnProperty(key))
                    (<any>data["permissionsByRole"])[key] = (<any>this.permissionsByRole)[key];
            }
        }
        return data;
    }
}

export interface IUserRolesPermissionsOutputDto {
    currentPlaceId: number;
    permissionsByRole: { [key: string]: { [key: string]: string[]; }; } | undefined;
}

export class UsersToOrganizationUnitInput implements IUsersToOrganizationUnitInput {
    userIds!: number[] | undefined;
    organizationUnitId!: number;

    constructor(data?: IUsersToOrganizationUnitInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["userIds"])) {
                this.userIds = [] as any;
                for (let item of _data["userIds"])
                    this.userIds!.push(item);
            }
            this.organizationUnitId = _data["organizationUnitId"];
        }
    }

    static fromJS(data: any): UsersToOrganizationUnitInput {
        data = typeof data === 'object' ? data : {};
        let result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.userIds)) {
            data["userIds"] = [];
            for (let item of this.userIds)
                data["userIds"].push(item);
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    }
}

export interface IUsersToOrganizationUnitInput {
    userIds: number[] | undefined;
    organizationUnitId: number;
}

export class UserVendorDto implements IUserVendorDto {
    userId!: number;
    userName!: string | undefined;
    emailAddress!: string | undefined;
    vendor!: VendorDto | undefined;

    constructor(data?: IUserVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.emailAddress = _data["emailAddress"];
            this.vendor = _data["vendor"] ? VendorDto.fromJS(_data["vendor"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UserVendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserVendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUserVendorDto {
    userId: number;
    userName: string | undefined;
    emailAddress: string | undefined;
    vendor: VendorDto | undefined;
}

export class UserVendorInput implements IUserVendorInput {
    userId!: number;
    vendorExternalId!: number;
    isUpdate!: boolean;

    constructor(data?: IUserVendorInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.vendorExternalId = _data["vendorExternalId"];
            this.isUpdate = _data["isUpdate"];
        }
    }

    static fromJS(data: any): UserVendorInput {
        data = typeof data === 'object' ? data : {};
        let result = new UserVendorInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["vendorExternalId"] = this.vendorExternalId;
        data["isUpdate"] = this.isUpdate;
        return data;
    }
}

export interface IUserVendorInput {
    userId: number;
    vendorExternalId: number;
    isUpdate: boolean;
}

export class ValidateRequiredInformationForWoodForcedExitOutput implements IValidateRequiredInformationForWoodForcedExitOutput {
    needsNoSamplingReason!: boolean;
    needsInternalDestination!: boolean;

    constructor(data?: IValidateRequiredInformationForWoodForcedExitOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.needsNoSamplingReason = _data["needsNoSamplingReason"];
            this.needsInternalDestination = _data["needsInternalDestination"];
        }
    }

    static fromJS(data: any): ValidateRequiredInformationForWoodForcedExitOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateRequiredInformationForWoodForcedExitOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["needsNoSamplingReason"] = this.needsNoSamplingReason;
        data["needsInternalDestination"] = this.needsInternalDestination;
        return data;
    }
}

export interface IValidateRequiredInformationForWoodForcedExitOutput {
    needsNoSamplingReason: boolean;
    needsInternalDestination: boolean;
}

export class ValidateSamplePerformedInput implements IValidateSamplePerformedInput {
    reportId!: number;
    samplingInfo!: SampleRecoveryOrValidationInfoDto[] | undefined;

    constructor(data?: IValidateSamplePerformedInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            if (Array.isArray(_data["samplingInfo"])) {
                this.samplingInfo = [] as any;
                for (let item of _data["samplingInfo"])
                    this.samplingInfo!.push(SampleRecoveryOrValidationInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateSamplePerformedInput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateSamplePerformedInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        if (Array.isArray(this.samplingInfo)) {
            data["samplingInfo"] = [];
            for (let item of this.samplingInfo)
                data["samplingInfo"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidateSamplePerformedInput {
    reportId: number;
    samplingInfo: SampleRecoveryOrValidationInfoDto[] | undefined;
}

export class ValidateSamplePerformedOutput implements IValidateSamplePerformedOutput {
    validationResult!: boolean;
    wasAutomaticallyAssignedNoSamplingReason!: boolean;
    automaticallyAssignedNoSamplingReasonName!: string | undefined;

    constructor(data?: IValidateSamplePerformedOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validationResult = _data["validationResult"];
            this.wasAutomaticallyAssignedNoSamplingReason = _data["wasAutomaticallyAssignedNoSamplingReason"];
            this.automaticallyAssignedNoSamplingReasonName = _data["automaticallyAssignedNoSamplingReasonName"];
        }
    }

    static fromJS(data: any): ValidateSamplePerformedOutput {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateSamplePerformedOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validationResult"] = this.validationResult;
        data["wasAutomaticallyAssignedNoSamplingReason"] = this.wasAutomaticallyAssignedNoSamplingReason;
        data["automaticallyAssignedNoSamplingReasonName"] = this.automaticallyAssignedNoSamplingReasonName;
        return data;
    }
}

export interface IValidateSamplePerformedOutput {
    validationResult: boolean;
    wasAutomaticallyAssignedNoSamplingReason: boolean;
    automaticallyAssignedNoSamplingReasonName: string | undefined;
}

export class ValidationPreActitityReportOutputDto implements IValidationPreActitityReportOutputDto {
    isValid!: boolean;
    detail!: string | undefined;
    preActivityReportId!: number;

    constructor(data?: IValidationPreActitityReportOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.detail = _data["detail"];
            this.preActivityReportId = _data["preActivityReportId"];
        }
    }

    static fromJS(data: any): ValidationPreActitityReportOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationPreActitityReportOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["detail"] = this.detail;
        data["preActivityReportId"] = this.preActivityReportId;
        return data;
    }
}

export interface IValidationPreActitityReportOutputDto {
    isValid: boolean;
    detail: string | undefined;
    preActivityReportId: number;
}

export class VehicleInTagDto implements IVehicleInTagDto {
    externalId!: number;
    licensePlate!: string | undefined;
    isTruck!: boolean;
    vendorId!: number;
    typeId!: number;
    vehicleTruckTypeExternalId!: number;
    id!: number;

    constructor(data?: IVehicleInTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalId = _data["externalId"];
            this.licensePlate = _data["licensePlate"];
            this.isTruck = _data["isTruck"];
            this.vendorId = _data["vendorId"];
            this.typeId = _data["typeId"];
            this.vehicleTruckTypeExternalId = _data["vehicleTruckTypeExternalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VehicleInTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleInTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalId"] = this.externalId;
        data["licensePlate"] = this.licensePlate;
        data["isTruck"] = this.isTruck;
        data["vendorId"] = this.vendorId;
        data["typeId"] = this.typeId;
        data["vehicleTruckTypeExternalId"] = this.vehicleTruckTypeExternalId;
        data["id"] = this.id;
        return data;
    }
}

export interface IVehicleInTagDto {
    externalId: number;
    licensePlate: string | undefined;
    isTruck: boolean;
    vendorId: number;
    typeId: number;
    vehicleTruckTypeExternalId: number;
    id: number;
}

export class VendorDto implements IVendorDto {
    tenantId!: number;
    externalId!: number;
    fantasyName!: string | undefined;
    id!: number;

    constructor(data?: IVendorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.externalId = _data["externalId"];
            this.fantasyName = _data["fantasyName"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): VendorDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["externalId"] = this.externalId;
        data["fantasyName"] = this.fantasyName;
        data["id"] = this.id;
        return data;
    }
}

export interface IVendorDto {
    tenantId: number;
    externalId: number;
    fantasyName: string | undefined;
    id: number;
}

export class VerifySmsCodeInputDto implements IVerifySmsCodeInputDto {
    code!: string | undefined;
    phoneNumber!: string | undefined;

    constructor(data?: IVerifySmsCodeInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.phoneNumber = _data["phoneNumber"];
        }
    }

    static fromJS(data: any): VerifySmsCodeInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    }
}

export interface IVerifySmsCodeInputDto {
    code: string | undefined;
    phoneNumber: string | undefined;
}

export class WaterDensityAuditoryDto implements IWaterDensityAuditoryDto {
    username!: string | undefined;
    originalWaterDensity!: string | undefined;
    newWaterDensity!: string | undefined;
    date!: DateTime;

    constructor(data?: IWaterDensityAuditoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.originalWaterDensity = _data["originalWaterDensity"];
            this.newWaterDensity = _data["newWaterDensity"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WaterDensityAuditoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WaterDensityAuditoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["originalWaterDensity"] = this.originalWaterDensity;
        data["newWaterDensity"] = this.newWaterDensity;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        return data;
    }
}

export interface IWaterDensityAuditoryDto {
    username: string | undefined;
    originalWaterDensity: string | undefined;
    newWaterDensity: string | undefined;
    date: DateTime;
}

export class WeightDto implements IWeightDto {
    reason!: ReasonDto | undefined;
    value!: number;
    comment!: string | undefined;
    id!: number;
    creatorUserId!: number | undefined;
    takedWeightTime!: DateTime | undefined;

    constructor(data?: IWeightDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] ? ReasonDto.fromJS(_data["reason"]) : <any>undefined;
            this.value = _data["value"];
            this.comment = _data["comment"];
            this.id = _data["id"];
            this.creatorUserId = _data["creatorUserId"];
            this.takedWeightTime = _data["takedWeightTime"] ? DateTime.fromISO(_data["takedWeightTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): WeightDto {
        data = typeof data === 'object' ? data : {};
        let result = new WeightDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : <any>undefined;
        data["value"] = this.value;
        data["comment"] = this.comment;
        data["id"] = this.id;
        data["creatorUserId"] = this.creatorUserId;
        data["takedWeightTime"] = this.takedWeightTime ? this.takedWeightTime.toString() : <any>undefined;
        return data;
    }
}

export interface IWeightDto {
    reason: ReasonDto | undefined;
    value: number;
    comment: string | undefined;
    id: number;
    creatorUserId: number | undefined;
    takedWeightTime: DateTime | undefined;
}

export class Widget implements IWidget {
    widgetId!: string | undefined;
    height!: number;
    width!: number;
    positionX!: number;
    positionY!: number;

    constructor(data?: IWidget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.widgetId = _data["widgetId"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.positionX = _data["positionX"];
            this.positionY = _data["positionY"];
        }
    }

    static fromJS(data: any): Widget {
        data = typeof data === 'object' ? data : {};
        let result = new Widget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["widgetId"] = this.widgetId;
        data["height"] = this.height;
        data["width"] = this.width;
        data["positionX"] = this.positionX;
        data["positionY"] = this.positionY;
        return data;
    }
}

export interface IWidget {
    widgetId: string | undefined;
    height: number;
    width: number;
    positionX: number;
    positionY: number;
}

export class WidgetFilterOutput implements IWidgetFilterOutput {
    id!: string | undefined;
    name!: string | undefined;

    constructor(data?: IWidgetFilterOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): WidgetFilterOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetFilterOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IWidgetFilterOutput {
    id: string | undefined;
    name: string | undefined;
}

export class WidgetOutput implements IWidgetOutput {
    id!: string | undefined;
    name!: string | undefined;
    description!: string | undefined;
    filters!: WidgetFilterOutput[] | undefined;

    constructor(data?: IWidgetOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(WidgetFilterOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WidgetOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WidgetOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item.toJSON());
        }
        return data;
    }
}

export interface IWidgetOutput {
    id: string | undefined;
    name: string | undefined;
    description: string | undefined;
    filters: WidgetFilterOutput[] | undefined;
}

export class WoodActivityReportAbortedScannerReasonDto implements IWoodActivityReportAbortedScannerReasonDto {
    reasonId!: number;
    comment!: string | undefined;

    constructor(data?: IWoodActivityReportAbortedScannerReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reasonId = _data["reasonId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): WoodActivityReportAbortedScannerReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportAbortedScannerReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonId"] = this.reasonId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IWoodActivityReportAbortedScannerReasonDto {
    reasonId: number;
    comment: string | undefined;
}

export enum WoodActivityReportCreationSystemFilter {
    All = "All",
    SmartTruck = "SmartTruck",
    ProvidersModule = "ProvidersModule",
    Api = "Api",
    Totem = "Totem",
}

export class WoodActivityReportDto implements IWoodActivityReportDto {
    state!: ActivityReportState;
    activityReportLines!: WoodActivityReportLineDto[] | undefined;
    tenantId!: number;
    origin!: LocationDto | undefined;
    destination!: LocationDto | undefined;
    vehicleId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    vehicleVendorResourceTypeExternalId!: number;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    customsDeclaration!: SingleCustomDeclarationDto | undefined;
    isChip!: boolean;
    sampleAssignment!: SampleAssignmentType;
    internalDestination!: InternalDestinationDto | undefined;
    wasSampled!: boolean;
    date!: DateTime;
    serial!: string | undefined;
    number!: number | undefined;
    tripNumber!: number | undefined;
    loadEndDate!: DateTime;
    grossWeight!: WeightDto | undefined;
    placeId!: number;
    isTritrain!: boolean;
    id!: number;

    constructor(data?: IWoodActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(WoodActivityReportLineDto.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? LocationDto.fromJS(_data["destination"]) : <any>undefined;
            this.vehicleId = _data["vehicleId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.vehicleVendorResourceTypeExternalId = _data["vehicleVendorResourceTypeExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.customsDeclaration = _data["customsDeclaration"] ? SingleCustomDeclarationDto.fromJS(_data["customsDeclaration"]) : <any>undefined;
            this.isChip = _data["isChip"];
            this.sampleAssignment = _data["sampleAssignment"];
            this.internalDestination = _data["internalDestination"] ? InternalDestinationDto.fromJS(_data["internalDestination"]) : <any>undefined;
            this.wasSampled = _data["wasSampled"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.tripNumber = _data["tripNumber"];
            this.loadEndDate = _data["loadEndDate"] ? DateTime.fromISO(_data["loadEndDate"].toString()) : <any>undefined;
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.placeId = _data["placeId"];
            this.isTritrain = _data["isTritrain"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        data["vehicleId"] = this.vehicleId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["vehicleVendorResourceTypeExternalId"] = this.vehicleVendorResourceTypeExternalId;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["customsDeclaration"] = this.customsDeclaration ? this.customsDeclaration.toJSON() : <any>undefined;
        data["isChip"] = this.isChip;
        data["sampleAssignment"] = this.sampleAssignment;
        data["internalDestination"] = this.internalDestination ? this.internalDestination.toJSON() : <any>undefined;
        data["wasSampled"] = this.wasSampled;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["tripNumber"] = this.tripNumber;
        data["loadEndDate"] = this.loadEndDate ? this.loadEndDate.toString() : <any>undefined;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["placeId"] = this.placeId;
        data["isTritrain"] = this.isTritrain;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodActivityReportDto {
    state: ActivityReportState;
    activityReportLines: WoodActivityReportLineDto[] | undefined;
    tenantId: number;
    origin: LocationDto | undefined;
    destination: LocationDto | undefined;
    vehicleId: number;
    vehicleLicensePlate: string | undefined;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    vehicleVendorResourceTypeExternalId: number;
    driverExternalId: number;
    driverVendorExternalId: number;
    customsDeclaration: SingleCustomDeclarationDto | undefined;
    isChip: boolean;
    sampleAssignment: SampleAssignmentType;
    internalDestination: InternalDestinationDto | undefined;
    wasSampled: boolean;
    date: DateTime;
    serial: string | undefined;
    number: number | undefined;
    tripNumber: number | undefined;
    loadEndDate: DateTime;
    grossWeight: WeightDto | undefined;
    placeId: number;
    isTritrain: boolean;
    id: number;
}

export class WoodActivityReportEstimatedVolumeDto implements IWoodActivityReportEstimatedVolumeDto {
    estimatedVolume!: number;

    constructor(data?: IWoodActivityReportEstimatedVolumeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.estimatedVolume = _data["estimatedVolume"];
        }
    }

    static fromJS(data: any): WoodActivityReportEstimatedVolumeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportEstimatedVolumeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estimatedVolume"] = this.estimatedVolume;
        return data;
    }
}

export interface IWoodActivityReportEstimatedVolumeDto {
    estimatedVolume: number;
}

export class WoodActivityReportForMassEditGridDto implements IWoodActivityReportForMassEditGridDto {
    reportId!: number;
    externalId!: number | undefined;
    licensePlate!: string | undefined;
    state!: ActivityReportState;
    condition!: ActivityReportStateCondition;
    entryDate!: DateTime | undefined;
    exitDate!: DateTime | undefined;
    hasMultipleLines!: boolean;
    editLocked!: boolean;
    externalDestinationId!: number;
    originId!: number;

    constructor(data?: IWoodActivityReportForMassEditGridDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportId = _data["reportId"];
            this.externalId = _data["externalId"];
            this.licensePlate = _data["licensePlate"];
            this.state = _data["state"];
            this.condition = _data["condition"];
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.hasMultipleLines = _data["hasMultipleLines"];
            this.editLocked = _data["editLocked"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.originId = _data["originId"];
        }
    }

    static fromJS(data: any): WoodActivityReportForMassEditGridDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportForMassEditGridDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportId"] = this.reportId;
        data["externalId"] = this.externalId;
        data["licensePlate"] = this.licensePlate;
        data["state"] = this.state;
        data["condition"] = this.condition;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["hasMultipleLines"] = this.hasMultipleLines;
        data["editLocked"] = this.editLocked;
        data["externalDestinationId"] = this.externalDestinationId;
        data["originId"] = this.originId;
        return data;
    }
}

export interface IWoodActivityReportForMassEditGridDto {
    reportId: number;
    externalId: number | undefined;
    licensePlate: string | undefined;
    state: ActivityReportState;
    condition: ActivityReportStateCondition;
    entryDate: DateTime | undefined;
    exitDate: DateTime | undefined;
    hasMultipleLines: boolean;
    editLocked: boolean;
    externalDestinationId: number;
    originId: number;
}

export class WoodActivityReportForSamplesGridOutputDto implements IWoodActivityReportForSamplesGridOutputDto {
    date!: DateTime;
    sampleAssignment!: SampleAssignmentType;
    wasCompleted!: boolean;
    licensePlate!: string | undefined;
    isInPlant!: boolean;
    isChip!: boolean;
    externalId!: number | undefined;
    activityReportState!: ActivityReportState;
    activityReportStateCondition!: ActivityReportStateCondition;
    canRelease!: boolean;
    localId!: number | undefined;
    exitZoneId!: number | undefined;
    originExternalId!: number;
    originType!: LocationType;
    standExternalId!: number;
    id!: number;

    constructor(data?: IWoodActivityReportForSamplesGridOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.sampleAssignment = _data["sampleAssignment"];
            this.wasCompleted = _data["wasCompleted"];
            this.licensePlate = _data["licensePlate"];
            this.isInPlant = _data["isInPlant"];
            this.isChip = _data["isChip"];
            this.externalId = _data["externalId"];
            this.activityReportState = _data["activityReportState"];
            this.activityReportStateCondition = _data["activityReportStateCondition"];
            this.canRelease = _data["canRelease"];
            this.localId = _data["localId"];
            this.exitZoneId = _data["exitZoneId"];
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.standExternalId = _data["standExternalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodActivityReportForSamplesGridOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportForSamplesGridOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["sampleAssignment"] = this.sampleAssignment;
        data["wasCompleted"] = this.wasCompleted;
        data["licensePlate"] = this.licensePlate;
        data["isInPlant"] = this.isInPlant;
        data["isChip"] = this.isChip;
        data["externalId"] = this.externalId;
        data["activityReportState"] = this.activityReportState;
        data["activityReportStateCondition"] = this.activityReportStateCondition;
        data["canRelease"] = this.canRelease;
        data["localId"] = this.localId;
        data["exitZoneId"] = this.exitZoneId;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["standExternalId"] = this.standExternalId;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodActivityReportForSamplesGridOutputDto {
    date: DateTime;
    sampleAssignment: SampleAssignmentType;
    wasCompleted: boolean;
    licensePlate: string | undefined;
    isInPlant: boolean;
    isChip: boolean;
    externalId: number | undefined;
    activityReportState: ActivityReportState;
    activityReportStateCondition: ActivityReportStateCondition;
    canRelease: boolean;
    localId: number | undefined;
    exitZoneId: number | undefined;
    originExternalId: number;
    originType: LocationType;
    standExternalId: number;
    id: number;
}

export class WoodActivityReportGeoLocationInformationDto implements IWoodActivityReportGeoLocationInformationDto {
    latitude!: number;
    longitude!: number;
    precision!: number | undefined;
    stand!: string | undefined;
    sameStandRecommendedByArcGis!: boolean;

    constructor(data?: IWoodActivityReportGeoLocationInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.precision = _data["precision"];
            this.stand = _data["stand"];
            this.sameStandRecommendedByArcGis = _data["sameStandRecommendedByArcGis"];
        }
    }

    static fromJS(data: any): WoodActivityReportGeoLocationInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportGeoLocationInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["precision"] = this.precision;
        data["stand"] = this.stand;
        data["sameStandRecommendedByArcGis"] = this.sameStandRecommendedByArcGis;
        return data;
    }
}

export interface IWoodActivityReportGeoLocationInformationDto {
    latitude: number;
    longitude: number;
    precision: number | undefined;
    stand: string | undefined;
    sameStandRecommendedByArcGis: boolean;
}

export enum WoodActivityReportInformationLogType {
    Origin = "Origin",
    Stand = "Stand",
    Article = "Article",
}

export class WoodActivityReportLineDto implements IWoodActivityReportLineDto {
    pile!: PileDto | undefined;
    stand!: StandDto | undefined;
    article!: ArticleDto | undefined;
    contract!: ContractDto | undefined;
    standId!: number;
    articleId!: number;
    contractId!: number;
    services!: ServiceDto[] | undefined;
    origin!: LocationDto | undefined;
    grossWeight!: number;
    tareWeight!: number;
    netWeight!: number;
    barkSample!: boolean;
    isPefcCertified!: boolean | undefined;
    id!: number;

    constructor(data?: IWoodActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pile = _data["pile"] ? PileDto.fromJS(_data["pile"]) : <any>undefined;
            this.stand = _data["stand"] ? StandDto.fromJS(_data["stand"]) : <any>undefined;
            this.article = _data["article"] ? ArticleDto.fromJS(_data["article"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.standId = _data["standId"];
            this.articleId = _data["articleId"];
            this.contractId = _data["contractId"];
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceDto.fromJS(item));
            }
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.grossWeight = _data["grossWeight"];
            this.tareWeight = _data["tareWeight"];
            this.netWeight = _data["netWeight"];
            this.barkSample = _data["barkSample"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pile"] = this.pile ? this.pile.toJSON() : <any>undefined;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["standId"] = this.standId;
        data["articleId"] = this.articleId;
        data["contractId"] = this.contractId;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["grossWeight"] = this.grossWeight;
        data["tareWeight"] = this.tareWeight;
        data["netWeight"] = this.netWeight;
        data["barkSample"] = this.barkSample;
        data["isPefcCertified"] = this.isPefcCertified;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodActivityReportLineDto {
    pile: PileDto | undefined;
    stand: StandDto | undefined;
    article: ArticleDto | undefined;
    contract: ContractDto | undefined;
    standId: number;
    articleId: number;
    contractId: number;
    services: ServiceDto[] | undefined;
    origin: LocationDto | undefined;
    grossWeight: number;
    tareWeight: number;
    netWeight: number;
    barkSample: boolean;
    isPefcCertified: boolean | undefined;
    id: number;
}

export class WoodActivityReportLineEditionDto implements IWoodActivityReportLineEditionDto {
    stand!: ExternalStandDto | undefined;
    loadingServiceVendorId!: number | undefined;
    cutServiceVendorId!: number | undefined;
    extractionServiceVendorId!: number | undefined;
    lineId!: number;
    isPefcCertified!: boolean | undefined;
    articleId!: number | undefined;
    pileId!: number | undefined;
    origin!: ExternalLocationInputDto | undefined;
    contract!: ExternalContractDto | undefined;

    constructor(data?: IWoodActivityReportLineEditionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stand = _data["stand"] ? ExternalStandDto.fromJS(_data["stand"]) : <any>undefined;
            this.loadingServiceVendorId = _data["loadingServiceVendorId"];
            this.cutServiceVendorId = _data["cutServiceVendorId"];
            this.extractionServiceVendorId = _data["extractionServiceVendorId"];
            this.lineId = _data["lineId"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.articleId = _data["articleId"];
            this.pileId = _data["pileId"];
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.contract = _data["contract"] ? ExternalContractDto.fromJS(_data["contract"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WoodActivityReportLineEditionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportLineEditionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["loadingServiceVendorId"] = this.loadingServiceVendorId;
        data["cutServiceVendorId"] = this.cutServiceVendorId;
        data["extractionServiceVendorId"] = this.extractionServiceVendorId;
        data["lineId"] = this.lineId;
        data["isPefcCertified"] = this.isPefcCertified;
        data["articleId"] = this.articleId;
        data["pileId"] = this.pileId;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWoodActivityReportLineEditionDto {
    stand: ExternalStandDto | undefined;
    loadingServiceVendorId: number | undefined;
    cutServiceVendorId: number | undefined;
    extractionServiceVendorId: number | undefined;
    lineId: number;
    isPefcCertified: boolean | undefined;
    articleId: number | undefined;
    pileId: number | undefined;
    origin: ExternalLocationInputDto | undefined;
    contract: ExternalContractDto | undefined;
}

export class WoodActivityReportLogOutput implements IWoodActivityReportLogOutput {
    woodReportLogId!: number;
    woodActivityReportId!: number;
    destinationExternalId!: number;
    destinationType!: LocationType;
    woodActivityLogType!: WoodActivityReportInformationLogType;
    oldValue!: number;
    newValue!: number;
    userModifier!: string | undefined;
    woodActivityReportCreationTime!: DateTime;
    woodActivityReportLogCreationTime!: DateTime;
    originOldType!: LocationType | undefined;
    originNewType!: LocationType | undefined;

    constructor(data?: IWoodActivityReportLogOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodReportLogId = _data["woodReportLogId"];
            this.woodActivityReportId = _data["woodActivityReportId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.woodActivityLogType = _data["woodActivityLogType"];
            this.oldValue = _data["oldValue"];
            this.newValue = _data["newValue"];
            this.userModifier = _data["userModifier"];
            this.woodActivityReportCreationTime = _data["woodActivityReportCreationTime"] ? DateTime.fromISO(_data["woodActivityReportCreationTime"].toString()) : <any>undefined;
            this.woodActivityReportLogCreationTime = _data["woodActivityReportLogCreationTime"] ? DateTime.fromISO(_data["woodActivityReportLogCreationTime"].toString()) : <any>undefined;
            this.originOldType = _data["originOldType"];
            this.originNewType = _data["originNewType"];
        }
    }

    static fromJS(data: any): WoodActivityReportLogOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportLogOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodReportLogId"] = this.woodReportLogId;
        data["woodActivityReportId"] = this.woodActivityReportId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["woodActivityLogType"] = this.woodActivityLogType;
        data["oldValue"] = this.oldValue;
        data["newValue"] = this.newValue;
        data["userModifier"] = this.userModifier;
        data["woodActivityReportCreationTime"] = this.woodActivityReportCreationTime ? this.woodActivityReportCreationTime.toString() : <any>undefined;
        data["woodActivityReportLogCreationTime"] = this.woodActivityReportLogCreationTime ? this.woodActivityReportLogCreationTime.toString() : <any>undefined;
        data["originOldType"] = this.originOldType;
        data["originNewType"] = this.originNewType;
        return data;
    }
}

export interface IWoodActivityReportLogOutput {
    woodReportLogId: number;
    woodActivityReportId: number;
    destinationExternalId: number;
    destinationType: LocationType;
    woodActivityLogType: WoodActivityReportInformationLogType;
    oldValue: number;
    newValue: number;
    userModifier: string | undefined;
    woodActivityReportCreationTime: DateTime;
    woodActivityReportLogCreationTime: DateTime;
    originOldType: LocationType | undefined;
    originNewType: LocationType | undefined;
}

export class WoodActivityReportSampleDto implements IWoodActivityReportSampleDto {
    shouldConfirmEntrance!: boolean | undefined;

    constructor(data?: IWoodActivityReportSampleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shouldConfirmEntrance = _data["shouldConfirmEntrance"];
        }
    }

    static fromJS(data: any): WoodActivityReportSampleDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportSampleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shouldConfirmEntrance"] = this.shouldConfirmEntrance;
        return data;
    }
}

export interface IWoodActivityReportSampleDto {
    shouldConfirmEntrance: boolean | undefined;
}

export class WoodActivityReportsForTrucksToNextTrip implements IWoodActivityReportsForTrucksToNextTrip {
    id!: number;
    licensePlate!: string | undefined;

    constructor(data?: IWoodActivityReportsForTrucksToNextTrip) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): WoodActivityReportsForTrucksToNextTrip {
        data = typeof data === 'object' ? data : {};
        let result = new WoodActivityReportsForTrucksToNextTrip();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface IWoodActivityReportsForTrucksToNextTrip {
    id: number;
    licensePlate: string | undefined;
}

export class WoodControlActivityReportDto implements IWoodControlActivityReportDto {
    state!: ActivityReportState;
    stateCondition!: ActivityReportStateCondition;
    reason!: ActivityReportSystemReasons;
    activityReportLines!: WoodActivityReportLineDto[] | undefined;
    tenantId!: number;
    originExternalId!: number;
    originType!: LocationType;
    destionationExternalId!: number;
    destinationType!: LocationType;
    transportInternalId!: number;
    transportExternalId!: number;
    transportVendorExternalId!: number;
    transportActiveTagNumber!: number;
    semitrailers!: TruckVehicleDto[] | undefined;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    singleCustomDeclarationExternalId!: number | undefined;
    isChip!: boolean;
    tripNumber!: number;
    needsQR!: boolean;
    cycle!: number | undefined;
    sampleAssignment!: SampleAssignmentType;
    loadActivityReportId!: number | undefined;
    activityReportDate!: DateTime;
    serial!: string | undefined;
    number!: number;
    customsIntegrationId!: number;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    netWeight!: number;
    chipHumidity!: number | undefined;
    reportType!: ActivityReportType;
    internalDestination!: InternalDestinationDto | undefined;
    isAutomatic!: boolean;
    externalActivityReportId!: number | undefined;
    wasSampled!: boolean;
    exitDate!: DateTime | undefined;
    entryDate!: DateTime | undefined;
    paysTransport!: boolean;
    loadDate!: DateTime | undefined;
    sampleAlgorithmExecuted!: boolean;
    noSamplingReason!: ReasonDto | undefined;
    thirdPropertyCategory!: number | undefined;
    hasLoadActivityReport!: boolean;
    hasScannerResults!: boolean;
    comment!: string | undefined;
    editLocked!: boolean;
    enteringStockAreaId!: number;
    operationMode!: ActivityReportOperationMode;
    localId!: number;
    entryZoneId!: number;
    exitZoneId!: number;
    placeId!: number;
    usesScannerMeasurements!: boolean;
    abortedScannerReason!: WoodActivityReportAbortedScannerReasonDto | undefined;
    scannerIntegrationId!: number | undefined;
    creatorUserId!: number | undefined;
    woodActivityReportEstimatedVolume!: WoodActivityReportEstimatedVolumeDto | undefined;
    id!: number;

    constructor(data?: IWoodControlActivityReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"];
            this.stateCondition = _data["stateCondition"];
            this.reason = _data["reason"];
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(WoodActivityReportLineDto.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destionationExternalId = _data["destionationExternalId"];
            this.destinationType = _data["destinationType"];
            this.transportInternalId = _data["transportInternalId"];
            this.transportExternalId = _data["transportExternalId"];
            this.transportVendorExternalId = _data["transportVendorExternalId"];
            this.transportActiveTagNumber = _data["transportActiveTagNumber"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(TruckVehicleDto.fromJS(item));
            }
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.singleCustomDeclarationExternalId = _data["singleCustomDeclarationExternalId"];
            this.isChip = _data["isChip"];
            this.tripNumber = _data["tripNumber"];
            this.needsQR = _data["needsQR"];
            this.cycle = _data["cycle"];
            this.sampleAssignment = _data["sampleAssignment"];
            this.loadActivityReportId = _data["loadActivityReportId"];
            this.activityReportDate = _data["activityReportDate"] ? DateTime.fromISO(_data["activityReportDate"].toString()) : <any>undefined;
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.customsIntegrationId = _data["customsIntegrationId"];
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.chipHumidity = _data["chipHumidity"];
            this.reportType = _data["reportType"];
            this.internalDestination = _data["internalDestination"] ? InternalDestinationDto.fromJS(_data["internalDestination"]) : <any>undefined;
            this.isAutomatic = _data["isAutomatic"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.wasSampled = _data["wasSampled"];
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
            this.loadDate = _data["loadDate"] ? DateTime.fromISO(_data["loadDate"].toString()) : <any>undefined;
            this.sampleAlgorithmExecuted = _data["sampleAlgorithmExecuted"];
            this.noSamplingReason = _data["noSamplingReason"] ? ReasonDto.fromJS(_data["noSamplingReason"]) : <any>undefined;
            this.thirdPropertyCategory = _data["thirdPropertyCategory"];
            this.hasLoadActivityReport = _data["hasLoadActivityReport"];
            this.hasScannerResults = _data["hasScannerResults"];
            this.comment = _data["comment"];
            this.editLocked = _data["editLocked"];
            this.enteringStockAreaId = _data["enteringStockAreaId"];
            this.operationMode = _data["operationMode"];
            this.localId = _data["localId"];
            this.entryZoneId = _data["entryZoneId"];
            this.exitZoneId = _data["exitZoneId"];
            this.placeId = _data["placeId"];
            this.usesScannerMeasurements = _data["usesScannerMeasurements"];
            this.abortedScannerReason = _data["abortedScannerReason"] ? WoodActivityReportAbortedScannerReasonDto.fromJS(_data["abortedScannerReason"]) : <any>undefined;
            this.scannerIntegrationId = _data["scannerIntegrationId"];
            this.creatorUserId = _data["creatorUserId"];
            this.woodActivityReportEstimatedVolume = _data["woodActivityReportEstimatedVolume"] ? WoodActivityReportEstimatedVolumeDto.fromJS(_data["woodActivityReportEstimatedVolume"]) : <any>undefined;
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodControlActivityReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodControlActivityReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["stateCondition"] = this.stateCondition;
        data["reason"] = this.reason;
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destionationExternalId"] = this.destionationExternalId;
        data["destinationType"] = this.destinationType;
        data["transportInternalId"] = this.transportInternalId;
        data["transportExternalId"] = this.transportExternalId;
        data["transportVendorExternalId"] = this.transportVendorExternalId;
        data["transportActiveTagNumber"] = this.transportActiveTagNumber;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["singleCustomDeclarationExternalId"] = this.singleCustomDeclarationExternalId;
        data["isChip"] = this.isChip;
        data["tripNumber"] = this.tripNumber;
        data["needsQR"] = this.needsQR;
        data["cycle"] = this.cycle;
        data["sampleAssignment"] = this.sampleAssignment;
        data["loadActivityReportId"] = this.loadActivityReportId;
        data["activityReportDate"] = this.activityReportDate ? this.activityReportDate.toString() : <any>undefined;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["customsIntegrationId"] = this.customsIntegrationId;
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["chipHumidity"] = this.chipHumidity;
        data["reportType"] = this.reportType;
        data["internalDestination"] = this.internalDestination ? this.internalDestination.toJSON() : <any>undefined;
        data["isAutomatic"] = this.isAutomatic;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["wasSampled"] = this.wasSampled;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        data["loadDate"] = this.loadDate ? this.loadDate.toString() : <any>undefined;
        data["sampleAlgorithmExecuted"] = this.sampleAlgorithmExecuted;
        data["noSamplingReason"] = this.noSamplingReason ? this.noSamplingReason.toJSON() : <any>undefined;
        data["thirdPropertyCategory"] = this.thirdPropertyCategory;
        data["hasLoadActivityReport"] = this.hasLoadActivityReport;
        data["hasScannerResults"] = this.hasScannerResults;
        data["comment"] = this.comment;
        data["editLocked"] = this.editLocked;
        data["enteringStockAreaId"] = this.enteringStockAreaId;
        data["operationMode"] = this.operationMode;
        data["localId"] = this.localId;
        data["entryZoneId"] = this.entryZoneId;
        data["exitZoneId"] = this.exitZoneId;
        data["placeId"] = this.placeId;
        data["usesScannerMeasurements"] = this.usesScannerMeasurements;
        data["abortedScannerReason"] = this.abortedScannerReason ? this.abortedScannerReason.toJSON() : <any>undefined;
        data["scannerIntegrationId"] = this.scannerIntegrationId;
        data["creatorUserId"] = this.creatorUserId;
        data["woodActivityReportEstimatedVolume"] = this.woodActivityReportEstimatedVolume ? this.woodActivityReportEstimatedVolume.toJSON() : <any>undefined;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodControlActivityReportDto {
    state: ActivityReportState;
    stateCondition: ActivityReportStateCondition;
    reason: ActivityReportSystemReasons;
    activityReportLines: WoodActivityReportLineDto[] | undefined;
    tenantId: number;
    originExternalId: number;
    originType: LocationType;
    destionationExternalId: number;
    destinationType: LocationType;
    transportInternalId: number;
    transportExternalId: number;
    transportVendorExternalId: number;
    transportActiveTagNumber: number;
    semitrailers: TruckVehicleDto[] | undefined;
    driverExternalId: number;
    driverVendorExternalId: number;
    singleCustomDeclarationExternalId: number | undefined;
    isChip: boolean;
    tripNumber: number;
    needsQR: boolean;
    cycle: number | undefined;
    sampleAssignment: SampleAssignmentType;
    loadActivityReportId: number | undefined;
    activityReportDate: DateTime;
    serial: string | undefined;
    number: number;
    customsIntegrationId: number;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    netWeight: number;
    chipHumidity: number | undefined;
    reportType: ActivityReportType;
    internalDestination: InternalDestinationDto | undefined;
    isAutomatic: boolean;
    externalActivityReportId: number | undefined;
    wasSampled: boolean;
    exitDate: DateTime | undefined;
    entryDate: DateTime | undefined;
    paysTransport: boolean;
    loadDate: DateTime | undefined;
    sampleAlgorithmExecuted: boolean;
    noSamplingReason: ReasonDto | undefined;
    thirdPropertyCategory: number | undefined;
    hasLoadActivityReport: boolean;
    hasScannerResults: boolean;
    comment: string | undefined;
    editLocked: boolean;
    enteringStockAreaId: number;
    operationMode: ActivityReportOperationMode;
    localId: number;
    entryZoneId: number;
    exitZoneId: number;
    placeId: number;
    usesScannerMeasurements: boolean;
    abortedScannerReason: WoodActivityReportAbortedScannerReasonDto | undefined;
    scannerIntegrationId: number | undefined;
    creatorUserId: number | undefined;
    woodActivityReportEstimatedVolume: WoodActivityReportEstimatedVolumeDto | undefined;
    id: number;
}

export class WoodControlActivityReportLineInputDto implements IWoodControlActivityReportLineInputDto {
    article!: ExternalArticleInput | undefined;
    contract!: ExternalContractInput | undefined;
    stand!: ExternalStandInput | undefined;
    services!: ExternalServiceInput[] | undefined;
    origin!: ExternalLocationInputDto | undefined;
    barkSample!: boolean;
    isPefcCertified!: boolean;
    pileId!: number | undefined;

    constructor(data?: IWoodControlActivityReportLineInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.article = _data["article"] ? ExternalArticleInput.fromJS(_data["article"]) : <any>undefined;
            this.contract = _data["contract"] ? ExternalContractInput.fromJS(_data["contract"]) : <any>undefined;
            this.stand = _data["stand"] ? ExternalStandInput.fromJS(_data["stand"]) : <any>undefined;
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ExternalServiceInput.fromJS(item));
            }
            this.origin = _data["origin"] ? ExternalLocationInputDto.fromJS(_data["origin"]) : <any>undefined;
            this.barkSample = _data["barkSample"];
            this.isPefcCertified = _data["isPefcCertified"];
            this.pileId = _data["pileId"];
        }
    }

    static fromJS(data: any): WoodControlActivityReportLineInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodControlActivityReportLineInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["barkSample"] = this.barkSample;
        data["isPefcCertified"] = this.isPefcCertified;
        data["pileId"] = this.pileId;
        return data;
    }
}

export interface IWoodControlActivityReportLineInputDto {
    article: ExternalArticleInput | undefined;
    contract: ExternalContractInput | undefined;
    stand: ExternalStandInput | undefined;
    services: ExternalServiceInput[] | undefined;
    origin: ExternalLocationInputDto | undefined;
    barkSample: boolean;
    isPefcCertified: boolean;
    pileId: number | undefined;
}

export enum WoodControlActivityReportLogOperation {
    ValidateTruck = "ValidateTruck",
    GetTrip = "GetTrip",
    GetLoadActivityReport = "GetLoadActivityReport",
    ReadAccessCard = "ReadAccessCard",
    SendSignalToScanner = "SendSignalToScanner",
    UpdateVehicleOnArrival = "UpdateVehicleOnArrival",
    YardManagingOnEntrance = "YardManagingOnEntrance",
    EnableSemaphore = "EnableSemaphore",
    RawMaterialsExecution = "RawMaterialsExecution",
    JySCallback = "JySCallback",
    SaveArchimedesSample = "SaveArchimedesSample",
    CreateDiverseProducts = "CreateDiverseProducts",
    EditDiverseProducts = "EditDiverseProducts",
    ElectronicReport = "ElectronicReport",
    EditWoodActivityReport = "EditWoodActivityReport",
    EditWoodActivityReportEventData = "EditWoodActivityReportEventData",
    BioforestIntegration = "BioforestIntegration",
    ExitSuccessful = "ExitSuccessful",
    CancelArchimedesSample = "CancelArchimedesSample",
    BioforestDeleteActivityReport = "BioforestDeleteActivityReport",
    SmartripUpdateInvoice = "SmartripUpdateInvoice",
    ManualArchimedesSampleAssignment = "ManualArchimedesSampleAssignment",
    YardManagingOnExit = "YardManagingOnExit",
    YardManagingCurrentTurn = "YardManagingCurrentTurn",
    CreateWoodActivityReport = "CreateWoodActivityReport",
    UpdateWoodActivityReport = "UpdateWoodActivityReport",
    SemiautomaticExit = "SemiautomaticExit",
    EditDiverseProductActivityReportEventData = "EditDiverseProductActivityReportEventData",
    ForcedExit = "ForcedExit",
    CreateInternalMovement = "CreateInternalMovement",
    ScannerResultReceived = "ScannerResultReceived",
    YardManagingCompleteSample = "YardManagingCompleteSample",
    SendEmail = "SendEmail",
    EditDiverseProductActivityReport = "EditDiverseProductActivityReport",
    YardManagingGetInternalDestination = "YardManagingGetInternalDestination",
    SamplingAlgorithmFailed = "SamplingAlgorithmFailed",
    ScannerModelNotFound = "ScannerModelNotFound",
    CantUpdateExternalReportAfterScannerResults = "CantUpdateExternalReportAfterScannerResults",
    ScannerModelChanged = "ScannerModelChanged",
    ScaleRead = "ScaleRead",
    GetDriverData = "GetDriverData",
    MassEdit = "MassEdit",
    UnlockActivityReport = "UnlockActivityReport",
    UpdateTripDriver = "UpdateTripDriver",
    CancelPreActivityReport = "CancelPreActivityReport",
    RejectPreActivityReport = "RejectPreActivityReport",
    ApprovePreReportValidation = "ApprovePreReportValidation",
    CreateDiverseProductPreActivityReport = "CreateDiverseProductPreActivityReport",
    CreateWoodPreActivityReport = "CreateWoodPreActivityReport",
    CreateInternalMovementPreActivityReport = "CreateInternalMovementPreActivityReport",
    UpdateTripDriverOnArrival = "UpdateTripDriverOnArrival",
    TurnExpired = "TurnExpired",
    EditWoodPreActivityReport = "EditWoodPreActivityReport",
    EditDiverseProductPreActivityReport = "EditDiverseProductPreActivityReport",
    EditInternalMovementPreActivityReport = "EditInternalMovementPreActivityReport",
    EntryWithExceptions = "EntryWithExceptions",
    DetourDetection = "DetourDetection",
    GetMeasurementType = "GetMeasurementType",
    SaveCalibrationSample = "SaveCalibrationSample",
    CreateWoodActivityReportFromLogyard = "CreateWoodActivityReportFromLogyard",
    SynchronizeWoodActivityReportFromLogyard = "SynchronizeWoodActivityReportFromLogyard",
    NotifyTravelLoaded = "NotifyTravelLoaded",
    PrintWoodReceipt = "PrintWoodReceipt",
    PrintDriverResume = "PrintDriverResume",
    PrintNextTravel = "PrintNextTravel",
    PrintLoadTicket = "PrintLoadTicket",
    DeleteScannerSample = "DeleteScannerSample",
    ScannerException = "ScannerException",
    PrintFourWayReceipt = "PrintFourWayReceipt",
    BioforestUpdateActivityReport = "BioforestUpdateActivityReport",
    SemitrailersDetection = "SemitrailersDetection",
    EditWoodPreReportTripNumber = "EditWoodPreReportTripNumber",
    DensitiyRecalculation = "DensitiyRecalculation",
    DeleteLoadActivityReport = "DeleteLoadActivityReport",
    Entry = "Entry",
    Exit = "Exit",
    EntryType = "EntryType",
    ExitType = "ExitType",
    ChangeArticleLengthOrSpecies = "ChangeArticleLengthOrSpecies",
    UpdateSingleCustomDeclaration = "UpdateSingleCustomDeclaration",
    EntryOutsideTheToleratedGrossWeight = "EntryOutsideTheToleratedGrossWeight",
    SendEmailToProviders = "SendEmailToProviders",
    SendEmailToLoaderVendors = "SendEmailToLoaderVendors",
    SendEmailToTransportVendors = "SendEmailToTransportVendors",
    ArcGisNearestStandIntegration = "ArcGisNearestStandIntegration",
    SendSampleInformationToScanner = "SendSampleInformationToScanner",
    PreviousValidationToFinishReport = "PreviousValidationToFinishReport",
    SendUpdateLogyardLoadActivityReport = "SendUpdateLogyardLoadActivityReport",
    ScannerMeasurementDataConfirmation = "ScannerMeasurementDataConfirmation",
    SendPolygonValidationEmail = "SendPolygonValidationEmail",
}

export class WoodCounterTripMonitorDto implements IWoodCounterTripMonitorDto {
    woodInPlant!: number;
    woodDispatched!: number;

    constructor(data?: IWoodCounterTripMonitorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodInPlant = _data["woodInPlant"];
            this.woodDispatched = _data["woodDispatched"];
        }
    }

    static fromJS(data: any): WoodCounterTripMonitorDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodCounterTripMonitorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodInPlant"] = this.woodInPlant;
        data["woodDispatched"] = this.woodDispatched;
        return data;
    }
}

export interface IWoodCounterTripMonitorDto {
    woodInPlant: number;
    woodDispatched: number;
}

export class WoodLineForArchimedesIndicatorOutputDto implements IWoodLineForArchimedesIndicatorOutputDto {
    originExternalId!: number;
    originType!: LocationType;
    articleExternalId!: number;
    contractExternalId!: number;
    standExternalId!: number;
    loaderExternalId!: number;
    id!: number;

    constructor(data?: IWoodLineForArchimedesIndicatorOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.articleExternalId = _data["articleExternalId"];
            this.contractExternalId = _data["contractExternalId"];
            this.standExternalId = _data["standExternalId"];
            this.loaderExternalId = _data["loaderExternalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodLineForArchimedesIndicatorOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodLineForArchimedesIndicatorOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["articleExternalId"] = this.articleExternalId;
        data["contractExternalId"] = this.contractExternalId;
        data["standExternalId"] = this.standExternalId;
        data["loaderExternalId"] = this.loaderExternalId;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodLineForArchimedesIndicatorOutputDto {
    originExternalId: number;
    originType: LocationType;
    articleExternalId: number;
    contractExternalId: number;
    standExternalId: number;
    loaderExternalId: number;
    id: number;
}

export class WoodPreActivityReportCertificationDto implements IWoodPreActivityReportCertificationDto {
    isPefcCertified!: boolean;
    isFSCCertified!: boolean;

    constructor(data?: IWoodPreActivityReportCertificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isPefcCertified = _data["isPefcCertified"];
            this.isFSCCertified = _data["isFSCCertified"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportCertificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportCertificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isPefcCertified"] = this.isPefcCertified;
        data["isFSCCertified"] = this.isFSCCertified;
        return data;
    }
}

export interface IWoodPreActivityReportCertificationDto {
    isPefcCertified: boolean;
    isFSCCertified: boolean;
}

export class WoodPreActivityReportForProviderSearchOutputDto implements IWoodPreActivityReportForProviderSearchOutputDto {
    externalDriverId!: number;
    date!: DateTime;
    externalTruckId!: number;
    externalOriginId!: number;
    originType!: LocationType;
    externalDestinationId!: number;
    destinationType!: LocationType;
    scheduledEntryTime!: DateTime | undefined;
    validationResult!: PreActivityReportValidation;
    isApproved!: boolean;
    creationMode!: PreActivityReportCreationMode;
    paysTransport!: boolean;
    tripNumber!: number | undefined;
    isChip!: boolean;
    externalArticleId!: number;
    id!: number;

    constructor(data?: IWoodPreActivityReportForProviderSearchOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalDriverId = _data["externalDriverId"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.externalTruckId = _data["externalTruckId"];
            this.externalOriginId = _data["externalOriginId"];
            this.originType = _data["originType"];
            this.externalDestinationId = _data["externalDestinationId"];
            this.destinationType = _data["destinationType"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.isApproved = _data["isApproved"];
            this.creationMode = _data["creationMode"];
            this.paysTransport = _data["paysTransport"];
            this.tripNumber = _data["tripNumber"];
            this.isChip = _data["isChip"];
            this.externalArticleId = _data["externalArticleId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportForProviderSearchOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportForProviderSearchOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalDriverId"] = this.externalDriverId;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["externalTruckId"] = this.externalTruckId;
        data["externalOriginId"] = this.externalOriginId;
        data["originType"] = this.originType;
        data["externalDestinationId"] = this.externalDestinationId;
        data["destinationType"] = this.destinationType;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["isApproved"] = this.isApproved;
        data["creationMode"] = this.creationMode;
        data["paysTransport"] = this.paysTransport;
        data["tripNumber"] = this.tripNumber;
        data["isChip"] = this.isChip;
        data["externalArticleId"] = this.externalArticleId;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodPreActivityReportForProviderSearchOutputDto {
    externalDriverId: number;
    date: DateTime;
    externalTruckId: number;
    externalOriginId: number;
    originType: LocationType;
    externalDestinationId: number;
    destinationType: LocationType;
    scheduledEntryTime: DateTime | undefined;
    validationResult: PreActivityReportValidation;
    isApproved: boolean;
    creationMode: PreActivityReportCreationMode;
    paysTransport: boolean;
    tripNumber: number | undefined;
    isChip: boolean;
    externalArticleId: number;
    id: number;
}

export class WoodPreActivityReportForSynchronizationDto implements IWoodPreActivityReportForSynchronizationDto {
    activityReportLines!: WoodPreActivityReportLineDto[] | undefined;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationType!: LocationType;
    vehicleId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    driverExternalId!: number;
    semitrailers!: TruckVehicleDto[] | undefined;
    tripNumber!: number | undefined;
    serial!: string | undefined;
    number!: number;
    reportType!: ActivityReportType;
    scheduledEntryTime!: DateTime | undefined;
    paysTransport!: boolean;
    date!: DateTime;
    validationResult!: PreActivityReportValidation;
    loaderVendorExternalId!: number | undefined;
    errors!: PreActivityReportErrorDto[] | undefined;
    isApproved!: boolean;
    isChip!: boolean;
    travelSystemHasError!: boolean | undefined;
    hasStandGeoLocationInformation!: boolean;
    latitude!: number | undefined;
    longitude!: number | undefined;
    id!: number;

    constructor(data?: IWoodPreActivityReportForSynchronizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["activityReportLines"])) {
                this.activityReportLines = [] as any;
                for (let item of _data["activityReportLines"])
                    this.activityReportLines!.push(WoodPreActivityReportLineDto.fromJS(item));
            }
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(TruckVehicleDto.fromJS(item));
            }
            this.tripNumber = _data["tripNumber"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.reportType = _data["reportType"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.loaderVendorExternalId = _data["loaderVendorExternalId"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.isApproved = _data["isApproved"];
            this.isChip = _data["isChip"];
            this.travelSystemHasError = _data["travelSystemHasError"];
            this.hasStandGeoLocationInformation = _data["hasStandGeoLocationInformation"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportForSynchronizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportForSynchronizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.activityReportLines)) {
            data["activityReportLines"] = [];
            for (let item of this.activityReportLines)
                data["activityReportLines"].push(item.toJSON());
        }
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["vehicleId"] = this.vehicleId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["driverExternalId"] = this.driverExternalId;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["tripNumber"] = this.tripNumber;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["reportType"] = this.reportType;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["loaderVendorExternalId"] = this.loaderVendorExternalId;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["isApproved"] = this.isApproved;
        data["isChip"] = this.isChip;
        data["travelSystemHasError"] = this.travelSystemHasError;
        data["hasStandGeoLocationInformation"] = this.hasStandGeoLocationInformation;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodPreActivityReportForSynchronizationDto {
    activityReportLines: WoodPreActivityReportLineDto[] | undefined;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationType: LocationType;
    vehicleId: number;
    vehicleLicensePlate: string | undefined;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    driverExternalId: number;
    semitrailers: TruckVehicleDto[] | undefined;
    tripNumber: number | undefined;
    serial: string | undefined;
    number: number;
    reportType: ActivityReportType;
    scheduledEntryTime: DateTime | undefined;
    paysTransport: boolean;
    date: DateTime;
    validationResult: PreActivityReportValidation;
    loaderVendorExternalId: number | undefined;
    errors: PreActivityReportErrorDto[] | undefined;
    isApproved: boolean;
    isChip: boolean;
    travelSystemHasError: boolean | undefined;
    hasStandGeoLocationInformation: boolean;
    latitude: number | undefined;
    longitude: number | undefined;
    id: number;
}

export class WoodPreActivityReportFullDto implements IWoodPreActivityReportFullDto {
    woodActivityReportLines!: WoodActivityReportLineDto[] | undefined;
    isApproved!: boolean;
    loaderServiceVendorExternalId!: number | undefined;
    creationMode!: PreActivityReportCreationMode;
    errors!: PreActivityReportErrorDto[] | undefined;
    originExternalId!: number;
    originType!: LocationType;
    destinationExternalId!: number;
    destinationType!: LocationType;
    vehicleId!: number;
    vehicleLicensePlate!: string | undefined;
    vehicleExternalId!: number;
    vehicleVendorExternalId!: number;
    driverExternalId!: number;
    semitrailers!: TruckVehicleDto[] | undefined;
    tripNumber!: number | undefined;
    serial!: string | undefined;
    number!: number;
    reportType!: ActivityReportType;
    scheduledEntryTime!: DateTime | undefined;
    paysTransport!: boolean;
    date!: DateTime;
    validationResult!: PreActivityReportValidation;
    certification!: WoodPreActivityReportCertificationDto | undefined;
    placeId!: number;
    isChip!: boolean;
    travelSystemHasError!: boolean | undefined;

    constructor(data?: IWoodPreActivityReportFullDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["woodActivityReportLines"])) {
                this.woodActivityReportLines = [] as any;
                for (let item of _data["woodActivityReportLines"])
                    this.woodActivityReportLines!.push(WoodActivityReportLineDto.fromJS(item));
            }
            this.isApproved = _data["isApproved"];
            this.loaderServiceVendorExternalId = _data["loaderServiceVendorExternalId"];
            this.creationMode = _data["creationMode"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(PreActivityReportErrorDto.fromJS(item));
            }
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.vehicleId = _data["vehicleId"];
            this.vehicleLicensePlate = _data["vehicleLicensePlate"];
            this.vehicleExternalId = _data["vehicleExternalId"];
            this.vehicleVendorExternalId = _data["vehicleVendorExternalId"];
            this.driverExternalId = _data["driverExternalId"];
            if (Array.isArray(_data["semitrailers"])) {
                this.semitrailers = [] as any;
                for (let item of _data["semitrailers"])
                    this.semitrailers!.push(TruckVehicleDto.fromJS(item));
            }
            this.tripNumber = _data["tripNumber"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.reportType = _data["reportType"];
            this.scheduledEntryTime = _data["scheduledEntryTime"] ? DateTime.fromISO(_data["scheduledEntryTime"].toString()) : <any>undefined;
            this.paysTransport = _data["paysTransport"];
            this.date = _data["date"] ? DateTime.fromISO(_data["date"].toString()) : <any>undefined;
            this.validationResult = _data["validationResult"];
            this.certification = _data["certification"] ? WoodPreActivityReportCertificationDto.fromJS(_data["certification"]) : <any>undefined;
            this.placeId = _data["placeId"];
            this.isChip = _data["isChip"];
            this.travelSystemHasError = _data["travelSystemHasError"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportFullDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportFullDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.woodActivityReportLines)) {
            data["woodActivityReportLines"] = [];
            for (let item of this.woodActivityReportLines)
                data["woodActivityReportLines"].push(item.toJSON());
        }
        data["isApproved"] = this.isApproved;
        data["loaderServiceVendorExternalId"] = this.loaderServiceVendorExternalId;
        data["creationMode"] = this.creationMode;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item.toJSON());
        }
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["vehicleId"] = this.vehicleId;
        data["vehicleLicensePlate"] = this.vehicleLicensePlate;
        data["vehicleExternalId"] = this.vehicleExternalId;
        data["vehicleVendorExternalId"] = this.vehicleVendorExternalId;
        data["driverExternalId"] = this.driverExternalId;
        if (Array.isArray(this.semitrailers)) {
            data["semitrailers"] = [];
            for (let item of this.semitrailers)
                data["semitrailers"].push(item.toJSON());
        }
        data["tripNumber"] = this.tripNumber;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["reportType"] = this.reportType;
        data["scheduledEntryTime"] = this.scheduledEntryTime ? this.scheduledEntryTime.toString() : <any>undefined;
        data["paysTransport"] = this.paysTransport;
        data["date"] = this.date ? this.date.toString() : <any>undefined;
        data["validationResult"] = this.validationResult;
        data["certification"] = this.certification ? this.certification.toJSON() : <any>undefined;
        data["placeId"] = this.placeId;
        data["isChip"] = this.isChip;
        data["travelSystemHasError"] = this.travelSystemHasError;
        return data;
    }
}

export interface IWoodPreActivityReportFullDto {
    woodActivityReportLines: WoodActivityReportLineDto[] | undefined;
    isApproved: boolean;
    loaderServiceVendorExternalId: number | undefined;
    creationMode: PreActivityReportCreationMode;
    errors: PreActivityReportErrorDto[] | undefined;
    originExternalId: number;
    originType: LocationType;
    destinationExternalId: number;
    destinationType: LocationType;
    vehicleId: number;
    vehicleLicensePlate: string | undefined;
    vehicleExternalId: number;
    vehicleVendorExternalId: number;
    driverExternalId: number;
    semitrailers: TruckVehicleDto[] | undefined;
    tripNumber: number | undefined;
    serial: string | undefined;
    number: number;
    reportType: ActivityReportType;
    scheduledEntryTime: DateTime | undefined;
    paysTransport: boolean;
    date: DateTime;
    validationResult: PreActivityReportValidation;
    certification: WoodPreActivityReportCertificationDto | undefined;
    placeId: number;
    isChip: boolean;
    travelSystemHasError: boolean | undefined;
}

export class WoodPreActivityReportLineDto implements IWoodPreActivityReportLineDto {
    services!: ServiceDto[] | undefined;
    tenantId!: number;
    article!: ArticleDto | undefined;
    stand!: StandDto | undefined;
    contract!: ContractDto | undefined;
    articleId!: number;
    origin!: LocationDto | undefined;
    isPefcCertified!: boolean | undefined;

    constructor(data?: IWoodPreActivityReportLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["services"])) {
                this.services = [] as any;
                for (let item of _data["services"])
                    this.services!.push(ServiceDto.fromJS(item));
            }
            this.tenantId = _data["tenantId"];
            this.article = _data["article"] ? ArticleDto.fromJS(_data["article"]) : <any>undefined;
            this.stand = _data["stand"] ? StandDto.fromJS(_data["stand"]) : <any>undefined;
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            this.articleId = _data["articleId"];
            this.origin = _data["origin"] ? LocationDto.fromJS(_data["origin"]) : <any>undefined;
            this.isPefcCertified = _data["isPefcCertified"];
        }
    }

    static fromJS(data: any): WoodPreActivityReportLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreActivityReportLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.services)) {
            data["services"] = [];
            for (let item of this.services)
                data["services"].push(item.toJSON());
        }
        data["tenantId"] = this.tenantId;
        data["article"] = this.article ? this.article.toJSON() : <any>undefined;
        data["stand"] = this.stand ? this.stand.toJSON() : <any>undefined;
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        data["articleId"] = this.articleId;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["isPefcCertified"] = this.isPefcCertified;
        return data;
    }
}

export interface IWoodPreActivityReportLineDto {
    services: ServiceDto[] | undefined;
    tenantId: number;
    article: ArticleDto | undefined;
    stand: StandDto | undefined;
    contract: ContractDto | undefined;
    articleId: number;
    origin: LocationDto | undefined;
    isPefcCertified: boolean | undefined;
}

export class WoodPreReportEntranceRequiredInfoOutput implements IWoodPreReportEntranceRequiredInfoOutput {
    id!: number;
    validationResult!: PreActivityReportValidation;
    paysTransport!: boolean;
    scheduledTurn!: DateTime | undefined;
    isApproved!: boolean;
    creationSystem!: ActivityReportCreationSystem;
    isChip!: boolean;

    constructor(data?: IWoodPreReportEntranceRequiredInfoOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.validationResult = _data["validationResult"];
            this.paysTransport = _data["paysTransport"];
            this.scheduledTurn = _data["scheduledTurn"] ? DateTime.fromISO(_data["scheduledTurn"].toString()) : <any>undefined;
            this.isApproved = _data["isApproved"];
            this.creationSystem = _data["creationSystem"];
            this.isChip = _data["isChip"];
        }
    }

    static fromJS(data: any): WoodPreReportEntranceRequiredInfoOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreReportEntranceRequiredInfoOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["validationResult"] = this.validationResult;
        data["paysTransport"] = this.paysTransport;
        data["scheduledTurn"] = this.scheduledTurn ? this.scheduledTurn.toString() : <any>undefined;
        data["isApproved"] = this.isApproved;
        data["creationSystem"] = this.creationSystem;
        data["isChip"] = this.isChip;
        return data;
    }
}

export interface IWoodPreReportEntranceRequiredInfoOutput {
    id: number;
    validationResult: PreActivityReportValidation;
    paysTransport: boolean;
    scheduledTurn: DateTime | undefined;
    isApproved: boolean;
    creationSystem: ActivityReportCreationSystem;
    isChip: boolean;
}

export class WoodPreReportInfoForEditValidationsDto implements IWoodPreReportInfoForEditValidationsDto {
    truckPlate!: string | undefined;
    paysTransport!: boolean;
    loaderVendorExternalId!: number | undefined;
    creationMode!: PreActivityReportCreationMode;

    constructor(data?: IWoodPreReportInfoForEditValidationsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.truckPlate = _data["truckPlate"];
            this.paysTransport = _data["paysTransport"];
            this.loaderVendorExternalId = _data["loaderVendorExternalId"];
            this.creationMode = _data["creationMode"];
        }
    }

    static fromJS(data: any): WoodPreReportInfoForEditValidationsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreReportInfoForEditValidationsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["truckPlate"] = this.truckPlate;
        data["paysTransport"] = this.paysTransport;
        data["loaderVendorExternalId"] = this.loaderVendorExternalId;
        data["creationMode"] = this.creationMode;
        return data;
    }
}

export interface IWoodPreReportInfoForEditValidationsDto {
    truckPlate: string | undefined;
    paysTransport: boolean;
    loaderVendorExternalId: number | undefined;
    creationMode: PreActivityReportCreationMode;
}

export class WoodPreReportPhotoOutputDto implements IWoodPreReportPhotoOutputDto {
    woodPreReportId!: number;
    photo!: string | undefined;
    existsFile!: boolean;
    errorMessage!: string | undefined;

    constructor(data?: IWoodPreReportPhotoOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.woodPreReportId = _data["woodPreReportId"];
            this.photo = _data["photo"];
            this.existsFile = _data["existsFile"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): WoodPreReportPhotoOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodPreReportPhotoOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["woodPreReportId"] = this.woodPreReportId;
        data["photo"] = this.photo;
        data["existsFile"] = this.existsFile;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IWoodPreReportPhotoOutputDto {
    woodPreReportId: number;
    photo: string | undefined;
    existsFile: boolean;
    errorMessage: string | undefined;
}

export class WoodReceiptForArchimedesIndicatorOutputDto implements IWoodReceiptForArchimedesIndicatorOutputDto {
    originExternalId!: number;
    originType!: LocationType;
    thirdPropertyCategory!: number | undefined;
    destinationExternalId!: number;
    woodLines!: WoodLineForArchimedesIndicatorOutputDto[] | undefined;
    usesScannerMeasurements!: boolean;
    id!: number;

    constructor(data?: IWoodReceiptForArchimedesIndicatorOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.thirdPropertyCategory = _data["thirdPropertyCategory"];
            this.destinationExternalId = _data["destinationExternalId"];
            if (Array.isArray(_data["woodLines"])) {
                this.woodLines = [] as any;
                for (let item of _data["woodLines"])
                    this.woodLines!.push(WoodLineForArchimedesIndicatorOutputDto.fromJS(item));
            }
            this.usesScannerMeasurements = _data["usesScannerMeasurements"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodReceiptForArchimedesIndicatorOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodReceiptForArchimedesIndicatorOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["thirdPropertyCategory"] = this.thirdPropertyCategory;
        data["destinationExternalId"] = this.destinationExternalId;
        if (Array.isArray(this.woodLines)) {
            data["woodLines"] = [];
            for (let item of this.woodLines)
                data["woodLines"].push(item.toJSON());
        }
        data["usesScannerMeasurements"] = this.usesScannerMeasurements;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodReceiptForArchimedesIndicatorOutputDto {
    originExternalId: number;
    originType: LocationType;
    thirdPropertyCategory: number | undefined;
    destinationExternalId: number;
    woodLines: WoodLineForArchimedesIndicatorOutputDto[] | undefined;
    usesScannerMeasurements: boolean;
    id: number;
}

export class WoodReceiptForReportOutput implements IWoodReceiptForReportOutput {
    densitiesGuid!: string | undefined;
    collectionResult!: PagedResultDtoOfWoodReceiptItemReportOutput | undefined;

    constructor(data?: IWoodReceiptForReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.densitiesGuid = _data["densitiesGuid"];
            this.collectionResult = _data["collectionResult"] ? PagedResultDtoOfWoodReceiptItemReportOutput.fromJS(_data["collectionResult"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WoodReceiptForReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodReceiptForReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["densitiesGuid"] = this.densitiesGuid;
        data["collectionResult"] = this.collectionResult ? this.collectionResult.toJSON() : <any>undefined;
        return data;
    }
}

export interface IWoodReceiptForReportOutput {
    densitiesGuid: string | undefined;
    collectionResult: PagedResultDtoOfWoodReceiptItemReportOutput | undefined;
}

export class WoodReceiptItemReportOutput implements IWoodReceiptItemReportOutput {
    activityReportDate!: DateTime;
    originExternalId!: number;
    originType!: LocationType | undefined;
    serial!: string | undefined;
    number!: number;
    transportExternalId!: number;
    transportVendorExternalId!: number;
    transportLicensePlate!: string | undefined;
    driverExternalId!: number;
    driverVendorExternalId!: number;
    exitDate!: DateTime | undefined;
    entryDate!: DateTime | undefined;
    loadDate!: DateTime | undefined;
    isDeleted!: boolean;
    externalActivityReportId!: number | undefined;
    wasSampled!: boolean;
    sampleAlgorithmExecuted!: boolean;
    activityReportReportLines!: ReceiptReportLineOutput[] | undefined;
    grossWeight!: WeightDto | undefined;
    tareWeight!: WeightDto | undefined;
    netWeight!: number;
    manualGrossWeightUser!: string | undefined;
    manualTareWeightUser!: string | undefined;
    comment!: string | undefined;
    noSampleReason!: string | undefined;
    activityReportId!: number;
    singleCustomDeclarationExternalId!: number;
    stockIntegration!: StockIntegrationOutputDto | undefined;
    electronicActivityReport!: ElectronicActivityReportDto | undefined;
    tripNumber!: number | undefined;
    internalDestinationName!: string | undefined;
    noSamplingReason!: ReasonDto | undefined;
    noSamplingReasonComment!: string | undefined;
    scannerIntegration!: ScannerIntegrationDto | undefined;
    customsIntegration!: CustomsIntegrationOutputDto | undefined;
    usesScannerMeasurements!: boolean;
    isAutomatic!: boolean;
    localId!: number | undefined;
    destinationExternalId!: number;
    destinationType!: LocationType | undefined;
    operationMode!: ActivityReportOperationMode;
    deletionReasonName!: string | undefined;
    deletionCommentary!: string | undefined;
    entryZoneName!: string | undefined;
    exitZoneName!: string | undefined;
    latitude!: number;
    longitude!: number;
    suggestedStandByArcGis!: string | undefined;

    constructor(data?: IWoodReceiptItemReportOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activityReportDate = _data["activityReportDate"] ? DateTime.fromISO(_data["activityReportDate"].toString()) : <any>undefined;
            this.originExternalId = _data["originExternalId"];
            this.originType = _data["originType"];
            this.serial = _data["serial"];
            this.number = _data["number"];
            this.transportExternalId = _data["transportExternalId"];
            this.transportVendorExternalId = _data["transportVendorExternalId"];
            this.transportLicensePlate = _data["transportLicensePlate"];
            this.driverExternalId = _data["driverExternalId"];
            this.driverVendorExternalId = _data["driverVendorExternalId"];
            this.exitDate = _data["exitDate"] ? DateTime.fromISO(_data["exitDate"].toString()) : <any>undefined;
            this.entryDate = _data["entryDate"] ? DateTime.fromISO(_data["entryDate"].toString()) : <any>undefined;
            this.loadDate = _data["loadDate"] ? DateTime.fromISO(_data["loadDate"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.externalActivityReportId = _data["externalActivityReportId"];
            this.wasSampled = _data["wasSampled"];
            this.sampleAlgorithmExecuted = _data["sampleAlgorithmExecuted"];
            if (Array.isArray(_data["activityReportReportLines"])) {
                this.activityReportReportLines = [] as any;
                for (let item of _data["activityReportReportLines"])
                    this.activityReportReportLines!.push(ReceiptReportLineOutput.fromJS(item));
            }
            this.grossWeight = _data["grossWeight"] ? WeightDto.fromJS(_data["grossWeight"]) : <any>undefined;
            this.tareWeight = _data["tareWeight"] ? WeightDto.fromJS(_data["tareWeight"]) : <any>undefined;
            this.netWeight = _data["netWeight"];
            this.manualGrossWeightUser = _data["manualGrossWeightUser"];
            this.manualTareWeightUser = _data["manualTareWeightUser"];
            this.comment = _data["comment"];
            this.noSampleReason = _data["noSampleReason"];
            this.activityReportId = _data["activityReportId"];
            this.singleCustomDeclarationExternalId = _data["singleCustomDeclarationExternalId"];
            this.stockIntegration = _data["stockIntegration"] ? StockIntegrationOutputDto.fromJS(_data["stockIntegration"]) : <any>undefined;
            this.electronicActivityReport = _data["electronicActivityReport"] ? ElectronicActivityReportDto.fromJS(_data["electronicActivityReport"]) : <any>undefined;
            this.tripNumber = _data["tripNumber"];
            this.internalDestinationName = _data["internalDestinationName"];
            this.noSamplingReason = _data["noSamplingReason"] ? ReasonDto.fromJS(_data["noSamplingReason"]) : <any>undefined;
            this.noSamplingReasonComment = _data["noSamplingReasonComment"];
            this.scannerIntegration = _data["scannerIntegration"] ? ScannerIntegrationDto.fromJS(_data["scannerIntegration"]) : <any>undefined;
            this.customsIntegration = _data["customsIntegration"] ? CustomsIntegrationOutputDto.fromJS(_data["customsIntegration"]) : <any>undefined;
            this.usesScannerMeasurements = _data["usesScannerMeasurements"];
            this.isAutomatic = _data["isAutomatic"];
            this.localId = _data["localId"];
            this.destinationExternalId = _data["destinationExternalId"];
            this.destinationType = _data["destinationType"];
            this.operationMode = _data["operationMode"];
            this.deletionReasonName = _data["deletionReasonName"];
            this.deletionCommentary = _data["deletionCommentary"];
            this.entryZoneName = _data["entryZoneName"];
            this.exitZoneName = _data["exitZoneName"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.suggestedStandByArcGis = _data["suggestedStandByArcGis"];
        }
    }

    static fromJS(data: any): WoodReceiptItemReportOutput {
        data = typeof data === 'object' ? data : {};
        let result = new WoodReceiptItemReportOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activityReportDate"] = this.activityReportDate ? this.activityReportDate.toString() : <any>undefined;
        data["originExternalId"] = this.originExternalId;
        data["originType"] = this.originType;
        data["serial"] = this.serial;
        data["number"] = this.number;
        data["transportExternalId"] = this.transportExternalId;
        data["transportVendorExternalId"] = this.transportVendorExternalId;
        data["transportLicensePlate"] = this.transportLicensePlate;
        data["driverExternalId"] = this.driverExternalId;
        data["driverVendorExternalId"] = this.driverVendorExternalId;
        data["exitDate"] = this.exitDate ? this.exitDate.toString() : <any>undefined;
        data["entryDate"] = this.entryDate ? this.entryDate.toString() : <any>undefined;
        data["loadDate"] = this.loadDate ? this.loadDate.toString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["externalActivityReportId"] = this.externalActivityReportId;
        data["wasSampled"] = this.wasSampled;
        data["sampleAlgorithmExecuted"] = this.sampleAlgorithmExecuted;
        if (Array.isArray(this.activityReportReportLines)) {
            data["activityReportReportLines"] = [];
            for (let item of this.activityReportReportLines)
                data["activityReportReportLines"].push(item.toJSON());
        }
        data["grossWeight"] = this.grossWeight ? this.grossWeight.toJSON() : <any>undefined;
        data["tareWeight"] = this.tareWeight ? this.tareWeight.toJSON() : <any>undefined;
        data["netWeight"] = this.netWeight;
        data["manualGrossWeightUser"] = this.manualGrossWeightUser;
        data["manualTareWeightUser"] = this.manualTareWeightUser;
        data["comment"] = this.comment;
        data["noSampleReason"] = this.noSampleReason;
        data["activityReportId"] = this.activityReportId;
        data["singleCustomDeclarationExternalId"] = this.singleCustomDeclarationExternalId;
        data["stockIntegration"] = this.stockIntegration ? this.stockIntegration.toJSON() : <any>undefined;
        data["electronicActivityReport"] = this.electronicActivityReport ? this.electronicActivityReport.toJSON() : <any>undefined;
        data["tripNumber"] = this.tripNumber;
        data["internalDestinationName"] = this.internalDestinationName;
        data["noSamplingReason"] = this.noSamplingReason ? this.noSamplingReason.toJSON() : <any>undefined;
        data["noSamplingReasonComment"] = this.noSamplingReasonComment;
        data["scannerIntegration"] = this.scannerIntegration ? this.scannerIntegration.toJSON() : <any>undefined;
        data["customsIntegration"] = this.customsIntegration ? this.customsIntegration.toJSON() : <any>undefined;
        data["usesScannerMeasurements"] = this.usesScannerMeasurements;
        data["isAutomatic"] = this.isAutomatic;
        data["localId"] = this.localId;
        data["destinationExternalId"] = this.destinationExternalId;
        data["destinationType"] = this.destinationType;
        data["operationMode"] = this.operationMode;
        data["deletionReasonName"] = this.deletionReasonName;
        data["deletionCommentary"] = this.deletionCommentary;
        data["entryZoneName"] = this.entryZoneName;
        data["exitZoneName"] = this.exitZoneName;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["suggestedStandByArcGis"] = this.suggestedStandByArcGis;
        return data;
    }
}

export interface IWoodReceiptItemReportOutput {
    activityReportDate: DateTime;
    originExternalId: number;
    originType: LocationType | undefined;
    serial: string | undefined;
    number: number;
    transportExternalId: number;
    transportVendorExternalId: number;
    transportLicensePlate: string | undefined;
    driverExternalId: number;
    driverVendorExternalId: number;
    exitDate: DateTime | undefined;
    entryDate: DateTime | undefined;
    loadDate: DateTime | undefined;
    isDeleted: boolean;
    externalActivityReportId: number | undefined;
    wasSampled: boolean;
    sampleAlgorithmExecuted: boolean;
    activityReportReportLines: ReceiptReportLineOutput[] | undefined;
    grossWeight: WeightDto | undefined;
    tareWeight: WeightDto | undefined;
    netWeight: number;
    manualGrossWeightUser: string | undefined;
    manualTareWeightUser: string | undefined;
    comment: string | undefined;
    noSampleReason: string | undefined;
    activityReportId: number;
    singleCustomDeclarationExternalId: number;
    stockIntegration: StockIntegrationOutputDto | undefined;
    electronicActivityReport: ElectronicActivityReportDto | undefined;
    tripNumber: number | undefined;
    internalDestinationName: string | undefined;
    noSamplingReason: ReasonDto | undefined;
    noSamplingReasonComment: string | undefined;
    scannerIntegration: ScannerIntegrationDto | undefined;
    customsIntegration: CustomsIntegrationOutputDto | undefined;
    usesScannerMeasurements: boolean;
    isAutomatic: boolean;
    localId: number | undefined;
    destinationExternalId: number;
    destinationType: LocationType | undefined;
    operationMode: ActivityReportOperationMode;
    deletionReasonName: string | undefined;
    deletionCommentary: string | undefined;
    entryZoneName: string | undefined;
    exitZoneName: string | undefined;
    latitude: number;
    longitude: number;
    suggestedStandByArcGis: string | undefined;
}

export class WoodReceiptWithoutLoadIndicatorItem implements IWoodReceiptWithoutLoadIndicatorItem {
    id!: number;
    licensePlate!: string | undefined;

    constructor(data?: IWoodReceiptWithoutLoadIndicatorItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.licensePlate = _data["licensePlate"];
        }
    }

    static fromJS(data: any): WoodReceiptWithoutLoadIndicatorItem {
        data = typeof data === 'object' ? data : {};
        let result = new WoodReceiptWithoutLoadIndicatorItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}

export interface IWoodReceiptWithoutLoadIndicatorItem {
    id: number;
    licensePlate: string | undefined;
}

export class WoodReportsWithoutIntegrateBioforestCurrentPeriod implements IWoodReportsWithoutIntegrateBioforestCurrentPeriod {
    placeId!: number;
    counter!: number;
    items!: WoodReportWithoutIntegrateBioforestCurrentPeriodItem[] | undefined;
    targetValue!: number;
    minimumThreshold!: number;
    maximumTreshold!: number;
    parameterValue!: number;
    message!: string | undefined;

    constructor(data?: IWoodReportsWithoutIntegrateBioforestCurrentPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.placeId = _data["placeId"];
            this.counter = _data["counter"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WoodReportWithoutIntegrateBioforestCurrentPeriodItem.fromJS(item));
            }
            this.targetValue = _data["targetValue"];
            this.minimumThreshold = _data["minimumThreshold"];
            this.maximumTreshold = _data["maximumTreshold"];
            this.parameterValue = _data["parameterValue"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): WoodReportsWithoutIntegrateBioforestCurrentPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new WoodReportsWithoutIntegrateBioforestCurrentPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["placeId"] = this.placeId;
        data["counter"] = this.counter;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["targetValue"] = this.targetValue;
        data["minimumThreshold"] = this.minimumThreshold;
        data["maximumTreshold"] = this.maximumTreshold;
        data["parameterValue"] = this.parameterValue;
        data["message"] = this.message;
        return data;
    }
}

export interface IWoodReportsWithoutIntegrateBioforestCurrentPeriod {
    placeId: number;
    counter: number;
    items: WoodReportWithoutIntegrateBioforestCurrentPeriodItem[] | undefined;
    targetValue: number;
    minimumThreshold: number;
    maximumTreshold: number;
    parameterValue: number;
    message: string | undefined;
}

export class WoodReportWithoutIntegrateBioforestCurrentPeriodItem implements IWoodReportWithoutIntegrateBioforestCurrentPeriodItem {
    id!: number;
    message!: string | undefined;
    lastExecution!: string | undefined;

    constructor(data?: IWoodReportWithoutIntegrateBioforestCurrentPeriodItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.message = _data["message"];
            this.lastExecution = _data["lastExecution"];
        }
    }

    static fromJS(data: any): WoodReportWithoutIntegrateBioforestCurrentPeriodItem {
        data = typeof data === 'object' ? data : {};
        let result = new WoodReportWithoutIntegrateBioforestCurrentPeriodItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["message"] = this.message;
        data["lastExecution"] = this.lastExecution;
        return data;
    }
}

export interface IWoodReportWithoutIntegrateBioforestCurrentPeriodItem {
    id: number;
    message: string | undefined;
    lastExecution: string | undefined;
}

export enum WoodScannerCategoryResults {
    EventApproved = "EventApproved",
    MeasurementError = "MeasurementError",
    AbortedSpeed = "AbortedSpeed",
    AbortedTimeout = "AbortedTimeout",
    SegmentationError = "SegmentationError",
    AbortedHardware = "AbortedHardware",
    InterventionStateUnknown = "InterventionStateUnknown",
    SystemError = "SystemError",
}

export class WoodTruckTypeDto implements IWoodTruckTypeDto {
    isTritrain!: boolean;
    resourceTypeId!: number;
    id!: number;

    constructor(data?: IWoodTruckTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isTritrain = _data["isTritrain"];
            this.resourceTypeId = _data["resourceTypeId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodTruckTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodTruckTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isTritrain"] = this.isTritrain;
        data["resourceTypeId"] = this.resourceTypeId;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodTruckTypeDto {
    isTritrain: boolean;
    resourceTypeId: number;
    id: number;
}

export class WoodVendorQuotaDto implements IWoodVendorQuotaDto {
    hourlyQuota!: number;
    tolerance!: number;
    vendorIds!: number[] | undefined;
    volumeDailyTolerance!: number;
    id!: number;

    constructor(data?: IWoodVendorQuotaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourlyQuota = _data["hourlyQuota"];
            this.tolerance = _data["tolerance"];
            if (Array.isArray(_data["vendorIds"])) {
                this.vendorIds = [] as any;
                for (let item of _data["vendorIds"])
                    this.vendorIds!.push(item);
            }
            this.volumeDailyTolerance = _data["volumeDailyTolerance"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): WoodVendorQuotaDto {
        data = typeof data === 'object' ? data : {};
        let result = new WoodVendorQuotaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourlyQuota"] = this.hourlyQuota;
        data["tolerance"] = this.tolerance;
        if (Array.isArray(this.vendorIds)) {
            data["vendorIds"] = [];
            for (let item of this.vendorIds)
                data["vendorIds"].push(item);
        }
        data["volumeDailyTolerance"] = this.volumeDailyTolerance;
        data["id"] = this.id;
        return data;
    }
}

export interface IWoodVendorQuotaDto {
    hourlyQuota: number;
    tolerance: number;
    vendorIds: number[] | undefined;
    volumeDailyTolerance: number;
    id: number;
}

export class WsFederationExternalLoginProviderSettings implements IWsFederationExternalLoginProviderSettings {
    clientId!: string | undefined;
    tenant!: string | undefined;
    metaDataAddress!: string | undefined;
    wtrealm!: string | undefined;
    authority!: string | undefined;

    constructor(data?: IWsFederationExternalLoginProviderSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientId = _data["clientId"];
            this.tenant = _data["tenant"];
            this.metaDataAddress = _data["metaDataAddress"];
            this.wtrealm = _data["wtrealm"];
            this.authority = _data["authority"];
        }
    }

    static fromJS(data: any): WsFederationExternalLoginProviderSettings {
        data = typeof data === 'object' ? data : {};
        let result = new WsFederationExternalLoginProviderSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["tenant"] = this.tenant;
        data["metaDataAddress"] = this.metaDataAddress;
        data["wtrealm"] = this.wtrealm;
        data["authority"] = this.authority;
        return data;
    }
}

export interface IWsFederationExternalLoginProviderSettings {
    clientId: string | undefined;
    tenant: string | undefined;
    metaDataAddress: string | undefined;
    wtrealm: string | undefined;
    authority: string | undefined;
}

export class ZoneByUserOutputDto implements IZoneByUserOutputDto {
    zoneId!: number;
    placeId!: number;

    constructor(data?: IZoneByUserOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.placeId = _data["placeId"];
        }
    }

    static fromJS(data: any): ZoneByUserOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneByUserOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["placeId"] = this.placeId;
        return data;
    }
}

export interface IZoneByUserOutputDto {
    zoneId: number;
    placeId: number;
}

export class ZoneConfigurationDto implements IZoneConfigurationDto {
    zoneId!: number;
    type!: number;
    isActive!: boolean;
    devices!: DeviceConfigurationDto[] | undefined;

    constructor(data?: IZoneConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.zoneId = _data["zoneId"];
            this.type = _data["type"];
            this.isActive = _data["isActive"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceConfigurationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ZoneConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["zoneId"] = this.zoneId;
        data["type"] = this.type;
        data["isActive"] = this.isActive;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IZoneConfigurationDto {
    zoneId: number;
    type: number;
    isActive: boolean;
    devices: DeviceConfigurationDto[] | undefined;
}

export class ZoneInCollectionDto implements IZoneInCollectionDto {
    name!: string | undefined;
    placeId!: number;
    placeName!: string | undefined;
    isActive!: boolean;
    zoneTypeDescription!: string | undefined;
    zoneTypeId!: number;
    externalId!: number;
    id!: number;

    constructor(data?: IZoneInCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.placeId = _data["placeId"];
            this.placeName = _data["placeName"];
            this.isActive = _data["isActive"];
            this.zoneTypeDescription = _data["zoneTypeDescription"];
            this.zoneTypeId = _data["zoneTypeId"];
            this.externalId = _data["externalId"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ZoneInCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneInCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["placeId"] = this.placeId;
        data["placeName"] = this.placeName;
        data["isActive"] = this.isActive;
        data["zoneTypeDescription"] = this.zoneTypeDescription;
        data["zoneTypeId"] = this.zoneTypeId;
        data["externalId"] = this.externalId;
        data["id"] = this.id;
        return data;
    }
}

export interface IZoneInCollectionDto {
    name: string | undefined;
    placeId: number;
    placeName: string | undefined;
    isActive: boolean;
    zoneTypeDescription: string | undefined;
    zoneTypeId: number;
    externalId: number;
    id: number;
}

export class ZoneInDeviceDto implements IZoneInDeviceDto {
    id!: number;
    name!: string | undefined;
    active!: boolean;
    zoneType!: ZoneTypeDto | undefined;
    placeId!: number;
    place!: PlaceInZoneDto | undefined;

    constructor(data?: IZoneInDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.zoneType = _data["zoneType"] ? ZoneTypeDto.fromJS(_data["zoneType"]) : <any>undefined;
            this.placeId = _data["placeId"];
            this.place = _data["place"] ? PlaceInZoneDto.fromJS(_data["place"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ZoneInDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneInDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["zoneType"] = this.zoneType ? this.zoneType.toJSON() : <any>undefined;
        data["placeId"] = this.placeId;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        return data;
    }
}

export interface IZoneInDeviceDto {
    id: number;
    name: string | undefined;
    active: boolean;
    zoneType: ZoneTypeDto | undefined;
    placeId: number;
    place: PlaceInZoneDto | undefined;
}

export class ZoneInPlaceDto implements IZoneInPlaceDto {
    id!: number;
    name!: string | undefined;
    active!: boolean;
    zoneType!: ZoneTypeDto | undefined;
    zoneTypeId!: number;

    constructor(data?: IZoneInPlaceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.zoneType = _data["zoneType"] ? ZoneTypeDto.fromJS(_data["zoneType"]) : <any>undefined;
            this.zoneTypeId = _data["zoneTypeId"];
        }
    }

    static fromJS(data: any): ZoneInPlaceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneInPlaceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["zoneType"] = this.zoneType ? this.zoneType.toJSON() : <any>undefined;
        data["zoneTypeId"] = this.zoneTypeId;
        return data;
    }
}

export interface IZoneInPlaceDto {
    id: number;
    name: string | undefined;
    active: boolean;
    zoneType: ZoneTypeDto | undefined;
    zoneTypeId: number;
}

export enum ZoneModeType {
    None = "None",
    Entrance = "Entrance",
    Exit = "Exit",
    Totem = "Totem",
    Sampling = "Sampling",
    Detour = "Detour",
    Load = "Load",
}

export class ZonesDto implements IZonesDto {
    id!: number;
    name!: string | undefined;
    active!: boolean;
    zoneType!: ZoneTypeDto | undefined;
    devices!: DeviceInZoneDto[] | undefined;
    zoneTypeId!: number;
    place!: PlaceInZoneDto | undefined;
    placeId!: number;
    externalId!: number;
    externalSmartLogyardId!: number;
    internalDestinationKey!: string | undefined;
    isDefaultInternalDestination!: boolean | undefined;

    constructor(data?: IZonesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.zoneType = _data["zoneType"] ? ZoneTypeDto.fromJS(_data["zoneType"]) : <any>undefined;
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceInZoneDto.fromJS(item));
            }
            this.zoneTypeId = _data["zoneTypeId"];
            this.place = _data["place"] ? PlaceInZoneDto.fromJS(_data["place"]) : <any>undefined;
            this.placeId = _data["placeId"];
            this.externalId = _data["externalId"];
            this.externalSmartLogyardId = _data["externalSmartLogyardId"];
            this.internalDestinationKey = _data["internalDestinationKey"];
            this.isDefaultInternalDestination = _data["isDefaultInternalDestination"];
        }
    }

    static fromJS(data: any): ZonesDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZonesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["zoneType"] = this.zoneType ? this.zoneType.toJSON() : <any>undefined;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["zoneTypeId"] = this.zoneTypeId;
        data["place"] = this.place ? this.place.toJSON() : <any>undefined;
        data["placeId"] = this.placeId;
        data["externalId"] = this.externalId;
        data["externalSmartLogyardId"] = this.externalSmartLogyardId;
        data["internalDestinationKey"] = this.internalDestinationKey;
        data["isDefaultInternalDestination"] = this.isDefaultInternalDestination;
        return data;
    }
}

export interface IZonesDto {
    id: number;
    name: string | undefined;
    active: boolean;
    zoneType: ZoneTypeDto | undefined;
    devices: DeviceInZoneDto[] | undefined;
    zoneTypeId: number;
    place: PlaceInZoneDto | undefined;
    placeId: number;
    externalId: number;
    externalSmartLogyardId: number;
    internalDestinationKey: string | undefined;
    isDefaultInternalDestination: boolean | undefined;
}

export class ZonesDtoInput implements IZonesDtoInput {
    name!: string | undefined;
    active!: boolean;
    zoneTypeId!: number;
    devices!: DeviceInZoneDto[] | undefined;
    placeId!: number;
    externalId!: number | undefined;
    externalSmartLogyardId!: number | undefined;
    internalDestinationKey!: string | undefined;

    constructor(data?: IZonesDtoInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.active = _data["active"];
            this.zoneTypeId = _data["zoneTypeId"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceInZoneDto.fromJS(item));
            }
            this.placeId = _data["placeId"];
            this.externalId = _data["externalId"];
            this.externalSmartLogyardId = _data["externalSmartLogyardId"];
            this.internalDestinationKey = _data["internalDestinationKey"];
        }
    }

    static fromJS(data: any): ZonesDtoInput {
        data = typeof data === 'object' ? data : {};
        let result = new ZonesDtoInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["active"] = this.active;
        data["zoneTypeId"] = this.zoneTypeId;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["placeId"] = this.placeId;
        data["externalId"] = this.externalId;
        data["externalSmartLogyardId"] = this.externalSmartLogyardId;
        data["internalDestinationKey"] = this.internalDestinationKey;
        return data;
    }
}

export interface IZonesDtoInput {
    name: string | undefined;
    active: boolean;
    zoneTypeId: number;
    devices: DeviceInZoneDto[] | undefined;
    placeId: number;
    externalId: number | undefined;
    externalSmartLogyardId: number | undefined;
    internalDestinationKey: string | undefined;
}

export class ZonesDtoUpdateInput implements IZonesDtoUpdateInput {
    id!: number;
    name!: string | undefined;
    active!: boolean;
    zoneTypeId!: number;
    devices!: DeviceInZoneDto[] | undefined;
    placeId!: number;
    externalId!: number | undefined;
    externalSmartLogyardId!: number | undefined;
    internalDestinationKey!: string | undefined;
    isDefaultInternalDestination!: boolean | undefined;

    constructor(data?: IZonesDtoUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.zoneTypeId = _data["zoneTypeId"];
            if (Array.isArray(_data["devices"])) {
                this.devices = [] as any;
                for (let item of _data["devices"])
                    this.devices!.push(DeviceInZoneDto.fromJS(item));
            }
            this.placeId = _data["placeId"];
            this.externalId = _data["externalId"];
            this.externalSmartLogyardId = _data["externalSmartLogyardId"];
            this.internalDestinationKey = _data["internalDestinationKey"];
            this.isDefaultInternalDestination = _data["isDefaultInternalDestination"];
        }
    }

    static fromJS(data: any): ZonesDtoUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new ZonesDtoUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["zoneTypeId"] = this.zoneTypeId;
        if (Array.isArray(this.devices)) {
            data["devices"] = [];
            for (let item of this.devices)
                data["devices"].push(item.toJSON());
        }
        data["placeId"] = this.placeId;
        data["externalId"] = this.externalId;
        data["externalSmartLogyardId"] = this.externalSmartLogyardId;
        data["internalDestinationKey"] = this.internalDestinationKey;
        data["isDefaultInternalDestination"] = this.isDefaultInternalDestination;
        return data;
    }
}

export interface IZonesDtoUpdateInput {
    id: number;
    name: string | undefined;
    active: boolean;
    zoneTypeId: number;
    devices: DeviceInZoneDto[] | undefined;
    placeId: number;
    externalId: number | undefined;
    externalSmartLogyardId: number | undefined;
    internalDestinationKey: string | undefined;
    isDefaultInternalDestination: boolean | undefined;
}

export class ZoneTypeDto implements IZoneTypeDto {
    id!: number;
    type!: string | undefined;

    constructor(data?: IZoneTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): ZoneTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ZoneTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface IZoneTypeDto {
    id: number;
    type: string | undefined;
}

export class AdditionalData implements IAdditionalData {
    paypal!: { [key: string]: string; };
    stripe!: { [key: string]: string; };

    constructor(data?: IAdditionalData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["Paypal"]) {
                this.paypal = {} as any;
                for (let key in _data["Paypal"]) {
                    if (_data["Paypal"].hasOwnProperty(key))
                        (<any>this.paypal)![key] = _data["Paypal"][key];
                }
            }
            if (_data["Stripe"]) {
                this.stripe = {} as any;
                for (let key in _data["Stripe"]) {
                    if (_data["Stripe"].hasOwnProperty(key))
                        (<any>this.stripe)![key] = _data["Stripe"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (let key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    (<any>data["Paypal"])[key] = (<any>this.paypal)[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (let key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    (<any>data["Stripe"])[key] = (<any>this.stripe)[key];
            }
        }
        return data;
    }
}

export interface IAdditionalData {
    paypal: { [key: string]: string; };
    stripe: { [key: string]: string; };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}